import * as AccordionPrimitive from '@radix-ui/react-accordion';
import { styled, keyframes, ThemeProvider as ThemeProvider$1, css as css$3, useTheme } from 'styled-components';
import * as React from 'react';
import React__default, { createContext, forwardRef, useContext, useState, useRef, useImperativeHandle, useEffect, cloneElement, Children, useLayoutEffect, useCallback, useMemo, Component, Fragment, isValidElement, useReducer, createElement } from 'react';
import shouldForwardProp from '@styled-system/should-forward-prop';
import { compose, background as background$1, flexbox, grid, layout, shadow, space as space$1, border, color, position, typography, system, variant } from 'styled-system';
import * as tokens from '@ksyos/design-tokens';
import { kdsColorDanger700, kdsColorForegroundDisabled, kdsColorPrimary700, kdsColorSecondary700, kdsColorForegroundDefault, kdsColorForegroundSubtle, kdsColorForegroundMinimal, kdsColorForegroundInverse, kdsColorForegroundPrimary, kdsColorForegroundSecondary, kdsColorForegroundInfo, kdsColorForegroundSuccess, kdsColorForegroundWarning, kdsColorForegroundDanger, kdsColorForegroundOnSelected } from '@ksyos/design-tokens';
import { css as css$2 } from '@styled-system/css';
import { Link as Link$1 } from '@ksyos/router';
import { AnimatePresence, motion } from 'framer-motion';
import { createPortal } from 'react-dom';
import { v4 } from 'uuid';
import * as RadixTooltip from '@radix-ui/react-tooltip';
import { cloneDeep, debounce, isEqual as isEqual$1, throttle, clamp } from 'lodash';
import { parseDate, getLocalTimeZone, isToday, CalendarDateTime, createCalendar, CalendarDate } from '@internationalized/date';
import { DateTime } from '@ksyos/date-time';
import { DateField, Label, DateInput as DateInput$1, DateSegment, Popover as Popover$1, Calendar, CalendarCell, DatePicker as DatePicker$1, Group as Group$2, Button as Button$1, Dialog, Heading as Heading$1, CalendarGrid, DialogTrigger, NumberField, Input as Input$2 } from 'react-aria-components';
import { setNonce } from 'get-nonce';
import FocusLock from 'react-focus-lock';
import { RemoveScroll } from 'react-remove-scroll';
import * as PopoverPrimitive from '@radix-ui/react-popover';
import * as RadixDropdownMenu from '@radix-ui/react-dropdown-menu';
import { useLocale } from '@react-aria/i18n';
import { useDatePickerState } from '@react-stately/datepicker';
import { useCalendarState } from 'react-stately';
import ReactSelect, { components as components$2 } from 'react-select';
import createCache from '@emotion/cache';
import { keyframes as keyframes$1, jsx, css as css$4, CacheProvider } from '@emotion/react';
export { useResizeObserver } from 'usehooks-ts';
import { usePopper } from 'react-popper';

const Accordion = styled(AccordionPrimitive.Root) `
    display: flex;
    gap: 8px;
    flex-direction: column;
`;
const AccordionItem = styled(AccordionPrimitive.Item) ``;
const slideDown$1 = keyframes({
    from: { height: 0 },
    to: { height: 'var(--radix-accordion-content-height)' },
});
const slideUp$1 = keyframes({
    from: { height: 'var(--radix-accordion-content-height)' },
    to: { height: 0 },
});
const AccordionContent = styled(AccordionPrimitive.Content) `
    overflow: hidden;

    &[data-state='open'] {
        animation: ${slideDown$1} 300ms cubic-bezier(0.87, 0, 0.13, 1);
    }

    &[data-state='closed'] {
        animation: ${slideUp$1} 300ms cubic-bezier(0.87, 0, 0.13, 1);
    }
`;
const AccordionContentIndent = styled.div `
    margin-top: 4px;
    margin-bottom: 12px;
    margin-left: 19px;
    padding-top: 4px;
    padding-bottom: 4px;
    padding-left: 20px;
    border-left: 1px solid var(--kds-color-border-subtle);
`;
const AccordionDescriptionList = styled.dl `
    margin: 0 0 16px;
`;
const AccordionDescriptionTerm = styled.dt `
    font-size: ${(props) => props.theme.fontSizes.xs};
    line-height: ${(props) => props.theme.lineHeights[4]};
    color: var(--kds-color-foreground-default);
    font-weight: ${(props) => props.theme.fontWeights.medium};
    margin: 0;
`;
const AccordionDescriptionDetails = styled.dd `
    font-size: ${(props) => props.theme.fontSizes.sm};
    line-height: ${(props) => props.theme.lineHeights[5]};
    color: var(--kds-color-foreground-default);
    font-weight: ${(props) => props.theme.fontWeights.normal};
    margin: 0 0 12px;
`;
const AccordionUnorderedList = styled.ul `
    list-style: none;
    padding: 0;
    margin-bottom: 16px;
`;
const AccordionListItem = styled.li `
    font-size: ${(props) => props.theme.fontSizes.sm};
    line-height: ${(props) => props.theme.lineHeights[5]};
    color: var(--kds-color-foreground-default);
`;

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */


function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var jsxRuntime = {exports: {}};

var reactJsxRuntime_production_min = {};

/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactJsxRuntime_production_min;

function requireReactJsxRuntime_production_min () {
	if (hasRequiredReactJsxRuntime_production_min) return reactJsxRuntime_production_min;
	hasRequiredReactJsxRuntime_production_min = 1;
var f=React__default,k=Symbol.for("react.element"),l=Symbol.for("react.fragment"),m=Object.prototype.hasOwnProperty,n=f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,p={key:!0,ref:!0,__self:!0,__source:!0};
	function q(c,a,g){var b,d={},e=null,h=null;void 0!==g&&(e=""+g);void 0!==a.key&&(e=""+a.key);void 0!==a.ref&&(h=a.ref);for(b in a)m.call(a,b)&&!p.hasOwnProperty(b)&&(d[b]=a[b]);if(c&&c.defaultProps)for(b in a=c.defaultProps,a)void 0===d[b]&&(d[b]=a[b]);return {$$typeof:k,type:c,key:e,ref:h,props:d,_owner:n.current}}reactJsxRuntime_production_min.Fragment=l;reactJsxRuntime_production_min.jsx=q;reactJsxRuntime_production_min.jsxs=q;
	return reactJsxRuntime_production_min;
}

var reactJsxRuntime_development = {};

/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactJsxRuntime_development;

function requireReactJsxRuntime_development () {
	if (hasRequiredReactJsxRuntime_development) return reactJsxRuntime_development;
	hasRequiredReactJsxRuntime_development = 1;

	if (process.env.NODE_ENV !== "production") {
	  (function() {

	var React = React__default;

	// ATTENTION
	// When adding new symbols to this file,
	// Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
	// The Symbol used to tag the ReactElement-like types.
	var REACT_ELEMENT_TYPE = Symbol.for('react.element');
	var REACT_PORTAL_TYPE = Symbol.for('react.portal');
	var REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
	var REACT_STRICT_MODE_TYPE = Symbol.for('react.strict_mode');
	var REACT_PROFILER_TYPE = Symbol.for('react.profiler');
	var REACT_PROVIDER_TYPE = Symbol.for('react.provider');
	var REACT_CONTEXT_TYPE = Symbol.for('react.context');
	var REACT_FORWARD_REF_TYPE = Symbol.for('react.forward_ref');
	var REACT_SUSPENSE_TYPE = Symbol.for('react.suspense');
	var REACT_SUSPENSE_LIST_TYPE = Symbol.for('react.suspense_list');
	var REACT_MEMO_TYPE = Symbol.for('react.memo');
	var REACT_LAZY_TYPE = Symbol.for('react.lazy');
	var REACT_OFFSCREEN_TYPE = Symbol.for('react.offscreen');
	var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator';
	function getIteratorFn(maybeIterable) {
	  if (maybeIterable === null || typeof maybeIterable !== 'object') {
	    return null;
	  }

	  var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];

	  if (typeof maybeIterator === 'function') {
	    return maybeIterator;
	  }

	  return null;
	}

	var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

	function error(format) {
	  {
	    {
	      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	        args[_key2 - 1] = arguments[_key2];
	      }

	      printWarning('error', format, args);
	    }
	  }
	}

	function printWarning(level, format, args) {
	  // When changing this logic, you might want to also
	  // update consoleWithStackDev.www.js as well.
	  {
	    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
	    var stack = ReactDebugCurrentFrame.getStackAddendum();

	    if (stack !== '') {
	      format += '%s';
	      args = args.concat([stack]);
	    } // eslint-disable-next-line react-internal/safe-string-coercion


	    var argsWithFormat = args.map(function (item) {
	      return String(item);
	    }); // Careful: RN currently depends on this prefix

	    argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
	    // breaks IE9: https://github.com/facebook/react/issues/13610
	    // eslint-disable-next-line react-internal/no-production-logging

	    Function.prototype.apply.call(console[level], console, argsWithFormat);
	  }
	}

	// -----------------------------------------------------------------------------

	var enableScopeAPI = false; // Experimental Create Event Handle API.
	var enableCacheElement = false;
	var enableTransitionTracing = false; // No known bugs, but needs performance testing

	var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
	// stuff. Intended to enable React core members to more easily debug scheduling
	// issues in DEV builds.

	var enableDebugTracing = false; // Track which Fiber(s) schedule render work.

	var REACT_MODULE_REFERENCE;

	{
	  REACT_MODULE_REFERENCE = Symbol.for('react.module.reference');
	}

	function isValidElementType(type) {
	  if (typeof type === 'string' || typeof type === 'function') {
	    return true;
	  } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


	  if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing  || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden  || type === REACT_OFFSCREEN_TYPE || enableScopeAPI  || enableCacheElement  || enableTransitionTracing ) {
	    return true;
	  }

	  if (typeof type === 'object' && type !== null) {
	    if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
	    // types supported by any Flight configuration anywhere since
	    // we don't know which Flight build this will end up being used
	    // with.
	    type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) {
	      return true;
	    }
	  }

	  return false;
	}

	function getWrappedName(outerType, innerType, wrapperName) {
	  var displayName = outerType.displayName;

	  if (displayName) {
	    return displayName;
	  }

	  var functionName = innerType.displayName || innerType.name || '';
	  return functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName;
	} // Keep in sync with react-reconciler/getComponentNameFromFiber


	function getContextName(type) {
	  return type.displayName || 'Context';
	} // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.


	function getComponentNameFromType(type) {
	  if (type == null) {
	    // Host root, text node or just invalid type.
	    return null;
	  }

	  {
	    if (typeof type.tag === 'number') {
	      error('Received an unexpected object in getComponentNameFromType(). ' + 'This is likely a bug in React. Please file an issue.');
	    }
	  }

	  if (typeof type === 'function') {
	    return type.displayName || type.name || null;
	  }

	  if (typeof type === 'string') {
	    return type;
	  }

	  switch (type) {
	    case REACT_FRAGMENT_TYPE:
	      return 'Fragment';

	    case REACT_PORTAL_TYPE:
	      return 'Portal';

	    case REACT_PROFILER_TYPE:
	      return 'Profiler';

	    case REACT_STRICT_MODE_TYPE:
	      return 'StrictMode';

	    case REACT_SUSPENSE_TYPE:
	      return 'Suspense';

	    case REACT_SUSPENSE_LIST_TYPE:
	      return 'SuspenseList';

	  }

	  if (typeof type === 'object') {
	    switch (type.$$typeof) {
	      case REACT_CONTEXT_TYPE:
	        var context = type;
	        return getContextName(context) + '.Consumer';

	      case REACT_PROVIDER_TYPE:
	        var provider = type;
	        return getContextName(provider._context) + '.Provider';

	      case REACT_FORWARD_REF_TYPE:
	        return getWrappedName(type, type.render, 'ForwardRef');

	      case REACT_MEMO_TYPE:
	        var outerName = type.displayName || null;

	        if (outerName !== null) {
	          return outerName;
	        }

	        return getComponentNameFromType(type.type) || 'Memo';

	      case REACT_LAZY_TYPE:
	        {
	          var lazyComponent = type;
	          var payload = lazyComponent._payload;
	          var init = lazyComponent._init;

	          try {
	            return getComponentNameFromType(init(payload));
	          } catch (x) {
	            return null;
	          }
	        }

	      // eslint-disable-next-line no-fallthrough
	    }
	  }

	  return null;
	}

	var assign = Object.assign;

	// Helpers to patch console.logs to avoid logging during side-effect free
	// replaying on render function. This currently only patches the object
	// lazily which won't cover if the log function was extracted eagerly.
	// We could also eagerly patch the method.
	var disabledDepth = 0;
	var prevLog;
	var prevInfo;
	var prevWarn;
	var prevError;
	var prevGroup;
	var prevGroupCollapsed;
	var prevGroupEnd;

	function disabledLog() {}

	disabledLog.__reactDisabledLog = true;
	function disableLogs() {
	  {
	    if (disabledDepth === 0) {
	      /* eslint-disable react-internal/no-production-logging */
	      prevLog = console.log;
	      prevInfo = console.info;
	      prevWarn = console.warn;
	      prevError = console.error;
	      prevGroup = console.group;
	      prevGroupCollapsed = console.groupCollapsed;
	      prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099

	      var props = {
	        configurable: true,
	        enumerable: true,
	        value: disabledLog,
	        writable: true
	      }; // $FlowFixMe Flow thinks console is immutable.

	      Object.defineProperties(console, {
	        info: props,
	        log: props,
	        warn: props,
	        error: props,
	        group: props,
	        groupCollapsed: props,
	        groupEnd: props
	      });
	      /* eslint-enable react-internal/no-production-logging */
	    }

	    disabledDepth++;
	  }
	}
	function reenableLogs() {
	  {
	    disabledDepth--;

	    if (disabledDepth === 0) {
	      /* eslint-disable react-internal/no-production-logging */
	      var props = {
	        configurable: true,
	        enumerable: true,
	        writable: true
	      }; // $FlowFixMe Flow thinks console is immutable.

	      Object.defineProperties(console, {
	        log: assign({}, props, {
	          value: prevLog
	        }),
	        info: assign({}, props, {
	          value: prevInfo
	        }),
	        warn: assign({}, props, {
	          value: prevWarn
	        }),
	        error: assign({}, props, {
	          value: prevError
	        }),
	        group: assign({}, props, {
	          value: prevGroup
	        }),
	        groupCollapsed: assign({}, props, {
	          value: prevGroupCollapsed
	        }),
	        groupEnd: assign({}, props, {
	          value: prevGroupEnd
	        })
	      });
	      /* eslint-enable react-internal/no-production-logging */
	    }

	    if (disabledDepth < 0) {
	      error('disabledDepth fell below zero. ' + 'This is a bug in React. Please file an issue.');
	    }
	  }
	}

	var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
	var prefix;
	function describeBuiltInComponentFrame(name, source, ownerFn) {
	  {
	    if (prefix === undefined) {
	      // Extract the VM specific prefix used by each line.
	      try {
	        throw Error();
	      } catch (x) {
	        var match = x.stack.trim().match(/\n( *(at )?)/);
	        prefix = match && match[1] || '';
	      }
	    } // We use the prefix to ensure our stacks line up with native stack frames.


	    return '\n' + prefix + name;
	  }
	}
	var reentry = false;
	var componentFrameCache;

	{
	  var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
	  componentFrameCache = new PossiblyWeakMap();
	}

	function describeNativeComponentFrame(fn, construct) {
	  // If something asked for a stack inside a fake render, it should get ignored.
	  if ( !fn || reentry) {
	    return '';
	  }

	  {
	    var frame = componentFrameCache.get(fn);

	    if (frame !== undefined) {
	      return frame;
	    }
	  }

	  var control;
	  reentry = true;
	  var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.

	  Error.prepareStackTrace = undefined;
	  var previousDispatcher;

	  {
	    previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
	    // for warnings.

	    ReactCurrentDispatcher.current = null;
	    disableLogs();
	  }

	  try {
	    // This should throw.
	    if (construct) {
	      // Something should be setting the props in the constructor.
	      var Fake = function () {
	        throw Error();
	      }; // $FlowFixMe


	      Object.defineProperty(Fake.prototype, 'props', {
	        set: function () {
	          // We use a throwing setter instead of frozen or non-writable props
	          // because that won't throw in a non-strict mode function.
	          throw Error();
	        }
	      });

	      if (typeof Reflect === 'object' && Reflect.construct) {
	        // We construct a different control for this case to include any extra
	        // frames added by the construct call.
	        try {
	          Reflect.construct(Fake, []);
	        } catch (x) {
	          control = x;
	        }

	        Reflect.construct(fn, [], Fake);
	      } else {
	        try {
	          Fake.call();
	        } catch (x) {
	          control = x;
	        }

	        fn.call(Fake.prototype);
	      }
	    } else {
	      try {
	        throw Error();
	      } catch (x) {
	        control = x;
	      }

	      fn();
	    }
	  } catch (sample) {
	    // This is inlined manually because closure doesn't do it for us.
	    if (sample && control && typeof sample.stack === 'string') {
	      // This extracts the first frame from the sample that isn't also in the control.
	      // Skipping one frame that we assume is the frame that calls the two.
	      var sampleLines = sample.stack.split('\n');
	      var controlLines = control.stack.split('\n');
	      var s = sampleLines.length - 1;
	      var c = controlLines.length - 1;

	      while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
	        // We expect at least one stack frame to be shared.
	        // Typically this will be the root most one. However, stack frames may be
	        // cut off due to maximum stack limits. In this case, one maybe cut off
	        // earlier than the other. We assume that the sample is longer or the same
	        // and there for cut off earlier. So we should find the root most frame in
	        // the sample somewhere in the control.
	        c--;
	      }

	      for (; s >= 1 && c >= 0; s--, c--) {
	        // Next we find the first one that isn't the same which should be the
	        // frame that called our sample function and the control.
	        if (sampleLines[s] !== controlLines[c]) {
	          // In V8, the first line is describing the message but other VMs don't.
	          // If we're about to return the first line, and the control is also on the same
	          // line, that's a pretty good indicator that our sample threw at same line as
	          // the control. I.e. before we entered the sample frame. So we ignore this result.
	          // This can happen if you passed a class to function component, or non-function.
	          if (s !== 1 || c !== 1) {
	            do {
	              s--;
	              c--; // We may still have similar intermediate frames from the construct call.
	              // The next one that isn't the same should be our match though.

	              if (c < 0 || sampleLines[s] !== controlLines[c]) {
	                // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
	                var _frame = '\n' + sampleLines[s].replace(' at new ', ' at '); // If our component frame is labeled "<anonymous>"
	                // but we have a user-provided "displayName"
	                // splice it in to make the stack more readable.


	                if (fn.displayName && _frame.includes('<anonymous>')) {
	                  _frame = _frame.replace('<anonymous>', fn.displayName);
	                }

	                {
	                  if (typeof fn === 'function') {
	                    componentFrameCache.set(fn, _frame);
	                  }
	                } // Return the line we found.


	                return _frame;
	              }
	            } while (s >= 1 && c >= 0);
	          }

	          break;
	        }
	      }
	    }
	  } finally {
	    reentry = false;

	    {
	      ReactCurrentDispatcher.current = previousDispatcher;
	      reenableLogs();
	    }

	    Error.prepareStackTrace = previousPrepareStackTrace;
	  } // Fallback to just using the name if we couldn't make it throw.


	  var name = fn ? fn.displayName || fn.name : '';
	  var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';

	  {
	    if (typeof fn === 'function') {
	      componentFrameCache.set(fn, syntheticFrame);
	    }
	  }

	  return syntheticFrame;
	}
	function describeFunctionComponentFrame(fn, source, ownerFn) {
	  {
	    return describeNativeComponentFrame(fn, false);
	  }
	}

	function shouldConstruct(Component) {
	  var prototype = Component.prototype;
	  return !!(prototype && prototype.isReactComponent);
	}

	function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {

	  if (type == null) {
	    return '';
	  }

	  if (typeof type === 'function') {
	    {
	      return describeNativeComponentFrame(type, shouldConstruct(type));
	    }
	  }

	  if (typeof type === 'string') {
	    return describeBuiltInComponentFrame(type);
	  }

	  switch (type) {
	    case REACT_SUSPENSE_TYPE:
	      return describeBuiltInComponentFrame('Suspense');

	    case REACT_SUSPENSE_LIST_TYPE:
	      return describeBuiltInComponentFrame('SuspenseList');
	  }

	  if (typeof type === 'object') {
	    switch (type.$$typeof) {
	      case REACT_FORWARD_REF_TYPE:
	        return describeFunctionComponentFrame(type.render);

	      case REACT_MEMO_TYPE:
	        // Memo may contain any component type so we recursively resolve it.
	        return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);

	      case REACT_LAZY_TYPE:
	        {
	          var lazyComponent = type;
	          var payload = lazyComponent._payload;
	          var init = lazyComponent._init;

	          try {
	            // Lazy may contain any component type so we recursively resolve it.
	            return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
	          } catch (x) {}
	        }
	    }
	  }

	  return '';
	}

	var hasOwnProperty = Object.prototype.hasOwnProperty;

	var loggedTypeFailures = {};
	var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;

	function setCurrentlyValidatingElement(element) {
	  {
	    if (element) {
	      var owner = element._owner;
	      var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
	      ReactDebugCurrentFrame.setExtraStackFrame(stack);
	    } else {
	      ReactDebugCurrentFrame.setExtraStackFrame(null);
	    }
	  }
	}

	function checkPropTypes(typeSpecs, values, location, componentName, element) {
	  {
	    // $FlowFixMe This is okay but Flow doesn't know it.
	    var has = Function.call.bind(hasOwnProperty);

	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.

	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            // eslint-disable-next-line react-internal/prod-error-codes
	            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
	            err.name = 'Invariant Violation';
	            throw err;
	          }

	          error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
	        } catch (ex) {
	          error$1 = ex;
	        }

	        if (error$1 && !(error$1 instanceof Error)) {
	          setCurrentlyValidatingElement(element);

	          error('%s: type specification of %s' + ' `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error$1);

	          setCurrentlyValidatingElement(null);
	        }

	        if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error$1.message] = true;
	          setCurrentlyValidatingElement(element);

	          error('Failed %s type: %s', location, error$1.message);

	          setCurrentlyValidatingElement(null);
	        }
	      }
	    }
	  }
	}

	var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare

	function isArray(a) {
	  return isArrayImpl(a);
	}

	/*
	 * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
	 * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
	 *
	 * The functions in this module will throw an easier-to-understand,
	 * easier-to-debug exception with a clear errors message message explaining the
	 * problem. (Instead of a confusing exception thrown inside the implementation
	 * of the `value` object).
	 */
	// $FlowFixMe only called in DEV, so void return is not possible.
	function typeName(value) {
	  {
	    // toStringTag is needed for namespaced types like Temporal.Instant
	    var hasToStringTag = typeof Symbol === 'function' && Symbol.toStringTag;
	    var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || 'Object';
	    return type;
	  }
	} // $FlowFixMe only called in DEV, so void return is not possible.


	function willCoercionThrow(value) {
	  {
	    try {
	      testStringCoercion(value);
	      return false;
	    } catch (e) {
	      return true;
	    }
	  }
	}

	function testStringCoercion(value) {
	  // If you ended up here by following an exception call stack, here's what's
	  // happened: you supplied an object or symbol value to React (as a prop, key,
	  // DOM attribute, CSS property, string ref, etc.) and when React tried to
	  // coerce it to a string using `'' + value`, an exception was thrown.
	  //
	  // The most common types that will cause this exception are `Symbol` instances
	  // and Temporal objects like `Temporal.Instant`. But any object that has a
	  // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
	  // exception. (Library authors do this to prevent users from using built-in
	  // numeric operators like `+` or comparison operators like `>=` because custom
	  // methods are needed to perform accurate arithmetic or comparison.)
	  //
	  // To fix the problem, coerce this object or symbol value to a string before
	  // passing it to React. The most reliable way is usually `String(value)`.
	  //
	  // To find which value is throwing, check the browser or debugger console.
	  // Before this exception was thrown, there should be `console.error` output
	  // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
	  // problem and how that type was used: key, atrribute, input value prop, etc.
	  // In most cases, this console output also shows the component and its
	  // ancestor components where the exception happened.
	  //
	  // eslint-disable-next-line react-internal/safe-string-coercion
	  return '' + value;
	}
	function checkKeyStringCoercion(value) {
	  {
	    if (willCoercionThrow(value)) {
	      error('The provided key is an unsupported type %s.' + ' This value must be coerced to a string before before using it here.', typeName(value));

	      return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
	    }
	  }
	}

	var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	var specialPropKeyWarningShown;
	var specialPropRefWarningShown;
	var didWarnAboutStringRefs;

	{
	  didWarnAboutStringRefs = {};
	}

	function hasValidRef(config) {
	  {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;

	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }

	  return config.ref !== undefined;
	}

	function hasValidKey(config) {
	  {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;

	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }

	  return config.key !== undefined;
	}

	function warnIfStringRefCannotBeAutoConverted(config, self) {
	  {
	    if (typeof config.ref === 'string' && ReactCurrentOwner.current && self && ReactCurrentOwner.current.stateNode !== self) {
	      var componentName = getComponentNameFromType(ReactCurrentOwner.current.type);

	      if (!didWarnAboutStringRefs[componentName]) {
	        error('Component "%s" contains the string ref "%s". ' + 'Support for string refs will be removed in a future major release. ' + 'This case cannot be automatically converted to an arrow function. ' + 'We ask you to manually fix this case by using useRef() or createRef() instead. ' + 'Learn more about using refs safely here: ' + 'https://reactjs.org/link/strict-mode-string-ref', getComponentNameFromType(ReactCurrentOwner.current.type), config.ref);

	        didWarnAboutStringRefs[componentName] = true;
	      }
	    }
	  }
	}

	function defineKeyPropWarningGetter(props, displayName) {
	  {
	    var warnAboutAccessingKey = function () {
	      if (!specialPropKeyWarningShown) {
	        specialPropKeyWarningShown = true;

	        error('%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
	      }
	    };

	    warnAboutAccessingKey.isReactWarning = true;
	    Object.defineProperty(props, 'key', {
	      get: warnAboutAccessingKey,
	      configurable: true
	    });
	  }
	}

	function defineRefPropWarningGetter(props, displayName) {
	  {
	    var warnAboutAccessingRef = function () {
	      if (!specialPropRefWarningShown) {
	        specialPropRefWarningShown = true;

	        error('%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
	      }
	    };

	    warnAboutAccessingRef.isReactWarning = true;
	    Object.defineProperty(props, 'ref', {
	      get: warnAboutAccessingRef,
	      configurable: true
	    });
	  }
	}
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, instanceof check
	 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} props
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} owner
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @internal
	 */


	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allows us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };

	  {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.

	    Object.defineProperty(element._store, 'validated', {
	      configurable: false,
	      enumerable: false,
	      writable: true,
	      value: false
	    }); // self and source are DEV only properties.

	    Object.defineProperty(element, '_self', {
	      configurable: false,
	      enumerable: false,
	      writable: false,
	      value: self
	    }); // Two elements created in two different places should be considered
	    // equal for testing purposes and therefore we hide it from enumeration.

	    Object.defineProperty(element, '_source', {
	      configurable: false,
	      enumerable: false,
	      writable: false,
	      value: source
	    });

	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }

	  return element;
	};
	/**
	 * https://github.com/reactjs/rfcs/pull/107
	 * @param {*} type
	 * @param {object} props
	 * @param {string} key
	 */

	function jsxDEV(type, config, maybeKey, source, self) {
	  {
	    var propName; // Reserved names are extracted

	    var props = {};
	    var key = null;
	    var ref = null; // Currently, key can be spread in as a prop. This causes a potential
	    // issue if key is also explicitly declared (ie. <div {...props} key="Hi" />
	    // or <div key="Hi" {...props} /> ). We want to deprecate key spread,
	    // but as an intermediary step, we will use jsxDEV for everything except
	    // <div {...props} key="Hi" />, because we aren't currently able to tell if
	    // key is explicitly declared to be undefined or not.

	    if (maybeKey !== undefined) {
	      {
	        checkKeyStringCoercion(maybeKey);
	      }

	      key = '' + maybeKey;
	    }

	    if (hasValidKey(config)) {
	      {
	        checkKeyStringCoercion(config.key);
	      }

	      key = '' + config.key;
	    }

	    if (hasValidRef(config)) {
	      ref = config.ref;
	      warnIfStringRefCannotBeAutoConverted(config, self);
	    } // Remaining properties are added to a new props object


	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    } // Resolve default props


	    if (type && type.defaultProps) {
	      var defaultProps = type.defaultProps;

	      for (propName in defaultProps) {
	        if (props[propName] === undefined) {
	          props[propName] = defaultProps[propName];
	        }
	      }
	    }

	    if (key || ref) {
	      var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;

	      if (key) {
	        defineKeyPropWarningGetter(props, displayName);
	      }

	      if (ref) {
	        defineRefPropWarningGetter(props, displayName);
	      }
	    }

	    return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	  }
	}

	var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
	var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;

	function setCurrentlyValidatingElement$1(element) {
	  {
	    if (element) {
	      var owner = element._owner;
	      var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
	      ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
	    } else {
	      ReactDebugCurrentFrame$1.setExtraStackFrame(null);
	    }
	  }
	}

	var propTypesMisspellWarningShown;

	{
	  propTypesMisspellWarningShown = false;
	}
	/**
	 * Verifies the object is a ReactElement.
	 * See https://reactjs.org/docs/react-api.html#isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a ReactElement.
	 * @final
	 */


	function isValidElement(object) {
	  {
	    return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	  }
	}

	function getDeclarationErrorAddendum() {
	  {
	    if (ReactCurrentOwner$1.current) {
	      var name = getComponentNameFromType(ReactCurrentOwner$1.current.type);

	      if (name) {
	        return '\n\nCheck the render method of `' + name + '`.';
	      }
	    }

	    return '';
	  }
	}

	function getSourceInfoErrorAddendum(source) {
	  {

	    return '';
	  }
	}
	/**
	 * Warn if there's no key explicitly set on dynamic arrays of children or
	 * object keys are not valid. This allows us to keep track of children between
	 * updates.
	 */


	var ownerHasKeyUseWarning = {};

	function getCurrentComponentErrorInfo(parentType) {
	  {
	    var info = getDeclarationErrorAddendum();

	    if (!info) {
	      var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;

	      if (parentName) {
	        info = "\n\nCheck the top-level render call using <" + parentName + ">.";
	      }
	    }

	    return info;
	  }
	}
	/**
	 * Warn if the element doesn't have an explicit key assigned to it.
	 * This element is in an array. The array could grow and shrink or be
	 * reordered. All children that haven't already been validated are required to
	 * have a "key" property assigned to it. Error statuses are cached so a warning
	 * will only be shown once.
	 *
	 * @internal
	 * @param {ReactElement} element Element that requires a key.
	 * @param {*} parentType element's parent's type.
	 */


	function validateExplicitKey(element, parentType) {
	  {
	    if (!element._store || element._store.validated || element.key != null) {
	      return;
	    }

	    element._store.validated = true;
	    var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);

	    if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
	      return;
	    }

	    ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
	    // property, it may be the creator of the child that's responsible for
	    // assigning it a key.

	    var childOwner = '';

	    if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) {
	      // Give the component that originally created this child.
	      childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
	    }

	    setCurrentlyValidatingElement$1(element);

	    error('Each child in a list should have a unique "key" prop.' + '%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);

	    setCurrentlyValidatingElement$1(null);
	  }
	}
	/**
	 * Ensure that every element either is passed in a static location, in an
	 * array with an explicit keys property defined, or in an object literal
	 * with valid key property.
	 *
	 * @internal
	 * @param {ReactNode} node Statically passed child of any type.
	 * @param {*} parentType node's parent's type.
	 */


	function validateChildKeys(node, parentType) {
	  {
	    if (typeof node !== 'object') {
	      return;
	    }

	    if (isArray(node)) {
	      for (var i = 0; i < node.length; i++) {
	        var child = node[i];

	        if (isValidElement(child)) {
	          validateExplicitKey(child, parentType);
	        }
	      }
	    } else if (isValidElement(node)) {
	      // This element was passed in a valid location.
	      if (node._store) {
	        node._store.validated = true;
	      }
	    } else if (node) {
	      var iteratorFn = getIteratorFn(node);

	      if (typeof iteratorFn === 'function') {
	        // Entry iterators used to provide implicit keys,
	        // but now we print a separate warning for them later.
	        if (iteratorFn !== node.entries) {
	          var iterator = iteratorFn.call(node);
	          var step;

	          while (!(step = iterator.next()).done) {
	            if (isValidElement(step.value)) {
	              validateExplicitKey(step.value, parentType);
	            }
	          }
	        }
	      }
	    }
	  }
	}
	/**
	 * Given an element, validate that its props follow the propTypes definition,
	 * provided by the type.
	 *
	 * @param {ReactElement} element
	 */


	function validatePropTypes(element) {
	  {
	    var type = element.type;

	    if (type === null || type === undefined || typeof type === 'string') {
	      return;
	    }

	    var propTypes;

	    if (typeof type === 'function') {
	      propTypes = type.propTypes;
	    } else if (typeof type === 'object' && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
	    // Inner props are checked in the reconciler.
	    type.$$typeof === REACT_MEMO_TYPE)) {
	      propTypes = type.propTypes;
	    } else {
	      return;
	    }

	    if (propTypes) {
	      // Intentionally inside to avoid triggering lazy initializers:
	      var name = getComponentNameFromType(type);
	      checkPropTypes(propTypes, element.props, 'prop', name, element);
	    } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
	      propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:

	      var _name = getComponentNameFromType(type);

	      error('Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?', _name || 'Unknown');
	    }

	    if (typeof type.getDefaultProps === 'function' && !type.getDefaultProps.isReactClassApproved) {
	      error('getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.');
	    }
	  }
	}
	/**
	 * Given a fragment, validate that it can only be provided with fragment props
	 * @param {ReactElement} fragment
	 */


	function validateFragmentProps(fragment) {
	  {
	    var keys = Object.keys(fragment.props);

	    for (var i = 0; i < keys.length; i++) {
	      var key = keys[i];

	      if (key !== 'children' && key !== 'key') {
	        setCurrentlyValidatingElement$1(fragment);

	        error('Invalid prop `%s` supplied to `React.Fragment`. ' + 'React.Fragment can only have `key` and `children` props.', key);

	        setCurrentlyValidatingElement$1(null);
	        break;
	      }
	    }

	    if (fragment.ref !== null) {
	      setCurrentlyValidatingElement$1(fragment);

	      error('Invalid attribute `ref` supplied to `React.Fragment`.');

	      setCurrentlyValidatingElement$1(null);
	    }
	  }
	}

	var didWarnAboutKeySpread = {};
	function jsxWithValidation(type, props, key, isStaticChildren, source, self) {
	  {
	    var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
	    // succeed and there will likely be errors in render.

	    if (!validType) {
	      var info = '';

	      if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	        info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and named imports.";
	      }

	      var sourceInfo = getSourceInfoErrorAddendum();

	      if (sourceInfo) {
	        info += sourceInfo;
	      } else {
	        info += getDeclarationErrorAddendum();
	      }

	      var typeString;

	      if (type === null) {
	        typeString = 'null';
	      } else if (isArray(type)) {
	        typeString = 'array';
	      } else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
	        typeString = "<" + (getComponentNameFromType(type.type) || 'Unknown') + " />";
	        info = ' Did you accidentally export a JSX literal instead of a component?';
	      } else {
	        typeString = typeof type;
	      }

	      error('React.jsx: type is invalid -- expected a string (for ' + 'built-in components) or a class/function (for composite ' + 'components) but got: %s.%s', typeString, info);
	    }

	    var element = jsxDEV(type, props, key, source, self); // The result can be nullish if a mock or a custom function is used.
	    // TODO: Drop this when these are no longer allowed as the type argument.

	    if (element == null) {
	      return element;
	    } // Skip key warning if the type isn't valid since our key validation logic
	    // doesn't expect a non-string/function type and can throw confusing errors.
	    // We don't want exception behavior to differ between dev and prod.
	    // (Rendering will throw with a helpful message and as soon as the type is
	    // fixed, the key warnings will appear.)


	    if (validType) {
	      var children = props.children;

	      if (children !== undefined) {
	        if (isStaticChildren) {
	          if (isArray(children)) {
	            for (var i = 0; i < children.length; i++) {
	              validateChildKeys(children[i], type);
	            }

	            if (Object.freeze) {
	              Object.freeze(children);
	            }
	          } else {
	            error('React.jsx: Static children should always be an array. ' + 'You are likely explicitly calling React.jsxs or React.jsxDEV. ' + 'Use the Babel transform instead.');
	          }
	        } else {
	          validateChildKeys(children, type);
	        }
	      }
	    }

	    {
	      if (hasOwnProperty.call(props, 'key')) {
	        var componentName = getComponentNameFromType(type);
	        var keys = Object.keys(props).filter(function (k) {
	          return k !== 'key';
	        });
	        var beforeExample = keys.length > 0 ? '{key: someKey, ' + keys.join(': ..., ') + ': ...}' : '{key: someKey}';

	        if (!didWarnAboutKeySpread[componentName + beforeExample]) {
	          var afterExample = keys.length > 0 ? '{' + keys.join(': ..., ') + ': ...}' : '{}';

	          error('A props object containing a "key" prop is being spread into JSX:\n' + '  let props = %s;\n' + '  <%s {...props} />\n' + 'React keys must be passed directly to JSX without using spread:\n' + '  let props = %s;\n' + '  <%s key={someKey} {...props} />', beforeExample, componentName, afterExample, componentName);

	          didWarnAboutKeySpread[componentName + beforeExample] = true;
	        }
	      }
	    }

	    if (type === REACT_FRAGMENT_TYPE) {
	      validateFragmentProps(element);
	    } else {
	      validatePropTypes(element);
	    }

	    return element;
	  }
	} // These two functions exist to still get child warnings in dev
	// even with the prod transform. This means that jsxDEV is purely
	// opt-in behavior for better messages but that we won't stop
	// giving you warnings if you use production apis.

	function jsxWithValidationStatic(type, props, key) {
	  {
	    return jsxWithValidation(type, props, key, true);
	  }
	}
	function jsxWithValidationDynamic(type, props, key) {
	  {
	    return jsxWithValidation(type, props, key, false);
	  }
	}

	var jsx =  jsxWithValidationDynamic ; // we may want to special case jsxs internally to take advantage of static children.
	// for now we can ship identical prod functions

	var jsxs =  jsxWithValidationStatic ;

	reactJsxRuntime_development.Fragment = REACT_FRAGMENT_TYPE;
	reactJsxRuntime_development.jsx = jsx;
	reactJsxRuntime_development.jsxs = jsxs;
	  })();
	}
	return reactJsxRuntime_development;
}

var hasRequiredJsxRuntime;

function requireJsxRuntime () {
	if (hasRequiredJsxRuntime) return jsxRuntime.exports;
	hasRequiredJsxRuntime = 1;

	if (process.env.NODE_ENV === 'production') {
	  jsxRuntime.exports = requireReactJsxRuntime_production_min();
	} else {
	  jsxRuntime.exports = requireReactJsxRuntime_development();
	}
	return jsxRuntime.exports;
}

var jsxRuntimeExports = requireJsxRuntime();

const alert = {
    danger: {
        backgroundColor: tokens.kdsColorDanger100,
        backgroundColorActive: tokens.kdsColorDanger300,
        backgroundColorHover: tokens.kdsColorDanger200,
        foregroundColor: tokens.kdsColorDanger700,
    },
    info: {
        backgroundColor: tokens.kdsColorLightblue100,
        backgroundColorActive: tokens.kdsColorLightblue300,
        backgroundColorHover: tokens.kdsColorLightblue200,
        foregroundColor: tokens.kdsColorLightblue700,
    },
    success: {
        backgroundColor: tokens.kdsColorSuccess100,
        backgroundColorActive: tokens.kdsColorSuccess300,
        backgroundColorHover: tokens.kdsColorSuccess200,
        foregroundColor: tokens.kdsColorSuccess700,
    },
    warning: {
        backgroundColor: tokens.kdsColorWarning100,
        backgroundColorActive: tokens.kdsColorWarning300,
        backgroundColorHover: tokens.kdsColorWarning200,
        foregroundColor: tokens.kdsColorWarning700,
    },
};

const appLayout = {
    header: {
        height: tokens.kdsSpacing16,
    },
};

/* eslint-disable perfectionist/sort-objects */
const badge = {
    backgroundColor: {
        blue: tokens.kdsColorBlue100,
        magenta: tokens.kdsColorMagenta100,
        red: tokens.kdsColorRed100,
        orange: tokens.kdsColorOrange100,
        yellow: tokens.kdsColorYellow100,
        green: tokens.kdsColorGreen100,
        cyan: tokens.kdsColorCyan100,
        neutral: tokens.kdsColorNeutral100,
        inverse: '#5e6d90',
        none: tokens.kdsColorGreen500,
        mild: tokens.kdsColorYellow400,
        moderate: tokens.kdsColorOrange500,
        severe: tokens.kdsColorOrange700,
        extreme: tokens.kdsColorRed700,
    },
    borderRadii: {
        circle: tokens.kdsBorderRadiusFull,
        square: tokens.kdsBorderRadiusSmall,
    },
    foregroundColor: {
        blue: tokens.kdsColorBlue700,
        magenta: tokens.kdsColorMagenta800,
        red: tokens.kdsColorRed700,
        orange: tokens.kdsColorOrange700,
        yellow: tokens.kdsColorYellow700,
        green: tokens.kdsColorGreen700,
        cyan: tokens.kdsColorCyan700,
        neutral: tokens.kdsColorNeutral700,
        inverse: tokens.kdsColorWhite,
        none: tokens.kdsColorNeutral900,
        mild: tokens.kdsColorNeutral900,
        moderate: tokens.kdsColorNeutral900,
        severe: tokens.kdsColorWhite,
        extreme: tokens.kdsColorWhite,
    },
    size: {
        large: {
            fontSize: tokens.kdsFontSizeMd,
            height: '30px',
            iconMargin: tokens.kdsSpacing2,
            iconSize: tokens.kdsSpacing4,
            lineHeight: tokens.kdsLineHeight6,
        },
        medium: {
            fontSize: tokens.kdsFontSizeSm,
            height: '24px',
            iconMargin: tokens.kdsSpacing15,
            iconSize: tokens.kdsSpacing35,
            lineHeight: tokens.kdsLineHeight5,
        },
        small: {
            fontSize: tokens.kdsFontSizeXs,
            height: '21px',
            iconMargin: tokens.kdsSpacing1,
            iconSize: tokens.kdsSpacing3,
            lineHeight: tokens.kdsLineHeight4,
        },
    },
};

const collection = {
    icon: {
        color: tokens.kdsColorNeutral300,
        easing: tokens.kdsEaseOut,
        hoverColor: tokens.kdsColorNeutral400,
    },
    link: {
        easing: tokens.kdsEaseIn,
        hoverColor: tokens.kdsColorNeutral50,
    },
};

const drawer = {
    size: {
        xsmall: '320px',
        small: '448px',
        medium: '512px',
        large: '672px;',
    },
};

const formButtonRow = {
    large: {
        marginTop: tokens.kdsSpacing8,
    },
    medium: {
        marginTop: tokens.kdsSpacing6,
    },
};

const formSection = {
    large: {
        header: {
            marginBottom: tokens.kdsSpacing5,
        },
        marginTop: tokens.kdsSpacing8,
        paddingTop: tokens.kdsSpacing8,
    },
    medium: {
        header: {
            marginBottom: tokens.kdsSpacing3,
        },
        marginTop: tokens.kdsSpacing6,
        paddingTop: tokens.kdsSpacing6,
    },
};

const formSubsection = {
    large: {
        header: {
            marginBottom: tokens.kdsSpacing5,
        },
        marginTop: tokens.kdsSpacing8,
    },
    medium: {
        header: {
            marginBottom: tokens.kdsSpacing3,
        },
        marginTop: tokens.kdsSpacing6,
    },
};

const iconButton = {
    size: {
        medium: {
            height: '40px',
            iconSize: '20px',
            width: '40px',
        },
        small: {
            height: '32px',
            iconSize: '18px',
            width: '32px',
        },
    },
    variant: {
        default: {
            backgroundColor: tokens.kdsColorTransparent,
            backgroundColorActive: tokens.kdsColorNeutral300,
            backgroundColorHover: tokens.kdsColorNeutral200,
            color: tokens.kdsColorNeutral500,
            colorActive: tokens.kdsColorNeutral800,
            colorDisabled: tokens.kdsColorNeutral400,
            colorHover: tokens.kdsColorNeutral700,
        },
        filled: {
            backgroundColor: tokens.kdsColorNeutral200,
            backgroundColorActive: tokens.kdsColorNeutral400,
            backgroundColorHover: tokens.kdsColorNeutral300,
            color: tokens.kdsColorNeutral700,
            colorActive: tokens.kdsColorNeutral900,
            colorDisabled: tokens.kdsColorNeutral400,
            colorHover: tokens.kdsColorNeutral800,
        },
        ghost: {
            backgroundColor: tokens.kdsColorTransparent,
            backgroundColorActive: tokens.kdsColorTransparent,
            backgroundColorHover: tokens.kdsColorTransparent,
            color: tokens.kdsColorNeutral500,
            colorActive: tokens.kdsColorNeutral800,
            colorDisabled: tokens.kdsColorNeutral400,
            colorHover: tokens.kdsColorNeutral700,
        },
        inverse: {
            backgroundColor: tokens.kdsColorTransparent,
            backgroundColorActive: 'rgb(255 255 255 / 20%)',
            backgroundColorHover: 'rgb(255 255 255 / 30%)',
            color: tokens.kdsColorWhite,
            colorActive: tokens.kdsColorWhite,
            colorDisabled: tokens.kdsColorNeutral400,
            colorHover: tokens.kdsColorWhite,
        },
    },
};

const monthPicker = {
    large: {
        fontSize: tokens.kdsFontSizeMd,
        height: '40px',
        iconButtonPositionBottom: '4px',
        iconButtonPositionRight: '38px',
        iconButtonPositionTop: '4px',
        iconPositionBottom: '12px',
        iconPositionRight: '12px',
        iconPositionTop: '10px',
        lineHeight: tokens.kdsLineHeight6,
        paddingLeft: '12px',
        paddingRight: '42px',
        width: '180px',
    },
    medium: {
        fontSize: tokens.kdsFontSizeSm,
        height: '38px',
        iconButtonPositionBottom: '3px',
        iconButtonPositionRight: '34px',
        iconButtonPositionTop: '3px',
        iconPositionBottom: '11px',
        iconPositionRight: '12px',
        iconPositionTop: '9px',
        lineHeight: tokens.kdsLineHeight5,
        paddingLeft: '12px',
        paddingRight: '40px',
        width: '160px',
    },
};

const pageLayout = {
    sideBar: {
        width: '320px',
    },
    width: {
        small: '896px',
        medium: '1280px',
        large: '1680px',
        full: '100%',
    },
};

const ribbon = {
    backgroundColor: {
        primary: tokens.kdsColorPrimary100,
        secondary: tokens.kdsColorSecondary100,
        success: tokens.kdsColorSuccess100,
    },
    color: {
        primary: tokens.kdsColorPrimary700,
        secondary: tokens.kdsColorSecondary700,
        success: tokens.kdsColorSuccess700,
    },
};

/* eslint-disable perfectionist/sort-objects */
const scoreBar = {
    backgroundColor: {
        none: tokens.kdsColorGreen500,
        mild: tokens.kdsColorYellow400,
        moderate: tokens.kdsColorOrange500,
        severe: tokens.kdsColorOrange700,
        extreme: tokens.kdsColorRed700,
    },
    color: {
        none: tokens.kdsColorNeutral900,
        mild: tokens.kdsColorNeutral900,
        moderate: tokens.kdsColorNeutral900,
        severe: tokens.kdsColorWhite,
        extreme: tokens.kdsColorWhite,
    },
};

const serialNumberInput = {
    color: {
        default: tokens.kdsColorMagenta700,
        error: tokens.kdsColorOrange700,
        success: tokens.kdsColorGreen700,
    },
};

const switchTheme = {
    backgroundColor: tokens.kdsColorNeutral300,
    backgroundColorChecked: tokens.kdsColorBackgroundSelected,
    backgroundColorCheckedDisabled: tokens.kdsColorBackgroundDisabled,
    backgroundColorCircle: tokens.kdsColorWhite,
    backgroundColorCircleChecked: tokens.kdsColorWhite,
    backgroundColorCircleDisabled: tokens.kdsColorNeutral300,
    backgroundColorDisabled: tokens.kdsColorWhite,
    borderColorDisabled: tokens.kdsColorNeutral300,
};

const todoList = {
    color: {
        danger: kdsColorDanger700,
        neutral: kdsColorForegroundDisabled,
        primary: kdsColorPrimary700,
        secondary: kdsColorSecondary700,
    },
    iconColor: {
        danger: 'danger',
        neutral: 'disabled',
        primary: 'primary',
        secondary: 'secondary',
    },
};

const components$1 = {
    alert,
    appLayout,
    badge,
    collection,
    drawer,
    formButtonRow,
    formSection,
    formSubsection,
    iconButton,
    monthPicker,
    pageLayout,
    ribbon,
    scoreBar,
    serialNumberInput,
    switch: switchTheme,
    todoList,
};

/* eslint-disable perfectionist/sort-objects */
const breakpoints = [
    tokens.kdsBreakpointSmall,
    tokens.kdsBreakpointMedium,
    tokens.kdsBreakpointLarge,
    tokens.kdsBreakpointXlarge,
];
const mediaQueries = {
    small: `@media screen and (min-width: ${breakpoints[0]})`,
    medium: `@media screen and (min-width: ${breakpoints[1]})`,
    large: `@media screen and (min-width: ${breakpoints[2]})`,
    xlarge: `@media screen and (min-width: ${breakpoints[3]})`,
};

/* eslint-disable perfectionist/sort-objects */
const colors$1 = {
    // Semantic color palette tokens
    primary50: tokens.kdsColorPrimary50,
    primary100: tokens.kdsColorPrimary100,
    primary200: tokens.kdsColorPrimary200,
    primary300: tokens.kdsColorPrimary300,
    primary400: tokens.kdsColorPrimary400,
    primary500: tokens.kdsColorPrimary500,
    primary600: tokens.kdsColorPrimary600,
    primary700: tokens.kdsColorPrimary700,
    primary800: tokens.kdsColorPrimary800,
    primary900: tokens.kdsColorPrimary900,
    primary950: tokens.kdsColorPrimary950,
    secondary50: tokens.kdsColorSecondary50,
    secondary100: tokens.kdsColorSecondary100,
    secondary200: tokens.kdsColorSecondary200,
    secondary300: tokens.kdsColorSecondary300,
    secondary400: tokens.kdsColorSecondary400,
    secondary500: tokens.kdsColorSecondary500,
    secondary600: tokens.kdsColorSecondary600,
    secondary700: tokens.kdsColorSecondary700,
    secondary800: tokens.kdsColorSecondary800,
    secondary900: tokens.kdsColorSecondary900,
    secondary950: tokens.kdsColorSecondary950,
    success50: tokens.kdsColorSuccess50,
    success100: tokens.kdsColorSuccess100,
    success200: tokens.kdsColorSuccess200,
    success300: tokens.kdsColorSuccess300,
    success400: tokens.kdsColorSuccess400,
    success500: tokens.kdsColorSuccess500,
    success600: tokens.kdsColorSuccess600,
    success700: tokens.kdsColorSuccess700,
    success800: tokens.kdsColorSuccess800,
    success900: tokens.kdsColorSuccess900,
    success950: tokens.kdsColorSuccess950,
    warning50: tokens.kdsColorWarning50,
    warning100: tokens.kdsColorWarning100,
    warning200: tokens.kdsColorWarning200,
    warning300: tokens.kdsColorWarning300,
    warning400: tokens.kdsColorWarning400,
    warning500: tokens.kdsColorWarning500,
    warning600: tokens.kdsColorWarning600,
    warning700: tokens.kdsColorWarning700,
    warning800: tokens.kdsColorWarning800,
    warning900: tokens.kdsColorWarning900,
    warning950: tokens.kdsColorWarning950,
    danger50: tokens.kdsColorDanger50,
    danger100: tokens.kdsColorDanger100,
    danger200: tokens.kdsColorDanger200,
    danger300: tokens.kdsColorDanger300,
    danger400: tokens.kdsColorDanger400,
    danger500: tokens.kdsColorDanger500,
    danger600: tokens.kdsColorDanger600,
    danger700: tokens.kdsColorDanger700,
    danger800: tokens.kdsColorDanger800,
    danger900: tokens.kdsColorDanger900,
    danger950: tokens.kdsColorDanger950,
    neutral0: tokens.kdsColorNeutral0,
    neutral50: tokens.kdsColorNeutral50,
    neutral100: tokens.kdsColorNeutral100,
    neutral200: tokens.kdsColorNeutral200,
    neutral300: tokens.kdsColorNeutral300,
    neutral400: tokens.kdsColorNeutral400,
    neutral500: tokens.kdsColorNeutral500,
    neutral600: tokens.kdsColorNeutral600,
    neutral700: tokens.kdsColorNeutral700,
    neutral800: tokens.kdsColorNeutral800,
    neutral900: tokens.kdsColorNeutral900,
    neutral950: tokens.kdsColorNeutral950,
    neutral1000: tokens.kdsColorNeutral1000,
    // Base color palette tokens
    magenta50: tokens.kdsColorMagenta50,
    magenta100: tokens.kdsColorMagenta100,
    magenta200: tokens.kdsColorMagenta200,
    magenta300: tokens.kdsColorMagenta300,
    magenta400: tokens.kdsColorMagenta400,
    magenta500: tokens.kdsColorMagenta500,
    magenta600: tokens.kdsColorMagenta600,
    magenta700: tokens.kdsColorMagenta700,
    magenta800: tokens.kdsColorMagenta800,
    magenta900: tokens.kdsColorMagenta900,
    magenta950: tokens.kdsColorMagenta950,
    purple50: tokens.kdsColorPurple50,
    purple100: tokens.kdsColorPurple100,
    purple200: tokens.kdsColorPurple200,
    purple300: tokens.kdsColorPurple300,
    purple400: tokens.kdsColorPurple400,
    purple500: tokens.kdsColorPurple500,
    purple600: tokens.kdsColorPurple600,
    purple700: tokens.kdsColorPurple700,
    purple800: tokens.kdsColorPurple800,
    purple900: tokens.kdsColorPurple900,
    purple950: tokens.kdsColorPurple950,
    blue50: tokens.kdsColorBlue50,
    blue100: tokens.kdsColorBlue100,
    blue200: tokens.kdsColorBlue200,
    blue300: tokens.kdsColorBlue300,
    blue400: tokens.kdsColorBlue400,
    blue500: tokens.kdsColorBlue500,
    blue600: tokens.kdsColorBlue600,
    blue700: tokens.kdsColorBlue700,
    blue800: tokens.kdsColorBlue800,
    blue900: tokens.kdsColorBlue900,
    blue950: tokens.kdsColorBlue950,
    lightBlue50: tokens.kdsColorLightblue50,
    lightBlue100: tokens.kdsColorLightblue100,
    lightBlue200: tokens.kdsColorLightblue200,
    lightBlue300: tokens.kdsColorLightblue300,
    lightBlue400: tokens.kdsColorLightblue400,
    lightBlue500: tokens.kdsColorLightblue500,
    lightBlue600: tokens.kdsColorLightblue600,
    lightBlue700: tokens.kdsColorLightblue700,
    lightBlue800: tokens.kdsColorLightblue800,
    lightBlue900: tokens.kdsColorLightblue900,
    lightBlue950: tokens.kdsColorLightblue950,
    teal50: tokens.kdsColorTeal50,
    teal100: tokens.kdsColorTeal100,
    teal200: tokens.kdsColorTeal200,
    teal300: tokens.kdsColorTeal300,
    teal400: tokens.kdsColorTeal400,
    teal500: tokens.kdsColorTeal500,
    teal600: tokens.kdsColorTeal600,
    teal700: tokens.kdsColorTeal700,
    teal800: tokens.kdsColorTeal800,
    teal900: tokens.kdsColorTeal900,
    teal950: tokens.kdsColorTeal950,
    cyan50: tokens.kdsColorCyan50,
    cyan100: tokens.kdsColorCyan100,
    cyan200: tokens.kdsColorCyan200,
    cyan300: tokens.kdsColorCyan300,
    cyan400: tokens.kdsColorCyan400,
    cyan500: tokens.kdsColorCyan500,
    cyan600: tokens.kdsColorCyan600,
    cyan700: tokens.kdsColorCyan700,
    cyan800: tokens.kdsColorCyan800,
    cyan900: tokens.kdsColorCyan900,
    cyan950: tokens.kdsColorCyan950,
    green50: tokens.kdsColorGreen50,
    green100: tokens.kdsColorGreen100,
    green200: tokens.kdsColorGreen200,
    green300: tokens.kdsColorGreen300,
    green400: tokens.kdsColorGreen400,
    green500: tokens.kdsColorGreen500,
    green600: tokens.kdsColorGreen600,
    green700: tokens.kdsColorGreen700,
    green800: tokens.kdsColorGreen800,
    green900: tokens.kdsColorGreen900,
    green950: tokens.kdsColorGreen950,
    lime50: tokens.kdsColorLime50,
    lime100: tokens.kdsColorLime100,
    lime200: tokens.kdsColorLime200,
    lime300: tokens.kdsColorLime300,
    lime400: tokens.kdsColorLime400,
    lime500: tokens.kdsColorLime500,
    lime600: tokens.kdsColorLime600,
    lime700: tokens.kdsColorLime700,
    lime800: tokens.kdsColorLime800,
    lime900: tokens.kdsColorLime900,
    lime950: tokens.kdsColorLime950,
    yellow50: tokens.kdsColorYellow50,
    yellow100: tokens.kdsColorYellow100,
    yellow200: tokens.kdsColorYellow200,
    yellow300: tokens.kdsColorYellow300,
    yellow400: tokens.kdsColorYellow400,
    yellow500: tokens.kdsColorYellow500,
    yellow600: tokens.kdsColorYellow600,
    yellow700: tokens.kdsColorYellow700,
    yellow800: tokens.kdsColorYellow800,
    yellow900: tokens.kdsColorYellow900,
    yellow950: tokens.kdsColorYellow950,
    orange50: tokens.kdsColorOrange50,
    orange100: tokens.kdsColorOrange100,
    orange200: tokens.kdsColorOrange200,
    orange300: tokens.kdsColorOrange300,
    orange400: tokens.kdsColorOrange400,
    orange500: tokens.kdsColorOrange500,
    orange600: tokens.kdsColorOrange600,
    orange700: tokens.kdsColorOrange700,
    orange800: tokens.kdsColorOrange800,
    orange900: tokens.kdsColorOrange900,
    orange950: tokens.kdsColorOrange950,
    red50: tokens.kdsColorRed50,
    red100: tokens.kdsColorRed100,
    red200: tokens.kdsColorRed200,
    red300: tokens.kdsColorRed300,
    red400: tokens.kdsColorRed400,
    red500: tokens.kdsColorRed500,
    red600: tokens.kdsColorRed600,
    red700: tokens.kdsColorRed700,
    red800: tokens.kdsColorRed800,
    red900: tokens.kdsColorRed900,
    red950: tokens.kdsColorRed950,
    gray50: tokens.kdsColorGray50,
    gray100: tokens.kdsColorGray100,
    gray200: tokens.kdsColorGray200,
    gray300: tokens.kdsColorGray300,
    gray400: tokens.kdsColorGray400,
    gray500: tokens.kdsColorGray500,
    gray600: tokens.kdsColorGray600,
    gray700: tokens.kdsColorGray700,
    gray800: tokens.kdsColorGray800,
    gray900: tokens.kdsColorGray900,
    gray950: tokens.kdsColorGray950,
    white: tokens.kdsColorWhite,
    black: tokens.kdsColorBlack,
    transparent: tokens.kdsColorTransparent,
};

/* eslint-disable perfectionist/sort-objects */
const fontSizes = {
    xs: tokens.kdsFontSizeXs,
    sm: tokens.kdsFontSizeSm,
    md: tokens.kdsFontSizeMd,
    lg: tokens.kdsFontSizeLg,
    xl: tokens.kdsFontSizeXl,
    '2xl': tokens.kdsFontSize2xl,
    '3xl': tokens.kdsFontSize3xl,
    '4xl': tokens.kdsFontSize4xl,
    '5xl': tokens.kdsFontSize5xl,
    '6xl': tokens.kdsFontSize6xl,
    '7xl': tokens.kdsFontSize7xl,
    '8xl': tokens.kdsFontSize8xl,
    '9xl': tokens.kdsFontSize9xl,
    inherit: 'inherit',
};

/* eslint-disable perfectionist/sort-objects */
const fontWeights = {
    normal: tokens.kdsFontWeightNormal,
    medium: tokens.kdsFontWeightMedium,
    bold: tokens.kdsFontWeightBold,
};

const fonts = {
    base: tokens.kdsFontFamilyBase,
};

/* eslint-disable perfectionist/sort-objects */
const letterSpacings = {
    tighter: tokens.kdsLetterSpacingTighter,
    tight: tokens.kdsLetterSpacingTight,
    normal: tokens.kdsLetterSpacingNormal,
    wide: tokens.kdsLetterSpacingWide,
    wider: tokens.kdsLetterSpacingWider,
    widest: tokens.kdsLetterSpacingWidest,
};

/* eslint-disable perfectionist/sort-objects */
const lineHeights = {
    3: tokens.kdsLineHeight3,
    4: tokens.kdsLineHeight4,
    5: tokens.kdsLineHeight5,
    6: tokens.kdsLineHeight6,
    7: tokens.kdsLineHeight7,
    8: tokens.kdsLineHeight8,
    9: tokens.kdsLineHeight9,
    10: tokens.kdsLineHeight10,
    none: tokens.kdsLineHeightNone,
    tight: tokens.kdsLineHeightTight,
    snug: tokens.kdsLineHeightSnug,
    normal: tokens.kdsLineHeightNormal,
    relaxed: tokens.kdsLineHeightRelaxed,
    loose: tokens.kdsLineHeightLoose,
    inherit: 'inherit',
};

/* eslint-disable perfectionist/sort-objects */
const radii = {
    none: tokens.kdsBorderRadiusNone,
    sm: tokens.kdsBorderRadiusSmall,
    base: tokens.kdsBorderRadiusBase,
    md: tokens.kdsBorderRadiusMedium,
    lg: tokens.kdsBorderRadiusLarge,
    xl: tokens.kdsBorderRadiusXlarge,
    '2xl': tokens.kdsBorderRadius2xlarge,
    '3xl': tokens.kdsBorderRadius3xlarge,
    full: tokens.kdsBorderRadiusFull,
};

/* eslint-disable perfectionist/sort-objects */
const shadows = {
    none: tokens.kdsBoxShadowNone,
    sm: tokens.kdsBoxShadowSmall,
    base: tokens.kdsBoxShadowBase,
    md: tokens.kdsBoxShadowMedium,
    lg: tokens.kdsBoxShadowLarge,
    xl: tokens.kdsBoxShadowXlarge,
    '2xl': tokens.kdsBoxShadow2xlarge,
};

/* eslint-disable perfectionist/sort-objects */
const space = {
    0: tokens.kdsSpacing0,
    px: tokens.kdsSpacingPx,
    0.5: tokens.kdsSpacing05,
    1: tokens.kdsSpacing1,
    1.5: tokens.kdsSpacing15,
    2: tokens.kdsSpacing2,
    2.5: tokens.kdsSpacing25,
    3: tokens.kdsSpacing3,
    3.5: tokens.kdsSpacing35,
    4: tokens.kdsSpacing4,
    5: tokens.kdsSpacing5,
    6: tokens.kdsSpacing6,
    7: tokens.kdsSpacing7,
    8: tokens.kdsSpacing8,
    9: tokens.kdsSpacing9,
    10: tokens.kdsSpacing10,
    12: tokens.kdsSpacing12,
    14: tokens.kdsSpacing14,
    16: tokens.kdsSpacing16,
    20: tokens.kdsSpacing20,
    24: tokens.kdsSpacing24,
    28: tokens.kdsSpacing28,
    32: tokens.kdsSpacing32,
    36: tokens.kdsSpacing36,
    40: tokens.kdsSpacing40,
    44: tokens.kdsSpacing44,
    48: tokens.kdsSpacing48,
    56: tokens.kdsSpacing56,
    60: tokens.kdsSpacing60,
    64: tokens.kdsSpacing64,
    72: tokens.kdsSpacing72,
    80: tokens.kdsSpacing80,
    96: tokens.kdsSpacing96,
};

/* eslint-disable perfectionist/sort-objects */
const zIndices = {
    hide: -1,
    auto: 'auto',
    base: 0,
    banner: 900,
    navbar: 999,
    modal: 1050,
};

const foundations = {
    breakpoints,
    colors: colors$1,
    fonts,
    fontSizes,
    fontWeights,
    letterSpacings,
    lineHeights,
    mediaQueries,
    radii,
    shadows,
    space,
    zIndices,
};

const defaultTheme$1 = Object.assign(Object.assign({}, foundations), components$1);

createContext(defaultTheme$1);
const ThemeProvider = (_a) => {
    var { children, theme } = _a, props = __rest(_a, ["children", "theme"]);
    if (defaultTheme$1 === undefined) {
        throw new Error('theme value must be provided within a ThemeProvider');
    }
    return (jsxRuntimeExports.jsx(ThemeProvider$1, Object.assign({ theme: theme }, props, { children: children })));
};

const sx = (props) => css$2(props.sx);

const Box = styled.div.withConfig({ shouldForwardProp }) `
    ${compose(background$1, flexbox, grid, layout, shadow, space$1, border, color, position, typography)}
    ${system({
    gap: {
        property: 'gap',
        scale: 'space',
    },
})}
    ${sx}
`;

const iconPathProperties = {
    'todo-list': {
        stroke: 'currentColor',
    },
    'waiting-small': {
        clipRule: 'evenodd',
        fillRule: 'evenodd',
    },
};

// Icon paths
const iconPaths = {
    add: 'M10 10v6.071a1 1 0 1 1-2 0V10H1.929a1 1 0 1 1 0-2H8V1.929a1 1 0 1 1 2 0V8h6.071a1 1 0 1 1 0 2H10z',
    'add-patient': 'M6.5 6a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm1.96 3a4 4 0 0 1 3.945 3.342l.583 3.494A1 1 0 0 1 12 17h-2a1 1 0 0 1 0-2h.82l-.388-2.329A2 2 0 0 0 8.459 11H4.542a2 2 0 0 0-1.973 1.671L2.18 15H3a1 1 0 0 1 0 2H1a1 1 0 0 1-.987-1.164l.582-3.494A4 4 0 0 1 4.542 9h3.917zM15 4a1 1 0 0 1 1 1v1h1a1 1 0 0 1 0 2h-1v1a1 1 0 0 1-2 0V8h-1a1 1 0 1 1 0-2h1V5a1 1 0 0 1 1-1zM6.5 1a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7z',
    'arrow-down': 'M8.225 14.095L8.21 2.02a1 1 0 112 0v12.083l2.548-2.548a1 1 0 011.415 1.414L10 17.142a1.1 1.1 0 01-1.556 0L4.272 12.97a1 1 0 011.414-1.414l2.54 2.539z',
    'arrow-left': 'M4.37 8.246l12.073-.016h.001a1 1 0 1 1 0 2H4.36l2.548 2.548a1 1 0 0 1-1.414 1.414L1.322 10.02a1.1 1.1 0 0 1 0-1.555l4.172-4.172a1 1 0 0 1 1.414 1.414L4.37 8.246z',
    'arrow-right': 'M13.828 10.243H2.001a1 1 0 0 1-.002-2h.002l11.843.015-2.551-2.55a1 1 0 1 1 1.414-1.415l4.172 4.172a1.1 1.1 0 0 1 0 1.555l-4.172 4.172a1 1 0 0 1-1.414-1.414l2.535-2.535z',
    'arrow-up': 'M10.219 4.39l.016 12.074v.001a1 1 0 11-2-.001V4.38L5.686 6.929a1 1 0 01-1.414-1.414l4.172-4.172a1.1 1.1 0 011.556 0l4.172 4.172a1 1 0 01-1.415 1.414L10.22 4.39z',
    assessment: 'm14 0c1.1046 0 2 0.89543 2 2v14c0 1.1046-0.89543 2-2 2h-10c-1.1046 0-2-0.89543-2-2v-14c0-1.1046 0.89543-2 2-2h10zm0 2h-10v14h10v-14zm-3.5-1.6c0.82843 0 1.5 0.67157 1.5 1.5s-0.67157 1.5-1.5 1.5h-3c-0.82843 0-1.5-0.67157-1.5-1.5s0.67157-1.5 1.5-1.5h3zm1.5 5c0.55228 0 1 0.44772 1 1s-0.44772 1-1 1h-3c-0.55228 0-1-0.44772-1-1s0.44772-1 1-1h3zm-6 0c0.55228 0 1 0.44772 1 1s-0.44772 1-1 1-1-0.44772-1-1 0.44772-1 1-1zm6 3c0.55228 0 1 0.44772 1 1s-0.44772 1-1 1h-3c-0.55228 0-1-0.44772-1-1s0.44772-1 1-1h3zm-6 0c0.55228 0 1 0.44772 1 1s-0.44772 1-1 1-1-0.44772-1-1 0.44772-1 1-1zm6 3c0.55228 0 1 0.44772 1 1s-0.44772 1-1 1h-3c-0.55228 0-1-0.44772-1-1s0.44772-1 1-1h3zm-6 0c0.55228 0 1 0.44772 1 1s-0.44772 1-1 1-1-0.44772-1-1 0.44772-1 1-1z',
    calender: 'M2 6v10h14V6H2zm10-4V1a1 1 0 0 1 2 0v1h2a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h2V1a1 1 0 1 1 2 0v1h6zM5 8a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm0 4a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm4-4a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm0 4a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm4-4a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm0 4a1 1 0 1 1 0 2 1 1 0 0 1 0-2z',
    'caret-double': 'M11.744 5.707a1 1 0 0 1 1.414-1.414l4.172 4.172a1.1 1.1 0 0 1 0 1.555l-4.172 4.172a1 1 0 0 1-1.414-1.414l3.536-3.535-3.536-3.536zM6.158 12.778a1 1 0 0 1-1.414 1.414L.572 10.02a1.1 1.1 0 0 1 0-1.555l4.172-4.172a1 1 0 1 1 1.414 1.414L2.623 9.243l3.535 3.535z',
    'caret-down': 'M12.372 6.293a.923.923 0 0 1 1.349 0c.372.39.372 1.024 0 1.414L9.74 11.88c-.409.43-1.073.43-1.483 0L4.28 7.707a1.035 1.035 0 0 1 0-1.414.923.923 0 0 1 1.35 0L9 9.828l3.372-3.535z',
    'caret-down-big': 'M.526 4.809a1 1 0 011.327-.078l-.62-.63L9.01 11.88l7.071-7.071a1 1 0 011.327-.078l.087.078a1 1 0 01.078 1.327l-.078.087L9.718 14a1 1 0 01-1.327.078L8.304 14 .526 6.223a1 1 0 010-1.414z',
    'caret-left': 'M11.908 12.778a1 1 0 0 1-1.414 1.414L6.322 10.02a1.1 1.1 0 0 1 0-1.555l4.172-4.172a1 1 0 0 1 1.414 1.414L8.373 9.243l3.535 3.535z',
    'caret-left-big': 'M12.4.507a1 1 0 01.077 1.327l.63-.62-7.779 7.778 7.071 7.071a1 1 0 01.078 1.327l-.078.088a1 1 0 01-1.326.077l-.088-.077-7.778-7.779a1 1 0 01-.078-1.326l.078-.088L10.985.507a1 1 0 011.414 0z',
    'caret-right': 'M6.293 5.707a1 1 0 0 1 1.414-1.414l4.172 4.172a1.1 1.1 0 0 1 0 1.555l-4.172 4.172a1 1 0 0 1-1.414-1.414l3.535-3.535-3.535-3.536z',
    'caret-right-big': 'M5.985.507a1 1 0 00-.077 1.327l-.63-.62 7.778 7.778-7.07 7.071a1 1 0 00-.078 1.327l.077.088a1 1 0 001.327.077l.087-.077 7.779-7.779a1 1 0 00.077-1.326l-.077-.088L7.399.507a1 1 0 00-1.414 0z',
    'caret-skip-backward': 'M13.72 5.695a1 1 0 00-1.415-1.414L8.132 8.453a1.1 1.1 0 000 1.556l4.173 4.172a1 1 0 001.414-1.414L10.184 9.23l3.535-3.536zM5.012 5.23a1 1 0 012 0v8a1 1 0 01-2 0v-8z',
    'caret-skip-forward': 'M4.28 5.695A1 1 0 015.696 4.28l4.173 4.172a1.1 1.1 0 010 1.556L5.695 14.18a1 1 0 01-1.414-1.414L7.816 9.23 4.28 5.695zM12.988 5.23a1 1 0 00-2 0v8a1 1 0 002 0v-8z',
    'caret-up': 'M5.707 11.908a1 1 0 1 1-1.414-1.414l4.172-4.172a1.1 1.1 0 0 1 1.555 0l4.172 4.172a1 1 0 0 1-1.414 1.414L9.243 8.373l-3.536 3.535z',
    'caret-up-big': 'M.526 13.223a1 1 0 001.327.077l-.62.63L9.01 6.152l7.071 7.07a1 1 0 001.327.078l.087-.077a1 1 0 00.078-1.327l-.078-.087L9.718 4.03a1 1 0 00-1.327-.077l-.087.077L.526 11.81a1 1 0 000 1.414z',
    check: 'M11.293 6.293a1 1 0 0 1 1.414 1.414L8 12.414 5.293 9.707a1 1 0 0 1 1.414-1.414L8 9.586l3.293-3.293z',
    checked: 'M9 16A7 7 0 1 0 9 2a7 7 0 0 0 0 14zM9 0a9 9 0 1 1 0 18A9 9 0 0 1 9 0zm3.707 6.293a1 1 0 0 0-1.32-.083l-.094.083L8 9.586 6.707 8.293a1 1 0 0 0-1.497 1.32l.083.094L8 12.414l4.707-4.707a1 1 0 0 0 0-1.414z',
    checkup: 'M12.906 15.32a8 8 0 1 1-1.33-13.478 1 1 0 1 1-.895 1.789A6 6 0 1 0 14 9a1 1 0 0 1 2-.001 7.965 7.965 0 0 1-1.68 4.906l2.387 2.387a1 1 0 0 1-1.414 1.414l-2.387-2.387zM8 9.586l8.293-8.293a1 1 0 0 1 1.414 1.414L8 12.414 4.293 8.707a1 1 0 0 1 1.414-1.414L8 9.586z',
    clock: 'M9,0 C13.9705516,0 18,4.02943939 18,9 C18,13.9705472 13.9705516,18 9,18 C4.02943367,18 0,13.9705472 0,9 C0,4.02943939 4.02943367,0 9,0 Z M8.99999774,1.8493123 C5.05078892,1.8493123 1.8493089,5.05079573 1.8493089,9.00000873 C1.8493089,12.9492114 5.05078892,16.1506846 8.99999774,16.1506846 C12.9492169,16.1506846 16.1506866,12.9492114 16.1506866,9.00000873 C16.1506866,5.05079573 12.9492169,1.8493123 8.99999774,1.8493123 Z M8.40491854,3.93975575 C8.88721949,3.93975575 9.27820544,4.33074211 9.27820544,4.81304357 L9.27820544,8.90604084 L12.1885727,11.8164317 C12.5295656,12.1574249 12.5295656,12.7103702 12.1885727,13.0514662 C11.8474772,13.3924594 11.2946352,13.3924594 10.9535396,13.0514662 L7.53163165,9.62950333 L7.53163165,4.81304357 C7.53163165,4.33074211 7.9226176,3.93975575 8.40491854,3.93975575 Z',
    close: 'M4.707 3.293L9 7.585l4.293-4.292a1 1 0 0 1 1.414 1.414L10.415 9l4.292 4.293a1 1 0 0 1-1.414 1.414L9 10.415l-4.293 4.292a1 1 0 1 1-1.414-1.414L7.585 9 3.293 4.707a1 1 0 0 1 1.414-1.414z',
    closed: 'M14.285 3.301a1 1 0 0 1 1.43 1.398l-8.642 8.849c-.618.604-1.567.593-2.146 0l-3.642-3.73a1 1 0 1 1 1.43-1.397L6 11.784l8.285-8.483z',
    consultation: 'M8.807 0c4.854 0 8.804 3.959 8.804 8.825a8.947 8.947 0 01-1.508 4.958l-2.534-.059a6.904 6.904 0 002.042-4.899C15.611 5.062 12.558 2 8.807 2 5.054 2 2 5.084 2 8.875s3.054 6.875 6.807 6.875h5.568l3.008.014.164-.001c.166.32.203.704.083 1.06-.184.556-.704.93-1.29.928H8.807C3.95 17.75 0 13.769 0 8.875 0 3.981 3.95 0 8.807 0zM5.423 7.762a1.152 1.152 0 110 2.304 1.152 1.152 0 010-2.304zm3.427 0a1.152 1.152 0 110 2.304 1.152 1.152 0 010-2.304zm3.428 0a1.152 1.152 0 110 2.304 1.152 1.152 0 010-2.304z',
    contact: 'M2.024 4v8.62c0 .491.39.896.893.951l.118.007h8.094l1.646 1.038a.463.463 0 0 1 .14.664.514.514 0 0 1-.42.213H7.081L2.79 17.932a.522.522 0 0 1-.694-.165.46.46 0 0 1-.072-.246v-2.028C.906 15.493 0 14.636 0 13.578V5.916C0 4.858.906 4 2.024 4zM18 0v11.494h-2v2.027a.49.49 0 0 1-.5.479.517.517 0 0 1-.257-.068l-4.124-2.37a.517.517 0 0 0-.257-.068H4V0h14zm-2 2H6v7.605h4.862c.453 0 .897.117 1.286.339L14 11V9.605h2V2zM8.5 5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5zm4 0h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5z',
    copy: 'M7.95312 1C6.57241 1 5.45312 2.11929 5.45312 3.5V10.9195C5.45312 12.3002 6.57241 13.4195 7.95312 13.4195H14.4994C15.8802 13.4195 16.9994 12.3002 16.9994 10.9195V3.5C16.9994 2.11929 15.8802 1 14.4994 1H7.95312ZM7.45312 3.5C7.45312 3.22386 7.67698 3 7.95312 3H14.4994C14.7756 3 14.9994 3.22386 14.9994 3.5V10.9195C14.9994 11.1957 14.7756 11.4195 14.4994 11.4195H7.95312C7.67698 11.4195 7.45312 11.1957 7.45312 10.9195V3.5ZM1.875 7.74412C1.875 6.20241 3.03795 4.93232 4.53447 4.76324V6.8036C4.14984 6.94289 3.875 7.31141 3.875 7.74412V14.1636C3.875 14.7159 4.32271 15.1636 4.875 15.1636H10.4213C10.9736 15.1636 11.4213 14.7159 11.4213 14.1636V14.0785H13.4213V14.1636C13.4213 15.8205 12.0782 17.1636 10.4213 17.1636H4.875C3.21814 17.1636 1.875 15.8205 1.875 14.1636V7.74412Z',
    counseling: 'M4 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 2a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm4 9a1 1 0 0 1-2 0v-4a2 2 0 1 0-4 0v4a1 1 0 0 1-2 0v-4a4 4 0 1 1 8 0v4zm4-11v1a1 1 0 0 1-2 0V4a1 1 0 0 1 1-1h5a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2h-4v1h1a1 1 0 0 1 0 2h-2a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h5V5h-4z',
    dashboard: 'm9 1 0.26536 0.0038336c4.8478 0.14024 8.7346 4.1106 8.7346 8.988 0 2.6605-1.141 4.9423-3.3681 6.7794-0.42588 0.35131-1.0562 0.29118-1.4078-0.13432-0.35163-0.4255-0.29144-1.0552 0.13444-1.4065 1.7793-1.4678 2.6415-3.192 2.6415-5.2386 0-3.8625-3.134-6.9937-7-6.9937-3.866 0-7 3.1312-7 6.9937 0 2.0441 0.8709 3.7671 2.6699 5.2352 0.42773 0.34907 0.49124 0.97847 0.14185 1.4058s-0.97935 0.49079-1.4071 0.14173c-2.2507-1.8368-3.4046-4.1198-3.4046-6.7828 0-4.9661 4.0294-8.9919 9-8.9919zm3.7071 5.2929c0.39052 0.39052 0.39052 1.0237 0 1.4142l-2.7746 2.7759c0.044013 0.16493 0.067476 0.33824 0.067476 0.51704 0 1.1046-0.89543 2-2 2s-2-0.89543-2-2 0.89543-2 2-2c0.1788 0 0.35211 0.023462 0.51704 0.067476l2.7759-2.7746c0.39052-0.39052 1.0237-0.39052 1.4142 0z',
    delete: 'M4 5v11h10V5H4zm3 2a1 1 0 0 1 1 1v5a1 1 0 0 1-2 0V8a1 1 0 0 1 1-1zm4 0a1 1 0 0 1 1 1v5a1 1 0 0 1-2 0V8a1 1 0 0 1 1-1zm1-4h5a1 1 0 0 1 0 2h-1v11a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5H1a1 1 0 1 1 0-2h5V1a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2zM8 2v1h2V2H8z',
    devices: 'M2 10h4V5H2v5zm13.002 0V2.964C14.955 2.318 14.46 2 13.06 2s-1.895.318-1.941.889l-.001 11.37C11.027 16.667 9.531 18 7 18c-2.546 0-4.013-1.358-4-3.778V12H1c-.549 0-1-.451-1-1V4c0-.549.451-1 1-1h6c.549 0 1 .451 1 1v7c0 .549-.451 1-1 1H5v2.227C4.993 15.506 5.527 16 7 16c1.488 0 2.07-.518 2.118-1.778L9.12 2.814C9.262.942 10.728 0 13.06 0c2.33 0 3.797.942 3.941 2.889V10c.549 0 1 .451 1 1v3c0 .549-.451 1-1 1v3h-2v-3c-.549 0-1-.451-1-1v-3c0-.549.451-1 1-1h.002-.001zM3 0h2c.549 0 1 .451 1 1v1H2V1c0-.549.451-1 1-1z',
    download: 'M1.004 13c.664 0 .996.333.996 1v2h14v-2c0-.667.338-1 1.014-1C18 13 18 14 18 14v2a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2s0-1 1.004-1zM6 10.44a.5.5 0 0 1 .5-.5l1.5.001V4h2v5.941h1.5a.5.5 0 0 1 .249.066l.071.05a.5.5 0 0 1 .064.704l-2.5 3a.5.5 0 0 1-.769 0l-2.5-3A.5.5 0 0 1 6 10.44z',
    draft: 'M4.44089 12.2477C4.4794 12.051 4.57618 11.8703 4.71866 11.7292L10.4452 6.05899L12.514 8.12777L6.78696 13.7985C6.6453 13.9388 6.46412 14.0343 6.26823 14.0713L4 14.5L4.44089 12.2477ZM13.2195 7.42916L14.2933 6.36598C14.6871 5.97604 14.6895 5.33933 14.2976 4.94744L13.6431 4.29289C13.2539 3.90373 12.6234 3.90218 12.2324 4.28941L11.1507 5.36038L13.2195 7.42916Z',
    edit: 'M6 2a1 1 0 1 1 0 2H2v11h11v-4a1 1 0 0 1 2 0v4a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h4zM16.16.84a2.866 2.866 0 0 1 0 4.053L8.053 13H4V8.947L12.107.84a2.866 2.866 0 0 1 4.053 0zm-2.62 1.433L6.027 9.786v1.187h1.187l7.513-7.513a.84.84 0 0 0-1.187-1.187z',
    'edit-light': 'M11.737 1.893C13.206.69 14.772.69 16.04 1.96c1.269 1.268 1.269 2.834 0 4.377L5.67 16.707a1 1 0 0 1-.707.293H2a1 1 0 0 1-1-1v-2.963a1 1 0 0 1 .293-.707zm-8.219 11.04L3 13.45V15h1.547l.519-.52-1.548-1.547zm11.108-9.56c-.51-.509-.918-.509-1.549 0l-8.145 8.145 1.549 1.549 8.078-8.07c.505-.617.568-1.007.234-1.436l-.077-.093z',
    episodes: 'M5 4h12a1 1 0 110 2H5a1 1 0 110-2zm0 4h12a1 1 0 110 2H5a1 1 0 110-2zm0 4h12a1 1 0 110 2H5a1 1 0 110-2zM1 4a1 1 0 110 2 1 1 0 010-2zm0 4a1 1 0 110 2 1 1 0 010-2zm0 4a1 1 0 110 2 1 1 0 010-2z',
    examination: 'M3 0a1 1 0 1 1 0 2H2v5a3 3 0 1 0 6 0V2H7a1 1 0 1 1 0-2h2a1 1 0 0 1 .993.883L10 1v6a5.002 5.002 0 0 1-3.999 4.9L6 12a4 4 0 1 0 8 0V9.83a3.001 3.001 0 1 1 2-.001V12a6 6 0 1 1-12 0v-.1A5.002 5.002 0 0 1 0 7V1a1 1 0 0 1 1-1h2zm12 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z',
    external: 'M8 1a1 1 0 110 2H3v12h12v-5a1 1 0 012 0v5a2 2 0 01-2 2H3a2 2 0 01-2-2V3a2 2 0 012-2h5zm9.5-1a.5.5 0 01.5.5v4.293a.5.5 0 01-.854.353L15.7 3.7 9.12 10.278a1 1 0 11-1.414-1.414l6.579-6.578L12.854.854A.5.5 0 0113.207 0H17.5z',
    file: 'M11.02 3.95a1 1 0 1 1 1.415 1.414l-6.01 6.01a.5.5 0 1 0 .707.707l6.01-6.01a2 2 0 1 0-2.828-2.828l-6.01 6.01a3.5 3.5 0 1 0 4.949 4.95l6.01-6.01a1 1 0 0 1 1.415 1.414l-6.01 6.01a5.5 5.5 0 1 1-7.779-7.778l6.01-6.01a4 4 0 1 1 5.657 5.656l-6.01 6.01A2.5 2.5 0 1 1 5.01 9.96l6.01-6.01z',
    filter: 'M7.479 11.33c.795 0 1.471.497 1.722 1.19h6.312c.269 0 .487.266.487.595 0 .329-.218.595-.487.595H9.201a1.825 1.825 0 0 1-1.722 1.19 1.825 1.825 0 0 1-1.722-1.19H2.538c-.297 0-.538-.266-.538-.595 0-.329.241-.595.538-.595h3.218c.25-.693.927-1.19 1.723-1.19Zm0 1.19a.602.602 0 0 0-.61.595c0 .329.273.595.61.595a.602.602 0 0 0 .608-.595.602.602 0 0 0-.608-.595Zm4.87-5.355c.795 0 1.471.497 1.722 1.19h1.39c.298 0 .539.266.539.595 0 .329-.241.595-.538.595H14.07a1.825 1.825 0 0 1-1.722 1.19 1.825 1.825 0 0 1-1.722-1.19H2.48C2.215 9.545 2 9.279 2 8.95c0-.329.215-.595.48-.595h8.146c.25-.693.927-1.19 1.723-1.19Zm0 1.19a.602.602 0 0 0-.61.595c0 .329.273.595.61.595a.602.602 0 0 0 .608-.595.602.602 0 0 0-.608-.595ZM5.652 3c.796 0 1.472.497 1.723 1.19h8.144c.266 0 .481.266.481.595 0 .329-.215.595-.48.595H7.373a1.825 1.825 0 0 1-1.722 1.19A1.825 1.825 0 0 1 3.93 5.38H2.538C2.241 5.38 2 5.114 2 4.785c0-.329.241-.595.538-.595H3.93C4.18 3.497 4.857 3 5.652 3Zm0 1.19a.602.602 0 0 0-.608.595c0 .329.272.595.608.595a.602.602 0 0 0 .61-.595.602.602 0 0 0-.61-.595Z"',
    finance: 'M9.00001592,0 C13.9705459,0 18,4.02944077 18,9.00001182 C18,13.970552 13.9705459,18 9.00001592,18 C4.02944488,18 0,13.970552 0,9.00001182 C0,4.02944077 4.02944488,0 9.00001592,0 Z M9.00001592,1.84931294 C5.05079129,1.84931294 1.84931705,5.05079746 1.84931705,9.00001182 C1.84931705,12.9492159 5.05079129,16.1506901 9.00001592,16.1506901 C12.9492097,16.1506901 16.150684,12.9492159 16.150684,9.00001182 C16.150684,5.05079746 12.9492097,1.84931294 9.00001592,1.84931294 Z M9.49167822,4.70426286 C10.0475621,4.71264643 10.5940041,4.84930061 11.0883879,5.10356101 C11.5827718,5.35781114 11.9183199,5.61423936 12.2484228,6.06152726 C12.3036968,6.13219168 12.3443817,6.2131198 12.3681146,6.29961642 C12.3919503,6.38611304 12.3983201,6.4764624 12.3870187,6.56544532 C12.3756146,6.65442825 12.3467448,6.74026733 12.3019502,6.8180208 C12.2572584,6.89576399 12.1975666,6.96387019 12.1262652,7.01839419 C11.9831487,7.12711342 11.8027376,7.17459975 11.6245868,7.15042508 C11.4464361,7.12625041 11.2852374,7.03239762 11.1762305,6.88945577 C10.9717783,6.60715767 10.798559,6.48439391 10.4901342,6.32196232 C10.1817813,6.15954101 9.84009963,6.07041425 9.49167822,6.06152726 C9.08101705,6.07459576 8.68118465,6.19645541 8.33303036,6.41464388 C7.98487608,6.63284262 7.70089305,6.93954141 7.51007446,7.30342516 L9.09129103,7.30342516 C9.27127057,7.30342516 9.44388367,7.37492177 9.57115771,7.50218553 C9.69842148,7.62945957 9.76991809,7.80207267 9.76991809,7.98205222 C9.76991809,8.16204204 9.69842148,8.33464486 9.57115771,8.4619189 C9.44388367,8.58918267 9.27127057,8.66068955 9.09129103,8.66068955 L7.08932425,8.66068955 C7.07130369,8.77301495 7.05997149,8.88632665 7.0553893,8.99999795 C7.05997149,9.11367951 7.07130369,9.22698094 7.08932425,9.33931661 L9.09129103,9.33931661 C9.27127057,9.33931661 9.44388367,9.41081322 9.57115771,9.53808726 C9.69842148,9.66533048 9.76991809,9.83793331 9.76991809,10.0179334 C9.76991809,10.1979335 9.69842148,10.3705363 9.57115771,10.4978309 C9.44388367,10.6251255 9.27127057,10.6965296 9.09129103,10.6965296 L7.51007446,10.6965296 C7.69638278,11.0668038 7.97841374,11.3803656 8.32688653,11.6047493 C8.67535931,11.829133 9.07755472,11.9560166 9.49167822,11.972455 C9.84009963,11.9635166 10.1817813,11.8744412 10.4901342,11.7120096 C10.798559,11.549578 11.0234564,11.3675231 11.1051345,11.2674546 C11.1806483,11.174886 11.2115729,11.0988586 11.2891415,11.0362901 C11.3666073,10.9737216 11.4570183,10.928927 11.5537991,10.9051941 C11.6506828,10.8814612 11.7514705,10.8794064 11.849176,10.8990297 C11.9468815,10.9187558 12.0391419,10.9596462 12.1191761,11.0190298 C12.1993132,11.0783107 12.2653749,11.1545436 12.3126351,11.2422833 C12.3599982,11.3300231 12.387327,11.4270095 12.3928749,11.5265643 C12.3984229,11.6261192 12.3820872,11.7255713 12.3447927,11.8180371 C12.3074982,11.9105029 12.2460598,12.0138591 12.1730118,12.0817701 C11.8087993,12.481736 11.5827718,12.6422156 11.0883879,12.8964965 C10.5940041,13.1506747 10.0475621,13.2873186 9.49167822,13.2957433 C8.71453399,13.2731406 7.9632699,13.0114623 7.34026616,12.5462566 C6.71726241,12.0811536 6.25284779,11.4352286 6.01029972,10.6965296 L5.01949784,10.6965296 C4.8395183,10.6965296 4.66690519,10.6251255 4.53963116,10.4978309 C4.41236739,10.3705363 4.34087078,10.1979335 4.34087078,10.0179334 C4.34087078,9.83793331 4.41236739,9.66533048 4.53963116,9.53808726 C4.66690519,9.41081322 4.8395183,9.33931661 5.01949784,9.33931661 L5.69813518,9.33931661 L5.69813518,8.66068955 L5.01949784,8.66068955 C4.8395183,8.66068955 4.66690519,8.58918267 4.53963116,8.4619189 C4.41236739,8.33464486 4.34087078,8.16204204 4.34087078,7.98205222 C4.34087078,7.80207267 4.41236739,7.62945957 4.53963116,7.50218553 C4.66690519,7.37492177 4.8395183,7.30342516 5.01949784,7.30342516 L6.01029972,7.30342516 C6.25284779,6.56474669 6.71726241,5.91883198 7.34026616,5.45370845 C7.9632699,4.98858493 8.71453399,4.72687589 9.49167822,4.70426286 Z',
    'healthcare-institution': 'M15 0a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1zm-1 2H4v14h4v-3a1 1 0 0 1 1.993-.117L10 13v3h4V2zM9 4a1 1 0 0 1 .993.883L10 5v1h1a1 1 0 0 1 .117 1.993L11 8h-1v1a1 1 0 0 1-1.993.117L8 9V8H7a1 1 0 0 1-.117-1.993L7 6h1V5a1 1 0 0 1 1-1z',
    home: 'M10.354 1.528l7.323 6.736a1 1 0 0 1-1.354 1.472L16 9.439v5.568A1.997 1.997 0 0 1 14 17H4c-1.103 0-2-.89-2-1.993V9.439l-.323.297A1 1 0 0 1 .323 8.264l7.323-6.736a2 2 0 0 1 2.708 0zM9 3L4 7.6V15h4v-3a1 1 0 1 1 2 0v3h4V7.6L9 3z',
    honoraria: 'M8.253 12.732c-.156.06-.32.115-.488.167-.884.275-2.027.456-2.506.456a1 1 0 1 1 0-2c.227 0 .92-.104 1.548-.264.04-.016.082-.03.125-.04.192-.05.394-.112.621-.194.569-.22.847-.443.847-.541 0-.366.055-.339-.99-.366-.435-.012-.625-.02-.886-.043-1.243-.11-1.928.193-4.932 2.398a1 1 0 0 1-1.184-1.612c3.365-2.47 4.434-2.942 6.293-2.778.205.018.368.025.761.036 1.724.045 2.658.393 2.884 1.673l.454-.217c4.275-2.05 5.194-2.397 6.24-1.648 1.476 1.058 1.205 2.79.255 3.78-.19.197-.457.409-2.803 2.248-1.48 1.161-2.204 1.737-2.517 2.011-.919.806-2.142 1.128-3.01 1.034-.072-.008-.409.001-1.033.031.17-.008-1.768.09-2.472.122l-.156.007c-1.278.057-2.231.266-2.851.6a1 1 0 0 1-.95-1.759c.923-.5 2.158-.77 3.712-.839l.155-.007c.698-.031 2.63-.13 2.465-.121.779-.038 1.117-.047 1.343-.022.344.037 1.01-.138 1.479-.55.355-.31 1.073-.882 2.583-2.067 1.913-1.499 2.533-1.99 2.612-2.073.215-.223.273-.57.042-.755l.047.038c.024.026-.008.03-.09.043-.245.039-.592.142-1.027.306-.739.278-1.435.597-3.132 1.411-1.688.81-2.665 1.257-3.44 1.535zM10.063 8a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm5-4a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm-5 2a1 1 0 1 0 0-2 1 1 0 0 0 0 2z',
    import: 'M5 2a1 1 0 1 1 0 2H2v9h14V4h-3a1 1 0 0 1 0-2h3a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-6v1h2a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2h2v-1H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h3zm3-1a1 1 0 1 1 2 0v6h1.507c.117 0 .23.042.319.118a.504.504 0 0 1 .057.704l-2.507 3.001a.488.488 0 0 1-.752 0l-2.507-3A.504.504 0 0 1 6 7.5c0-.276.22-.5.493-.5H8V1z',
    information: 'M9 16A7 7 0 1 0 9 2a7 7 0 0 0 0 14zm0 2A9 9 0 1 1 9 0a9 9 0 0 1 0 18zM9 5a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm0 3a1 1 0 0 1 1 1v3a1 1 0 0 1-2 0V9a1 1 0 0 1 1-1z',
    inquiry: 'M14 5h-2a1 1 0 0 1-1-1V2H4v14h10V5zM4 0h8l3.707 3.707a1 1 0 0 1 .293.707V16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm4 10V9a1 1 0 1 1 2 0v1h1a1 1 0 0 1 0 2h-1v1a1 1 0 0 1-2 0v-1H7a1 1 0 0 1 0-2h1zM7 4h1a1 1 0 1 1 0 2H7a1 1 0 1 1 0-2z',
    invisible: 'M13.496 1.132a1 1 0 01.377 1.35L6.431 15.504c-.002.005-.002.01-.005.015l-.558.977a1 1 0 01-1.737-.992l.775-1.356C2.882 13.21 1.247 11.494 0 9c2-4 5-6 9-6 .753 0 1.459.095 2.141.236l.99-1.732a1 1 0 011.365-.372zM9 5C6.087 5 3.905 6.272 2.277 9c.99 1.66 2.189 2.773 3.63 3.396L7.277 10A1.977 1.977 0 017 9c0-1.102.89-1.993 1.99-1.999l1.105-1.934A8.834 8.834 0 009 5zm5.792-.094C16.052 5.889 17.124 7.249 18 9c-1.996 3.992-4.988 5.99-8.976 5.999l1.193-2.088c2.312-.32 4.114-1.58 5.506-3.911-.573-.96-1.225-1.717-1.944-2.323l1.013-1.772z',
    invitation: 'M4 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 2a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm4 9a1 1 0 0 1-2 0v-4a2 2 0 1 0-4 0v4a1 1 0 0 1-2 0v-4a4 4 0 1 1 8 0v4zm4-11v1a1 1 0 0 1-2 0V4a1 1 0 0 1 1-1h5a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2h-4v1h1a1 1 0 0 1 0 2h-2a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h5V5h-4z',
    jobs: 'M4 0h10a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm0 2v14h10V2H4zm3 2h4a1 1 0 0 1 0 2H7a1 1 0 1 1 0-2zm0 4h4a1 1 0 0 1 0 2H7a1 1 0 1 1 0-2zm0 4h4a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2z',
    logout: 'M10 0a2 2 0 0 1 2 2v3a1 1 0 0 1-2 0V2H2v14h8v-3a1 1 0 0 1 2 0v3a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h8zm4.5 6a.5.5 0 0 1 .32.116l3 2.5a.5.5 0 0 1 0 .768l-3 2.5A.5.5 0 0 1 14 11.5V10H7a1 1 0 1 1 0-2h7V6.5a.5.5 0 0 1 .5-.5z',
    medication: 'M16.251 8.82L8.82 16.25c-1.853 1.853-5.023 1.688-6.891-.18-1.868-1.868-2.033-5.038-.18-6.89L9.18 1.748c1.853-1.853 5.023-1.688 6.891.18 1.868 1.868 2.033 5.038.18 6.89zM6.171 7.586l-3.008 3.009c-1.022 1.022-.957 2.925.18 4.062 1.137 1.137 3.04 1.202 4.062.18l3.01-3.009-4.243-4.242zm8.666-.18c1.022-1.023.957-2.926-.18-4.063-1.137-1.137-3.04-1.202-4.062-.18l-3.01 3.009 4.243 4.242 3.01-3.009z',
    menu: 'M15.71 14.5a1 1 0 01.116 1.993l-.116.007H2.29a1 1 0 01-.116-1.993l.116-.007h13.42zm-4.091-6.25a1 1 0 01.117 1.993l-.117.007H2.295a1 1 0 01-.117-1.993l.117-.007h9.324zm4.09-6.75a1 1 0 01.117 1.993l-.116.007H2.29a1 1 0 01-.116-1.993L2.29 1.5h13.42z',
    more: 'M2.98 7a1.98 1.98 0 100 3.96 1.979 1.979 0 100-3.96zm6.123 0a1.98 1.98 0 10-.001 3.96 1.98 1.98 0 000-3.96zm5.918 0a1.98 1.98 0 10-.002 3.96A1.98 1.98 0 0015.02 7z',
    organization: 'M7 16h3V2H2v14h3v-3a1 1 0 0 1 2 0v3zm5-12h3a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2zm0 12h3V6h-3v10zm-6-6a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm0-4a1 1 0 1 1 0-2 1 1 0 0 1 0 2z',
    patient: 'M5 16a1 1 0 110 2H2a1 1 0 01-.99-1.141l.632-4.425A4 4 0 015.602 9h6.796a4 4 0 013.96 3.434l.632 4.425A1 1 0 0116 18h-3a1 1 0 110-2h1.847l-.469-3.283A2 2 0 0012.398 11H5.602a2 2 0 00-1.98 1.717L3.153 16H5zM9 6a2 2 0 100-4 2 2 0 000 4zm0 2a4 4 0 110-8 4 4 0 010 8z',
    patients: 'M6.5 6a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm1.96 3a4 4 0 0 1 3.945 3.342l.583 3.494A1 1 0 0 1 12 17h-2a1 1 0 0 1 0-2h.82l-.388-2.329A2 2 0 0 0 8.459 11H4.542a2 2 0 0 0-1.973 1.671L2.18 15H3a1 1 0 0 1 0 2H1a1 1 0 0 1-.987-1.164l.582-3.494A4 4 0 0 1 4.542 9h3.917zM14 9a3.419 3.419 0 0 1 3.379 2.897l.61 3.95A1 1 0 0 1 17 17h-1.85a1 1 0 1 1 0-2h.685l-.432-2.798A1.419 1.419 0 0 0 14 11a1 1 0 1 1 0-2zM6.5 1a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7zM12 1c2.173 0 4 1.523 4 3.5S14.173 8 12 8a1 1 0 1 1 0-2c1.141 0 2-.716 2-1.5S13.141 3 12 3a1 1 0 1 1 0-2z',
    pause: 'm9 16c3.866 0 7-3.134 7-7 0-3.866-3.134-7-7-7-3.866 0-7 3.134-7 7 0 3.866 3.134 7 7 7zm0 2c-4.9706 0-9-4.0294-9-9 0-4.9706 4.0294-9 9-9 4.9706 0 9 4.0294 9 9 0 4.9706-4.0294 9-9 9zm-3-12h2v7h-2zm4 0h2v7h-2z',
    play: 'M9 0a9 9 0 1 1 0 18A9 9 0 0 1 9 0zm0 2a7 7 0 1 0 0 14A7 7 0 0 0 9 2zM7 5a1 1 0 0 1 .53.152l5.113 3.196a1 1 0 0 1 0 1.696L7.53 13.24A1 1 0 0 1 6 12.392V6a1 1 0 0 1 1-1zm1 2.804v2.783l2.226-1.391L8 7.804z',
    practitioner: 'M9.858 15.514a1 1 0 0 1-1.715 0l-2.705-4.507a2 2 0 0 0-1.816 1.71L3.153 16H5a1 1 0 0 1 0 2H2a1 1 0 0 1-.99-1.141l.632-4.425A4 4 0 0 1 5.602 9h6.796a4 4 0 0 1 3.96 3.434l.632 4.425A1 1 0 0 1 16 18h-3a1 1 0 1 1 0-2h1.847l-.469-3.283a2 2 0 0 0-1.816-1.71l-2.704 4.507zm-2.091-4.512L9 13.056l1.231-2.052-2.464-.002zM9 0a4 4 0 1 1 0 8 4 4 0 0 1 0-8zm0 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4z',
    print: 'M12 0a2 2 0 011.995 1.85L14 2v3h1a3 3 0 012.995 2.824L18 8v5a3 3 0 01-2.824 2.995L15 16h-1a2 2 0 01-1.85 1.995L12 18H6a2 2 0 01-1.995-1.85L4 16H3a3 3 0 01-2.995-2.824L0 13V8a3 3 0 012.824-2.995L3 5h1V2A2 2 0 015.85.005L6 0h6zm0 11H6v5h6v-5zm-1.5 3v1h-3v-1h3zM3 10a1 1 0 01.883-.993L4 9h10a1 1 0 01.117 1.993L14 11v3h1a1 1 0 00.993-.883L16 13V8a1 1 0 00-.883-.993L15 7H3a1 1 0 00-.993.883L2 8v5a1 1 0 00.883.993L3 14h1v-3a1 1 0 01-1-1zm7.5 2v1h-3v-1h3zM12 2H6v3h6V2z',
    question: 'M4 6.342V5.223A5 5 0 1 1 9.94 10.9V13a1 1 0 0 1-2 0v-3a1 1 0 0 1 1-1 3 3 0 1 0-3-3A1 1 0 0 1 4 6.342zM8.598 17.94a1 1 0 1 1 .684 0h-.684z',
    recorder: 'M4.92 9.394A1 1 0 0 1 4 10H1a1 1 0 1 1 0-2h2.34l2.74-6.394c.372-.865 1.623-.785 1.882.12l3.227 11.295 1.892-4.415A1 1 0 0 1 14 8h3a1 1 0 0 1 0 2h-2.34l-2.74 6.394c-.372.865-1.623.786-1.882-.12L6.811 4.98 4.92 9.394z',
    records: 'M2 15h14V6H2v9zM16 4a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h4.171a2 2 0 0 1 1.415.586L8.999 4H16z',
    referral: 'M9 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm5.5 6a.5.5 0 0 1 .32.116l3 2.5a.5.5 0 0 1 0 .768l-3 2.5A.5.5 0 0 1 14 17.5V16H7a1 1 0 1 1 0-2h7v-1.5a.5.5 0 0 1 .5-.5zM13 9a1 1 0 0 1 0 2h-1.6l-1.193 2-2.408-.002L6.6 11h-.998a2 2 0 0 0-1.98 1.717l-.632 4.424a1 1 0 1 1-1.98-.282l.632-4.425A4 4 0 0 1 5.602 9H13zM9 0a4 4 0 1 1 0 8 4 4 0 0 1 0-8z',
    refresh: 'M6.252 1.304a.5.5 0 0 1-.011.225L4.76 6.694a.5.5 0 0 1-.852.197l-1.08-1.197A7 7 0 0 0 9 16a1 1 0 0 1 0 2A9 9 0 0 1 1.426 4.135L.096 2.658a.5.5 0 0 1 .285-.827L5.673.9a.5.5 0 0 1 .58.405zM9 0a9 9 0 0 1 7.574 13.865l1.33 1.477a.5.5 0 0 1-.285.827l-5.292.932a.5.5 0 0 1-.568-.63l1.481-5.165a.5.5 0 0 1 .852-.197l1.08 1.197A7 7 0 0 0 9 2a1 1 0 1 1 0-2z',
    search: 'M8.53 1a7.53 7.53 0 0 1 5.948 12.146l2.246 2.247a.941.941 0 1 1-1.33 1.331l-2.248-2.246A7.53 7.53 0 1 1 8.53 1zm0 1.882a5.647 5.647 0 1 0 0 11.294 5.647 5.647 0 0 0 0-11.294zm0 .942a4.706 4.706 0 0 1 4.705 4.705.941.941 0 1 1-1.882 0 2.824 2.824 0 0 0-2.824-2.823.941.941 0 0 1 0-1.882z',
    settings: 'M9 1a1 1 0 0 1 1 1v1.083c.377.063.743.162 1.093.292l.541-.937a1 1 0 0 1 1.732 1l-.542.938c.291.241.559.509.8.8l.938-.542a1 1 0 1 1 1 1.732l-.937.541c.13.35.229.716.292 1.093H16a1 1 0 0 1 0 2h-1.083a5.957 5.957 0 0 1-.292 1.093l.937.541a1 1 0 0 1-1 1.732l-.938-.542a6.047 6.047 0 0 1-.8.8l.542.938a1 1 0 1 1-1.732 1l-.541-.937c-.35.13-.716.229-1.093.292V16a1 1 0 0 1-2 0v-1.083a5.957 5.957 0 0 1-1.093-.292l-.541.937a1 1 0 1 1-1.732-1l.542-.938a6.037 6.037 0 0 1-.8-.8l-.938.542a1 1 0 1 1-1-1.732l.937-.541A5.957 5.957 0 0 1 3.083 10H2a1 1 0 1 1 0-2h1.083c.063-.377.162-.743.292-1.093l-.937-.541a1 1 0 1 1 1-1.732l.938.542c.241-.291.509-.559.8-.8l-.542-.938a1 1 0 1 1 1.732-1l.541.937c.35-.13.716-.229 1.093-.292V2a1 1 0 0 1 1-1zm0 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8zm0 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2z',
    'split-view': 'M 10 2 L 3 2 C 2.449219 2 2 2.449219 2 3 L 2 15 C 2 15.550781 2.449219 16 3 16 L 10 16 Z M 0 3 C 0 1.34375 1.34375 0 3 0 L 15 0 C 16.65625 0 18 1.34375 18 3 L 18 15 C 18 16.65625 16.65625 18 15 18 L 3 18 C 1.34375 18 0 16.65625 0 15 Z M 0 3 ',
    star: 'M11.958 10.89l3.06-3.11-4.22-.64L9 3.345 7.202 7.14l-4.22.64 3.06 3.108-.702 4.263L9 13.147l3.66 2.005-.702-4.263zM9 15.426L4.526 17.88c-.5.274-1.115.067-1.374-.461a1.132 1.132 0 0 1-.1-.68l.851-5.17L.313 7.92a1.122 1.122 0 0 1-.029-1.523c.158-.174.366-.287.59-.32l4.976-.754L8.088.596c.252-.533.865-.748 1.368-.482.197.105.357.273.455.482l2.239 4.727 4.975.753c.557.085.944.63.865 1.22a1.1 1.1 0 0 1-.303.624l-3.59 3.648.85 5.17c.097.586-.274 1.144-.83 1.246a.97.97 0 0 1-.643-.105L9 15.427z',
    stopped: 'M9 16A7 7 0 1 0 9 2a7 7 0 0 0 0 14zM9 0a9 9 0 1 1 0 18A9 9 0 0 1 9 0zm3 5H6a1 1 0 0 0-.993.883L5 6v6a1 1 0 0 0 .883.993L6 13h6a1 1 0 0 0 .993-.883L13 12V6a1 1 0 0 0-.883-.993L12 5zm-1 2v4H7V7h4z',
    telephone: 'M5 13h8V2h-3v1a1 1 0 1 1-2 0V2H5v11zm0 2v1h8v-1H5zM5 0h8a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2z',
    todo: 'M4 4v6h2c.974 0 1.793.26 2.719.754.147.078.291.159.476.265l.422.245c.944.539 1.52.736 2.383.736h2V6h-2c-.974 0-1.793-.26-2.719-.754-.147-.078-.291-.159-.476-.265l-.422-.245C7.439 4.197 6.863 4 6 4H4zm0 8v5a1 1 0 0 1-2 0V1a1 1 0 1 1 2 0v1h2c3 0 4 2 6 2h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2c-3 0-4-2-6-2H4z',
    'todo-list': 'M12.226 1.85432L12.3142 2.24374L12.7135 2.24386L14.0165 2.24428H14.0167C14.9781 2.24431 15.7575 3.02374 15.7575 3.98521V15.7591C15.7575 16.7205 14.9781 17.5 14.0166 17.5H3.98702C3.02554 17.5 2.24609 16.7205 2.24609 15.7591V3.98521C2.24609 3.02377 3.02556 2.24431 3.98704 2.24428H3.98718L5.29018 2.24386L5.68944 2.24374L5.77766 1.85434C5.95341 1.0786 6.64739 0.5 7.47558 0.5H10.5281C11.3562 0.5 12.0503 1.07862 12.226 1.85432ZM12.3023 3.10985L12.0568 3.10987L11.9067 3.30417C11.5878 3.71692 11.089 3.98186 10.5281 3.98186H7.47558C6.91466 3.98186 6.41584 3.71694 6.09694 3.30418L5.94683 3.1099L5.70132 3.10988L3.98707 3.10972H3.98699C3.50355 3.10975 3.11154 3.50167 3.11154 3.98521V15.7591C3.11154 16.2426 3.50351 16.6346 3.98702 16.6346H14.0166C14.5001 16.6346 14.8921 16.2426 14.8921 15.7591V3.98521C14.8921 3.50171 14.5001 3.10975 14.0167 3.10972H14.0166L12.3023 3.10985ZM11.7062 8.33575L8.17777 11.8642L6.30038 9.98683C6.24254 9.9257 6.2106 9.84451 6.21133 9.76028C6.21207 9.67492 6.24631 9.59328 6.30666 9.53292C6.36702 9.47256 6.44867 9.43833 6.53402 9.43758C6.61825 9.43685 6.69944 9.46879 6.76056 9.52662L7.82422 10.5903L8.17777 10.9438L8.53133 10.5903L11.246 7.87557C11.3072 7.81773 11.3884 7.78578 11.4726 7.78652C11.5579 7.78726 11.6396 7.82149 11.7 7.88185C11.7603 7.94221 11.7945 8.02385 11.7953 8.10921C11.796 8.19344 11.7641 8.27462 11.7062 8.33575ZM10.5281 1.08682H7.47558C6.83818 1.08682 6.32147 1.60354 6.32147 2.24093C6.32147 2.87832 6.83818 3.39503 7.47558 3.39503H10.5281C11.1654 3.39503 11.6822 2.87832 11.6822 2.24093C11.6822 1.60353 11.1654 1.08682 10.5281 1.08682Z',
    upload: 'M9.39 6.146l3.035 3.036a.5.5 0 0 1-.354.854h-2.046l.01 6.964a1 1 0 0 1-2 0l-.01-6.964H6a.5.5 0 0 1-.354-.854l3.036-3.036a.5.5 0 0 1 .707 0zM9 0a5.002 5.002 0 0 1 4.916 4.084A5.002 5.002 0 0 1 13 14a1 1 0 0 1 0-2 3 3 0 0 0 .552-5.95 2 2 0 0 1-1.602-1.602A3.001 3.001 0 0 0 6 5a2.004 2.004 0 0 1-1.78 2.015A2.5 2.5 0 0 0 4.5 12H5a1 1 0 0 1 0 2h-.5A4.5 4.5 0 0 1 4 5.027C4 2.24 6.24 0 9 0z',
    visible: 'M9,3 C13,3 16,5 18,9 C16,13 13,15 9,15 C5,15 2,13 0,9 C2,5 5,3 9,3 Z M9,5 C6.08729076,5 3.9053576,6.27240067 2.27710088,9 C3.9053576,11.7275993 6.08729076,13 9,13 C11.9127092,13 14.0946424,11.7275993 15.7228991,9 C14.0946424,6.27240067 11.9127092,5 9,5 Z M9,7 C10.1045695,7 11,7.8954305 11,9 C11,10.1045695 10.1045695,11 9,11 C7.8954305,11 7,10.1045695 7,9 C7,7.8954305 7.8954305,7 9,7 Z',
    waiting: 'M3 16v-1.757a3 3 0 0 1 .879-2.122l2.414-2.414a1 1 0 0 0 0-1.414L3.879 5.879A3 3 0 0 1 3 3.757V2H2a1 1 0 1 1 0-2h15a1 1 0 0 1 0 2h-1v1.757a3 3 0 0 1-.879 2.122l-2.414 2.414a1 1 0 0 0 0 1.414l2.414 2.414A3 3 0 0 1 16 14.243V16h1a1 1 0 0 1 0 2H2a1 1 0 0 1 0-2h1zm2 0h9v-1.757a1 1 0 0 0-.293-.707l-2.414-2.415a3 3 0 0 1 0-4.242l2.414-2.415A1 1 0 0 0 14 3.757V2H5v1.757a1 1 0 0 0 .293.707L7.707 6.88a3 3 0 0 1 0 4.242l-2.414 2.415a1 1 0 0 0-.293.707V16zM6.5 3.793V3.5A.5.5 0 0 1 7 3h5a.5.5 0 0 1 .5.5v.293a.5.5 0 0 1-.146.353l-2.5 2.5a.5.5 0 0 1-.708 0l-2.5-2.5a.5.5 0 0 1-.146-.353z',
    'waiting-small': 'M1.55938 2.44871V1.61016L3.22046 1.61024H6.44062L6.44062 2.42636C6.44062 3.02025 6.1943 3.58753 5.76038 3.993L4.82591 4.86619C4.47088 5.19793 4.26935 5.66208 4.26935 6.14798V6.29209C4.26935 6.78338 4.47536 7.25216 4.83727 7.5844L5.7465 8.4191C6.14998 8.78951 6.39492 9.29876 6.43483 9.84109C6.41216 9.80886 6.38556 9.77795 6.35486 9.74885L5.0905 8.55037C4.49235 7.98339 3.55628 7.97977 2.95376 8.5421L1.6641 9.74575C1.62299 9.78412 1.58912 9.82571 1.56203 9.86943C1.58949 9.3177 1.82913 8.79618 2.23321 8.41549L3.12377 7.57645C3.47562 7.24497 3.67509 6.78299 3.67509 6.29958V6.14042C3.67509 5.66241 3.48003 5.20509 3.13501 4.87424L2.21947 3.99627C1.79779 3.59189 1.55938 3.03295 1.55938 2.44871ZM1.55938 0.0507812L4.77983 0.050865H6.44062C7.30184 0.050865 8 0.749021 8 1.61024V2.42636C8 3.45216 7.57454 4.43202 6.82503 5.13237L5.89057 6.00556C5.85112 6.04242 5.82873 6.09399 5.82873 6.14798V6.29209C5.82873 6.34668 5.85162 6.39876 5.89183 6.43568L6.80106 7.27038C7.56509 7.97178 8 8.96143 8 9.99859V10.39C8 11.2512 7.30184 11.9494 6.44062 11.9494H1.55938C0.698157 11.9494 0 11.2512 0 10.39V9.97611C0 8.95559 0.421101 7.9803 1.16388 7.2805L2.05445 6.44146C2.09355 6.40463 2.11571 6.3533 2.11571 6.29958V6.14042C2.11571 6.08731 2.09404 6.0365 2.0557 5.99974L1.14016 5.12176C0.411798 4.42329 0 3.45785 0 2.44871V1.61016C0 0.748937 0.698159 0.0507812 1.55938 0.0507812Z',
    warning: 'M2.313 15h13.374L9 2.294 2.313 15zm0 2a2 2 0 0 1-1.77-2.931L7.23 1.363a2 2 0 0 1 3.54 0l6.687 12.706A2 2 0 0 1 15.687 17H2.313zM9 12a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm0-6a1 1 0 0 1 1 1v3a1 1 0 0 1-2 0V7a1 1 0 0 1 1-1z',
    'zoom-in': 'M8,0 C12.418278,0 16,3.581722 16,8 C16,9.84871145 15.3729184,11.5509601 14.3198574,12.9056439 L16.7071068,15.2928932 C17.0976311,15.6834175 17.0976311,16.3165825 16.7071068,16.7071068 C16.3165825,17.0976311 15.6834175,17.0976311 15.2928932,16.7071068 L12.9056439,14.3198574 C11.5509601,15.3729184 9.84871145,16 8,16 C3.581722,16 -7.28306304e-14,12.418278 -7.28306304e-14,8 C-7.28306304e-14,3.581722 3.581722,0 8,0 Z M8,2 C4.6862915,2 2,4.6862915 2,8 C2,11.3137085 4.6862915,14 8,14 C11.3137085,14 14,11.3137085 14,8 C14,4.6862915 11.3137085,2 8,2 Z M8,4 C8.27371087,4 8.49559737,4.2218865 8.49559737,4.49559737 L8.49559737,7.50440263 L11.5044026,7.50440263 C11.7781135,7.50440263 12,7.72628913 12,8 C12,8.27371087 11.7781135,8.49559737 11.5044026,8.49559737 L8.49559737,8.49559737 L8.49559737,11.5044026 C8.49559737,11.7781135 8.27371087,12 8,12 C7.72628913,12 7.50440263,11.7781135 7.50440263,11.5044026 L7.50440263,8.49559737 L4.49559737,8.49559737 C4.2218865,8.49559737 4,8.27371087 4,8 C4,7.72628913 4.2218865,7.50440263 4.49559737,7.50440263 L7.50440263,7.50440263 L7.50440263,4.49559737 C7.50440263,4.2218865 7.72628913,4 8,4 Z',
};

const iconColor = {
    inherit: 'inherit',
    default: kdsColorForegroundDefault,
    subtle: kdsColorForegroundSubtle,
    minimal: kdsColorForegroundMinimal,
    disabled: kdsColorForegroundDisabled,
    inverse: kdsColorForegroundInverse,
    primary: kdsColorForegroundPrimary,
    secondary: kdsColorForegroundSecondary,
    info: kdsColorForegroundInfo,
    success: kdsColorForegroundSuccess,
    warning: kdsColorForegroundWarning,
    danger: kdsColorForegroundDanger,
};
const Icon = forwardRef((_a, ref) => {
    var { color = 'default', icon = 'question', id, size = '18', sx: sxProp } = _a, props = __rest(_a, ["color", "icon", "id", "size", "sx"]);
    return (jsxRuntimeExports.jsx(StyledIcon$d, Object.assign({ "$color": color, height: size, id: id, ref: ref, sx: sxProp, viewBox: "0 0 18 18", width: size }, props, { children: jsxRuntimeExports.jsx(Path, Object.assign({ d: iconPaths[icon] }, iconPathProperties[icon])) })));
});
Icon.displayName = 'Icon';
const StyledIcon$d = styled.svg `
    display: inline-block;
    vertical-align: text-bottom;

    ${({ $color }) => $color &&
    css$3 `
            color: ${iconColor[$color]};
        `}

    ${sx};
`;
const Path = styled.path `
    fill: currentcolor;
`;

function AccordionTrigger(_a) {
    var { children, icon, isSensitiveData = false } = _a, props = __rest(_a, ["children", "icon", "isSensitiveData"]);
    return (jsxRuntimeExports.jsx(StyledHeader$6, { "data-dd-privacy": isSensitiveData ? 'mask' : 'allow', children: jsxRuntimeExports.jsxs(StyledTrigger, Object.assign({}, props, { children: [jsxRuntimeExports.jsxs(Box, { alignItems: "center", as: "span", display: "flex", textAlign: "left", children: [jsxRuntimeExports.jsx(StyledIcon$c, { "aria-hidden": true, color: "secondary", icon: icon, size: 16 }), children] }), jsxRuntimeExports.jsx(StyledCaret, { "aria-hidden": true, icon: "caret-down" })] })) }));
}
AccordionTrigger.displayName = 'AccordionTrigger';
const StyledHeader$6 = styled(AccordionPrimitive.Header) `
    display: flex;
    margin: 0;
`;
const StyledCaret = styled(Icon) `
    flex-shrink: 0;
    transition: transform 300ms cubic-bezier(0.87, 0, 0.13, 1);
`;
const StyledTrigger = styled(AccordionPrimitive.Trigger) `
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 1 1 0%;
    font-size: ${(props) => props.theme.fontSizes.sm};
    line-height: ${(props) => props.theme.lineHeights[5]};
    font-weight: ${(props) => props.theme.fontWeights.medium};
    color: var(--kds-color-foreground-default);
    width: 100%;
    background-color: transparent;
    border: none;
    padding: 16px 12px;
    border-radius: 4px;

    &:hover {
        background: ${(props) => props.theme.colors.neutral200};
    }

    &[data-state='open'] ${StyledCaret} {
        transform: rotate(180deg);
    }

    &:focus {
        outline: none;
    }

    &:focus-visible {
        outline: 2px solid var(--kds-color-border-focused);
    }
`;
const StyledIcon$c = styled(Icon) `
    margin-right: 12px;
    flex-shrink: 0;
`;

const textStyles = {
    inherit: { fontSize: 'inherit', lineHeight: 'inherit' },
    xs: {
        fontSize: 'xs',
        lineHeight: 4,
    },
    sm: {
        fontSize: 'sm',
        lineHeight: 5,
    },
    md: {
        fontSize: 'md',
        lineHeight: 6,
    },
    lg: {
        fontSize: 'lg',
        lineHeight: 7,
    },
    xl: {
        fontSize: 'xl',
        lineHeight: 7,
    },
    '2xl': {
        fontSize: '2xl',
        lineHeight: 8,
    },
    '3xl': {
        fontSize: '3xl',
        lineHeight: 10,
    },
    '4xl': {
        fontSize: '4xl',
        lineHeight: 'none',
    },
    '5xl': {
        fontSize: '5xl',
        lineHeight: 'none',
    },
    '6xl': {
        fontSize: '6xl',
        lineHeight: 'none',
    },
    '7xl': {
        fontSize: '7xl',
        lineHeight: 'none',
    },
    '8xl': {
        fontSize: '8xl',
        lineHeight: 'none',
    },
    '9xl': {
        fontSize: '9xl',
        lineHeight: 'none',
    },
};
const textColor = {
    inherit: 'inherit',
    default: kdsColorForegroundDefault,
    subtle: kdsColorForegroundSubtle,
    minimal: kdsColorForegroundMinimal,
    disabled: kdsColorForegroundDisabled,
    inverse: kdsColorForegroundInverse,
    primary: kdsColorForegroundPrimary,
    secondary: kdsColorForegroundSecondary,
    info: kdsColorForegroundInfo,
    success: kdsColorForegroundSuccess,
    warning: kdsColorForegroundWarning,
    danger: kdsColorForegroundDanger,
};
const Text = styled.p.withConfig({ shouldForwardProp })(css$2({
    margin: 0,
    color: textColor.default,
}), (props) => props.color &&
    css$2({
        color: textColor[props.color],
    }), (props) => !props.size &&
    !props.fontSize &&
    css$2({
        lineHeight: 6,
        fontSize: 'md',
    }), (props) => !props.fontWeight &&
    css$2({
        fontWeight: 'normal',
    }), (props) => props.size &&
    !props.fontSize &&
    variant({
        prop: 'size',
        variants: textStyles,
    }), (props) => props.whiteSpace &&
    css$2({
        whiteSpace: props.whiteSpace,
    }), compose(space$1, typography), sx);

styled(Link) ``;
function Link(_a) {
    var { children, color = 'primary', fontWeight = 'bold', iconLeft, iconRight, openInNewTab, size = 'inherit' } = _a, props = __rest(_a, ["children", "color", "fontWeight", "iconLeft", "iconRight", "openInNewTab", "size"]);
    if (props.variant === 'link') {
        return (jsxRuntimeExports.jsxs(StyledLink, Object.assign({ as: Link$1, color: color, fontWeight: fontWeight, rel: openInNewTab ? 'noopener noreferrer' : undefined, size: size, target: openInNewTab ? '_blank' : undefined }, props, { children: [iconLeft && (jsxRuntimeExports.jsx(IconLeft$1, { children: jsxRuntimeExports.jsx(Icon, { color: "inherit", icon: iconLeft }) })), children, iconRight && (jsxRuntimeExports.jsx(IconRight$1, { children: jsxRuntimeExports.jsx(Icon, { color: "inherit", icon: iconRight }) }))] })));
    }
    else if (props.variant === 'externalLink') {
        return (jsxRuntimeExports.jsxs(StyledLink, Object.assign({ as: "a", color: color, fontWeight: fontWeight, rel: openInNewTab ? 'noopener noreferrer' : undefined, size: size, target: openInNewTab ? '_blank' : undefined }, props, { children: [iconLeft && (jsxRuntimeExports.jsx(IconLeft$1, { children: jsxRuntimeExports.jsx(Icon, { color: "inherit", icon: iconLeft }) })), children, iconRight && (jsxRuntimeExports.jsx(IconRight$1, { children: jsxRuntimeExports.jsx(Icon, { color: "inherit", icon: iconRight }) }))] })));
    }
    else if (props.variant === 'button') {
        return (jsxRuntimeExports.jsxs(StyledLink, Object.assign({ as: "button", color: color, fontWeight: fontWeight, size: size, type: "button" }, props, { children: [iconLeft && (jsxRuntimeExports.jsx(IconLeft$1, { children: jsxRuntimeExports.jsx(Icon, { color: "inherit", icon: iconLeft }) })), children, iconRight && (jsxRuntimeExports.jsx(IconRight$1, { children: jsxRuntimeExports.jsx(Icon, { color: "inherit", icon: iconRight }) }))] })));
    }
    return null;
}
const IconLeft$1 = styled.span `
    margin-right: 0.5rem;
    display: inherit;
    align-items: center;
`;
const IconRight$1 = styled.span `
    margin-left: 0.75rem;
    display: inherit;
    align-items: center;
`;
const StyledLink = styled.a.withConfig({ shouldForwardProp })(css$2({
    '&:focus': {
        boxShadow: 'none',
        outline: 'none',
        textDecoration: 'none',
    },
    '&:focus-visible': {
        outline: '2px solid var(--kds-color-border-focused)',
        outlineOffset: '2px',
    },
    '&:hover': {
        textDecoration: 'none',
    },
    alignItems: 'center',
    background: 'none',
    border: 'none',
    borderRadius: 'var(--kds-border-radius-small)',
    cursor: 'pointer',
    display: 'inline-flex',
    margin: 0,
    padding: 0,
    textAlign: 'left',
    textDecoration: 'underline',
}), (props) => props.color &&
    css$2({
        '&:focus': {
            color: textColor[props.color],
        },
        '&:hover': {
            color: textColor[props.color],
        },
        color: textColor[props.color],
    }), (props) => props.size &&
    !props.fontSize &&
    variant({
        prop: 'size',
        variants: textStyles,
    }), (props) => props.whiteSpace &&
    css$2({
        whiteSpace: props.whiteSpace,
    }), compose(space$1, typography), sx);

function AccordionLink(_a) {
    var { children, size = 'sm' } = _a, props = __rest(_a, ["children", "size"]);
    return (jsxRuntimeExports.jsx(StyledAccordionLink, Object.assign({ size: size }, props, { children: children })));
}
const StyledAccordionLink = styled(Link) `
    display: block;
    color: var(--kds-color-secondary-800);
    margin-top: var(--kds-spacing-1);

    &:first-of-type {
        margin-top: var(--kds-spacing-0);
    }

    &:hover {
        color: var(--kds-color-secondary-800);
    }

    &:focus {
        color: var(--kds-color-secondary-800);
    }
    ${sx}
`;

const IconButton = forwardRef(function IconButton(_a, ref) {
    var { buttonRef, icon, iconColor = 'inherit', id, isDisabled, labelText, onClick, size = 'medium', type = 'button', variant = 'default' } = _a, props = __rest(_a, ["buttonRef", "icon", "iconColor", "id", "isDisabled", "labelText", "onClick", "size", "type", "variant"]);
    const theme = useTheme();
    return (jsxRuntimeExports.jsx(StyledIconButton$3, Object.assign({ "$size": size, "$variant": variant, "aria-label": labelText, disabled: isDisabled, id: id, onClick: onClick, ref: ref || buttonRef, type: type }, props, { children: jsxRuntimeExports.jsx(Icon, { color: iconColor, icon: icon, size: theme.iconButton.size[size].iconSize }) })));
});
const StyledIconButton$3 = styled.button `
    box-sizing: border-box;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    border-radius: ${(props) => props.theme.radii.full};
    border: none;
    box-shadow: none;
    padding: 0;
    position: relative;
    cursor: pointer;
    outline: currentcolor none medium;
    transition: background 0.1s ease-out;
    min-height: ${(props) => props.$size && props.theme.iconButton.size[props.$size].height};
    height: ${(props) => props.$size && props.theme.iconButton.size[props.$size].height};
    min-width: ${(props) => props.$size && props.theme.iconButton.size[props.$size].width};
    width: ${(props) => props.$size && props.theme.iconButton.size[props.$size].width};
    background-color: ${(props) => props.$variant && props.theme.iconButton.variant[props.$variant].backgroundColor};
    color: ${(props) => props.$variant && props.theme.iconButton.variant[props.$variant].color};

    @media (hover: hover) {
        &:hover:not(:disabled) {
            color: ${(props) => props.$variant && props.theme.iconButton.variant[props.$variant].colorHover};
            background-color: ${(props) => props.$variant && props.theme.iconButton.variant[props.$variant].backgroundColorHover};
        }
    }

    &:disabled {
        color: ${(props) => props.$variant && props.theme.iconButton.variant[props.$variant].colorDisabled};
        pointer-events: none;

        ${(props) => props.$variant &&
    props.$variant === 'filled' &&
    css$3 `
                background-color: transparent;
                border: 1px solid ${props.theme.iconButton.variant[props.$variant].colorDisabled};
            `}
    }

    &:focus {
        outline: none;
    }

    &:focus-visible {
        outline: 2px solid var(--kds-color-border-focused);
        outline-offset: 2px;
    }

    &:active:not(:disabled) {
        background-color: ${(props) => props.$variant && props.theme.iconButton.variant[props.$variant].backgroundColorActive};
        color: ${(props) => props.$variant && props.theme.iconButton.variant[props.$variant].colorActive};
    }

    ${sx}
`;

const variants$2 = {
    closed: {
        opacity: 0,
        scale: 0.9,
        transition: {
            duration: 0.2,
            ease: [0.4, 0, 0.2, 1],
        },
        transitionEnd: {
            display: 'none',
        },
    },
    open: {
        display: 'flex',
        opacity: 1,
        scale: 1,
        transition: {
            duration: 0.3,
            ease: [0.4, 0, 0.2, 1],
        },
    },
};
function ActionBar(_a) {
    var { children, isOpen = false, onClose } = _a, props = __rest(_a, ["children", "isOpen", "onClose"]);
    const bar = (jsxRuntimeExports.jsx(StyledActionBarContainer, { children: jsxRuntimeExports.jsx(AnimatePresence, { children: jsxRuntimeExports.jsx(motion.div, { animate: isOpen ? 'open' : 'closed', exit: 'closed', initial: 'closed', variants: variants$2, children: jsxRuntimeExports.jsxs(StyledActionBar, Object.assign({}, props, { children: [jsxRuntimeExports.jsx(StyledBarContent, { children: children }), jsxRuntimeExports.jsx(StyledIconButtonWrapper$1, { children: jsxRuntimeExports.jsx(IconButton, { icon: "close", labelText: "Close ActionBar", onClick: onClose, variant: "inverse" }) })] })) }, "child") }) }));
    return createPortal(bar, document.body);
}
const StyledActionBarContainer = styled.div `
    position: fixed;
    align-items: center;
    bottom: 48px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1000;
    width: 100%;
    display: flex;
    justify-content: center;
    pointer-events: none;
`;
const StyledActionBar = styled.div `
    display: flex;
    align-items: center;
    height: 64px;
    padding: 16px;
    background: ${(props) => props.theme.colors.blue900};
    border-radius: ${(props) => props.theme.radii.base};
    box-shadow: ${(props) => props.theme.shadows.xl};
    position: relative;
    pointer-events: all;

    ${(props) => props.theme.mediaQueries.small} {
        margin: 0;
        min-width: 450px;
        width: auto;
    }

    ${(props) => props.theme.mediaQueries.medium} {
        padding: 16px 32px;
    }

    ${sx}
`;
const StyledBarContent = styled.div `
    flex: 1;
`;
const StyledIconButtonWrapper$1 = styled.div `
    flex: 0 0 auto;
    margin-left: 12px;
`;

const rotate = keyframes `
      0% { transform: rotate(0deg) }
      100% { transform: rotate(1turn) }
    `;
const convertHexToRGBA = (hexCode, opacity = 1) => {
    let hex = hexCode.replace('#', '');
    if (hex.length === 3) {
        hex = `${hex[0]}${hex[0]}${hex[1]}${hex[1]}${hex[2]}${hex[2]}`;
    }
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    return `rgba(${r},${g},${b},${opacity})`;
};
const getSize$1 = (size) => {
    if (size === 'small') {
        return 16;
    }
    if (size === 'medium') {
        return 40;
    }
    if (size === 'large') {
        return 60;
    }
    return;
};
function Spinner(_a) {
    var { color = 'neutral800', size = 'small' } = _a, props = __rest(_a, ["color", "size"]);
    return (jsxRuntimeExports.jsx(StyledSpinner$1, Object.assign({ "$color": color, "$size": size }, props)));
}
const StyledSpinner$1 = styled.div `
    display: inline-block;
    border-top: 2px solid
        ${(props) => props.$color && convertHexToRGBA(props.theme.colors[props.$color] || props.$color, 0.2)};
    border-right: 2px solid
        ${(props) => props.$color && convertHexToRGBA(props.theme.colors[props.$color] || props.$color, 0.2)};
    border-bottom: 2px solid
        ${(props) => props.$color && convertHexToRGBA(props.theme.colors[props.$color] || props.$color, 0.2)};
    border-left: 2px solid
        ${(props) => props.$color && convertHexToRGBA(props.theme.colors[props.$color] || props.$color, 0.8)};
    border-radius: ${tokens.kdsBorderRadiusFull};
    vertical-align: text-bottom;
    width: ${(props) => props.$size && getSize$1(props.$size)}px;
    height: ${(props) => props.$size && getSize$1(props.$size)}px;
    animation: ${rotate} 0.8s infinite linear;

    ${sx}
`;

const Button = forwardRef((_a, ref) => {
    var { as = 'button', buttonRef, children, color = 'primary', iconLeft, iconRight, isDisabled, isLoading = false, isSensitiveData = false, loadingText, size = 'medium', to, type = 'button', variant = 'solid', width = 'auto' } = _a, props = __rest(_a, ["as", "buttonRef", "children", "color", "iconLeft", "iconRight", "isDisabled", "isLoading", "isSensitiveData", "loadingText", "size", "to", "type", "variant", "width"]);
    const handleClick = (e) => {
        const { onClick } = props;
        if (isLoading || isDisabled) {
            e.preventDefault();
            return;
        }
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
    };
    const iconSize = {
        medium: tokens.kdsButtonIconSizeMedium,
        small: tokens.kdsButtonIconSizeSmall,
    };
    const spinnerColor = {
        danger: {
            link: tokens.kdsButtonColorForegroundLinkDanger,
            outline: tokens.kdsButtonColorForegroundOutlineDanger,
            solid: tokens.kdsButtonColorForegroundSolidDanger,
        },
        neutral: {
            link: tokens.kdsButtonColorForegroundLinkNeutral,
            outline: tokens.kdsButtonColorForegroundOutlineNeutral,
            solid: tokens.kdsButtonColorForegroundSolidNeutral,
        },
        primary: {
            link: tokens.kdsButtonColorForegroundLinkPrimary,
            outline: tokens.kdsButtonColorForegroundOutlinePrimary,
            solid: tokens.kdsButtonColorForegroundSolidPrimary,
        },
        secondary: {
            link: tokens.kdsButtonColorForegroundLinkSecondary,
            outline: tokens.kdsButtonColorForegroundOutlineSecondary,
            solid: tokens.kdsButtonColorForegroundSolidSecondary,
        },
        success: {
            link: tokens.kdsButtonColorForegroundLinkSuccess,
            outline: tokens.kdsButtonColorForegroundOutlineSuccess,
            solid: tokens.kdsButtonColorForegroundSolidSuccess,
        },
        warning: {
            link: tokens.kdsButtonColorForegroundLinkWarning,
            outline: tokens.kdsButtonColorForegroundOutlineWarning,
            solid: tokens.kdsButtonColorForegroundSolidWarning,
        },
    };
    return (jsxRuntimeExports.jsxs(StyledButton$2, Object.assign({ "$color": color, "$isLoading": isLoading, "$size": size, "$variant": variant, "$width": width, "aria-disabled": isLoading ? true : undefined, as: as, "data-dd-privacy": isSensitiveData ? 'mask' : 'allow', disabled: isDisabled, onClick: handleClick, ref: ref || buttonRef, to: to, type: as === 'button' ? type : undefined }, props, { children: [isLoading && (jsxRuntimeExports.jsx(Spinner, { color: spinnerColor[color][variant], size: "small", sx: {
                    mr: loadingText ? 2 : 0,
                    position: loadingText ? 'relative' : 'absolute',
                } })), (isLoading && loadingText) || (jsxRuntimeExports.jsxs(ButtonContent, { "$isLoading": isLoading, children: [iconLeft && (jsxRuntimeExports.jsx(IconLeft, { children: jsxRuntimeExports.jsx(Icon, { color: "inherit", icon: iconLeft, size: iconSize[size] }) })), children, iconRight && (jsxRuntimeExports.jsx(IconRight, { children: jsxRuntimeExports.jsx(Icon, { color: "inherit", icon: iconRight, size: iconSize[size] }) }))] }))] })));
});
Button.displayName = 'Button';
const ButtonContent = styled.span `
    opacity: 1;
    display: flex;
    transition: opacity 0.3s;

    ${(props) => props.$isLoading &&
    css$3 `
            opacity: 0;
        `}
`;
const IconLeft = styled.span `
    margin-right: 0.5rem;
    display: inherit;
    align-items: center;
`;
const IconRight = styled.span `
    margin-left: 0.5rem;
    display: inherit;
    align-items: center;
`;
const StyledButton$2 = styled.button `
    /* stylelint-disable custom-property-pattern */
    font-family: var(--kds-font-family-base);
    display: inline-flex;
    vertical-align: middle;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: relative;
    text-decoration: none;
    transition: background 0.1s ease-out;
    font-size: var(--kds-button-font-size-${[({ $size }) => $size]});
    font-weight: var(--kds-button-font-weight);
    line-height: var(--kds-button-line-height);
    letter-spacing: var(--kds-button-letter-spacing);
    border-radius: var(--kds-button-border-radius);
    min-height: var(--kds-button-min-height-${[({ $size }) => $size]});
    padding-block: var(--kds-button-padding-block-${[({ $size }) => $size]});
    padding-inline: var(--kds-button-padding-inline-${[({ $size }) => $size]});
    background: var(--kds-button-color-background-${[({ $variant }) => $variant]}-${[({ $color }) => $color]});
    border: 1px solid var(--kds-button-color-border-${[({ $variant }) => $variant]}-${[({ $color }) => $color]});
    color: var(--kds-button-color-foreground-${[({ $variant }) => $variant]}-${[({ $color }) => $color]});

    @media (hover: hover) {
        &:hover:not(:disabled) {
            background: var(
                --kds-button-color-background-${[({ $variant }) => $variant]}-${[({ $color }) => $color]}-hovered
            );
            border: 1px solid
                var(--kds-button-color-border-${[({ $variant }) => $variant]}-${[({ $color }) => $color]}-hovered);
            color: var(
                --kds-button-color-foreground-${[({ $variant }) => $variant]}-${[({ $color }) => $color]}-hovered
            );
        }
    }

    &:disabled {
        background: var(--kds-button-color-background-${[({ $variant }) => $variant]}-disabled);
        border: 1px solid var(--kds-button-color-border-${[({ $variant }) => $variant]}-disabled);
        color: var(--kds-button-color-foreground-${[({ $variant }) => $variant]}-disabled);
        pointer-events: none;
    }

    &:focus {
        outline: none;
    }

    &:focus-visible {
        outline: 2px solid var(--kds-color-border-focused);
        outline-offset: 2px;
    }

    &:active:not(:disabled) {
        background: var(
            --kds-button-color-background-${[({ $variant }) => $variant]}-${[({ $color }) => $color]}-pressed
        );
        border: 1px solid
            var(--kds-button-color-border-${[({ $variant }) => $variant]}-${[({ $color }) => $color]}-pressed);
        color: var(--kds-button-color-foreground-${[({ $variant }) => $variant]}-${[({ $color }) => $color]}-pressed);
    }

    ${(props) => props.$width &&
    props.$width === 'auto' &&
    css$3 `
            width: auto;
        `}

    ${(props) => props.$width &&
    props.$width === 'full' &&
    css$3 `
            width: 100%;
        `}

    ${(props) => props.$width &&
    props.$width === 'full-below-small' &&
    css$3 `
            width: 100%;

            ${props.theme.mediaQueries.small} {
                width: auto;
            }
        `}

    ${(props) => props.$variant === 'link' &&
    css$3 `
            padding-inline: 0;

            @media (hover: hover) {
                &:hover:not(:disabled) {
                    text-decoration: underline;
                }
            }
        `}

    ${(props) => props.$isLoading &&
    css$3 `
            pointer-events: none;
            cursor: default;
        `};

    ${sx}
`;

const AlertContext = createContext({});

function AlertButton(_a) {
    var { children } = _a, props = __rest(_a, ["children"]);
    const { appearance } = useContext(AlertContext);
    return (jsxRuntimeExports.jsx(StyledAlertButton, Object.assign({ "$appearance": appearance, variant: "outline" }, props, { children: children })));
}
const StyledAlertButton = styled(Button) `
    ${(props) => props.$appearance &&
    css$3 `
            background: ${props.theme.alert[props.$appearance].backgroundColor};
            border-color: ${props.theme.alert[props.$appearance].foregroundColor};
            color: ${props.theme.alert[props.$appearance].foregroundColor};

            @media (hover: hover) {
                &:hover:not(:disabled) {
                    background: ${props.theme.alert[props.$appearance].backgroundColorHover};
                    border-color: ${props.theme.alert[props.$appearance].foregroundColor};
                    color: ${props.theme.alert[props.$appearance].foregroundColor};
                }
            }

            &:active:not(:disabled) {
                background: ${props.theme.alert[props.$appearance].backgroundColorActive};
                border-color: ${props.theme.alert[props.$appearance].foregroundColor};
                color: ${props.theme.alert[props.$appearance].foregroundColor};
            }
        `}
    ${sx}
`;

const useUniqueId = (id) => {
    const [generatedId] = useState(() => v4());
    return id || generatedId;
};

/**
 * Used to provide feedback about an invalid input,
 * and suggest clear instructions on how to fix it.
 */
function FormErrorMessage(_a) {
    var { children, isSensitiveData = false } = _a, props = __rest(_a, ["children", "isSensitiveData"]);
    return (jsxRuntimeExports.jsx(StyledFormErrorMessage, Object.assign({ className: "has-danger", "data-dd-privacy": isSensitiveData ? 'mask' : 'allow' }, props, { children: children })));
}
const StyledFormErrorMessage = styled.div `
    display: inline-block;
    position: relative;
    background-color: ${(props) => props.theme.colors.orange100};
    border-radius: ${(props) => props.theme.radii.sm};
    margin: 8px 0 0;
    line-height: ${(props) => props.theme.lineHeights[4]};
    font-size: ${(props) => props.theme.fontSizes.xs};
    font-weight: ${(props) => props.theme.fontWeights.medium};
    color: ${(props) => props.theme.colors.orange700};
    padding: 4px 8px;

    &::after {
        content: '';
        position: absolute;
        width: 0;
        height: 0;
        top: -6px;
        left: 8px;
        display: inline-block;
        border-bottom: 6px solid ${(props) => props.theme.colors.orange100};
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
    }
    ${sx}
`;

const FormGroupContext = createContext({});

const TextInput = forwardRef(function TextInput(_a, ref) {
    var { disabled, error, name, onBlur, onChange, onEnterKeyPress, onReset, placeholder, size, suffix, sx: sxProp, type = 'text', value, variant } = _a, props = __rest(_a, ["disabled", "error", "name", "onBlur", "onChange", "onEnterKeyPress", "onReset", "placeholder", "size", "suffix", "sx", "type", "value", "variant"]);
    const inputRef = useRef(null);
    useImperativeHandle(ref, () => ({
        blur: () => { var _a; return (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.blur(); },
        focus: () => { var _a; return (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus(); },
    }));
    const { size: formGroupContextSize, variant: formGroupContextVariant } = useContext(FormGroupContext);
    const sizeProp = size || formGroupContextSize || 'large';
    const variantProp = variant || formGroupContextVariant || 'outline';
    const renderSuffix = (suffixParam) => {
        return (jsxRuntimeExports.jsx(StyledIconButton$2, { "$parentSize": sizeProp, disabled: disabled, icon: suffixParam.icon, labelText: suffixParam.labelText, onClick: suffixParam.onSuffixClick, size: "small", tabIndex: -1, variant: "ghost" }));
    };
    const renderClearIcon = () => {
        if (disabled) {
            return;
        }
        return renderSuffix({
            icon: 'close',
            labelText: 'clear-icon',
            onSuffixClick: onReset,
        });
    };
    return (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsxs(StyledTextInputContainer, { "$error": error, "$onReset": onReset, "$size": sizeProp, "$suffix": suffix, "$value": value, "$variant": variantProp, sx: sxProp, children: [jsxRuntimeExports.jsx(StyledTextInput, Object.assign({ "$error": error, "$variant": variantProp, disabled: disabled, name: name, onBlur: onBlur, onChange: onChange, onKeyPress: (event) => {
                            if (event.key === 'Enter' && onEnterKeyPress) {
                                event.preventDefault();
                                onEnterKeyPress();
                            }
                        }, onReset: onReset, placeholder: placeholder, ref: inputRef, type: type, value: value }, props)), (suffix || (onReset && value)) && (jsxRuntimeExports.jsxs(StyledIconButtonWrapper, { "$onReset": onReset, "$size": sizeProp, "$suffix": suffix, "$value": value, children: [onReset && value && renderClearIcon(), onReset && value && suffix && jsxRuntimeExports.jsx(StyledButtonDivider, {}), suffix && renderSuffix(suffix)] }))] }), error && jsxRuntimeExports.jsx(FormErrorMessage, { children: error })] }));
});
const StyledIconButton$2 = styled(IconButton) `
    ${(props) => props.$parentSize === 'medium' &&
    css$3 `
            height: 38px;
            width: 38px;
        `}

    ${(props) => props.$parentSize === 'large' &&
    css$3 `
            height: 40px;
            width: 40px;
        `}
`;
const StyledIconButtonWrapper = styled.div `
    display: ${(props) => (props.$suffix || props.$onReset ? 'flex' : 'none')};
    align-items: center;
    justify-content: flex-end;
    position: absolute;
    right: 0;
    top: 0;

    ${(props) => props.$size === 'medium' &&
    css$3 `
            height: 38px;
            width: ${props.$value && props.$suffix && props.$onReset
        ? '77px'
        : props.$suffix || props.$onReset
            ? '38px'
            : '0px'};
        `}

    ${(props) => props.$size === 'large' &&
    css$3 `
            height: 40px;
            width: ${props.$value && props.$suffix && props.$onReset
        ? '81px'
        : props.$suffix || props.$onReset
            ? '40px'
            : '0px'};
        `}
`;
const StyledButtonDivider = styled.span `
    align-self: stretch;
    background-color: var(--kds-color-border-medium);
    margin-bottom: 8px;
    margin-top: 8px;
    width: 1px;
    box-sizing: border-box;
    flex-shrink: 0;
`;
const StyledTextInput = styled.input `
    color: var(--kds-color-foreground-default);
    font-weight: var(--kds-font-weight-input);
    width: 100%;
    min-width: 0;
    border: 0;
    box-shadow: none;
    padding: 8px 0;
    appearance: none;
    transition: all 0.2s;

    &::placeholder {
        font-weight: var(--kds-font-weight-placeholder);
        color: var(--kds-color-foreground-minimal);
    }

    ${(props) => props.$variant === 'flushed' &&
    css$3 `
            border-bottom: 1px solid var(--kds-color-border-medium);
            background-color: var(--kds-color-transparent);
            border-radius: 0;

            &:hover {
                border-color: var(--kds-color-border-strong);
            }

            &:focus {
                outline: none;
                border-color: var(--kds-color-border-focused);
            }
        `}

    ${(props) => props.$variant === 'outline' &&
    css$3 `
            border: 1px solid var(--kds-color-border-medium);
            background-color: var(--kds-color-background-default);
            padding-left: 12px;
            padding-right: 12px;
            border-radius: var(--kds-border-radius-base);

            &:hover {
                border-color: var(--kds-color-border-strong);
            }

            &:focus {
                outline: none;
                background-color: var(--kds-color-background-default);
                border-color: var(--kds-color-border-focused);
                box-shadow: 0 0 0 4px var(--kds-color-shadow-focused);
            }
        `}

    ${(props) => props.$error &&
    css$3 `
            border-color: var(--kds-color-border-warning);

            &:hover {
                border-color: var(--kds-color-border-warning);
            }

            &:focus {
                border-color: var(--kds-color-border-warning);
                box-shadow: 0 0 0 4px var(--kds-color-shadow-warning);
            }

            &::placeholder {
                color: var(--kds-color-foreground-warning);
            }
        `}

    ${(props) => props.disabled &&
    css$3 `
            color: var(--kds-color-foreground-disabled);
            background-color: var(--kds-color-background-disabled);
            border-color: var(--kds-color-border-disabled);
            pointer-events: none;

            &::placeholder {
                color: var(--kds-color-foreground-disabled);
            }
        `}
`;
const StyledTextInputContainer = styled.div `
    width: 100%;
    display: flex;
    position: relative;

    ${StyledTextInput} {
        font-size: var(--kds-font-size-input-large);
        line-height: var(--kds-line-height-input-large);
        height: var(--kds-size-input-height-large);

        ${(props) => props.$variant === 'flushed' &&
    css$3 `
                padding-right: ${props.$suffix && props.$onReset && props.$value
        ? '81px'
        : props.$suffix || (props.$onReset && props.$value)
            ? '40px'
            : '0px'};
            `}

        ${(props) => props.$variant === 'outline' &&
    css$3 `
                padding-right: ${props.$suffix && props.$onReset && props.$value
        ? '81px'
        : props.$suffix || (props.$onReset && props.$value)
            ? '40px'
            : '12px'};
            `};

        ${(props) => props.$size === 'medium' &&
    css$3 `
                ${props.theme.mediaQueries.small} {
                    font-size: var(--kds-font-size-input-medium);
                    line-height: var(--kds-line-height-input-medium);
                    height: var(--kds-size-input-height-medium);

                    ${props.$variant === 'flushed' &&
        css$3 `
                        padding-right: ${props.$suffix && props.$onReset && props.$value
            ? '77px'
            : props.$suffix || (props.$onReset && props.$value)
                ? '38px'
                : '0px'};
                    `}

                    ${props.$variant === 'outline' &&
        css$3 `
                        padding-right: ${props.$suffix && props.$onReset && props.$value
            ? '77px'
            : props.$suffix || (props.$onReset && props.$value)
                ? '38px'
                : '12px'};
                    `};
                }
            `}
    }
    ${sx}
`;

function Checkbox(_a) {
    var { checked = false, disabled = false, error, id, indeterminate = false, inputRef, label = '', onChange, sx: sxProp, textInput, value } = _a, props = __rest(_a, ["checked", "disabled", "error", "id", "indeterminate", "inputRef", "label", "onChange", "sx", "textInput", "value"]);
    const inputId = useUniqueId(id);
    const [shouldFocus, setShouldFocus] = useState(false);
    const textInputRef = useRef(null);
    useEffect(() => {
        if (checked && textInputRef.current && shouldFocus) {
            textInputRef.current.focus();
        }
    }, [checked]);
    return (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsxs(StyledCheckboxContainer, { sx: sxProp, children: [jsxRuntimeExports.jsxs(StyledCheckboxInputWrapper, { disabled: disabled, children: [jsxRuntimeExports.jsx(StyledCheckboxInput, Object.assign({ checked: checked, disabled: disabled, id: inputId, onChange: (event) => {
                                    setShouldFocus(true);
                                    onChange === null || onChange === void 0 ? void 0 : onChange(event);
                                }, ref: inputRef, type: "checkbox", value: value }, props)), jsxRuntimeExports.jsx(StyledCheckboxRipple, {}), jsxRuntimeExports.jsx(StyledCheckboxBackground, { children: jsxRuntimeExports.jsx(StyledCheckboxCheck, { "$checked": checked, children: indeterminate ? jsxRuntimeExports.jsx(IndeterminateBox, {}) : jsxRuntimeExports.jsx(CheckedIcon, { disabled: disabled }) }) })] }), label && (jsxRuntimeExports.jsx(StyledCheckboxLabel, { "$disabled": disabled, htmlFor: inputId, children: label }))] }), textInput && (jsxRuntimeExports.jsx(TextInput, { "aria-label": textInput['aria-label'], disabled: !checked || disabled, onChange: (event) => {
                    textInput.onChange(event);
                }, ref: textInputRef, sx: { pb: 1, pl: 8, pt: 0.5 }, value: textInput.value })), error && jsxRuntimeExports.jsx(FormErrorMessage, { children: error })] }));
}
const StyledCheckboxContainer = styled.div `
    display: flex;
    align-items: center;
    position: relative;
    min-height: 24px;

    ${sx}
`;
const StyledCheckboxInputWrapper = styled.div `
    display: flex;
    height: 20px;
    width: 20px;
    flex-shrink: 0;
    margin-top: 2px;
    align-self: flex-start;
`;
const StyledCheckboxRipple = styled.span `
    border-radius: ${(props) => props.theme.radii.full};
    box-shadow: 0 0 0 0 var(--kds-color-shadow-subtle);
    height: 20px;
    transition: box-shadow 150ms ease-out;
    width: 20px;
    position: absolute;
    pointer-events: none;
`;
const StyledCheckboxBackground = styled.div `
    align-items: center;
    background-color: var(--kds-color-background-default);
    border-radius: ${(props) => props.theme.radii.sm};
    border: 1px solid var(--kds-color-border-medium);
    box-sizing: border-box;
    display: flex;
    height: 20px;
    justify-content: center;
    pointer-events: none;
    position: absolute;
    transition:
        border 200ms ease,
        background 200ms;
    width: 20px;
`;
const StyledCheckboxCheck = styled.div `
    pointer-events: none;
    transition:
        transform 200ms ease,
        opacity 200ms ease;
    opacity: ${(props) => (props.$checked ? '1' : '0')};
    transform: ${(props) => (props.$checked ? 'scale(1)' : 'scale(0.5)')};
`;
const IndeterminateBox = styled.div `
    width: 14px;
    height: 2px;
    border-radius: ${(props) => props.theme.radii.sm};
    background-color: var(--kds-color-background-default);
`;
function CheckedIcon({ disabled }) {
    return (jsxRuntimeExports.jsx("svg", { height: "20px", style: { display: 'block' }, viewBox: "0 0 20 20", width: "20px", xmlns: "http://www.w3.org/2000/svg", children: jsxRuntimeExports.jsx("path", { d: "M15.399 5.274a.951.951 0 011.32-.015c.369.35.376.926.015 1.285L8.668 14.59c-.576.55-1.463.539-2.003 0l-3.4-3.39a.892.892 0 01.016-1.286.951.951 0 011.32.015l3.066 3.058 7.732-7.712z", fill: disabled ? kdsColorForegroundDisabled : kdsColorForegroundOnSelected, fillRule: "nonzero" }) }));
}
const StyledCheckboxLabel = styled.label `
    font-size: var(--kds-font-size-sm);
    color: ${(props) => props.$disabled ? `var(--kds-color-foreground-disabled);` : `var(--kds-color-foreground-default)`};
    line-height: var(--kds-line-height-5);
    font-weight: 400;
    padding-left: 12px;
    cursor: ${(props) => (props.$disabled ? '' : 'pointer')};
    margin: 0;
`;
const StyledCheckboxInput = styled.input `
    border-radius: ${(props) => props.theme.radii.sm};
    width: 24px;
    height: 24px;
    margin: -2px 0 0 -2px;
    position: absolute;
    opacity: 0;
    cursor: ${(props) => (props.disabled ? undefined : 'pointer')};

    &:focus,
    &:active {
        outline: none;
    }

    &:not(:checked, :disabled):active,
    &:not(:checked, :disabled, :focus):hover {
        ~ ${StyledCheckboxBackground} {
            border-color: var(--kds-color-border-strong);
        }
    }

    &:checked ~ ${StyledCheckboxBackground} {
        border-color: var(--kds-color-border-selected);
        background-color: var(--kds-color-background-selected);
    }

    &:disabled ~ ${StyledCheckboxBackground} {
        border-color: var(--kds-color-border-disabled);
        background-color: var(--kds-color-background-disabled);
    }

    &:disabled:checked ~ ${StyledCheckboxBackground} {
        border-color: var(--kds-color-border-disabled);
        background-color: var(--kds-color-background-disabled);
    }

    &:focus ~ ${StyledCheckboxBackground} {
        border-color: var(--kds-color-border-focused);
        border-width: 2px;
        box-shadow: none;
    }

    &:focus:not(:focus-visible) ~ ${StyledCheckboxBackground} {
        border: 1px solid var(--kds-color-border-medium);
        box-shadow: none;
    }

    &:focus:not(:focus-visible):hover ~ ${StyledCheckboxBackground} {
        border-color: var(--kds-color-border-strong);
    }

    &:checked:focus ~ ${StyledCheckboxBackground} {
        border-color: var(--kds-color-border-selected);
        border-width: 1px;
        outline: 2px solid var(--kds-color-border-focused);
        outline-offset: 2px;
    }

    &:checked:focus:not(:focus-visible) ~ ${StyledCheckboxBackground} {
        border-color: var(--kds-color-border-selected);
        box-shadow: none;
        outline: none;
    }

    &:hover ~ ${StyledCheckboxRipple} {
        box-shadow: ${(props) => (props.disabled ? undefined : `0 0 0 7px var(--kds-color-shadow-subtle)`)};
    }
`;

function AlertCheckbox(_a) {
    var props = __rest(_a, []);
    const { appearance } = useContext(AlertContext);
    return (jsxRuntimeExports.jsx(StyledAlertCheckbox, Object.assign({ "$appearance": appearance }, props)));
}
const StyledAlertCheckbox = styled(Checkbox) `
    ${(props) => props.$appearance &&
    css$3 `
            ~ ${StyledCheckboxBackground} {
                border-color: ${props.theme.alert[props.$appearance].foregroundColor};
            }

            &:not(:checked, :disabled):active,
            &:not(:checked, :disabled, :focus):hover {
                ~ ${StyledCheckboxBackground} {
                    border-color: ${props.theme.alert[props.$appearance].foregroundColor};
                }
            }

            &:checked ~ ${StyledCheckboxBackground} {
                border-color: ${props.theme.alert[props.$appearance].foregroundColor};
                background-color: ${props.theme.alert[props.$appearance].foregroundColor};
            }

            &:focus ~ ${StyledCheckboxBackground} {
                border-color: ${props.theme.alert[props.$appearance].foregroundColor};
            }

            &:focus:not(:focus-visible) ~ ${StyledCheckboxBackground} {
                border-color: ${props.theme.alert[props.$appearance].foregroundColor};
            }

            &:checked:focus:not(:focus-visible) ~ ${StyledCheckboxBackground} {
                border-color: ${props.theme.alert[props.$appearance].foregroundColor};
            }

            &:hover ~ ${StyledCheckboxRipple} {
                box-shadow: 0 0 0 7px ${props.theme.alert[props.$appearance].backgroundColorHover};
            }
        `}
    ${sx}
`;

function AlertCloseButton(_a) {
    var props = __rest(_a, []);
    const { appearance } = useContext(AlertContext);
    return (jsxRuntimeExports.jsx(StyledAlertCloseButton, Object.assign({ "$appearance": appearance, icon: "close" }, props)));
}
const StyledAlertCloseButton = styled(IconButton) `
    ${(props) => props.$appearance &&
    css$3 `
            background: ${props.theme.alert[props.$appearance].backgroundColor};
            color: ${props.theme.alert[props.$appearance].foregroundColor};

            @media (hover: hover) {
                &:hover:not(:disabled) {
                    background: ${props.theme.alert[props.$appearance].backgroundColorHover};
                    color: ${props.theme.alert[props.$appearance].foregroundColor};
                }
            }

            &:active:not(:disabled) {
                background: ${props.theme.alert[props.$appearance].backgroundColorActive};
                color: ${props.theme.alert[props.$appearance].foregroundColor};
            }
        `}
    ${sx}
`;

function AlertLink(_a) {
    var { children } = _a, props = __rest(_a, ["children"]);
    const { appearance } = useContext(AlertContext);
    return (jsxRuntimeExports.jsx(StyledAlertLink, Object.assign({ "$appearance": appearance }, props, { children: children })));
}
const StyledAlertLink = styled(Link) `
    ${(props) => props.$appearance &&
    css$3 `
            color: ${props.theme.alert[props.$appearance].foregroundColor};

            &:hover {
                color: ${props.theme.alert[props.$appearance].foregroundColor};
            }

            &:focus {
                color: ${props.theme.alert[props.$appearance].foregroundColor};
            }
        `}
    ${sx}
`;

function AlertText(_a) {
    var { children, sx } = _a, props = __rest(_a, ["children", "sx"]);
    const { appearance } = useContext(AlertContext);
    return (jsxRuntimeExports.jsx(Text, Object.assign({ sx: Object.assign({ color: (theme) => theme.alert[appearance].foregroundColor }, sx) }, props, { children: children })));
}

const icons = {
    danger: 'warning',
    info: 'information',
    success: 'checked',
    warning: 'warning',
};
function Alert(_a) {
    var { appearance = 'info', children, isClosable, isLoading, onClose, withIcon = false } = _a, props = __rest(_a, ["appearance", "children", "isClosable", "isLoading", "onClose", "withIcon"]);
    const theme = useTheme();
    return (jsxRuntimeExports.jsx(AlertContext.Provider, { value: { appearance }, children: jsxRuntimeExports.jsxs(StyledAlert, Object.assign({ "$appearance": appearance, role: "alert" }, props, { children: [withIcon && !isLoading && (jsxRuntimeExports.jsx(StyledIcon$b, { "$appearance": appearance, icon: icons[appearance] })), isLoading && (jsxRuntimeExports.jsx(StyledSpinner, { color: theme.alert[appearance].foregroundColor, size: "small" })), jsxRuntimeExports.jsx(StyledAlertContent, { children: children }), isClosable && jsxRuntimeExports.jsx(AlertCloseButton, { onClick: onClose })] })) }));
}
const StyledAlert = styled.div `
    position: relative;
    padding: 16px;
    border: none;
    border-radius: 0;
    margin: 16px 0;
    display: flex;
    flex-direction: row;
    overflow-wrap: break-word;

    ${(props) => props.$appearance &&
    css$3 `
            background-color: ${props.theme.alert[props.$appearance].backgroundColor};
            color: ${props.theme.alert[props.$appearance].foregroundColor};
        `}
    ${sx}
`;
const StyledAlertContent = styled.div `
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    width: 100%;
`;
const StyledIcon$b = styled(Icon) `
    margin-right: 16px;
    min-width: 18px;
    margin-top: 4px;
    flex-shrink: 0;

    ${(props) => props.$appearance &&
    css$3 `
            color: ${props.theme.alert[props.$appearance].foregroundColor};
        `}
`;
const StyledSpinner = styled(Spinner) `
    margin-right: 16px;
    margin-top: 4px;
    min-width: 18px;
    min-height: 18px;
`;
Alert.Button = AlertButton;
Alert.Link = AlertLink;
Alert.Checkbox = AlertCheckbox;
Alert.Text = AlertText;

function AppLayout({ banner, children, header, isSplitViewOpen }) {
    return (jsxRuntimeExports.jsxs(StyledAppLayout, { "$banner": banner, "$hasBanner": Boolean(banner), "$hasHeader": Boolean(header), "$isSplitViewOpen": isSplitViewOpen, children: [header && jsxRuntimeExports.jsx(StyledHeader$5, { children: header }), banner && (jsxRuntimeExports.jsx(StyledBanner, { "$hasHeader": Boolean(header), children: jsxRuntimeExports.jsx(StyledBannerContent, { "$hasHeader": Boolean(header), children: banner.children }) })), jsxRuntimeExports.jsx(StyledChildren$1, { "$hasBanner": Boolean(banner), "$hasHeader": Boolean(header), children: children })] }));
}
const StyledAppLayout = styled.div `
    display: grid;
    background-color: var(--kds-color-background-minimal);
    height: 100%;
    overflow: ${({ $isSplitViewOpen }) => $isSplitViewOpen && 'hidden'};

    ${(props) => props.$hasHeader &&
    props.$hasBanner &&
    props.$banner &&
    css$3 `
            grid-template-rows: ${props.theme.appLayout.header.height} ${`${props.$banner.height}px`} 1fr;
        `}
    ${(props) => !props.$hasHeader &&
    props.$hasBanner &&
    props.$banner &&
    css$3 `
            grid-template-rows: ${`${props.$banner.height}px`} 1fr;
        `}
        ${(props) => props.$hasHeader &&
    !props.$hasBanner &&
    css$3 `
            grid-template-rows: ${props.theme.appLayout.header.height} 1fr;
        `}
        ${(props) => !props.$hasHeader &&
    !props.$hasBanner &&
    css$3 `
            grid-template-rows: 1fr;
        `};
`;
const StyledHeader$5 = styled.div `
    grid-row: 1 / 2;
    min-width: 0;
`;
const StyledBanner = styled.div `
    grid-row: ${(props) => (props.$hasHeader ? '2 / 3' : ' 1 / 2')};
    min-width: 0;
`;
const StyledBannerContent = styled.div `
    position: fixed;
    width: 100%;
    z-index: ${(props) => props.theme.zIndices.banner};
    top: ${(props) => (props.$hasHeader ? props.theme.appLayout.header.height : 0)};
`;
const StyledChildren$1 = styled.div `
    ${(props) => props.$hasHeader &&
    props.$hasBanner &&
    css$3 `
            grid-row: 3/ 4;
        `}

    ${(props) => !props.$hasHeader &&
    props.$hasBanner &&
    css$3 `
            grid-row: 2/ 3;
        `}


    ${(props) => props.$hasHeader &&
    !props.$hasBanner &&
    css$3 `
            grid-row: 2/ 3;
        `}

    ${(props) => !props.$hasHeader &&
    !props.$hasBanner &&
    css$3 `
            grid-row: 1/ 2;
        `}

    min-width: 0;
`;

const variants$1 = {
    danger: {
        color: tokens.kdsColorDanger700,
    },
    default: {
        color: tokens.kdsColorMagenta700,
    },
    success: {
        color: tokens.kdsColorSuccess700,
    },
};
function AuthCode(_a) {
    var { appearance = 'default', length = 6, onChange } = _a, props = __rest(_a, ["appearance", "length", "onChange"]);
    const inputsRef = useRef([]);
    useEffect(() => {
        if (inputsRef.current[0]) {
            inputsRef.current[0].focus();
        }
    }, []);
    useEffect(() => {
        if (appearance === 'danger') {
            setTimeout(() => {
                handleClearInputs();
            }, 2000);
        }
    }, [appearance]);
    const sendResult = () => {
        const result = inputsRef.current.map((input) => input === null || input === void 0 ? void 0 : input.value).join('');
        if (onChange) {
            onChange(result);
        }
    };
    const handleChange = (e) => {
        const nextElement = e.target.nextElementSibling;
        if (e.target.value.match('^[0-9]*$')) {
            if (nextElement) {
                nextElement.focus();
            }
            else {
                e.target.blur();
            }
        }
        else {
            e.target.value = '';
        }
        sendResult();
    };
    const handleKeyDown = (e) => {
        const currentElement = e.target;
        const previousElement = currentElement.previousElementSibling;
        const { key } = e;
        if (key === 'Backspace') {
            if (currentElement.value === '' && previousElement !== null) {
                previousElement.focus();
                previousElement.value = '';
            }
            else {
                currentElement.value = '';
            }
            sendResult();
        }
    };
    const handleFocus = (e) => {
        e.target.select();
    };
    const handlePaste = (e) => {
        const value = e.clipboardData.getData('Text');
        if (value.match('^[0-9]*$')) {
            for (let i = 0; i < length && i < value.length; i++) {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const nextElement = inputsRef.current[i].nextElementSibling;
                inputsRef.current[i].value = value.charAt(i);
                if (nextElement) {
                    nextElement.focus();
                }
                else {
                    inputsRef.current[i].blur();
                }
            }
            sendResult();
        }
    };
    const handleClearInputs = () => {
        if (!inputsRef.current) {
            return;
        }
        inputsRef.current.forEach((input) => input.value && (input.value = ''));
        inputsRef.current[0].focus();
    };
    const inputs = [];
    for (let i = 0; i < length; i++) {
        inputs.push(jsxRuntimeExports.jsx(StyledInput, { "$appearance": appearance, "aria-label": `Enter Verification Code Digit ${i + 1}`, autoComplete: "one-time-code", inputMode: "numeric", maxLength: 1, onChange: handleChange, onFocus: handleFocus, onKeyDown: handleKeyDown, onPaste: handlePaste, pattern: "[0-9]*", ref: (ref) => (inputsRef.current[i] = ref), type: "text" }, i));
    }
    return jsxRuntimeExports.jsx(AuthCodeContainer, Object.assign({}, props, { children: inputs }));
}
const AuthCodeContainer = styled.div `
    display: flex;
    width: 100%;
    justify-content: center;

    ${sx}
`;
const StyledInput = styled.input `
    border: 1px solid var(--kds-color-border-medium);
    border-radius: ${(props) => props.theme.radii.sm};
    height: 52px;
    width: 40px;
    text-align: center;
    font-size: 21px;
    font-weight: 400;
    caret-color: ${(props) => props.theme.colors.magenta700};
    box-shadow: none;
    appearance: none;

    ${(props) => props.$appearance &&
    css$3 `
            color: ${variants$1[props.$appearance].color};
        `}

    ${(props) => props.$appearance === 'danger' &&
    css$3 `
            animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
            transform: translate3d(0, 0, 0);
            backface-visibility: hidden;
        `}

    ${(props) => props.theme.mediaQueries.medium} {
        height: 78px;
        width: 62px;
        font-size: 32px;
    }

    &:hover {
        border-color: var(--kds-color-border-strong);
    }

    &:focus {
        border-color: ${(props) => props.theme.colors.magenta700};
        outline: none;
    }

    ${AuthCodeContainer} &:not(:first-of-type) {
        margin-left: 4px;

        ${(props) => props.theme.mediaQueries.medium} {
            margin-left: 8px;
        }
    }

    ${AuthCodeContainer} &:nth-child(3n+4) {
        margin-left: 16px;

        ${(props) => props.theme.mediaQueries.medium} {
            margin-left: 32px;
        }
    }

    @keyframes shake {
        10%,
        90% {
            transform: translate3d(-1px, 0, 0);
        }

        20%,
        80% {
            transform: translate3d(2px, 0, 0);
        }

        30%,
        50%,
        70% {
            transform: translate3d(-4px, 0, 0);
        }

        40%,
        60% {
            transform: translate3d(4px, 0, 0);
        }
    }
`;

const AvatarGroupContainer = styled.div `
    display: flex;
    align-items: center;

    ${sx}
`;

function AvatarIcon(_a) {
    var { color = 'currentColor', icon = 'patient-nogender', id, size = '40' } = _a, props = __rest(_a, ["color", "icon", "id", "size"]);
    return (jsxRuntimeExports.jsx("svg", Object.assign({ height: size, id: id, viewBox: "0 0 40 40", width: size, xmlns: "http://www.w3.org/2000/svg" }, props, { children: getAvatarIcon(icon, color) })));
}
function getAvatarIcon(icon, color) {
    switch (icon) {
        case 'patient-man':
            return (jsxRuntimeExports.jsx("path", { d: "M20.112 37.3c-3.396 0-6.942-1.911-7.684-2.949-2.473.974-5.059 2.627-5.523 3.025l-.887-.992c.72-.617 4.057-2.57 6.863-3.505 1.834-.611 3.155-1.122 3.155-1.377V28.47h1.359v3.674l-.213.201c-.092.085-.93.654-3.471 1.546.648.836 3.684 2.05 6.4 2.05h1.36c2.716 0 5.3-1.214 5.948-2.05-2.54-.892-3.153-1.541-3.245-1.625l.013-.122V28.47h1.359v3.032c0 .255.869.786 2.704 1.398 2.806.934 5.917 2.907 6.637 3.524l-1 1.032c-.464-.398-2.655-2.13-5.129-3.105-.741 1.038-3.891 2.95-7.288 2.95h-1.358zm-3.09-33.497c-.637 0-1.12.192-1.475.587-.78.869-.79 2.565-.727 3.146l.073.683-.685.066c-.627.06-1.045.252-1.24.57-.507.825.194 2.603.612 3.664.275.698.419 1.078.419 1.398v5.054c0 3.014 3.392 7.461 6.439 7.461h.271c2.992 0 6.195-4.379 6.195-7.46l.01-5.543c.438-2.634.202-4.58-.685-5.627-.678-.801-1.608-.92-2.1-.92a2.25 2.25 0 0 0-.29.016l-.276.04-.228-.163c-3.376-2.456-5.296-2.972-6.313-2.972m3.687 23.988h-.271c-3.869 0-7.798-5.131-7.798-8.82v-5.054c-.014-.113-.186-.549-.324-.9-.544-1.382-1.367-3.469-.506-4.872.339-.554.886-.924 1.63-1.106-.002-.888.142-2.49 1.093-3.553.619-.69 1.456-1.041 2.489-1.041 1.755 0 4.016 1.008 6.906 3.083.645-.034 2.2.053 3.338 1.396 1.162 1.372 1.498 3.617.997 6.672v5.375c0 3.77-3.735 8.82-7.554 8.82", fill: color }));
        case 'patient-nogender':
            return (jsxRuntimeExports.jsx("path", { d: "M20.324 37.227c-3.814 0-7.797-2.063-8.63-3.228-2.778 1.093-5.682 2.993-6.204 3.44l-.997-1.093c.81-.694 4.6-2.876 7.751-3.926 2.06-.687 3.588-1.25 3.588-1.538v-3.405h1.5v4.127l-.27.227c-.103.094-1.059.663-3.912 1.664.727.939 4.122 2.232 7.174 2.232h1.526c3.052 0 5.954-1.293 6.682-2.232-2.854-1.002-3.577-1.695-3.68-1.79l-.02-.101v-4.127h1.5v3.405c0 .288 1.023.883 3.086 1.57 3.151 1.051 6.67 3.266 7.479 3.96l-1.112 1.158c-.522-.447-2.976-2.478-5.755-3.571-.833 1.165-4.365 3.228-8.18 3.228h-1.526zm.758-33.646c-3.97 0-7.5 3.975-7.5 7.107v5.034c0 3.306 3.78 9.222 7.5 9.222s7.5-5.916 7.5-9.222v-5.034c0-3.132-3.531-7.107-7.5-7.107m0 22.863c-2.981 0-5.265-2.486-6.36-3.968-1.604-2.167-2.64-4.817-2.64-6.754v-5.034c0-3.874 4.153-8.607 9-8.607s9 4.733 9 8.607v5.034c0 1.937-1.036 4.587-2.64 6.754-1.095 1.482-3.379 3.968-6.36 3.968", fill: color }));
        case 'patient-woman':
            return (jsxRuntimeExports.jsxs("g", { fill: color, children: [jsxRuntimeExports.jsx("path", { d: "M17.892 9.573c-1.443.595-2.77 1.843-2.77 3.513v4.63c0 2.62 2.908 7.037 5.031 7.037h.222c2.181 0 3.712-4.604 3.712-7.15a1066.54 1066.54 0 0 0-.128-4.52c-2.46-.526-4.455-1.647-6.067-3.51m2.483 16.65h-.222c-3.225 0-6.501-5.386-6.501-8.507v-4.63c0-2.59 2.138-4.418 4.257-5.08l.481-.15.314.394c1.556 1.96 3.549 3.12 6.09 3.547l.555.093.054.56c.02.19.113 3.623.154 5.134 0 3.062-1.78 8.639-5.182 8.639" }), jsxRuntimeExports.jsx("path", { d: "M9.978 30.631h-1.47V13.308c0-6.113 4.945-11.087 11.021-11.087 6.18 0 11.02 4.87 11.02 11.087V30.63H29.08V13.308c0-5.393-4.195-9.617-9.55-9.617-5.267 0-9.552 4.314-9.552 9.617V30.63z" }), jsxRuntimeExports.jsx("path", { d: "M19.897 37.464c-3.941 0-7.153-2.067-7.955-3.189-2.676 1.053-5.484 2.84-5.986 3.27L5 36.474c.78-.668 4.394-2.78 7.43-3.79 1.984-.662 3.003-1.215 3.426-1.49v-4.236h1.47v4.93l-.238.218c-.1.09-1.012.707-3.76 1.671.7.905 3.432 2.219 6.569 2.219 2.938 0 5.95-1.314 6.65-2.219-2.748-.964-3.701-1.666-3.8-1.757l-.279-.133v-4.929h1.47v4.235c.734.276 1.524.85 3.508 1.512 3.035 1.011 6.692 3.145 7.47 3.813l-.935 1.116c-.502-.431-3.382-2.305-6.058-3.358-.802 1.122-3.618 3.19-8.026 3.19" })] }));
        case 'practitioner-man':
            return (jsxRuntimeExports.jsxs("g", { fill: color, children: [jsxRuntimeExports.jsx("path", { d: "M10.38 33.459c2.49-.884 3.15-1.608 3.24-1.691l.049-.2V28h-1.332v2.93c0 .254-.973.78-2.772 1.387-2.75.928-5.859 2.884-6.565 3.497l.95 1.024c.455-.395 2.708-1.956 5.132-2.922C9.809 34.946 11.672 37 15 37v-1.348c-2.663 0-3.986-1.364-4.62-2.193M13.234 2.33c-.599 0-1.051.187-1.385.573-.733.85-.742 2.511-.683 3.08l.069.669-.643.064c-.59.059-.982.246-1.165.557-.476.809.224 2.547.617 3.587.259.683.437 1.054.437 1.367v4.947c0 2.95 3.1 7.45 5.961 7.45h.255c2.81 0 5.818-4.36 5.818-7.376l.01-5.461c.412-2.578.189-4.501-.644-5.526-.637-.784-1.51-.91-1.973-.91a2.89 2.89 0 0 0-.273.011l-.258.038-.214-.16c-3.17-2.405-4.974-2.91-5.929-2.91M16.697 26h-.255c-3.633 0-7.283-5.216-7.283-8.826v-4.947c0-.11-.195-.537-.324-.88-.512-1.352-1.295-3.396-.486-4.769.319-.541.827-.904 1.526-1.081-.002-.87.132-2.438 1.024-3.477.582-.677 1.367-1.02 2.336-1.02 1.649 0 3.771.987 6.485 3.017.61-.031 2.018.053 3.086 1.367 1.092 1.343 1.548 3.54.887 6.53v5.26c0 3.69-3.41 8.826-6.996 8.826M29.5 23c-4.687 0-8.5 3.813-8.5 8.5 0 4.687 3.813 8.5 8.5 8.5 4.687 0 8.5-3.813 8.5-8.5 0-4.687-3.813-8.5-8.5-8.5m0 1.36a7.14 7.14 0 1 1 0 14.28 7.14 7.14 0 0 1 0-14.28" }), jsxRuntimeExports.jsx("path", { d: "M32.143 29.857V27h-4.286v2.857H25v4.286h2.857V37h4.286v-2.857H35v-4.286z" })] }));
        case 'practitioner-nogender':
            return (jsxRuntimeExports.jsxs("g", { fill: color, children: [jsxRuntimeExports.jsx("path", { d: "M8.994 31.065c2.698-.982 3.414-1.786 3.511-1.879l.053-.222V25h-1.443v3.256c0 .282-1.054.866-3.003 1.541C5.133 30.828 1.765 33.002 1 33.682l1.03 1.138c.492-.44 2.933-2.173 5.559-3.246C8.376 32.717 10.394 35 14 35v-1.497c-2.885 0-4.318-1.516-5.006-2.438M16 1.478c-3.892 0-7.5 3.914-7.5 7v4.96c0 3.257 3.852 9.085 7.5 9.085s7.5-5.828 7.5-9.084v-4.96c0-3.087-3.608-7-7.5-7M15.827 24c-2.924 0-5.164-2.448-6.239-3.908C8.016 17.957 7 15.346 7 13.439v-4.96C7 4.662 11.246 0 16 0c4.753 0 9 4.662 9 8.479v4.96c0 1.907-1.19 4.518-2.762 6.653C21.164 21.552 18.75 24 15.827 24M30 21c-4.963 0-9 4.261-9 9.5 0 5.238 4.037 9.5 9 9.5s9-4.262 9-9.5c0-5.239-4.037-9.5-9-9.5m0 1.52c4.175 0 7.56 3.573 7.56 7.98 0 4.408-3.385 7.98-7.56 7.98s-7.56-3.572-7.56-7.98c0-4.407 3.385-7.98 7.56-7.98" }), jsxRuntimeExports.jsx("path", { d: "M32.143 28.857V26h-4.286v2.857H25v4.286h2.857V36h4.286v-2.857H35v-4.286z" })] }));
        case 'practitioner-woman':
            return (jsxRuntimeExports.jsxs("g", { fill: color, children: [jsxRuntimeExports.jsx("path", { d: "M18 29h1v-4h-1zM14.275 7.756c-1.455.607-2.794 1.884-2.794 3.59v4.733c0 2.678 2.932 7.42 5.072 7.42h.224c2.199 0 3.742-4.82 3.742-7.423-.04-1.512-.097-3.66-.129-4.675-2.48-.54-4.49-1.742-6.115-3.645M16.777 25h-.224C13.303 25 10 19.269 10 16.079v-4.733c0-2.647 2.156-4.515 4.292-5.193L14.777 6l.316.403c1.568 2.003 3.577 3.189 6.138 3.626l.56.095.054.572c.02.194.114 3.817.155 5.36C22 19.186 20.206 25 16.777 25" }), jsxRuntimeExports.jsx("path", { d: "M6.467 29H5V11.23C5 5.037 9.935 0 16 0c6.168 0 11 4.932 11 11.23v10.328h-1.467V11.23c0-5.462-4.187-9.74-9.533-9.74-5.257 0-9.533 4.369-9.533 9.74V29z" }), jsxRuntimeExports.jsx("path", { d: "M9.452 32.005c2.79-.997 3.715-1.814 3.816-1.908l.24-.226V25h-1.49v4.153c-.43.286-1.463.88-3.478 1.564-3.08 1.047-6.75 3.254-7.54 3.945l.97 1.155c.51-.446 3.36-2.206 6.075-3.296C8.86 33.682 11 36 15 36v-1.52c-3.183 0-4.837-1.539-5.548-2.475M31 22c-4.963 0-9 4.037-9 9s4.037 9 9 9 9-4.037 9-9-4.037-9-9-9m0 1.44a7.56 7.56 0 1 1 0 15.12 7.56 7.56 0 0 1 0-15.12" }), jsxRuntimeExports.jsx("path", { d: "M33.143 28.857V26h-4.286v2.857H26v4.286h2.857V36h4.286v-2.857H36v-4.286z" })] }));
        case 'organization':
            return (jsxRuntimeExports.jsx("g", { fill: color, children: jsxRuntimeExports.jsx("path", { d: "M14.0325173,38 L25,38 L25,2 L2,2 L2,38 L12.0539241,38 L12.0539241,29.6962626 C12.0539241,28.4366722 12.2841472,27.7599819 13.0550108,27.7599819 C13.8258744,27.7599819 14.0325173,28.4366722 14.0325173,29.6962626 L14.0325173,38 Z M27.0344238,10.0199322 L38,10.0199322 C39.1045695,10.0199322 40,10.9153627 40,12.0199322 L40,38 C40,39.1045695 39.1045695,40 38,40 L2,40 C0.8954305,40 1.3527075e-16,39.1045695 0,38 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 L25.0344238,0 C26.1389933,-6.83287194e-16 27.0344238,0.8954305 27.0344238,2 L27.0344238,10.0199322 L27.0344238,10.0199322 Z M27,38 L38,38 L38,12 L27,12 L27,38 Z M13,22 C12.4477153,22 12,21.5522847 12,21 C12,20.4477153 12.4477153,20 13,20 C13.5522847,20 14,20.4477153 14,21 C14,21.5522847 13.5522847,22 13,22 Z M13,14 C12.4477153,14 12,13.5522847 12,13 C12,12.4477153 12.4477153,12 13,12 C13.5522847,12 14,12.4477153 14,13 C14,13.5522847 13.5522847,14 13,14 Z" }) }));
        default:
            return null;
    }
}

const circleSizes = {
    large: '80px',
    medium: '48px',
    small: '40px',
    xlarge: '120px',
    xsmall: '32px',
    xxlarge: '160px',
};
const borderRadiuses = {
    circle: tokens.kdsBorderRadiusFull,
    square: tokens.kdsBorderRadiusBase,
};
const colorOptions = [
    tokens.kdsColorYellow800,
    tokens.kdsColorPurple800,
    tokens.kdsColorLightblue900,
    tokens.kdsColorTeal800,
    tokens.kdsColorGreen800,
    tokens.kdsColorLime800,
    tokens.kdsColorCyan800,
];
const backgroundOptions = [
    tokens.kdsColorYellow300,
    tokens.kdsColorPurple300,
    tokens.kdsColorLightblue300,
    tokens.kdsColorTeal300,
    tokens.kdsColorGreen300,
    tokens.kdsColorLime300,
    tokens.kdsColorCyan300,
];
function getIconSize(size) {
    if (typeof size === 'string') {
        if (size === 'xsmall') {
            return 32 * 0.625;
        }
        if (size === 'small') {
            return 40 * 0.625;
        }
        if (size === 'medium') {
            return 48 * 0.625;
        }
        if (size === 'large') {
            return 80 * 0.625;
        }
        if (size === 'xlarge') {
            return 120 * 0.625;
        }
        if (size === 'xxlarge') {
            return 160 * 0.625;
        }
        return undefined;
    }
    if (typeof size === 'number') {
        return size * 0.625;
    }
    return undefined;
}
function getFontSize(size) {
    if (typeof size === 'string') {
        if (size === 'xsmall') {
            return 13;
        }
        if (size === 'small') {
            return 15;
        }
        if (size === 'medium') {
            return 18;
        }
        if (size === 'large') {
            return 25;
        }
        if (size === 'xlarge') {
            return 35;
        }
        if (size === 'xxlarge') {
            return 45;
        }
        return undefined;
    }
    if (typeof size === 'number') {
        return size / 3;
    }
    return undefined;
}
function Avatar(_a) {
    var { altText = 'avatar', backgroundColor = tokens.kdsColorNeutral100, color = tokens.kdsColorNeutral700, icon = 'practitioner-nogender', imageUrl, initials, shape = 'circle', size = 'medium' } = _a, props = __rest(_a, ["altText", "backgroundColor", "color", "icon", "imageUrl", "initials", "shape", "size"]);
    const iconSize = getIconSize(size);
    const fontSize = getFontSize(size);
    return (jsxRuntimeExports.jsx(StyledAvatar$2, Object.assign({ "$backgroundColor": backgroundColor, "$color": color, "$initials": initials, "$shape": shape, "$size": size, "aria-label": altText, role: "img" }, props, { children: imageUrl ? (jsxRuntimeExports.jsx(AvatarImage, { alt: altText, src: imageUrl })) : initials ? (jsxRuntimeExports.jsx(AvatarInitials, { fontSize: fontSize, children: initials })) : (jsxRuntimeExports.jsx(AvatarIcon, { icon: icon, size: iconSize })) })));
}
const StyledAvatar$2 = styled.div `
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    border: 0;
    border-radius: ${(props) => props.$shape && borderRadiuses[props.$shape]};
    box-sizing: border-box;
    overflow: hidden;
    position: relative;
    min-height: ${(props) => typeof props.$size === 'string' ? circleSizes[props.$size] : `${props.$size}px`};
    height: ${(props) => typeof props.$size === 'string' ? circleSizes[props.$size] : `${props.$size}px`};
    min-width: ${(props) => typeof props.$size === 'string' ? circleSizes[props.$size] : `${props.$size}px`};
    width: ${(props) => typeof props.$size === 'string' ? circleSizes[props.$size] : `${props.$size}px`};
    color: ${(props) => props.$initials ? colorOptions[props.$initials.charCodeAt(0) % colorOptions.length] : props.$color};
    background-color: ${(props) => props.$initials
    ? backgroundOptions[props.$initials.charCodeAt(0) % Object.keys(backgroundOptions).length]
    : props.$backgroundColor};

    ${AvatarGroupContainer} & {
        border: 2px solid rgb(255 255 255);
    }

    ${AvatarGroupContainer} &:not(:first-child) {
        margin-left: -12px;
    }

    ${sx}
`;
const AvatarImage = styled.img `
    height: 100%;
    width: auto;
    top: 50%;
    left: 50%;
    position: absolute;
    transform: translate(-50%, -50%);
`;
const AvatarInitials = styled.span `
    font-size: ${(props) => `${props.fontSize}px`};
    font-weight: 500;
`;

function CarePathIcon(_a) {
    var { color = 'currentColor', icon = 'general', id, size, variant = 'large-multicolor' } = _a, props = __rest(_a, ["color", "icon", "id", "size", "variant"]);
    const theme = useTheme();
    const primaryColor = theme.colors.orange500;
    const secondaryColor = theme.colors.magenta700;
    if (variant === 'small') {
        size = size ? size : 18;
        return (jsxRuntimeExports.jsx("svg", Object.assign({ height: size, id: id, viewBox: "0 0 18 18", width: size }, props, { children: getSmallIcon(icon, color) })));
    }
    if (variant === 'large') {
        size = size ? size : 90;
        return (jsxRuntimeExports.jsx("svg", Object.assign({ height: size, id: id, viewBox: "0 0 90 90", width: size, xmlns: "http://www.w3.org/2000/svg" }, props, { children: getLargeIcon(icon, color, color) })));
    }
    if (variant === 'large-multicolor') {
        size = size ? size : 90;
        return (jsxRuntimeExports.jsx("svg", Object.assign({ height: size, id: id, viewBox: "0 0 90 90", width: size, xmlns: "http://www.w3.org/2000/svg" }, props, { children: getLargeIcon(icon, primaryColor, secondaryColor) })));
    }
    return null;
}
function getSmallIcon(icon, color) {
    switch (icon) {
        case 'bariatrics':
            return (jsxRuntimeExports.jsx("g", { fill: "none", fillRule: "evenodd", stroke: "none", strokeWidth: "1", children: jsxRuntimeExports.jsx("g", { fill: "#322A24", fillRule: "nonzero", id: "Icons", transform: "translate(-295.000000, -1041.000000)", children: jsxRuntimeExports.jsxs("g", { id: "Icons/Care/Open/small/Bariatrie", transform: "translate(295.000000, 1041.000000)", children: [jsxRuntimeExports.jsx("path", { d: "M15.8204757,3.23686576 L16.6175823,3.82601911 C17.1419642,4.21359763 17.5807811,4.69986056 17.9000122,5.25783272 C18.8197379,6.86538684 18.887537,9.68065765 18.0576131,11.6145187 C17.5582453,12.7781288 16.6396122,14.0959628 15.5725823,15.1540208 C14.1270481,16.5874005 12.4776212,17.5121854 10.7160314,17.8316372 C10.233126,17.9192087 9.75503309,17.9722471 9.28695483,17.990556 L8.93785515,17.9977728 L7.83177578,18 L9.44874863,16.1997022 L9.64441047,16.1813155 C9.88858705,16.1583698 10.136451,16.1241821 10.3868997,16.0787649 C11.6820007,15.8439076 12.9891119,15.1265557 14.1223298,14.0722444 L14.3624329,13.8412161 L14.4999099,13.7018464 C15.312479,12.8620811 15.9718603,11.8878002 16.3864016,10.9218498 C17.0029244,9.48524885 16.9562313,7.24518268 16.3190157,6.13141726 C16.2507318,6.01206638 16.1729106,5.89751811 16.0863287,5.78853633 L15.9499821,5.62933401 L15.8212155,5.48963859 L15.8204757,3.23686576 Z", id: "Path" }), jsxRuntimeExports.jsx("path", { d: "M0,17.8827544 L0,13.5526499 C0,11.6395246 1.51741816,10.0496698 3.26978251,9.94812181 C3.61068162,9.928367 3.90720879,9.94599566 4.23105678,10.0052871 L4.48018563,10.0576344 L4.87662284,10.1550582 L4.94969249,10.1033841 L5.35840509,9.77877322 L5.5635082,9.62789433 C5.74464804,9.5014224 5.91805462,9.39924665 6.10264536,9.31113585 C6.27615732,9.2283133 6.44379144,9.15940651 6.63447964,9.0926326 L6.83392408,9.02613325 L7.29454805,8.88484676 L7.63969207,8.77117951 L7.91047571,8.66462256 L8.08526024,8.58640245 L8.29257352,8.48490235 C8.69612727,8.27053864 8.9479003,8.01927227 9.1945192,7.59021554 L9.28704606,7.42071017 L9.444172,7.11045296 L9.5537963,6.88466005 L9.59929973,6.78453369 L9.67463513,6.60150016 C9.7525193,6.39580616 9.7681716,6.29328319 9.78982108,6.32522496 C9.70059507,6.19358036 9.60726453,6.12892646 9.3648446,6.06197923 L9.25139973,6.03294516 L8.8730079,5.94449023 C8.25306111,5.76922249 7.58150127,5.37010447 7.07996888,4.84312115 C6.28230975,4.00498375 5.91587235,3.28973368 5.85162501,2.33642403 L5.84210429,2.1120393 L5.842,1.757 L5.83833389,1.63676493 L5.83521212,1.43578506 L5.83764118,0.976632781 L5.841,0.875 L5.84131066,0 L7.66445051,0 L7.65887123,0.857122502 L7.655,0.951 L7.655,1.704 L7.66018597,1.81137826 L7.66874141,1.9154665 L7.69118095,2.07257377 L7.7213695,2.18488914 L7.73522094,2.21861859 L7.77202722,2.28189597 L7.82373231,2.34513097 L7.93009451,2.45039556 L8.0150289,2.52919857 C8.28235151,2.77221155 8.4046949,2.84110847 8.67301466,2.86586184 L8.79779443,2.87414668 L8.90153241,2.87779494 L12.0568284,2.87967723 L12.0568284,4.66175189 L10.6127376,4.6618201 C10.884107,4.82868334 11.1013425,5.04492071 11.2993685,5.33708952 C11.6520585,5.8574505 11.6578989,6.4489321 11.3891506,7.1833757 L11.3162848,7.37000654 L11.2363733,7.55397092 L11.1438568,7.75073553 L10.947761,8.14279076 C10.4838362,9.06206016 9.95813867,9.6334741 9.12523037,10.0685727 L8.91046104,10.1746299 L8.79274328,10.2288969 L8.52671965,10.3442963 L8.26644754,10.4440515 L8.04325611,10.5201739 L7.41974306,10.7133345 L7.2500478,10.7692571 C7.11910975,10.8148933 7.00918206,10.8600161 6.89508199,10.9144796 C6.82212605,10.9493037 6.74969274,10.9904677 6.67294358,11.0409076 L6.55397815,11.1238913 L6.48457987,11.1759574 L6.11723288,11.4687126 C5.9201333,11.6223407 5.76538118,11.7221795 5.5940931,11.8000872 C5.46075231,11.8607352 5.32526942,11.9028207 5.18570288,11.9252802 C5.13973896,11.9326768 5.09347947,11.9380907 5.04688982,11.9415522 C4.91262979,11.9515274 4.78120826,11.9456585 4.63879181,11.9244138 L4.49219802,11.8980612 L4.37237234,11.8707726 L4.12244195,11.8068556 C3.83148673,11.7335714 3.63761758,11.7123676 3.37654852,11.7274963 L3.27574313,11.7373751 C4.17196889,12.0247733 4.93541257,12.7086626 4.93541257,13.60479 L4.93541257,13.60479 L4.94382014,13.7397752 C4.97686759,14.0251597 5.10381205,14.3920775 5.26170914,14.6433914 L5.26170914,14.6433914 L5.53674536,15.052166 L4.33682728,16.414319 L3.96573791,15.9345641 C3.8806295,15.8245335 3.80106486,15.7107534 3.72720626,15.5933703 C3.37969953,15.0410794 3.14482349,14.3152978 3.12307577,13.6896669 L3.12307577,13.6896669 L3.12165001,13.60479 C3.12165001,13.3341522 2.8074042,13.0656177 2.42725668,13.0932832 C2.09109461,13.1177476 1.82970767,13.3996789 1.82014953,13.5792602 L1.82014953,13.5792602 L1.81931166,17.8827544 L0,17.8827544 Z", id: "Combined-Shape" }), jsxRuntimeExports.jsx("path", { d: "M14.9494549,2.976119 L12.9589562,2.95357399 L12.9194532,5.38464136 L14.9094249,5.43498096 L14.9394181,3.77713391 C14.9427163,3.53247486 14.9460613,3.26548949 14.9494549,2.976119 Z M14.8833616,6.79817655 L12.8931101,6.7599878 L12.8803227,7.23522171 C12.8516728,8.03747935 12.7915302,8.48128335 12.6527355,8.91430804 L14.5514003,9.50205433 C14.7886181,8.76196024 14.8576899,8.09031392 14.8833616,6.79817655 Z M12.15631,9.91685964 L12.1224908,9.96735927 C11.7431197,10.5275333 11.33477,10.9346986 10.662162,11.4534949 L11.8911929,12.9923908 C12.6257171,12.4258373 13.1432515,11.9282306 13.6077181,11.2952496 L13.8246846,10.9840033 L12.15631,9.91685964 Z M9.5571117,12.2719298 C9.10384188,12.6064512 8.73137022,12.8913914 8.33807587,13.2092136 C8.12996025,13.3773923 7.87179521,13.6327249 7.54606608,13.9871172 L9.02329313,15.2984135 L9.23391741,15.0739083 C9.39523362,14.9060134 9.52018871,14.7866791 9.60239977,14.7202441 C9.97027407,14.422964 10.3207745,14.1548317 10.7524848,13.8362216 L9.5571117,12.2719298 Z M8.14077033,16.3074142 L6.60973406,15.0571486 L5.94707306,15.8528161 C5.71009248,16.1410553 5.4570021,16.4523281 5.18775325,16.7866851 C6.28090349,17.5215926 6.84071524,17.8730485 6.86718852,17.841053 C7.02829821,17.6463363 7.26996274,17.3542613 7.59218212,16.9648279 C7.78705986,16.7286076 7.96993281,16.509459 8.14077033,16.3074142 Z", id: "Path-5" })] }) }) }));
        case 'cardiology':
            return (jsxRuntimeExports.jsxs("g", { fill: "none", fillRule: "evenodd", stroke: color, strokeLinecap: "round", strokeWidth: "2", children: [jsxRuntimeExports.jsx("path", { d: "M5 3l-.894.447A2 2 0 0 0 3 5.237V11c0 5 5.5 6 10 6 1.674 0 2-2 2-4 0-3-3-7-4-8" }), jsxRuntimeExports.jsx("path", { d: "M8 5c0-2.002 1-3 3-3h2.5a1.5 1.5 0 0 1 0 3H11M9 2L8 1m-1 9c0 2 1.333 3 4 3" })] }));
        case 'general':
            return (jsxRuntimeExports.jsxs("g", { fill: color, fillRule: "evenodd", children: [jsxRuntimeExports.jsx("path", { d: "M13.719 13.849a6.904 6.904 0 0 0 2.042-4.899c0-3.763-3.053-6.825-6.804-6.825C5.204 2.125 2.15 5.209 2.15 9s3.054 6.875 6.807 6.875h5.568l3.008.014.164-.001c.166.32.203.704.083 1.06-.184.556-.704.93-1.29.928H8.957C4.1 17.875.15 13.894.15 9 .15 4.106 4.1.125 8.957.125c4.854 0 8.804 3.959 8.804 8.825a8.947 8.947 0 0 1-1.508 4.958" }), jsxRuntimeExports.jsx("circle", { cx: "9", cy: "9", r: "1" }), jsxRuntimeExports.jsx("circle", { cx: "6", cy: "9", r: "1" }), jsxRuntimeExports.jsx("circle", { cx: "12", cy: "9", r: "1" })] }));
        case 'dermatology':
            return (jsxRuntimeExports.jsxs("g", { fill: color, fillRule: "evenodd", children: [jsxRuntimeExports.jsx("path", { d: "M9.224 10.549c-.642 0-1.125-.492-1.125-1.144 0-3 1.557-7.706 4.168-9.244a.254.254 0 0 1 .323.055c.083.096.09.236.017.339-1.48 2.064-2.263 6.432-2.263 8.844.001.666-.47 1.15-1.12 1.15z" }), jsxRuntimeExports.jsx("path", { d: "M17.596 6.457h-5.239a.417.417 0 0 0-.396.335c-.213 1.016-.33 2.25-.33 3.464 0 1.395-1.125 2.532-2.508 2.532a2.52 2.52 0 0 1-2.514-2.52c0-1.152.139-2.316.391-3.279a.432.432 0 0 0-.071-.362.419.419 0 0 0-.32-.17H.404c-.223 0-.404.207-.404.431v8.11c0 1.638 1.27 2.943 2.832 2.943l10.419.022v-2l-10.415-.022c-.463 0-.836-.422-.836-.943V8.457h2.708c-.066.594-.1 1.205-.1 1.812a4.522 4.522 0 0 0 4.514 4.52c2.485 0 4.508-2.033 4.508-4.532 0-.611.032-1.223.094-1.799H16v6.541c0 .491-.337.897-.749.95v2.011C16.773 17.912 18 16.606 18 14.998v-8.11c0-.224-.182-.431-.404-.431z" })] }));
        case 'mentalHealth':
            return (jsxRuntimeExports.jsx("path", { d: "M5.991 17.424c-.655-.104-1.179-.655-1.399-1.146a2.796 2.796 0 0 1-2.413-3.288A3.424 3.424 0 0 1 .81 10.268c0-.692.215-1.361.608-1.926A4.32 4.32 0 0 1 .81 6.125a4.36 4.36 0 0 1 2.935-4.104A3.853 3.853 0 0 1 9.005.527 3.883 3.883 0 0 1 10.869.05c1.43 0 2.71.766 3.388 1.99a4.356 4.356 0 0 1 2.934 4.104c0 .79-.212 1.553-.607 2.217.393.565.607 1.232.607 1.924a3.428 3.428 0 0 1-1.369 2.723 2.795 2.795 0 0 1-2.411 3.289 2.835 2.835 0 0 1-2.58 1.672H8V4.938h2v11.031h.83a.828.828 0 0 0 .825-.772l.078-1.188 1.156.281a.792.792 0 0 0 .188.026.792.792 0 0 0 .668-1.22l-.632-1.01 1.104-.447c.592-.239.974-.771.974-1.354 0-.418-.19-.806-.536-1.093l-.819-.678.728-.776c.405-.432.628-.998.628-1.594a2.343 2.343 0 0 0-1.848-2.285l-.527-.111-.196-.502a1.87 1.87 0 0 0-1.75-1.195c-.453 0-.875.155-1.22.449L9 3.051 8.353 2.5a1.893 1.893 0 0 0-1.219-.468c-.779 0-1.466.469-1.75 1.195l-.197.502-.528.112A2.343 2.343 0 0 0 2.81 6.125c0 .594.224 1.161.629 1.595l.725.777-.819.677a1.408 1.408 0 0 0-.535 1.094c0 .582.383 1.114.975 1.355l1.104.449-.634 1.009a.792.792 0 0 0 .668 1.216c.059 0 .117-.01.174-.025l.895-.207v3.359", fill: color, fillRule: "evenodd" }));
        case 'ophthalmology':
            return (jsxRuntimeExports.jsxs("g", { fill: "none", fillRule: "evenodd", stroke: color, children: [jsxRuntimeExports.jsx("path", { d: "M16.36 11.01l.076-.09a16.587 16.587 0 0 0-.524-.711l-.199.237c-1.04 1.221-2.033 1.98-2.684 2.403-1.315.854-2.656 1.288-3.989 1.288-2.539 0-5.057-1.57-7.49-4.666.3-.422.984-1.32 1.962-2.205.777-.703 1.584-1.262 2.4-1.661 1.004-.492 2.025-.742 3.035-.742 2.54 0 5.062 1.562 7.501 4.642.183.229.363.466.54.715.221-.299.341-.487.35-.5l.162-.257-.185-.24C14.645 5.756 11.83 4 8.947 4c-1.143 0-2.294.28-3.419.833-.89.437-1.764 1.045-2.601 1.805C1.509 7.927.696 9.201.662 9.254L.5 9.511l.184.24C3.345 13.235 6.157 15 9.04 15c1.498 0 2.995-.48 4.449-1.424 1.264-.822 2.258-1.848 2.87-2.565z", fill: color, fillRule: "nonzero" }), jsxRuntimeExports.jsx("path", { d: "M9.25 11.5a2 2 0 1 1 0-4 2 2 0 0 1 0 4z", strokeWidth: "2" })] }));
        case 'orthopedics':
            return (jsxRuntimeExports.jsx("path", { d: "M13.821 17.947h-2v-2.259l.107-.213a1.46 1.46 0 0 1 1.307-.802h.659c.242 0 .647 0 .647-.648 0-.511-.081-.648-.647-.648h-.652c-.556 0-1.052-.3-1.306-.782l-.115-.219v-5.33l.107-.212c.25-.496.751-.803 1.307-.803h.659c.526 0 .647-.121.647-.647 0-.119 0-.342-.075-.476-.085-.15-.396-.172-.572-.172h-.652c-1.031 0-1.223-1.013-1.404-2.584-.795.103-1.863.118-1.877.118H8.039c-.014 0-1.083-.015-1.877-.119-.182 1.571-.372 2.584-1.393 2.584h-.664c-.177 0-.487.022-.572.172-.075.134-.075.357-.075.465 0 .538.121.659.647.659h.66c.554 0 1.054.307 1.305.801l.108.214v5.33l-.114.218a1.46 1.46 0 0 1-1.296.784h-.663c-.567 0-.647.138-.647.648 0 .648.405.648.647.648h.66a1.46 1.46 0 0 1 1.305.8l.109.214v2.26h-2v-1.273h-.074c-1.819 0-2.647-1.373-2.647-2.648 0-1.634 1.015-2.648 2.647-2.648h.073V8.03h-.073c-1.633 0-2.647-1.014-2.647-2.647 0-.246 0-.87.336-1.462.249-.438.872-1.169 2.265-1.185.043-.255.097-.634.16-1.198l.011-.097C4.275.504 5.265-.189 6.18.131 6.432.197 7.568.27 8.039.27h1.922c.468 0 1.596-.072 1.865-.141.925-.313 1.897.379 1.943 1.312l.012.097c.063.564.116.943.159 1.198 1.394.016 2.018.747 2.266 1.185.336.592.336 1.217.336 1.452 0 1.644-1.015 2.658-2.647 2.658h-.073v3.347h.073c1.633 0 2.647 1.015 2.647 2.648 0 1.275-.828 2.648-2.647 2.648h-.073v1.273h-.001z", fill: color, fillRule: "evenodd" }));
        case 'pulmonology':
            return (jsxRuntimeExports.jsx("path", { d: "M5.972 2.764a1 1 0 0 1-.736 1.208C3.111 4.488 2 6.649 2 10.778c0 3.79 1.015 5.325 3.053 5.216A1 1 0 0 0 6 14.996V12a1 1 0 0 1 2 0v2.996a3 3 0 0 1-2.84 2.995C1.723 18.175 0 15.568 0 10.778c0-4.946 1.555-7.97 4.764-8.75a1 1 0 0 1 1.208.736zm7.264-.736c3.209.78 4.764 3.804 4.764 8.75 0 4.79-1.723 7.397-5.16 7.213A3 3 0 0 1 10 14.996V12a1 1 0 0 1 2 0v2.996a1 1 0 0 0 .947.998c2.038.11 3.053-1.426 3.053-5.216 0-4.129-1.111-6.29-3.236-6.806a1 1 0 0 1 .472-1.944zM9 0a1 1 0 0 1 1 1v5.494l2.74 1.354a1.031 1.031 0 0 1 .464 1.39 1.05 1.05 0 0 1-1.404.468L9.443 8.541a1 1 0 0 0-.886 0L6.2 9.706a1.051 1.051 0 0 1-1.404-.467 1.031 1.031 0 0 1 .463-1.39L8 6.493V1a1 1 0 0 1 1-1z", fill: color, fillRule: "evenodd" }));
        case 'somnology':
            return (jsxRuntimeExports.jsxs("g", { fill: "none", fillRule: "evenodd", children: [jsxRuntimeExports.jsx("path", { d: "M2.216 13.643c-1.163 0-2.11.946-2.11 2.11a2.11 2.11 0 0 0 4.219 0c0-1.164-.946-2.11-2.109-2.11zm-.194 2.11c0-.107.086-.195.194-.195.106 0 .194.088.194.195-.001.213-.388.212-.388 0z", fill: color, fillRule: "nonzero" }), jsxRuntimeExports.jsx("path", { d: "M12.432 12c-.01.029-.005.015 0 0z", fill: color }), jsxRuntimeExports.jsx("path", { d: "M12.554 1.584c-.689 0-1.347.134-1.981.393C9.73 1.165 8.645.698 7.458.698 4.947.698 3 2.742 3 5.254v.094C1 5.989.914 7.231.914 8.638c0 1.862 1.271 3.389 3.055 3.678.665 1.7 2.329 2.822 4.201 2.822 1.31 0 2.503-.512 3.332-1.452 0 0-.781-.098-2.177-.591-.103.104-.7.224-1.154.224a2.602 2.602 0 0 1-2.539-2.062l-.245-.797-.816.037a1.835 1.835 0 1 1-.483-3.605l.861-.233-.173-.878a2.643 2.643 0 0 1 2.588-3.168c.848 0 1.652.414 2.149 1.107l.515.718.757-.455a3.393 3.393 0 0 1 5.134 2.907 3.393 3.393 0 0 1-4.04 3.326l-1.014-.201-.125 1.025a2.62 2.62 0 0 1-.044.253l.005.002a7.683 7.683 0 0 1-.045.273c.563.282 1.775.432 1.775.432.01-.026.006-.014.001 0h.099c2.924 0 5.317-2.283 5.317-5.208 0-2.925-2.369-5.208-5.294-5.208z", fill: color })] }));
        case 'lab':
            return (jsxRuntimeExports.jsx("path", { d: "M18 17.918h-6.707l.623-1.405C14.95 9.671 9.905 5.894 9.689 5.736l-.817-.594 1.394-1.88-1.145-.921-5.36 6.599 1.135.914 3.117-3.69.762.624c1.607 1.315 2.579 3.194 2.734 5.291.006.111.098 2.165-.66 3.736a7.32 7.32 0 01-.945 1.562l-.3.379H0v-2h8.609a5.34 5.34 0 00.425-.779c.46-.957.501-2.325.479-2.774a5.49 5.49 0 00-1.299-3.176l-2.19 2.593a1.358 1.358 0 01-1.886.193l-2.134-1.719a1.355 1.355 0 01-.498-.915c-.04-.359.067-.719.295-.998L7.97.585c.224-.278.548-.456.908-.495a1.33 1.33 0 01.998.292l2.127 1.711A1.355 1.355 0 0112.2 4.01l-.576.776c1.506 1.479 4.544 5.345 2.661 11.132H18v2z", fill: color, fillRule: "nonzero" }));
        case 'allergology':
            return (jsxRuntimeExports.jsx("path", { clipRule: "evenodd", d: "M8.01938 4.11252L8.02255 4.11925L8.0372 4.14795L8.49711 4.97542C8.08378 5.28751 7.95248 5.8642 8.21081 6.33024L8.97387 7.66105C9.1895 8.04681 9.61142 8.24512 10.025 8.19445L10.2072 8.52402L10.6375 9.27005C9.98743 9.30638 9.27579 9.4335 8.49358 9.67025C8.45232 9.67956 8.38917 9.68717 8.28596 9.68596L8.22173 9.68423L8.19308 9.68292L8.12122 9.67847L8.04375 9.67221L7.95867 9.66398L7.86632 9.65384L7.7107 9.63468L7.27555 9.57659L7.13505 9.55929L7.04214 9.549L6.93034 9.53857L6.82164 9.53108C6.82164 9.53108 6.09891 9.48283 5.65547 9.58905C5.46348 9.63504 5.36956 9.70402 5.24508 9.79544C5.19864 9.82954 5.14788 9.86682 5.08625 9.90715C4.62624 10.2081 4.82675 10.9954 4.82675 10.9954C4.36624 10.52 4.17965 10.2847 3.98847 10.0436C3.77924 9.77973 3.56452 9.50894 2.97927 8.90901C2.55014 8.46305 1.90698 8.35877 1.65266 8.37153C1.29434 8.38949 0.947672 8.49106 0.710125 8.60934C0.314122 8.80651 0.121087 9.25447 0.0464661 9.60642C-0.0323196 9.97801 -0.0237449 10.4396 0.17303 10.8088L0.18905 10.838L0.220932 10.892L0.274063 10.9763L0.342958 11.08L0.422449 11.1958L0.512201 11.3237L0.646139 11.5109L0.833848 11.7684L0.997266 11.9893L1.61973 12.7878L1.79921 13.0243L2.06955 13.3764L2.33411 13.7157L2.50288 13.9291L2.66167 14.1271L2.7732 14.2641L2.87652 14.3889L2.97096 14.5006L3.05577 14.5981L3.13078 14.6809L3.17808 14.7302L3.18322 14.7354C3.20552 14.7578 3.23061 14.782 3.25662 14.8043C3.3342 14.8707 3.42924 14.9192 3.49879 14.9518L3.56442 14.9814L3.64265 15.0139L3.64758 15.0159C3.67406 15.0265 3.70152 15.0372 3.72983 15.048L3.81446 15.0794L3.81773 15.0805L3.86381 15.097L3.95761 15.1296L4.05976 15.1639L4.16709 15.1987L4.33644 15.2517L4.45645 15.2882L4.70591 15.3614L4.90418 15.4176L5.17772 15.4928L5.46127 15.5681L5.75143 15.6429L5.97206 15.6983L6.26651 15.7704L6.48734 15.823L6.70585 15.8738L6.99164 15.9384L7.26934 15.9988L7.53572 16.0544L7.72701 16.0925L7.9087 16.1271L8.02505 16.1483L8.18851 16.1765L8.34103 16.2006L8.43725 16.2144L8.52665 16.226L8.6105 16.2354L8.61514 16.2359L8.65559 16.2398L8.72632 16.2453L8.7332 16.2457C8.74578 16.2465 8.75825 16.2473 8.77059 16.2478L8.84148 16.2495L8.926 16.2485L9.02065 16.2452L9.12106 16.2398L9.22742 16.2326L9.33963 16.2236L9.51743 16.2072L9.70811 16.1872L9.90912 16.1642L10.1902 16.1292L10.4843 16.0898L10.8632 16.0355L11.0951 16.0005L11.2499 15.9765L11.4049 15.9519C11.5589 15.9272 11.7119 15.902 11.8617 15.8764L12.1521 15.8261L12.1983 15.8224L12.2751 15.8186L12.3806 15.815L12.5119 15.8119L12.8517 15.8073L13.4116 15.8047L14.1951 15.8061L14.1972 15.8061L15.2413 15.8126L16.6824 15.8136L17.9808 15.8291L18 14.2931L17.6463 14.2683L14.6581 14.2724L13.7827 14.2689L13.0631 14.2705L12.6981 14.2741L12.3661 14.2808L12.1727 14.2878L12.1151 14.2908L12.0434 14.2953L11.9715 14.3016L11.9115 14.309L11.6162 14.3603L11.6133 14.3608L11.3336 14.4075L11.3307 14.408L11.0462 14.4537L11.0429 14.4542L10.6846 14.5091L10.6815 14.5095L10.4713 14.5403L10.468 14.5408L10.1212 14.589L9.92319 14.6149L9.91997 14.6153L9.73003 14.6388L9.54877 14.6598L9.37975 14.6776L9.22498 14.6922L9.08585 14.7032L9.00464 14.7084L8.93233 14.7118L8.8684 14.7135L8.84857 14.7136L8.82419 14.713L8.79009 14.7108L8.77382 14.7094L8.72487 14.7042L8.63582 14.6928L8.57011 14.6832L8.45654 14.665L8.3313 14.6433L8.14609 14.6089L7.89012 14.5582L7.67041 14.5124L7.3205 14.4363L7.07667 14.3813L7.07389 14.3807L6.76485 14.309L6.76167 14.3083L6.38506 14.2181L6.38177 14.2173L6.03008 14.1304L6.02735 14.1298L5.79923 14.0719L5.79662 14.0713L5.51974 13.9994L5.51653 13.9985L5.25288 13.928L4.95828 13.8463L4.78061 13.7951L4.65928 13.7589L4.5128 13.7134L4.41772 13.6824L4.36353 13.6639L4.28993 13.6374L4.27401 13.6314L4.2401 13.6178L4.23408 13.6152L4.22478 13.6053L4.18267 13.5584L4.11021 13.4744L4.02312 13.3702L3.89636 13.215L3.7235 12.9991L3.4673 12.6731L3.12401 12.2285L2.39749 11.2972L2.13628 10.9473L1.93053 10.6671L1.75516 10.4233L1.65428 10.2792C1.55079 10.1265 1.54787 9.95666 1.77036 9.89804C1.96791 9.846 2.0118 9.88869 2.15003 10.0231L2.15791 10.0308C2.40077 10.278 2.62641 10.5415 2.85202 10.8049C3.14936 11.1521 3.44666 11.4992 3.78323 11.809L3.8463 11.8654C3.90937 11.9221 3.92022 11.9319 4.06699 12.0518C4.16243 12.1266 4.251 12.1958 4.35604 12.2576C4.6278 12.4175 4.8978 12.5319 5.21291 12.5616L5.35601 12.5734L5.45875 12.5808L5.61965 12.5912L5.79246 12.6008L6.02262 12.6117L6.15774 12.6815L6.20859 12.6996C6.52836 12.8129 6.98124 12.9062 7.49451 12.9669L7.86936 13.008L8.3852 13.0727L8.97342 13.2724C9.94472 13.7952 10.7181 12.7552 9.79437 12.2436L9.58901 12.129L9.49285 12.0769L9.48795 12.0744C9.44701 12.0528 9.37722 12.0165 9.31364 11.9953C9.16911 11.9469 9.0259 11.8946 8.88271 11.8422L8.76259 11.7984L7.88964 11.6041L7.88773 11.6039C7.71047 11.5857 7.53402 11.561 7.35819 11.5323C7.25799 11.5141 7.15942 11.509 7.057 11.5037C6.98235 11.4999 6.90562 11.4959 6.82476 11.4867C6.82476 11.4867 6.27593 11.4257 6.36645 11.1011C6.40864 10.9096 6.56693 10.9371 6.685 10.9577C6.71345 10.9626 6.73956 10.9672 6.76115 10.9681L6.98396 10.9843L7.19218 11.0116C7.33886 11.031 7.4858 11.0503 7.6326 11.0687L7.87627 11.0965L7.87956 11.0968C7.93825 11.1027 7.99501 11.1078 8.05004 11.1118C8.13576 11.1172 8.22129 11.1213 8.30714 11.1235C8.51925 11.1258 8.75504 11.121 8.96112 11.0692L8.97199 11.0664L8.98271 11.0632C9.87653 10.7918 10.5434 10.7801 11.1634 10.7965L11.6973 10.8306C11.7469 10.9171 11.7983 11.0089 11.8517 11.1042C12.4924 12.2479 13.4214 13.9061 15.0569 13.1203C15.6322 12.8441 15.8738 12.0272 15.8263 11.559L16.3881 11.5421L16.3926 11.5421L17.9025 11.5338L17.8993 9.99789L16.2366 10.0073L15.7991 10.0122L15.309 10.0033L14.9965 9.47296L13.3472 6.40648C13.6706 6.08153 13.7553 5.57009 13.5219 5.14898L12.7588 3.81815C12.4864 3.33079 11.8847 3.14263 11.3865 3.37777L10.9506 2.57514L10.9459 2.56724C10.4901 1.80204 9.52258 1.52858 8.74048 1.94443C7.96041 2.3592 7.64313 3.31317 8.01938 4.11252ZM10.1134 4.0749L9.69432 3.29326C9.63551 3.2021 9.51623 3.17056 9.41971 3.22188C9.32543 3.27201 9.28446 3.38461 9.32248 3.48252L9.75984 4.26912L10.1134 4.0749ZM12.1192 7.12975L11.3265 7.56521L11.4652 7.80925L11.4667 7.81187L13.4815 11.3047C13.4815 11.3047 13.9003 11.8555 14.1595 11.6936C14.5892 11.425 14.2552 10.8379 14.2552 10.8379L12.1192 7.12975ZM11.6782 4.80382L9.56882 5.93868L10.0284 6.74011C10.208 6.66699 10.4475 6.54284 10.7082 6.39528C10.8262 6.3285 10.9921 6.2366 11.1712 6.13746C11.5349 5.93602 11.9526 5.70472 12.1312 5.59373L11.6782 4.80382Z", fill: "#322A24", fillRule: "evenodd" }));
        case 'homeconsultation':
            return null;
        case 'corona':
            return null;
        case 'digitalconsultation':
            return null;
        case 'audiology':
            return (jsxRuntimeExports.jsxs("g", { children: [jsxRuntimeExports.jsx("path", { clipRule: "evenodd", d: "M13.4936 0.265991L13.8748 0.520086C14.5675 0.981901 15.0063 1.51132 15.3715 2.24185C15.7229 2.94453 15.9951 3.60885 15.9951 4.45006V4.94504L14.3225 4.93468V4.44579C14.3225 3.83066 14.0785 3.34935 13.8548 2.90183C13.6491 2.49048 13.4157 2.32935 13.0045 2.0455C12.9558 2.01184 12.9045 1.97646 12.8505 1.93873L12.4268 1.64271L13.4936 0.265991ZM6.40159 13.1786L6.40158 11.5061H6.89351C7.32692 11.5061 7.51963 11.4291 7.62929 11.3304C7.74487 11.2263 7.86947 11.0072 7.94369 10.4809L8.00313 10.0595L9.74009 10.0523L9.68918 10.5926C9.61217 11.4098 9.32738 12.0744 8.81588 12.5311C8.30599 12.9864 7.634 13.1786 6.89351 13.1786H6.40159ZM9.7577 7.12158L9.33997 6.97434C8.63656 6.72639 8.06703 6.71254 7.6608 6.91828C7.2759 7.11321 6.89698 7.57943 6.73729 8.63372L6.67434 9.04932L4.95114 9.06018L4.99887 8.52145C5.13352 7.00136 5.74465 5.93437 6.71819 5.39952C7.67605 4.87328 8.85982 4.93229 10.0023 5.38275L10.4923 5.57591L9.7577 7.12158Z", fill: color, fillRule: "evenodd" }), jsxRuntimeExports.jsx("path", { clipRule: "evenodd", d: "M6.27623 2.24099L6.28355 2.23904C7.13145 2.01405 7.62925 1.89462 8.95948 1.89462C10.0198 1.89462 10.9987 2.32534 11.362 2.56756C11.3741 2.57563 11.3893 2.5854 11.4072 2.59695C11.5974 2.71937 12.0991 3.04228 12.5584 3.66921C13.0652 4.36106 13.5045 5.39673 13.5045 6.90755C13.5045 8.03611 13.4883 8.85976 13.3555 9.59516C13.2195 10.3482 12.9652 10.9909 12.5196 11.7787C12.3267 12.1199 12.1608 12.5218 11.9915 12.9792C11.9251 13.1588 11.8552 13.3556 11.7826 13.5597C11.6795 13.8499 11.5711 14.155 11.46 14.4464C11.0692 15.4714 10.5561 16.5803 9.65668 17.5319C9.45474 17.7588 9.16527 17.9154 8.92479 18.0166C8.67296 18.1225 8.40565 18.1961 8.20109 18.2227L8.19495 18.2235L8.18546 18.2246C7.98771 18.2478 7.84237 18.2649 7.66978 18.2659C7.49889 18.2669 7.30911 18.2523 7.01021 18.2248C6.59224 18.1863 6.19747 17.9806 5.86046 17.7249C5.51767 17.4649 5.19761 17.1251 4.92421 16.7594C4.39303 16.0487 3.96234 15.1349 3.96234 14.3897V13.8978H5.67793V14.3897C5.67793 14.4979 5.71608 14.687 5.81512 14.9338C5.91089 15.1725 6.05091 15.4335 6.22214 15.6777C6.58557 16.196 6.99956 16.5155 7.3281 16.5584C7.48781 16.5793 7.6565 16.5817 7.79349 16.5748C7.86152 16.5713 7.91634 16.5657 7.95355 16.5604C7.95888 16.5596 7.96352 16.5589 7.9675 16.5582C8.74859 16.1884 9.2042 15.4203 9.5921 14.4114C9.72006 14.0786 9.83213 13.7444 9.94717 13.4014C10.0099 13.2145 10.0734 13.0249 10.1409 12.8315C10.3262 12.3009 10.5349 11.7615 10.8122 11.2879C11.2991 10.4566 11.5178 9.90177 11.6252 9.30908C11.7337 8.71045 11.7336 8.05499 11.7336 6.99487C11.7336 6.96607 11.7336 6.93696 11.7336 6.90755C11.7336 4.96469 10.5534 4.18422 10.1896 4.01165C9.96556 3.90537 9.64587 3.75391 9.12438 3.69081C8.60185 3.62758 7.85041 3.65072 6.78 3.93889C4.59933 4.82244 3.82946 6.22572 3.82946 7.1952V10.5472L3.83002 10.5573C3.83085 10.5709 3.83236 10.5922 3.83492 10.6194C3.84009 10.6743 3.8493 10.7504 3.86515 10.8343C3.90046 11.0213 3.95508 11.1705 4.01174 11.243L4.63302 12.0379H2.60448L2.45688 11.8581C2.35388 11.7327 2.2873 11.5776 2.24416 11.46C2.19724 11.332 2.15988 11.1963 2.13132 11.0778C2.10243 10.958 2.0806 10.8476 2.06602 10.7675C2.05868 10.7273 2.05307 10.6941 2.04924 10.6706L2.04479 10.6427L2.04355 10.6347L2.04318 10.6322L2.04302 10.6311L2.03828 10.5832L2.03803 10.5781L2.03739 10.5644L2.03509 10.5123C2.03316 10.4668 2.03052 10.4002 2.02759 10.3147C2.02173 10.1436 2.01473 9.8964 2.01006 9.59011C2.00074 8.97787 2.00073 8.12777 2.03805 7.17593C2.12058 5.07122 3.44034 3.08785 6.26896 2.24316L6.27623 2.24099ZM2.04302 10.6311L2.03947 10.6072L2.03828 10.5832L2.04302 10.6311ZM7.9877 16.5544L7.98554 16.5549Z", fill: color, fillRule: "evenodd" })] }));
        case 'radiology':
            return (jsxRuntimeExports.jsxs("g", { children: [jsxRuntimeExports.jsx("path", { clipRule: "evenodd", d: "M10.2969 6.19059C10.4478 6.19058 10.6245 6.19057 10.8331 6.19057C11.2171 6.19057 11.4678 6.66804 11.5698 6.89539L13.3663 6.87905C13.1807 5.59121 12.0701 4.64078 10.7673 4.64078H10.6829C11.259 4.15917 11.6255 3.43513 11.6255 2.62549C11.6255 1.17547 10.45 0 9.00002 0C7.55001 0 6.37454 1.17547 6.37454 2.62549C6.37454 3.43513 6.74101 4.15917 7.31714 4.64078H7.23275C5.92995 4.64078 4.81935 5.59121 4.63379 6.87905L6.43795 6.88932C6.54825 6.61144 6.76667 6.1875 7.17878 6.1875C7.58297 6.1875 7.77003 6.18738 7.94652 6.18727C7.98758 6.18725 8.02807 6.18722 8.07059 6.1872C8.49957 6.18697 8.59098 6.18692 8.94343 6.18853L9.26177 6.18996C9.44473 6.19061 9.5679 6.19061 10.2969 6.19059ZM8.10485 2.62552C8.10485 2.13117 8.5056 1.73042 8.99995 1.73042C9.4943 1.73042 9.89506 2.13117 9.89506 2.62552C9.89506 3.11987 9.4943 3.52063 8.99995 3.52063C8.5056 3.52063 8.10485 3.11987 8.10485 2.62552Z", fill: color, fillRule: "evenodd" }), jsxRuntimeExports.jsx("path", { d: "M9.63638 11.1413C9.72948 11.1257 9.82762 11.1058 9.92774 11.0826C10.1984 11.0196 10.4419 10.9414 10.5786 10.8867L11.1696 10.6504L11.6422 11.8323L11.0513 12.0686C10.8441 12.1514 10.5373 12.2477 10.216 12.3224C10.0352 12.3644 9.83568 12.403 9.63638 12.4273L9.63638 13.2661C10.1669 13.208 10.7583 13.0366 11.1592 12.8798L11.7433 12.6512L12.2324 13.8316L11.6354 14.0652C11.1514 14.2546 10.3745 14.4869 9.63638 14.5452V15.267H8.36348V14.5452C7.6254 14.4869 6.84852 14.2546 6.36451 14.0652L5.76745 13.8316L6.25661 12.6512L6.84068 12.8798C7.24155 13.0366 7.83298 13.208 8.36348 13.2661L8.36348 12.4273C8.16412 12.403 7.96455 12.3644 7.7837 12.3224C7.46237 12.2477 7.15561 12.1514 6.9484 12.0686L6.35746 11.8323L6.83011 10.6504L7.42105 10.8867C7.55775 10.9414 7.80126 11.0196 8.07196 11.0826C8.17213 11.1058 8.27033 11.1257 8.36348 11.1413V10.3669H9.63638V11.1413Z", fill: color }), jsxRuntimeExports.jsx("path", { clipRule: "evenodd", d: "M3.0268 7.69312C2.294 7.69312 1.69995 8.28717 1.69995 9.01997V16.6732C1.69995 17.406 2.294 18.0001 3.0268 18.0001H14.9732C15.706 18.0001 16.3001 17.406 16.3001 16.6732V9.01997C16.3001 8.28717 15.706 7.69312 14.9732 7.69312H3.0268ZM3.22325 9.37772H14.7766V16.3155H3.22325V9.37772Z", fill: color, fillRule: "evenodd" })] }));
        case 'neurology':
            return (jsxRuntimeExports.jsx("path", { d: "M5.991 17.424c-.655-.104-1.179-.655-1.399-1.146a2.796 2.796 0 0 1-2.413-3.288A3.424 3.424 0 0 1 .81 10.268c0-.692.215-1.361.608-1.926A4.32 4.32 0 0 1 .81 6.125a4.36 4.36 0 0 1 2.935-4.104A3.853 3.853 0 0 1 9.005.527 3.883 3.883 0 0 1 10.869.05c1.43 0 2.71.766 3.388 1.99a4.356 4.356 0 0 1 2.934 4.104c0 .79-.212 1.553-.607 2.217.393.565.607 1.232.607 1.924a3.428 3.428 0 0 1-1.369 2.723 2.795 2.795 0 0 1-2.411 3.289 2.835 2.835 0 0 1-2.58 1.672H8V4.938h2v11.031h.83a.828.828 0 0 0 .825-.772l.078-1.188 1.156.281a.792.792 0 0 0 .188.026.792.792 0 0 0 .668-1.22l-.632-1.01 1.104-.447c.592-.239.974-.771.974-1.354 0-.418-.19-.806-.536-1.093l-.819-.678.728-.776c.405-.432.628-.998.628-1.594a2.343 2.343 0 0 0-1.848-2.285l-.527-.111-.196-.502a1.87 1.87 0 0 0-1.75-1.195c-.453 0-.875.155-1.22.449L9 3.051 8.353 2.5a1.893 1.893 0 0 0-1.219-.468c-.779 0-1.466.469-1.75 1.195l-.197.502-.528.112A2.343 2.343 0 0 0 2.81 6.125c0 .594.224 1.161.629 1.595l.725.777-.819.677a1.408 1.408 0 0 0-.535 1.094c0 .582.383 1.114.975 1.355l1.104.449-.634 1.009a.792.792 0 0 0 .668 1.216c.059 0 .117-.01.174-.025l.895-.207v3.359", fill: color, fillRule: "evenodd" }));
        default:
            return null;
    }
}
function getLargeIcon(icon, primaryColor, secondaryColor) {
    switch (icon) {
        case 'allergology':
            return (jsxRuntimeExports.jsx("g", { fill: "none", fillRule: "evenodd", stroke: "none", strokeWidth: "1", children: jsxRuntimeExports.jsx("g", { id: "Icons", transform: "translate(-366.000000, -1539.000000)", children: jsxRuntimeExports.jsxs("g", { id: "Group", transform: "translate(366.858132, 1537.646510)", children: [jsxRuntimeExports.jsxs("g", { fill: secondaryColor, fillRule: "nonzero", id: "Group-27", transform: "translate(45.029335, 51.822945) scale(-1, 1) translate(-45.029335, -51.822945) translate(0.000000, 32.645890)", children: [jsxRuntimeExports.jsx("path", { d: "M57.5259582,8.92999382 C58.0242597,9.05477281 58.6069434,9.11039039 59.3489305,9.10053276 L59.7335462,9.09016474 C59.799977,9.08753305 59.8676007,9.08445093 59.9364608,9.08092053 L60.3648045,9.05437569 L60.8249016,9.01717431 L61.3188332,8.96941877 L61.8486805,8.91121147 L62.715346,8.80452746 L65.0715369,8.49013406 L65.8023267,8.40036641 L66.2711799,8.3488018 L66.8294437,8.2973506 L67.3555991,8.26142905 L67.6217446,8.24784519 C71.4575903,8.07160218 73.9748474,8.89264855 75.0823411,11.0413132 C76.0942871,13.0046045 75.8289898,14.9538384 74.4233201,16.9104028 C73.9181088,17.5905848 73.4348574,18.1201314 72.9186417,18.5601154 C72.4883691,18.9268478 72.0575493,19.2172094 71.5158041,19.5201417 L71.205433,19.6885808 L69.7642758,20.4337501 L69.6516762,20.4736516 C68.174177,20.9972271 65.9387006,21.4713394 63.2682781,21.7869585 L61.257671,22.0071764 L59.7966668,22.1830022 L58.4264072,22.3627631 L57.4439103,22.5024502 L56.8142555,22.600003 L56.4574893,22.6613501 L56.2833027,22.6953579 L56.1413642,22.730468 L56.0952966,22.7537594 L54.9537186,23.410965 L54.3794304,23.7312572 L53.9321802,23.9714741 L53.4919811,24.1967041 L53.2118647,24.3318716 C53.1210586,24.3743743 53.0331329,24.4141019 52.9490308,24.4503884 C51.9902855,24.8640466 50.9149117,25.2166213 49.6689582,25.5085075 L49.2472485,25.6035557 L48.5544563,22.4070952 C49.7778112,22.1419485 50.7851374,21.8218984 51.6533292,21.4473103 L51.7748043,21.3926149 L52.0580379,21.2535136 L52.5597736,20.9877314 L52.9269917,20.7857926 L54.0459762,20.1617663 L54.5365999,19.8960935 C54.7845037,19.7656523 54.9846815,19.6685654 55.1040456,19.6286474 C55.1674818,19.6074329 55.2311365,19.5879734 55.2951669,19.5702989 L55.4426468,19.5338768 L55.7494261,19.4709659 L56.0059965,19.424195 L56.6286658,19.321184 L57.5770914,19.1795324 L58.2163361,19.0904995 L59.1266042,18.9703768 L60.3190762,18.8232631 L61.271118,18.7139664 L62.1203134,18.6232147 C62.7266377,18.5609505 63.309606,18.490207 63.864639,18.4126805 L64.5169767,18.3165015 L65.1407381,18.2144621 L65.7341649,18.107214 C66.1192804,18.0341236 66.4830004,17.957995 66.8229805,17.8796966 L67.3148526,17.7607301 C67.6305065,17.6804791 67.9212481,17.5984925 68.1847329,17.5156389 L68.4560762,17.4258724 L69.7322907,16.7678245 C70.20058,16.5170095 70.506194,16.3188087 70.7970345,16.0709179 C71.1142861,15.8005162 71.4325979,15.4517103 71.7823025,14.9812405 C72.4959308,13.9877539 72.5848215,13.3346425 72.1751271,12.5397885 C71.8209672,11.8526777 70.555102,11.4207409 68.0368519,11.5045536 L67.5391908,11.5270387 L67.0705581,11.5596359 L66.6946131,11.5938069 L66.2771302,11.6383483 L65.4387542,11.7406069 L63.4570782,12.0057875 C63.2161486,12.0379392 62.9831674,12.0681528 62.7575689,12.0963603 L62.1023565,12.174897 L61.4880472,12.2409901 C61.1905528,12.2708578 60.9071246,12.2959063 60.6358536,12.3159064 L60.1089559,12.3491075 C60.0236527,12.3534965 59.9395589,12.3573076 59.8566038,12.3605322 L59.3719725,12.3727756 C58.3490936,12.3837619 57.4947619,12.2927762 56.6536537,12.0811657 C51.63249,10.5567747 47.391007,9.98591688 43.7375378,10.0826357 L45.5078688,6.81553312 C49.0573618,6.91616813 53.0386488,7.56610171 57.5259582,8.92999382 Z M0.023831322,10.7874983 L16.4765381,10.8318054 L17.4462854,10.8482162 L18.3823884,10.8566993 C18.5355984,10.8574538 18.6874039,10.8578789 18.8378037,10.8579751 L19.7233229,10.8546094 L20.575041,10.8433729 C20.7141738,10.8408456 20.8518956,10.8379912 20.9882051,10.8348103 L21.7891043,10.8118105 L22.3930739,10.7875331 L20.6610739,14.1115331 L20.2513586,14.1197102 L19.3410086,14.127826 L18.3972038,14.1275283 C18.2371117,14.1267789 18.075623,14.1256798 17.9127364,14.1242315 L15.6736187,14.0970073 L0.0170738502,14.0581672 L0.023831322,10.7874983 Z", id: "Combined-Shape" }), jsxRuntimeExports.jsx("path", { d: "M73.8539398,0.609928535 C75.656693,-0.165148223 77.3242694,-0.249055206 79.0202693,0.634283971 C79.5772748,0.924392919 80.4661536,1.62325879 80.9049251,2.25998462 L80.997834,2.40560394 L78.3152147,3.9733685 C78.3081253,3.96123781 78.2836955,3.93643397 78.2476976,3.9035666 L78.1107719,3.78538351 L77.9390714,3.64647687 L77.7672301,3.51450436 C77.6870466,3.45486124 77.619798,3.40819005 77.5849659,3.3900482 C76.8191079,2.99116119 76.0975232,3.02746897 75.081204,3.46442585 C74.6115957,3.66632952 74.0338358,4.03009618 73.3854009,4.52282548 L72.9881588,4.83367538 C72.7855971,4.99657488 72.5773492,5.17048882 72.364427,5.35452887 L71.9326499,5.73584727 C71.5681417,6.06442518 71.1925232,6.41948619 70.8104788,6.79691774 L70.349241,7.26031027 L69.8836333,7.74359932 C69.8057678,7.8257178 69.7277952,7.9085995 69.6497529,7.99221152 L69.1809633,8.5023843 C69.1027923,8.588786 69.0246266,8.67585222 68.9465037,8.76355006 L68.4785796,9.29705334 L68.0134811,9.84413625 C67.9363,9.93636064 67.8593117,10.029085 67.7825535,10.1222766 L67.553007,10.4032196 L65.1391257,8.44681739 C66.0069518,7.37606154 66.9051148,6.35703476 67.7983438,5.42483919 L68.3334069,4.8762224 C70.3800493,2.8152867 72.3632741,1.25082616 73.8539398,0.609928535 Z", id: "Path-13-Copy" }), jsxRuntimeExports.jsx("path", { d: "M86.2388752,2.0973893 C87.8229886,3.34533322 88.2143456,5.28944005 87.5684552,7.64140739 L87.5004144,7.87795299 L84.524731,6.98372673 C84.9309834,5.63185571 84.8042416,4.92269238 84.3160894,4.53813245 C83.6069662,3.97949438 82.8817993,4.05820875 81.2788764,4.87114596 L81.0169239,5.00774655 L80.871498,5.09547115 L80.7065236,5.20536269 L80.5221571,5.33731864 L80.3185546,5.49123647 L79.9774253,5.76306742 L79.5938942,6.08373581 L79.0174725,6.5866649 L78.5370546,7.01994153 L78.0159929,7.50090207 L77.4548146,8.02920045 L76.8540473,8.60449061 L75.9923525,9.44404435 L75.0624649,10.3657035 L74.0656343,11.3686478 L71.8543689,9.18584283 L72.923778,8.10976972 L73.9188788,7.1238304 L74.6171914,6.44303275 L75.0601629,6.01690721 L75.6911554,5.41907193 L76.089735,5.04793422 L76.4708314,4.69861219 L77.0100367,4.21530926 L77.3481086,3.92007786 L77.6692441,3.64630326 L77.9735996,3.39388293 L78.2613312,3.16271434 L78.5325953,2.95269495 C78.5764424,2.91944845 78.6196098,2.8870789 78.6621009,2.85558416 L78.9089566,2.6770963 L79.1397355,2.5195013 C79.1768675,2.49497085 79.2133363,2.47130665 79.2491449,2.44850658 L79.4561014,2.32205861 L79.6473716,2.21624715 C82.3672025,0.800183216 84.2492271,0.529970302 86.2388752,2.0973893 Z", id: "Path-14-Copy" }), jsxRuntimeExports.jsx("path", { d: "M87.3839067,6.20602939 C89.5780704,7.29850787 90.8712601,10.2146173 89.4854364,12.81483 L89.4330593,12.9100604 L89.3002479,13.1353014 L89.0345044,13.5553407 L88.6947153,14.0663578 L88.2873904,14.6597622 L87.8190395,15.3269637 L87.1108934,16.3165137 L86.112927,17.6854475 L85.2431326,18.8613751 L83.8555704,20.7121771 L82.8977847,21.9742905 L81.4505654,23.8589232 L80.0369885,25.6722244 L79.1390115,26.8075263 L78.2945625,27.8602197 L77.705636,28.5832789 L77.1620083,29.2398268 L76.6701891,29.8212731 L76.2366882,30.3190275 L75.8680152,30.7244998 L75.6614633,30.9393046 C75.5664353,31.0350747 75.4840201,31.1130783 75.4153028,31.1718836 C75.2692188,31.2968959 75.0179317,31.4412687 74.6758025,31.6015566 L74.3606367,31.7427634 L74.0029866,31.8912833 C73.8769124,31.9419552 73.7440925,31.9937655 73.6048617,32.046634 L73.1682719,32.2083334 C73.0924132,32.2357856 73.0150354,32.2634822 72.9361806,32.2914133 L72.4456615,32.4617317 L71.9217016,32.6371936 L71.3663107,32.8173167 L70.4786873,33.0951864 L69.8535112,33.2848531 L68.5319776,33.6726255 L67.4864567,33.9689405 L66.0328302,34.3682476 L64.5258289,34.7688423 L62.9815304,35.1668675 L61.8085019,35.4613799 L60.23762,35.8456271 L59.0631181,36.1253763 L57.8992893,36.3960864 L56.3758435,36.7401597 L54.8995079,37.0614135 L53.4863603,37.3559905 L52.4776384,37.5570963 L51.520286,37.7393995 L50.9139393,37.8496856 L50.0572757,37.9970352 L49.270069,38.1212428 L48.7872013,38.1903878 L48.3402275,38.2480421 L47.9311575,38.2937236 C47.8662494,38.3003127 47.8030044,38.3063828 47.7414644,38.3119239 L47.3930181,38.3387423 C47.3384652,38.3421272 47.285701,38.3449631 47.2347673,38.3472398 L46.9514666,38.3541101 L46.543654,38.3485411 L46.0901206,38.332145 L45.5935304,38.3053882 L45.0565472,38.2687369 L44.481835,38.2226574 L43.5548525,38.1368807 L42.5579647,38.0325138 L41.5001626,37.9111306 L40.0105439,37.7255369 L38.4499286,37.5162205 L36.4317876,37.2268987 L35.2009552,37.0413428 L34.3776386,36.9136259 L33.5552207,36.7832426 C32.73414,36.6516816 31.9184034,36.5168206 31.1199985,36.3807581 L29.5030738,36.1001815 L29.3845166,36.0858042 L29.0476804,36.0593197 L28.5784518,36.0358774 L27.9775146,36.0154958 L27.245553,35.9981934 L25.3912919,35.9729002 L22.3486358,35.9589336 L18.1183286,35.9663989 L12.4841206,36.0016494 L4.5496245,36.0790987 L0.0409051722,36.132716 L0,32.8622959 L9.40161233,32.7569631 L15.6370152,32.7070021 L20.3645054,32.6884197 L24.2249282,32.6966514 L26.1706788,32.71616 L27.9325261,32.7521656 L28.9336099,32.7888481 L29.2067308,32.8029309 L29.5599056,32.825802 L29.8455177,32.850776 L30.0638433,32.8778605 L31.6102135,33.1462706 L33.14766,33.4031582 L34.7130064,33.6544647 L36.6768606,33.9553302 L37.8432129,34.1261056 L39.7386989,34.3896745 L40.8324604,34.5327362 L41.8827221,34.662654 L42.880605,34.7779273 L43.8172301,34.8770553 L44.6837184,34.9585375 L45.4711908,35.0208731 L45.94789,35.0510521 L46.382894,35.0716099 L46.773572,35.0821018 C46.834845,35.082987 46.8941615,35.0834342 46.9514666,35.0834342 L47.1714033,35.0777478 L47.4290188,35.0609499 C47.4750063,35.0572461 47.5224977,35.0530956 47.5714597,35.0485066 L47.8826152,35.0157766 L48.4120546,34.9478077 L48.8045021,34.8904841 L49.4484345,34.7874625 L50.1539154,34.6651735 L51.1810339,34.4744366 L52.5860452,34.1959323 L53.7914591,33.9448845 L55.7054745,33.5285894 L57.0335513,33.2291505 L58.7298869,32.8357175 L60.7928997,32.3419121 L62.7192688,31.8659295 L63.9765286,31.5471831 L65.4989058,31.151797 L66.9470836,30.7646183 L68.557483,30.3181115 L69.5371172,30.0355477 L70.2148923,29.8334367 L71.0340624,29.5791594 L71.579182,29.4013011 L71.9071033,29.2894677 L72.3423988,29.1326524 C72.3868529,29.115992 72.4299752,29.0995928 72.4717377,29.083462 L72.7057716,28.9899509 L72.9058305,28.9032085 L73.0705748,28.8235655 L73.198665,28.7513524 C73.2351039,28.7285565 73.2652105,28.707054 73.2887615,28.6869 L73.391864,28.5922785 L73.518406,28.4651379 L73.6673428,28.3068541 L73.9304528,28.0140444 L74.3498972,27.5274712 L74.8401157,26.9410901 L75.5396821,26.0845269 L76.4849111,24.9037669 L77.8783537,23.1309761 L79.7401016,20.7198845 L81.7099504,18.1239836 L83.1284929,16.2237139 L84.2494457,14.6974755 L85.2104866,13.3613974 L85.7738397,12.5566666 L86.1379268,12.0194162 L86.3549078,11.6859592 L86.5198376,11.417297 C86.55044,11.3651431 86.5769214,11.3181381 86.5991051,11.2765149 C87.0353935,10.4579097 86.5961729,9.46747847 85.9261321,9.13386381 C85.2621494,8.80326552 84.3865926,8.9865093 82.9651731,10.2252222 L82.6392671,10.5163302 L82.276906,10.8530808 L81.8831947,11.2305554 L81.4632379,11.6438356 L81.0221403,12.0880029 L80.5650068,12.5581387 L80.0969422,13.0493246 L79.6230511,13.5566419 L79.1484385,14.0751723 L78.678209,14.5999972 C78.6004863,14.6877194 78.5231589,14.7754988 78.4463332,14.8632331 L77.99225,15.3882776 C77.7255444,15.7006938 77.446259,16.0136787 77.1596276,16.3232108 L76.7248253,16.7844165 C76.6516581,16.8606849 76.5781953,16.9366119 76.5045187,17.0121346 L76.060548,17.4599159 L75.6153716,17.8949776 C75.4672147,18.037543 75.3195111,18.1774858 75.172915,18.3143032 L74.7371035,18.7148767 L74.3118625,19.0936819 C74.1025388,19.2771398 73.898651,19.4513034 73.7024072,19.6144763 L73.3207657,19.9256649 L72.9634334,20.2045285 L72.6343356,20.4480511 C72.4252209,20.5979488 72.2375461,20.7222749 72.0765451,20.817008 C71.8695233,20.9388197 71.5906653,21.0487998 71.2340014,21.1485185 L70.9846332,21.2134946 L70.7118182,21.2755337 L70.4151635,21.3347392 L70.0942759,21.3912143 L69.7487625,21.4450626 L69.37823,21.4963874 L68.9822854,21.545292 L68.3398611,21.6143374 L67.8786667,21.657644 L67.136525,21.7187769 L66.607624,21.7571316 L65.7620798,21.8113213 L64.8527254,21.8618102 L63.5386994,21.9239752 L61.7285338,21.994562 L61.6133827,18.7259137 L63.2020096,18.6631352 L64.9241809,18.5777463 L65.9554365,18.5161031 L67.1071521,18.4352907 L67.9145591,18.3687079 L68.4514363,18.3182213 L68.9278764,18.2676768 L69.3424663,18.2174459 L69.693793,18.1679005 L69.9804432,18.119412 L70.1349142,18.0878572 L70.2595933,18.0570474 C70.3326891,18.0367804 70.3856445,18.0170835 70.4179013,17.9981036 L70.537743,17.9209497 L70.7006962,17.8055471 L70.9011871,17.6557699 L71.2601134,17.3751265 L71.5300622,17.1563621 L71.8180398,16.9167826 L72.1184723,16.660262 C72.1692726,16.616312 72.2203596,16.5718176 72.2716172,16.5268594 C73.3938058,15.5425847 74.5130365,14.4263636 75.5047246,13.2647102 L75.7430973,12.9873154 L76.2305425,12.4305973 L76.7280119,11.8754086 L77.2304146,11.3266701 L77.7326602,10.7893025 L78.229658,10.2682268 L78.7163172,9.76836387 L79.1875474,9.29463445 C79.2645171,9.21813072 79.3406319,9.14292093 79.4157857,9.06910758 L79.8543271,8.64380507 L80.2647128,8.25693822 C80.3304813,8.19593677 80.3948645,8.13674183 80.4577564,8.07945594 L80.8163634,7.75946916 C83.169375,5.70890926 85.4336929,5.23501406 87.3839067,6.20602939 Z", id: "Path-15-Copy" })] }), jsxRuntimeExports.jsx("circle", { cx: "75.7207914", cy: "56.1675351", fill: primaryColor, id: "Oval-Copy-16", r: "2.28947317", transform: "translate(75.720791, 56.167535) scale(-1, 1) translate(-75.720791, -56.167535) " }), jsxRuntimeExports.jsx("circle", { cx: "85.6739085", cy: "56.1675351", fill: primaryColor, id: "Oval-Copy-18", r: "2.28947317", transform: "translate(85.673909, 56.167535) scale(-1, 1) translate(-85.673909, -56.167535) " }), jsxRuntimeExports.jsx("polygon", { fill: primaryColor, fillRule: "nonzero", id: "Path-2", points: "46.672187 31.9110265 50.6861762 31.9984074 50.6254228 34.7892145 46.6114336 34.7018335" }), jsxRuntimeExports.jsx("polygon", { fill: primaryColor, fillRule: "nonzero", id: "Path-2", points: "49.6956292 37.2197011 53.7096184 37.307082 53.648865 40.0978891 49.6348758 40.0105081" }), jsxRuntimeExports.jsx("g", { fill: primaryColor, fillRule: "nonzero", id: "Group-6", transform: "translate(19.698440, 0.000000)", children: jsxRuntimeExports.jsxs("g", { id: "Group-2", transform: "translate(30.086819, 29.797491) scale(-1, 1) rotate(-16.000000) translate(-30.086819, -29.797491) translate(5.668387, 5.801051)", children: [jsxRuntimeExports.jsx("path", { d: "M37.1114456,0.51094331 C39.6878197,-1.74499313 43.5812196,-1.5820219 45.9600521,0.881331229 C48.3388845,3.34468435 48.3658788,7.24140018 45.9861774,9.77364276 L41.0787496,14.6352146 L39.2169639,12.5242733 L43.5118331,8.29386124 L43.986716,7.82636251 C45.311926,6.41546258 45.2966675,4.21285278 43.9520379,2.820448 C42.6507834,1.4729595 40.5477648,1.34322032 39.0935846,2.49195026 L38.9778287,2.5871819 L36.1710232,5.40131276 L34.2016507,3.42296325 L37.046161,0.571907185 L37.1114456,0.51094331 Z", id: "Path-Copy", transform: "translate(40.979636, 6.777985) scale(-1, 1) rotate(-90.000000) translate(-40.979636, -6.777985) " }), jsxRuntimeExports.jsx("path", { d: "M26.7862099,13.0971333 L28.7198889,15.1103845 L6.74985548,36.2825225 L6.70425054,38.9218811 L3.33539084,42.1604189 C2.81784303,42.6567508 2.65173813,43.4167302 2.91502346,44.083725 C3.17831554,44.7507368 3.81882806,45.1924685 4.54257146,45.2017389 C4.96142838,45.20905 5.367102,45.068048 5.69076062,44.8050188 L5.80815372,44.7007141 L9.16043862,41.4634502 L11.79683,41.5089486 L28.1681701,25.6873593 L34.6206859,19.4019145 L36.5684952,21.4014979 L30.1120414,27.6907637 L13.7034408,43.5492463 C13.2269805,44.00562 12.6019366,44.270896 11.9530483,44.2991859 L11.7755814,44.3009912 L10.267903,44.2740972 L7.74969676,46.7063796 C6.93344016,47.4984549 5.85255903,47.9546315 4.7261825,47.9911887 L4.50036551,47.9928804 C2.65023563,47.9692211 0.997859779,46.8296543 0.318521964,45.1086517 C-0.336604176,43.4489858 0.0385518045,41.5662117 1.26255742,40.2865159 L1.40204204,40.1468513 L3.93366281,37.7125518 L3.95962018,36.2155167 C3.96732066,35.5557954 4.21549677,34.9237671 4.65789868,34.4325264 L4.78333452,34.3021272 L26.7862099,13.0971333 Z", id: "Path" })] }) }), jsxRuntimeExports.jsx("path", { d: "M46.618826,10.2037618 C48.1598413,9.34956311 50.1015459,9.90633795 50.9557446,11.4473532 L52.8647047,14.8912083 C53.7189034,16.4322236 53.1621286,18.3739282 51.6211133,19.2281269 L39.6490038,25.8643755 C38.1079885,26.7185742 36.1662839,26.1617994 35.3120852,24.6207841 L33.4031252,21.1769291 C32.5489265,19.6359138 33.1057013,17.6942092 34.6467166,16.8400105 L46.618826,10.2037618 Z M47.7788237,12.2964531 L35.8067143,18.9327017 C35.4489786,19.1309979 35.303407,19.5637181 35.455416,19.9329793 L35.4958164,20.0169314 L37.4047765,23.4607864 C37.6030726,23.8185221 38.0357928,23.9640937 38.405054,23.8120847 L38.4890061,23.7716843 L50.4611156,17.1354356 C50.8188513,16.9371395 50.9644229,16.5044193 50.8124138,16.135158 L50.7720134,16.051206 L48.8630534,12.6073509 C48.6647573,12.2496152 48.232037,12.1040436 47.8627758,12.2560527 L47.7788237,12.2964531 Z", fill: primaryColor, fillRule: "nonzero", id: "Rectangle" })] }) }) }));
        case 'bariatrics':
            return (jsxRuntimeExports.jsx("g", { fill: "none", fillRule: "evenodd", stroke: "none", strokeWidth: "1", children: jsxRuntimeExports.jsx("g", { fillRule: "nonzero", transform: "translate(-481.000000, -1529.000000)", children: jsxRuntimeExports.jsxs("g", { transform: "translate(481.118568, 1529.646510)", children: [jsxRuntimeExports.jsx("path", { d: "M70.2555637,14.905957 C76.4414137,15.7746932 82.5655191,19.6472063 85.9135828,25.6019125 C90.1133292,33.071381 90.4842255,46.6438907 86.5809483,55.8988761 C84.2811233,61.351947 79.9306386,67.8503179 74.6251579,73.2035609 C67.9057315,79.9834787 60.0956478,84.615289 51.5501258,86.1921687 C44.0090665,87.5836979 37.3327131,87.1526886 31.888669,85.0907506 L36.7756119,82.2561011 C40.8147909,83.1250051 45.5282283,83.1224626 50.8040395,82.1489328 C58.704501,80.6910842 66.1637434,76.0190243 72.1168197,69.9925586 L72.8238911,69.2630006 C77.1387417,64.7254372 80.6054892,59.4869384 82.7925916,54.301142 C86.2180832,46.1790249 85.8835624,33.9376325 82.3297282,27.6169528 C79.9186549,23.3287329 75.6725938,20.3599402 71.2620936,19.2811063 L70.2555637,14.905957 Z M22.0142366,67.0441261 C22.0142366,69.0682929 22.8860954,71.8206116 24.0680461,73.7320634 C24.5286411,74.4769382 25.0366857,75.1800346 25.5906536,75.839995 L21.7858607,77.6645677 C21.3559831,77.0986624 20.9508057,76.5084765 20.5710965,75.8944104 C19.0782331,73.4801503 18.0040903,70.1937292 17.9095253,67.4345559 L17.9027404,67.0441261 C17.9027404,64.2982432 16.7069023,63.3027272 15.0142042,63.3542721 C13.7722151,63.3920924 12.4868577,65.0942312 12.3966307,66.8490154 L12.3915866,67.0441261 L12.3915866,86.4119604 L8.2800904,86.4119604 L8.2800904,67.0441261 C8.2800904,63.2095943 11.0886962,59.3604072 14.8890615,59.2446809 C18.7714236,59.1264577 22.0142366,61.8260473 22.0142366,67.0441261 Z M41.5306421,0 L41.5194932,1.79948884 L41.4699505,3.31102328 L41.4643752,4.30143357 L41.469558,5.19612476 L41.4797564,5.74298167 L41.4958855,6.25265681 L41.5184054,6.72729423 C41.5227168,6.80359977 41.5273137,6.87853474 41.5322056,6.9521438 L41.5651736,7.37824467 C41.5712838,7.44672879 41.5777083,7.51397634 41.5844564,7.58003198 L41.6289071,7.96242036 C41.6450701,8.08535377 41.6626048,8.20387691 41.6815877,8.31834711 L41.742958,8.64995626 L41.8134777,8.95939184 C41.8761841,9.20861138 41.9489001,9.43696681 42.0328232,9.65004153 L42.1389869,9.89875377 L42.1962469,10.0182788 L42.3194108,10.2490069 L42.4544829,10.4704255 C42.5015428,10.5429184 42.550664,10.614217 42.6019231,10.6846788 L42.7621911,10.8939106 L42.9357467,11.1002651 C42.9658054,11.1345369 42.996437,11.1687781 43.027651,11.2030334 L43.2220001,11.4090919 L43.4307863,11.6176331 L43.6648065,11.8439885 L44.1096923,12.2638276 C46.0480968,14.0568989 47.1810881,14.5729002 49.6526584,14.6903745 L50.2248018,14.7102769 L50.8462422,14.7192014 L58.8000904,14.719 L59.6040904,18.831 L51.1770826,18.8317128 C46.3159282,18.8317128 44.235653,18.0758833 40.8337377,14.8250719 L40.5623449,14.5632137 C39.9150161,13.9328372 39.3919577,13.3419785 38.9712278,12.7217674 L38.7692887,12.408897 C38.2529824,11.5663525 37.9120923,10.65122 37.6946087,9.50025138 L37.6187355,9.0572645 C37.6070202,8.98148461 37.5957615,8.90470377 37.5849469,8.82688212 L37.5252848,8.34714381 L37.4756684,7.84051321 C37.4682023,7.75372747 37.4611293,7.66574151 37.4544369,7.57651547 L37.4187461,7.02595946 C37.4135247,6.93161369 37.4086584,6.83594812 37.4041345,6.73892292 L37.380998,6.1401371 C37.3777928,6.03751389 37.3749046,5.93345133 37.3723207,5.82790955 L37.3569385,4.8370188 L37.3559308,3.75979408 L37.3672406,2.58977879 L37.4116246,1.4524485 L37.4191459,0 L41.5306421,0 Z", fill: secondaryColor }), jsxRuntimeExports.jsx("path", { d: "M33.4555135,0 L33.4555135,7.84587978 C33.4555135,11.8386743 34.6705806,14.2929217 37.8951297,17.7405959 C39.9208552,19.906493 42.6369285,21.2911954 44.4526005,21.6704358 C48.2632545,22.466369 50.3934972,23.4825159 52.1820664,26.1677161 C53.6309702,28.3429727 53.371746,30.9373814 52.0374179,34.21832 L51.9179828,34.5071867 L51.6627505,35.0963592 C51.6180725,35.1966223 51.5722178,35.2981849 51.5250257,35.4014452 L51.2245393,36.0445667 C51.1713551,36.1562113 51.1165122,36.2703504 51.05985,36.3873823 L50.2567625,38.0130284 C48.0651356,42.4319998 45.6417155,45.1352074 41.1992935,47.247157 L40.6423051,47.508731 L39.8755289,47.8547597 L39.3919596,48.0617205 L38.9159308,48.255432 C38.8365281,48.286886 38.75692,48.3179926 38.6768464,48.3488542 L38.1887422,48.5319015 L37.6769969,48.7139792 L37.1291379,48.8999994 L36.5326926,49.0948739 L35.5196413,49.4145324 L34.0071989,49.8840457 L33.8474757,49.9354669 C32.783013,50.2805777 31.942485,50.6074742 31.0454172,51.0431906 C30.3295682,51.3908868 29.6511219,51.8188552 28.9028985,52.3785191 L28.5007262,52.6868991 L26.6766034,54.1663384 C25.8683526,54.8073861 25.2348173,55.2341771 24.5520685,55.5501675 C24.0907785,55.7636621 23.6258279,55.9132894 23.1465588,55.9917691 C22.9867426,56.0179388 22.8262461,56.0369944 22.6647496,56.0492039 C21.9976639,56.0996373 21.3490249,56.0356879 20.5990766,55.8771164 L20.436855,55.8417606 L20.0943307,55.760854 L18.8299044,55.4318303 C17.2073962,55.0159864 15.96549,54.8549057 14.3150422,54.952227 C9.44638345,55.2393155 4.28649145,59.9919784 4.11584746,66.4478791 L4.11149619,66.7775996 L4.11149619,86.4119604 L0,86.4119604 L0,66.7775996 C0,57.8559607 7.05373223,51.2617641 14.0730215,50.8478602 C16.0380583,50.7319886 17.5923301,50.9050656 19.3945685,51.3359814 L21.229615,51.7991304 L21.6978157,51.9073296 L21.884556,51.9416645 L22.0270417,51.9583459 L22.1468571,51.9616979 L22.3547948,51.9494077 C22.3985364,51.9461007 22.4407934,51.9410836 22.4821558,51.9343106 C22.574102,51.9192545 22.6865997,51.8830512 22.825169,51.8189185 C23.1125586,51.6859086 23.4595046,51.4589156 23.9365581,51.0900852 L25.9604994,49.4540361 L26.0555812,49.3794993 C27.1439549,48.534142 28.1418548,47.8826624 29.249096,47.3448624 C30.3340228,46.8179008 31.3465376,46.4241154 32.5794601,46.0243881 L33.5403718,45.7226307 L34.9135295,45.2957601 L35.7632827,45.0210075 L36.266491,44.8507187 L36.7330489,44.6852958 C36.8084203,44.6578718 36.882764,44.6304564 36.9563298,44.6029524 L37.3903875,44.4360885 L37.8177618,44.2624377 L38.2504397,44.0773389 C38.3236606,44.0452761 38.3976019,44.0125421 38.4725134,43.9790398 L39.1796535,43.6541526 C39.2626334,43.6151664 39.3473327,43.5751206 39.4340011,43.533918 C42.8314978,41.9187311 44.637356,39.976869 46.3919982,36.5464575 L47.1931768,34.9363623 L47.5048333,34.2927721 L47.7767402,33.7115198 L48.0157812,33.1759497 C48.0532649,33.0895695 48.0896661,33.0043987 48.1251281,32.9200904 L48.22884,32.6694058 C49.0951491,30.5392649 49.23324,29.1572017 48.760175,28.4469835 C47.8452758,27.0734345 46.7477056,26.4417519 44.5362448,25.9027167 L43.9334619,25.7637736 C43.8285827,25.7408244 43.7214447,25.7179436 43.6119715,25.6950778 C41.0165075,25.152962 37.541103,23.381139 34.8923198,20.5490712 C31.1245166,16.520552 29.4386528,13.2148645 29.347901,8.27348719 L29.3440173,7.84587978 L29.3440173,0 L33.4555135,0 Z", fill: secondaryColor }), jsxRuntimeExports.jsx("path", { d: "M62.4068596,15.5763367 C62.8800193,17.5902223 63.2523458,19.5693715 63.5240696,21.5138251 L67.6378571,20.9389521 C67.3482907,18.8668169 66.9524324,16.7625813 66.4505127,14.626286 L62.4068596,15.5763367 Z M63.9769157,26.0090853 C64.1004163,28.0456502 64.1073738,30.0421833 63.998056,31.9990062 L68.14535,32.2306945 C68.2637448,30.1113887 68.2562254,27.9536021 68.1230597,25.7576563 L63.9769157,26.0090853 Z M63.536672,36.4630699 C63.2351404,38.4423762 62.8069674,40.3795672 62.2521364,42.2752611 L66.2386593,43.4420352 C66.8456155,41.3682446 67.313753,39.2502417 67.6430552,37.0886448 L63.536672,36.4630699 Z M60.7852145,46.4826567 C60.043146,48.3081654 59.1751165,50.0940371 58.1807291,51.8407087 L61.7905019,53.8957675 C62.8745513,51.991602 63.8222496,50.0418209 64.6331999,48.0468611 L60.7852145,46.4826567 Z M55.7594461,55.6626567 C54.6358957,57.2678271 53.3976306,58.8382427 52.0442778,60.3739437 L55.1606129,63.1202471 C56.6151798,61.4696946 57.9492358,59.7777934 59.162408,58.044584 L55.7594461,55.6626567 Z M48.8863831,63.6913114 C47.4799219,65.0633904 45.9749946,66.4057964 44.3714274,67.7184158 L47.0024778,70.9326499 C48.698186,69.5446073 50.2930742,68.1219555 51.7869684,66.6645809 L48.8863831,63.6913114 Z M40.8392912,70.4453742 C39.2412879,71.6106492 37.5603792,72.7506849 35.7965118,73.8653738 L38.0155405,77.3767323 C39.8562376,76.2134902 41.613295,75.0218086 43.2866594,73.8015797 L40.8392912,70.4453742 Z M31.8509564,76.2373997 C30.1228428,77.2265087 28.3250201,78.194127 26.4574823,79.1401832 L28.3345785,82.8456166 C30.2643048,81.868057 32.1242268,80.8670157 33.9143388,79.8424211 L31.8509564,76.2373997 Z", fill: primaryColor })] }) }) }));
        case 'cardiology':
            return (jsxRuntimeExports.jsxs("g", { fill: "none", fillRule: "nonzero", children: [jsxRuntimeExports.jsx("path", { d: "M48.999 76.995c-12.103 0-21.949-9.846-21.949-21.948h4c0 9.896 8.052 17.948 17.949 17.948v4z", fill: primaryColor }), jsxRuntimeExports.jsx("path", { d: "M62.962 89.69c-6.495 0-18.59-3.054-22.743-4.156-13.415-4.006-22.742-16.535-22.742-30.487V24.213a6.795 6.795 0 0 1 6.787-6.787c3.741 0 6.785 3.045 6.785 6.787v15.676h-4V24.213a2.79 2.79 0 0 0-2.785-2.787 2.79 2.79 0 0 0-2.787 2.787v30.834c0 12.197 8.153 23.151 19.827 26.639 9.661 2.563 21.368 4.743 23.298 3.882 1.214-.551 5.173-3.72 5.173-21.343 0-13.698-9.207-25.719-22.389-29.231l-.771-.191a2.001 2.001 0 0 1-1.497-2.239c.617-4.104 4.006-7.083 8.059-7.083h7.86a2.79 2.79 0 0 0 2.786-2.786 2.79 2.79 0 0 0-2.786-2.787h-9.645c-7.161 0-12.986 5.825-12.986 12.984h-4c0-9.365 7.62-16.984 16.986-16.984h9.645a6.794 6.794 0 0 1 6.786 6.787 6.793 6.793 0 0 1-6.786 6.786h-7.86a4.04 4.04 0 0 0-3.516 2.006c14.276 4.404 24.114 17.675 24.114 32.738 0 14.312-2.529 22.719-7.519 24.985-.742.337-1.887.48-3.294.48z", fill: secondaryColor }), jsxRuntimeExports.jsx("path", { d: "M38.66 16.289l-4.631-6.765a2.86 2.86 0 0 1-.455-2.158 2.867 2.867 0 0 1 1.207-1.848 2.865 2.865 0 0 1 2.158-.455c.756.142 1.413.57 1.848 1.206l4.899 7.157c1.296-.515 2.654-.9 4.062-1.148l-5.66-8.269a6.834 6.834 0 0 0-4.412-2.877 6.82 6.82 0 0 0-5.153 1.085 6.829 6.829 0 0 0-2.879 4.412 6.833 6.833 0 0 0 1.085 5.155l4.975 7.267a21.007 21.007 0 0 1 2.956-2.762z", fill: primaryColor })] }));
        case 'general':
            return (jsxRuntimeExports.jsxs("g", { fill: "none", fillRule: "nonzero", transform: "translate(1 1)", children: [jsxRuntimeExports.jsx("circle", { cx: "29.5", cy: "44.5", fill: primaryColor, r: "3.167" }), jsxRuntimeExports.jsx("circle", { cx: "42.5", cy: "44.5", fill: primaryColor, r: "3.167" }), jsxRuntimeExports.jsx("circle", { cx: "55.5", cy: "44.5", fill: primaryColor, r: "3.167" }), jsxRuntimeExports.jsx("path", { d: "M87.167 84.383l-12.664-9.218.03-.031-3.29-2.395a39.23 39.23 0 0 1-1.198 1.107 2 2 0 0 0 .139 3.122L79.844 84H44.185C22.51 84 4.875 66.194 4.875 44.308S22.509 4.617 44.185 4.617c21.675 0 39.309 17.683 39.309 39.418 0 9.548-3.407 18.671-9.477 25.775l3.248 2.364c6.558-7.789 10.229-17.739 10.229-28.14C87.494 20.093 68.066.616 44.185.616 20.304.616.875 20.216.875 44.307S20.304 88 44.185 88H85.99a1.999 1.999 0 0 0 1.177-3.617z", fill: secondaryColor })] }));
        case 'dermatology':
            return (jsxRuntimeExports.jsxs("g", { fill: "none", fillRule: "nonzero", children: [jsxRuntimeExports.jsx("path", { d: "M45.794 63.258c-4.767 0-8.794-3.896-8.794-8.508C37 32.864 48.132 12.688 66.777.734l2.158 3.367C51.443 15.315 41 34.234 41 54.709c0 2.442 2.24 4.549 4.794 4.549 2.543 0 4.612-2.041 4.612-4.549 0-10.313 1.538-20.344 4.572-29.812l3.809 1.221c-2.907 9.073-4.381 18.692-4.381 28.591 0 4.714-3.863 8.549-8.612 8.549z", fill: primaryColor }), jsxRuntimeExports.jsx("path", { d: "M88 36H62.094a2 2 0 0 0-1.957 1.59c-1.055 5.023-1.635 11.096-1.635 17.097 0 6.894-5.562 12.502-12.4 12.502-6.853 0-12.427-5.592-12.427-12.466 0-5.699.686-11.459 1.931-16.217A2 2 0 0 0 33.67 36H3a2 2 0 0 0-2 2v46a2 2 0 0 0 2 2h79v-4H5V40h26.146c-.954 4.523-1.471 9.654-1.471 14.723 0 9.079 7.369 16.466 16.427 16.466 9.043 0 16.4-7.402 16.4-16.502 0-5.029.447-10.282 1.24-14.687H86v46h2a2 2 0 0 0 2-2V38a2 2 0 0 0-2-2z", fill: secondaryColor })] }));
        case 'lab':
            return (jsxRuntimeExports.jsxs("g", { fill: "none", fillRule: "nonzero", children: [jsxRuntimeExports.jsx("path", { d: "M19.846 44.606l11.228 9.051-2.51 3.114-11.228-9.051zM58.248.841l6.62 5.329-2.508 3.116-6.62-5.329z", fill: primaryColor }), jsxRuntimeExports.jsx("path", { d: "M75 76H63.435a35.259 35.259 0 0 0 4.643-7.68c3.898-1.843 6.461-5.798 6.461-10.101 0-3.033-1.193-5.889-3.303-7.964-.763-10.143-5.538-19.358-13.265-25.679l5.836-7.225a2.001 2.001 0 0 0-.301-2.815l-11.89-9.572a2.002 2.002 0 0 0-2.812.303L21.947 38.595a2 2 0 0 0 .302 2.812l11.89 9.584a2.003 2.003 0 0 0 2.813-.301L48.73 36.08c4.062 3.369 6.772 8.154 7.61 13.47a11.12 11.12 0 0 0-4.12 8.671c0 2.102.59 4.3 1.61 6.105C49.85 71.452 42.271 76 34.223 76H16a2 2 0 0 0-2 2v10.004c0 1.104.895 1.996 1.999 1.996H18V80h16.223c9.923 0 19.23-5.844 23.711-14.888a1.998 1.998 0 0 0-.185-2.077c-.943-1.276-1.53-3.121-1.53-4.815a7.145 7.145 0 0 1 3.331-6.061 2 2 0 0 0 .917-1.899c-.8-7.528-4.765-14.289-10.937-18.588a1.999 1.999 0 0 0-2.699.387l-11.74 14.564-8.776-7.075L50.664 9.335l8.772 7.062-5.862 7.257a2 2 0 0 0 .381 2.876c7.944 5.767 12.807 14.795 13.339 24.767.029.555.288 1.072.715 1.429 1.631 1.362 2.529 3.313 2.529 5.494 0 2.944-1.887 5.641-4.695 6.708a1.998 1.998 0 0 0-1.137 1.104c-1.637 3.949-4.048 7.494-7.165 10.537A2 2 0 0 0 58.938 80H73v6H34.287c-.08.001-.16.005-.303.012L22 86.007v4l11.987.005h.001c.092 0 .182-.004.317-.012H75a2 2 0 0 0 2-2V78a2 2 0 0 0-2-2z", fill: secondaryColor })] }));
        case 'mentalHealth':
            return (jsxRuntimeExports.jsxs("g", { fill: "none", fillRule: "nonzero", children: [jsxRuntimeExports.jsx("path", { d: "M25.355 28.894a13.39 13.39 0 0 1-2.585-.253l.776-3.924a9.245 9.245 0 0 0 10.554-6.06l3.783 1.3a13.248 13.248 0 0 1-12.528 8.937zM34.391 71.544l-3.854-1.07c.261-.938.393-1.915.393-2.901 0-5.974-4.86-10.833-10.833-10.833v-4c8.179 0 14.833 6.654 14.833 14.833 0 1.347-.181 2.684-.539 3.971zM56.71 57.691a14.606 14.606 0 0 1-1.008-5.354c0-6.838 4.842-12.865 11.513-14.331l.857 3.907c-4.85 1.065-8.37 5.449-8.37 10.423 0 1.345.246 2.654.732 3.895l-3.724 1.46z", fill: primaryColor }), jsxRuntimeExports.jsx("path", { d: "M85.053 30.646c0-8.787-5.99-16.524-14.389-18.788-2.794-6.03-8.757-9.869-15.474-9.869a17.051 17.051 0 0 0-9.476 2.893 17.066 17.066 0 0 0-9.905-3.174c-6.717 0-12.68 3.839-15.474 9.869-8.397 2.263-14.388 10-14.388 18.787 0 4.281 1.394 8.39 3.959 11.761-2.536 2.725-3.959 6.244-3.959 9.913 0 5.313 2.953 10.164 7.678 12.858a11.318 11.318 0 0 0-.763 4.084c0 6.274 5.105 11.38 11.38 11.38a9.9 9.9 0 0 0 .569-.016c1.299 5.001 5.861 8.667 11.193 8.667 2.421 0 4.666-.75 6.524-2.027a15.552 15.552 0 0 1-1.941-3.525 7.52 7.52 0 0 1-4.583 1.553c-3.966 0-7.28-3.102-7.547-7.061l-.105-1.584-.023-.346a.555.555 0 0 0-.478-.327l-.301.072-1.556.374a7.465 7.465 0 0 1-1.753.22c-4.069 0-7.38-3.311-7.38-7.38 0-1.389.395-2.747 1.143-3.928l.854-1.349.172-.272c.013-.045.028-.09.028-.139a.534.534 0 0 0-.288-.469l-.1-.041-1.603-.652c-4.326-1.76-7.121-5.722-7.121-10.093 0-3.131 1.45-6.126 3.979-8.216l1.154-.955.182-.149a.465.465 0 0 0 .104-.282.463.463 0 0 0-.125-.313l-.028-.03-1.1-1.177a15.398 15.398 0 0 1-4.165-10.551c0-7.264 5.15-13.623 12.246-15.122l.489-.103s.555-.105.826-.785l.134-.34c1.976-5.047 6.751-8.308 12.167-8.308 2.783 0 5.488.894 7.721 2.531 0 0 .814.876 2.231.876 1.062 0 1.708-.595 1.708-.595a13.058 13.058 0 0 1 7.721-2.531c5.416 0 10.191 3.261 12.167 8.308l.134.34c.271.68.826.785.826.785l.489.103c7.096 1.499 12.246 7.858 12.246 15.122 0 3.931-1.479 7.678-4.165 10.551l-1.1 1.177-.028.03a.463.463 0 0 0-.125.313c0 .107.043.202.104.282l.182.149 1.154.955c2.528 2.09 3.979 5.085 3.979 8.216 0 4.371-2.795 8.333-7.121 10.093l-1.603.652-.1.041a.534.534 0 0 0-.288.469c0 .049.016.094.028.139l.172.272.854 1.349a7.331 7.331 0 0 1 1.143 3.928c0 4.069-3.311 7.38-7.38 7.38a7.413 7.413 0 0 1-1.753-.22l-1.556-.374-.301-.072a.556.556 0 0 0-.478.327l-.023.346-.105 1.584c-.267 3.959-3.581 7.061-7.547 7.061-3.887 0-7.097-2.944-7.523-6.72l-.002-65.417h-3.94l-.002 65.136-.008.052a11.451 11.451 0 0 0 3.089 7.313c.064.067.129.133.194.198.209.213.426.419.65.615a11.498 11.498 0 0 0 7.541 2.822c5.332 0 9.895-3.666 11.193-8.667a9.9 9.9 0 0 0 .569.016c6.274 0 11.38-5.105 11.38-11.38 0-1.403-.261-2.786-.763-4.084 4.725-2.694 7.678-7.545 7.678-12.858 0-3.669-1.423-7.188-3.959-9.913a19.36 19.36 0 0 0 3.961-11.76z", fill: secondaryColor })] }));
        case 'ophthalmology':
            return (jsxRuntimeExports.jsxs("g", { fill: "none", fillRule: "nonzero", transform: "translate(1 17)", children: [jsxRuntimeExports.jsx("path", { d: "M44.665 44.533c-8.9 0-16.142-7.241-16.142-16.142S35.765 12.25 44.665 12.25c8.9 0 16.142 7.241 16.142 16.141 0 8.9-7.242 16.142-16.142 16.142zm0-28.283c-6.695 0-12.142 5.446-12.142 12.141s5.446 12.142 12.142 12.142 12.142-5.446 12.142-12.142c0-6.694-5.447-12.141-12.142-12.141z", fill: primaryColor }), jsxRuntimeExports.jsx("circle", { cx: "44.666", cy: "28.392", fill: secondaryColor, r: "5.765" }), jsxRuntimeExports.jsx("path", { d: "M83.027 36.056c.137-.154.271-.305.402-.455a83.281 83.281 0 0 0-2.742-3.557c-.328.383-.674.779-1.041 1.189-5.445 6.104-10.647 9.902-14.052 12.016-6.883 4.271-13.908 6.438-20.882 6.438-13.293 0-26.48-7.848-39.213-23.33 1.57-2.113 5.152-6.6 10.272-11.029 4.063-3.516 8.289-6.312 12.56-8.309 5.26-2.459 10.605-3.706 15.891-3.706 13.297 0 26.504 7.808 39.273 23.214l-.002.002a83.575 83.575 0 0 1 2.831 3.57c1.155-1.492 1.781-2.432 1.825-2.498L89 28.313l-.971-1.203C74.057 9.781 59.318.995 44.223.995c-5.985 0-12.008 1.402-17.899 4.167-4.656 2.186-9.238 5.223-13.62 9.026C5.283 20.632 1.026 27.005.849 27.272L0 28.556l.963 1.203c13.932 17.416 28.652 26.246 43.75 26.246 7.843 0 15.68-2.396 23.293-7.123 6.619-4.108 11.822-9.242 15.021-12.826z", fill: secondaryColor })] }));
        case 'orthopedics':
            return (jsxRuntimeExports.jsxs("g", { fill: "none", children: [jsxRuntimeExports.jsx("path", { d: "M50.021 23.219a33.275 33.275 0 0 1-4.258.265c-1.69 0-3.284-.122-4.787-.345v4.041a37.274 37.274 0 0 0 9.045.059v-4.02zm0 20.189a33.275 33.275 0 0 1-4.258.265c-1.69 0-3.284-.122-4.787-.345v4.04a37.434 37.434 0 0 0 9.045.06v-4.02zm0 21.017a33.094 33.094 0 0 1-4.258.265c-1.69 0-3.284-.122-4.787-.346v4.041a37.434 37.434 0 0 0 9.045.06v-4.02z", fill: primaryColor }), jsxRuntimeExports.jsx("path", { d: "M59.341 62.629l3.112.006a7.149 7.149 0 0 0 7.141-7.141c0-3.938-3.203-7.143-7.141-7.143l-2.828.003c-.87 0-1.578-.707-1.578-1.573l.006-2.811a1.47 1.47 0 0 1 1.283-1.457l3.117.006c3.938 0 7.141-3.204 7.141-7.143a7.149 7.149 0 0 0-7.141-7.141l-2.828.004c-.87 0-1.578-.709-1.578-1.584l-.008-2.802c0-.747.558-1.369 1.286-1.458l3.114.006c3.938 0 7.141-3.204 7.141-7.142a7.149 7.149 0 0 0-7.141-7.141h-3.154a1.697 1.697 0 0 1-1.664-1.384 5.7 5.7 0 0 0-5.695-5.523c-.718 0-1.329.161-1.845.312-1.636.478-3.267.721-4.849.721-2.535 0-4.085-.634-4.086-.634l-.116-.046a5.744 5.744 0 0 0-1.973-.353 5.698 5.698 0 0 0-5.689 5.526c-.146.793-.85 1.381-1.751 1.381h-3.07c-3.938 0-7.141 3.204-7.141 7.141 0 3.938 3.203 7.142 7.141 7.142h2.962l.154-.006a1.47 1.47 0 0 1 1.287 1.462l.005 2.804a1.58 1.58 0 0 1-1.574 1.578l-2.834-.004a7.149 7.149 0 0 0-7.141 7.141c0 3.938 3.203 7.143 7.141 7.143h2.962l.158-.006a1.47 1.47 0 0 1 1.283 1.46l.005 2.804c0 .87-.707 1.577-1.574 1.577l-2.834-.003c-3.938 0-7.141 3.204-7.141 7.143a7.149 7.149 0 0 0 7.141 7.141h2.962l.154-.006c.729.09 1.287.711 1.287 1.457v2.173c0 .811-.659 1.471-1.494 1.471h-2.909c-3.938 0-7.141 3.204-7.141 7.143 0 3.937 3.203 7.14 7.141 7.14h3.127c.601 0 1.146.312 1.452.821.696 2.171 2.238 3.941 4.316 4.977A17.203 17.203 0 0 0 45.5 89.79c2.804 0 5.591-.685 8.005-1.951a8.523 8.523 0 0 0 3.036-2.464 17.582 17.582 0 0 1-2.263-.857 8.844 8.844 0 0 1-1.582-.903 4.86 4.86 0 0 1-.994.654A13.218 13.218 0 0 1 45.5 85.79c-2.188 0-4.274-.512-6.237-1.54-1.172-.584-1.982-1.514-2.364-2.751l-.148-.371a5.67 5.67 0 0 0-5.076-3.114h-3.127a3.144 3.144 0 0 1-3.141-3.14 3.146 3.146 0 0 1 3.141-3.143h2.935a5.476 5.476 0 0 0 5.469-5.471v-2.173a5.47 5.47 0 0 0-5.167-5.46l-3.236.009a3.144 3.144 0 0 1-3.141-3.141 3.145 3.145 0 0 1 3.139-3.143l2.834.003a5.584 5.584 0 0 0 5.576-5.581l-.005-2.803c0-2.901-2.27-5.3-5.166-5.461l-3.237.01a3.146 3.146 0 0 1-3.141-3.143 3.144 3.144 0 0 1 3.139-3.141l2.834.004a5.585 5.585 0 0 0 5.576-5.582l-.005-2.804a5.47 5.47 0 0 0-5.167-5.461l-3.236.009a3.145 3.145 0 0 1-3.141-3.142 3.144 3.144 0 0 1 3.141-3.141h3.157a5.707 5.707 0 0 0 5.646-4.959l.017-.257a1.691 1.691 0 0 1 2.26-1.593c.46.188 2.482.935 5.606.935 1.962 0 3.971-.296 5.973-.882.261-.077.532-.151.727-.151.933 0 1.691.759 1.691 1.693l.017.258c.368 2.826 2.795 4.956 5.733 4.956h3.066a3.145 3.145 0 0 1 3.141 3.141 3.145 3.145 0 0 1-3.141 3.142h-2.889l-.221-.016-.126.007a5.471 5.471 0 0 0-5.165 5.467l.008 2.802a5.587 5.587 0 0 0 5.588 5.578l2.818-.004a3.145 3.145 0 0 1 3.141 3.141 3.146 3.146 0 0 1-3.141 3.143h-2.882l-.22-.018-.133.008a5.471 5.471 0 0 0-5.166 5.456l-.006 2.812c0 3.075 2.502 5.577 5.588 5.577l2.818-.003a3.146 3.146 0 0 1 3.141 3.143 3.145 3.145 0 0 1-3.141 3.141h-2.888l-.219-.016-.127.007a5.47 5.47 0 0 0-5.167 5.46v2.173c0 3.017 2.453 5.471 5.492 5.471h2.908a3.146 3.146 0 0 1 3.141 3.143 3.144 3.144 0 0 1-3.141 3.14h-3.125a5.654 5.654 0 0 0-4.477 2.194c.321.256.669.487 1.07.664 1.33.615 2.706.98 4.115 1.142h2.416c3.938 0 7.141-3.203 7.141-7.14 0-3.938-3.203-7.143-7.141-7.143H59.52c-.81 0-1.469-.66-1.469-1.471v-2.173a1.471 1.471 0 0 1 1.29-1.458z", fill: secondaryColor })] }));
        case 'pulmonology':
            return (jsxRuntimeExports.jsxs("g", { fill: "none", fillRule: "nonzero", children: [jsxRuntimeExports.jsx("path", { d: "M64.115 43.226L47 33.023V3h-4v30.023L26.887 43.226l2.343 3.409 16.271-9.918 16.708 9.918z", fill: primaryColor }), jsxRuntimeExports.jsx("path", { d: "M62.148 12.389c-.91-.531-2.059-1.05-3.658-1.05-4.199 0-7.49 3.32-7.49 7.723v11.659l4 2.419V19.062c0-1.85 1.406-3.723 3.615-3.723.537 0 .681.09 1.414.518C75.509 24.621 85 40.928 85 58.414v.172c0 12.998-10.188 23.6-23.1 23.82-3.654 0-6.9-2.973-6.9-6.627V46.85l-4-2.47V75.908c0 5.664 5 10.273 10 10.49v.012c16 0 28-12.482 28-27.824v-.172a52.893 52.893 0 0 0-26.852-46.025zM27.852 12.389c.91-.531 2.058-1.05 3.658-1.05 4.199 0 7.49 3.32 7.49 7.723v11.659l-4 2.419V19.062c0-1.85-1.406-3.723-3.615-3.723-.537 0-.681.09-1.415.518C14.491 24.621 5 40.928 5 58.414v.172c0 12.998 10.188 23.6 23.1 23.82 3.654 0 6.9-2.973 6.9-6.627V46.85l4-2.47V75.908c0 5.664-5 10.273-10 10.49v.012c-16 0-28-12.482-28-27.824v-.172a52.89 52.89 0 0 1 26.852-46.025z", fill: secondaryColor })] }));
        case 'somnology':
            return (jsxRuntimeExports.jsxs("g", { fill: "none", fillRule: "evenodd", children: [jsxRuntimeExports.jsx("path", { d: "M10.784 86.79c-4.63 0-8.396-3.768-8.396-8.397 0-4.628 3.768-8.394 8.396-8.394 4.629 0 8.396 3.767 8.396 8.394 0 4.629-3.767 8.397-8.396 8.397zm0-12.822a4.43 4.43 0 0 0-4.425 4.425 4.43 4.43 0 0 0 4.425 4.425 4.43 4.43 0 0 0 4.425-4.425 4.43 4.43 0 0 0-4.425-4.425z", fill: secondaryColor, fillRule: "nonzero" }), jsxRuntimeExports.jsx("path", { d: "M58.72 63.97c-3.262 7.998-11.123 13.522-20.134 13.522-9.707 0-18.249-6.52-20.899-15.722-9.267-.456-16.664-8.138-16.664-17.514 0-7.293 4.536-13.785 11.229-16.364a22.023 22.023 0 0 1-.154-2.6c0-12.137 9.874-22.012 22.012-22.012a22.07 22.07 0 0 1 16.81 7.81A26.173 26.173 0 0 1 62.86 8.21c14.44 0 26.187 11.747 26.187 26.185 0 14.437-11.747 26.183-26.186 26.183-1.01 0-2.025-.06-3.034-.176 0 0-1.069-.137-3.876-.855 0 0 .209-1.087.276-1.642l.255-2.122 2.096.41c1.41.274 2.851.413 4.283.413 12.248 0 22.214-9.964 22.214-22.21 0-12.25-9.966-22.214-22.214-22.214a22.177 22.177 0 0 0-11.436 3.169l-1.57.946-1.068-1.49A18.097 18.097 0 0 0 34.11 7.253c-9.948 0-18.042 8.093-18.042 18.04 0 1.195.12 2.396.355 3.57l.363 1.82-1.79.486c-5.89 1.595-10.002 6.977-10.002 13.086 0 7.48 6.085 13.564 13.564 13.564.2 0 .398-.007.597-.016l1.685-.07.345 1.65c1.702 8.193 9.021 14.14 17.401 14.14 7.162 0 13.433-4.266 16.227-10.51l3.907.958z", fill: secondaryColor }), jsxRuntimeExports.jsx("path", { d: "M33.113 45.527h-6.701a1.982 1.982 0 0 1-1.8-1.143c-.326-.7-.217-1.51.278-2.101l3.927-4.668h-2.653a1.98 1.98 0 0 1-1.986-1.978 1.98 1.98 0 0 1 1.986-1.978h6.909c.772 0 1.473.429 1.8 1.128.326.699.217 1.518-.28 2.11l-3.925 4.674h2.445a1.979 1.979 0 1 1 0 3.956zM48.998 45.527h-7.935a1.98 1.98 0 0 1-1.8-1.143c-.326-.7-.217-1.51.28-2.101l3.922-4.668h-2.41a1.98 1.98 0 0 1-1.986-1.978 1.98 1.98 0 0 1 1.986-1.978h6.667c.771 0 1.473.429 1.798 1.128.326.699.22 1.518-.277 2.11l-3.925 4.674h3.68a1.98 1.98 0 0 1 1.987 1.978c0 1.095-.89 1.978-1.987 1.978zM62.896 45.527h-7.184a1.98 1.98 0 0 1-1.798-1.143c-.326-.7-.219-1.51.277-2.101l3.926-4.668h-2.169a1.981 1.981 0 0 1-1.986-1.978 1.98 1.98 0 0 1 1.986-1.978h6.427a1.965 1.965 0 0 1 1.518 3.237l-3.924 4.675h2.927a1.98 1.98 0 0 1 1.988 1.978 1.983 1.983 0 0 1-1.988 1.978z", fill: primaryColor })] }));
        case 'corona':
            return (jsxRuntimeExports.jsxs("g", { fill: "none", children: [jsxRuntimeExports.jsxs("g", { fill: secondaryColor, children: [jsxRuntimeExports.jsx("path", { d: "M46.2991204 12.6c17.6316907 0 31.925 14.2933094 31.925 31.925s-14.2933093 31.925-31.925 31.925c-.9446766 0-1.87977-.0410309-2.8035952-.1214078l-.1111351-4.0288789c.9580217.0993608 1.9304288.1502867 2.9147303.1502867 15.4225517 0 27.925-12.5024484 27.925-27.925S61.7216721 16.6 46.2991204 16.6c-15.4225516 0-27.925 12.5024484-27.925 27.925 0 13.0484134 8.9494845 24.0065627 21.0451372 27.0711318l.0723267 4.1264864C25.1305145 72.6035147 14.3741204 59.8204026 14.3741204 44.525c0-17.6316906 14.2933094-31.925 31.925-31.925z" }), jsxRuntimeExports.jsx("path", { d: "M43.7240572 4.32802236l3.9979204-.12896518.3914652 12.13542042-3.9979204.1289652z" }), jsxRuntimeExports.jsx("path", { d: "M52.45.525v4H39v-4zm23.10325464 15.60292656l2.8208944 2.8359399-8.60830608 8.56263626-2.82089433-2.83593983z" }), jsxRuntimeExports.jsx("path", { d: "M84.2314356 19.77829444l-2.9254148 2.72799344-9.17287795-9.8367073 2.92541481-2.72799343zm2.940542 25.70826276l.1289652 3.9979204-12.1354204.3914652-.1289652-3.9979204z" }), jsxRuntimeExports.jsx("path", { d: "M89.975 53.95h-4V40.5h4zM75.4540612 75.07776092L72.76964208 78.043211l-9.00142547-8.148375 2.68441907-2.96545002z" }), jsxRuntimeExports.jsx("path", { d: "M72.25618757 83.67964198l-2.8773592-2.77863348 9.34315508-9.67512032 2.8773592 2.77863348zM47.8375624 86.8844776l-3.9979205.1289652-.3914652-12.1354204 3.9979205-.1289652zM18.13444937 76.33384312l-2.77097072-2.8847393 8.75643353-8.41109654 2.77097072 2.8847393z" }), jsxRuntimeExports.jsx("path", { d: "M9.77126618 72.55484099l2.9725793-2.67652243 8.99980667 9.99529793-2.9725793 2.67652242zM4.49437729 46.91880924l-.19871889-3.99506078 12.1267401-.60319786.1987189 3.99506079z" }), jsxRuntimeExports.jsx("path", { d: "M.60793678 38.46171707l3.99939078-.06980963.23473486 13.4479515-3.99939078.06980963zm14.34744726-21.17834824l2.78627657-2.86995874 8.71156786 8.45755645-2.7862765 2.86995867z" }), jsxRuntimeExports.jsx("path", { d: "M18.4357115 8.53555536l2.77863348 2.8773592-9.67512035 9.34315512-2.77863348-2.8773592zM39.5741196 89.625v-4h13.45v4z" })] }), jsxRuntimeExports.jsx("path", { d: "M46 22c-3.8659932 0-7 3.13400675-7 7 0 3.8659932 3.1340068 7 7 7s7-3.1340068 7-7c0-3.86599325-3.1340068-7-7-7zm0 4c1.6568542 0 3 1.34314575 3 3s-1.3431458 3-3 3-3-1.34314575-3-3 1.3431458-3 3-3zM31 38c-3.86599325 0-7 3.1340068-7 7s3.13400675 7 7 7c3.8659932 0 7-3.1340068 7-7s-3.1340068-7-7-7zm0 4c1.65685425 0 3 1.3431458 3 3s-1.34314575 3-3 3-3-1.3431458-3-3 1.34314575-3 3-3zm32-4c-3.8659932 0-7 3.1340068-7 7s3.1340068 7 7 7 7-3.1340068 7-7-3.1340068-7-7-7zm0 4c1.6568542 0 3 1.3431458 3 3s-1.3431458 3-3 3-3-1.3431458-3-3 1.3431458-3 3-3zM46 53c-3.8659932 0-7 3.1340068-7 7s3.1340068 7 7 7 7-3.1340068 7-7-3.1340068-7-7-7zm0 4c1.6568542 0 3 1.3431458 3 3s-1.3431458 3-3 3-3-1.3431458-3-3 1.3431458-3 3-3z", fill: primaryColor })] }));
        case 'digitalconsultation':
            return (jsxRuntimeExports.jsxs("g", { fill: "none", children: [jsxRuntimeExports.jsx("path", { d: "M48 66c2.209139 0 4 1.790861 4 4v8h7c1.1045695 0 2 .8954305 2 2 0 1.0543618-.8158778 1.9181651-1.8507377 1.9945143L59 82H30c-1.1045695 0-2-.8954305-2-2 0-1.0543618.8158778-1.9181651 1.8507377-1.9945143L30 78h8v-8c0-2.209139 1.790861-4 4-4zm0 4h-6v8h6v-8zM28.922 18l1.959 4H4v44h82V22H59.445l1.535-4H86c2.1421954 0 3.8910789 1.6839685 3.9951047 3.8003597L90 22v44c0 2.209139-1.790861 4-4 4H4c-2.209139 0-4-1.790861-4-4V22c0-2.209139 1.790861-4 4-4h24.922z", fill: secondaryColor }), jsxRuntimeExports.jsx("path", { d: "M56.0436105 29c6.4693029 0 11.9541436 4.7164299 12.8690412 11.0661247l2.0540743 14.255962C71.2464205 56.2632601 69.7272047 58 67.7494657 58h-9.749771v-4h8.7120363l-1.8731668-13.0224932c-.2079553-3.6293204-3.2024901-7.1096052-7.3895866-7.8538881l-9.6622309 16.2811875c-1.2622633 2.1269251-4.3112301 2.1269251-5.5734934 0L32.5395446 33.104441c-4.2768053.5823646-6.8358838 3.8162184-7.3781088 7.8730658L23.25354 54H32l.0003053 4h-9.749771c-1.977739 0-3.4969548-1.7367399-3.2172603-3.6779133l2.0540743-14.255962C22.0022459 33.7164299 27.4870866 29 33.9563895 29h22.087221zM52.819 33.01H37.046L45 46.3295898 52.819 33.01zM45 0c7.1797017 0 13 5.82029825 13 13 0 7.1797017-5.8202983 13-13 13s-13-5.8202983-13-13c0-7.17970175 5.8202983-13 13-13zm0 4c-4.9705627 0-9 4.02943725-9 9 0 4.9705627 4.0294373 9 9 9s9-4.0294373 9-9c0-4.97056275-4.0294373-9-9-9z", fill: primaryColor })] }));
        case 'homeconsultation':
            return (jsxRuntimeExports.jsxs("g", { fill: "none", fillRule: "evenodd", children: [jsxRuntimeExports.jsx("path", { d: "M24.4646324 56.4521128c-.4552276 1.0570802-1.7488077 1.7424641-2.9044444 1.7424641H9.8935213v-3.7499408h11.7617444l6.9162811-17.3823286c1.0709061-2.486742 3.6861888-2.2587067 4.4330437.3426912l9.7141532 31.3499105 5.0750253-13.567809c.4552276-1.0570802 1.4996711-1.7424641 2.6553079-1.7424641h10.6666666v3.7499408h-9.7617444l-7.3493667 18.1250296c-1.0709061 2.486742-2.7531451 2.5160058-3.5-.0853922l-9.8696289-32.7459066-6.1703711 13.9638051z", fill: primaryColor }), jsxRuntimeExports.jsx("path", { d: "M70.38556004 12.36258034l-.02656819 71.60235837c-.00078651 2.20913898-1.79228524 3.99936208-4.0014245 3.99857486L4.29581534 87.7929054c-2.20483786-.00606103-3.98900319-1.79513934-3.9890034-3.99998476l-7e-8-49.47543381c0-1.02237642.39147765-2.00594611 1.0940279-2.74869539L29.35547037 2.0146344c1.5180625-1.60492408 4.04974336-1.6753392 5.65466743-.15727667a4.00000692 4.00000692 0 0 1 .18770234.18980414l18.34137148 19.82859665v5.89019949L32.26144242 4.76332979 4.30681184 34.31748682V83.7929207l62.05218047.17059361.02483232-67.60208609-4.84156013.0007071.00002673 20.05616617-6.740894-7.28692029 2.74968252 2.96709508-.00644775-5.89886968-.00248888-.00271854.00014814-13.83430779 12.84326878 7e-8z", fill: secondaryColor, fillRule: "nonzero" })] }));
        case 'audiology':
            return (jsxRuntimeExports.jsxs("g", { children: [jsxRuntimeExports.jsx("path", { d: "M42.114 11.718c-6.495 0-8.805.565-12.958 1.667C15.741 17.39 9.812 26.593 9.437 36.155c-.375 9.563 0 17.094 0 17.094S10 57.05 11 58.266h4c-1.343-1.718-1.457-5.017-1.457-5.017V36.155c0-6.28 4.894-14.187 16.698-18.922 11.54-3.14 16.759-.671 19.196.485 2.438 1.156 9.275 5.858 9.275 16.976 0 11.118.1 14.774-5.025 23.524-5.125 8.75-5.69 23.31-15.75 27.875-.39.177-2.454.384-4.437.125-5.5-.718-10.563-9.5-10.563-13.5H19.22c0 6 7.302 16.455 13.218 17 3.063.282 3.392.248 5.5 0 1.563-.204 4.563-1.218 5.875-2.719 8.5-8.968 9.89-21.128 14.22-28.781 4.327-7.653 4.68-12 4.68-23.524 0-14.312-8.275-18.976-9.775-19.976s-6-3-10.823-3Z", fill: secondaryColor }), jsxRuntimeExports.jsx("path", { clipRule: "evenodd", d: "M62.269 6.556c2.495 1.306 4.257 2.71 5.843 5.185 1.323 2.066 2.532 5.62 2.532 8.116l-3.937.054c0-2.55-.782-4.536-1.917-6.308-1.309-2.044-2.383-2.588-4.57-3.732l2.049-3.315ZM71.942.978C75.064 3.059 77.017 5.4 78.7 8.766c1.586 3.171 2.3 6.55 2.3 10.5l-3.5-.022c0-3.45-.698-6.686-2.036-9.36C73.955 6.867 72 5.766 69.555 4.058l2.387-3.08Z", fill: primaryColor, fillRule: "evenodd" }), jsxRuntimeExports.jsx("path", { d: "M48 47.266c1.125 10-4 16.9-12 16.9v-3.5c6 0 8.449-4.65 8.449-13.4H48ZM19.578 44.76c-3.212-17.23 16.788-29.743 30.17-17.678l-3 2.447c-9.436-8.7-25.757.738-23.67 14.83l-3.5.402Z", fill: primaryColor })] }));
        case 'radiology':
            return (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx("path", { d: "M68.0094 36.3213C65.6311 32.4735 61.355 29.9594 56.5542 29.9594H33.7363C28.9377 29.9594 24.6634 32.4712 22.2844 36.316C22.2833 36.3177 22.2822 36.3195 22.2811 36.3213H27.6077L27.6112 36.3181C28.8262 35.2112 30.3879 34.4562 32.2726 34.1996C35.6318 34.1996 37.7579 34.1984 39.2529 34.1976C42.0323 34.1961 42.6305 34.1958 44.915 34.2062C45.8525 34.2105 46.4068 34.2134 46.9611 34.2154C48.4015 34.2206 49.842 34.2194 58.0061 34.2194C59.7327 34.5263 61.2631 35.2836 62.4924 36.3213H68.0094Z", fill: primaryColor }), jsxRuntimeExports.jsx("path", { d: "M70.2607 48.2169H65.9759L67.5753 76.2383H58.575V80.3706H68.6473C70.6905 80.3706 72.26 78.5764 71.971 76.571L70.2607 48.2169Z", fill: primaryColor }), jsxRuntimeExports.jsx("path", { d: "M24.3084 48.2169H20.0299L18.3195 76.571C18.0306 78.5764 19.6001 80.3706 21.6432 80.3706H31.7155L31.7152 76.2383H22.6794L24.3084 48.2169Z", fill: primaryColor }), jsxRuntimeExports.jsx("path", { clipRule: "evenodd", d: "M58.5753 13.4301C58.5753 6.01284 52.5625 0 45.1453 0C37.7281 0 31.7152 6.01284 31.7152 13.4301C31.7152 20.8473 37.7281 26.8601 45.1453 26.8601C52.5625 26.8601 58.5753 20.8473 58.5753 13.4301ZM35.8475 13.4301C35.8475 8.29506 40.0103 4.13232 45.1453 4.13232C50.2803 4.13232 54.443 8.29506 54.443 13.4301C54.443 18.565 50.2803 22.7278 45.1453 22.7278C40.0103 22.7278 35.8475 18.565 35.8475 13.4301Z", fill: primaryColor, fillRule: "evenodd" }), jsxRuntimeExports.jsx("path", { clipRule: "evenodd", d: "M77.8718 43.8827H12.1282V86H77.8718V43.8827ZM12.1282 39.8827C9.91903 39.8827 8.12817 41.6735 8.12817 43.8827V86C8.12817 88.2091 9.91903 90 12.1282 90H77.8718C80.081 90 81.8718 88.2091 81.8718 86V43.8827C81.8718 41.6735 80.081 39.8827 77.8718 39.8827H12.1282Z", fill: secondaryColor, fillRule: "evenodd" }), jsxRuntimeExports.jsx("path", { d: "M46.8735 63.4617V67.6911C48.1101 67.6716 49.5974 67.5027 51.032 67.2409C52.6871 66.939 54.1274 66.5398 54.9448 66.1832L56.5405 65.4872L57.8659 68.8076L56.2702 69.5037C55.1053 70.0118 53.3741 70.4668 51.6169 70.7873C50.0562 71.0721 48.3623 71.2713 46.8735 71.2917V73.844H43.4175V71.2916C41.9288 71.2711 40.235 71.0719 38.6745 70.7872C36.9173 70.4666 35.186 70.0117 34.0212 69.5035L32.4255 68.8075L33.7509 65.4871L35.3466 66.1831C36.1639 66.5396 37.6043 66.9388 39.2594 67.2408C40.6938 67.5025 42.1809 67.6714 43.4175 67.691V63.4618C38.9722 63.4633 33.7562 61.8278 30.6406 60.4982L29.0533 59.8208L30.4269 56.4887L32.0142 57.1661C34.9366 58.4133 39.6354 59.8476 43.4175 59.8647V56.2381C41.8642 56.193 40.1222 55.8669 38.5633 55.4715C36.7855 55.0207 35.1107 54.4446 34.0209 53.9692L32.4252 53.2732L33.7506 49.9527L35.3463 50.6488C36.2387 51.038 37.7355 51.5589 39.3699 51.9734C40.8039 52.3371 42.2431 52.5927 43.4175 52.6364V49.5079H46.8735V52.6365C48.0478 52.5928 49.4869 52.3372 50.9207 51.9735C52.5552 51.559 54.052 51.0382 54.9444 50.6489L56.5401 49.9528L57.8655 53.2733L56.2698 53.9693C55.18 54.4447 53.5052 55.0208 51.7273 55.4717C50.1686 55.867 48.4267 56.193 46.8735 56.2382V59.8646C50.6555 59.8474 55.354 58.4132 58.2762 57.166L59.8635 56.4886L61.2371 59.8206L59.6499 60.498C56.5344 61.8277 51.3187 63.463 46.8735 63.4617Z", fill: secondaryColor })] }));
        case 'neurology':
            return (jsxRuntimeExports.jsxs("g", { fill: "none", children: [jsxRuntimeExports.jsx("path", { d: "M44.3221 4.45113C41.5073 0.889879 36.1929 -0.101747 31.553 0.726181C27.5287 1.44428 24.8503 3.99972 23.2319 6.75215C22.1103 8.6596 21.4463 10.7392 21.1608 12.5613C14.4993 12.4723 9.79453 15.4558 7.29799 19.6723C4.897 23.7275 4.62639 28.8155 6.52192 32.8758C-0.612852 42.0927 2.55118 53.6242 9.31618 59.0424C8.41722 61.8065 8.15269 64.2499 8.41615 66.4827C8.77627 69.5348 10.0966 71.9637 11.6896 74.0825C13.9131 77.0398 16.3576 78.7456 18.8025 79.6271C20.4941 80.237 22.1179 80.4281 23.5699 80.4184C23.8376 81.3181 24.2709 82.4845 24.9565 83.667C26.4485 86.2402 29.2362 89.0048 34.0183 89.0048C37.2816 89.0048 39.8923 87.9183 41.853 86.4735L39.4803 83.2533C38.1336 84.2455 36.341 85.0048 34.0183 85.0048C31.097 85.0048 29.4419 83.4284 28.4169 81.6606C27.8941 80.7589 27.5621 79.8387 27.3616 79.1328C27.2624 78.7837 27.1982 78.4969 27.1598 78.3044C27.1406 78.2084 27.1281 78.1367 27.1208 78.0932C27.119 78.082 27.1175 78.0727 27.1163 78.0653C27.1153 78.0585 27.1145 78.0534 27.114 78.05L27.1136 78.0473L27.1133 78.0455L26.851 76.1195L24.9118 76.335C23.45 76.4974 21.8252 76.4649 20.1593 75.8642C18.5129 75.2706 16.6861 74.0719 14.8868 71.6787C13.5436 69.8921 12.6373 68.1221 12.3886 66.014C12.1388 63.8966 12.5261 61.2093 14.1894 57.5624L14.0692 57.5076L14.138 57.3543C7.30894 54.2882 2.88849 42.9668 10.4197 34.4365L11.4049 33.3206L10.6187 32.0566C8.83057 29.1815 8.78335 25.0148 10.7399 21.7102C12.6164 18.5409 16.4515 16.0154 22.7933 16.6595L25.0235 16.886L24.9952 14.6444C24.9769 13.1949 25.4593 10.8556 26.68 8.77963C27.8764 6.74501 29.6754 5.12441 32.2557 4.66398C35.9308 4.0082 38.4193 4.86746 39.9676 6.15866C41.5543 7.48195 42.3565 9.42205 42.3565 11.286L42.365 22.4421C42.3655 22.6553 42.375 22.872 42.3936 23.0916V80.639L42.5289 80.9879C43.5869 83.7158 47.4517 89.0049 54.7112 89.0049C59.473 89.0049 62.2329 86.321 63.7028 83.7826C64.3804 82.6125 64.7992 81.4589 65.0537 80.5737C66.8764 80.4579 69.0305 79.9375 71.1062 78.9741C73.9663 77.6465 76.8812 75.3825 78.6168 71.8773C81.2233 66.6132 80.609 60.7428 77.8703 56.5397C75.0944 52.2794 70.0753 49.6913 64.192 51.3145L65.2559 55.1704C69.2559 54.0668 72.5727 55.7364 74.519 58.7234C76.5026 61.7676 76.9969 66.1343 75.0321 70.1024C73.7974 72.596 71.6785 74.2985 69.4221 75.3459C67.1278 76.4108 64.8958 76.7035 63.6763 76.568L61.7121 76.3498L61.4715 78.3032L61.4711 78.3058L61.471 78.3068C61.4701 78.313 61.4682 78.3265 61.465 78.3471C61.4587 78.3881 61.4475 78.4567 61.4302 78.5487C61.3955 78.7333 61.3366 79.0092 61.2441 79.3454C61.057 80.0254 60.7434 80.9111 60.2413 81.7781C59.265 83.4642 57.6527 85.0049 54.7112 85.0049C49.9312 85.0049 47.2557 81.7128 46.3936 79.858V30.8935C49.0157 33.4721 52.8955 35.4158 57.9271 35.4158V31.4159C53.9849 31.4159 51.0943 29.9126 49.1843 28.0277C47.4171 26.2838 46.5558 24.2896 46.3936 22.8945V10.7961H46.3919C46.5198 9.08776 47.3144 7.36643 48.7625 6.1588C50.3107 4.86759 52.7993 4.00834 56.4743 4.66412C59.0546 5.12455 60.8537 6.74515 62.05 8.77977C63.2707 10.8558 63.7532 13.195 63.7348 14.6446L63.7065 16.8862L65.9368 16.6596C72.3208 16.0113 76.0876 18.4144 77.9451 21.4725C79.8816 24.6607 79.9382 28.8542 78.2755 32.0662L77.6823 33.2121L78.4819 34.2249C83.5991 40.7066 82.9479 48.0452 79.7058 52.8891C79.59 53.0621 79.4536 53.2238 79.3166 53.361C79.1765 53.5012 79.0606 53.5909 78.9999 53.6313L81.2187 56.9595C81.8122 56.5638 82.4947 55.9137 83.0299 55.114C87.0001 49.1824 87.8197 40.4415 82.3649 32.7398C84.0794 28.5292 83.8188 23.4377 81.3638 19.3959C78.849 15.2557 74.1855 12.4449 67.5687 12.5577C67.2828 10.7365 66.6189 8.65843 65.4981 6.75229C63.8797 3.99986 61.2013 1.44442 57.177 0.726322C52.5372 -0.101606 46.8383 1.25633 44.3288 4.45789L44.3265 4.46603L44.3221 4.45113Z", fill: secondaryColor }), jsxRuntimeExports.jsx("path", { clipRule: "evenodd", d: "M34.8621 21.143C36.9033 21.864 38.3659 23.8104 38.3659 26.0985C38.3659 29.0002 36.0136 31.3525 33.1119 31.3525C30.7468 31.3525 28.7466 29.7897 28.0878 27.6404H23.6448C22.4021 27.6404 21.3948 28.6477 21.3948 29.8904V41.5173C22.8886 42.0449 24.0725 43.2288 24.6001 44.7227H28.1564C28.8773 42.6814 30.8238 41.2188 33.1119 41.2188C36.0136 41.2188 38.3659 43.571 38.3659 46.4727C38.3659 48.7608 36.9033 50.7073 34.8621 51.4282V63.1801C36.9033 63.9011 38.3659 65.8475 38.3659 68.1356C38.3659 71.0373 36.0136 73.3896 33.1119 73.3896C30.2102 73.3896 27.8579 71.0373 27.8579 68.1356C27.8579 65.8474 29.3206 63.9009 31.3621 63.18V51.4283C29.868 50.9007 28.6839 49.7167 28.1564 48.2227H24.6002C23.8793 50.264 21.9328 51.7267 19.6446 51.7267C16.7429 51.7267 14.3906 49.3745 14.3906 46.4727C14.3906 44.1846 15.8534 42.238 17.8948 41.5172V29.8904C17.8948 26.7147 20.4691 24.1404 23.6448 24.1404H28.2349C28.7957 22.7449 29.9381 21.6457 31.3621 21.1429V14.3806H34.8621V21.143ZM33.1119 27.8525C34.0806 27.8525 34.8659 27.0672 34.8659 26.0985C34.8659 25.1298 34.0806 24.3445 33.1119 24.3445C32.1432 24.3445 31.3579 25.1298 31.3579 26.0985C31.3579 27.0672 32.1432 27.8525 33.1119 27.8525ZM21.3986 46.4727C21.3986 47.4415 20.6133 48.2267 19.6446 48.2267C18.6759 48.2267 17.8906 47.4415 17.8906 46.4727C17.8906 45.504 18.6759 44.7188 19.6446 44.7188C20.6133 44.7188 21.3986 45.504 21.3986 46.4727ZM34.8659 46.4727C34.8659 47.4415 34.0806 48.2267 33.1119 48.2267C32.1432 48.2267 31.3579 47.4415 31.3579 46.4727C31.3579 45.504 32.1432 44.7188 33.1119 44.7188C34.0806 44.7188 34.8659 45.504 34.8659 46.4727ZM33.1119 69.8896C34.0806 69.8896 34.8659 69.1043 34.8659 68.1356C34.8659 67.1669 34.0806 66.3816 33.1119 66.3816C32.1432 66.3816 31.3579 67.1669 31.3579 68.1356C31.3579 69.1043 32.1432 69.8896 33.1119 69.8896Z", fill: primaryColor, fillRule: "evenodd" })] }));
        default:
            return null;
    }
}

function Tooltip({ children, content, hasArrow = true, placement = 'bottom' }) {
    return (jsxRuntimeExports.jsx(RadixTooltip.Provider, { delayDuration: 150, children: jsxRuntimeExports.jsxs(RadixTooltip.Root, { children: [jsxRuntimeExports.jsx(RadixTooltip.Trigger, { asChild: true, children: children }), jsxRuntimeExports.jsx(RadixTooltip.Portal, { children: jsxRuntimeExports.jsxs(StyledTooltipContent, { side: placement, sideOffset: 4, children: [content, hasArrow && jsxRuntimeExports.jsx(StyledTooltipArrow, {})] }) })] }) }));
}
const StyledTooltipContent = styled(RadixTooltip.Content) `
    display: inline-block;
    max-width: 300px;
    padding: 8px 16px;
    border-radius: ${(props) => props.theme.radii.base};
    font-weight: ${(props) => props.theme.fontWeights.normal};
    font-size: 14px;
    line-height: 1.375;
    color: white;
    background-color: ${(props) => props.theme.colors.neutral900};
    text-align: left;
    word-wrap: break-word;
    user-select: none;
    animation-duration: 400ms;
    animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);
    will-change: transform, opacity;
    z-index: 9999;

    &[data-state='delayed-open'] {
        animation-name: fade-in;
    }

    @keyframes fade-in {
        from {
            opacity: 0;
        }

        to {
            opacity: 1;
        }
    }
`;
const StyledTooltipArrow = styled(RadixTooltip.Arrow) `
    fill: ${(props) => props.theme.colors.neutral900};
`;

const Badge = forwardRef((props, ref) => {
    const { tooltip } = props, innerBadgeProps = __rest(props, ["tooltip"]);
    return tooltip ? (jsxRuntimeExports.jsx(Tooltip, Object.assign({}, tooltip, { children: jsxRuntimeExports.jsx(InnerBadge, Object.assign({}, innerBadgeProps, { ref: ref })) }))) : (jsxRuntimeExports.jsx(InnerBadge, Object.assign({}, props, { ref: ref })));
});
Badge.displayName = 'Badge';
const InnerBadge = forwardRef((_a, ref) => {
    var { carePathIcon, color = 'neutral', icon, isSensitiveData = false, shape = 'square', size = 'medium', text } = _a, props = __rest(_a, ["carePathIcon", "color", "icon", "isSensitiveData", "shape", "size", "text"]);
    const theme = useTheme();
    return (jsxRuntimeExports.jsxs(StyledBadge$1, Object.assign({ "$color": color, "$shape": shape, "$size": size, ref: ref }, props, { children: [icon && (jsxRuntimeExports.jsx(Icon, { icon: icon, size: theme.badge.size[size].iconSize, sx: {
                    color: theme.badge.foregroundColor[color],
                } })), carePathIcon && (jsxRuntimeExports.jsx(CarePathIcon, { color: theme.badge.foregroundColor[color], icon: carePathIcon, size: theme.badge.size[size].iconSize, variant: "small" })), jsxRuntimeExports.jsx(StyledText$4, { "$size": size, "data-dd-privacy": isSensitiveData ? 'mask' : 'allow', children: text })] })));
});
InnerBadge.displayName = 'InnerBadge';
const StyledBadge$1 = styled.div `
    display: inline-flex;
    align-items: center;
    vertical-align: middle;
    text-align: center;
    justify-content: center;
    margin: 0;
    padding: 2px 8px;
    flex-shrink: 0;
    color: ${(props) => props.$color && props.theme.badge.foregroundColor[props.$color]};
    background-color: ${(props) => props.$color && props.theme.badge.backgroundColor[props.$color]};
    border-radius: ${(props) => props.$shape && props.theme.badge.borderRadii[props.$shape]};
    min-width: ${(props) => props.$size && props.theme.badge.size[props.$size].height};
    min-height: ${(props) => props.$size && props.theme.badge.size[props.$size].height};

    & svg {
        margin-right: ${(props) => props.$size && props.theme.badge.size[props.$size].iconMargin};
    }

    ${sx}
`;
const StyledText$4 = styled.span `
    display: inline-block;
    font-size: ${(props) => props.$size && props.theme.badge.size[props.$size].fontSize};
    line-height: ${(props) => props.$size && props.theme.badge.size[props.$size].lineHeight};
    font-weight: ${tokens.kdsFontWeightMedium};
    margin: 0;
    padding: 0;
`;

function AvatarBlock(_a) {
    var { altText, backgroundColor, badgeColor, badgeText, color, direction, icon, imageUrl, initials, shape, size = 'large', subtitle, subtitleSuffix, title, titleSuffix } = _a, props = __rest(_a, ["altText", "backgroundColor", "badgeColor", "badgeText", "color", "direction", "icon", "imageUrl", "initials", "shape", "size", "subtitle", "subtitleSuffix", "title", "titleSuffix"]);
    function getTitleSize(avatarSize) {
        if (avatarSize === 'xsmall') {
            return 'xs';
        }
        if (avatarSize === 'small') {
            return 'sm';
        }
        if (avatarSize === 'medium') {
            return 'md';
        }
        if (avatarSize === 'large') {
            return 'md';
        }
        return 'lg';
    }
    function getSubtitleSize(avatarSize) {
        if (avatarSize === 'xsmall') {
            return 'xs';
        }
        if (avatarSize === 'small') {
            return 'xs';
        }
        if (avatarSize === 'medium') {
            return 'sm';
        }
        if (avatarSize === 'large') {
            return 'md';
        }
        return 'md';
    }
    function getBadgeSize(avatarSize) {
        if (avatarSize === 'xsmall') {
            return 'small';
        }
        if (avatarSize === 'small') {
            return 'small';
        }
        if (avatarSize === 'medium') {
            return 'medium';
        }
        if (avatarSize === 'large') {
            return 'medium';
        }
        return 'medium';
    }
    function getDirection(avatarSize) {
        switch (avatarSize) {
            case 'xsmall':
                return 'horizontal';
            case 'small':
                return 'horizontal';
            case 'medium':
                return 'horizontal';
            case 'large':
                return 'vertical';
            default:
                return 'vertical';
        }
    }
    return (jsxRuntimeExports.jsxs(StyledAvatarBlock, Object.assign({ "$direction": direction || getDirection(size) }, props, { children: [jsxRuntimeExports.jsx(StyledAvatar$1, { altText: altText, backgroundColor: backgroundColor, color: color, icon: icon, imageUrl: imageUrl, initials: initials, shape: shape, size: size }), jsxRuntimeExports.jsxs("div", { children: [title && (jsxRuntimeExports.jsxs(StyledTitle$4, { size: getTitleSize(size), children: [title, title && titleSuffix && (jsxRuntimeExports.jsx(StyledTitleSuffix, { size: getSubtitleSize(size), children: titleSuffix }))] })), subtitle && (jsxRuntimeExports.jsxs(StyledSubtitle$3, { size: getSubtitleSize(size), children: [subtitle, subtitle && subtitleSuffix && (jsxRuntimeExports.jsx(StyledSubtitleSuffix, { size: getSubtitleSize(size), children: subtitleSuffix }))] }))] }), badgeText && (jsxRuntimeExports.jsx(StyledBadge, { color: badgeColor, size: getBadgeSize(size), text: badgeText }))] })));
}
const StyledAvatarBlock = styled.div `
    display: flex;

    ${(props) => props.$direction === 'horizontal' &&
    css$3 `
            flex-direction: row;
            align-items: center;

            ${StyledAvatar$1} {
                margin-right: 12px;
            }

            ${StyledBadge} {
                margin-top: 0;
                margin-left: 8px;
            }
        `}

    ${(props) => props.$direction === 'vertical' &&
    css$3 `
            flex-direction: column;
            align-items: center;

            ${StyledAvatar$1} {
                margin-bottom: 16px;
            }

            ${StyledTitle$4} {
                text-align: center;
            }

            ${StyledSubtitle$3} {
                text-align: center;
            }

            ${StyledBadge} {
                margin-top: 16px;
            }
        `}
    ${sx}
`;
const StyledAvatar$1 = styled(Avatar) ``;
const StyledTitle$4 = styled(Text) `
    width: 100%;
    font-weight: ${(props) => props.theme.fontWeights.medium};
    word-break: normal;
    hyphens: auto;
    text-align: left;
    display: -webkit-box;
    max-width: 100%;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    color: var(--kds-color-foreground-default);
`;
const StyledTitleSuffix = styled(Text).attrs({ as: 'span' }) `
    font-weight: ${(props) => props.theme.fontWeights.normal};
    padding-left: 0.25rem;
    padding-right: 0.25rem;
    color: var(--kds-color-foreground-default);
`;
const StyledSubtitle$3 = styled(StyledTitle$4) `
    font-weight: ${(props) => props.theme.fontWeights.normal};
`;
const StyledSubtitleSuffix = styled(StyledTitleSuffix) ``;
const StyledBadge = styled(Badge) ``;

function AvatarButton(_a) {
    var { altText = 'Avatar', backgroundColor = '#ECECE6', buttonRef, color = '#322A24', icon = 'practitioner-nogender', imageUrl, initials, onClick, size = 'medium', textOverlay = 'Edit', type = 'button' } = _a, props = __rest(_a, ["altText", "backgroundColor", "buttonRef", "color", "icon", "imageUrl", "initials", "onClick", "size", "textOverlay", "type"]);
    const iconSize = getIconSize(size);
    const fontSize = getFontSize(size);
    return (jsxRuntimeExports.jsxs(StyledAvatarButton, Object.assign({ "$backgroundColor": backgroundColor, "$color": color, "$initials": initials, "aria-label": altText, disabled: !onClick, onClick: onClick, ref: buttonRef, size: size, type: type }, props, { children: [imageUrl ? (jsxRuntimeExports.jsx(AvatarImage, { alt: altText, src: imageUrl })) : initials ? (jsxRuntimeExports.jsx(AvatarInitials, { fontSize: fontSize, children: initials })) : (jsxRuntimeExports.jsx(AvatarIcon, { icon: icon, size: iconSize })), textOverlay && jsxRuntimeExports.jsx(TextOverlay, { children: textOverlay })] })));
}
const StyledAvatarButton = styled.button `
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    border: 0;
    border-radius: ${(props) => props.theme.radii.full};
    box-sizing: border-box;
    overflow: hidden;
    position: relative;
    height: ${(props) => (typeof props.size === 'string' ? circleSizes[props.size] : `${props.size}px`)};
    min-height: ${(props) => (typeof props.size === 'string' ? circleSizes[props.size] : `${props.size}px`)};
    width: ${(props) => (typeof props.size === 'string' ? circleSizes[props.size] : `${props.size}px`)};
    min-width: ${(props) => (typeof props.size === 'string' ? circleSizes[props.size] : `${props.size}px`)};
    cursor: ${(props) => (props.onClick ? 'pointer' : 'default')};
    color: ${(props) => props.$initials
    ? colorOptions[props.$initials.charCodeAt(0) % Object.keys(colorOptions).length]
    : props.$color};
    background-color: ${(props) => props.$initials
    ? backgroundOptions[props.$initials.charCodeAt(0) % Object.keys(backgroundOptions).length]
    : props.$backgroundColor};

    &:focus {
        outline: none;
    }

    &:focus-visible {
        outline: 2px solid var(--kds-color-border-focused);
        outline-offset: 2px;
    }

    ${sx}
`;
const TextOverlay = styled.span `
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    color: white;
    background: rgb(40 35 32 / 80%);
    padding-bottom: 4px;
    padding-top: 2px;
    margin: 0;
    font-size: 14px;
    line-height: 21px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

function AvatarGroup(_a) {
    var { children, limit, size = 'medium' } = _a, props = __rest(_a, ["children", "limit", "size"]);
    if (!children) {
        return null;
    }
    const numOfChildren = children.length;
    const childrenShow = children.slice(0, limit);
    if (limit && limit < numOfChildren) {
        const fontSize = getFontSize(size);
        const hiddenCount = numOfChildren - limit;
        return (jsxRuntimeExports.jsxs(AvatarGroupContainer, Object.assign({}, props, { children: [childrenShow.map((child, index) => {
                    if (child.type === Avatar) {
                        const zIndex = numOfChildren - index;
                        return (jsxRuntimeExports.jsx(React__default.Fragment, { children: cloneElement(child, {
                                size: size,
                                style: { zIndex: zIndex },
                            }) }, index));
                    }
                    return child;
                }), jsxRuntimeExports.jsx(AvatarHiddenCount, { fontSize: fontSize, size: size, children: `+${hiddenCount}` })] })));
    }
    return (jsxRuntimeExports.jsx(AvatarGroupContainer, Object.assign({}, props, { children: Children.map(children, (child, index) => {
            if (child.type === Avatar) {
                const zIndex = numOfChildren - index;
                return (jsxRuntimeExports.jsx(React__default.Fragment, { children: cloneElement(child, {
                        size: size,
                        style: { zIndex: zIndex },
                    }) }, index));
            }
            return child;
        }) })));
}
const AvatarHiddenCount = styled.span `
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    border: 0;
    border-radius: ${(props) => props.theme.radii.full};
    box-sizing: border-box;
    overflow: hidden;
    position: relative;
    min-height: ${(props) => (typeof props.size === 'string' ? circleSizes[props.size] : `${props.size}px`)};
    height: ${(props) => (typeof props.size === 'string' ? circleSizes[props.size] : `${props.size}px`)};
    min-width: ${(props) => (typeof props.size === 'string' ? circleSizes[props.size] : `${props.size}px`)};
    width: ${(props) => (typeof props.size === 'string' ? circleSizes[props.size] : `${props.size}px`)};
    color: ${(props) => props.theme.colors.neutral700};
    background-color: ${(props) => props.theme.colors.neutral200};
    font-size: ${(props) => `${props.fontSize}px`};
    font-weight: 400;
    margin-left: -12px;
`;

function ButtonGroup(_a) {
    var { children, color = 'primary', size = 'medium', variant = 'link' } = _a, props = __rest(_a, ["children", "color", "size", "variant"]);
    if (!children) {
        return null;
    }
    return (jsxRuntimeExports.jsx(ButtonGroupContainer, Object.assign({ "$variant": variant }, props, { children: Children.map(children, (child) => {
            if (child.type === Button) {
                return cloneElement(child, {
                    color: color,
                    size: size,
                    variant: variant,
                });
            }
            return child;
        }) })));
}
const ButtonGroupContainer = styled.div `
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    ${StyledButton$2} {
        &:not(:first-child) {
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
            margin-left: -1px;

            ${(props) => props.$variant &&
    props.$variant === 'solid' &&
    css$3 `
                    border-left-color: white;
                `}

            ${(props) => props.$variant &&
    props.$variant === 'link' &&
    css$3 `
                    padding-left: 16px;
                `}
        }

        &:not(:last-child) {
            border-right: 1px solid ${(props) => props.theme.colors.neutral300};
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;

            ${(props) => props.$variant &&
    props.$variant === 'solid' &&
    css$3 `
                    border-right-color: transparent;
                `}

            ${(props) => props.$variant &&
    props.$variant === 'outline' &&
    css$3 `
                    border-right-color: transparent;
                `}

                ${(props) => props.$variant &&
    props.$variant === 'link' &&
    css$3 `
                    padding-right: 16px;
                `}
        }
    }

    ${sx}
`;

function ButtonRow(_a) {
    var { children, isStackedBelowSmall = false, justify = 'left' } = _a, props = __rest(_a, ["children", "isStackedBelowSmall", "justify"]);
    return (jsxRuntimeExports.jsx(StyledButtonRow$2, Object.assign({ "$isStackedBelowSmall": isStackedBelowSmall, "$justify": justify }, props, { children: children })));
}
const StyledButtonRow$2 = styled.div `
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;

    ${(props) => props.$justify === 'left' &&
    css$3 `
            justify-content: flex-start;
        `}

    ${(props) => props.$justify === 'center' &&
    css$3 `
            justify-content: center;
        `}

    ${(props) => props.$justify === 'right' &&
    css$3 `
            justify-content: flex-end;
        `}

    ${(props) => props.$isStackedBelowSmall &&
    css$3 `
            flex-direction: column-reverse;
            align-items: stretch;

            ${props.theme.mediaQueries.small} {
                flex-direction: row;
                align-items: center;
            }
        `}

    ${sx};
`;

function CardBody(_a) {
    var { children } = _a, props = __rest(_a, ["children"]);
    return jsxRuntimeExports.jsx(StyledCardBody, Object.assign({}, props, { children: children }));
}
const StyledCardBody = styled.div `
    padding: var(--kds-spacing-6);

    ${(props) => props.theme.mediaQueries.large} {
        padding-block: var(--kds-spacing-6);
        padding-inline: var(--kds-spacing-8);
    }
`;

function CardFooter(_a) {
    var { children } = _a, props = __rest(_a, ["children"]);
    return jsxRuntimeExports.jsx(StyledCardFooter, Object.assign({}, props, { children: children }));
}
const StyledCardFooter = styled.div `
    border-top: 1px solid var(--kds-color-border-minimal);
    padding-block: var(--kds-spacing-4);
    padding-inline: var(--kds-spacing-6);

    ${(props) => props.theme.mediaQueries.large} {
        padding-inline: var(--kds-spacing-8);
    }
`;

const headingStyles = {
    xsmall: {
        fontSize: 'sm',
        lineHeight: 5,
    },
    small: {
        fontSize: 'md',
        lineHeight: 6,
    },
    medium: {
        fontSize: ['lg', null, null, 'xl'],
        lineHeight: 7,
    },
    large: {
        fontSize: ['xl', null, null, '2xl'],
        lineHeight: [7, null, null, 8],
    },
    xlarge: {
        fontSize: ['2xl', null, null, '3xl'],
        lineHeight: [8, null, null, 10],
    },
};
function Heading(_a) {
    var { as, size = 'xlarge', fontWeight, isSensitiveData = false, letterSpacing, children } = _a, props = __rest(_a, ["as", "size", "fontWeight", "isSensitiveData", "letterSpacing", "children"]);
    const tags = {
        xlarge: 'h1',
        large: 'h2',
        medium: 'h3',
        small: 'h4',
        xsmall: 'h5',
    };
    return (jsxRuntimeExports.jsx(StyledHeading$2, Object.assign({ as: as !== null && as !== void 0 ? as : tags[size], "data-dd-privacy": isSensitiveData ? 'mask' : 'allow', fontWeight: fontWeight, letterSpacing: letterSpacing, size: size }, props, { children: children })));
}
const StyledHeading$2 = styled.h1.withConfig({ shouldForwardProp })(css$2({
    margin: 0,
    color: kdsColorForegroundSubtle,
}), (props) => !props.letterSpacing &&
    (props.size === 'xlarge' || props.size === 'large' || props.size === 'medium') &&
    css$2({
        letterSpacing: 'tight',
    }), (props) => !props.letterSpacing &&
    (props.size === 'xsmall' || props.size === 'small') &&
    css$2({
        letterSpacing: 'normal',
    }), (props) => !props.fontWeight &&
    (props.size === 'xlarge' || props.size === 'small') &&
    css$2({
        fontWeight: 'bold',
    }), (props) => !props.fontWeight &&
    (props.size === 'large' || props.size === 'medium' || props.size === 'xsmall') &&
    css$2({
        fontWeight: 'medium',
    }), (props) => props.size &&
    variant({
        prop: 'size',
        variants: headingStyles,
    }), compose(space$1, typography), sx);

function CardHeader(_a) {
    var { action, badge, isSensitiveData = false, title, tooltipContent } = _a, props = __rest(_a, ["action", "badge", "isSensitiveData", "title", "tooltipContent"]);
    return (jsxRuntimeExports.jsxs(StyledCardHeader, Object.assign({}, props, { children: [jsxRuntimeExports.jsxs(StyledCardHeaderTitle, { children: [jsxRuntimeExports.jsx(Heading, { "data-dd-privacy": isSensitiveData ? 'mask' : 'allow', size: "large", children: title }), title && tooltipContent && (jsxRuntimeExports.jsx(Tooltip, { content: tooltipContent, children: jsxRuntimeExports.jsx(Icon, { color: "primary", icon: "information", sx: { flexShrink: 0 } }) })), badge && (jsxRuntimeExports.jsx(Badge, { color: badge.color, text: badge.text }))] }), jsxRuntimeExports.jsx(StyledCardHeaderAction, { children: action })] })));
}
const StyledCardHeader = styled.div `
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    min-height: 40px;
    box-sizing: content-box;
    padding-block: var(--kds-spacing-5);
    padding-inline: var(--kds-spacing-6);

    ${(props) => props.theme.mediaQueries.large} {
        padding-inline: var(--kds-spacing-8);
    }
`;
const StyledCardHeaderTitle = styled.div `
    display: flex;
    align-items: center;
    flex-flow: row wrap;
    gap: 8px;
`;
const StyledCardHeaderAction = styled.div ``;

function CardTransition({ type }) {
    return (jsxRuntimeExports.jsx(StyledAnimation, { animate: { height: type === 'edit' ? '100%' : '0%' }, initial: { height: '0%' }, transition: { duration: 0.2, ease: 'easeOut' } }));
}
const StyledAnimation = styled(motion.div) `
    width: 3px;
    border-top-left-radius: var(--kds-border-radius-base);
    border-bottom-left-radius: var(--kds-border-radius-base);
    background: var(--kds-color-primary-700);
    position: absolute;
    left: 0;
    top: 0;
`;

function Card(_a) {
    var { children, sx: sxProp } = _a, props = __rest(_a, ["children", "sx"]);
    return (jsxRuntimeExports.jsx(StyledCard, Object.assign({ sx: sxProp }, props, { children: children })));
}
const StyledCard = styled.div `
    position: relative;
    margin-block-end: var(--kds-spacing-6);
    background-color: var(--kds-color-background-default);
    box-shadow: var(--kds-box-shadow-base);
    border-radius: ${(props) => props.theme.radii.base};

    ${sx}
`;
Card.Header = CardHeader;
Card.Body = CardBody;
Card.Footer = CardFooter;
Card.Transition = CardTransition;

function Ribbon(_a) {
    var { color = 'success', isSensitiveData = false, position = 'top-left', text = 'aanbevolen' } = _a, props = __rest(_a, ["color", "isSensitiveData", "position", "text"]);
    return (jsxRuntimeExports.jsx(StyledRibbonWrapper, Object.assign({ "$position": position, "data-dd-privacy": isSensitiveData ? 'mask' : 'allow' }, props, { children: jsxRuntimeExports.jsx(StyledRibbon, { "$color": color, "$position": position, children: text }) })));
}
const StyledRibbonWrapper = styled.div `
    position: absolute;
    width: 145px;
    height: 125px;
    top: ${(props) => props.$position && (props.$position === 'top-left' || props.$position === 'top-right') && '0'};
    right: ${(props) => props.$position && (props.$position === 'top-right' || props.$position === 'bottom-right') && '0'};
    bottom: ${(props) => props.$position && (props.$position === 'bottom-left' || props.$position === 'bottom-right') && '0'};
    /* stylelint-disable-next-line declaration-block-no-redundant-longhand-properties */
    left: ${(props) => props.$position && (props.$position === 'top-left' || props.$position === 'bottom-left') && '0'};
    overflow: hidden;
    ${sx};
`;
const StyledRibbon = styled.span `
    position: absolute;
    background-color: ${(props) => props.$color && props.theme.ribbon.backgroundColor[props.$color]};
    color: ${(props) => props.$color && props.theme.ribbon.color[props.$color]};
    font-weight: ${(props) => props.theme.fontWeights.medium};
    font-size: ${(props) => props.theme.fontSizes.sm};
    text-align: center;
    width: 150px;
    padding-top: 2px;
    padding-bottom: 5px;
    box-shadow: ${(props) => props.theme.shadows.sm};

    ${(props) => props.$position &&
    props.$position === 'top-left' &&
    css$3 `
            top: 20px;
            left: -30px;
            text-indent: -8px;
            transform: rotate(-39deg);
        `};

    ${(props) => props.$position &&
    props.$position === 'top-right' &&
    css$3 `
            top: 20px;
            right: -30px;
            text-indent: 8px;
            transform: rotate(39deg);
        `};

    ${(props) => props.$position &&
    props.$position === 'bottom-right' &&
    css$3 `
            bottom: 20px;
            right: -30px;
            text-indent: 8px;
            transform: rotate(-39deg);
        `};

    ${(props) => props.$position &&
    props.$position === 'bottom-left' &&
    css$3 `
            bottom: 20px;
            left: -30px;
            text-indent: -8px;
            transform: rotate(39deg);
        `};
`;

function InputCheckmark(_a) {
    var { bodyText, bodyTextFooter, checked = false, color = 'primary', disabled = false, id, inputRef, isFullWidth = false, isSensitiveData = false, label = '', media, name, onChange, ribbonPosition, ribbonText, value, variant = 'single-line' } = _a, props = __rest(_a, ["bodyText", "bodyTextFooter", "checked", "color", "disabled", "id", "inputRef", "isFullWidth", "isSensitiveData", "label", "media", "name", "onChange", "ribbonPosition", "ribbonText", "value", "variant"]);
    const inputId = useUniqueId(id);
    return (jsxRuntimeExports.jsxs(StyledInputCheckmarkContainer, { "$isFullWidth": isFullWidth, "$variant": variant, children: [jsxRuntimeExports.jsx(StyledInputCheckmark, Object.assign({ "$color": color, "$variant": variant, "aria-checked": checked, checked: checked, disabled: disabled, id: inputId, name: name, onChange: onChange, ref: inputRef, type: "checkbox", value: value }, props)), jsxRuntimeExports.jsxs(StyledLabel$2, { "$disabled": disabled, "$variant": variant, "data-dd-privacy": isSensitiveData ? 'mask' : 'allow', htmlFor: inputId, children: [label, media && jsxRuntimeExports.jsx(StyledMedia, { children: media }), bodyText && (jsxRuntimeExports.jsx(StyledBodyText, { "$disabled": disabled, "$variant": variant, children: bodyText })), bodyTextFooter && jsxRuntimeExports.jsx(StyledBodyTextFooter, { "$disabled": disabled, children: bodyTextFooter }), ribbonText && (jsxRuntimeExports.jsx(Ribbon, { position: ribbonPosition, text: ribbonText }))] }), checked && (jsxRuntimeExports.jsx(StyledCheckmark, { "$color": color, children: jsxRuntimeExports.jsx(Icon, { color: "inverse", icon: "check" }) }))] }));
}
const StyledInputCheckmarkContainer = styled.div `
    height: 100%;
    position: relative;

    ${(props) => (props.$variant === 'multi-line' || props.$variant === 'media-card') &&
    css$3 `
            min-width: 210px;
            max-width: 210px;
        `}
    ${(props) => props.$isFullWidth &&
    css$3 `
            width: 100%;
            max-width: 100%;
        `}
`;
const StyledInputCheckmark = styled.input `
    opacity: 0;
    position: fixed;
    width: 0;
    cursor: ${(props) => (props.disabled ? undefined : 'pointer')};

    &:focus + label,
    &:active + label {
        outline: none;
    }

    &:checked + label {
        border-color: ${(props) => props.$variant === 'single-line'
    ? `var(--kds-color-border-medium)`
    : `var(--kds-color-${props.$color}-700)`};
        box-shadow: none;
    }

    &:focus + label {
        border-color: var(--kds-color-border-focused);
        box-shadow: inset 0 0 0 1px var(--kds-color-border-focused);
    }

    &:disabled + label {
        border-color: var(--kds-color-border-disabled);
        background-color: var(--kds-color-background-disabled);
        color: var(--kds-color-foreground-disabled);
    }

    &:disabled:checked + label {
        border-color: var(--kds-color-border-disabled);
        background-color: var(--kds-color-background-disabled);
    }

    &:focus:not(:focus-visible) + label {
        border: 1px solid var(--kds-color-border-medium);
        box-shadow: none;
    }

    &:not(:checked, :disabled):active + label,
    &:not(:checked, :disabled, :focus):hover + label {
        border-color: var(--kds-color-border-strong);
    }

    &:checked:focus + label {
        border-color: ${(props) => props.$variant === 'single-line'
    ? `var(--kds-color-border-medium)`
    : `var(--kds-color-${props.$color}-700)`};
        border-width: 1px;
        outline: 2px solid var(--kds-color-border-focused);
        outline-offset: 2px;
        box-shadow: none;
    }

    &:checked:focus:not(:focus-visible) + label {
        border-color: ${(props) => props.$variant === 'single-line'
    ? `var(--kds-color-border-medium)`
    : `var(--kds-color-${props.$color}-700)`};
        box-shadow: none;
        outline: none;
    }

    &:focus:not(:focus-visible, :checked):hover + label {
        border: 1px solid var(--kds-color-border-strong);
    }
`;
const StyledLabel$2 = styled.label `
    display: block;
    font-size: var(--kds-font-size-sm);
    line-height: var(--kds-line-height-5);
    font-weight: var(--kds-font-weight-normal);
    border-radius: var(--kds-border-radius-medium);
    color: var(--kds-color-foreground-default);
    border: 1px solid var(--kds-color-border-medium);
    cursor: ${(props) => (props.$disabled ? undefined : 'pointer')};
    margin: 0;
    user-select: none;
    background-color: var(--kds-color-background-default);
    height: 100%;

    ${(props) => props.$variant === 'single-line' &&
    css$3 `
            padding: 12px 16px;
        `}

    ${(props) => (props.$variant === 'multi-line' || props.$variant === 'media-card') &&
    css$3 `
            padding: 20px 24px 24px;
            font-weight: var(--kds-font-weight-medium);
        `}
`;
const StyledBodyText = styled.span `
    display: block;
    margin: 0;
    margin-top: 8px;
    color: ${(props) => props.$disabled ? `var(--kds-color-foreground-disabled);` : `var(--kds-color-foreground-default)`};
    user-select: none;
    font-weight: var(--kds-font-weight-normal);

    ${(props) => props.$variant === 'media-card' &&
    css$3 `
            text-align: center;
        `}
`;
const StyledBodyTextFooter = styled.span `
    display: block;
    word-break: break-word;
    hyphens: auto;
    margin: 0;
    font-weight: var(--kds-font-weight-medium);
    color: ${(props) => props.$disabled ? `var(--kds-color-foreground-disabled);` : `var(--kds-color-foreground-default)`};
    text-align: center;
    user-select: none;
`;
const StyledMedia = styled.div `
    display: flex;
    place-content: center center;
    justify-content: center;
    margin: 10px 20px;
`;
const StyledCheckmark = styled.div `
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(50%, -50%) scale(1);
    opacity: 1;
    animation: scale-up 0.2s cubic-bezier(0.75, -0.5, 0, 1.75);
    border-radius: var(--kds-border-radius-full);
    background-color: ${(props) => `var(--kds-color-${props.$color}-700)`};

    @keyframes scale-up {
        0% {
            transform: translate(50%, -50%) scale(0);
            opacity: 0;
        }

        100% {
            transform: translate(50%, -50%) scale(1);
            opacity: 1;
        }
    }
`;

function CheckboxGroup({ children, error, layout = 'column', onChange, value }) {
    const handleChange = (event) => {
        const newValue = event.target.value;
        const isChecked = event.target.checked;
        onChange === null || onChange === void 0 ? void 0 : onChange(isChecked ? [...(value || []), newValue] : (value || []).filter((val) => val !== newValue));
    };
    return (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx(StyledCheckboxGroup, { "$layout": layout, children: Children.map(children, (child) => {
                    var _a;
                    if (child.type === Checkbox || child.type === InputCheckmark) {
                        const isChecked = (value || []).includes((_a = child.props.value) !== null && _a !== void 0 ? _a : '');
                        return cloneElement(child, {
                            checked: isChecked,
                            onChange: (event) => handleChange(event),
                        });
                    }
                    return child;
                }) }), error && jsxRuntimeExports.jsx(FormErrorMessage, { children: error })] }));
}
const StyledCheckboxGroup = styled.div `
    /* stylelint-disable declaration-block-no-redundant-longhand-properties */
    display: flex;
    flex-direction: ${(props) => (props.$layout === 'row' ? 'row' : 'column')};
    flex-wrap: ${(props) => (props.$layout === 'row' ? 'wrap' : 'nowrap')};

    ${StyledCheckboxContainer} {
        margin: 4px 0;
    }

    ${StyledInputCheckmarkContainer} {
        ${(props) => props.$layout === 'row' &&
    css$3 `
                margin: 12px 16px 8px 0;
            `}

        ${(props) => props.$layout === 'column' &&
    css$3 `
                margin: 12px 0 4px;
            `}
    }
`;

function createCheckboxOptions({ data, onChange }) {
    return Object.entries(data).map(([key, { displayValue, hasTextInput, value }]) => {
        const isChecked = Boolean(value) || (Boolean(hasTextInput) && value === '');
        const baseObject = {
            isChecked,
            label: displayValue,
            onChange: (e) => handleChange({
                data,
                key,
                newValue: hasTextInput ? e.target.value : e.target.checked,
                onChange,
            }),
        };
        return hasTextInput
            ? Object.assign(Object.assign({}, baseObject), { textInput: {
                    'aria-label': displayValue,
                    onChange: baseObject.onChange,
                    value: value === undefined ? '' : value,
                } }) : baseObject;
    });
}
const handleChange = ({ data, key, newValue, onChange, }) => {
    const newData = cloneDeep(data);
    newData[key].value = newValue;
    return onChange === null || onChange === void 0 ? void 0 : onChange(newData);
};

/**
 * Extracts initial text input values from a CheckboxGroupWithTextInputData object.
 *
 * This function iterates over the provided CheckboxGroupWithTextInputData object and collects
 * the initial values of text inputs associated with checkboxes. It returns a record
 * where the keys are the display values of checkboxes that have associated text inputs,
 * and the values are the corresponding text input values.
 *
 * @param data - The CheckboxGroupWithTextInputData object containing checkbox information.
 *               Each key in this object represents a checkbox option, and the value
 *               is an object containing details about the checkbox.
 * @returns A record where the keys are the display values of checkboxes with text inputs,
 *          and the values are the corresponding text input values.
 *
 * @example
 * const data: CheckboxGroupWithTextInputData = {
 *     option1: { displayValue: 'Option 1', hasTextInput: true, value: 'text1' },
 *     option2: { displayValue: 'Option 2', value: true },
 *     option3: { displayValue: 'Option 3', hasTextInput: true, value: 'text3' },
 * };
 * const result = getInitialTextInputValues(data);
 * console.log(result); // { 'Option 1': 'text1', 'Option 3': 'text3' }
 *
 * @remarks
 * This function assumes that the `value` property of checkboxes with text inputs
 * is always a string. If the `value` property is not a string, it will be cast to a string.
 *
 * @see CheckboxGroupWithTextInputData for the structure of the data object.
 */
function getInitialTextInputValues(data) {
    return Object.values(data).reduce((acc, { displayValue, hasTextInput, value }) => {
        if (hasTextInput && value) {
            acc[displayValue] = value;
        }
        return acc;
    }, {});
}

function CheckboxGroupWithTextInput({ data, error, onChange }) {
    const [isChecked, setIsChecked] = useState({});
    const [textInputValues, setTextInputValues] = useState(getInitialTextInputValues(data));
    const handleChangeCheckbox = (event, label, onChangeTextInput) => {
        // Reset the text input value in the onchange when the checkbox is unchecked, so it will not be saved
        onChangeTextInput({
            target: { value: !event.target.checked ? '' : textInputValues[label] },
        });
        setIsChecked(Object.assign(Object.assign({}, isChecked), { [label]: event.target.checked }));
    };
    const checkboxOptions = createCheckboxOptions({
        data,
        onChange,
    });
    function getTextInputProps(label, textInput, inputValues) {
        const { onChange: onChangeTextInput } = textInput;
        return {
            'aria-label': label,
            onChange: (event) => {
                onChangeTextInput(event);
                setTextInputValues(Object.assign(Object.assign({}, textInputValues), { [label]: event.target.value }));
            },
            value: inputValues[label] || (textInput === null || textInput === void 0 ? void 0 : textInput.value) || '',
        };
    }
    return (jsxRuntimeExports.jsxs(StyledCheckboxGroup, { "$layout": "column", children: [checkboxOptions.map(({ isChecked: checkboxIsChecked, label, onChange: checkboxOnChange, textInput }, index) => {
                return (jsxRuntimeExports.jsx(Checkbox, { checked: textInput ? isChecked[label] || Boolean(textInput.value) : checkboxIsChecked, label: label, onChange: (event) => textInput
                        ? handleChangeCheckbox(event, label, textInput.onChange)
                        : checkboxOnChange(event), textInput: textInput && getTextInputProps(label, textInput, textInputValues) }, index));
            }), error && jsxRuntimeExports.jsx(FormErrorMessage, { children: error })] }));
}

function Collapse({ children, isOpen }) {
    return (jsxRuntimeExports.jsx(Accordion, { collapsible: true, type: "single", value: isOpen ? 'collapse' : '', children: jsxRuntimeExports.jsx(AccordionItem, { value: "collapse", children: jsxRuntimeExports.jsx(AccordionContent, { children: children }) }) }));
}

function Collection(_a) {
    var { children, type = 'ul' } = _a, props = __rest(_a, ["children", "type"]);
    return (jsxRuntimeExports.jsx(StyledCollection, Object.assign({ as: type }, props, { children: children })));
}
const StyledCollection = styled.ul `
    width: 100%;
    margin: 0;
    padding: 0;

    ${sx}
`;

function CollectionItem(_a) {
    var { alignItems = 'center', children, mediaItem, padding = 'medium', subtitle, title } = _a, props = __rest(_a, ["alignItems", "children", "mediaItem", "padding", "subtitle", "title"]);
    return (jsxRuntimeExports.jsxs(StyledCollectionItem, Object.assign({ "$padding": padding, alignItems: alignItems }, props, { children: [jsxRuntimeExports.jsxs(Box, { alignItems: alignItems, display: "flex", flexDirection: "row", minWidth: 0, children: [mediaItem && (jsxRuntimeExports.jsx(StyledFigure$1, { children: jsxRuntimeExports.jsx(StyledMediaItem$1, { children: mediaItem }) })), jsxRuntimeExports.jsxs(Box, { alignSelf: alignItems, display: "inline-block", minWidth: 0, children: [title && (jsxRuntimeExports.jsx(StyledText$3, { fontWeight: "medium", size: "md", children: title })), subtitle && (jsxRuntimeExports.jsx(Text, { as: "p", color: "minimal", size: "sm", children: subtitle }))] })] }), jsxRuntimeExports.jsx(Box, { alignSelf: alignItems, display: "inline-block", style: { marginLeft: 'auto' }, children: children })] })));
}
const StyledText$3 = styled(Text) `
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;
const StyledCollectionItem = styled.li.withConfig({ shouldForwardProp }) `
    display: flex;
    position: relative;
    margin: 0;
    line-height: 1;
    box-shadow: none;
    list-style: none;
    justify-content: space-between;
    flex-wrap: nowrap;
    ${flexbox}

    &:not(:last-child) {
        box-shadow: 0 2px 0 -1px rgb(236 236 230/ 100%);
    }

    ${(props) => props.$padding &&
    props.$padding === 'small' &&
    css$3 `
            padding: 8px;

            ${props.theme.mediaQueries.medium} {
                padding: 8px 16px;
            }
        `}

    ${(props) => props.$padding &&
    props.$padding === 'medium' &&
    css$3 `
            padding: 16px;

            ${props.theme.mediaQueries.medium} {
                padding: 16px 24px;
            }
        `}
    ${sx}
`;
const StyledFigure$1 = styled.figure `
    flex: 0 0 auto;
    margin: 0 16px 0 0;

    ${(props) => props.theme.mediaQueries.medium} {
        margin: 0 24px 0 0;
    }
`;
const StyledMediaItem$1 = styled.div `
    display: flex;
`;

function CollectionLink(_a) {
    var { alignItems = 'center', as, children, icon = 'caret-right-big', mediaItem, onClick, padding = 'medium', subtitle, title, to } = _a, props = __rest(_a, ["alignItems", "as", "children", "icon", "mediaItem", "onClick", "padding", "subtitle", "title", "to"]);
    return (jsxRuntimeExports.jsxs(StyledCollectionLink, Object.assign({ "$padding": padding, alignItems: alignItems, as: as, onClick: onClick, to: to }, props, { children: [jsxRuntimeExports.jsxs(Box, { alignItems: alignItems, display: "flex", flexDirection: "row", minWidth: 0, children: [mediaItem && (jsxRuntimeExports.jsx(StyledFigure, { children: jsxRuntimeExports.jsx(StyledMediaItem, { children: mediaItem }) })), jsxRuntimeExports.jsxs(Box, { alignSelf: alignItems, display: "inline-block", minWidth: 0, children: [title && (jsxRuntimeExports.jsx(StyledText$2, { fontWeight: "medium", size: "md", children: title })), subtitle && (jsxRuntimeExports.jsx(Text, { as: "p", color: "minimal", size: "sm", children: subtitle }))] })] }), jsxRuntimeExports.jsx(Box, { alignSelf: alignItems, display: "inline-block", children: children }), icon && (jsxRuntimeExports.jsx(StyledIcon$a, { "aria-hidden": "true", icon: icon }))] })));
}
const StyledText$2 = styled(Text) `
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;
const StyledIcon$a = styled(Icon) ``;
const StyledCollectionLink = styled.a.withConfig({ shouldForwardProp }) `
    display: flex;
    position: relative;
    margin: 0;
    box-shadow: none;
    transition: all cubic-bezier(${(props) => props.theme.collection.link.easing});
    cursor: pointer;
    text-decoration: none;
    color: inherit;
    justify-content: space-between;
    flex-wrap: nowrap;
    ${flexbox}

    &:not(:last-child) {
        box-shadow: 0 2px 0 -1px var(--kds-color-border-minimal);
    }

    &:hover {
        background: ${(props) => props.theme.collection.link.hoverColor};
        text-decoration: none;

        ${StyledIcon$a} {
            transform: translateX(3px);
            color: ${(props) => props.theme.collection.icon.hoverColor};
        }
    }

    &:focus {
        outline: none;
        box-shadow: 0 0 10px 1px var(--kds-color-border-minimal);
    }

    &:focus:not(:focus-visible) {
        outline: none;

        &:not(:last-child) {
            box-shadow: 0 2px 0 -1px var(--kds-color-border-minimal);
        }
    }

    ${(props) => props.$padding &&
    props.$padding === 'small' &&
    css$3 `
            padding: 8px 32px 8px 8px;

            ${props.theme.mediaQueries.medium} {
                padding: 8px 48px 8px 8px;
            }
        `}

    ${(props) => props.$padding &&
    props.$padding === 'medium' &&
    css$3 `
            padding: 16px 48px 16px 16px;

            ${props.theme.mediaQueries.medium} {
                padding: 16px 64px 16px 24px;
            }
        `}

       ${StyledIcon$a} {
        min-width: 18px;
        min-height: 18px;
        align-self: center;
        margin-left: 32px;
        color: ${(props) => props.theme.collection.icon.color};
        transition: all cubic-bezier(${(props) => props.theme.collection.icon.easing}) 0.2s;
        position: absolute;
        right: 16px;

        ${(props) => props.theme.mediaQueries.medium} {
            right: 24px;
        }
    }

    ${sx}
`;
const StyledFigure = styled.figure `
    flex: 0 0 auto;
    margin: 0 16px 0 0;

    ${(props) => props.theme.mediaQueries.medium} {
        margin: 0 24px 0 0;
    }
`;
const StyledMediaItem = styled.div `
    display: flex;
`;

/**
 * `useEvent` is a custom hook that provides utility functions for handling events in React.
 * It returns an object containing a method `convertToInputFocusEvent`.
 *
 * `convertToInputFocusEvent` is a method that converts a React.FocusEvent into a new event with the target.name property set to the provided name.
 * This can be useful when you want to handle multiple input fields with a single event handler function,
 * and you need to know which input field triggered the event.
 *
 * @param {React.FocusEvent} event - The original event.
 * @param {string | undefined} name - The name to set on the target of the new event.
 * @returns {Object} An object containing utility functions for event handling.
 * @returns {React.FocusEvent<HTMLInputElement>} A new event with the target.name property set to the provided name.
 *
 * @example
 * ```jsx
 * import { useEvent } from './use-event';
 *
 * function MyComponent() {
 *   const { convertToInputFocusEvent } = useEvent();
 *
 *   const handleFocus = (event) => {
 *     const newEvent = convertToInputFocusEvent(event, 'myInput');
 *     // Now newEvent.target.name is 'myInput'
 *   };
 *
 *   return <input onFocus={handleFocus} />;
 * }
 * ```
 *
 * @function
 * @name useEvent
 */
function useEvent() {
    return {
        convertToInputFocusEvent: (event, name) => (Object.assign(Object.assign({}, event), { target: Object.assign(Object.assign({}, event.target), { name: name !== null && name !== void 0 ? name : '' }) })),
    };
}

function parseDateString(rawDateString) {
    const dateString = rawDateString.trim();
    //It first tries to parse the date string in DMY format then in MDY format
    //You can add or remove date formats as needed
    const dateFormatsDMYorMDY = [
        'DD-MM-YYYY',
        'DD/MM/YYYY',
        'DD.MM.YYYY',
        'DD MM YYYY',
        'D-M-YYYY',
        'D/M/YYYY',
        'D.M.YYYY',
        'D M YYYY',
        'MM-DD-YYYY',
        'MM/DD/YYYY',
        'MM.DD.YYYY',
        'MM DD YYYY',
    ];
    const dateDMYorMDY = DateTime.parseExact(dateString, dateFormatsDMYorMDY).tz('UTC', true);
    if (dateDMYorMDY.isValid()) {
        return dateDMYorMDY.toDate();
    }
    //If the date string is not in DMY or MDY format, it tries to parse it as a date string in ISO format
    const dateOther = DateTime.parse(dateString).tz('UTC', true);
    if (dateOther.isValid()) {
        return dateOther.toDate();
    }
    return undefined;
}

function DateInput(_a) {
    var _b;
    var { error, label, maxValue, minValue, name, onBlur, onChange, size, sx: sxProp, value } = _a, props = __rest(_a, ["error", "label", "maxValue", "minValue", "name", "onBlur", "onChange", "size", "sx", "value"]);
    const { size: formGroupContextSize } = useContext(FormGroupContext);
    const { convertToInputFocusEvent } = useEvent();
    const sizeProp = (_b = size !== null && size !== void 0 ? size : formGroupContextSize) !== null && _b !== void 0 ? _b : 'large';
    const handleBlur = (event) => {
        if (onBlur) {
            onBlur(convertToInputFocusEvent(event, name));
        }
    };
    const handleChange = (newValue) => {
        if (onChange) {
            if (newValue === null) {
                onChange(null);
            }
            else {
                onChange(newValue.toDate(getLocalTimeZone()));
            }
        }
    };
    const handlePaste = (evt) => {
        const pastedDate = parseDateString(evt.clipboardData.getData('text'));
        if (pastedDate) {
            evt.preventDefault();
            onChange(pastedDate);
        }
    };
    return (jsxRuntimeExports.jsxs(StyledDateInput, { "$size": sizeProp, onPaste: handlePaste, sx: sxProp, children: [jsxRuntimeExports.jsxs(DateField, Object.assign({}, props, { isInvalid: !!error, maxValue: maxValue && parseDate(DateTime.from(maxValue).format('YYYY-MM-DD')), minValue: minValue && parseDate(DateTime.from(minValue).format('YYYY-MM-DD')), onBlur: handleBlur, onChange: handleChange, placeholderValue: parseDate('2025-01-01'), shouldForceLeadingZeros: true, value: value === null ? null : parseDate(DateTime.from(value).format('YYYY-MM-DD')), children: [jsxRuntimeExports.jsx(Label, { hidden: true, children: label }), jsxRuntimeExports.jsx(DateInput$1, { children: (segment) => jsxRuntimeExports.jsx(DateSegment, { segment: segment }) })] })), error && jsxRuntimeExports.jsx(FormErrorMessage, { children: error })] }));
}
const StyledDateInput = styled.div `
    .react-aria-DateInput {
        display: flex;
        padding: 7px 12px;
        border: 1px solid var(--kds-color-border-medium);
        border-radius: var(--kds-border-radius-base);
        color: var(--kds-color-foreground-default);
        background-color: white;
        width: fit-content;
        min-width: 144px;
        white-space: nowrap;
        transition: all 0.2s;

        ${(props) => props.$size === 'medium' &&
    css$3 `
                ${props.theme.mediaQueries.small} {
                    padding: 8px 12px;
                    min-width: 128px;
                }
            `};

        &[data-invalid] {
            border: 1px solid var(--kds-color-border-warning);
        }

        &:focus-within {
            outline: none;
            border-color: var(--kds-color-border-focused);
            box-shadow: 0 0 0 4px var(--kds-color-shadow-focused);

            &[data-invalid] {
                border-color: var(--kds-color-border-warning);
                box-shadow: 0 0 0 4px var(--kds-color-shadow-warning);
            }
        }

        &[data-disabled] {
            color: var(--kds-color-foreground-disabled);
            background-color: var(--kds-color-background-disabled);
            border-color: var(--kds-color-border-disabled);
            pointer-events: none;
            user-select: none;
        }
    }

    .react-aria-DateSegment {
        padding: 0 2px;
        font-size: var(--kds-font-size-input-large);
        line-height: var(--kds-line-height-input-large);
        font-weight: var(--kds-font-weight-input);
        text-align: end;
        color: var(--kds-color-foreground-default);

        ${(props) => props.$size === 'medium' &&
    css$3 `
                ${props.theme.mediaQueries.small} {
                    font-size: var(--kds-font-size-input-medium);
                    line-height: var(--kds-line-height-input-medium);
                }
            `};

        &[data-type='literal'] {
            padding: 0;
        }

        &[data-placeholder] {
            font-weight: var(--kds-font-weight-placeholder);
            color: var(--kds-color-foreground-minimal);
        }

        &:focus {
            background: ${(props) => props.theme.colors.blue100};
            outline: none;
            border-radius: var(--kds-border-radius-base);
            caret-color: transparent;
        }

        &[data-disabled] {
            color: var(--kds-color-foreground-disabled);
            border-color: var(--kds-color-border-disabled);
            pointer-events: none;
            user-select: none;
        }
    }
    ${sx}
`;

function DatePicker(_a) {
    var _b;
    var { color = 'primary', error, label, maxValue, minValue, name, onBlur, onChange, size, sx: sxProp, value } = _a, props = __rest(_a, ["color", "error", "label", "maxValue", "minValue", "name", "onBlur", "onChange", "size", "sx", "value"]);
    const { size: formGroupContextSize } = useContext(FormGroupContext);
    const { convertToInputFocusEvent } = useEvent();
    const sizeProp = (_b = size !== null && size !== void 0 ? size : formGroupContextSize) !== null && _b !== void 0 ? _b : 'large';
    const handleBlur = (event) => {
        if (onBlur) {
            onBlur(convertToInputFocusEvent(event, name));
        }
    };
    const handleChange = (newValue) => {
        if (onChange) {
            if (newValue === null) {
                onChange(null);
            }
            else {
                onChange(newValue.toDate(getLocalTimeZone()));
            }
        }
    };
    const handlePaste = (evt) => {
        const pastedDate = parseDateString(evt.clipboardData.getData('text'));
        if (pastedDate) {
            evt.preventDefault();
            handleChange(new CalendarDateTime(pastedDate.getFullYear(), pastedDate.getMonth() + 1, pastedDate.getDate()));
        }
    };
    return (jsxRuntimeExports.jsx(StyledDatePicker, { "$size": sizeProp, onPaste: handlePaste, sx: sxProp, children: jsxRuntimeExports.jsxs(DatePicker$1, Object.assign({}, props, { isInvalid: !!error, maxValue: maxValue && parseDate(DateTime.from(maxValue).format('YYYY-MM-DD')), minValue: minValue && parseDate(DateTime.from(minValue).format('YYYY-MM-DD')), onBlur: handleBlur, onChange: handleChange, shouldForceLeadingZeros: true, value: value === null ? null : parseDate(DateTime.from(value).format('YYYY-MM-DD')), children: [jsxRuntimeExports.jsx(Label, { hidden: true, children: label }), jsxRuntimeExports.jsxs(Group$2, { children: [jsxRuntimeExports.jsx(DateInput$1, { children: (segment) => jsxRuntimeExports.jsx(DateSegment, { segment: segment }) }), jsxRuntimeExports.jsx(Button$1, { children: jsxRuntimeExports.jsx(StyledIcon$9, { color: color, icon: "calender" }) })] }), error && jsxRuntimeExports.jsx(FormErrorMessage, { children: error }), jsxRuntimeExports.jsx(StyledRAPopover$1, { children: jsxRuntimeExports.jsx(Dialog, { children: jsxRuntimeExports.jsxs(StyledRACalendar, { children: [jsxRuntimeExports.jsxs(StyledRAHeader, { children: [jsxRuntimeExports.jsx(Heading$1, {}), jsxRuntimeExports.jsx(IconButton, { as: Button$1, icon: "caret-left", slot: "previous" }), jsxRuntimeExports.jsx(IconButton, { as: Button$1, icon: "caret-right", slot: "next", sx: { ml: 2 } })] }), jsxRuntimeExports.jsx(CalendarGrid, { weekdayStyle: "short", children: (date) => jsxRuntimeExports.jsx(StyledRACalendarCell, { date: date }) })] }) }) })] })) }));
}
const StyledIcon$9 = styled(Icon) ``;
const StyledDatePicker = styled(StyledDateInput) `
    .react-aria-DatePicker {
        .react-aria-Group {
            display: flex;
            width: fit-content;
            align-items: center;
            min-width: 168px;

            ${(props) => props.$size === 'medium' &&
    css$3 `
                    ${props.theme.mediaQueries.small} {
                        min-width: 152px;
                    }
                `};

            .react-aria-DateInput {
                min-width: 168px;

                ${(props) => props.$size === 'medium' &&
    css$3 `
                        ${props.theme.mediaQueries.small} {
                            min-width: 152px;
                        }
                    `};
            }

            &[data-disabled] {
                .react-aria-DateInput {
                    color: var(--kds-color-foreground-disabled);
                    background-color: var(--kds-color-background-disabled);
                    border-color: var(--kds-color-border-disabled);
                    pointer-events: none;
                    user-select: none;
                }
            }
        }

        .react-aria-Button {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 28px;
            height: 28px;
            border-radius: 4px;
            background: ${(props) => props.theme.colors.white};
            border: none;
            appearance: none;
            margin-left: -2.2rem;
            padding: 0;
            vertical-align: middle;
            outline: none;
            box-sizing: content-box;

            &[data-focus-visible] {
                background-color: ${(props) => props.theme.colors.blue100};
            }

            &[data-disabled] {
                background-color: var(--kds-color-background-disabled);

                ${StyledIcon$9} {
                    color: var(--kds-color-foreground-disabled);
                }
            }
        }
    }

    ${sx}
`;
const StyledRAPopover$1 = styled(Popover$1) `
    &[data-placement='top'] {
        --origin: translateY(8px);
    }

    &[data-placement='bottom'] {
        --origin: translateY(-8px);
    }

    &[data-entering] {
        animation: slide 200ms;
    }

    &[data-exiting] {
        animation: slide 200ms reverse ease-in;
    }

    @keyframes slide {
        from {
            transform: var(--origin);
            opacity: 0;
        }

        to {
            transform: translateY(0);
            opacity: 1;
        }
    }
`;
const StyledRACalendar = styled(Calendar) `
    width: fit-content;
    box-shadow: ${(props) => props.theme.shadows.md};
    padding: 17px 16px 16px;
    background-color: ${(props) => props.theme.colors.white};
    border-radius: ${(props) => props.theme.radii.base};

    .react-aria-CalendarHeaderCell {
        font-size: ${(props) => props.theme.fontSizes.sm};
        font-weight: ${(props) => props.theme.fontWeights.medium};
        line-height: ${(props) => props.theme.lineHeights[5]};
        color: ${(props) => props.theme.colors.neutral800};
        width: 44px;
        height: 44px;
        text-align: center;
    }
`;
const StyledRAHeader = styled.header `
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 0;
    padding-bottom: 0;
    padding-left: 10px;

    .react-aria-Heading {
        font-size: ${(props) => props.theme.fontSizes.lg};
        line-height: ${(props) => props.theme.lineHeights.none};
        font-weight: ${(props) => props.theme.fontWeights.medium};
        color: ${(props) => props.theme.colors.neutral900};
        margin-bottom: 0;
        flex: 1;
    }
`;
const StyledRACalendarCell = styled(CalendarCell) `
    box-sizing: border-box;
    width: 44px;
    height: 44px;
    text-align: center;
    font-size: ${(props) => props.theme.fontSizes.sm};
    font-weight: ${(props) => props.theme.fontWeights.normal};
    line-height: 44px;
    border-radius: ${(props) => props.theme.radii.full};
    margin: -1px;
    outline: none;

    ${(props) => isToday(props.date, getLocalTimeZone()) &&
    css$3 `
            position: relative;
            color: ${props.theme.colors.blue700};
            font-weight: ${props.theme.fontWeights.medium};

            &::after {
                content: '';
                width: 4px;
                height: 4px;
                background-color: ${props.theme.colors.blue700};
                position: absolute;
                bottom: 8px;
                left: 50%;
                margin-left: -2px;
                border-radius: ${props.theme.radii.full};
            }

            &[data-selected] {
                &::after {
                    background-color: white;
                }
            }

            &[data-disabled] {
                &::after {
                    background-color: ${props.theme.colors.neutral300};
                }
            }
        `};

    &[data-outside-month] {
        display: none;
    }

    &[data-focus-visible] {
        box-shadow: ${(props) => `inset 0 0 0 2px ${props.theme.colors.blue500}, inset 0 0 0 4px ${props.theme.colors.white}`};
    }

    &[data-hovered] {
        background-color: ${(props) => props.theme.colors.blue100};
    }

    &[data-selected] {
        color: ${(props) => props.theme.colors.white};
        background-color: ${(props) => props.theme.colors.blue700};
        font-weight: ${(props) => props.theme.fontWeights.medium};
    }

    &[data-disabled] {
        color: var(--kds-color-foreground-disabled);
        cursor: default;
    }
`;

const spacingOptions = {
    large: '32px',
    medium: '24px',
    small: '16px',
};
function Divider({ color = 'subtle', orientation = 'horizontal', spacing = 'large' }) {
    return (jsxRuntimeExports.jsx(StyledDivider, { "$color": color, "$orientation": orientation, "$spacing": spacing, "aria-orientation": orientation, role: "separator" }));
}
const StyledDivider = styled.hr `
    /* Show the overflow for hr in Edge and IE. */
    overflow: visible;
    border: none;
    border-width: 1px;
    margin: 0;
    align-self: stretch;
    opacity: 1;
    background-color: ${(props) => `var(--kds-color-border-${props.$color})`};

    ${(props) => props.$spacing &&
    props.$orientation === 'horizontal' &&
    css$3 `
            height: 1px;
            width: 100%;
            margin-top: ${spacingOptions[props.$spacing]};
            margin-bottom: ${spacingOptions[props.$spacing]};
        `}
    ${(props) => props.$spacing &&
    props.$orientation === 'vertical' &&
    css$3 `
            height: 100%;
            width: 1px;
            margin-left: ${spacingOptions[props.$spacing]};
            margin-right: ${spacingOptions[props.$spacing]};

            &:not([size]) {
                height: 100%;
            }
        `};
`;

function useOutsideClick({ handler, ref }) {
    useEffect(() => {
        const listener = (event) => {
            const el = ref === null || ref === void 0 ? void 0 : ref.current;
            // Do nothing if clicking ref's element or descendent elements
            if (!el || el.contains(event.target)) {
                return;
            }
            handler(event);
        };
        document.addEventListener(`mousedown`, listener);
        return () => {
            document.removeEventListener(`mousedown`, listener);
        };
        // Reload only if ref or handler changes
    }, [ref, handler]);
}

function useUnmountEffect(fn, deps = []) {
    return React.useEffect(() => () => fn(), deps);
}

function useForceUpdate() {
    const unloadingRef = React.useRef(false);
    const [count, setCount] = React.useState(0);
    useUnmountEffect(() => {
        unloadingRef.current = true;
    });
    return React.useCallback(() => {
        if (!unloadingRef.current) {
            setCount(count + 1);
        }
    }, [count]);
}

/**
 * Renders a React subtree in a different part of the DOM. Appends to `document.body`.
 */
function Portal({ children }) {
    const tempNode = useRef(null);
    const portal = useRef(null);
    const forceUpdate = useForceUpdate();
    useLayoutEffect(() => {
        var _a;
        if (!tempNode.current) {
            return;
        }
        const doc = (_a = tempNode.current) === null || _a === void 0 ? void 0 : _a.ownerDocument;
        const host = doc.body;
        if (!host) {
            return;
        }
        portal.current = doc.createElement('div');
        host.appendChild(portal.current);
        forceUpdate();
        const portalNode = portal.current;
        return () => {
            if (host.contains(portalNode)) {
                host.removeChild(portalNode);
            }
        };
    }, []);
    return portal.current ? createPortal(jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: children }), portal.current) : jsxRuntimeExports.jsx("span", { ref: tempNode });
}

function DrawerBody(_a) {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (jsxRuntimeExports.jsx(StyledDrawerBody, Object.assign({ sx: sx }, props, { children: children })));
}
const StyledDrawerBody = styled.div(css$2({
    flex: 1,
    overflow: 'auto',
    px: [6, 8],
}), sx);

const DrawerContext = createContext({});

function DrawerCloseButton(_a) {
    var { children, icon = 'close', labelText = 'close', size = 'medium', variant = 'default' } = _a, props = __rest(_a, ["children", "icon", "labelText", "size", "variant"]);
    const { onClose } = useContext(DrawerContext);
    return (jsxRuntimeExports.jsx(StyledDrawerCloseButton, Object.assign({ icon: icon, labelText: labelText, onClick: onClose, size: size, sx: sx, variant: variant }, props, { children: children })));
}
const StyledDrawerCloseButton = styled(IconButton)(css$2({
    position: 'absolute',
    right: [3, 4],
    top: [2, 4],
}), sx);

function DrawerFooter(_a) {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (jsxRuntimeExports.jsx(StyledButtonRow$1, Object.assign({ isStackedBelowSmall: true, justify: "right", sx: sx }, props, { children: children })));
}
const StyledButtonRow$1 = styled(ButtonRow)(css$2({
    p: [6, 8],
}), sx);

function DrawerHeader(_a) {
    var { children } = _a, props = __rest(_a, ["children"]);
    return jsxRuntimeExports.jsx(StyledHeader$4, Object.assign({}, props, { children: children }));
}
const StyledHeader$4 = styled.header(css$2({
    color: 'neutral700',
    fontSize: ['xl', null, null, '2xl'],
    fontWeight: 'medium',
    letterSpacing: 'tight',
    lineHeight: [7, null, null, 8],
    px: [6, 8],
    py: [4, 6],
}), sx);

/**
 * The Drawer component is a panel that slides out from the edge of the screen.
 * It can be useful when you need users to complete a task or view some details without leaving the current page.
 */
function Drawer(_a) {
    var { children, closeOnEsc = true, closeOnOverlayClick = true, isOpen = false, onClose, onCloseComplete, position = 'right', size = 'medium' } = _a, props = __rest(_a, ["children", "closeOnEsc", "closeOnOverlayClick", "isOpen", "onClose", "onCloseComplete", "position", "size"]);
    const drawerRef = useRef(null);
    const triggerRef = useRef(null);
    setNonce(window.__webpack_nonce__);
    useOutsideClick({
        handler: (event) => {
            var _a;
            if (!((_a = triggerRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.target))) {
                if (closeOnOverlayClick) {
                    onClose();
                }
            }
        },
        ref: drawerRef,
    });
    const overlayVariants = {
        enter: {
            opacity: 1,
            transition: {
                duration: 0.2,
            },
        },
        exit: {
            opacity: 0,
            transition: {
                duration: 0.1,
            },
        },
    };
    const drawerVariants = {
        bottom: {
            enter: {
                transition: {
                    duration: 0.3,
                },
                x: 0,
                y: 0,
            },
            exit: {
                transition: {
                    duration: 0.2,
                },
                x: 0,
                y: '100%',
            },
        },
        left: {
            enter: {
                transition: {
                    duration: 0.3,
                },
                x: 0,
                y: 0,
            },
            exit: {
                transition: {
                    duration: 0.2,
                },
                x: '-100%',
                y: 0,
            },
        },
        right: {
            enter: {
                transition: {
                    duration: 0.3,
                },
                x: 0,
                y: 0,
            },
            exit: {
                transition: {
                    duration: 0.2,
                },
                x: '100%',
                y: 0,
            },
        },
        top: {
            enter: {
                transition: {
                    duration: 0.3,
                },
                x: 0,
                y: 0,
            },
            exit: {
                transition: {
                    duration: 0.2,
                },
                x: 0,
                y: '-100%',
            },
        },
    };
    const onKeyDown = useCallback((event) => {
        if (event.key === 'Escape') {
            event.stopPropagation();
            if (closeOnEsc) {
                onClose === null || onClose === void 0 ? void 0 : onClose();
            }
        }
    }, [closeOnEsc, onClose]);
    const animate = isOpen ? 'enter' : 'exit';
    return (jsxRuntimeExports.jsx(DrawerContext.Provider, { value: { isOpen, onClose, size }, children: jsxRuntimeExports.jsx(AnimatePresence, { onExitComplete: onCloseComplete, children: isOpen && (jsxRuntimeExports.jsxs(Portal, { children: [jsxRuntimeExports.jsx(StyledMotionOverlay$1, { animate: animate, exit: "exit", initial: "exit", ref: triggerRef, variants: overlayVariants }), jsxRuntimeExports.jsx(FocusLock, { children: jsxRuntimeExports.jsx(RemoveScroll, { allowPinchZoom: true, children: jsxRuntimeExports.jsx(StyledMotionWrapper$1, { animate: animate, "aria-modal": true, exit: "exit", initial: "exit", onKeyDown: onKeyDown, role: "dialog", tabIndex: -1, transition: { damping: 25, stiffness: 180, type: 'spring' }, variants: drawerVariants[position], children: jsxRuntimeExports.jsx(StyledModalWrapper$1, Object.assign({ "$position": position, "$size": size }, props, { children: jsxRuntimeExports.jsx(StyledDrawerContent, { ref: drawerRef, children: children }) })) }) }) })] })) }) }));
}
const StyledMotionOverlay$1 = styled(motion.div) `
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgb(0 0 0 / 50%);
    z-index: ${(props) => props.theme.zIndices.modal};
`;
const StyledMotionWrapper$1 = styled(motion.div) `
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: ${(props) => props.theme.zIndices.modal};
    overflow-y: auto;

    &:focus {
        outline: none;
    }
`;
const StyledModalWrapper$1 = styled.section `
    position: fixed;
    height: 100%;
    width: 100%;
    z-index: ${(props) => props.theme.zIndices.modal};

    &:focus {
        outline: none;
    }

    ${(props) => props.$position === 'top' &&
    css$3 `
            top: 0;
            right: 0;
            left: 0;
        `}

    ${(props) => props.$position === 'right' &&
    css$3 `
            top: 0;
            right: 0;
            bottom: 0;
        `}

    ${(props) => props.$position === 'bottom' &&
    css$3 `
            right: 0;
            bottom: 0;
            left: 0;
        `}

    ${(props) => props.$position === 'left' &&
    css$3 `
            top: 0;
            bottom: 0;
            left: 0;
        `}

    ${(props) => props.$size &&
    (props.$position === 'right' || props.$position === 'left') &&
    css$3 `
            max-width: ${props.theme.drawer.size[props.$size]};
        `}


    ${(props) => props.$size &&
    (props.$position === 'top' || props.$position === 'bottom') &&
    css$3 `
            max-height: ${props.theme.drawer.size[props.$size]};
        `}


    ${sx};
`;
const StyledDrawerContent = styled.div `
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    background-color: white;
`;
Drawer.Header = DrawerHeader;
Drawer.CloseButton = DrawerCloseButton;
Drawer.Body = DrawerBody;
Drawer.Footer = DrawerFooter;

const DropdownFilterAccordionItem = forwardRef((_a, forwardedRef) => {
    var { children, label } = _a, props = __rest(_a, ["children", "label"]);
    return (jsxRuntimeExports.jsxs(StyledRadixAccordionItem, Object.assign({}, props, { ref: forwardedRef, children: [jsxRuntimeExports.jsxs(StyledRadixAccordionTrigger, { children: [label, jsxRuntimeExports.jsx(StyledIcon$8, { icon: "caret-down-big" })] }), jsxRuntimeExports.jsx(StyledRadixAccordionContent, { children: children })] })));
});
DropdownFilterAccordionItem.displayName = 'DropdownFilterAccordionItem';
const StyledRadixAccordionItem = styled(AccordionPrimitive.Item) `
    display: flex;
    flex-direction: column;

    &:not(:last-child) {
        border-bottom: 1px solid ${(props) => props.theme.colors.neutral200};
    }
`;
const StyledIcon$8 = styled(Icon) ``;
const StyledRadixAccordionTrigger = styled(AccordionPrimitive.Trigger) `
    display: flex;
    background-color: var(--kds-color-background-default);
    font-size: 16px;
    border: none;
    border-radius: var(--kds-border-radius-base);
    line-height: 24px;
    font-weight: 500;
    align-items: center;
    color: var(--kds-color-foreground-default);
    justify-content: space-between;
    padding: 20px 16px;

    &:hover {
        background: var(--kds-color-background-subtle);
    }

    &[data-state='open'] ${StyledIcon$8} {
        transform: rotate(180deg);
    }

    &:focus {
        outline: none;
    }

    &:focus-visible {
        outline: 2px solid var(--kds-color-border-focused);
        outline-offset: -2px;
    }
`;
const StyledRadixAccordionContent = styled(AccordionPrimitive.Content) `
    padding: 16px;
`;
const DropdownFilterAccordion = AccordionPrimitive.Root;

const DropdownFilterContent = forwardRef((_a, ref) => {
    var { children, noPadding, onReset, onSubmit } = _a, props = __rest(_a, ["children", "noPadding", "onReset", "onSubmit"]);
    return (jsxRuntimeExports.jsxs(StyledDropdownFilterContent, Object.assign({}, props, { ref: ref, children: [jsxRuntimeExports.jsx(StyledFilterScroll, { children: jsxRuntimeExports.jsx(StyledFilterContent, { "$noPadding": noPadding, children: children }) }), jsxRuntimeExports.jsxs(StyledFilterFooter, { children: [jsxRuntimeExports.jsx(Link, { color: "subtle", fontWeight: "normal", onClick: onReset, size: "sm", variant: "button", children: "Wissen" }), jsxRuntimeExports.jsx(Button, { onClick: onSubmit, size: "small", variant: "solid", children: "Opslaan" })] })] })));
});
DropdownFilterContent.displayName = 'DropdownFilterContent';
const StyledDropdownFilterContent = styled(PopoverPrimitive.Content) `
    padding: 0;
    margin: 8px 0;
    box-shadow: ${(props) => props.theme.shadows.md};
    border-radius: ${(props) => props.theme.radii.sm};
    background-color: white;
    width: 310px;
    z-index: 9999;
`;
const StyledFilterScroll = styled.div `
    display: flex;
    max-height: 283px;
    overflow: hidden auto;
    height: 100%;
    flex-direction: column;
`;
const StyledFilterContent = styled.div `
    ${(props) => !props.$noPadding &&
    css$3 `
            padding: 12px 16px;
        `}

    &:focus {
        outline: none;
    }
`;
const StyledFilterFooter = styled.div `
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px;
    border-top: 1px solid ${(props) => props.theme.colors.neutral200};
`;

function DropdownFilter({ children, count, label, noPadding, onReset, onSubmit, width = 'auto', }) {
    const [isOpen, setIsOpen] = useState(false);
    const handleSubmit = () => {
        handleClose();
        if (onSubmit) {
            onSubmit();
        }
    };
    const handleReset = () => {
        handleClose();
        if (onReset) {
            onReset();
        }
    };
    const handleClose = () => {
        if (!isOpen) {
            return;
        }
        setIsOpen(false);
    };
    const getLabelWithCount = () => {
        return (jsxRuntimeExports.jsxs(Box, { as: "span", display: "flex", flexWrap: "nowrap", left: "12px", position: "absolute", right: "30px", children: [jsxRuntimeExports.jsx(StyledLabel$1, { as: "span", fontWeight: count !== undefined && count > 0 ? 'medium' : 'normal', size: "sm", children: label }), jsxRuntimeExports.jsxs(StyledCount, { as: "span", fontWeight: "medium", size: "sm", children: [String.fromCharCode(8226), " ", count] })] }));
    };
    return (jsxRuntimeExports.jsxs(PopoverPrimitive.Root, { modal: false, onOpenChange: setIsOpen, open: isOpen, children: [jsxRuntimeExports.jsx(PopoverPrimitive.Trigger, { asChild: true, children: jsxRuntimeExports.jsxs(StyledButton$1, { "$isOpen": isOpen, "$width": width, children: [jsxRuntimeExports.jsx(StyledLabel$1, { as: "span", fontWeight: "normal", size: "sm", sx: {
                                opacity: count ? 0 : 1,
                            }, children: label }), count !== undefined && count > 0 && getLabelWithCount(), jsxRuntimeExports.jsx(StyledIcon$7, { color: "minimal", icon: "caret-down", size: "20px" })] }) }), jsxRuntimeExports.jsx(PopoverPrimitive.Portal, { children: jsxRuntimeExports.jsx(DropdownFilterContent, { align: "end", noPadding: noPadding, onReset: handleReset, onSubmit: handleSubmit, side: "bottom", sideOffset: 5, children: children }) })] }));
}
const StyledLabel$1 = styled(Text) `
    flex: 1 1 auto;
    text-align: left;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
`;
const StyledIcon$7 = styled(Icon) `
    flex-shrink: 0;
    margin-left: 24px;
`;
const StyledCount = styled(Text) `
    flex-shrink: 0;
    margin-left: 2px;
`;
const StyledButton$1 = styled.button `
    height: 40px;
    border-radius: var(--kds-border-radius-base);
    border: 1px solid var(--kds-color-border-medium);
    color: var(--kds-color-foreground-default);
    background-color: var(--kds-color-background-default);
    display: inline-flex;
    box-sizing: border-box;
    align-items: center;
    justify-content: space-between;
    margin: 0;
    padding-left: 12px;
    position: relative;
    padding-right: 8px;
    transition: background-color 0.1s ease-out;

    ${(props) => props.$width === 'auto' &&
    css$3 `
            width: auto;
        `}

    ${(props) => props.$width === 'full' &&
    css$3 `
            width: 100%;
        `}

    ${(props) => props.$isOpen &&
    css$3 `
            background-color: var(--kds-color-background-minimal);
        `}

    &:hover {
        background-color: var(--kds-color-background-minimal);
    }

    &:focus {
        outline: none;
    }

    &:focus-visible {
        outline: 2px solid var(--kds-color-border-focused);
        outline-offset: 2px;
    }
`;
DropdownFilter.Accordion = DropdownFilterAccordion;
DropdownFilter.AccordionItem = DropdownFilterAccordionItem;

function DropdownMenuItem(props) {
    return jsxRuntimeExports.jsx(StyledRadixDropdownMenuItem, Object.assign({}, props));
}
const StyledRadixDropdownMenuItem = styled(RadixDropdownMenu.Item) `
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 40px;
    padding: 8px 16px;
    cursor: pointer;
    box-sizing: border-box;
    font-size: 14px;
    line-height: 1.5;
    font-weight: 400;
    color: ${(props) => props.theme.colors.neutral900};
    white-space: nowrap;
    background-color: inherit;
    border: 0;

    &:focus {
        outline: none;
    }

    &[data-highlighted] {
        background-color: ${(props) => props.theme.colors.neutral100};
        color: ${(props) => props.theme.colors.neutral900};
    }

    &[data-disabled] {
        color: ${(props) => props.theme.colors.neutral400};
        cursor: default;
    }
`;

function DropdownMenu({ children, trigger }) {
    return (jsxRuntimeExports.jsxs(RadixDropdownMenu.Root, { modal: false, children: [jsxRuntimeExports.jsx(RadixDropdownMenu.Trigger, { asChild: true, children: trigger }), jsxRuntimeExports.jsx(RadixDropdownMenu.Portal, { children: jsxRuntimeExports.jsx(StyledRadixDropdownMenuContent, { align: "end", side: "bottom", sideOffset: 5, children: children }) })] }));
}
const StyledRadixDropdownMenuContent = styled(RadixDropdownMenu.Content) `
    padding: 8px 0;
    margin: 8px 0;
    box-shadow: ${({ theme }) => theme.shadows.md};
    border-radius: ${({ theme }) => theme.radii.sm};
    background-color: white;
    z-index: 9999;
`;
DropdownMenu.Item = DropdownMenuItem;

const GradientCircleIcon = ({ cx = '40', cy = '40', fill, fillOpacity = '0.5', r = '40', }) => {
    return (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx("circle", { cx: cx, cy: cy, fill: "url(#ksyos-blue-gradient)", fillOpacity: fill ? '1.0' : fillOpacity, r: r }), jsxRuntimeExports.jsx(LinearGradient, { stopColor2: fill || '#C3D4FF' })] }));
};
const LinearGradient = ({ stopColor2 }) => (jsxRuntimeExports.jsx("defs", { children: jsxRuntimeExports.jsxs("linearGradient", { gradientUnits: "userSpaceOnUse", id: "ksyos-blue-gradient", x1: "0%", x2: "100%", y1: "0%", y2: "100%", children: [jsxRuntimeExports.jsx("stop", { offset: "0", stopColor: "#EBF1FF" }), jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: stopColor2 })] }) }));

const CareProviderIcon = ({ circleColor }) => (jsxRuntimeExports.jsxs("g", { children: [jsxRuntimeExports.jsx(GradientCircleIcon, { fill: circleColor }), jsxRuntimeExports.jsx("mask", { height: "80", id: "mask0_1047_1680", maskUnits: "userSpaceOnUse", style: {
                maskType: 'alpha',
            }, width: "80", x: "0", y: "0", children: jsxRuntimeExports.jsx("path", { d: "M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z", fill: "#E8ECF8" }) }), jsxRuntimeExports.jsxs("g", { mask: "url(#mask0_1047_1680)", children: [jsxRuntimeExports.jsx("path", { clipRule: "evenodd", d: "M40.0088 32.0128C40.4328 32.5183 40.9809 32.9188 41.6531 33.2144C45.9234 37.1045 48.5312 39.2977 49.4765 39.794C50.8944 40.5385 54.4717 49.7488 55.2632 53.7872C55.7908 56.4794 56.471 59.2681 57.3036 62.1531C59.9917 63.0477 62.2526 63.679 64.0862 64.0469C66.8367 64.5988 59.0198 69.2994 57.7864 69.2994C56.5531 69.2994 54.2975 70.0555 53.2043 68.2686C52.4755 67.0774 50.8878 64.317 48.4413 59.9874L49.0431 74.4767C50.1273 79.0362 50.6694 84.6636 50.6694 91.359C50.6694 97.115 48.8667 111.39 48.4413 115.426C48.1148 118.523 47.1124 121.293 46.7531 123.389C46.4098 125.391 46.081 127.311 45.7666 129.147C44.4208 138.832 43.7479 144.469 43.7479 146.056C43.7479 148.437 46.7379 152.851 48.1072 153.473C49.4765 154.094 54.7232 154.872 53.7962 156.771C52.8692 158.669 45.6021 158.496 44.426 157.938C43.2498 157.381 39.2419 156.771 37.9246 156.771C37.0464 156.771 36.7561 155.244 37.0535 152.189C37.8534 149.815 38.1437 147.654 37.9246 145.704C37.5959 142.78 36.1036 135.474 37.9246 128.606C39.1386 124.028 38.8483 114.512 37.0535 100.06L28.7709 123.389C26.784 139.641 25.7905 148.628 25.7905 150.351C25.7905 152.935 29.365 162.512 29.365 163.595C29.365 164.679 27.7236 166.185 24.8937 165.686C23.0071 165.353 21.7701 164.656 21.1825 163.595C21.8593 157.491 22.0285 153.877 21.6901 152.754C21.1825 151.069 19.009 142.131 19.009 138.207C19.009 134.282 19.728 126.131 20.8789 123.697C22.0298 121.263 20.5754 112.209 20.8789 103.27C21.0813 97.3108 22.7185 88.7205 25.7905 77.4994C26.088 73.1189 25.9499 70.278 25.3762 68.9766C24.8025 67.6752 23.3034 63.1454 20.8789 55.387L17.2922 63.9923C14.5573 65.5483 13.1362 66.3263 13.0288 66.3263C12.8677 66.3263 14.7423 43.6303 17.7797 40.5431C20.8171 37.456 28.9839 31.9911 30.8756 30.779C32.1367 29.971 32.7673 28.311 32.7673 25.799C37.1709 29.436 39.5847 31.5072 40.0088 32.0128Z", fill: "url(#paint0_linear_1047_1680)", fillRule: "evenodd" }), jsxRuntimeExports.jsx("path", { clipRule: "evenodd", d: "M32.8602 25.1652C32.8732 26.1877 32.8002 27.0259 32.6413 27.6799C32.2736 29.1932 31.5927 30.0804 30.92 30.7158C30.6151 31.0039 29.5171 31.6012 28.9354 31.9837C28.5477 32.2387 28.0184 32.5859 27.3477 33.0253C29.493 33.6551 30.8074 33.97 31.2909 33.97C31.4961 33.97 33.8316 34.6563 34.1007 33.97C34.3114 33.4329 32.6908 32.3745 32.6413 31.5591C32.5305 29.7338 33.694 28.9697 34.1007 28.9697C34.4024 28.9697 35.2294 30.0192 36.2669 30.6729C37.4306 31.4061 39.3596 32.6505 40.0356 32.6731C40.3967 32.6852 40.0356 31.6391 40.0356 31.5591C40.0356 31.5591 39.6186 31.1879 39.3155 30.7158C38.9607 30.1633 38.7064 29.4728 38.6207 29.0785C38.4617 28.3473 37.3568 27.9914 37.3568 27.9914C37.3568 27.9914 35.9189 27.4849 34.7552 26.4955C34.3583 26.1579 33.7266 25.7145 32.8602 25.1652Z", fill: "url(#paint1_linear_1047_1680)", fillRule: "evenodd" }), jsxRuntimeExports.jsx("path", { clipRule: "evenodd", d: "M17.2559 64.0682C17.2559 73.2195 17.2559 79.0332 17.2559 81.5091C17.2559 83.9851 18.5527 86.8156 21.1463 90.0004C21.5481 93.236 21.9722 94.9891 22.4187 95.2597C23.0885 95.6655 21.0508 95.8006 20.5189 94.8095C19.9869 93.8185 19.8266 92.3434 19.6655 92.3434C19.5044 92.3434 19.6655 94.6596 19.6655 95.5604C19.6655 96.4612 20.2675 99.8959 20.2675 100.599C20.2675 101.302 19.822 101.664 19.513 101.343C19.2039 101.021 19.6021 101.539 19.403 101.777C19.2039 102.015 18.3023 102.346 17.8888 101.343C17.6131 100.673 17.4441 100.175 17.3816 99.8477C17.626 100.715 17.6662 101.213 17.5021 101.343C17.2559 101.537 16.4208 100.804 16.2254 99.8477C16.03 98.8913 16.1923 100.347 16.0042 100.473C15.8161 100.599 14.8174 99.9381 14.4391 97.7492C14.1869 96.29 14.0454 94.3965 14.0146 92.0688C13.8972 87.1779 13.6787 84.3848 13.3589 83.6895C12.8794 82.6465 9.76193 68.9122 9.41785 66.0424C9.07377 63.1726 15.1986 42.7665 18.236 39.6794C20.2609 37.6213 19.9342 45.7509 17.2559 64.0682Z", fill: "url(#paint2_linear_1047_1680)", fillRule: "evenodd" }), jsxRuntimeExports.jsx("path", { clipRule: "evenodd", d: "M42.6956 14.631C42.8397 17.351 42.8397 19.5065 42.6956 21.0975C42.4795 23.4841 41.1928 28.9519 40.6189 29.4376C40.045 29.9233 37.5248 30.0995 36.7322 29.5536C35.9397 29.0076 31.7868 25.9416 31.585 25.5306C31.4505 25.2567 31.2012 24.4444 30.8369 23.0936C30.8911 23.4304 30.6666 23.5377 30.1637 23.4155C29.4092 23.2322 29.1615 21.5771 28.6756 21.2617C28.1897 20.9463 27.546 19.3821 27.6608 18.8669C27.7757 18.3517 28.3894 17.5049 29.0133 17.8104C29.4292 18.014 29.6944 18.2175 29.8088 18.421C29.3011 17.5723 28.9233 16.4458 28.6756 15.0414C28.3039 12.9348 28.3039 12.9348 29.3216 10.8744C30.3392 8.81393 32.093 7.68952 34.0281 6.9936C35.9631 6.29768 38.4133 6.67657 39.8077 8.19366C40.3451 8.7783 41.3584 9.7014 41.9179 11.0441C42.1901 11.6976 42.4493 12.8932 42.6956 14.631Z", fill: "url(#paint3_linear_1047_1680)", fillRule: "evenodd" }), jsxRuntimeExports.jsx("path", { clipRule: "evenodd", d: "M31.2505 19.6655C33.4246 20.9796 34.698 22.1921 35.0707 23.303C36.5061 27.582 40.0721 28.2415 40.6357 28.891C41.2784 29.6316 38.055 29.9809 37.3538 29.8284C36.6525 29.6759 33.4933 28.448 31.585 25.5308C31.5446 25.469 30.8089 22.708 30.8089 23.1309C30.8089 23.5538 30.0688 23.5897 29.6968 23.0644C28.9621 22.0265 28.2004 20.8854 27.8085 19.9376C27.2599 18.6111 28.3204 18.0963 28.6945 17.6933C28.9439 17.4246 29.7959 18.082 31.2505 19.6655Z", fill: "url(#paint4_linear_1047_1680)", fillRule: "evenodd" }), jsxRuntimeExports.jsx("path", { clipRule: "evenodd", d: "M41.5739 33.5385C38.9305 34.8205 36.8011 35.3837 35.1856 35.2279C33.5702 35.0721 31.4407 34.0982 28.7974 32.3063C21.2738 36.9973 17.4169 39.4501 17.2265 39.6647C16.9409 39.9866 17.016 42.1989 15.9361 44.1337C14.9768 45.8526 13.3385 49.0131 12.6341 51.8303C12.2269 53.4589 11.0446 54.6376 11.7082 55.9066C12.3503 57.1344 14.7451 58.4206 18.8926 59.7651L20.6887 56.3961C23.2912 64.4368 24.8105 69.3057 25.2468 71.003C25.683 72.7002 25.1704 76.4694 23.709 82.3106C29.7351 83.8267 34.2173 84.6219 37.1557 84.6962C40.0941 84.7705 44.3089 84.1951 49.8 82.9701C49.2101 77.736 48.9151 74.4329 48.9151 73.061C48.9151 71.689 48.9151 65.3773 48.9151 54.126L55.2467 54.126C52.5912 45.7507 50.7756 41.2509 49.8 40.6264C48.8244 40.002 46.0823 37.6393 41.5739 33.5385Z", fill: "url(#paint5_linear_1047_1680)", fillRule: "evenodd" }), jsxRuntimeExports.jsx("path", { clipRule: "evenodd", d: "M30.2886 35.7353C32.3906 36.6008 34.3285 36.9759 36.1021 36.8606C37.8758 36.7454 39.5391 36.3394 41.0919 35.6426L40.9828 35.2072C39.1011 36.0364 37.3532 36.451 35.7389 36.451C34.1247 36.451 32.3945 36.0734 30.5484 35.3181L30.2886 35.7353Z", fill: "url(#paint6_linear_1047_1680)", fillRule: "evenodd" }), jsxRuntimeExports.jsx("path", { clipRule: "evenodd", d: "M48.6931 59.9076C48.6931 62.1683 49.093 68.2869 49.666 73.4291C49.761 74.2814 51.1778 103.608 50.7128 105.977C50.2477 108.345 46.4188 108.568 46.3401 107.537C46.2614 106.506 43.3443 61.0637 43.3443 52.9244C43.3443 47.4983 42.0563 40.1616 39.4802 30.9143C39.8203 31.3872 40.2501 31.845 40.7698 32.2877C41.2894 32.7304 43.6455 34.6763 47.8381 38.1256C48.9487 38.7556 49.8878 39.7423 50.6557 41.0856C51.1972 42.033 52.5291 44.673 54.102 49.2569C54.5403 50.5342 55.1962 52.8096 56.0698 56.0833L57.9594 62.5795L70.1125 62.8754C69.2804 66.8988 68.8644 69.2213 68.8644 69.8429C68.8644 70.7754 54.4122 70.3131 52.7921 69.0273C51.7121 68.1701 50.3835 65.5989 48.8064 61.3136C48.7309 59.9145 48.6931 59.4458 48.6931 59.9076Z", fill: "white", fillRule: "evenodd" }), jsxRuntimeExports.jsx("path", { clipRule: "evenodd", d: "M48.9913 48.6078C50.1762 48.7277 50.3354 52.1044 49.4688 58.7379C48.675 64.8148 49.9494 75.7905 50.6753 83.2392C51.138 87.9867 51.1214 106.262 50.7129 105.977C50.3572 105.729 50.4968 90.0548 50.1978 86.4654C49.6149 79.4668 49.4275 70.1809 48.9426 68.5939C48.0684 65.7327 47.0559 60.8341 48.1472 58.7379C48.8747 57.3403 49.1561 53.9637 48.9913 48.6078Z", fill: "url(#paint7_linear_1047_1680)", fillRule: "evenodd" }), jsxRuntimeExports.jsx("path", { clipRule: "evenodd", d: "M42.779 14.6639C41.5551 12.2004 40.1786 10.9687 38.6496 10.9687C36.356 10.9687 33.1199 11.494 33.1199 12.0983C33.1199 12.7025 32.7956 14.6641 32.0806 15.4845C31.6039 16.0315 31.3656 17.5715 31.3656 20.1045C31.3214 20.5987 31.2205 20.7223 31.0628 20.4752C30.9238 20.2573 30.6106 19.4554 30.0014 18.4254C29.5745 17.7035 28.8296 17.6152 28.6368 17.6152C28.4253 17.6152 27.9269 16.6642 27.8991 15.4845C27.8653 14.0544 28.3283 12.3126 28.3283 11.8369C28.3283 11.4392 29.0279 10.3961 30.0014 9.11275C30.3204 8.69233 30.7148 7.77015 31.0628 7.46437C31.9719 6.66566 32.9758 7.01805 33.488 6.91257C34.7948 6.64341 37.3734 5.59348 38.6496 5.94155C39.9257 6.28962 39.8932 5.94155 39.9866 6.91257C40.0801 7.88359 40.9324 7.29636 41.9168 7.88763C42.9011 8.47891 42.2361 9.19649 42.5686 9.86469C42.9011 10.5329 44.0095 10.1005 44.0095 10.9687C44.0095 11.8369 43.7952 12.3312 44.4914 12.9775C44.9555 13.4084 44.3847 13.9705 42.779 14.6639Z", fill: "url(#paint8_linear_1047_1680)", fillRule: "evenodd" }), jsxRuntimeExports.jsx("path", { clipRule: "evenodd", d: "M39.3785 30.872C40.1444 31.7179 40.7004 32.3061 41.0466 32.6366C42.1731 33.7123 43.0419 34.3701 43.3559 34.6702C44.0164 35.3014 43.8864 36.6949 44.2001 37.2591C45.1612 38.9873 46.2057 42.1569 46.2057 43.3784C46.2057 44.1928 45.6415 44.5533 44.5132 44.4598L46.2057 46.9264C45.3257 57.6618 44.6571 63.0295 44.2001 63.0295C43.5146 63.0295 42.63 49.4822 42.128 43.7199C41.7933 39.8783 40.8768 35.5957 39.3785 30.872Z", fill: "white", fillRule: "evenodd" }), jsxRuntimeExports.jsx("path", { clipRule: "evenodd", d: "M41.9542 33.3873C43.2419 34.336 44.0856 35.6075 44.4853 37.202C45.0849 39.5936 45.1339 40.8973 44.694 40.8973C44.4007 40.8973 44.0926 40.8396 43.7695 40.7242C44.3005 41.1312 44.6604 41.6065 44.8491 42.1502C45.1322 42.9658 44.4231 46.866 44.0347 50.0775C43.7757 52.2185 43.637 55.3879 43.6185 59.5854C43.4854 55.3608 43.4854 52.1915 43.6185 50.0775C43.7515 47.9635 43.9634 45.4413 44.2541 42.5107L42.0906 39.8542C43.632 40.2112 44.3531 39.9366 44.2541 39.0301C44.1551 38.1237 43.3884 36.2428 41.9542 33.3873Z", fill: "url(#paint9_linear_1047_1680)", fillRule: "evenodd" }), jsxRuntimeExports.jsx("path", { clipRule: "evenodd", d: "M49.2982 62.5196C51.3331 64.1365 52.5192 65.2668 52.8565 65.9103C53.3624 66.8757 54.2644 68.3431 55.5748 68.7944C56.4484 69.0953 60.8517 69.2351 68.7848 69.214C64.8212 69.6941 62.2509 69.9342 61.0737 69.9342C57.3429 69.9342 53.2529 69.5503 52.8565 69.214C52.4787 68.8935 51.6858 67.7019 50.8378 66.0464C50.4893 65.3661 49.9761 64.1905 49.2982 62.5196Z", fill: "url(#paint10_linear_1047_1680)", fillRule: "evenodd" }), jsxRuntimeExports.jsx("path", { clipRule: "evenodd", d: "M70.1125 62.8749C62.225 64.0401 57.768 64.3343 56.7415 63.7576C55.2017 62.8927 54.9329 56.9692 54.2892 54.3577C53.6455 51.7462 50.447 41.5482 49.7716 40.5239C49.0962 39.4997 44.0187 36.7913 43.0418 36.1268C42.3905 35.6838 41.3642 34.6901 39.9628 33.1457L39.3783 30.872C40.6502 32.2724 41.5088 33.1105 41.9542 33.3865C42.6223 33.8006 48.1268 38.2178 49.7716 39.8818C51.4164 41.5459 52.5827 44.8539 54.102 49.2564C55.1148 52.1915 56.3981 56.5714 57.9518 62.3963L70.1125 62.8749Z", fill: "url(#paint11_linear_1047_1680)", fillRule: "evenodd" }), jsxRuntimeExports.jsx("path", { clipRule: "evenodd", d: "M31.284 18.304C31.4343 17.2973 31.6078 16.6157 31.8045 16.2592C32.236 15.4774 32.569 14.7276 32.6623 14.536C32.9369 13.9716 32.8524 13.3165 33.133 12.9069C33.8375 11.8782 35.0633 11.5452 35.93 11.5452C36.6738 11.5452 37.8381 11.2997 38.6394 11.3116C39.4308 11.3234 40.2275 11.0907 40.7147 10.5969C41.2251 10.0794 38.8912 10.2614 38.2423 9.53501C37.5935 8.80863 35.0822 9.02887 34.2215 9.53501C33.3609 10.0411 32.1056 11.5201 31.8045 13.1671C31.7317 13.5656 30.8942 15.3857 30.143 16.5835C29.6 17.4493 27.9193 14.2957 27.8033 15.0008C27.7924 15.0671 27.7792 15.7113 27.881 16.3526C27.9611 16.8569 28.1347 17.3515 28.2853 17.6158C28.4868 17.9696 28.8571 17.9128 29.0085 17.9793C29.3265 18.1189 29.7852 18.5354 29.909 18.7155C30.1918 19.1271 30.8592 21.261 31.1994 20.8892C31.2885 20.7919 31.3167 19.9302 31.284 18.304Z", fill: "url(#paint12_linear_1047_1680)", fillRule: "evenodd" }), jsxRuntimeExports.jsx("path", { clipRule: "evenodd", d: "M39.333 11.0948C40.887 12.4997 41.8727 13.6341 42.2903 14.4981C42.7078 15.362 43.4542 15.0532 44.5294 13.5715C43.5588 14.0001 42.8124 13.628 42.2903 12.455C41.7682 11.2821 40.7824 10.8287 39.333 11.0948Z", fill: "url(#paint13_linear_1047_1680)", fillRule: "evenodd" }), jsxRuntimeExports.jsx("path", { clipRule: "evenodd", d: "M31.0848 30.53C27.779 32.6226 25.8742 33.7231 25.3704 33.8315C24.6147 33.9941 19.9004 35.6924 17.6266 38.9198C15.3528 42.1473 8.97957 59.0281 9.00006 63.6663C9.01379 66.7585 10.2317 73.4499 12.6539 83.7405L18.0687 82.1678L17.1288 64.1899L20.6086 56.7493C20.9434 57.4697 21.2054 58.1694 21.3947 58.8484C21.9494 60.8386 22.5175 64.0902 22.5866 68.9268C22.708 77.4322 21.7319 87.8073 21.3662 92.6383C21.3376 93.0165 21.7811 94.2669 22.0859 94.9499C22.3135 95.4599 22.417 95.3529 22.2174 95.5177C22.0179 95.6824 21.2093 95.3535 21.1311 95.3535C21.0529 95.3535 20.5483 103.995 20.5483 104.073C20.5483 105.359 26.8958 108.558 27.8636 107.373C28.8313 106.189 29.0044 86.2779 29.0044 82.8264C29.0044 70.4739 28.1809 63.3155 28.1809 60.8321C28.1809 57.6547 29.1488 47.554 31.0848 30.53Z", fill: "white", fillRule: "evenodd" }), jsxRuntimeExports.jsx("g", { style: { mixBlendMode: 'multiply' }, children: jsxRuntimeExports.jsx("path", { d: "M47.2144 46.2797L43.6929 46.2797L43.6929 50.8798L47.2144 46.2797Z", fill: "url(#paint14_linear_1047_1680)" }) }), jsxRuntimeExports.jsx("g", { style: { mixBlendMode: 'multiply' }, children: jsxRuntimeExports.jsx("path", { d: "M43.6929 46.2804L43.6929 50.8805L47.2144 50.8805L43.6929 46.2804Z", fill: "url(#paint15_linear_1047_1680)" }) }), jsxRuntimeExports.jsx("path", { clipRule: "evenodd", d: "M29.8613 31.494C29.4558 32.3233 29.1714 32.9211 29.0079 33.2876C28.7588 33.8459 28.5584 34.431 28.3815 34.8099C27.8601 35.9264 27.1502 36.8008 26.9609 37.5457C26.5803 39.0431 27.0298 40.2492 28.3095 41.1639C27.3399 42.3236 26.855 43.0379 26.855 43.3067C26.855 43.7099 27.4126 47.8526 27.7603 49.9274C28.7658 55.9271 27.9799 60.1426 28.0868 60.1794C28.1963 60.217 28.9582 56.1299 28.1718 49.9274C27.9249 47.9805 27.9439 43.9166 27.9431 43.578C27.9426 43.3523 28.4145 42.3829 29.3588 40.6697C27.9179 40.3259 27.2446 39.7283 27.3389 38.877C27.4332 38.0257 28.274 35.5647 29.8613 31.494Z", fill: "url(#paint16_linear_1047_1680)", fillRule: "evenodd" }), jsxRuntimeExports.jsx("path", { clipRule: "evenodd", d: "M22.3584 50.692C21.7583 53.2757 21.2189 55.2192 20.7403 56.5225C20.3488 57.5885 19.7302 58.6712 19.2708 59.7411C17.9688 62.7731 17.2741 64.2245 17.1867 64.0954C17.4955 69.1281 17.6996 72.8598 17.799 75.2906C17.8984 77.7213 18.0081 79.9959 18.1282 82.1142C15.3291 83.0764 14.0002 83.4578 14.1416 83.2583C15.1272 81.8674 15.6822 74.5068 15.5749 73.301C15.3704 71.0047 14.3435 64.5012 14.3435 63.7511C14.3435 63.001 18.8438 57.6595 18.8438 54.6637C18.8438 52.6664 20.0153 51.3426 22.3584 50.692Z", fill: "url(#paint17_linear_1047_1680)", fillRule: "evenodd" }), jsxRuntimeExports.jsx("path", { clipRule: "evenodd", d: "M21.2735 54.7303C22.2147 56.8075 23.6686 60.5168 23.8207 61.5207C24.902 68.6559 24.4139 70.7156 23.8932 73.7625C23.1651 78.0232 23.8932 88.0474 23.8932 90.6697C23.8932 93.1145 23.1195 97.9086 23.957 102.897C24.1516 104.056 24.8919 105.59 26.1777 107.499C25.3851 107.288 24.4462 106.923 23.3609 106.403C22.6418 106.059 21.5672 105.347 20.9778 104.763C20.7777 104.565 20.6345 104.319 20.5483 104.026C20.96 98.2942 21.1858 95.4284 21.2258 95.4284C21.2913 95.4284 21.5928 95.5235 21.893 95.5693C22.1932 95.6152 22.3954 95.4786 22.293 95.3507C22.2464 95.2925 22.1539 95.1509 22.0955 95.032C22.0408 94.9206 22.0008 94.8382 21.9486 94.6649C21.8139 94.2176 21.6011 93.6628 21.5596 93.4852C21.5182 93.3076 21.353 92.8736 21.3513 92.693C21.3459 92.1012 21.4701 91.4662 21.5074 90.9179C21.6069 89.4569 21.7254 88.0974 21.8132 86.8201C21.8925 85.6658 22.0444 83.605 22.2202 80.6893C22.3499 78.5371 22.5523 75.9282 22.5782 72.8919C22.5941 71.0161 22.8018 67.7993 22.293 62.622C22.1073 60.7322 21.1216 54.3951 21.2735 54.7303Z", fill: "url(#paint18_linear_1047_1680)", fillRule: "evenodd" }), jsxRuntimeExports.jsx("path", { clipRule: "evenodd", d: "M43.1142 84.2233C43.4209 80.3269 43.5901 76.912 43.6218 73.9784C43.6534 71.0449 43.6534 66.6081 43.6218 60.668L45.2595 83.5983L43.1142 84.2233Z", fill: "url(#paint19_linear_1047_1680)", fillRule: "evenodd" }), jsxRuntimeExports.jsx("path", { clipRule: "evenodd", d: "M48.693 59.9074C48.693 62.168 49.0928 68.2867 49.6659 73.4288C49.7609 74.2812 50.1309 78.4166 49.6659 80.7848L44.9999 81.9995C44.9212 80.9686 43.3441 61.0634 43.3441 52.9241C43.3441 47.498 42.0561 40.1613 39.4801 30.9141C39.8201 31.387 40.25 31.8447 40.7696 32.2874C41.2892 32.7301 43.6454 34.6761 47.838 38.1253C48.9485 38.7554 49.8877 39.742 50.6555 41.0854C51.197 42.0327 52.5289 44.6727 54.1018 49.2566C54.5401 50.5339 55.196 52.8094 56.0696 56.083L57.9592 62.5792L70.1123 62.8751C69.2803 66.8985 68.8642 69.221 68.8642 69.8427C68.8642 70.7751 54.4121 70.3129 52.792 69.0271C51.7119 68.1698 50.3834 65.5986 48.8063 61.3134C48.7307 59.9142 48.693 59.4455 48.693 59.9074Z", fill: "white", fillRule: "evenodd" })] }), jsxRuntimeExports.jsx("g", { style: { mixBlendMode: 'multiply' }, children: jsxRuntimeExports.jsx("path", { d: "M48.2144 46.2793L44.6929 46.2793L44.6929 50.8794L48.2144 46.2793Z", fill: "url(#paint20_linear_1047_1680)" }) }), jsxRuntimeExports.jsx("g", { style: { mixBlendMode: 'multiply' }, children: jsxRuntimeExports.jsx("path", { d: "M44.6929 46.2799L44.6929 50.88L48.2144 50.88L44.6929 46.2799Z", fill: "url(#paint21_linear_1047_1680)" }) }), jsxRuntimeExports.jsx("path", { clipRule: "evenodd", d: "M73.8389 61.69C76.5302 60.8288 78.0782 60.3363 78.4829 60.2125C79.09 60.0269 78.7334 61.3556 77.8758 61.9269C77.0182 62.4983 77.9497 62.2449 78.7128 62.2761C79.4759 62.3073 82.1762 62.2517 82.7717 62.2761C83.0443 62.2872 83.6418 62.1559 83.7402 62.8131C83.8386 63.4704 82.7717 63.4389 82.7717 63.5014C82.7717 63.5942 83.5452 63.2665 83.7402 63.5014C83.9353 63.7364 84.085 64.4576 83.2206 64.8936C82.3562 65.3296 81.4195 65.192 82.27 65.2608C83.1205 65.3296 83.393 65.2664 83.4802 65.6735C83.5674 66.0807 82.815 66.8007 81.9982 66.99C81.7083 67.0572 80.4405 67.5557 80.6552 67.4583C80.8754 67.3585 81.6399 67.4232 81.6853 67.6962C81.7837 68.288 81.2393 68.3952 80.5596 68.5029C79.9177 68.6047 79.1547 68.7196 78.7128 68.824C78.0871 68.9719 76.9871 69.1631 75.7577 69.3789C74.5283 69.5948 69.6989 68.1715 68.1441 68.3097C68.0498 68.3181 69.9481 66.1115 73.8389 61.69Z", fill: "url(#paint22_linear_1047_1680)", fillRule: "evenodd" }), jsxRuntimeExports.jsx("path", { clipRule: "evenodd", d: "M78.2139 61.4253C76.8087 62.5171 75.7195 63.1561 74.946 63.3422C74.1726 63.5283 73.6987 64.6298 73.5244 66.6465C74.2828 65.5779 74.7567 64.9464 74.946 64.7518C76.1698 63.4941 76.6305 63.4365 77.3931 62.6104C78.3328 61.5927 78.6064 61.1976 78.2139 61.4253Z", fill: "#E7A79B", fillRule: "evenodd" }), jsxRuntimeExports.jsx("path", { clipRule: "evenodd", d: "M69.3368 63.4528C70.3585 63.653 71.2556 63.3396 72.0278 62.5124C72.5756 61.9256 74.2719 61.4273 75.7986 60.7629C77.5004 60.0224 78.1065 59.5592 78.5321 59.4969C79.3396 59.3789 79.2403 59.5709 78.8014 60.7825C78.3623 61.994 76.3236 62.256 75.626 62.6357C74.9283 63.0153 74.5005 65.0353 74.2568 65.3631C74.0131 65.6908 73.1254 69.0615 72.404 68.5606C72.1026 68.3513 68.9407 68.9419 68.4404 67.6954C68.2418 67.2006 68.5406 65.7864 69.3368 63.4528Z", fill: "url(#paint23_linear_1047_1680)", fillRule: "evenodd" }), jsxRuntimeExports.jsxs("defs", { children: [jsxRuntimeExports.jsxs("linearGradient", { gradientUnits: "userSpaceOnUse", id: "paint0_linear_1047_1680", x1: "-2241.68", x2: "-4093.56", y1: "7943.8", y2: "7292.58", children: [jsxRuntimeExports.jsx("stop", { stopColor: "#F4CBB8" }), jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "#EC9A95" })] }), jsxRuntimeExports.jsxs("linearGradient", { gradientUnits: "userSpaceOnUse", id: "paint1_linear_1047_1680", x1: "35.4993", x2: "33.3372", y1: "34.7371", y2: "25.4248", children: [jsxRuntimeExports.jsx("stop", { stopColor: "#F3BBA2" }), jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "#E5908B" })] }), jsxRuntimeExports.jsxs("linearGradient", { gradientUnits: "userSpaceOnUse", id: "paint2_linear_1047_1680", x1: "-410.704", x2: "-947.174", y1: "3669.91", y2: "3582.73", children: [jsxRuntimeExports.jsx("stop", { stopColor: "#F4CBB8" }), jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "#EC9A95" })] }), jsxRuntimeExports.jsxs("linearGradient", { gradientUnits: "userSpaceOnUse", id: "paint3_linear_1047_1680", x1: "46.1937", x2: "15.8419", y1: "6.75514", y2: "60.9768", children: [jsxRuntimeExports.jsx("stop", { stopColor: "#F4CBB8" }), jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "#EC9A95" })] }), jsxRuntimeExports.jsxs("linearGradient", { gradientUnits: "userSpaceOnUse", id: "paint4_linear_1047_1680", x1: "31.8916", x2: "36.3281", y1: "27.6678", y2: "23.4017", children: [jsxRuntimeExports.jsx("stop", { stopColor: "#E6988E" }), jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "#F2BEAF" })] }), jsxRuntimeExports.jsxs("linearGradient", { gradientUnits: "userSpaceOnUse", id: "paint5_linear_1047_1680", x1: "107.139", x2: "26.9416", y1: "99.9778", y2: "68.5329", children: [jsxRuntimeExports.jsx("stop", { stopColor: "#D77C09" }), jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "#FF9A1C" })] }), jsxRuntimeExports.jsxs("linearGradient", { gradientUnits: "userSpaceOnUse", id: "paint6_linear_1047_1680", x1: "-244.155", x2: "-824.916", y1: "138.14", y2: "-497.745", children: [jsxRuntimeExports.jsx("stop", { stopColor: "#D77C09" }), jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "#FF9A1C" })] }), jsxRuntimeExports.jsxs("linearGradient", { gradientUnits: "userSpaceOnUse", id: "paint7_linear_1047_1680", x1: "-109.847", x2: "-461.283", y1: "4375.3", y2: "4232.27", children: [jsxRuntimeExports.jsx("stop", { stopColor: "#CDD4E7" }), jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "#F4F4F2" })] }), jsxRuntimeExports.jsxs("linearGradient", { gradientUnits: "userSpaceOnUse", id: "paint8_linear_1047_1680", x1: "28.8164", x2: "40.13", y1: "5.8141", y2: "25.4876", children: [jsxRuntimeExports.jsx("stop", { stopColor: "#65095C" }), jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "#0B0A09" })] }), jsxRuntimeExports.jsxs("linearGradient", { gradientUnits: "userSpaceOnUse", id: "paint9_linear_1047_1680", x1: "-127.344", x2: "-87.6032", y1: "718.554", y2: "721.222", children: [jsxRuntimeExports.jsx("stop", { stopColor: "#DBD5D0" }), jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "white" })] }), jsxRuntimeExports.jsxs("linearGradient", { gradientUnits: "userSpaceOnUse", id: "paint10_linear_1047_1680", x1: "-4752.33", x2: "324.293", y1: "644.095", y2: "-1031.75", children: [jsxRuntimeExports.jsx("stop", { stopColor: "#DBD5D0" }), jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "white", stopOpacity: "0" })] }), jsxRuntimeExports.jsxs("linearGradient", { gradientUnits: "userSpaceOnUse", id: "paint11_linear_1047_1680", x1: "26.8665", x2: "91.2661", y1: "96.5901", y2: "32.8471", children: [jsxRuntimeExports.jsx("stop", { stopColor: "#DBD5D0" }), jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "white" })] }), jsxRuntimeExports.jsxs("linearGradient", { gradientUnits: "userSpaceOnUse", id: "paint12_linear_1047_1680", x1: "-909.07", x2: "-54.4476", y1: "-197.899", y2: "856.837", children: [jsxRuntimeExports.jsx("stop", { stopColor: "#65095C" }), jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "#0B0A09" })] }), jsxRuntimeExports.jsxs("linearGradient", { gradientUnits: "userSpaceOnUse", id: "paint13_linear_1047_1680", x1: "440.827", x2: "-440.337", y1: "-79.4285", y2: "426.935", children: [jsxRuntimeExports.jsx("stop", { stopColor: "#65095C" }), jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "#0B0A09" })] }), jsxRuntimeExports.jsxs("linearGradient", { gradientUnits: "userSpaceOnUse", id: "paint14_linear_1047_1680", x1: "44.5813", x2: "45.6743", y1: "47.4679", y2: "48.2844", children: [jsxRuntimeExports.jsx("stop", { stopColor: "#FF9A1E" }), jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "#FF9A1E", stopOpacity: "0" })] }), jsxRuntimeExports.jsxs("linearGradient", { gradientUnits: "userSpaceOnUse", id: "paint15_linear_1047_1680", x1: "44.9671", x2: "47.665", y1: "47.9291", y2: "49.9944", children: [jsxRuntimeExports.jsx("stop", { offset: "0.43904", stopColor: "#FF37F0" }), jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "#FF37F0", stopOpacity: "0" })] }), jsxRuntimeExports.jsxs("linearGradient", { gradientUnits: "userSpaceOnUse", id: "paint16_linear_1047_1680", x1: "195.713", x2: "158.948", y1: "781.717", y2: "784.42", children: [jsxRuntimeExports.jsx("stop", { stopColor: "#DBD5D0" }), jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "white" })] }), jsxRuntimeExports.jsxs("linearGradient", { gradientUnits: "userSpaceOnUse", id: "paint17_linear_1047_1680", x1: "34.4685", x2: "11.2232", y1: "72.8802", y2: "65.094", children: [jsxRuntimeExports.jsx("stop", { stopColor: "#DBD5D0" }), jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "white" })] }), jsxRuntimeExports.jsxs("linearGradient", { gradientUnits: "userSpaceOnUse", id: "paint18_linear_1047_1680", x1: "-10.8858", x2: "50.5598", y1: "91.7306", y2: "57.7841", children: [jsxRuntimeExports.jsx("stop", { stopColor: "#DBD5D0" }), jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "white", stopOpacity: "0" })] }), jsxRuntimeExports.jsxs("linearGradient", { gradientUnits: "userSpaceOnUse", id: "paint19_linear_1047_1680", x1: "-62.0042", x2: "-2354.37", y1: "2416.2", y2: "-1926.16", children: [jsxRuntimeExports.jsx("stop", { stopColor: "#D77C09" }), jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "#FF9A1C" })] }), jsxRuntimeExports.jsxs("linearGradient", { gradientUnits: "userSpaceOnUse", id: "paint20_linear_1047_1680", x1: "45.5813", x2: "46.6743", y1: "47.4675", y2: "48.2839", children: [jsxRuntimeExports.jsx("stop", { stopColor: "#FF9A1E" }), jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "#FF9A1E", stopOpacity: "0" })] }), jsxRuntimeExports.jsxs("linearGradient", { gradientUnits: "userSpaceOnUse", id: "paint21_linear_1047_1680", x1: "45.9671", x2: "48.6651", y1: "47.9287", y2: "49.994", children: [jsxRuntimeExports.jsx("stop", { offset: "0.43904", stopColor: "#FF37F0" }), jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "#FF37F0", stopOpacity: "0" })] }), jsxRuntimeExports.jsxs("linearGradient", { gradientUnits: "userSpaceOnUse", id: "paint22_linear_1047_1680", x1: "79.5651", x2: "85.4337", y1: "38.5968", y2: "90.4297", children: [jsxRuntimeExports.jsx("stop", { stopColor: "#F4CBB8" }), jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "#EC9A95" })] }), jsxRuntimeExports.jsxs("linearGradient", { gradientUnits: "userSpaceOnUse", id: "paint23_linear_1047_1680", x1: "56.7591", x2: "75.378", y1: "56.1218", y2: "64.0115", children: [jsxRuntimeExports.jsx("stop", { stopColor: "#FAE3D9" }), jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "#EFAEA3" })] })] })] }));

const ContactMomentsIcon = ({ circleColor }) => (jsxRuntimeExports.jsxs("g", { children: [jsxRuntimeExports.jsx(GradientCircleIcon, { fill: circleColor }), jsxRuntimeExports.jsx("g", { filter: "url(#b)", children: jsxRuntimeExports.jsx("path", { clipRule: "evenodd", d: "m25.468 13.248 21.018 4.403a1.16 1.16 0 0 1 .9 1.38L37.735 63.8a1.177 1.177 0 0 1-1.392.9l-21.018-4.404a1.16 1.16 0 0 1-.9-1.38l9.652-44.767c.136-.63.76-1.032 1.392-.9Z", fill: "#3A65DC", fillRule: "evenodd" }) }), jsxRuntimeExports.jsx("path", { clipRule: "evenodd", d: "m26.412 16.21 17.866 3.796c.67.142 1.096.8.954 1.469l-8.42 39.597a1.24 1.24 0 0 1-1.47.954l-17.866-3.795a1.238 1.238 0 0 1-.954-1.47l8.42-39.597a1.24 1.24 0 0 1 1.47-.954Z", fill: "#7090E5", fillRule: "evenodd" }), jsxRuntimeExports.jsx("g", { filter: "url(#c)", children: jsxRuntimeExports.jsx("path", { clipRule: "evenodd", d: "m26.494 16.146 17.791 3.856c.666.145 1.09.8.95 1.467L36.87 61.01a1.239 1.239 0 0 1-2.422.006L25.02 17.62a1.239 1.239 0 0 1 1.473-1.474Z", fill: "#A6BAF1", fillRule: "evenodd" }) }), jsxRuntimeExports.jsx("circle", { cx: "30.872", cy: "40.837", fill: "url(#d)", r: "6.194" }), jsxRuntimeExports.jsx("path", { d: "M29.67 39.047c-.25 1.777-.004 2.672 1.092 4.072l-1.09.54c-1.224-1.671-1.332-3.44-1.163-4.684l1.162.072Z", fill: "#fff" }), jsxRuntimeExports.jsx("path", { d: "M31.226 37.242a.551.551 0 0 1 .217.779 3.936 3.936 0 0 0-.514 1.178c-.064.239-.29.395-.542.439-.338.059-.648.2-.903.327-.353.177-1.032-.213-1.019-.605.028-.804.443-2.09 1.326-2.638.138-.086.318-.073.469.007l.966.513ZM33.123 44.32c.182-.254.08-.613-.202-.783a4.636 4.636 0 0 1-1.058-.851c-.178-.188-.46-.238-.707-.179-.333.08-.681.077-.974.063-.405-.02-.815.597-.604.942.433.71 1.457 1.696 2.524 1.838a.443.443 0 0 0 .417-.19l.604-.84Z", fill: "#fff" }), jsxRuntimeExports.jsx("path", { d: "M42 40.5h24", stroke: "#7090E5", strokeDasharray: "2 2" }), jsxRuntimeExports.jsx("g", { clipPath: "url(#e)", children: jsxRuntimeExports.jsx("path", { d: "M62.184 35.427 66 39.242l3.816-3.815a.889.889 0 0 1 1.257 1.257L67.258 40.5l3.815 3.816a.89.89 0 0 1-1.257 1.257L66 41.758l-3.816 3.815a.89.89 0 1 1-1.257-1.257l3.815-3.816-3.815-3.816a.889.889 0 0 1 1.257-1.257Z", fill: "#7090E5" }) }), jsxRuntimeExports.jsxs("defs", { children: [jsxRuntimeExports.jsxs("linearGradient", { gradientUnits: "userSpaceOnUse", id: "d", x1: "24.459", x2: "37.286", y1: "34.644", y2: "47.031", children: [jsxRuntimeExports.jsx("stop", { stopColor: "#CF00B1" }), jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "#FF37F0" })] }), jsxRuntimeExports.jsxs("filter", { colorInterpolationFilters: "sRGB", filterUnits: "userSpaceOnUse", height: "63.501", id: "b", width: "45.016", x: "8.397", y: "11.223", children: [jsxRuntimeExports.jsx("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }), jsxRuntimeExports.jsx("feColorMatrix", { in: "SourceAlpha", result: "hardAlpha", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" }), jsxRuntimeExports.jsx("feOffset", { dy: "4" }), jsxRuntimeExports.jsx("feGaussianBlur", { stdDeviation: "3" }), jsxRuntimeExports.jsx("feComposite", { in2: "hardAlpha", operator: "out" }), jsxRuntimeExports.jsx("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" }), jsxRuntimeExports.jsx("feBlend", { in2: "BackgroundImageFix", result: "effect1_dropShadow_1047_1834" }), jsxRuntimeExports.jsx("feBlend", { in: "SourceGraphic", in2: "effect1_dropShadow_1047_1834", result: "shape" })] }), jsxRuntimeExports.jsxs("filter", { colorInterpolationFilters: "sRGB", filterUnits: "userSpaceOnUse", height: "57.873", id: "c", width: "32.269", x: "18.993", y: "14.118", children: [jsxRuntimeExports.jsx("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }), jsxRuntimeExports.jsx("feColorMatrix", { in: "SourceAlpha", result: "hardAlpha", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" }), jsxRuntimeExports.jsx("feOffset", { dy: "4" }), jsxRuntimeExports.jsx("feGaussianBlur", { stdDeviation: "3" }), jsxRuntimeExports.jsx("feComposite", { in2: "hardAlpha", operator: "out" }), jsxRuntimeExports.jsx("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" }), jsxRuntimeExports.jsx("feBlend", { in2: "BackgroundImageFix", result: "effect1_dropShadow_1047_1834" }), jsxRuntimeExports.jsx("feBlend", { in: "SourceGraphic", in2: "effect1_dropShadow_1047_1834", result: "shape" })] }), jsxRuntimeExports.jsx("clipPath", { id: "e", children: jsxRuntimeExports.jsx("path", { d: "M0 0h16v16H0z", fill: "#fff", transform: "translate(58 32.5)" }) })] })] }));

const MedicalFileIcon = ({ circleColor }) => (jsxRuntimeExports.jsxs("g", { id: "medical-file-icon", children: [jsxRuntimeExports.jsx(GradientCircleIcon, { fill: circleColor }), jsxRuntimeExports.jsx("path", { clipRule: "evenodd", d: "M19.8013 55.507L15.3648 26.1635C15.1371 24.6571 16.1736 23.2513 17.68 23.0235C17.6961 23.0211 17.7122 23.0188 17.7283 23.0167L29.2775 21.4789C30.5323 21.3118 31.7848 21.8017 32.5932 22.7758L33.0034 23.2699C34.0862 24.5745 35.6937 25.3294 37.3892 25.3294H50.6326C51.7487 25.3294 52.8043 25.8361 53.5024 26.7068L55.7294 29.4847L27.2942 32.2654L23.2882 56.6451L19.8013 55.507Z", fill: "#3A65DC", fillRule: "evenodd", id: "Path-3" }), jsxRuntimeExports.jsx("path", { clipRule: "evenodd", d: "M19.8013 54.5073C19.8013 53.7553 21.0554 46.9191 23.5636 33.9987C24.1078 31.1878 26.5691 29.158 29.4321 29.1584H64.4388C65.9624 29.1584 67.1974 30.3935 67.1974 31.9171C67.1974 32.0405 67.1892 32.1637 67.1727 32.286L64.1351 54.7945C63.9197 56.3911 62.5568 57.5824 60.9457 57.5824H22.8765C21.1781 57.5824 19.8013 56.2057 19.8013 54.5073Z", fill: "#A6BAF1", fillRule: "evenodd", id: "Path-2" }), jsxRuntimeExports.jsx("path", { clipRule: "evenodd", d: "M30.6975 26.9229C29.8198 26.7356 28.9332 27.0616 28.0376 27.901C27.5379 28.3694 27.1395 29.0519 26.8425 29.9486C27.6566 29.5499 28.3075 29.3092 28.7952 29.2264C29.2829 29.1436 30.0972 29.1341 31.2381 29.1977", fill: "#7090E5", fillRule: "evenodd", id: "Path-4" }), jsxRuntimeExports.jsx("path", { clipRule: "evenodd", d: "M29.1446 27.2061C29.579 27.2061 29.9009 27.2822 30.1101 27.4342C30.424 27.6624 31.0113 27.6179 31.2893 35.7711C31.4633 40.872 31.3794 46.1142 31.0376 51.4978C31.0223 51.7513 31.2154 51.9691 31.4689 51.9843C31.5851 51.9912 31.6996 51.9539 31.7876 51.8776L34.2369 49.8429L36.7546 51.9413C36.9481 52.1058 37.238 52.079 37.4002 51.8837C37.4671 51.8032 37.5045 51.7024 37.5064 51.5978C37.618 40.7766 37.6146 34.3047 37.4963 32.1821C37.3967 30.3964 37.0587 28.8746 36.4823 27.6168C36.2568 27.1269 35.7668 26.8129 35.2276 26.8132H30.9251C30.3101 26.8132 29.7025 26.9473 29.1446 27.2061Z", fill: "#EDF2FF", fillRule: "evenodd", id: "Path" }), jsxRuntimeExports.jsx("path", { d: "M35.1648 43.0769H33.8462V47.0329H35.1648V43.0769Z", fill: "#CF07BE", id: "Rectangle" }), jsxRuntimeExports.jsx("path", { clipRule: "evenodd", d: "M36.4835 44.3956V45.7143H32.5275V44.3956H36.4835Z", fill: "#CF07BE", fillRule: "evenodd", id: "Rectangle_2" })] }));

const NotesIcon = ({ circleColor }) => (jsxRuntimeExports.jsxs("g", { children: [jsxRuntimeExports.jsx(GradientCircleIcon, { fill: circleColor }), jsxRuntimeExports.jsx("rect", { fill: "white", height: "46.2539", rx: "4", width: "41.5349", x: "19.2325", y: "17.7461" }), jsxRuntimeExports.jsx("rect", { fill: "#3A65DC", height: "2.23809", width: "2.14836", x: "23.5292", y: "20.73" }), jsxRuntimeExports.jsx("rect", { fill: "#3A65DC", height: "2.23809", width: "2.14836", x: "27.8259", y: "20.73" }), jsxRuntimeExports.jsx("rect", { fill: "#3A65DC", height: "2.23809", width: "2.14836", x: "32.1227", y: "20.73" }), jsxRuntimeExports.jsx("rect", { fill: "#3A65DC", height: "2.23809", width: "2.14836", x: "36.4194", y: "20.73" }), jsxRuntimeExports.jsx("rect", { fill: "#3A65DC", height: "2.23809", width: "2.14836", x: "40.7161", y: "20.73" }), jsxRuntimeExports.jsx("rect", { fill: "#3A65DC", height: "2.23809", width: "2.14836", x: "45.0128", y: "20.73" }), jsxRuntimeExports.jsx("rect", { fill: "#3A65DC", height: "2.23809", width: "2.14836", x: "49.3095", y: "20.73" }), jsxRuntimeExports.jsx("rect", { fill: "#3A65DC", height: "2.23809", width: "2.14836", x: "53.6063", y: "20.73" }), jsxRuntimeExports.jsx("rect", { fill: "url(#paint1_linear_1047_1835)", height: "5.48", rx: "0.35806", width: "0.716119", x: "24.2453", y: "16" }), jsxRuntimeExports.jsx("rect", { fill: "url(#paint2_linear_1047_1835)", height: "5.48", rx: "0.35806", width: "0.716119", x: "28.5421", y: "16" }), jsxRuntimeExports.jsx("rect", { fill: "url(#paint3_linear_1047_1835)", height: "5.48", rx: "0.35806", width: "0.716119", x: "32.8387", y: "16" }), jsxRuntimeExports.jsx("rect", { fill: "url(#paint4_linear_1047_1835)", height: "5.48", rx: "0.35806", width: "0.716119", x: "37.1354", y: "16" }), jsxRuntimeExports.jsx("rect", { fill: "url(#paint5_linear_1047_1835)", height: "5.48", rx: "0.35806", width: "0.716119", x: "41.4322", y: "16" }), jsxRuntimeExports.jsx("rect", { fill: "url(#paint6_linear_1047_1835)", height: "5.48", rx: "0.35806", width: "0.716119", x: "45.7289", y: "16" }), jsxRuntimeExports.jsx("rect", { fill: "url(#paint7_linear_1047_1835)", height: "5.48", rx: "0.35806", width: "0.716119", x: "50.0256", y: "16" }), jsxRuntimeExports.jsx("rect", { fill: "url(#paint8_linear_1047_1835)", height: "5.48", rx: "0.35806", width: "0.716119", x: "54.3223", y: "16" }), jsxRuntimeExports.jsx("path", { d: "M24.2454 28.5637H55.7546", stroke: "#7090E5", strokeLinecap: "round" }), jsxRuntimeExports.jsx("path", { d: "M24.2454 34.5319H55.7546", stroke: "#7090E5", strokeLinecap: "round" }), jsxRuntimeExports.jsx("path", { d: "M24.2454 40.5H55.7546", stroke: "#7090E5", strokeLinecap: "round" }), jsxRuntimeExports.jsx("path", { d: "M24.2454 46.4681H55.7546", stroke: "#7090E5", strokeLinecap: "round" }), jsxRuntimeExports.jsx("path", { d: "M24.2454 52.4363H55.7546", stroke: "#7090E5", strokeLinecap: "round" }), jsxRuntimeExports.jsx("path", { d: "M24.2454 58.4047H55.7546", stroke: "#7090E5", strokeLinecap: "round" }), jsxRuntimeExports.jsxs("defs", { children: [jsxRuntimeExports.jsxs("linearGradient", { gradientUnits: "userSpaceOnUse", id: "paint0_linear_1047_1835", x1: "-14.7658", x2: "77.1277", y1: "6.46155", y2: "56.6137", children: [jsxRuntimeExports.jsx("stop", { stopColor: "#EBF1FF" }), jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "#C3D4FF" })] }), jsxRuntimeExports.jsxs("linearGradient", { gradientUnits: "userSpaceOnUse", id: "paint1_linear_1047_1835", x1: "24.2326", x2: "25.6432", y1: "16", y2: "16.178", children: [jsxRuntimeExports.jsx("stop", { stopColor: "#CF00B1" }), jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "#FF37F0" })] }), jsxRuntimeExports.jsxs("linearGradient", { gradientUnits: "userSpaceOnUse", id: "paint2_linear_1047_1835", x1: "28.5293", x2: "29.94", y1: "16", y2: "16.178", children: [jsxRuntimeExports.jsx("stop", { stopColor: "#CF00B1" }), jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "#FF37F0" })] }), jsxRuntimeExports.jsxs("linearGradient", { gradientUnits: "userSpaceOnUse", id: "paint3_linear_1047_1835", x1: "32.826", x2: "34.2366", y1: "16", y2: "16.178", children: [jsxRuntimeExports.jsx("stop", { stopColor: "#CF00B1" }), jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "#FF37F0" })] }), jsxRuntimeExports.jsxs("linearGradient", { gradientUnits: "userSpaceOnUse", id: "paint4_linear_1047_1835", x1: "37.1227", x2: "38.5334", y1: "16", y2: "16.178", children: [jsxRuntimeExports.jsx("stop", { stopColor: "#CF00B1" }), jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "#FF37F0" })] }), jsxRuntimeExports.jsxs("linearGradient", { gradientUnits: "userSpaceOnUse", id: "paint5_linear_1047_1835", x1: "41.4195", x2: "42.8301", y1: "16", y2: "16.178", children: [jsxRuntimeExports.jsx("stop", { stopColor: "#CF00B1" }), jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "#FF37F0" })] }), jsxRuntimeExports.jsxs("linearGradient", { gradientUnits: "userSpaceOnUse", id: "paint6_linear_1047_1835", x1: "45.7162", x2: "47.1269", y1: "16", y2: "16.178", children: [jsxRuntimeExports.jsx("stop", { stopColor: "#CF00B1" }), jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "#FF37F0" })] }), jsxRuntimeExports.jsxs("linearGradient", { gradientUnits: "userSpaceOnUse", id: "paint7_linear_1047_1835", x1: "50.0129", x2: "51.4235", y1: "16", y2: "16.178", children: [jsxRuntimeExports.jsx("stop", { stopColor: "#CF00B1" }), jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "#FF37F0" })] }), jsxRuntimeExports.jsxs("linearGradient", { gradientUnits: "userSpaceOnUse", id: "paint8_linear_1047_1835", x1: "54.3096", x2: "55.7203", y1: "16", y2: "16.178", children: [jsxRuntimeExports.jsx("stop", { stopColor: "#CF00B1" }), jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "#FF37F0" })] })] })] }));

const SearchResultsIcon = ({ circleColor }) => (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx(GradientCircleIcon, { fill: circleColor }), jsxRuntimeExports.jsxs("g", { filter: "url(#filter0_dd_1116_1212)", children: [jsxRuntimeExports.jsx("rect", { fill: "white", height: "46.5766", rx: "2", width: "36.6667", x: "22.2286", y: "15.562" }), jsxRuntimeExports.jsx("rect", { fill: "#D7E1FB", height: "1.98198", rx: "0.990991", width: "26.7568", x: "27.1836", y: "35.3818" }), jsxRuntimeExports.jsx("rect", { fill: "#D7E1FB", height: "1.98198", rx: "0.990991", width: "26.7568", x: "27.1836", y: "40.3367" }), jsxRuntimeExports.jsx("rect", { fill: "#D7E1FB", height: "1.98198", rx: "0.990991", width: "26.7568", x: "27.1836", y: "45.2917" }), jsxRuntimeExports.jsx("rect", { fill: "#CF07BE", height: "1.98198", rx: "0.990991", width: "17.3423", x: "27.1836", y: "20.5169" }), jsxRuntimeExports.jsx("rect", { fill: "#D7E1FB", height: "1.98198", rx: "0.990991", width: "26.7568", x: "27.1836", y: "25.4718" }), jsxRuntimeExports.jsx("rect", { fill: "#D7E1FB", height: "1.98198", rx: "0.990991", width: "26.7568", x: "27.1836", y: "30.4269" })] }), jsxRuntimeExports.jsx("g", { style: { mixBlendMode: 'soft-light' }, children: jsxRuntimeExports.jsx("circle", { cx: "51.0163", cy: "49.0166", fill: "#EDF2FF", r: "8.763" }) }), jsxRuntimeExports.jsx("path", { clipRule: "evenodd", d: "M57.4862 55.6354C55.8176 57.2666 53.5347 58.2719 51.017 58.2719C45.9056 58.2719 41.762 54.1283 41.762 49.0169C41.762 43.9055 45.9056 39.7619 51.017 39.7619C56.1284 39.7619 60.272 43.9055 60.272 49.0169C60.272 51.539 59.2632 53.8254 57.6271 55.4947C57.6023 55.517 57.5779 55.5402 57.554 55.5641C57.5306 55.5874 57.508 55.6112 57.4862 55.6354ZM57.0417 57.3165C55.3503 58.5464 53.2683 59.2719 51.017 59.2719C45.3533 59.2719 40.762 54.6806 40.762 49.0169C40.762 43.3533 45.3533 38.7619 51.017 38.7619C56.6806 38.7619 61.272 43.3533 61.272 49.0169C61.272 51.2731 60.5434 53.359 59.3087 55.0524C59.6503 55.1278 59.9752 55.2984 60.241 55.5641L67.6408 62.964C68.3828 63.706 68.3828 64.909 67.6408 65.651C66.8988 66.393 65.6958 66.393 64.9538 65.651L57.554 58.2511C57.2876 57.9848 57.1169 57.659 57.0417 57.3165Z", fill: "#7090E5", fillRule: "evenodd" }), jsxRuntimeExports.jsx("g", { clipPath: "url(#clip0_1116_1212)", children: jsxRuntimeExports.jsx("path", { d: "M48.9703 46.1847L51.3553 48.5691L53.7403 46.1847C53.8451 46.0835 53.9854 46.0275 54.1311 46.0287C54.2767 46.03 54.4161 46.0884 54.5191 46.1914C54.6221 46.2944 54.6805 46.4338 54.6818 46.5794C54.683 46.7251 54.6271 46.8654 54.5259 46.9702L52.1414 49.3552L54.5259 51.7402C54.6271 51.845 54.683 51.9853 54.6818 52.131C54.6805 52.2767 54.6221 52.416 54.5191 52.519C54.4161 52.622 54.2767 52.6804 54.1311 52.6817C53.9854 52.683 53.8451 52.627 53.7403 52.5258L51.3553 50.1413L48.9703 52.5258C48.919 52.5788 48.8577 52.6211 48.79 52.6503C48.7222 52.6794 48.6493 52.6947 48.5755 52.6953C48.5018 52.696 48.4286 52.6819 48.3603 52.654C48.292 52.6261 48.23 52.5848 48.1779 52.5327C48.1257 52.4805 48.0844 52.4185 48.0565 52.3502C48.0286 52.2819 48.0145 52.2088 48.0152 52.135C48.0158 52.0612 48.0311 51.9883 48.0602 51.9205C48.0894 51.8528 48.1317 51.7915 48.1847 51.7402L50.5692 49.3552L48.1847 46.9702C48.0835 46.8654 48.0275 46.7251 48.0288 46.5794C48.0301 46.4338 48.0885 46.2944 48.1915 46.1914C48.2945 46.0884 48.4339 46.03 48.5795 46.0287C48.7252 46.0275 48.8655 46.0835 48.9703 46.1847Z", fill: "#910A1F" }) }), jsxRuntimeExports.jsxs("defs", { children: [jsxRuntimeExports.jsxs("filter", { colorInterpolationFilters: "sRGB", filterUnits: "userSpaceOnUse", height: "56.5766", id: "filter0_dd_1116_1212", width: "46.6666", x: "17.2286", y: "14.562", children: [jsxRuntimeExports.jsx("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }), jsxRuntimeExports.jsx("feColorMatrix", { in: "SourceAlpha", result: "hardAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" }), jsxRuntimeExports.jsx("feMorphology", { in: "SourceAlpha", operator: "erode", radius: "1", result: "effect1_dropShadow_1116_1212" }), jsxRuntimeExports.jsx("feOffset", { dy: "2" }), jsxRuntimeExports.jsx("feGaussianBlur", { stdDeviation: "2" }), jsxRuntimeExports.jsx("feComposite", { in2: "hardAlpha", operator: "out" }), jsxRuntimeExports.jsx("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" }), jsxRuntimeExports.jsx("feBlend", { in2: "BackgroundImageFix", mode: "normal", result: "effect1_dropShadow_1116_1212" }), jsxRuntimeExports.jsx("feColorMatrix", { in: "SourceAlpha", result: "hardAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" }), jsxRuntimeExports.jsx("feMorphology", { in: "SourceAlpha", operator: "erode", radius: "1", result: "effect2_dropShadow_1116_1212" }), jsxRuntimeExports.jsx("feOffset", { dy: "4" }), jsxRuntimeExports.jsx("feGaussianBlur", { stdDeviation: "3" }), jsxRuntimeExports.jsx("feComposite", { in2: "hardAlpha", operator: "out" }), jsxRuntimeExports.jsx("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" }), jsxRuntimeExports.jsx("feBlend", { in2: "effect1_dropShadow_1116_1212", mode: "normal", result: "effect2_dropShadow_1116_1212" }), jsxRuntimeExports.jsx("feBlend", { in: "SourceGraphic", in2: "effect2_dropShadow_1116_1212", mode: "normal", result: "shape" })] }), jsxRuntimeExports.jsx("clipPath", { id: "clip0_1116_1212", children: jsxRuntimeExports.jsx("rect", { fill: "white", height: "9.69523", transform: "translate(46.3553 44.3552)", width: "9.69523" }) })] })] }));

const TasksIcon = ({ circleColor }) => (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx(GradientCircleIcon, { fill: circleColor }), jsxRuntimeExports.jsxs("g", { filter: "url(#filter0_d_1047_1594)", id: "object-1", children: [jsxRuntimeExports.jsx("path", { d: "M28.9833 29.6671H96.2239C96.8843 29.6671 97.5178 29.9302 97.9848 30.3984C98.4519 30.8666 98.7142 31.5017 98.7142 32.1638V44.6475C98.7142 45.3096 98.4519 45.9447 97.9848 46.4129C97.5178 46.8812 96.8843 47.1442 96.2239 47.1442H28.9833C28.3228 47.1442 27.6894 46.8812 27.2223 46.4129C26.7553 45.9447 26.4929 45.3096 26.4929 44.6475V32.1638C26.4929 31.5017 26.7553 30.8666 27.2223 30.3984C27.6894 29.9302 28.3228 29.6671 28.9833 29.6671V29.6671Z", fill: "white" }), jsxRuntimeExports.jsx("path", { d: "M66.665 33.5021H48.6868C47.5411 33.5021 46.6124 34.2199 46.6124 35.1055C46.6124 35.991 47.5411 36.7089 48.6868 36.7089H66.665C67.8106 36.7089 68.7394 35.991 68.7394 35.1055C68.7394 34.2199 67.8106 33.5021 66.665 33.5021Z", fill: "#7090E5" }), jsxRuntimeExports.jsx("path", { d: "M74.0433 40.2361H48.3632C47.3962 40.2361 46.6123 40.8822 46.6123 41.6791C46.6123 42.4761 47.3962 43.1222 48.3632 43.1222H74.0433C75.0103 43.1222 75.7942 42.4761 75.7942 41.6791C75.7942 40.8822 75.0103 40.2361 74.0433 40.2361Z", fill: "#D7E1FB" }), jsxRuntimeExports.jsx("path", { d: "M35.2093 43.1498C37.8226 43.1498 39.9411 41.0259 39.9411 38.406C39.9411 35.7861 37.8226 33.6622 35.2093 33.6622C32.596 33.6622 30.4776 35.7861 30.4776 38.406C30.4776 41.0259 32.596 43.1498 35.2093 43.1498Z", fill: "url(#paint1_linear_1047_1594)" })] }), jsxRuntimeExports.jsxs("g", { filter: "url(#filter1_d_1047_1594)", id: "object-2", children: [jsxRuntimeExports.jsx("path", { d: "M7.49778 51.1528H74.7383C75.3988 51.1528 76.0323 51.4159 76.4993 51.8841C76.9663 52.3523 77.2287 52.9874 77.2287 53.6496V66.1332C77.2287 66.7954 76.9663 67.4304 76.4993 67.8986C76.0323 68.3669 75.3988 68.6299 74.7383 68.6299H7.49778C6.83728 68.6299 6.20384 68.3669 5.7368 67.8986C5.26976 67.4304 5.00739 66.7954 5.00739 66.1332V53.6496C5.00739 52.9874 5.26976 52.3523 5.7368 51.8841C6.20384 51.4159 6.83728 51.1528 7.49778 51.1528V51.1528Z", fill: "white" }), jsxRuntimeExports.jsx("path", { d: "M39.5453 55.1469H26.5952C25.77 55.1469 25.101 55.8175 25.101 56.6449C25.101 57.4722 25.77 58.1429 26.5952 58.1429H39.5453C40.3705 58.1429 41.0395 57.4722 41.0395 56.6449C41.0395 55.8175 40.3705 55.1469 39.5453 55.1469Z", fill: "#7090E5" }), jsxRuntimeExports.jsx("path", { d: "M48.5106 61.6388H26.5952C25.7699 61.6388 25.1009 62.3095 25.1009 63.1368C25.1009 63.9642 25.7699 64.6349 26.5952 64.6349H48.5106C49.3358 64.6349 50.0048 63.9642 50.0048 63.1368C50.0048 62.3095 49.3358 61.6388 48.5106 61.6388Z", fill: "#D7E1FB" }), jsxRuntimeExports.jsx("path", { d: "M13.7237 64.6344C16.337 64.6344 18.4555 62.5106 18.4555 59.8906C18.4555 57.2707 16.337 55.1469 13.7237 55.1469C11.1104 55.1469 8.99197 57.2707 8.99197 59.8906C8.99197 62.5106 11.1104 64.6344 13.7237 64.6344Z", fill: "url(#paint2_linear_1047_1594)" })] }), jsxRuntimeExports.jsx("g", { filter: "url(#filter2_d_1047_1594)", id: "object-3", children: jsxRuntimeExports.jsx("path", { d: "M7.49781 8.18127H74.7383C75.3988 8.18127 76.0323 8.44432 76.4993 8.91255C76.9664 9.38078 77.2287 10.0158 77.2287 10.678V23.1616C77.2287 23.8238 76.9664 24.4589 76.4993 24.9271C76.0323 25.3953 75.3988 25.6584 74.7383 25.6584H7.49781C6.83731 25.6584 6.20387 25.3953 5.73683 24.9271C5.2698 24.4589 5.00742 23.8238 5.00742 23.1616V10.678C5.00742 10.0158 5.2698 9.38078 5.73683 8.91255C6.20387 8.44432 6.83731 8.18127 7.49781 8.18127V8.18127Z", fill: "white" }) }), jsxRuntimeExports.jsx("path", { d: "M39.5453 12.1765H26.5953C25.77 12.1765 25.101 12.8472 25.101 13.6745C25.101 14.5019 25.77 15.1726 26.5953 15.1726H39.5453C40.3706 15.1726 41.0395 14.5019 41.0395 13.6745C41.0395 12.8472 40.3706 12.1765 39.5453 12.1765Z", fill: "#7090E5", id: "object-4" }), jsxRuntimeExports.jsx("path", { d: "M60.3953 18.7504H27.378C26.1347 18.7504 25.1268 19.3965 25.1268 20.1935C25.1268 20.9905 26.1347 21.6366 27.378 21.6366H60.3953C61.6386 21.6366 62.6464 20.9905 62.6464 20.1935C62.6464 19.3965 61.6386 18.7504 60.3953 18.7504Z", fill: "#D7E1FB", id: "object-5" }), jsxRuntimeExports.jsx("path", { d: "M13.7237 21.6641C16.337 21.6641 18.4555 19.5402 18.4555 16.9203C18.4555 14.3004 16.337 12.1765 13.7237 12.1765C11.1105 12.1765 8.992 14.3004 8.992 16.9203C8.992 19.5402 11.1105 21.6641 13.7237 21.6641Z", fill: "url(#paint3_linear_1047_1594)", id: "object-6" }), jsxRuntimeExports.jsxs("defs", { children: [jsxRuntimeExports.jsxs("filter", { colorInterpolationFilters: "sRGB", filterUnits: "userSpaceOnUse", height: "27.4771", id: "filter0_d_1047_1594", width: "82.2213", x: "21.4929", y: "28.6671", children: [jsxRuntimeExports.jsx("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }), jsxRuntimeExports.jsx("feColorMatrix", { in: "SourceAlpha", result: "hardAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" }), jsxRuntimeExports.jsx("feMorphology", { in: "SourceAlpha", operator: "erode", radius: "1", result: "effect1_dropShadow_1047_1594" }), jsxRuntimeExports.jsx("feOffset", { dy: "4" }), jsxRuntimeExports.jsx("feGaussianBlur", { stdDeviation: "3" }), jsxRuntimeExports.jsx("feComposite", { in2: "hardAlpha", operator: "out" }), jsxRuntimeExports.jsx("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" }), jsxRuntimeExports.jsx("feBlend", { in2: "BackgroundImageFix", mode: "normal", result: "effect1_dropShadow_1047_1594" }), jsxRuntimeExports.jsx("feBlend", { in: "SourceGraphic", in2: "effect1_dropShadow_1047_1594", mode: "normal", result: "shape" })] }), jsxRuntimeExports.jsxs("filter", { colorInterpolationFilters: "sRGB", filterUnits: "userSpaceOnUse", height: "27.4771", id: "filter1_d_1047_1594", width: "82.2213", x: "0.00738525", y: "50.1528", children: [jsxRuntimeExports.jsx("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }), jsxRuntimeExports.jsx("feColorMatrix", { in: "SourceAlpha", result: "hardAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" }), jsxRuntimeExports.jsx("feMorphology", { in: "SourceAlpha", operator: "erode", radius: "1", result: "effect1_dropShadow_1047_1594" }), jsxRuntimeExports.jsx("feOffset", { dy: "4" }), jsxRuntimeExports.jsx("feGaussianBlur", { stdDeviation: "3" }), jsxRuntimeExports.jsx("feComposite", { in2: "hardAlpha", operator: "out" }), jsxRuntimeExports.jsx("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" }), jsxRuntimeExports.jsx("feBlend", { in2: "BackgroundImageFix", mode: "normal", result: "effect1_dropShadow_1047_1594" }), jsxRuntimeExports.jsx("feBlend", { in: "SourceGraphic", in2: "effect1_dropShadow_1047_1594", mode: "normal", result: "shape" })] }), jsxRuntimeExports.jsxs("filter", { colorInterpolationFilters: "sRGB", filterUnits: "userSpaceOnUse", height: "27.4771", id: "filter2_d_1047_1594", width: "82.2213", x: "0.00741577", y: "7.18127", children: [jsxRuntimeExports.jsx("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }), jsxRuntimeExports.jsx("feColorMatrix", { in: "SourceAlpha", result: "hardAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" }), jsxRuntimeExports.jsx("feMorphology", { in: "SourceAlpha", operator: "erode", radius: "1", result: "effect1_dropShadow_1047_1594" }), jsxRuntimeExports.jsx("feOffset", { dy: "4" }), jsxRuntimeExports.jsx("feGaussianBlur", { stdDeviation: "3" }), jsxRuntimeExports.jsx("feComposite", { in2: "hardAlpha", operator: "out" }), jsxRuntimeExports.jsx("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" }), jsxRuntimeExports.jsx("feBlend", { in2: "BackgroundImageFix", mode: "normal", result: "effect1_dropShadow_1047_1594" }), jsxRuntimeExports.jsx("feBlend", { in: "SourceGraphic", in2: "effect1_dropShadow_1047_1594", mode: "normal", result: "shape" })] }), jsxRuntimeExports.jsxs("linearGradient", { gradientUnits: "userSpaceOnUse", id: "paint0_linear_1047_1594", x1: "-11.7658", x2: "80.1277", y1: "6.46155", y2: "56.6137", children: [jsxRuntimeExports.jsx("stop", { stopColor: "#EBF1FF" }), jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "#C3D4FF" })] }), jsxRuntimeExports.jsxs("linearGradient", { gradientUnits: "userSpaceOnUse", id: "paint1_linear_1047_1594", x1: "30.3094", x2: "40.1332", y1: "33.6622", y2: "43.1248", children: [jsxRuntimeExports.jsx("stop", { stopColor: "#CF00B1" }), jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "#FF37F0" })] }), jsxRuntimeExports.jsxs("linearGradient", { gradientUnits: "userSpaceOnUse", id: "paint2_linear_1047_1594", x1: "8.82385", x2: "18.6476", y1: "55.1469", y2: "64.6095", children: [jsxRuntimeExports.jsx("stop", { stopColor: "#CF00B1" }), jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "#FF37F0" })] }), jsxRuntimeExports.jsxs("linearGradient", { gradientUnits: "userSpaceOnUse", id: "paint3_linear_1047_1594", x1: "8.82388", x2: "18.6476", y1: "12.1765", y2: "21.6391", children: [jsxRuntimeExports.jsx("stop", { stopColor: "#CF00B1" }), jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "#FF37F0" })] })] })] }));

function EmptyStateIcon(_a) {
    var { circleColor, icon = 'medicalfile', id, size = 80 } = _a, props = __rest(_a, ["circleColor", "icon", "id", "size"]);
    return (jsxRuntimeExports.jsx(StyledEmptyStateIcon$1, Object.assign({ fill: "none", height: size, id: id, viewBox: getViewbox(icon) }, props, { children: getIcon(icon, circleColor) })));
}
function getViewbox(icon) {
    switch (icon) {
        case 'tasks':
            return '0 0 104 80';
        case 'careprovider':
            return '0 0 84 80';
        default:
            return '0 0 80 80';
    }
}
function getIcon(icon, circleColor) {
    switch (icon) {
        case 'medicalfile':
            return jsxRuntimeExports.jsx(MedicalFileIcon, { circleColor: circleColor });
        case 'contactmoments':
            return jsxRuntimeExports.jsx(ContactMomentsIcon, { circleColor: circleColor });
        case 'notes':
            return jsxRuntimeExports.jsx(NotesIcon, { circleColor: circleColor });
        case 'tasks':
            return jsxRuntimeExports.jsx(TasksIcon, { circleColor: circleColor });
        case 'searchresults':
            return jsxRuntimeExports.jsx(SearchResultsIcon, { circleColor: circleColor });
        case 'careprovider':
            return jsxRuntimeExports.jsx(CareProviderIcon, { circleColor: circleColor });
    }
    return null;
}
const StyledEmptyStateIcon$1 = styled.svg `
    transition: all 0.2s;
    flex-shrink: 0;
`;

/**
 * EmptyState component to display a message with an icon, title, and subtitle.
 *
 */
function EmptyState$1({ children, icon = 'medicalfile', subtitle = '', title = '', variant = 'centered', }) {
    return (jsxRuntimeExports.jsxs(StyledEmptyState, { "$variant": variant, children: [jsxRuntimeExports.jsx(StyledEmptyStateIcon, { icon: icon }), jsxRuntimeExports.jsxs(StyledTextContainer, { "$variant": variant, children: [jsxRuntimeExports.jsx(StyledHeading$1, { children: title }), jsxRuntimeExports.jsx(StyledText$1, { children: subtitle })] }), children && (jsxRuntimeExports.jsx(ButtonRow, { isStackedBelowSmall: true, justify: "center", children: children }))] }));
}
const StyledEmptyStateIcon = styled(EmptyStateIcon) ``;
const StyledHeading$1 = styled(Heading) ``;
const StyledText$1 = styled(Text) ``;
const containerQuerySmall = '@container empty-state (inline-size > 544px)';
const StyledEmptyState = styled.div `
    display: flex;
    text-align: center;
    flex-flow: column wrap;
    align-items: center;
    justify-content: center;
    container-name: empty-state;
    container-type: inline-size;

    ${({ $variant, theme }) => {
    switch ($variant) {
        case 'centered':
            return css$3 `
                    ${StyledEmptyStateIcon} {
                        height: 80px;

                        ${containerQuerySmall} {
                            height: 200px;
                        }
                    }

                    ${StyledHeading$1} {
                        text-align: center;
                        width: 100%;
                        font-size: ${theme.fontSizes.sm};
                        line-height: ${theme.lineHeights[5]};
                        font-weight: ${theme.fontWeights.bold};
                        margin: ${theme.space[4]} 0 0;

                        ${containerQuerySmall} {
                            font-size: ${theme.fontSizes.xl};
                            line-height: ${theme.lineHeights[7]};
                            margin: ${theme.space[8]} 0 ${theme.space[2]};
                        }
                    }

                    ${StyledText$1} {
                        font-size: ${theme.fontSizes.sm};
                        line-height: ${theme.lineHeights[5]};
                        margin-bottom: ${theme.space[4]};

                        ${containerQuerySmall} {
                            font-size: ${theme.fontSizes.md};
                            margin-bottom: ${theme.space[5]};
                        }
                    }
                `;
        case 'left-aligned':
            return css$3 `
                    margin: ${theme.space[4]} 0 ${theme.space[3]};

                    ${StyledHeading$1} {
                        width: 100%;
                        font-size: ${theme.fontSizes.sm};
                        line-height: ${theme.lineHeights[5]};
                        margin-top: ${theme.space[4]};

                        ${containerQuerySmall} {
                            font-size: ${theme.fontSizes.md};
                            line-height: ${theme.lineHeights[6]};
                            margin-top: ${theme.space[4]};
                        }
                    }

                    ${StyledText$1} {
                        width: 100%;
                        font-size: ${theme.fontSizes.sm};
                        line-height: ${theme.lineHeights[5]};
                        margin-top: ${theme.space[0]};
                    }

                    /* Align left on medium and above screens */
                    ${theme.mediaQueries.medium} {
                        align-items: flex-start;
                        justify-content: flex-start;
                        text-align: left;
                        flex-flow: row nowrap;

                        ${StyledHeading$1} {
                            margin: 0;
                        }
                    }

                    border: 1px dashed;
                    border-color: ${theme.colors.neutral400};
                    border-radius: ${theme.radii.base};
                    padding: ${theme.space[6]};
                    min-height: 128px;
                `;
        default:
            return '';
    }
}}
`;
const StyledTextContainer = styled.div `
    ${({ $variant, theme }) => {
    switch ($variant) {
        case 'centered':
            return css$3 `
                    flex: 1 0 100%;
                `;
        case 'left-aligned':
            return css$3 `
                    align-self: stretch;
                    display: flex;
                    flex-flow: row wrap;
                    align-items: center;
                    align-content: center;

                    ${theme.mediaQueries.medium} {
                        margin-left: ${theme.space[8]};
                    }
                `;
        default:
            return '';
    }
}}
`;

const useViewportWidth = () => {
    const [width, setWidth] = useState(window.innerWidth);
    useEffect(() => {
        const handleWindowResize = () => setWidth(window.innerWidth);
        window.addEventListener('resize', handleWindowResize);
        return () => window.removeEventListener('resize', handleWindowResize);
    }, []);
    return { width };
};

const createStatusConfig = ({ Component, icon, iconColor, spinnerColor, textColor, }) => ({
    icon: (jsxRuntimeExports.jsx(Component, { color: Component === Spinner ? spinnerColor : iconColor, icon: icon, sx: { mr: Component === Spinner ? 2 : 1 } })),
    text: {
        color: textColor,
        isSensitiveData: false,
    },
});
function Status({ isSensitiveData, state, sx: sxProp, text }) {
    if (!state) {
        return null;
    }
    const statusConfig = {
        failed: createStatusConfig({
            Component: Icon,
            icon: 'warning',
            iconColor: 'danger',
            textColor: 'danger',
        }),
        retrying: createStatusConfig({
            Component: Spinner,
            spinnerColor: 'red700',
            textColor: 'danger',
        }),
        saved: createStatusConfig({
            Component: Icon,
            icon: 'closed',
            iconColor: 'subtle',
            textColor: 'subtle',
        }),
        saving: createStatusConfig({
            Component: Spinner,
            spinnerColor: 'neutral700',
            textColor: 'subtle',
        }),
        // add more statuses here if needed
    };
    return (jsxRuntimeExports.jsxs(StyledStatus, { sx: sxProp, children: [statusConfig[state].icon, jsxRuntimeExports.jsx(Text, { as: "span", color: statusConfig[state].text.color, "data-dd-privacy": isSensitiveData ? 'mask' : 'allow', fontWeight: "medium", size: ['sm', null, null, 'md'], children: text })] }));
}
const StyledStatus = styled.span `
    display: flex;
    flex-direction: row;
    align-items: center;

    ${(props) => props.theme.mediaQueries.large} {
        top: 16px;
    }

    ${sx}
`;

function EpisodeHeader(_a) {
    var { autoSaveStatus, bannerHeight, children, icon, isSensitiveData = false, title, withinScrollContainer } = _a, props = __rest(_a, ["autoSaveStatus", "bannerHeight", "children", "icon", "isSensitiveData", "title", "withinScrollContainer"]);
    const { width } = useViewportWidth();
    return (jsxRuntimeExports.jsx(StyledEpisodeHeaderWrapper, Object.assign({ "$bannerHeight": bannerHeight, "$withinScrollContainer": withinScrollContainer }, props, { children: jsxRuntimeExports.jsxs(StyledEpisodeHeader, { children: [autoSaveStatus && (jsxRuntimeExports.jsx(Status, { isSensitiveData: isSensitiveData, state: autoSaveStatus.state, sx: {
                        position: 'absolute',
                        right: 0,
                        top: '8px',
                    }, text: autoSaveStatus.text })), jsxRuntimeExports.jsxs(StyledEpisodeHeaderTitle, { children: [jsxRuntimeExports.jsx(CarePathIcon, { icon: icon, size: width < 1024 ? '39px' : '55px', style: { flexShrink: 0 } }), jsxRuntimeExports.jsx(Heading, { "data-dd-privacy": isSensitiveData ? 'mask' : 'allow', ml: 4, size: "xlarge", children: title })] }), children] }) })));
}
const StyledEpisodeHeaderWrapper = styled.div `
    position: sticky;
    background-color: var(--kds-color-background-minimal);
    z-index: 2;
    margin-bottom: 16px;
    margin-top: -16px;

    ${(props) => css$3 `
        top: calc(
            ${props.$bannerHeight ? props.$bannerHeight : 0}px +
                ${props.$withinScrollContainer ? '0px' : props.theme.appLayout.header.height}
        );
    `}

    ${(props) => props.theme.mediaQueries.small} {
        /* extra padding to overlap the box-shadow of the form which scrolls behind the EpisodeHeader */
        margin-left: -8px;
        padding-left: 8px;
        margin-right: -8px;
        padding-right: 8px;
    }

    ${sx}
`;
const StyledEpisodeHeader = styled.div `
    display: flex;
    align-items: left;
    flex-direction: column;
    padding-top: 8px;
    margin-left: 16px;
    margin-right: 16px;
    position: relative;

    ${(props) => props.theme.mediaQueries.small} {
        margin-left: 0;
        margin-right: 0;
    }

    ${(props) => props.theme.mediaQueries.large} {
        padding-top: 16px;
    }
`;
const StyledEpisodeHeaderTitle = styled.div `
    display: flex;
    align-items: center;
    padding-bottom: 4px;

    ${(props) => props.theme.mediaQueries.large} {
        padding-bottom: 8px;
    }
`;

function FileTypeIcon(_a) {
    var { height, icon = 'doc', id, width } = _a, props = __rest(_a, ["height", "icon", "id", "width"]);
    if (width) {
        height = '100%';
    }
    else if (height) {
        width = '100%';
    }
    return (jsxRuntimeExports.jsx("svg", Object.assign({ height: height, id: id, viewBox: "0 0 44 60", width: width, xmlns: "http://www.w3.org/2000/svg" }, props, { children: getFileTypeIcon(icon) })));
}
function getFileTypeIcon(icon) {
    switch (icon) {
        case 'doc':
            return (jsxRuntimeExports.jsxs("g", { fill: "none", fillRule: "evenodd", children: [jsxRuntimeExports.jsx("path", { d: "M0 0h31.974L44 12.111V60H0z", fill: "#ECECE6" }), jsxRuntimeExports.jsx("path", { d: "M44 12H32V0z", fill: "#002996" }), jsxRuntimeExports.jsx("path", { d: "M0 0h32v12H0z", fill: "#003BD7" }), jsxRuntimeExports.jsx("path", { d: "M8.616 9V2.88h2.088c1.808 0 3.064.888 3.064 2.984S12.528 9 10.736 9h-2.12zm1.312-.992h.712c1.056 0 1.736-.528 1.736-2.112 0-1.512-.688-2.04-1.696-2.04h-.752v4.152zM14.56 5.96c0-2.016 1.176-3.168 2.888-3.168 1.792 0 2.888 1.128 2.888 3.168 0 2.016-1.136 3.168-2.888 3.168-1.832 0-2.888-1.136-2.888-3.168zm2.888 2.208c.928 0 1.472-.752 1.472-2.208 0-1.464-.608-2.224-1.472-2.224-.928 0-1.464.744-1.464 2.224 0 1.472.504 2.208 1.464 2.208zm6.52-4.4c-.824 0-1.416.752-1.416 2.208 0 1.4.536 2.168 1.408 2.168.72 0 1.128-.456 1.2-1.224h1.336c-.064 1.32-1.008 2.208-2.504 2.208-1.904 0-2.856-1.16-2.856-3.104 0-2.016 1.056-3.232 2.832-3.232 1.496 0 2.448.784 2.536 2.16h-1.352c-.064-.72-.512-1.184-1.184-1.184z", fill: "#FFF", fillRule: "nonzero" }), jsxRuntimeExports.jsx("path", { d: "M12 21h20v28H12V21zm2 2v24h16V23H14zm2 5h12v2H16v-2zm0 4h12v2H16v-2zm0 4h12v2H16v-2zm0 4h6v2h-6v-2z", fill: "#DBD5D0" })] }));
        case 'mov':
            return (jsxRuntimeExports.jsxs("g", { fill: "none", fillRule: "evenodd", children: [jsxRuntimeExports.jsx("path", { d: "M0 0h31.974L44 12.111V60H0z", fill: "#ECECE6" }), jsxRuntimeExports.jsx("path", { d: "M44 12H32V0z", fill: "#0087D2" }), jsxRuntimeExports.jsx("path", { d: "M0 0h32v12H0z", fill: "#03ADF8" }), jsxRuntimeExports.jsx("path", { d: "M6.616 9V2.88H8.52l1.104 3.288c.176.512.256.904.256.904h.016s.088-.392.256-.904l1.096-3.288h1.904V9h-1.296V4.208h-.024s-.136.568-.376 1.296L10.312 9h-.976L8.184 5.504c-.24-.736-.36-1.288-.36-1.288H7.8V9H6.616zm7.552-3.04c0-2.016 1.176-3.168 2.888-3.168 1.792 0 2.888 1.128 2.888 3.168 0 2.016-1.136 3.168-2.888 3.168-1.832 0-2.888-1.136-2.888-3.168zm2.888 2.208c.928 0 1.472-.752 1.472-2.208 0-1.464-.608-2.224-1.472-2.224-.928 0-1.464.744-1.464 2.224 0 1.472.504 2.208 1.464 2.208zM22.568 9l-2.064-6.12h1.376l1.256 3.968c.184.592.216.912.216.912h.016s.032-.32.216-.904l1.272-3.976h1.264L24.072 9h-1.504z", fill: "#FFF", fillRule: "nonzero" }), jsxRuntimeExports.jsxs("g", { stroke: "#DBD5D0", strokeWidth: "2", children: [jsxRuntimeExports.jsx("path", { d: "M6 26h32v20H6z" }), jsxRuntimeExports.jsx("path", { d: "M25 36.5L20 40v-7z" })] })] }));
        case 'mp4':
            return (jsxRuntimeExports.jsxs("g", { fill: "none", fillRule: "evenodd", children: [jsxRuntimeExports.jsx("path", { d: "M0 0h31.974L44 12.111V60H0z", fill: "#ECECE6" }), jsxRuntimeExports.jsx("path", { d: "M44 12H32V0z", fill: "#0087D2" }), jsxRuntimeExports.jsx("path", { d: "M0 0h32v12H0z", fill: "#03ADF8" }), jsxRuntimeExports.jsx("path", { d: "M7.616 9V2.88H9.52l1.104 3.288c.176.512.256.904.256.904h.016s.088-.392.256-.904l1.096-3.288h1.904V9h-1.296V4.208h-.024s-.136.568-.376 1.296L11.312 9h-.976L9.184 5.504c-.24-.736-.36-1.288-.36-1.288H8.8V9H7.616zM17.4 6.904h-.704V9h-1.312V2.88h2.128c1.328 0 2.336.56 2.336 1.976 0 1.488-1.08 2.048-2.448 2.048zm-.704-.968h.792c.68 0 1.072-.352 1.072-1.064 0-.752-.392-1.048-1.056-1.048h-.808v2.112zm4.896.792h1.624v-2.56H23.2s-.104.288-.336.64l-1.272 1.92zm3.568.96h-.72V9h-1.248V7.688h-2.8V6.8l2.544-3.728h1.504v3.64h.72v.976z", fill: "#FFF", fillRule: "nonzero" }), jsxRuntimeExports.jsxs("g", { stroke: "#DBD5D0", strokeWidth: "2", children: [jsxRuntimeExports.jsx("path", { d: "M6 26h32v20H6z" }), jsxRuntimeExports.jsx("path", { d: "M25 36.5L20 40v-7z" })] })] }));
        case 'pdf':
            return (jsxRuntimeExports.jsxs("g", { fill: "none", fillRule: "evenodd", children: [jsxRuntimeExports.jsx("path", { d: "M0 0h31.974L44 12.111V60H0z", fill: "#ECECE6" }), jsxRuntimeExports.jsx("path", { d: "M12 21h20v28H12V21zm2 2v24h16V23H14zm2 5h12v2H16v-2zm0 4h12v2H16v-2zm0 4h12v2H16v-2zm0 4h6v2h-6v-2z", fill: "#DBD5D0" }), jsxRuntimeExports.jsx("path", { d: "M44 12H32V0z", fill: "#C71D3A" }), jsxRuntimeExports.jsx("path", { d: "M0 0h32v12H0z", fill: "#F92549" }), jsxRuntimeExports.jsx("path", { d: "M10.976 6.945h-.69V9H9V3h2.086c1.302 0 2.29.549 2.29 1.937 0 1.46-1.058 2.008-2.4 2.008zm-.69-.949h.777c.666 0 1.05-.345 1.05-1.043 0-.737-.384-1.028-1.035-1.028h-.792v2.071zM14.24 9V3h2.047c1.773 0 3.004.87 3.004 2.925C19.29 7.98 18.075 9 16.318 9h-2.079zm1.286-.973h.699c1.035 0 1.701-.517 1.701-2.07 0-1.482-.674-2-1.662-2h-.738v4.07zm6.04-1.34V9h-1.287V3h3.773v.98h-2.486v1.742h2.345v.964h-2.345z", fill: "#FFF" })] }));
        case 'png':
            return (jsxRuntimeExports.jsxs("g", { fill: "none", fillRule: "evenodd", children: [jsxRuntimeExports.jsx("path", { d: "M0 0h31.974L44 12.111V60H0z", fill: "#ECECE6" }), jsxRuntimeExports.jsx("path", { d: "M44 12H32V0z", fill: "#CC2CC0" }), jsxRuntimeExports.jsx("path", { d: "M33 25v22H11V25h22zM14.938 36.996L13 38.904V45h10.003l-8.065-8.004zM24 34.414l-4.395 4.395 6.232 6.186-.007.005H31v-3.585l-7-7zM31 27H13v9.096l1.943-1.913 3.242 3.218L24 31.586l7 6.999V27zm-13 1a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm0 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2z", fill: "#DBD5D0", fillRule: "nonzero" }), jsxRuntimeExports.jsx("path", { d: "M0 0h32v12H0z", fill: "#FF37F0" }), jsxRuntimeExports.jsx("path", { d: "M9.91 6.894h-.668v1.985H8V3.083h2.015c1.258 0 2.212.53 2.212 1.872 0 1.409-1.022 1.939-2.318 1.939zm-.668-.917h.75c.644 0 1.016-.333 1.016-1.007 0-.712-.372-.993-1-.993h-.766v2zm3.819 2.902V3.083h1.37l1.872 3.137c.295.5.417.863.417.863h.022v-4h1.137V8.88h-1.31l-1.925-3.197a5.05 5.05 0 0 1-.44-.879h-.022V8.88H13.06zm8.515-4.985c-.902 0-1.417.735-1.417 2.114 0 1.5.538 2.09 1.417 2.09.795 0 1.257-.484 1.318-1.31l.008-.106H21.53v-.894h2.53v3.09h-.984v-.787h-.03c-.273.523-.826.909-1.682.909-1.652 0-2.53-1.144-2.53-2.932C18.833 4.19 19.931 3 21.575 3c1.394 0 2.235.66 2.371 1.84h-1.265c-.076-.56-.493-.946-1.106-.946z", fill: "#FFF" })] }));
        case 'ppt':
            return (jsxRuntimeExports.jsxs("g", { fill: "none", fillRule: "evenodd", children: [jsxRuntimeExports.jsx("path", { d: "M0 0h31.974L44 12.111V60H0z", fill: "#ECECE6" }), jsxRuntimeExports.jsx("path", { d: "M44 12H32V0z", fill: "#C71D3A" }), jsxRuntimeExports.jsx("path", { d: "M0 0h32v12H0z", fill: "#F92549" }), jsxRuntimeExports.jsx("path", { d: "M10.632 6.904h-.704V9H8.616V2.88h2.128c1.328 0 2.336.56 2.336 1.976 0 1.488-1.08 2.048-2.448 2.048zm-.704-.968h.792c.68 0 1.072-.352 1.072-1.064 0-.752-.392-1.048-1.056-1.048h-.808v2.112zm6.048.968h-.704V9H13.96V2.88h2.128c1.328 0 2.336.56 2.336 1.976 0 1.488-1.08 2.048-2.448 2.048zm-.704-.968h.792c.68 0 1.072-.352 1.072-1.064 0-.752-.392-1.048-1.056-1.048h-.808v2.112zM23.8 2.88v1.032h-1.808V9H20.68V3.912h-1.808V2.88H23.8z", fill: "#FFF", fillRule: "nonzero" }), jsxRuntimeExports.jsx("path", { d: "M10 18h24v35H10V18zm2 2v31h20V20H12zm6 20h12v2H18v-2zm-2 0h-2v2h2v-2zm2 4h12v2H18v-2zm-2 0h-2v2h2v-2z", fill: "#DBD5D0" }), jsxRuntimeExports.jsx("path", { d: "M22 36a6 6 0 0 0 5.087-9.183c-.213-.34-.602-.793-1.168-1.36-.66-.487-1.18-.812-1.56-.975A6 6 0 1 0 22 36z", stroke: "#DBD5D0", strokeWidth: "2" }), jsxRuntimeExports.jsx("path", { d: "M21.732 30.286L21.861 23l7.13 6.65z", fill: "#DBD5D0" })] }));
        case 'tiff':
            return (jsxRuntimeExports.jsxs("g", { fill: "none", fillRule: "evenodd", children: [jsxRuntimeExports.jsx("path", { d: "M0 0h31.974L44 12.111V60H0z", fill: "#ECECE6" }), jsxRuntimeExports.jsx("path", { d: "M33 25v22H11V25h22zM14.938 36.996L13 38.904V45h10.003l-8.065-8.004zM24 34.414l-4.395 4.395 6.232 6.186-.007.005H31v-3.585l-7-7zM31 27H13v9.096l1.943-1.913 3.242 3.218L24 31.586l7 6.999V27zm-13 1a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm0 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2z", fill: "#DBD5D0", fillRule: "nonzero" }), jsxRuntimeExports.jsx("path", { d: "M44 12H32V0z", fill: "#002996" }), jsxRuntimeExports.jsx("path", { d: "M0 0h32v12H0z", fill: "#003BD7" }), jsxRuntimeExports.jsx("path", { d: "M12.831 3v1.012H11.06V9H9.773V4.012H8V3h4.831zm.785 6V3h1.286v6h-1.286zm3.78-2.314V9H16.11V3h3.772v.98h-2.486v1.742h2.345v.964h-2.345zm4.73 0V9h-1.287V3h3.773v.98h-2.487v1.742h2.346v.964h-2.346z", fill: "#FFF" })] }));
        case 'xls':
            return (jsxRuntimeExports.jsxs("g", { fill: "none", fillRule: "evenodd", children: [jsxRuntimeExports.jsx("path", { d: "M0 0h31.974L44 12.111V60H0z", fill: "#ECECE6" }), jsxRuntimeExports.jsx("path", { d: "M44 12H32V0z", fill: "#00D06A" }), jsxRuntimeExports.jsx("path", { d: "M0 0h32v12H0z", fill: "#1CE093" }), jsxRuntimeExports.jsx("path", { d: "M8.2 9l2.032-3.16-1.888-2.96h1.512l1.176 1.952h.008l1.208-1.952h1.376l-1.896 2.912L13.808 9h-1.552L10.92 6.808h-.016L9.568 9H8.2zm6.424 0V2.88h1.312v5.096h2.64V9h-3.952zm9.344-4.456h-1.344c-.032-.408-.304-.8-.912-.8-.568 0-.92.304-.92.736 0 .408.224.656.808.76l.928.168c1.088.2 1.616.784 1.616 1.688 0 1.312-.896 2.032-2.456 2.032-1.528 0-2.384-.736-2.448-1.88h1.368c.064.528.432.92 1.112.92.728 0 1.064-.368 1.064-.832 0-.424-.232-.648-.872-.768L21 6.392c-.944-.184-1.576-.752-1.576-1.728 0-1.08.832-1.872 2.296-1.872 1.552 0 2.208.8 2.248 1.752z", fill: "#FFF", fillRule: "nonzero" }), jsxRuntimeExports.jsx("path", { d: "M8 24h28v23H8V24zm2 2v19h24V26H10zm0 5h24v2H10v-2zm0 7h24v2H10v-2z", fill: "#DBD5D0" }), jsxRuntimeExports.jsx("path", { d: "M16.5 25v20", stroke: "#DBD5D0", strokeLinecap: "square", strokeWidth: "2" })] }));
        case 'jpg':
            return (jsxRuntimeExports.jsxs("g", { fill: "none", fillRule: "evenodd", children: [jsxRuntimeExports.jsx("polygon", { fill: "#ECECE6", points: "0 0 31.974 0 44 12.111 44 60 0 60" }), jsxRuntimeExports.jsx("path", { d: "M31,38.5857864 L31,27 L13,27 L13,36.0975919 L14.94349,34.1833828 L18.1851677,37.4006187 L24,31.5857864 L31,38.5857864 Z M31,41.4142136 L24,34.4142136 L19.604733,38.8094806 L25.8368906,44.9946484 L25.8315793,45 L31,45 L31,41.4142136 Z M23.0030914,45 L14.9381379,36.9958554 L13,38.9047931 L13,45 L23.0030914,45 Z M11,25 L33,25 L33,47 L11,47 L11,25 Z M18,34 C16.3431458,34 15,32.6568542 15,31 C15,29.3431458 16.3431458,28 18,28 C19.6568542,28 21,29.3431458 21,31 C21,32.6568542 19.6568542,34 18,34 Z M18,32 C18.5522847,32 19,31.5522847 19,31 C19,30.4477153 18.5522847,30 18,30 C17.4477153,30 17,30.4477153 17,31 C17,31.5522847 17.4477153,32 18,32 Z", fill: "#DBD5D0", fillRule: "nonzero" }), jsxRuntimeExports.jsx("polygon", { fill: "#D88219", points: "32 0 44 0 44 12", transform: "rotate(-180 38 6)" }), jsxRuntimeExports.jsx("rect", { fill: "#FF9A1E", height: "12", width: "32" }), jsxRuntimeExports.jsx("path", { d: "M9.47727273,8.90151515 L9,8.90151515 L9,7.91666667 L9.28030303,7.91666667 C10.2424242,7.91666667 10.3863636,7.56818182 10.3863636,6.87121212 L10.3863636,3.08333333 L11.6136364,3.08333333 L11.6136364,7.02272727 C11.6136364,8.46212121 10.8181818,8.90151515 9.47727273,8.90151515 Z M14.6363636,6.89393939 L13.969697,6.89393939 L13.969697,8.87878788 L12.7272727,8.87878788 L12.7272727,3.08333333 L14.7424242,3.08333333 C16,3.08333333 16.9545455,3.61363636 16.9545455,4.95454545 C16.9545455,6.36363636 15.9318182,6.89393939 14.6363636,6.89393939 Z M13.969697,5.97727273 L14.719697,5.97727273 C15.3636364,5.97727273 15.7348485,5.64393939 15.7348485,4.96969697 C15.7348485,4.25757576 15.3636364,3.97727273 14.7348485,3.97727273 L13.969697,3.97727273 L13.969697,5.97727273 Z M20.3257576,3.89393939 C19.4242424,3.89393939 18.9090909,4.62878788 18.9090909,6.00757576 C18.9090909,7.50757576 19.4469697,8.09848485 20.3257576,8.09848485 C21.1212121,8.09848485 21.5833333,7.61363636 21.6439394,6.78787879 L21.6515152,6.68181818 L20.280303,6.68181818 L20.280303,5.78787879 L22.8106061,5.78787879 L22.8106061,8.87878788 L21.8257576,8.87878788 L21.8257576,8.09090909 L21.7954545,8.09090909 C21.5227273,8.61363636 20.969697,9 20.1136364,9 C18.4621212,9 17.5833333,7.85606061 17.5833333,6.06818182 C17.5833333,4.18939394 18.6818182,3 20.3257576,3 C21.719697,3 22.5606061,3.65909091 22.6969697,4.84090909 L21.4318182,4.84090909 C21.3560606,4.28030303 20.9393939,3.89393939 20.3257576,3.89393939 Z", fill: "#FFF" })] }));
        case 'heic':
            return (jsxRuntimeExports.jsxs("g", { fill: "none", fillRule: "evenodd", children: [jsxRuntimeExports.jsx("path", { d: "M0 0h31.974L44 12.111V60H0z", fill: "#ECECE6" }), jsxRuntimeExports.jsx("path", { d: "M44 12H32V0z", fill: "#CC2CC0" }), jsxRuntimeExports.jsx("path", { d: "M33 25v22H11V25h22zM14.938 36.996L13 38.904V45h10.003l-8.065-8.004zM24 34.414l-4.395 4.395 6.232 6.186-.007.005H31v-3.585l-7-7zM31 27H13v9.096l1.943-1.913 3.242 3.218L24 31.586l7 6.999V27zm-13 1a3 3 0 110 6 3 3 0 010-6zm0 2a1 1 0 100 2 1 1 0 000-2z", fill: "#DBD5D0", fillRule: "nonzero" }), jsxRuntimeExports.jsx("path", { d: "M0 0h32v12H0z", fill: "#FF37F0" }), jsxRuntimeExports.jsx("path", { d: "M9.308 8.8V6.415h2.31V8.8h1.244V3.063h-1.244v2.392h-2.31V3.063h-1.23V8.8h1.23zm8.557 0v-.93h-2.617V6.393h2.415v-.915h-2.415V4h2.55v-.937h-3.78V8.8h3.847zm2.243 0V3.063h-1.23V8.8h1.23zm3.63.12c1.402 0 2.287-.832 2.347-2.07h-1.252c-.068.72-.45 1.148-1.125 1.148-.818 0-1.32-.72-1.32-2.033 0-1.365.555-2.07 1.327-2.07.63 0 1.05.435 1.11 1.11h1.268c-.083-1.29-.975-2.025-2.378-2.025-1.665 0-2.655 1.14-2.655 3.03 0 1.823.893 2.91 2.678 2.91z", fill: "#FFF", fillRule: "nonzero" })] }));
        default:
            return null;
    }
}

function Form(_a) {
    var { children, formRef, id, onSubmit, submitOnEnter } = _a, props = __rest(_a, ["children", "formRef", "id", "onSubmit", "submitOnEnter"]);
    return (jsxRuntimeExports.jsx(StyledForm, Object.assign({ id: id, onKeyDown: (e) => handleKeyDown(e, submitOnEnter), onSubmit: onSubmit, ref: formRef }, props, { children: children })));
}
function handleKeyDown(event, submitOnEnter) {
    if (event.key === 'Enter' &&
        !submitOnEnter &&
        !(event.target instanceof HTMLTextAreaElement) &&
        !(event.target instanceof HTMLButtonElement)) {
        event.preventDefault();
    }
}
const StyledForm = styled.form `
    ${sx}
`;

function FormButtonRow(_a) {
    var { children, isStackedBelowSmall = true, justify = 'right', size } = _a, props = __rest(_a, ["children", "isStackedBelowSmall", "justify", "size"]);
    const { size: formGroupContextSize } = useContext(FormGroupContext);
    const sizeProp = size || formGroupContextSize || 'large';
    return (jsxRuntimeExports.jsx(StyledFormButtonRow, Object.assign({ isStackedBelowSmall: isStackedBelowSmall, justify: justify, size: sizeProp }, props, { children: children })));
}
const StyledFormButtonRow = styled(ButtonRow) `
    margin-top: ${(props) => props.size && props.theme.formButtonRow[props.size].marginTop};
`;

function FormLabel(_a) {
    var _b;
    var { avatar, children, error, isRequired, isSensitiveData = false, size, tooltipText } = _a, props = __rest(_a, ["avatar", "children", "error", "isRequired", "isSensitiveData", "size", "tooltipText"]);
    const { size: formGroupContextSize } = useContext(FormGroupContext);
    const sizeProp = (_b = size !== null && size !== void 0 ? size : formGroupContextSize) !== null && _b !== void 0 ? _b : 'large';
    return (jsxRuntimeExports.jsxs(StyledFormLabel$1, Object.assign({ "$error": error, "$hasAvatar": !!avatar, "$size": sizeProp, "data-dd-privacy": isSensitiveData ? 'mask' : 'allow' }, props, { children: [avatar && (jsxRuntimeExports.jsx(Avatar, Object.assign({}, avatar, { size: sizeProp === 'large' ? 'small' : 'xsmall', sx: { mr: 4 } }))), children, isRequired && jsxRuntimeExports.jsx(Asterisk, { "$size": sizeProp, children: "*" }), tooltipText && (jsxRuntimeExports.jsx(Tooltip, { content: tooltipText, children: jsxRuntimeExports.jsx(Icon, { color: "primary", icon: "information", sx: { ml: 2 } }) }))] })));
}
const StyledFormLabel$1 = styled.label `
    color: var(--kds-color-foreground-default);
    display: inline-block;
    font-weight: var(--kds-font-weight-normal);
    margin: 0;

    ${(props) => props.$hasAvatar &&
    css$3 `
            display: inline-flex;
            align-items: center;
        `}

    ${(props) => props.$size === 'medium' &&
    css$3 `
            font-size: 14px;
            line-height: 20px;
        `}

    ${(props) => props.$size === 'large' &&
    css$3 `
            font-size: 16px;
            line-height: 24px;
        `}

    ${(props) => props.$error &&
    css$3 `
            color: var(--kds-color-foreground-warning);
        `}
    ${sx}
`;
const Asterisk = styled.span `
    color: var(--kds-color-secondary-700);
    font-weight: var(--kds-font-weight-bold);
    display: inline-block;
    padding-left: 2px;

    ${(props) => props.$size === 'medium' &&
    css$3 `
            font-size: 14px;
            line-height: 20px;
        `}

    ${(props) => props.$size === 'large' &&
    css$3 `
            font-size: 16px;
            line-height: 24px;
        `}
`;

/**
 * Check if the MONTH value is out of the range of the min and max value
 * @param value - The value to check
 * @param minValue - The minimum value
 * @param maxValue - The maximum value
 * @returns true if the value is out of range, otherwise false
 */
const isValueOutOfRange = (value, minValue, maxValue) => {
    if (!value) {
        return false;
    }
    // Convert RADateValueType to JavaScript Date
    const valueDate = new Date(value.year, value.month - 1, 1);
    // transform min value to always be the first day of the month
    const minValueDate = minValue ? new Date(minValue.getFullYear(), minValue.getMonth(), 1) : null;
    // transform max value to always be the last day of the month
    const maxValueDate = maxValue ? new Date(maxValue.getFullYear(), maxValue.getMonth() + 1, 0) : null;
    // check if the value is less than the min value
    if (minValueDate && valueDate < minValueDate) {
        return true;
    }
    // check if the value is greater than the max value
    if (maxValueDate && valueDate > maxValueDate) {
        return true;
    }
    return false;
};

const isThisMonth = (date) => {
    const now = new Date();
    return date.year === (now === null || now === void 0 ? void 0 : now.getFullYear()) && (date === null || date === void 0 ? void 0 : date.month) === (now === null || now === void 0 ? void 0 : now.getMonth()) + 1;
};
function MonthPickerCalendarCell({ focusedYear, maxValue, minValue, monthDate, monthName, onChange, value, }) {
    const isMonthSelected = (value === null || value === void 0 ? void 0 : value.month) === monthDate.month;
    const isCellCurrentMonth = isThisMonth(monthDate);
    const isInThisYear = focusedYear === monthDate.year;
    const isSelectedMonthInThisYear = (value === null || value === void 0 ? void 0 : value.year) === focusedYear;
    const isItemOutOfRange = isValueOutOfRange(monthDate, minValue, maxValue);
    const handleSelectMonth = () => {
        onChange(monthDate);
    };
    return (jsxRuntimeExports.jsx(StyledMonthPickerCalendarCell, { id: `${monthName}-${focusedYear}`, isDisabled: isItemOutOfRange, isInThisMonth: isInThisYear && isCellCurrentMonth, isSelected: isInThisYear && isSelectedMonthInThisYear && isMonthSelected, onPress: handleSelectMonth, children: jsxRuntimeExports.jsx(StyledMonthLabel, { children: monthName }) }));
}
const StyledMonthPickerCalendarCell = styled(Button$1) `
    width: 44px;
    height: 44px;
    line-height: 20px;
    box-sizing: border-box;
    position: relative;
    text-align: center;
    background-color: ${({ theme }) => theme.colors.transparent};
    border: none;
    outline: none;
    border-radius: ${({ theme }) => theme.radii.full};
    font-size: ${({ theme }) => theme.fontSizes.sm};
    font-weight: ${({ theme }) => theme.fontWeights.normal};
    color: ${({ theme }) => theme.colors.neutral900};

    &::after {
        content: '';
        width: ${({ theme }) => theme.space[1]};
        height: ${({ theme }) => theme.space[1]};
        background-color: transparent;
        position: absolute;
        bottom: ${({ theme }) => theme.space[2]};
        left: 50%;
        margin-left: -2px;
        border-radius: ${({ theme }) => theme.radii.full};
    }

    &[data-hovered] {
        background-color: ${({ isSelected, theme }) => {
    return isSelected ? theme.colors.blue700 : theme.colors.blue100;
}};
    }

    ${({ isSelected }) => isSelected &&
    css$3 `
            color: ${({ theme }) => theme.colors.white};
            background-color: ${({ theme }) => theme.colors.blue700};
            font-weight: ${({ theme }) => theme.fontWeights.medium};
        `}

    ${({ isDisabled, isInThisMonth, isSelected, theme }) => {
    if (!isInThisMonth) {
        return '';
    }
    switch (true) {
        case isDisabled:
            return css$3 `
                    font-weight: ${theme.fontWeights.medium};
                    color: var(--kds-color-foreground-disabled);

                    &::after {
                        background-color: ${theme.colors.neutral300};
                    }
                `;
        case isSelected:
            return css$3 `
                    font-weight: ${theme.fontWeights.medium};
                    color: ${theme.colors.white};

                    &::after {
                        background-color: ${theme.colors.white};
                    }
                `;
        default:
            return css$3 `
                    font-weight: ${theme.fontWeights.medium};
                    color: ${theme.colors.blue700};

                    &::after {
                        background-color: ${theme.colors.blue700};
                    }
                `;
    }
}}

    &[data-focus-visible] {
        outline: none;
        box-shadow: ${({ theme }) => `inset 0 0 0 2px ${theme.colors.blue500}, inset 0 0 0 4px ${theme.colors.white}`};
    }

    &[data-disabled] {
        background-color: ${({ theme }) => theme.colors.transparent};
        color: var(--kds-color-foreground-disabled);
        cursor: default;
    }
`;
const StyledMonthLabel = styled.span `
    position: relative;
`;

/**
 * Generates an array of month objects for a given year.
 * Each month object contains the month name, value, and date.
 *
 * @param {string} locale - The locale used to format the month name.
 * @param {number} [year=new Date().getFullYear()] - The year for which to generate the months array.
 * @returns {Month[]} An array of month objects.
 */
const generateMonthsArray = (locale, year = new Date().getFullYear()) => {
    // Check if the year is valid
    if (year < 1 || year > 9999) {
        throw new Error(`Invalid year: ${year}`);
    }
    // Create an array of 12 elements, each representing a month
    const months = Array.from({ length: 12 }, (_, i) => i);
    // Map each month to an object containing its name, value, and date
    const monthObjects = months.map((monthIndex) => {
        const date = new Date(year, monthIndex, 1);
        const monthName = date.toLocaleString(locale, { month: 'short' });
        const paddedMonth = (monthIndex + 1).toString().padStart(2, '0');
        const parsedDate = parseDate(`${year}-${paddedMonth}-01`);
        return { date: parsedDate, monthName, value: monthIndex + 1 };
    });
    return monthObjects;
};

function MonthPickerCalendarGrid({ focusedYear, maxValue, minValue, onChange, value, }) {
    const { locale } = useLocale();
    const [monthsArray, setMonthsArray] = useState(generateMonthsArray(locale, focusedYear));
    useEffect(() => {
        setMonthsArray(generateMonthsArray(locale, focusedYear));
    }, [value, locale, focusedYear]);
    return (jsxRuntimeExports.jsx(StyledMonthPickerCalendarGrid, { children: monthsArray.map(({ date, monthName }, i) => (jsxRuntimeExports.jsx(MonthPickerCalendarCell, { focusedYear: focusedYear, maxValue: maxValue, minValue: minValue, monthDate: date, monthName: monthName, onChange: onChange, value: value }, i))) }));
}
const StyledMonthPickerCalendarGrid = styled.div `
    display: grid;
    grid-gap: ${({ theme }) => theme.space[2]};
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: repeat(3, 1fr);
    min-width: 200px;
`;

/**
 * Checks if a year is out of range.
 * @param year - The year to check.
 * @param minValue - The minimum allowed date.
 * @param maxValue - The maximum allowed date.
 * @returns True if the year is out of range, false otherwise.
 */
const isYearOutOfRange = (year, minValue, maxValue) => {
    if (!(minValue instanceof Date) || !(maxValue instanceof Date)) {
        return false;
    }
    if (minValue && year < (minValue === null || minValue === void 0 ? void 0 : minValue.getFullYear())) {
        return true;
    }
    if (maxValue && year > (maxValue === null || maxValue === void 0 ? void 0 : maxValue.getFullYear())) {
        return true;
    }
    return false;
};

function MonthPickerCalendar({ maxValue, minValue, onChange, value }) {
    const { locale } = useLocale();
    const calendarState = useCalendarState({
        createCalendar,
        locale,
        value,
    });
    const handleButtonClick = (operation) => {
        switch (operation) {
            case 'prev':
                calendarState.setFocusedDate(calendarState.focusedDate.subtract({ years: 1 }));
                break;
            case 'next':
                calendarState.setFocusedDate(calendarState.focusedDate.add({ years: 1 }));
                break;
        }
    };
    return (jsxRuntimeExports.jsxs(StyledMonthPickerCalendar, { children: [jsxRuntimeExports.jsxs(StyledHeader$3, { children: [jsxRuntimeExports.jsx(StyledHeading, { "$isDisabled": isYearOutOfRange(calendarState.focusedDate.year, minValue, maxValue), children: (calendarState === null || calendarState === void 0 ? void 0 : calendarState.focusedDate.year) || new Date().getFullYear() }), jsxRuntimeExports.jsx(StyledRAButton$1, { onPress: () => handleButtonClick('prev'), children: jsxRuntimeExports.jsx(Icon, { icon: "caret-left", size: 18 }) }), jsxRuntimeExports.jsx(StyledRAButton$1, { "data-slot": "next", onPress: () => handleButtonClick('next'), children: jsxRuntimeExports.jsx(Icon, { icon: "caret-right", size: 18 }) })] }), jsxRuntimeExports.jsx(MonthPickerCalendarGrid, { focusedYear: calendarState.focusedDate.year, maxValue: maxValue, minValue: minValue, onChange: onChange, value: value })] }));
}
const StyledMonthPickerCalendar = styled.div `
    box-shadow: ${({ theme }) => theme.shadows.md};
    background-color: ${({ theme }) => theme.colors.white};
    border-radius: ${({ theme }) => theme.radii.base};
    display: flex;
    padding: ${({ theme }) => `${theme.space[6]} ${theme.space[4]} ${theme.space[4]}`};
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
`;
const StyledHeader$3 = styled(Box) `
    display: flex;
    justify-content: space-between;
    padding: ${({ theme }) => `0 ${theme.space[1]} 0 ${theme.space[2]}`};
    padding: 0;
    width: 100%;
    height: 32px;
    align-items: center;
`;
const StyledHeading = styled.h2 `
    flex: 1;
    font-size: ${({ theme }) => theme.fontSizes.lg};
    line-height: ${({ theme }) => theme.lineHeights.none};
    font-weight: ${({ theme }) => theme.fontWeights.medium};
    color: ${({ $isDisabled, theme }) => ($isDisabled ? theme.colors.neutral300 : theme.colors.neutral900)};
    text-transform: capitalize;
    margin-bottom: 0;
    display: flex;
    align-items: center;
    height: 32px;
    margin-left: 10px;
`;
const StyledRAButton$1 = styled(Button$1) `
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: ${({ theme }) => theme.radii.full};
    border: none;
    transition: all 120ms ease-in 0s;
    height: 32px;
    width: 32px;
    background-color: transparent;
    outline: none;
    color: ${({ theme }) => theme.colors.neutral500};

    &[data-slot='next'] {
        margin-left: ${({ theme }) => `${theme.space[2]}`};
    }

    &[data-hovered] {
        color: ${({ theme }) => theme.colors.neutral800};
        background-color: ${({ theme }) => theme.colors.neutral200};
    }

    &[data-focus-visible] {
        border-color: transparent;
        box-shadow: ${({ theme }) => `${theme.colors.white} 0 0 0 2px, ${theme.colors.blue500} 0 0 0 4px`};
    }
`;

/**
 * Converts a Date object to a React Aria Components CalendarDate Type object.
 * @param date - The Date object to be converted.
 * @returns The converted RADateValueType object.
 */
const convertDatetoRADate = (date) => {
    if (!date || !(date instanceof Date)) {
        return null;
    }
    const year = date.getFullYear();
    const month = date.getMonth() + 1; // JavaScript months are 0-based, so we add 1
    const day = date.getDate();
    return new CalendarDate(year, month, day);
};

function formatValue({ dateFormat, locale, returnEndOfMonth = false, value }) {
    if (!value || typeof value.year !== 'number' || typeof value.month !== 'number') {
        return '';
    }
    let date;
    if (returnEndOfMonth) {
        // Get the last day of the month
        date = new Date(value.year, value.month, 0);
    }
    else {
        date = new Date(value.year, value.month - 1);
    }
    if (dateFormat === 'full') {
        // dd mm yyyy (but with proper locale based formatting)
        return date.toLocaleDateString(locale); // This will use the user's locale by default
    }
    const month = date.toLocaleString(locale, { month: 'short' });
    return `${month} ${value.year}`; // mmm yyyy (either dashes or dots with proper locale based formatting)
}

function MonthPicker({ color = 'primary', dateFormat = 'month-year', disabled = false, error, id, isRequired, maxValue, minValue, onChange, returnEndOfMonth = false, size, value, }) {
    const { locale } = useLocale();
    const { size: formGroupContextSize } = useContext(FormGroupContext);
    const sizeProp = size || formGroupContextSize || 'large';
    const [hasError, setHasError] = useState(false);
    const datePickerState = useDatePickerState({
        isRequired: true,
        value: convertDatetoRADate(value),
    });
    const handleChange = (val) => {
        datePickerState.setValue(val);
        // validate
        setHasError(isInvalid(val)); // with new value
        // Get the first or last day of the month based on returnEndOfMonth
        const day = returnEndOfMonth
            ? new Date(val.year, val.month, 0).getDate() // last day of the month
            : new Date(val.year, val.month - 1, 1).getDate(); // first day of the month
        // Convert RADateValueType to JavaScript Date
        const date = new Date(val.year, val.month - 1, day);
        // callback the date to the parent component
        onChange === null || onChange === void 0 ? void 0 : onChange(date);
    };
    /**
     * Validation logic for the date picker
     * @param value - The value to validate
     * @returns true if the value is invalid, otherwise false
     */
    const isInvalid = useCallback((dateValue) => {
        switch (true) {
            // Case: Value is required but not provided
            case isRequired && !dateValue:
                return true;
            // Case: Value is not provided and the date picker state is invalid
            case !value && datePickerState.isInvalid:
                return true;
            // Case: Value is provided and it is out of the specified range
            case value && isValueOutOfRange(dateValue, minValue, maxValue):
                datePickerState.setValue(null);
                return true;
            // Add more validation logic here if needed
            default:
                return false;
        }
    }, [isRequired, datePickerState, minValue, maxValue]);
    /**
     * This effect runs whenever the `value` prop changes. It updates the
     * `datePickerState` with the new value, ensuring that the `MonthPicker`
     * component re-renders with the updated value.
     *
     * @effect
     */
    useEffect(() => {
        datePickerState.setValue(convertDatetoRADate(value) || null);
    }, [value, datePickerState]);
    useEffect(() => {
        // Set the initial error state on render if the value is provided
        if (value) {
            setHasError(isInvalid(datePickerState.value));
        }
    }, [datePickerState.value, value, isInvalid]);
    const handleReset = () => {
        if (isRequired) {
            return;
        }
        datePickerState.setValue(null);
        onChange === null || onChange === void 0 ? void 0 : onChange(null);
    };
    return (jsxRuntimeExports.jsx(StyledMonthPicker, { children: jsxRuntimeExports.jsxs(DialogTrigger, { children: [jsxRuntimeExports.jsxs(StyledButtonWrapper, { "$sizeProp": sizeProp, children: [jsxRuntimeExports.jsxs(StyledRAButton, { "$hasError": hasError || !!error, "$sizeProp": sizeProp, id: id, isDisabled: disabled, children: [formatValue({ dateFormat, locale, returnEndOfMonth, value: datePickerState.value }), jsxRuntimeExports.jsx(StyledCalenderIcon, { "$sizeProp": sizeProp, color: disabled ? 'disabled' : color, icon: "calender" })] }), !isRequired && !disabled && value && (jsxRuntimeExports.jsx(StyledIconButton$1, { "$sizeProp": sizeProp, disabled: disabled, icon: "close", isDisabled: disabled, onClick: handleReset, size: "small", variant: "ghost" }))] }), error && jsxRuntimeExports.jsx(FormErrorMessage, { children: error }), jsxRuntimeExports.jsx(StyledRAPopover, { placement: "bottom left", children: jsxRuntimeExports.jsx(StyledRADialog, { children: ({ close }) => (jsxRuntimeExports.jsx(MonthPickerCalendar, { maxValue: maxValue, minValue: minValue, onChange: (newValue) => {
                                handleChange(newValue);
                                close();
                            }, value: datePickerState.value })) }) })] }) }));
}
const StyledMonthPicker = styled.div `
    display: inline-block;
`;
const StyledButtonWrapper = styled.div `
    position: relative;
    width: ${({ $sizeProp, theme }) => theme.monthPicker[$sizeProp].width};
`;
const StyledRAButton = styled(Button$1) `
    font-size: ${({ $sizeProp, theme }) => theme.monthPicker[$sizeProp].fontSize};
    height: ${({ $sizeProp, theme }) => theme.monthPicker[$sizeProp].height};
    line-height: ${({ $sizeProp, theme }) => theme.monthPicker[$sizeProp].lineHeight};
    width: ${({ $sizeProp, theme }) => theme.monthPicker[$sizeProp].width};
    font-weight: var(--kds-font-weight-input);
    border-radius: ${({ theme }) => theme.radii.base};
    color: var(--kds-color-foreground-default);
    position: relative;
    min-width: 0;
    box-shadow: none;
    padding: 6px 0;
    appearance: none;
    padding-right: ${({ $sizeProp, theme }) => theme.monthPicker[$sizeProp].paddingRight};
    padding-left: ${({ $sizeProp, theme }) => theme.monthPicker[$sizeProp].paddingLeft};
    border: 1px solid var(--kds-color-border-medium);
    background-color: white;
    text-align: left;
    transition: all 0.2s;
    outline: none;

    &[data-hovered] {
        border-color: var(--kds-color-border-strong);
    }

    &[data-focus-visible] {
        border-color: var(--kds-color-border-focused);
        box-shadow: 0 0 0 4px var(--kds-color-shadow-focused);
    }

    ${(props) => props.$hasError &&
    css$3 `
            border-color: var(--kds-color-border-warning);

            &[data-hovered] {
                border-color: var(--kds-color-border-warning);
            }

            &[data-focus-visible] {
                border-color: var(--kds-color-border-warning);
                box-shadow: 0 0 0 4px var(--kds-color-shadow-warning);
            }
        `}

    &[data-disabled] {
        color: var(--kds-color-foreground-disabled);
        background-color: var(--kds-color-background-disabled);
        border-color: var(--kds-color-border-disabled);
        pointer-events: none;
        user-select: none;
    }
`;
const StyledCalenderIcon = styled(Icon) `
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    top: ${({ $sizeProp, theme }) => theme.monthPicker[$sizeProp].iconPositionTop};
    bottom: ${({ $sizeProp, theme }) => theme.monthPicker[$sizeProp].iconPositionBottom};
    right: ${({ $sizeProp, theme }) => theme.monthPicker[$sizeProp].iconPositionRight};
`;
const StyledIconButton$1 = styled(IconButton) `
    position: absolute;
    top: ${({ $sizeProp, theme }) => theme.monthPicker[$sizeProp].iconButtonPositionTop};
    bottom: ${({ $sizeProp, theme }) => theme.monthPicker[$sizeProp].iconButtonPositionBottom};
    right: ${({ $sizeProp, theme }) => theme.monthPicker[$sizeProp].iconButtonPositionRight};
    z-index: 1;
`;
const StyledRAPopover = styled(Popover$1) `
    &[data-placement='top'] {
        --origin: translateY(8px);
    }

    &[data-placement='bottom'] {
        --origin: translateY(-8px);
    }

    &[data-entering] {
        animation: slide 200ms;
    }

    &[data-exiting] {
        animation: slide 200ms reverse ease-in;
    }

    @keyframes slide {
        from {
            transform: var(--origin);
            opacity: 0;
        }

        to {
            transform: translateY(0);
            opacity: 1;
        }
    }
`;
const StyledRADialog = styled(Dialog) `
    outline: none;
`;

function NumberInput(_a) {
    var { error, formatOptions, isCurrency = false, label, maximumFractionDigits = 0, name, onBlur, onChange, size, submitOnEnter, sx: sxProp, useGrouping = false, value } = _a, props = __rest(_a, ["error", "formatOptions", "isCurrency", "label", "maximumFractionDigits", "name", "onBlur", "onChange", "size", "submitOnEnter", "sx", "useGrouping", "value"]);
    const { size: formGroupContextSize } = useContext(FormGroupContext);
    const sizeProp = size || formGroupContextSize || 'large';
    function handleChange(newValue) {
        if (onChange) {
            if (typeof newValue === 'number') {
                onChange(newValue);
            }
            if (newValue === undefined || isNaN(newValue)) {
                onChange(null);
            }
        }
    }
    return (jsxRuntimeExports.jsxs(StyledNumberInput, { "$error": error, "$size": sizeProp, sx: sxProp, children: [jsxRuntimeExports.jsx(NumberField, Object.assign({ "aria-label": label, formatOptions: Object.assign({ currency: isCurrency ? 'EUR' : undefined, maximumFractionDigits, style: isCurrency ? 'currency' : 'decimal', useGrouping }, formatOptions), onChange: handleChange, onKeyDown: (event) => {
                    if (event.key === 'Enter' && !submitOnEnter) {
                        event.preventDefault();
                    }
                }, value: typeof value === 'number' && !isNaN(value) ? value : NaN }, props, { children: jsxRuntimeExports.jsx(Input$2, { name: name, onBlur: onBlur }) })), error && jsxRuntimeExports.jsx(FormErrorMessage, { children: error })] }));
}
const StyledNumberInput = styled.div `
    .react-aria-Input {
        color: var(--kds-color-foreground-default);
        font-size: var(--kds-font-size-input-large);
        font-weight: var(--kds-font-weight-input);
        line-height: var(--kds-line-height-input-large);
        width: 100%;
        min-width: 0;
        box-shadow: none;
        padding: 7px 12px;
        appearance: none;
        transition: all 0.2s;
        border: 1px solid var(--kds-color-border-medium);
        background-color: white;
        border-radius: var(--kds-border-radius-base);

        &:hover {
            border-color: var(--kds-color-border-strong);
        }

        &:focus {
            outline: none;
            background-color: var(--kds-color-background-default);
            border-color: var(--kds-color-border-focused);
            box-shadow: 0 0 0 4px var(--kds-color-shadow-focused);
        }

        &::placeholder {
            font-weight: var(--kds-font-weight-placeholder);
            color: var(--kds-color-foreground-minimal);
        }

        ${(props) => props.$size === 'medium' &&
    css$3 `
                ${props.theme.mediaQueries.small} {
                    padding: 8px 12px;
                    font-size: var(--kds-font-size-input-medium);
                    line-height: var(--kds-line-height-input-medium);
                }
            `};

        ${(props) => props.$error &&
    css$3 `
                border-color: var(--kds-color-border-warning);

                &:hover {
                    border-color: var(--kds-color-border-warning);
                }

                &:focus {
                    border-color: var(--kds-color-border-warning);
                    box-shadow: 0 0 0 4px var(--kds-color-shadow-warning);
                }

                &::placeholder {
                    color: var(--kds-color-foreground-warning);
                }
            `}

        &:disabled {
            color: var(--kds-color-foreground-disabled);
            background-color: var(--kds-color-background-disabled);
            border-color: var(--kds-color-border-disabled);
            pointer-events: none;

            &::placeholder {
                color: var(--kds-color-foreground-disabled);
            }
        }
    }
    ${sx}
`;

const strengthStyles = [
    {
        backgroundColor: tokens.kdsColorNeutral300,
        color: tokens.kdsColorNeutral500,
        text: 'Geen',
    },
    {
        backgroundColor: tokens.kdsColorRed500,
        color: tokens.kdsColorRed600,
        text: 'Erg Zwak',
    },
    {
        backgroundColor: tokens.kdsColorOrange500,
        color: tokens.kdsColorOrange700,
        text: 'Zwak',
    },
    {
        backgroundColor: tokens.kdsColorYellow400,
        color: tokens.kdsColorYellow700,
        text: 'Niet voldoende',
    },
    {
        backgroundColor: tokens.kdsColorLime500,
        color: tokens.kdsColorLime700,
        text: 'Sterk',
    },
    {
        backgroundColor: tokens.kdsColorGreen600,
        color: tokens.kdsColorGreen700,
        text: 'Erg sterk',
    },
];
function PasswordInput(_a) {
    var { capsLockText, disabled, error, name, onBlur, onChange, onEnterKeyPress, placeholder, strength, value } = _a, props = __rest(_a, ["capsLockText", "disabled", "error", "name", "onBlur", "onChange", "onEnterKeyPress", "placeholder", "strength", "value"]);
    const [shouldRevealPassword, setShouldRevealPassword] = useState(false);
    const [isCapsLockEnabled, setIsCapsLockEnabled] = useState(false);
    const keypressListener = (event) => {
        setIsCapsLockEnabled(event.getModifierState && event.getModifierState('CapsLock'));
    };
    useEffect(() => {
        document.addEventListener('keyup', keypressListener);
        document.addEventListener('keydown', keypressListener);
        return () => {
            document.removeEventListener('keyup', keypressListener);
            document.removeEventListener('keydown', keypressListener);
        };
    });
    const passwordInputSuffix = {
        icon: shouldRevealPassword ? 'visible' : 'invisible',
        labelText: 'Show password',
        onSuffixClick: () => setShouldRevealPassword(!shouldRevealPassword),
    };
    return (jsxRuntimeExports.jsxs(StyledPasswordInputContainer, { error: error, children: [jsxRuntimeExports.jsx(TextInput, Object.assign({ disabled: disabled, error: error, name: name, onBlur: onBlur, onChange: onChange, onKeyPress: (event) => {
                    if (event.key === 'Enter' && onEnterKeyPress) {
                        event.preventDefault();
                        onEnterKeyPress();
                    }
                }, placeholder: placeholder, suffix: passwordInputSuffix, type: shouldRevealPassword ? 'text' : 'password', value: value }, props)), strength !== undefined && (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsxs(StyledPasswordStrengthMeter, { children: [jsxRuntimeExports.jsx(StyledIndicator, { "$isActive": strength > 0, "$strength": strength }), jsxRuntimeExports.jsx(StyledIndicator, { "$isActive": strength > 1, "$strength": strength }), jsxRuntimeExports.jsx(StyledIndicator, { "$isActive": strength > 2, "$strength": strength }), jsxRuntimeExports.jsx(StyledIndicator, { "$isActive": strength > 3, "$strength": strength }), jsxRuntimeExports.jsx(StyledIndicator, { "$isActive": strength > 4, "$strength": strength })] }), jsxRuntimeExports.jsxs(StyledText, { children: ["Watchwoordsterkte:", ' ', jsxRuntimeExports.jsx(StyledTextStrength, { "$strength": strength, children: strengthStyles[strength].text })] })] })), isCapsLockEnabled && capsLockText && jsxRuntimeExports.jsx(FormErrorMessage, { children: capsLockText })] }));
}
const StyledPasswordInputContainer = styled.div `
    position: relative;
`;
const StyledPasswordStrengthMeter = styled.div `
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
`;
const StyledIndicator = styled.div `
    display: flex;
    height: 5px;
    margin: 8px 0;
    background-color: ${tokens.kdsColorNeutral300};
    background-color: ${(props) => props.$strength !== undefined && props.$isActive && strengthStyles[props.$strength].backgroundColor};
    border-radius: ${tokens.kdsBorderRadiusSmall};
    width: 20%;

    &:not(:first-child) {
        margin-left: 4px;
    }

    &:not(:last-child) {
        margin-right: 4px;
    }
`;
const StyledText = styled.p `
    font-size: 14px;
    line-height: 21px;
    color: var(--kds-color-foreground-minimal);
    font-weight: 400;
    margin-top: 8px;
    margin-bottom: 4px;
`;
const StyledTextStrength = styled.span `
    color: ${(props) => props.$strength !== undefined && strengthStyles[props.$strength].color};
    font-weight: 700;
`;

const sizeStyles = {
    large: {
        control: {
            fontSize: tokens.kdsFontSizeInputLarge,
            minHeight: tokens.kdsSizeInputHeightLarge,
        },
        option: {
            fontSize: tokens.kdsFontSizeInputLarge,
            lineHeight: tokens.kdsLineHeightInputLarge,
            padding: '8px 12px',
            paddingGrouped: '8px 12px 8px 24px',
        },
    },
    medium: {
        control: {
            fontSize: tokens.kdsFontSizeInputMedium,
            minHeight: tokens.kdsSizeInputHeightMedium,
        },
        option: {
            fontSize: tokens.kdsFontSizeInputMedium,
            lineHeight: tokens.kdsLineHeightInputMedium,
            padding: '9px 12px',
            paddingGrouped: '9px 12px 9px 24px',
        },
    },
};
function customStyles(size, error, showClearIndicator) {
    return {
        clearIndicator: (provided) => (Object.assign(Object.assign({}, provided), { display: 'none' })),
        control: (provided, state) => (Object.assign(Object.assign({}, provided), { '@media (min-width: 576px)': {
                fontSize: sizeStyles[size].control.fontSize,
                minHeight: sizeStyles[size].control.minHeight,
            }, '&:hover': {
                borderColor: state.isDisabled
                    ? tokens.kdsColorBorderDisabled
                    : error
                        ? tokens.kdsColorBorderWarning
                        : state.isFocused
                            ? tokens.kdsColorBorderFocused
                            : tokens.kdsColorBorderStrong,
                cursor: 'pointer',
            }, backgroundColor: state.isDisabled ? tokens.kdsColorBackgroundDisabled : tokens.kdsColorBackgroundDefault, borderColor: state.isDisabled
                ? tokens.kdsColorBorderDisabled
                : error
                    ? tokens.kdsColorBorderWarning
                    : state.isFocused
                        ? tokens.kdsColorBorderFocused
                        : tokens.kdsColorBorderMedium, boxShadow: state.isFocused && error
                ? `0 0 0 4px ${tokens.kdsColorShadowWarning}`
                : state.isFocused
                    ? `0 0 0 4px ${tokens.kdsColorShadowFocused}`
                    : 'none', fontSize: sizeStyles.large.control.fontSize, fontWeight: tokens.kdsFontWeightInput, minHeight: sizeStyles.large.control.minHeight })),
        dropdownIndicator: (provided, state) => (Object.assign(Object.assign({}, provided), { '&:hover': {
                color: state.isDisabled ? tokens.kdsColorBorderDisabled : tokens.kdsColorBorderStrong,
            }, color: state.isDisabled ? tokens.kdsColorBorderDisabled : tokens.kdsColorBorderMedium })),
        indicatorSeparator: (provided, state) => (Object.assign(Object.assign({}, provided), { color: tokens.kdsColorBorderMedium, width: (state.selectProps.isClearable && state.selectProps.value) || state.selectProps.isLoading ? '1px' : 0 })),
        menuList: (provided) => (Object.assign(Object.assign({}, provided), { padding: '8px' })),
        option: (provided, state) => (Object.assign(Object.assign({}, provided), { '@media (min-width: 576px)': {
                fontSize: sizeStyles[size].option.fontSize,
                lineHeight: sizeStyles[size].option.lineHeight,
                padding: sizeStyles[size].option.padding,
            }, '&:active': {
                backgroundColor: !state.isDisabled
                    ? state.isSelected
                        ? tokens.kdsColorPrimary100
                        : tokens.kdsColorPrimary100
                    : undefined,
            }, '&:hover': {
                cursor: state.isDisabled ? 'default' : 'pointer',
            }, backgroundColor: state.isSelected
                ? state.isFocused
                    ? tokens.kdsColorPrimary50
                    : tokens.kdsColorTransparent
                : state.isFocused
                    ? tokens.kdsColorPrimary50
                    : tokens.kdsColorTransparent, borderRadius: '4px', color: state.isDisabled
                ? tokens.kdsColorForegroundDisabled
                : state.isSelected
                    ? tokens.kdsColorForegroundSelected
                    : tokens.kdsColorForegroundDefault, fontSize: sizeStyles.large.option.fontSize, fontWeight: state.isSelected ? tokens.kdsFontWeightMedium : tokens.kdsFontWeightNormal, lineHeight: sizeStyles.large.option.lineHeight, padding: sizeStyles.large.option.padding })),
        placeholder: (provided, state) => (Object.assign(Object.assign({}, provided), { color: state.isDisabled
                ? tokens.kdsColorForegroundDisabled
                : error
                    ? tokens.kdsColorForegroundWarning
                    : tokens.kdsColorForegroundMinimal, fontWeight: tokens.kdsFontWeightPlaceholder })),
        singleValue: (provided) => (Object.assign(Object.assign({}, provided), { fontWeight: tokens.kdsFontWeightInput })),
        valueContainer: (provided, state) => (Object.assign(Object.assign({}, provided), { color: state.isDisabled ? tokens.kdsColorForegroundDisabled : tokens.kdsColorForegroundDefault })),
    };
}

function SelectOption(_a) {
    var { isDisabled, isSelected, label } = _a, props = __rest(_a, ["isDisabled", "isSelected", "label"]);
    const isGroupOption = Object.prototype.hasOwnProperty.call(props.data, 'isGroupOption') &&
        props.data.isGroupOption;
    const isGroupHeader = Object.prototype.hasOwnProperty.call(props.data, 'isGroupHeader') &&
        props.data.isGroupHeader;
    return (jsxRuntimeExports.jsx("div", { children: jsxRuntimeExports.jsx(components$2.Option, Object.assign({ isDisabled: isDisabled, isSelected: isSelected, label: label }, props, { children: jsxRuntimeExports.jsxs(Box, { alignItems: "center", display: "flex", justifyContent: "space-between", pl: isGroupOption ? 6 : 0, children: [jsxRuntimeExports.jsx(Box, { as: "label", fontWeight: isGroupHeader ? 'medium' : undefined, m: 0, sx: {
                            '&:hover': {
                                cursor: isDisabled ? 'default' : 'pointer',
                            },
                        }, children: label }), isSelected && (jsxRuntimeExports.jsx(Icon, { color: "primary", icon: "closed", sx: { flexShrink: 0 } }))] }) })) }));
}

function Select$1(_a) {
    var _b;
    var { dropdownOffset = 0, error, id, name, onBlur, size } = _a, props = __rest(_a, ["dropdownOffset", "error", "id", "name", "onBlur", "size"]);
    const selectRef = useRef(null);
    const { size: formGroupContextSize } = useContext(FormGroupContext);
    const { convertToInputFocusEvent } = useEvent();
    const sizeProp = (_b = size !== null && size !== void 0 ? size : formGroupContextSize) !== null && _b !== void 0 ? _b : 'large';
    const handleBlur = (event) => {
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(convertToInputFocusEvent(event, name));
    };
    const [menuPlacement, setMenuPlacement] = useState('auto');
    useEffect(() => {
        /**
         * The handleScroll function adjusts the placement of the menu drop based on the scroll position.
         * If the position of the select element's bottom is less than the height of the document minus a certain offset,
         * the menu drop is placed at the 'bottom'.
         * Otherwise, the menu drop is set to appear upwards, with the placement set to 'top'.
         */
        const handleScroll = () => {
            var _a;
            const selectRect = (_a = selectRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
            if (!selectRect) {
                return; // Handle case where ref hasn't been assigned yet
            }
            const body = document.body;
            const html = document.documentElement;
            // Math.max is used to ensure we get the highest value considering all these scenarios:
            const documentHeight = Math.max(body.scrollHeight, // Height of the body's content, including content not visible on the screen due to overflow
            body.offsetHeight, // Height of the body, including padding and borders, but not the margin
            html.clientHeight, // Height of the html content visible on the screen, including padding but not borders or scrollbars
            html.scrollHeight, // Height of the html's content, including content not visible on the screen due to overflow
            html.offsetHeight // Height of the html, including padding and borders, but not the margin
            );
            // Calculating the heignt of the expanded select options including the padding and margin
            const heightExpandedSelectOptions = props.options ? props.options.length * 40 + 16 + 8 : 0;
            // Calculating the position of the bottom of the select element relative to the document, considering the scroll position
            const positionOfSelectBottom = selectRect.bottom + window.scrollY + heightExpandedSelectOptions;
            const menuPlacementToUse = positionOfSelectBottom < documentHeight - dropdownOffset ? 'bottom' : 'top';
            setMenuPlacement(menuPlacementToUse);
        };
        const handleResize = () => {
            handleScroll();
        };
        window.addEventListener('scroll', handleScroll);
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('resize', handleResize);
        };
    }, [props.options]);
    return (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx(SelectContainer$1, { ref: selectRef, sx: sx, children: jsxRuntimeExports.jsx(ReactSelect, Object.assign({ components: { Option: SelectOption }, inputId: id, menuPlacement: menuPlacement, noOptionsMessage: ({ inputValue }) => (!inputValue ? inputValue : 'Geen opties'), onBlur: handleBlur, placeholder: "Selecteer...", styles: customStyles(sizeProp, error) }, props)) }), error && jsxRuntimeExports.jsx(FormErrorMessage, { children: error })] }));
}
const SelectContainer$1 = styled.div `
    width: 100%;

    ${sx}
`;

function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}

function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}

function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}

function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}

function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}

function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}

function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}

function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}

function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}

function _createSuper(t) {
  var r = _isNativeReflectConstruct();
  return function () {
    var e,
      o = _getPrototypeOf(t);
    if (r) {
      var s = _getPrototypeOf(this).constructor;
      e = Reflect.construct(o, arguments, s);
    } else e = o.apply(this, arguments);
    return _possibleConstructorReturn(this, e);
  };
}

function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}

function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}

function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}

function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}

function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}

function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}

function _taggedTemplateLiteral(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}

/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */

const min = Math.min;
const max = Math.max;
const round = Math.round;
const floor = Math.floor;
const createCoords = v => ({
  x: v,
  y: v
});
function rectToClientRect(rect) {
  const {
    x,
    y,
    width,
    height
  } = rect;
  return {
    width,
    height,
    top: y,
    left: x,
    right: x + width,
    bottom: y + height,
    x,
    y
  };
}

function hasWindow() {
  return typeof window !== 'undefined';
}
function getNodeName(node) {
  if (isNode(node)) {
    return (node.nodeName || '').toLowerCase();
  }
  // Mocked nodes in testing environments may not be instances of Node. By
  // returning `#document` an infinite loop won't occur.
  // https://github.com/floating-ui/floating-ui/issues/2317
  return '#document';
}
function getWindow(node) {
  var _node$ownerDocument;
  return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node) {
  var _ref;
  return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Node || value instanceof getWindow(value).Node;
}
function isElement(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Element || value instanceof getWindow(value).Element;
}
function isHTMLElement(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
}
function isShadowRoot(value) {
  if (!hasWindow() || typeof ShadowRoot === 'undefined') {
    return false;
  }
  return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
}
function isOverflowElement(element) {
  const {
    overflow,
    overflowX,
    overflowY,
    display
  } = getComputedStyle$1(element);
  return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !['inline', 'contents'].includes(display);
}
function isWebKit() {
  if (typeof CSS === 'undefined' || !CSS.supports) return false;
  return CSS.supports('-webkit-backdrop-filter', 'none');
}
function isLastTraversableNode(node) {
  return ['html', 'body', '#document'].includes(getNodeName(node));
}
function getComputedStyle$1(element) {
  return getWindow(element).getComputedStyle(element);
}
function getParentNode(node) {
  if (getNodeName(node) === 'html') {
    return node;
  }
  const result =
  // Step into the shadow DOM of the parent of a slotted node.
  node.assignedSlot ||
  // DOM Element detected.
  node.parentNode ||
  // ShadowRoot detected.
  isShadowRoot(node) && node.host ||
  // Fallback.
  getDocumentElement(node);
  return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
  const parentNode = getParentNode(node);
  if (isLastTraversableNode(parentNode)) {
    return node.ownerDocument ? node.ownerDocument.body : node.body;
  }
  if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) {
    return parentNode;
  }
  return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list, traverseIframes) {
  var _node$ownerDocument2;
  if (list === void 0) {
    list = [];
  }
  if (traverseIframes === void 0) {
    traverseIframes = true;
  }
  const scrollableAncestor = getNearestOverflowAncestor(node);
  const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
  const win = getWindow(scrollableAncestor);
  if (isBody) {
    const frameElement = getFrameElement(win);
    return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? getOverflowAncestors(frameElement) : []);
  }
  return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}
function getFrameElement(win) {
  return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

function getCssDimensions(element) {
  const css = getComputedStyle$1(element);
  // In testing environments, the `width` and `height` properties are empty
  // strings for SVG elements, returning NaN. Fallback to `0` in this case.
  let width = parseFloat(css.width) || 0;
  let height = parseFloat(css.height) || 0;
  const hasOffset = isHTMLElement(element);
  const offsetWidth = hasOffset ? element.offsetWidth : width;
  const offsetHeight = hasOffset ? element.offsetHeight : height;
  const shouldFallback = round(width) !== offsetWidth || round(height) !== offsetHeight;
  if (shouldFallback) {
    width = offsetWidth;
    height = offsetHeight;
  }
  return {
    width,
    height,
    $: shouldFallback
  };
}

function unwrapElement(element) {
  return !isElement(element) ? element.contextElement : element;
}

function getScale(element) {
  const domElement = unwrapElement(element);
  if (!isHTMLElement(domElement)) {
    return createCoords(1);
  }
  const rect = domElement.getBoundingClientRect();
  const {
    width,
    height,
    $
  } = getCssDimensions(domElement);
  let x = ($ ? round(rect.width) : rect.width) / width;
  let y = ($ ? round(rect.height) : rect.height) / height;

  // 0, NaN, or Infinity should always fallback to 1.

  if (!x || !Number.isFinite(x)) {
    x = 1;
  }
  if (!y || !Number.isFinite(y)) {
    y = 1;
  }
  return {
    x,
    y
  };
}

const noOffsets = /*#__PURE__*/createCoords(0);
function getVisualOffsets(element) {
  const win = getWindow(element);
  if (!isWebKit() || !win.visualViewport) {
    return noOffsets;
  }
  return {
    x: win.visualViewport.offsetLeft,
    y: win.visualViewport.offsetTop
  };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
  {
    return false;
  }
}

function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  const clientRect = element.getBoundingClientRect();
  const domElement = unwrapElement(element);
  let scale = createCoords(1);
  if (includeScale) {
    {
      scale = getScale(element);
    }
  }
  const visualOffsets = shouldAddVisualOffsets() ? getVisualOffsets(domElement) : createCoords(0);
  let x = (clientRect.left + visualOffsets.x) / scale.x;
  let y = (clientRect.top + visualOffsets.y) / scale.y;
  let width = clientRect.width / scale.x;
  let height = clientRect.height / scale.y;
  if (domElement) {
    const win = getWindow(domElement);
    const offsetWin = offsetParent;
    let currentWin = win;
    let currentIFrame = getFrameElement(currentWin);
    while (currentIFrame && offsetParent && offsetWin !== currentWin) {
      const iframeScale = getScale(currentIFrame);
      const iframeRect = currentIFrame.getBoundingClientRect();
      const css = getComputedStyle$1(currentIFrame);
      const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
      const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
      x *= iframeScale.x;
      y *= iframeScale.y;
      width *= iframeScale.x;
      height *= iframeScale.y;
      x += left;
      y += top;
      currentWin = getWindow(currentIFrame);
      currentIFrame = getFrameElement(currentWin);
    }
  }
  return rectToClientRect({
    width,
    height,
    x,
    y
  });
}

function rectsAreEqual(a, b) {
  return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}

// https://samthor.au/2021/observing-dom/
function observeMove(element, onMove) {
  let io = null;
  let timeoutId;
  const root = getDocumentElement(element);
  function cleanup() {
    var _io;
    clearTimeout(timeoutId);
    (_io = io) == null || _io.disconnect();
    io = null;
  }
  function refresh(skip, threshold) {
    if (skip === void 0) {
      skip = false;
    }
    if (threshold === void 0) {
      threshold = 1;
    }
    cleanup();
    const elementRectForRootMargin = element.getBoundingClientRect();
    const {
      left,
      top,
      width,
      height
    } = elementRectForRootMargin;
    if (!skip) {
      onMove();
    }
    if (!width || !height) {
      return;
    }
    const insetTop = floor(top);
    const insetRight = floor(root.clientWidth - (left + width));
    const insetBottom = floor(root.clientHeight - (top + height));
    const insetLeft = floor(left);
    const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
    const options = {
      rootMargin,
      threshold: max(0, min(1, threshold)) || 1
    };
    let isFirstUpdate = true;
    function handleObserve(entries) {
      const ratio = entries[0].intersectionRatio;
      if (ratio !== threshold) {
        if (!isFirstUpdate) {
          return refresh();
        }
        if (!ratio) {
          // If the reference is clipped, the ratio is 0. Throttle the refresh
          // to prevent an infinite loop of updates.
          timeoutId = setTimeout(() => {
            refresh(false, 1e-7);
          }, 1000);
        } else {
          refresh(false, ratio);
        }
      }
      if (ratio === 1 && !rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) {
        // It's possible that even though the ratio is reported as 1, the
        // element is not actually fully within the IntersectionObserver's root
        // area anymore. This can happen under performance constraints. This may
        // be a bug in the browser's IntersectionObserver implementation. To
        // work around this, we compare the element's bounding rect now with
        // what it was at the time we created the IntersectionObserver. If they
        // are not equal then the element moved, so we refresh.
        refresh();
      }
      isFirstUpdate = false;
    }

    // Older browsers don't support a `document` as the root and will throw an
    // error.
    try {
      io = new IntersectionObserver(handleObserve, {
        ...options,
        // Handle <iframe>s
        root: root.ownerDocument
      });
    } catch (e) {
      io = new IntersectionObserver(handleObserve, options);
    }
    io.observe(element);
  }
  refresh(true);
  return cleanup;
}

/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */
function autoUpdate(reference, floating, update, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    ancestorScroll = true,
    ancestorResize = true,
    elementResize = typeof ResizeObserver === 'function',
    layoutShift = typeof IntersectionObserver === 'function',
    animationFrame = false
  } = options;
  const referenceEl = unwrapElement(reference);
  const ancestors = ancestorScroll || ancestorResize ? [...(referenceEl ? getOverflowAncestors(referenceEl) : []), ...getOverflowAncestors(floating)] : [];
  ancestors.forEach(ancestor => {
    ancestorScroll && ancestor.addEventListener('scroll', update, {
      passive: true
    });
    ancestorResize && ancestor.addEventListener('resize', update);
  });
  const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
  let reobserveFrame = -1;
  let resizeObserver = null;
  if (elementResize) {
    resizeObserver = new ResizeObserver(_ref => {
      let [firstEntry] = _ref;
      if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
        // Prevent update loops when using the `size` middleware.
        // https://github.com/floating-ui/floating-ui/issues/1740
        resizeObserver.unobserve(floating);
        cancelAnimationFrame(reobserveFrame);
        reobserveFrame = requestAnimationFrame(() => {
          var _resizeObserver;
          (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
        });
      }
      update();
    });
    if (referenceEl && !animationFrame) {
      resizeObserver.observe(referenceEl);
    }
    resizeObserver.observe(floating);
  }
  let frameId;
  let prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
  if (animationFrame) {
    frameLoop();
  }
  function frameLoop() {
    const nextRefRect = getBoundingClientRect(reference);
    if (prevRefRect && !rectsAreEqual(prevRefRect, nextRefRect)) {
      update();
    }
    prevRefRect = nextRefRect;
    frameId = requestAnimationFrame(frameLoop);
  }
  update();
  return () => {
    var _resizeObserver2;
    ancestors.forEach(ancestor => {
      ancestorScroll && ancestor.removeEventListener('scroll', update);
      ancestorResize && ancestor.removeEventListener('resize', update);
    });
    cleanupIo == null || cleanupIo();
    (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
    resizeObserver = null;
    if (animationFrame) {
      cancelAnimationFrame(frameId);
    }
  };
}

var isClient = typeof document !== 'undefined';

var index = isClient ? useLayoutEffect : useEffect;

var _excluded$4 = ["className", "clearValue", "cx", "getStyles", "getClassNames", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue", "theme"];
// ==============================
// NO OP
// ==============================

var noop = function noop() {};

// ==============================
// Class Name Prefixer
// ==============================

/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/
function applyPrefixToName(prefix, name) {
  if (!name) {
    return prefix;
  } else if (name[0] === '-') {
    return prefix + name;
  } else {
    return prefix + '__' + name;
  }
}
function classNames(prefix, state) {
  for (var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    classNameList[_key - 2] = arguments[_key];
  }
  var arr = [].concat(classNameList);
  if (state && prefix) {
    for (var key in state) {
      if (state.hasOwnProperty(key) && state[key]) {
        arr.push("".concat(applyPrefixToName(prefix, key)));
      }
    }
  }
  return arr.filter(function (i) {
    return i;
  }).map(function (i) {
    return String(i).trim();
  }).join(' ');
}
// ==============================
// Clean Value
// ==============================

var cleanValue = function cleanValue(value) {
  if (isArray(value)) return value.filter(Boolean);
  if (_typeof(value) === 'object' && value !== null) return [value];
  return [];
};

// ==============================
// Clean Common Props
// ==============================

var cleanCommonProps = function cleanCommonProps(props) {
  //className
  props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = _objectWithoutProperties(props, _excluded$4);
  return _objectSpread2({}, innerProps);
};

// ==============================
// Get Style Props
// ==============================

var getStyleProps = function getStyleProps(props, name, classNamesState) {
  var cx = props.cx,
    getStyles = props.getStyles,
    getClassNames = props.getClassNames,
    className = props.className;
  return {
    css: getStyles(name, props),
    className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
  };
};

// ==============================
// Handle Input Change
// ==============================

function handleInputChange(inputValue, actionMeta, onInputChange) {
  if (onInputChange) {
    var _newValue = onInputChange(inputValue, actionMeta);
    if (typeof _newValue === 'string') return _newValue;
  }
  return inputValue;
}

// ==============================
// Scroll Helpers
// ==============================

function isDocumentElement(el) {
  return [document.documentElement, document.body, window].indexOf(el) > -1;
}

// Normalized Scroll Top
// ------------------------------

function normalizedHeight(el) {
  if (isDocumentElement(el)) {
    return window.innerHeight;
  }
  return el.clientHeight;
}

// Normalized scrollTo & scrollTop
// ------------------------------

function getScrollTop(el) {
  if (isDocumentElement(el)) {
    return window.pageYOffset;
  }
  return el.scrollTop;
}
function scrollTo(el, top) {
  // with a scroll distance, we perform scroll on the element
  if (isDocumentElement(el)) {
    window.scrollTo(0, top);
    return;
  }
  el.scrollTop = top;
}

// Get Scroll Parent
// ------------------------------

function getScrollParent(element) {
  var style = getComputedStyle(element);
  var excludeStaticParent = style.position === 'absolute';
  var overflowRx = /(auto|scroll)/;
  if (style.position === 'fixed') return document.documentElement;
  for (var parent = element; parent = parent.parentElement;) {
    style = getComputedStyle(parent);
    if (excludeStaticParent && style.position === 'static') {
      continue;
    }
    if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) {
      return parent;
    }
  }
  return document.documentElement;
}

// Animated Scroll To
// ------------------------------

/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/
function easeOutCubic(t, b, c, d) {
  return c * ((t = t / d - 1) * t * t + 1) + b;
}
function animatedScrollTo(element, to) {
  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
  var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : noop;
  var start = getScrollTop(element);
  var change = to - start;
  var increment = 10;
  var currentTime = 0;
  function animateScroll() {
    currentTime += increment;
    var val = easeOutCubic(currentTime, start, change, duration);
    scrollTo(element, val);
    if (currentTime < duration) {
      window.requestAnimationFrame(animateScroll);
    } else {
      callback(element);
    }
  }
  animateScroll();
}

// Scroll Into View
// ------------------------------

function scrollIntoView(menuEl, focusedEl) {
  var menuRect = menuEl.getBoundingClientRect();
  var focusedRect = focusedEl.getBoundingClientRect();
  var overScroll = focusedEl.offsetHeight / 3;
  if (focusedRect.bottom + overScroll > menuRect.bottom) {
    scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
  } else if (focusedRect.top - overScroll < menuRect.top) {
    scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
  }
}

// ==============================
// Get bounding client object
// ==============================

// cannot get keys using array notation with DOMRect
function getBoundingClientObj(element) {
  var rect = element.getBoundingClientRect();
  return {
    bottom: rect.bottom,
    height: rect.height,
    left: rect.left,
    right: rect.right,
    top: rect.top,
    width: rect.width
  };
}

// ==============================
// Touch Capability Detector
// ==============================

function isTouchCapable() {
  try {
    document.createEvent('TouchEvent');
    return true;
  } catch (e) {
    return false;
  }
}

// ==============================
// Mobile Device Detector
// ==============================

function isMobileDevice() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch (e) {
    return false;
  }
}

// ==============================
// Passive Event Detector
// ==============================

// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var passiveOptionAccessed = false;
var options = {
  get passive() {
    return passiveOptionAccessed = true;
  }
};
// check for SSR
var w = typeof window !== 'undefined' ? window : {};
if (w.addEventListener && w.removeEventListener) {
  w.addEventListener('p', noop, options);
  w.removeEventListener('p', noop, false);
}
var supportsPassiveEvents = passiveOptionAccessed;
function notNullish(item) {
  return item != null;
}
function isArray(arg) {
  return Array.isArray(arg);
}
function valueTernary(isMulti, multiValue, singleValue) {
  return isMulti ? multiValue : singleValue;
}
function singleValueAsValue(singleValue) {
  return singleValue;
}
function multiValueAsValue(multiValue) {
  return multiValue;
}
var removeProps = function removeProps(propsObj) {
  for (var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    properties[_key2 - 1] = arguments[_key2];
  }
  var propsMap = Object.entries(propsObj).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
      key = _ref2[0];
    return !properties.includes(key);
  });
  return propsMap.reduce(function (newProps, _ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      key = _ref4[0],
      val = _ref4[1];
    newProps[key] = val;
    return newProps;
  }, {});
};

var _excluded$3 = ["children", "innerProps"],
  _excluded2$1 = ["children", "innerProps"];
function getMenuPlacement(_ref) {
  var preferredMaxHeight = _ref.maxHeight,
    menuEl = _ref.menuEl,
    minHeight = _ref.minHeight,
    preferredPlacement = _ref.placement,
    shouldScroll = _ref.shouldScroll,
    isFixedPosition = _ref.isFixedPosition,
    controlHeight = _ref.controlHeight;
  var scrollParent = getScrollParent(menuEl);
  var defaultState = {
    placement: 'bottom',
    maxHeight: preferredMaxHeight
  };

  // something went wrong, return default state
  if (!menuEl || !menuEl.offsetParent) return defaultState;

  // we can't trust `scrollParent.scrollHeight` --> it may increase when
  // the menu is rendered
  var _scrollParent$getBoun = scrollParent.getBoundingClientRect(),
    scrollHeight = _scrollParent$getBoun.height;
  var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(),
    menuBottom = _menuEl$getBoundingCl.bottom,
    menuHeight = _menuEl$getBoundingCl.height,
    menuTop = _menuEl$getBoundingCl.top;
  var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(),
    containerTop = _menuEl$offsetParent$.top;
  var viewHeight = isFixedPosition ? window.innerHeight : normalizedHeight(scrollParent);
  var scrollTop = getScrollTop(scrollParent);
  var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
  var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
  var viewSpaceAbove = containerTop - marginTop;
  var viewSpaceBelow = viewHeight - menuTop;
  var scrollSpaceAbove = viewSpaceAbove + scrollTop;
  var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
  var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
  var scrollUp = scrollTop + menuTop - marginTop;
  var scrollDuration = 160;
  switch (preferredPlacement) {
    case 'auto':
    case 'bottom':
      // 1: the menu will fit, do nothing
      if (viewSpaceBelow >= menuHeight) {
        return {
          placement: 'bottom',
          maxHeight: preferredMaxHeight
        };
      }

      // 2: the menu will fit, if scrolled
      if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        }
        return {
          placement: 'bottom',
          maxHeight: preferredMaxHeight
        };
      }

      // 3: the menu will fit, if constrained
      if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        }

        // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.
        var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
        return {
          placement: 'bottom',
          maxHeight: constrainedHeight
        };
      }

      // 4. Forked beviour when there isn't enough space below

      // AUTO: flip the menu, render above
      if (preferredPlacement === 'auto' || isFixedPosition) {
        // may need to be constrained after flipping
        var _constrainedHeight = preferredMaxHeight;
        var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
        if (spaceAbove >= minHeight) {
          _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
        }
        return {
          placement: 'top',
          maxHeight: _constrainedHeight
        };
      }

      // BOTTOM: allow browser to increase scrollable area and immediately set scroll
      if (preferredPlacement === 'bottom') {
        if (shouldScroll) {
          scrollTo(scrollParent, scrollDown);
        }
        return {
          placement: 'bottom',
          maxHeight: preferredMaxHeight
        };
      }
      break;
    case 'top':
      // 1: the menu will fit, do nothing
      if (viewSpaceAbove >= menuHeight) {
        return {
          placement: 'top',
          maxHeight: preferredMaxHeight
        };
      }

      // 2: the menu will fit, if scrolled
      if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }
        return {
          placement: 'top',
          maxHeight: preferredMaxHeight
        };
      }

      // 3: the menu will fit, if constrained
      if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
        var _constrainedHeight2 = preferredMaxHeight;

        // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.
        if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
          _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
        }
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }
        return {
          placement: 'top',
          maxHeight: _constrainedHeight2
        };
      }

      // 4. not enough space, the browser WILL NOT increase scrollable area when
      // absolutely positioned element rendered above the viewport (only below).
      // Flip the menu, render below
      return {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
      };
    default:
      throw new Error("Invalid placement provided \"".concat(preferredPlacement, "\"."));
  }
  return defaultState;
}

// Menu Component
// ------------------------------

function alignToControl(placement) {
  var placementToCSSProp = {
    bottom: 'top',
    top: 'bottom'
  };
  return placement ? placementToCSSProp[placement] : 'bottom';
}
var coercePlacement = function coercePlacement(p) {
  return p === 'auto' ? 'bottom' : p;
};
var menuCSS = function menuCSS(_ref2, unstyled) {
  var _objectSpread2$1;
  var placement = _ref2.placement,
    _ref2$theme = _ref2.theme,
    borderRadius = _ref2$theme.borderRadius,
    spacing = _ref2$theme.spacing,
    colors = _ref2$theme.colors;
  return _objectSpread2((_objectSpread2$1 = {
    label: 'menu'
  }, _defineProperty(_objectSpread2$1, alignToControl(placement), '100%'), _defineProperty(_objectSpread2$1, "position", 'absolute'), _defineProperty(_objectSpread2$1, "width", '100%'), _defineProperty(_objectSpread2$1, "zIndex", 1), _objectSpread2$1), unstyled ? {} : {
    backgroundColor: colors.neutral0,
    borderRadius: borderRadius,
    boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
    marginBottom: spacing.menuGutter,
    marginTop: spacing.menuGutter
  });
};
var PortalPlacementContext = /*#__PURE__*/createContext(null);

// NOTE: internal only
var MenuPlacer = function MenuPlacer(props) {
  var children = props.children,
    minMenuHeight = props.minMenuHeight,
    maxMenuHeight = props.maxMenuHeight,
    menuPlacement = props.menuPlacement,
    menuPosition = props.menuPosition,
    menuShouldScrollIntoView = props.menuShouldScrollIntoView,
    theme = props.theme;
  var _ref3 = useContext(PortalPlacementContext) || {},
    setPortalPlacement = _ref3.setPortalPlacement;
  var ref = useRef(null);
  var _useState = useState(maxMenuHeight),
    _useState2 = _slicedToArray(_useState, 2),
    maxHeight = _useState2[0],
    setMaxHeight = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    placement = _useState4[0],
    setPlacement = _useState4[1];
  var controlHeight = theme.spacing.controlHeight;
  index(function () {
    var menuEl = ref.current;
    if (!menuEl) return;

    // DO NOT scroll if position is fixed
    var isFixedPosition = menuPosition === 'fixed';
    var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
    var state = getMenuPlacement({
      maxHeight: maxMenuHeight,
      menuEl: menuEl,
      minHeight: minMenuHeight,
      placement: menuPlacement,
      shouldScroll: shouldScroll,
      isFixedPosition: isFixedPosition,
      controlHeight: controlHeight
    });
    setMaxHeight(state.maxHeight);
    setPlacement(state.placement);
    setPortalPlacement === null || setPortalPlacement === void 0 ? void 0 : setPortalPlacement(state.placement);
  }, [maxMenuHeight, menuPlacement, menuPosition, menuShouldScrollIntoView, minMenuHeight, setPortalPlacement, controlHeight]);
  return children({
    ref: ref,
    placerProps: _objectSpread2(_objectSpread2({}, props), {}, {
      placement: placement || coercePlacement(menuPlacement),
      maxHeight: maxHeight
    })
  });
};
var Menu = function Menu(props) {
  var children = props.children,
    innerRef = props.innerRef,
    innerProps = props.innerProps;
  return jsx("div", _extends({}, getStyleProps(props, 'menu', {
    menu: true
  }), {
    ref: innerRef
  }, innerProps), children);
};
var Menu$1 = Menu;

// ==============================
// Menu List
// ==============================

var menuListCSS = function menuListCSS(_ref4, unstyled) {
  var maxHeight = _ref4.maxHeight,
    baseUnit = _ref4.theme.spacing.baseUnit;
  return _objectSpread2({
    maxHeight: maxHeight,
    overflowY: 'auto',
    position: 'relative',
    // required for offset[Height, Top] > keyboard scroll
    WebkitOverflowScrolling: 'touch'
  }, unstyled ? {} : {
    paddingBottom: baseUnit,
    paddingTop: baseUnit
  });
};
var MenuList = function MenuList(props) {
  var children = props.children,
    innerProps = props.innerProps,
    innerRef = props.innerRef,
    isMulti = props.isMulti;
  return jsx("div", _extends({}, getStyleProps(props, 'menuList', {
    'menu-list': true,
    'menu-list--is-multi': isMulti
  }), {
    ref: innerRef
  }, innerProps), children);
};

// ==============================
// Menu Notices
// ==============================

var noticeCSS = function noticeCSS(_ref5, unstyled) {
  var _ref5$theme = _ref5.theme,
    baseUnit = _ref5$theme.spacing.baseUnit,
    colors = _ref5$theme.colors;
  return _objectSpread2({
    textAlign: 'center'
  }, unstyled ? {} : {
    color: colors.neutral40,
    padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
  });
};
var noOptionsMessageCSS = noticeCSS;
var loadingMessageCSS = noticeCSS;
var NoOptionsMessage = function NoOptionsMessage(_ref6) {
  var _ref6$children = _ref6.children,
    children = _ref6$children === void 0 ? 'No options' : _ref6$children,
    innerProps = _ref6.innerProps,
    restProps = _objectWithoutProperties(_ref6, _excluded$3);
  return jsx("div", _extends({}, getStyleProps(_objectSpread2(_objectSpread2({}, restProps), {}, {
    children: children,
    innerProps: innerProps
  }), 'noOptionsMessage', {
    'menu-notice': true,
    'menu-notice--no-options': true
  }), innerProps), children);
};
var LoadingMessage = function LoadingMessage(_ref7) {
  var _ref7$children = _ref7.children,
    children = _ref7$children === void 0 ? 'Loading...' : _ref7$children,
    innerProps = _ref7.innerProps,
    restProps = _objectWithoutProperties(_ref7, _excluded2$1);
  return jsx("div", _extends({}, getStyleProps(_objectSpread2(_objectSpread2({}, restProps), {}, {
    children: children,
    innerProps: innerProps
  }), 'loadingMessage', {
    'menu-notice': true,
    'menu-notice--loading': true
  }), innerProps), children);
};

// ==============================
// Menu Portal
// ==============================

var menuPortalCSS = function menuPortalCSS(_ref8) {
  var rect = _ref8.rect,
    offset = _ref8.offset,
    position = _ref8.position;
  return {
    left: rect.left,
    position: position,
    top: offset,
    width: rect.width,
    zIndex: 1
  };
};
var MenuPortal = function MenuPortal(props) {
  var appendTo = props.appendTo,
    children = props.children,
    controlElement = props.controlElement,
    innerProps = props.innerProps,
    menuPlacement = props.menuPlacement,
    menuPosition = props.menuPosition;
  var menuPortalRef = useRef(null);
  var cleanupRef = useRef(null);
  var _useState5 = useState(coercePlacement(menuPlacement)),
    _useState6 = _slicedToArray(_useState5, 2),
    placement = _useState6[0],
    setPortalPlacement = _useState6[1];
  var portalPlacementContext = useMemo(function () {
    return {
      setPortalPlacement: setPortalPlacement
    };
  }, []);
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    computedPosition = _useState8[0],
    setComputedPosition = _useState8[1];
  var updateComputedPosition = useCallback(function () {
    if (!controlElement) return;
    var rect = getBoundingClientObj(controlElement);
    var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
    var offset = rect[placement] + scrollDistance;
    if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) {
      setComputedPosition({
        offset: offset,
        rect: rect
      });
    }
  }, [controlElement, menuPosition, placement, computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset, computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left, computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width]);
  index(function () {
    updateComputedPosition();
  }, [updateComputedPosition]);
  var runAutoUpdate = useCallback(function () {
    if (typeof cleanupRef.current === 'function') {
      cleanupRef.current();
      cleanupRef.current = null;
    }
    if (controlElement && menuPortalRef.current) {
      cleanupRef.current = autoUpdate(controlElement, menuPortalRef.current, updateComputedPosition, {
        elementResize: 'ResizeObserver' in window
      });
    }
  }, [controlElement, updateComputedPosition]);
  index(function () {
    runAutoUpdate();
  }, [runAutoUpdate]);
  var setMenuPortalElement = useCallback(function (menuPortalElement) {
    menuPortalRef.current = menuPortalElement;
    runAutoUpdate();
  }, [runAutoUpdate]);

  // bail early if required elements aren't present
  if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;

  // same wrapper element whether fixed or portalled
  var menuWrapper = jsx("div", _extends({
    ref: setMenuPortalElement
  }, getStyleProps(_objectSpread2(_objectSpread2({}, props), {}, {
    offset: computedPosition.offset,
    position: menuPosition,
    rect: computedPosition.rect
  }), 'menuPortal', {
    'menu-portal': true
  }), innerProps), children);
  return jsx(PortalPlacementContext.Provider, {
    value: portalPlacementContext
  }, appendTo ? /*#__PURE__*/createPortal(menuWrapper, appendTo) : menuWrapper);
};

// ==============================
// Root Container
// ==============================

var containerCSS = function containerCSS(_ref) {
  var isDisabled = _ref.isDisabled,
    isRtl = _ref.isRtl;
  return {
    label: 'container',
    direction: isRtl ? 'rtl' : undefined,
    pointerEvents: isDisabled ? 'none' : undefined,
    // cancel mouse events when disabled
    position: 'relative'
  };
};
var SelectContainer = function SelectContainer(props) {
  var children = props.children,
    innerProps = props.innerProps,
    isDisabled = props.isDisabled,
    isRtl = props.isRtl;
  return jsx("div", _extends({}, getStyleProps(props, 'container', {
    '--is-disabled': isDisabled,
    '--is-rtl': isRtl
  }), innerProps), children);
};

// ==============================
// Value Container
// ==============================

var valueContainerCSS = function valueContainerCSS(_ref2, unstyled) {
  var spacing = _ref2.theme.spacing,
    isMulti = _ref2.isMulti,
    hasValue = _ref2.hasValue,
    controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
  return _objectSpread2({
    alignItems: 'center',
    display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
    flex: 1,
    flexWrap: 'wrap',
    WebkitOverflowScrolling: 'touch',
    position: 'relative',
    overflow: 'hidden'
  }, unstyled ? {} : {
    padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
  });
};
var ValueContainer = function ValueContainer(props) {
  var children = props.children,
    innerProps = props.innerProps,
    isMulti = props.isMulti,
    hasValue = props.hasValue;
  return jsx("div", _extends({}, getStyleProps(props, 'valueContainer', {
    'value-container': true,
    'value-container--is-multi': isMulti,
    'value-container--has-value': hasValue
  }), innerProps), children);
};

// ==============================
// Indicator Container
// ==============================

var indicatorsContainerCSS = function indicatorsContainerCSS() {
  return {
    alignItems: 'center',
    alignSelf: 'stretch',
    display: 'flex',
    flexShrink: 0
  };
};
var IndicatorsContainer = function IndicatorsContainer(props) {
  var children = props.children,
    innerProps = props.innerProps;
  return jsx("div", _extends({}, getStyleProps(props, 'indicatorsContainer', {
    indicators: true
  }), innerProps), children);
};

var _templateObject;
var _excluded$2$1 = ["size"],
  _excluded2 = ["innerProps", "isRtl", "size"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$3() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

// ==============================
// Dropdown & Clear Icons
// ==============================
var _ref2$2 = process.env.NODE_ENV === "production" ? {
  name: "8mmkcg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
} : {
  name: "tj5bde-Svg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;label:Svg;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$3
};
var Svg = function Svg(_ref) {
  var size = _ref.size,
    props = _objectWithoutProperties(_ref, _excluded$2$1);
  return jsx("svg", _extends({
    height: size,
    width: size,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    css: _ref2$2
  }, props));
};
var CrossIcon = function CrossIcon(props) {
  return jsx(Svg, _extends({
    size: 20
  }, props), jsx("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
};
var DownChevron = function DownChevron(props) {
  return jsx(Svg, _extends({
    size: 20
  }, props), jsx("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
};

// ==============================
// Dropdown & Clear Buttons
// ==============================

var baseCSS = function baseCSS(_ref3, unstyled) {
  var isFocused = _ref3.isFocused,
    _ref3$theme = _ref3.theme,
    baseUnit = _ref3$theme.spacing.baseUnit,
    colors = _ref3$theme.colors;
  return _objectSpread2({
    label: 'indicatorContainer',
    display: 'flex',
    transition: 'color 150ms'
  }, unstyled ? {} : {
    color: isFocused ? colors.neutral60 : colors.neutral20,
    padding: baseUnit * 2,
    ':hover': {
      color: isFocused ? colors.neutral80 : colors.neutral40
    }
  });
};
var dropdownIndicatorCSS = baseCSS;
var DropdownIndicator = function DropdownIndicator(props) {
  var children = props.children,
    innerProps = props.innerProps;
  return jsx("div", _extends({}, getStyleProps(props, 'dropdownIndicator', {
    indicator: true,
    'dropdown-indicator': true
  }), innerProps), children || jsx(DownChevron, null));
};
var clearIndicatorCSS = baseCSS;
var ClearIndicator = function ClearIndicator(props) {
  var children = props.children,
    innerProps = props.innerProps;
  return jsx("div", _extends({}, getStyleProps(props, 'clearIndicator', {
    indicator: true,
    'clear-indicator': true
  }), innerProps), children || jsx(CrossIcon, null));
};

// ==============================
// Separator
// ==============================

var indicatorSeparatorCSS = function indicatorSeparatorCSS(_ref4, unstyled) {
  var isDisabled = _ref4.isDisabled,
    _ref4$theme = _ref4.theme,
    baseUnit = _ref4$theme.spacing.baseUnit,
    colors = _ref4$theme.colors;
  return _objectSpread2({
    label: 'indicatorSeparator',
    alignSelf: 'stretch',
    width: 1
  }, unstyled ? {} : {
    backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
    marginBottom: baseUnit * 2,
    marginTop: baseUnit * 2
  });
};
var IndicatorSeparator = function IndicatorSeparator(props) {
  var innerProps = props.innerProps;
  return jsx("span", _extends({}, innerProps, getStyleProps(props, 'indicatorSeparator', {
    'indicator-separator': true
  })));
};

// ==============================
// Loading
// ==============================

var loadingDotAnimations = keyframes$1(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"])));
var loadingIndicatorCSS = function loadingIndicatorCSS(_ref5, unstyled) {
  var isFocused = _ref5.isFocused,
    size = _ref5.size,
    _ref5$theme = _ref5.theme,
    colors = _ref5$theme.colors,
    baseUnit = _ref5$theme.spacing.baseUnit;
  return _objectSpread2({
    label: 'loadingIndicator',
    display: 'flex',
    transition: 'color 150ms',
    alignSelf: 'center',
    fontSize: size,
    lineHeight: 1,
    marginRight: size,
    textAlign: 'center',
    verticalAlign: 'middle'
  }, unstyled ? {} : {
    color: isFocused ? colors.neutral60 : colors.neutral20,
    padding: baseUnit * 2
  });
};
var LoadingDot = function LoadingDot(_ref6) {
  var delay = _ref6.delay,
    offset = _ref6.offset;
  return jsx("span", {
    css: /*#__PURE__*/css$4({
      animation: "".concat(loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
      backgroundColor: 'currentColor',
      borderRadius: '1em',
      display: 'inline-block',
      marginLeft: offset ? '1em' : undefined,
      height: '1em',
      verticalAlign: 'top',
      width: '1em'
    }, process.env.NODE_ENV === "production" ? "" : ";label:LoadingDot;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  });
};
var LoadingIndicator = function LoadingIndicator(_ref7) {
  var innerProps = _ref7.innerProps,
    isRtl = _ref7.isRtl,
    _ref7$size = _ref7.size,
    size = _ref7$size === void 0 ? 4 : _ref7$size,
    restProps = _objectWithoutProperties(_ref7, _excluded2);
  return jsx("div", _extends({}, getStyleProps(_objectSpread2(_objectSpread2({}, restProps), {}, {
    innerProps: innerProps,
    isRtl: isRtl,
    size: size
  }), 'loadingIndicator', {
    indicator: true,
    'loading-indicator': true
  }), innerProps), jsx(LoadingDot, {
    delay: 0,
    offset: isRtl
  }), jsx(LoadingDot, {
    delay: 160,
    offset: true
  }), jsx(LoadingDot, {
    delay: 320,
    offset: !isRtl
  }));
};

var css$1 = function css(_ref, unstyled) {
  var isDisabled = _ref.isDisabled,
    isFocused = _ref.isFocused,
    _ref$theme = _ref.theme,
    colors = _ref$theme.colors,
    borderRadius = _ref$theme.borderRadius,
    spacing = _ref$theme.spacing;
  return _objectSpread2({
    label: 'control',
    alignItems: 'center',
    cursor: 'default',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    minHeight: spacing.controlHeight,
    outline: '0 !important',
    position: 'relative',
    transition: 'all 100ms'
  }, unstyled ? {} : {
    backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
    borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
    borderRadius: borderRadius,
    borderStyle: 'solid',
    borderWidth: 1,
    boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
    '&:hover': {
      borderColor: isFocused ? colors.primary : colors.neutral30
    }
  });
};
var Control = function Control(props) {
  var children = props.children,
    isDisabled = props.isDisabled,
    isFocused = props.isFocused,
    innerRef = props.innerRef,
    innerProps = props.innerProps,
    menuIsOpen = props.menuIsOpen;
  return jsx("div", _extends({
    ref: innerRef
  }, getStyleProps(props, 'control', {
    control: true,
    'control--is-disabled': isDisabled,
    'control--is-focused': isFocused,
    'control--menu-is-open': menuIsOpen
  }), innerProps, {
    "aria-disabled": isDisabled || undefined
  }), children);
};
var Control$1 = Control;

var _excluded$1$1 = ["data"];
var groupCSS = function groupCSS(_ref, unstyled) {
  var spacing = _ref.theme.spacing;
  return unstyled ? {} : {
    paddingBottom: spacing.baseUnit * 2,
    paddingTop: spacing.baseUnit * 2
  };
};
var Group = function Group(props) {
  var children = props.children,
    cx = props.cx,
    getStyles = props.getStyles,
    getClassNames = props.getClassNames,
    Heading = props.Heading,
    headingProps = props.headingProps,
    innerProps = props.innerProps,
    label = props.label,
    theme = props.theme,
    selectProps = props.selectProps;
  return jsx("div", _extends({}, getStyleProps(props, 'group', {
    group: true
  }), innerProps), jsx(Heading, _extends({}, headingProps, {
    selectProps: selectProps,
    theme: theme,
    getStyles: getStyles,
    getClassNames: getClassNames,
    cx: cx
  }), label), jsx("div", null, children));
};
var groupHeadingCSS = function groupHeadingCSS(_ref2, unstyled) {
  var _ref2$theme = _ref2.theme,
    colors = _ref2$theme.colors,
    spacing = _ref2$theme.spacing;
  return _objectSpread2({
    label: 'group',
    cursor: 'default',
    display: 'block'
  }, unstyled ? {} : {
    color: colors.neutral40,
    fontSize: '75%',
    fontWeight: 500,
    marginBottom: '0.25em',
    paddingLeft: spacing.baseUnit * 3,
    paddingRight: spacing.baseUnit * 3,
    textTransform: 'uppercase'
  });
};
var GroupHeading = function GroupHeading(props) {
  var _cleanCommonProps = cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = _objectWithoutProperties(_cleanCommonProps, _excluded$1$1);
  return jsx("div", _extends({}, getStyleProps(props, 'groupHeading', {
    'group-heading': true
  }), innerProps));
};
var Group$1 = Group;

var _excluded$5 = ["innerRef", "isDisabled", "isHidden", "inputClassName"];
var inputCSS = function inputCSS(_ref, unstyled) {
  var isDisabled = _ref.isDisabled,
    value = _ref.value,
    _ref$theme = _ref.theme,
    spacing = _ref$theme.spacing,
    colors = _ref$theme.colors;
  return _objectSpread2(_objectSpread2({
    visibility: isDisabled ? 'hidden' : 'visible',
    // force css to recompute when value change due to @emotion bug.
    // We can remove it whenever the bug is fixed.
    transform: value ? 'translateZ(0)' : ''
  }, containerStyle), unstyled ? {} : {
    margin: spacing.baseUnit / 2,
    paddingBottom: spacing.baseUnit / 2,
    paddingTop: spacing.baseUnit / 2,
    color: colors.neutral80
  });
};
var spacingStyle = {
  gridArea: '1 / 2',
  font: 'inherit',
  minWidth: '2px',
  border: 0,
  margin: 0,
  outline: 0,
  padding: 0
};
var containerStyle = {
  flex: '1 1 auto',
  display: 'inline-grid',
  gridArea: '1 / 1 / 2 / 3',
  gridTemplateColumns: '0 min-content',
  '&:after': _objectSpread2({
    content: 'attr(data-value) " "',
    visibility: 'hidden',
    whiteSpace: 'pre'
  }, spacingStyle)
};
var inputStyle = function inputStyle(isHidden) {
  return _objectSpread2({
    label: 'input',
    color: 'inherit',
    background: 0,
    opacity: isHidden ? 0 : 1,
    width: '100%'
  }, spacingStyle);
};
var Input = function Input(props) {
  var cx = props.cx,
    value = props.value;
  var _cleanCommonProps = cleanCommonProps(props),
    innerRef = _cleanCommonProps.innerRef,
    isDisabled = _cleanCommonProps.isDisabled,
    isHidden = _cleanCommonProps.isHidden,
    inputClassName = _cleanCommonProps.inputClassName,
    innerProps = _objectWithoutProperties(_cleanCommonProps, _excluded$5);
  return jsx("div", _extends({}, getStyleProps(props, 'input', {
    'input-container': true
  }), {
    "data-value": value || ''
  }), jsx("input", _extends({
    className: cx({
      input: true
    }, inputClassName),
    ref: innerRef,
    style: inputStyle(isHidden),
    disabled: isDisabled
  }, innerProps)));
};
var Input$1 = Input;

var multiValueCSS = function multiValueCSS(_ref, unstyled) {
  var _ref$theme = _ref.theme,
    spacing = _ref$theme.spacing,
    borderRadius = _ref$theme.borderRadius,
    colors = _ref$theme.colors;
  return _objectSpread2({
    label: 'multiValue',
    display: 'flex',
    minWidth: 0
  }, unstyled ? {} : {
    backgroundColor: colors.neutral10,
    borderRadius: borderRadius / 2,
    margin: spacing.baseUnit / 2
  });
};
var multiValueLabelCSS = function multiValueLabelCSS(_ref2, unstyled) {
  var _ref2$theme = _ref2.theme,
    borderRadius = _ref2$theme.borderRadius,
    colors = _ref2$theme.colors,
    cropWithEllipsis = _ref2.cropWithEllipsis;
  return _objectSpread2({
    overflow: 'hidden',
    textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
    whiteSpace: 'nowrap'
  }, unstyled ? {} : {
    borderRadius: borderRadius / 2,
    color: colors.neutral80,
    fontSize: '85%',
    padding: 3,
    paddingLeft: 6
  });
};
var multiValueRemoveCSS = function multiValueRemoveCSS(_ref3, unstyled) {
  var _ref3$theme = _ref3.theme,
    spacing = _ref3$theme.spacing,
    borderRadius = _ref3$theme.borderRadius,
    colors = _ref3$theme.colors,
    isFocused = _ref3.isFocused;
  return _objectSpread2({
    alignItems: 'center',
    display: 'flex'
  }, unstyled ? {} : {
    borderRadius: borderRadius / 2,
    backgroundColor: isFocused ? colors.dangerLight : undefined,
    paddingLeft: spacing.baseUnit,
    paddingRight: spacing.baseUnit,
    ':hover': {
      backgroundColor: colors.dangerLight,
      color: colors.danger
    }
  });
};
var MultiValueGeneric = function MultiValueGeneric(_ref4) {
  var children = _ref4.children,
    innerProps = _ref4.innerProps;
  return jsx("div", innerProps, children);
};
var MultiValueContainer = MultiValueGeneric;
var MultiValueLabel = MultiValueGeneric;
function MultiValueRemove(_ref5) {
  var children = _ref5.children,
    innerProps = _ref5.innerProps;
  return jsx("div", _extends({
    role: "button"
  }, innerProps), children || jsx(CrossIcon, {
    size: 14
  }));
}
var MultiValue = function MultiValue(props) {
  var children = props.children,
    components = props.components,
    data = props.data,
    innerProps = props.innerProps,
    isDisabled = props.isDisabled,
    removeProps = props.removeProps,
    selectProps = props.selectProps;
  var Container = components.Container,
    Label = components.Label,
    Remove = components.Remove;
  return jsx(Container, {
    data: data,
    innerProps: _objectSpread2(_objectSpread2({}, getStyleProps(props, 'multiValue', {
      'multi-value': true,
      'multi-value--is-disabled': isDisabled
    })), innerProps),
    selectProps: selectProps
  }, jsx(Label, {
    data: data,
    innerProps: _objectSpread2({}, getStyleProps(props, 'multiValueLabel', {
      'multi-value__label': true
    })),
    selectProps: selectProps
  }, children), jsx(Remove, {
    data: data,
    innerProps: _objectSpread2(_objectSpread2({}, getStyleProps(props, 'multiValueRemove', {
      'multi-value__remove': true
    })), {}, {
      'aria-label': "Remove ".concat(children || 'option')
    }, removeProps),
    selectProps: selectProps
  }));
};
var MultiValue$1 = MultiValue;

var optionCSS = function optionCSS(_ref, unstyled) {
  var isDisabled = _ref.isDisabled,
    isFocused = _ref.isFocused,
    isSelected = _ref.isSelected,
    _ref$theme = _ref.theme,
    spacing = _ref$theme.spacing,
    colors = _ref$theme.colors;
  return _objectSpread2({
    label: 'option',
    cursor: 'default',
    display: 'block',
    fontSize: 'inherit',
    width: '100%',
    userSelect: 'none',
    WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)'
  }, unstyled ? {} : {
    backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
    color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
    padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
    // provide some affordance on touch devices
    ':active': {
      backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
    }
  });
};
var Option = function Option(props) {
  var children = props.children,
    isDisabled = props.isDisabled,
    isFocused = props.isFocused,
    isSelected = props.isSelected,
    innerRef = props.innerRef,
    innerProps = props.innerProps;
  return jsx("div", _extends({}, getStyleProps(props, 'option', {
    option: true,
    'option--is-disabled': isDisabled,
    'option--is-focused': isFocused,
    'option--is-selected': isSelected
  }), {
    ref: innerRef,
    "aria-disabled": isDisabled
  }, innerProps), children);
};
var Option$1 = Option;

var placeholderCSS = function placeholderCSS(_ref, unstyled) {
  var _ref$theme = _ref.theme,
    spacing = _ref$theme.spacing,
    colors = _ref$theme.colors;
  return _objectSpread2({
    label: 'placeholder',
    gridArea: '1 / 1 / 2 / 3'
  }, unstyled ? {} : {
    color: colors.neutral50,
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2
  });
};
var Placeholder = function Placeholder(props) {
  var children = props.children,
    innerProps = props.innerProps;
  return jsx("div", _extends({}, getStyleProps(props, 'placeholder', {
    placeholder: true
  }), innerProps), children);
};
var Placeholder$1 = Placeholder;

var css = function css(_ref, unstyled) {
  var isDisabled = _ref.isDisabled,
    _ref$theme = _ref.theme,
    spacing = _ref$theme.spacing,
    colors = _ref$theme.colors;
  return _objectSpread2({
    label: 'singleValue',
    gridArea: '1 / 1 / 2 / 3',
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  }, unstyled ? {} : {
    color: isDisabled ? colors.neutral40 : colors.neutral80,
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2
  });
};
var SingleValue = function SingleValue(props) {
  var children = props.children,
    isDisabled = props.isDisabled,
    innerProps = props.innerProps;
  return jsx("div", _extends({}, getStyleProps(props, 'singleValue', {
    'single-value': true,
    'single-value--is-disabled': isDisabled
  }), innerProps), children);
};
var SingleValue$1 = SingleValue;

var components = {
  ClearIndicator: ClearIndicator,
  Control: Control$1,
  DropdownIndicator: DropdownIndicator,
  DownChevron: DownChevron,
  CrossIcon: CrossIcon,
  Group: Group$1,
  GroupHeading: GroupHeading,
  IndicatorsContainer: IndicatorsContainer,
  IndicatorSeparator: IndicatorSeparator,
  Input: Input$1,
  LoadingIndicator: LoadingIndicator,
  Menu: Menu$1,
  MenuList: MenuList,
  MenuPortal: MenuPortal,
  LoadingMessage: LoadingMessage,
  NoOptionsMessage: NoOptionsMessage,
  MultiValue: MultiValue$1,
  MultiValueContainer: MultiValueContainer,
  MultiValueLabel: MultiValueLabel,
  MultiValueRemove: MultiValueRemove,
  Option: Option$1,
  Placeholder: Placeholder$1,
  SelectContainer: SelectContainer,
  SingleValue: SingleValue$1,
  ValueContainer: ValueContainer
};
var defaultComponents = function defaultComponents(props) {
  return _objectSpread2(_objectSpread2({}, components), props.components);
};

var safeIsNaN = Number.isNaN ||
    function ponyfill(value) {
        return typeof value === 'number' && value !== value;
    };
function isEqual(first, second) {
    if (first === second) {
        return true;
    }
    if (safeIsNaN(first) && safeIsNaN(second)) {
        return true;
    }
    return false;
}
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) {
        return false;
    }
    for (var i = 0; i < newInputs.length; i++) {
        if (!isEqual(newInputs[i], lastInputs[i])) {
            return false;
        }
    }
    return true;
}

function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) { isEqual = areInputsEqual; }
    var cache = null;
    function memoized() {
        var newArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            newArgs[_i] = arguments[_i];
        }
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) {
            return cache.lastResult;
        }
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this,
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$2() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

// Assistive text to describe visual elements. Hidden for sighted users.
var _ref = process.env.NODE_ENV === "production" ? {
  name: "7pg0cj-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
} : {
  name: "1f43avz-a11yText-A11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;label:A11yText;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkExMXlUZXh0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFPSSIsImZpbGUiOiJBMTF5VGV4dC50c3giLCJzb3VyY2VzQ29udGVudCI6WyIvKiogQGpzeCBqc3ggKi9cbmltcG9ydCB7IEpTWCB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IGpzeCB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcblxuLy8gQXNzaXN0aXZlIHRleHQgdG8gZGVzY3JpYmUgdmlzdWFsIGVsZW1lbnRzLiBIaWRkZW4gZm9yIHNpZ2h0ZWQgdXNlcnMuXG5jb25zdCBBMTF5VGV4dCA9IChwcm9wczogSlNYLkludHJpbnNpY0VsZW1lbnRzWydzcGFuJ10pID0+IChcbiAgPHNwYW5cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAnYTExeVRleHQnLFxuICAgICAgekluZGV4OiA5OTk5LFxuICAgICAgYm9yZGVyOiAwLFxuICAgICAgY2xpcDogJ3JlY3QoMXB4LCAxcHgsIDFweCwgMXB4KScsXG4gICAgICBoZWlnaHQ6IDEsXG4gICAgICB3aWR0aDogMSxcbiAgICAgIHBvc2l0aW9uOiAnYWJzb2x1dGUnLFxuICAgICAgb3ZlcmZsb3c6ICdoaWRkZW4nLFxuICAgICAgcGFkZGluZzogMCxcbiAgICAgIHdoaXRlU3BhY2U6ICdub3dyYXAnLFxuICAgIH19XG4gICAgey4uLnByb3BzfVxuICAvPlxuKTtcblxuZXhwb3J0IGRlZmF1bHQgQTExeVRleHQ7XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$2
};
var A11yText = function A11yText(props) {
  return jsx("span", _extends({
    css: _ref
  }, props));
};
var A11yText$1 = A11yText;

var defaultAriaLiveMessages = {
  guidance: function guidance(props) {
    var isSearchable = props.isSearchable,
      isMulti = props.isMulti,
      tabSelectsValue = props.tabSelectsValue,
      context = props.context,
      isInitialFocus = props.isInitialFocus;
    switch (context) {
      case 'menu':
        return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");
      case 'input':
        return isInitialFocus ? "".concat(props['aria-label'] || 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '') : '';
      case 'value':
        return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
      default:
        return '';
    }
  },
  onChange: function onChange(props) {
    var action = props.action,
      _props$label = props.label,
      label = _props$label === void 0 ? '' : _props$label,
      labels = props.labels,
      isDisabled = props.isDisabled;
    switch (action) {
      case 'deselect-option':
      case 'pop-value':
      case 'remove-value':
        return "option ".concat(label, ", deselected.");
      case 'clear':
        return 'All selected options have been cleared.';
      case 'initial-input-focus':
        return "option".concat(labels.length > 1 ? 's' : '', " ").concat(labels.join(','), ", selected.");
      case 'select-option':
        return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
      default:
        return '';
    }
  },
  onFocus: function onFocus(props) {
    var context = props.context,
      focused = props.focused,
      options = props.options,
      _props$label2 = props.label,
      label = _props$label2 === void 0 ? '' : _props$label2,
      selectValue = props.selectValue,
      isDisabled = props.isDisabled,
      isSelected = props.isSelected,
      isAppleDevice = props.isAppleDevice;
    var getArrayIndex = function getArrayIndex(arr, item) {
      return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : '';
    };
    if (context === 'value' && selectValue) {
      return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
    }
    if (context === 'menu' && isAppleDevice) {
      var disabled = isDisabled ? ' disabled' : '';
      var status = "".concat(isSelected ? ' selected' : '').concat(disabled);
      return "".concat(label).concat(status, ", ").concat(getArrayIndex(options, focused), ".");
    }
    return '';
  },
  onFilter: function onFilter(props) {
    var inputValue = props.inputValue,
      resultsMessage = props.resultsMessage;
    return "".concat(resultsMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
  }
};

var LiveRegion = function LiveRegion(props) {
  var ariaSelection = props.ariaSelection,
    focusedOption = props.focusedOption,
    focusedValue = props.focusedValue,
    focusableOptions = props.focusableOptions,
    isFocused = props.isFocused,
    selectValue = props.selectValue,
    selectProps = props.selectProps,
    id = props.id,
    isAppleDevice = props.isAppleDevice;
  var ariaLiveMessages = selectProps.ariaLiveMessages,
    getOptionLabel = selectProps.getOptionLabel,
    inputValue = selectProps.inputValue,
    isMulti = selectProps.isMulti,
    isOptionDisabled = selectProps.isOptionDisabled,
    isSearchable = selectProps.isSearchable,
    menuIsOpen = selectProps.menuIsOpen,
    options = selectProps.options,
    screenReaderStatus = selectProps.screenReaderStatus,
    tabSelectsValue = selectProps.tabSelectsValue,
    isLoading = selectProps.isLoading;
  var ariaLabel = selectProps['aria-label'];
  var ariaLive = selectProps['aria-live'];

  // Update aria live message configuration when prop changes
  var messages = useMemo(function () {
    return _objectSpread2(_objectSpread2({}, defaultAriaLiveMessages), ariaLiveMessages || {});
  }, [ariaLiveMessages]);

  // Update aria live selected option when prop changes
  var ariaSelected = useMemo(function () {
    var message = '';
    if (ariaSelection && messages.onChange) {
      var option = ariaSelection.option,
        selectedOptions = ariaSelection.options,
        removedValue = ariaSelection.removedValue,
        removedValues = ariaSelection.removedValues,
        value = ariaSelection.value;
      // select-option when !isMulti does not return option so we assume selected option is value
      var asOption = function asOption(val) {
        return !Array.isArray(val) ? val : null;
      };

      // If there is just one item from the action then get its label
      var selected = removedValue || option || asOption(value);
      var label = selected ? getOptionLabel(selected) : '';

      // If there are multiple items from the action then return an array of labels
      var multiSelected = selectedOptions || removedValues || undefined;
      var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
      var onChangeProps = _objectSpread2({
        // multiSelected items are usually items that have already been selected
        // or set by the user as a default value so we assume they are not disabled
        isDisabled: selected && isOptionDisabled(selected, selectValue),
        label: label,
        labels: labels
      }, ariaSelection);
      message = messages.onChange(onChangeProps);
    }
    return message;
  }, [ariaSelection, messages, isOptionDisabled, selectValue, getOptionLabel]);
  var ariaFocused = useMemo(function () {
    var focusMsg = '';
    var focused = focusedOption || focusedValue;
    var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
    if (focused && messages.onFocus) {
      var onFocusProps = {
        focused: focused,
        label: getOptionLabel(focused),
        isDisabled: isOptionDisabled(focused, selectValue),
        isSelected: isSelected,
        options: focusableOptions,
        context: focused === focusedOption ? 'menu' : 'value',
        selectValue: selectValue,
        isAppleDevice: isAppleDevice
      };
      focusMsg = messages.onFocus(onFocusProps);
    }
    return focusMsg;
  }, [focusedOption, focusedValue, getOptionLabel, isOptionDisabled, messages, focusableOptions, selectValue, isAppleDevice]);
  var ariaResults = useMemo(function () {
    var resultsMsg = '';
    if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
      var resultsMessage = screenReaderStatus({
        count: focusableOptions.length
      });
      resultsMsg = messages.onFilter({
        inputValue: inputValue,
        resultsMessage: resultsMessage
      });
    }
    return resultsMsg;
  }, [focusableOptions, inputValue, menuIsOpen, messages, options, screenReaderStatus, isLoading]);
  var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
  var ariaGuidance = useMemo(function () {
    var guidanceMsg = '';
    if (messages.guidance) {
      var context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
      guidanceMsg = messages.guidance({
        'aria-label': ariaLabel,
        context: context,
        isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
        isMulti: isMulti,
        isSearchable: isSearchable,
        tabSelectsValue: tabSelectsValue,
        isInitialFocus: isInitialFocus
      });
    }
    return guidanceMsg;
  }, [ariaLabel, focusedOption, focusedValue, isMulti, isOptionDisabled, isSearchable, menuIsOpen, messages, selectValue, tabSelectsValue, isInitialFocus]);
  var ScreenReaderText = jsx(Fragment, null, jsx("span", {
    id: "aria-selection"
  }, ariaSelected), jsx("span", {
    id: "aria-focused"
  }, ariaFocused), jsx("span", {
    id: "aria-results"
  }, ariaResults), jsx("span", {
    id: "aria-guidance"
  }, ariaGuidance));
  return jsx(Fragment, null, jsx(A11yText$1, {
    id: id
  }, isInitialFocus && ScreenReaderText), jsx(A11yText$1, {
    "aria-live": ariaLive,
    "aria-atomic": "false",
    "aria-relevant": "additions text",
    role: "log"
  }, isFocused && !isInitialFocus && ScreenReaderText));
};
var LiveRegion$1 = LiveRegion;

var diacritics = [{
  base: 'A',
  letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
}, {
  base: 'AA',
  letters: "\uA732"
}, {
  base: 'AE',
  letters: "\xC6\u01FC\u01E2"
}, {
  base: 'AO',
  letters: "\uA734"
}, {
  base: 'AU',
  letters: "\uA736"
}, {
  base: 'AV',
  letters: "\uA738\uA73A"
}, {
  base: 'AY',
  letters: "\uA73C"
}, {
  base: 'B',
  letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
}, {
  base: 'C',
  letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
}, {
  base: 'D',
  letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
}, {
  base: 'DZ',
  letters: "\u01F1\u01C4"
}, {
  base: 'Dz',
  letters: "\u01F2\u01C5"
}, {
  base: 'E',
  letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
}, {
  base: 'F',
  letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
}, {
  base: 'G',
  letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
}, {
  base: 'H',
  letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
}, {
  base: 'I',
  letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
}, {
  base: 'J',
  letters: "J\u24BF\uFF2A\u0134\u0248"
}, {
  base: 'K',
  letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
}, {
  base: 'L',
  letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
}, {
  base: 'LJ',
  letters: "\u01C7"
}, {
  base: 'Lj',
  letters: "\u01C8"
}, {
  base: 'M',
  letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
}, {
  base: 'N',
  letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
}, {
  base: 'NJ',
  letters: "\u01CA"
}, {
  base: 'Nj',
  letters: "\u01CB"
}, {
  base: 'O',
  letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
}, {
  base: 'OI',
  letters: "\u01A2"
}, {
  base: 'OO',
  letters: "\uA74E"
}, {
  base: 'OU',
  letters: "\u0222"
}, {
  base: 'P',
  letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
}, {
  base: 'Q',
  letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
}, {
  base: 'R',
  letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
}, {
  base: 'S',
  letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
}, {
  base: 'T',
  letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
}, {
  base: 'TZ',
  letters: "\uA728"
}, {
  base: 'U',
  letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
}, {
  base: 'V',
  letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
}, {
  base: 'VY',
  letters: "\uA760"
}, {
  base: 'W',
  letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
}, {
  base: 'X',
  letters: "X\u24CD\uFF38\u1E8A\u1E8C"
}, {
  base: 'Y',
  letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
}, {
  base: 'Z',
  letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
}, {
  base: 'a',
  letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
}, {
  base: 'aa',
  letters: "\uA733"
}, {
  base: 'ae',
  letters: "\xE6\u01FD\u01E3"
}, {
  base: 'ao',
  letters: "\uA735"
}, {
  base: 'au',
  letters: "\uA737"
}, {
  base: 'av',
  letters: "\uA739\uA73B"
}, {
  base: 'ay',
  letters: "\uA73D"
}, {
  base: 'b',
  letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
}, {
  base: 'c',
  letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
}, {
  base: 'd',
  letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
}, {
  base: 'dz',
  letters: "\u01F3\u01C6"
}, {
  base: 'e',
  letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
}, {
  base: 'f',
  letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
}, {
  base: 'g',
  letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
}, {
  base: 'h',
  letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
}, {
  base: 'hv',
  letters: "\u0195"
}, {
  base: 'i',
  letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
}, {
  base: 'j',
  letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
}, {
  base: 'k',
  letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
}, {
  base: 'l',
  letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
}, {
  base: 'lj',
  letters: "\u01C9"
}, {
  base: 'm',
  letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
}, {
  base: 'n',
  letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
}, {
  base: 'nj',
  letters: "\u01CC"
}, {
  base: 'o',
  letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
}, {
  base: 'oi',
  letters: "\u01A3"
}, {
  base: 'ou',
  letters: "\u0223"
}, {
  base: 'oo',
  letters: "\uA74F"
}, {
  base: 'p',
  letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
}, {
  base: 'q',
  letters: "q\u24E0\uFF51\u024B\uA757\uA759"
}, {
  base: 'r',
  letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
}, {
  base: 's',
  letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
}, {
  base: 't',
  letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
}, {
  base: 'tz',
  letters: "\uA729"
}, {
  base: 'u',
  letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
}, {
  base: 'v',
  letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
}, {
  base: 'vy',
  letters: "\uA761"
}, {
  base: 'w',
  letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
}, {
  base: 'x',
  letters: "x\u24E7\uFF58\u1E8B\u1E8D"
}, {
  base: 'y',
  letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
}, {
  base: 'z',
  letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
}];
var anyDiacritic = new RegExp('[' + diacritics.map(function (d) {
  return d.letters;
}).join('') + ']', 'g');
var diacriticToBase = {};
for (var i = 0; i < diacritics.length; i++) {
  var diacritic = diacritics[i];
  for (var j = 0; j < diacritic.letters.length; j++) {
    diacriticToBase[diacritic.letters[j]] = diacritic.base;
  }
}
var stripDiacritics = function stripDiacritics(str) {
  return str.replace(anyDiacritic, function (match) {
    return diacriticToBase[match];
  });
};

var memoizedStripDiacriticsForInput = memoizeOne(stripDiacritics);
var trimString = function trimString(str) {
  return str.replace(/^\s+|\s+$/g, '');
};
var defaultStringify = function defaultStringify(option) {
  return "".concat(option.label, " ").concat(option.value);
};
var createFilter = function createFilter(config) {
  return function (option, rawInput) {
    // eslint-disable-next-line no-underscore-dangle
    if (option.data.__isNew__) return true;
    var _ignoreCase$ignoreAcc = _objectSpread2({
        ignoreCase: true,
        ignoreAccents: true,
        stringify: defaultStringify,
        trim: true,
        matchFrom: 'any'
      }, config),
      ignoreCase = _ignoreCase$ignoreAcc.ignoreCase,
      ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents,
      stringify = _ignoreCase$ignoreAcc.stringify,
      trim = _ignoreCase$ignoreAcc.trim,
      matchFrom = _ignoreCase$ignoreAcc.matchFrom;
    var input = trim ? trimString(rawInput) : rawInput;
    var candidate = trim ? trimString(stringify(option)) : stringify(option);
    if (ignoreCase) {
      input = input.toLowerCase();
      candidate = candidate.toLowerCase();
    }
    if (ignoreAccents) {
      input = memoizedStripDiacriticsForInput(input);
      candidate = stripDiacritics(candidate);
    }
    return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
  };
};

var _excluded$2 = ["innerRef"];
function DummyInput(_ref) {
  var innerRef = _ref.innerRef,
    props = _objectWithoutProperties(_ref, _excluded$2);
  // Remove animation props not meant for HTML elements
  var filteredProps = removeProps(props, 'onExited', 'in', 'enter', 'exit', 'appear');
  return jsx("input", _extends({
    ref: innerRef
  }, filteredProps, {
    css: /*#__PURE__*/css$4({
      label: 'dummyInput',
      // get rid of any default styles
      background: 0,
      border: 0,
      // important! this hides the flashing cursor
      caretColor: 'transparent',
      fontSize: 'inherit',
      gridArea: '1 / 1 / 2 / 3',
      outline: 0,
      padding: 0,
      // important! without `width` browsers won't allow focus
      width: 1,
      // remove cursor on desktop
      color: 'transparent',
      // remove cursor on mobile whilst maintaining "scroll into view" behaviour
      left: -100,
      opacity: 0,
      position: 'relative',
      transform: 'scale(.01)'
    }, process.env.NODE_ENV === "production" ? "" : ";label:DummyInput;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkR1bW15SW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXlCTSIsImZpbGUiOiJEdW1teUlucHV0LnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsgSlNYLCBSZWYgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5pbXBvcnQgeyByZW1vdmVQcm9wcyB9IGZyb20gJy4uL3V0aWxzJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gRHVtbXlJbnB1dCh7XG4gIGlubmVyUmVmLFxuICAuLi5wcm9wc1xufTogSlNYLkludHJpbnNpY0VsZW1lbnRzWydpbnB1dCddICYge1xuICByZWFkb25seSBpbm5lclJlZjogUmVmPEhUTUxJbnB1dEVsZW1lbnQ+O1xufSkge1xuICAvLyBSZW1vdmUgYW5pbWF0aW9uIHByb3BzIG5vdCBtZWFudCBmb3IgSFRNTCBlbGVtZW50c1xuICBjb25zdCBmaWx0ZXJlZFByb3BzID0gcmVtb3ZlUHJvcHMoXG4gICAgcHJvcHMsXG4gICAgJ29uRXhpdGVkJyxcbiAgICAnaW4nLFxuICAgICdlbnRlcicsXG4gICAgJ2V4aXQnLFxuICAgICdhcHBlYXInXG4gICk7XG5cbiAgcmV0dXJuIChcbiAgICA8aW5wdXRcbiAgICAgIHJlZj17aW5uZXJSZWZ9XG4gICAgICB7Li4uZmlsdGVyZWRQcm9wc31cbiAgICAgIGNzcz17e1xuICAgICAgICBsYWJlbDogJ2R1bW15SW5wdXQnLFxuICAgICAgICAvLyBnZXQgcmlkIG9mIGFueSBkZWZhdWx0IHN0eWxlc1xuICAgICAgICBiYWNrZ3JvdW5kOiAwLFxuICAgICAgICBib3JkZXI6IDAsXG4gICAgICAgIC8vIGltcG9ydGFudCEgdGhpcyBoaWRlcyB0aGUgZmxhc2hpbmcgY3Vyc29yXG4gICAgICAgIGNhcmV0Q29sb3I6ICd0cmFuc3BhcmVudCcsXG4gICAgICAgIGZvbnRTaXplOiAnaW5oZXJpdCcsXG4gICAgICAgIGdyaWRBcmVhOiAnMSAvIDEgLyAyIC8gMycsXG4gICAgICAgIG91dGxpbmU6IDAsXG4gICAgICAgIHBhZGRpbmc6IDAsXG4gICAgICAgIC8vIGltcG9ydGFudCEgd2l0aG91dCBgd2lkdGhgIGJyb3dzZXJzIHdvbid0IGFsbG93IGZvY3VzXG4gICAgICAgIHdpZHRoOiAxLFxuXG4gICAgICAgIC8vIHJlbW92ZSBjdXJzb3Igb24gZGVza3RvcFxuICAgICAgICBjb2xvcjogJ3RyYW5zcGFyZW50JyxcblxuICAgICAgICAvLyByZW1vdmUgY3Vyc29yIG9uIG1vYmlsZSB3aGlsc3QgbWFpbnRhaW5pbmcgXCJzY3JvbGwgaW50byB2aWV3XCIgYmVoYXZpb3VyXG4gICAgICAgIGxlZnQ6IC0xMDAsXG4gICAgICAgIG9wYWNpdHk6IDAsXG4gICAgICAgIHBvc2l0aW9uOiAncmVsYXRpdmUnLFxuICAgICAgICB0cmFuc2Zvcm06ICdzY2FsZSguMDEpJyxcbiAgICAgIH19XG4gICAgLz5cbiAgKTtcbn1cbiJdfQ== */")
  }));
}

var cancelScroll = function cancelScroll(event) {
  if (event.cancelable) event.preventDefault();
  event.stopPropagation();
};
function useScrollCapture(_ref) {
  var isEnabled = _ref.isEnabled,
    onBottomArrive = _ref.onBottomArrive,
    onBottomLeave = _ref.onBottomLeave,
    onTopArrive = _ref.onTopArrive,
    onTopLeave = _ref.onTopLeave;
  var isBottom = useRef(false);
  var isTop = useRef(false);
  var touchStart = useRef(0);
  var scrollTarget = useRef(null);
  var handleEventDelta = useCallback(function (event, delta) {
    if (scrollTarget.current === null) return;
    var _scrollTarget$current = scrollTarget.current,
      scrollTop = _scrollTarget$current.scrollTop,
      scrollHeight = _scrollTarget$current.scrollHeight,
      clientHeight = _scrollTarget$current.clientHeight;
    var target = scrollTarget.current;
    var isDeltaPositive = delta > 0;
    var availableScroll = scrollHeight - clientHeight - scrollTop;
    var shouldCancelScroll = false;

    // reset bottom/top flags
    if (availableScroll > delta && isBottom.current) {
      if (onBottomLeave) onBottomLeave(event);
      isBottom.current = false;
    }
    if (isDeltaPositive && isTop.current) {
      if (onTopLeave) onTopLeave(event);
      isTop.current = false;
    }

    // bottom limit
    if (isDeltaPositive && delta > availableScroll) {
      if (onBottomArrive && !isBottom.current) {
        onBottomArrive(event);
      }
      target.scrollTop = scrollHeight;
      shouldCancelScroll = true;
      isBottom.current = true;

      // top limit
    } else if (!isDeltaPositive && -delta > scrollTop) {
      if (onTopArrive && !isTop.current) {
        onTopArrive(event);
      }
      target.scrollTop = 0;
      shouldCancelScroll = true;
      isTop.current = true;
    }

    // cancel scroll
    if (shouldCancelScroll) {
      cancelScroll(event);
    }
  }, [onBottomArrive, onBottomLeave, onTopArrive, onTopLeave]);
  var onWheel = useCallback(function (event) {
    handleEventDelta(event, event.deltaY);
  }, [handleEventDelta]);
  var onTouchStart = useCallback(function (event) {
    // set touch start so we can calculate touchmove delta
    touchStart.current = event.changedTouches[0].clientY;
  }, []);
  var onTouchMove = useCallback(function (event) {
    var deltaY = touchStart.current - event.changedTouches[0].clientY;
    handleEventDelta(event, deltaY);
  }, [handleEventDelta]);
  var startListening = useCallback(function (el) {
    // bail early if no element is available to attach to
    if (!el) return;
    var notPassive = supportsPassiveEvents ? {
      passive: false
    } : false;
    el.addEventListener('wheel', onWheel, notPassive);
    el.addEventListener('touchstart', onTouchStart, notPassive);
    el.addEventListener('touchmove', onTouchMove, notPassive);
  }, [onTouchMove, onTouchStart, onWheel]);
  var stopListening = useCallback(function (el) {
    // bail early if no element is available to detach from
    if (!el) return;
    el.removeEventListener('wheel', onWheel, false);
    el.removeEventListener('touchstart', onTouchStart, false);
    el.removeEventListener('touchmove', onTouchMove, false);
  }, [onTouchMove, onTouchStart, onWheel]);
  useEffect(function () {
    if (!isEnabled) return;
    var element = scrollTarget.current;
    startListening(element);
    return function () {
      stopListening(element);
    };
  }, [isEnabled, startListening, stopListening]);
  return function (element) {
    scrollTarget.current = element;
  };
}

var STYLE_KEYS = ['boxSizing', 'height', 'overflow', 'paddingRight', 'position'];
var LOCK_STYLES = {
  boxSizing: 'border-box',
  // account for possible declaration `width: 100%;` on body
  overflow: 'hidden',
  position: 'relative',
  height: '100%'
};
function preventTouchMove(e) {
  if (e.cancelable) e.preventDefault();
}
function allowTouchMove(e) {
  e.stopPropagation();
}
function preventInertiaScroll() {
  var top = this.scrollTop;
  var totalScroll = this.scrollHeight;
  var currentScroll = top + this.offsetHeight;
  if (top === 0) {
    this.scrollTop = 1;
  } else if (currentScroll === totalScroll) {
    this.scrollTop = top - 1;
  }
}

// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function isTouchDevice() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var activeScrollLocks = 0;
var listenerOptions = {
  capture: false,
  passive: false
};
function useScrollLock(_ref) {
  var isEnabled = _ref.isEnabled,
    _ref$accountForScroll = _ref.accountForScrollbars,
    accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
  var originalStyles = useRef({});
  var scrollTarget = useRef(null);
  var addScrollLock = useCallback(function (touchScrollTarget) {
    if (!canUseDOM) return;
    var target = document.body;
    var targetStyle = target && target.style;
    if (accountForScrollbars) {
      // store any styles already applied to the body
      STYLE_KEYS.forEach(function (key) {
        var val = targetStyle && targetStyle[key];
        originalStyles.current[key] = val;
      });
    }

    // apply the lock styles and padding if this is the first scroll lock
    if (accountForScrollbars && activeScrollLocks < 1) {
      var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
      var clientWidth = document.body ? document.body.clientWidth : 0;
      var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
      Object.keys(LOCK_STYLES).forEach(function (key) {
        var val = LOCK_STYLES[key];
        if (targetStyle) {
          targetStyle[key] = val;
        }
      });
      if (targetStyle) {
        targetStyle.paddingRight = "".concat(adjustedPadding, "px");
      }
    }

    // account for touch devices
    if (target && isTouchDevice()) {
      // Mobile Safari ignores { overflow: hidden } declaration on the body.
      target.addEventListener('touchmove', preventTouchMove, listenerOptions);

      // Allow scroll on provided target
      if (touchScrollTarget) {
        touchScrollTarget.addEventListener('touchstart', preventInertiaScroll, listenerOptions);
        touchScrollTarget.addEventListener('touchmove', allowTouchMove, listenerOptions);
      }
    }

    // increment active scroll locks
    activeScrollLocks += 1;
  }, [accountForScrollbars]);
  var removeScrollLock = useCallback(function (touchScrollTarget) {
    if (!canUseDOM) return;
    var target = document.body;
    var targetStyle = target && target.style;

    // safely decrement active scroll locks
    activeScrollLocks = Math.max(activeScrollLocks - 1, 0);

    // reapply original body styles, if any
    if (accountForScrollbars && activeScrollLocks < 1) {
      STYLE_KEYS.forEach(function (key) {
        var val = originalStyles.current[key];
        if (targetStyle) {
          targetStyle[key] = val;
        }
      });
    }

    // remove touch listeners
    if (target && isTouchDevice()) {
      target.removeEventListener('touchmove', preventTouchMove, listenerOptions);
      if (touchScrollTarget) {
        touchScrollTarget.removeEventListener('touchstart', preventInertiaScroll, listenerOptions);
        touchScrollTarget.removeEventListener('touchmove', allowTouchMove, listenerOptions);
      }
    }
  }, [accountForScrollbars]);
  useEffect(function () {
    if (!isEnabled) return;
    var element = scrollTarget.current;
    addScrollLock(element);
    return function () {
      removeScrollLock(element);
    };
  }, [isEnabled, addScrollLock, removeScrollLock]);
  return function (element) {
    scrollTarget.current = element;
  };
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$1() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var blurSelectInput = function blurSelectInput(event) {
  var element = event.target;
  return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
var _ref2$1 = process.env.NODE_ENV === "production" ? {
  name: "1kfdb0e",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0"
} : {
  name: "bp8cua-ScrollManager",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0;label:ScrollManager;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1
};
function ScrollManager(_ref) {
  var children = _ref.children,
    lockEnabled = _ref.lockEnabled,
    _ref$captureEnabled = _ref.captureEnabled,
    captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled,
    onBottomArrive = _ref.onBottomArrive,
    onBottomLeave = _ref.onBottomLeave,
    onTopArrive = _ref.onTopArrive,
    onTopLeave = _ref.onTopLeave;
  var setScrollCaptureTarget = useScrollCapture({
    isEnabled: captureEnabled,
    onBottomArrive: onBottomArrive,
    onBottomLeave: onBottomLeave,
    onTopArrive: onTopArrive,
    onTopLeave: onTopLeave
  });
  var setScrollLockTarget = useScrollLock({
    isEnabled: lockEnabled
  });
  var targetRef = function targetRef(element) {
    setScrollCaptureTarget(element);
    setScrollLockTarget(element);
  };
  return jsx(Fragment, null, lockEnabled && jsx("div", {
    onClick: blurSelectInput,
    css: _ref2$1
  }), children(targetRef));
}

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "1a0ro4n-requiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
} : {
  name: "5kkxb2-requiredInput-RequiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%;label:RequiredInput;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlJlcXVpcmVkSW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWNJIiwiZmlsZSI6IlJlcXVpcmVkSW5wdXQudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiLyoqIEBqc3gganN4ICovXG5pbXBvcnQgeyBGb2N1c0V2ZW50SGFuZGxlciwgRnVuY3Rpb25Db21wb25lbnQgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5cbmNvbnN0IFJlcXVpcmVkSW5wdXQ6IEZ1bmN0aW9uQ29tcG9uZW50PHtcbiAgcmVhZG9ubHkgbmFtZT86IHN0cmluZztcbiAgcmVhZG9ubHkgb25Gb2N1czogRm9jdXNFdmVudEhhbmRsZXI8SFRNTElucHV0RWxlbWVudD47XG59PiA9ICh7IG5hbWUsIG9uRm9jdXMgfSkgPT4gKFxuICA8aW5wdXRcbiAgICByZXF1aXJlZFxuICAgIG5hbWU9e25hbWV9XG4gICAgdGFiSW5kZXg9ey0xfVxuICAgIGFyaWEtaGlkZGVuPVwidHJ1ZVwiXG4gICAgb25Gb2N1cz17b25Gb2N1c31cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAncmVxdWlyZWRJbnB1dCcsXG4gICAgICBvcGFjaXR5OiAwLFxuICAgICAgcG9pbnRlckV2ZW50czogJ25vbmUnLFxuICAgICAgcG9zaXRpb246ICdhYnNvbHV0ZScsXG4gICAgICBib3R0b206IDAsXG4gICAgICBsZWZ0OiAwLFxuICAgICAgcmlnaHQ6IDAsXG4gICAgICB3aWR0aDogJzEwMCUnLFxuICAgIH19XG4gICAgLy8gUHJldmVudCBgU3dpdGNoaW5nIGZyb20gdW5jb250cm9sbGVkIHRvIGNvbnRyb2xsZWRgIGVycm9yXG4gICAgdmFsdWU9XCJcIlxuICAgIG9uQ2hhbmdlPXsoKSA9PiB7fX1cbiAgLz5cbik7XG5cbmV4cG9ydCBkZWZhdWx0IFJlcXVpcmVkSW5wdXQ7XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var RequiredInput = function RequiredInput(_ref) {
  var name = _ref.name,
    onFocus = _ref.onFocus;
  return jsx("input", {
    required: true,
    name: name,
    tabIndex: -1,
    "aria-hidden": "true",
    onFocus: onFocus,
    css: _ref2
    // Prevent `Switching from uncontrolled to controlled` error
    ,
    value: "",
    onChange: function onChange() {}
  });
};
var RequiredInput$1 = RequiredInput;

/// <reference types="user-agent-data-types" />

function testPlatform(re) {
  var _window$navigator$use;
  return typeof window !== 'undefined' && window.navigator != null ? re.test(((_window$navigator$use = window.navigator['userAgentData']) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.platform) || window.navigator.platform) : false;
}
function isIPhone() {
  return testPlatform(/^iPhone/i);
}
function isMac() {
  return testPlatform(/^Mac/i);
}
function isIPad() {
  return testPlatform(/^iPad/i) ||
  // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  isMac() && navigator.maxTouchPoints > 1;
}
function isIOS() {
  return isIPhone() || isIPad();
}
function isAppleDevice() {
  return isMac() || isIOS();
}

var formatGroupLabel = function formatGroupLabel(group) {
  return group.label;
};
var getOptionLabel$1 = function getOptionLabel(option) {
  return option.label;
};
var getOptionValue$1 = function getOptionValue(option) {
  return option.value;
};
var isOptionDisabled = function isOptionDisabled(option) {
  return !!option.isDisabled;
};

var defaultStyles = {
  clearIndicator: clearIndicatorCSS,
  container: containerCSS,
  control: css$1,
  dropdownIndicator: dropdownIndicatorCSS,
  group: groupCSS,
  groupHeading: groupHeadingCSS,
  indicatorsContainer: indicatorsContainerCSS,
  indicatorSeparator: indicatorSeparatorCSS,
  input: inputCSS,
  loadingIndicator: loadingIndicatorCSS,
  loadingMessage: loadingMessageCSS,
  menu: menuCSS,
  menuList: menuListCSS,
  menuPortal: menuPortalCSS,
  multiValue: multiValueCSS,
  multiValueLabel: multiValueLabelCSS,
  multiValueRemove: multiValueRemoveCSS,
  noOptionsMessage: noOptionsMessageCSS,
  option: optionCSS,
  placeholder: placeholderCSS,
  singleValue: css,
  valueContainer: valueContainerCSS
};

var colors = {
  primary: '#2684FF',
  primary75: '#4C9AFF',
  primary50: '#B2D4FF',
  primary25: '#DEEBFF',
  danger: '#DE350B',
  dangerLight: '#FFBDAD',
  neutral0: 'hsl(0, 0%, 100%)',
  neutral5: 'hsl(0, 0%, 95%)',
  neutral10: 'hsl(0, 0%, 90%)',
  neutral20: 'hsl(0, 0%, 80%)',
  neutral30: 'hsl(0, 0%, 70%)',
  neutral40: 'hsl(0, 0%, 60%)',
  neutral50: 'hsl(0, 0%, 50%)',
  neutral60: 'hsl(0, 0%, 40%)',
  neutral70: 'hsl(0, 0%, 30%)',
  neutral80: 'hsl(0, 0%, 20%)',
  neutral90: 'hsl(0, 0%, 10%)'
};
var borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var baseUnit = 4;
// The minimum height of the control
var controlHeight = 38;
// The amount of space between the control and menu */
var menuGutter = baseUnit * 2;
var spacing = {
  baseUnit: baseUnit,
  controlHeight: controlHeight,
  menuGutter: menuGutter
};
var defaultTheme = {
  borderRadius: borderRadius,
  colors: colors,
  spacing: spacing
};

var defaultProps = {
  'aria-live': 'polite',
  backspaceRemovesValue: true,
  blurInputOnSelect: isTouchCapable(),
  captureMenuScroll: !isTouchCapable(),
  classNames: {},
  closeMenuOnSelect: true,
  closeMenuOnScroll: false,
  components: {},
  controlShouldRenderValue: true,
  escapeClearsValue: false,
  filterOption: createFilter(),
  formatGroupLabel: formatGroupLabel,
  getOptionLabel: getOptionLabel$1,
  getOptionValue: getOptionValue$1,
  isDisabled: false,
  isLoading: false,
  isMulti: false,
  isRtl: false,
  isSearchable: true,
  isOptionDisabled: isOptionDisabled,
  loadingMessage: function loadingMessage() {
    return 'Loading...';
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: false,
  menuPlacement: 'bottom',
  menuPosition: 'absolute',
  menuShouldBlockScroll: false,
  menuShouldScrollIntoView: !isMobileDevice(),
  noOptionsMessage: function noOptionsMessage() {
    return 'No options';
  },
  openMenuOnFocus: false,
  openMenuOnClick: true,
  options: [],
  pageSize: 5,
  placeholder: 'Select...',
  screenReaderStatus: function screenReaderStatus(_ref) {
    var count = _ref.count;
    return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
  },
  styles: {},
  tabIndex: 0,
  tabSelectsValue: true,
  unstyled: false
};
function toCategorizedOption(props, option, selectValue, index) {
  var isDisabled = _isOptionDisabled(props, option, selectValue);
  var isSelected = _isOptionSelected(props, option, selectValue);
  var label = getOptionLabel(props, option);
  var value = getOptionValue(props, option);
  return {
    type: 'option',
    data: option,
    isDisabled: isDisabled,
    isSelected: isSelected,
    label: label,
    value: value,
    index: index
  };
}
function buildCategorizedOptions(props, selectValue) {
  return props.options.map(function (groupOrOption, groupOrOptionIndex) {
    if ('options' in groupOrOption) {
      var categorizedOptions = groupOrOption.options.map(function (option, optionIndex) {
        return toCategorizedOption(props, option, selectValue, optionIndex);
      }).filter(function (categorizedOption) {
        return isFocusable(props, categorizedOption);
      });
      return categorizedOptions.length > 0 ? {
        type: 'group',
        data: groupOrOption,
        options: categorizedOptions,
        index: groupOrOptionIndex
      } : undefined;
    }
    var categorizedOption = toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
    return isFocusable(props, categorizedOption) ? categorizedOption : undefined;
  }).filter(notNullish);
}
function buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
  return categorizedOptions.reduce(function (optionsAccumulator, categorizedOption) {
    if (categorizedOption.type === 'group') {
      optionsAccumulator.push.apply(optionsAccumulator, _toConsumableArray(categorizedOption.options.map(function (option) {
        return option.data;
      })));
    } else {
      optionsAccumulator.push(categorizedOption.data);
    }
    return optionsAccumulator;
  }, []);
}
function buildFocusableOptionsWithIds(categorizedOptions, optionId) {
  return categorizedOptions.reduce(function (optionsAccumulator, categorizedOption) {
    if (categorizedOption.type === 'group') {
      optionsAccumulator.push.apply(optionsAccumulator, _toConsumableArray(categorizedOption.options.map(function (option) {
        return {
          data: option.data,
          id: "".concat(optionId, "-").concat(categorizedOption.index, "-").concat(option.index)
        };
      })));
    } else {
      optionsAccumulator.push({
        data: categorizedOption.data,
        id: "".concat(optionId, "-").concat(categorizedOption.index)
      });
    }
    return optionsAccumulator;
  }, []);
}
function buildFocusableOptions(props, selectValue) {
  return buildFocusableOptionsFromCategorizedOptions(buildCategorizedOptions(props, selectValue));
}
function isFocusable(props, categorizedOption) {
  var _props$inputValue = props.inputValue,
    inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
  var data = categorizedOption.data,
    isSelected = categorizedOption.isSelected,
    label = categorizedOption.label,
    value = categorizedOption.value;
  return (!shouldHideSelectedOptions(props) || !isSelected) && _filterOption(props, {
    label: label,
    value: value,
    data: data
  }, inputValue);
}
function getNextFocusedValue(state, nextSelectValue) {
  var focusedValue = state.focusedValue,
    lastSelectValue = state.selectValue;
  var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
  if (lastFocusedIndex > -1) {
    var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
    if (nextFocusedIndex > -1) {
      // the focused value is still in the selectValue, return it
      return focusedValue;
    } else if (lastFocusedIndex < nextSelectValue.length) {
      // the focusedValue is not present in the next selectValue array by
      // reference, so return the new value at the same index
      return nextSelectValue[lastFocusedIndex];
    }
  }
  return null;
}
function getNextFocusedOption(state, options) {
  var lastFocusedOption = state.focusedOption;
  return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var getFocusedOptionId = function getFocusedOptionId(focusableOptionsWithIds, focusedOption) {
  var _focusableOptionsWith;
  var focusedOptionId = (_focusableOptionsWith = focusableOptionsWithIds.find(function (option) {
    return option.data === focusedOption;
  })) === null || _focusableOptionsWith === void 0 ? void 0 : _focusableOptionsWith.id;
  return focusedOptionId || null;
};
var getOptionLabel = function getOptionLabel(props, data) {
  return props.getOptionLabel(data);
};
var getOptionValue = function getOptionValue(props, data) {
  return props.getOptionValue(data);
};
function _isOptionDisabled(props, option, selectValue) {
  return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function _isOptionSelected(props, option, selectValue) {
  if (selectValue.indexOf(option) > -1) return true;
  if (typeof props.isOptionSelected === 'function') {
    return props.isOptionSelected(option, selectValue);
  }
  var candidate = getOptionValue(props, option);
  return selectValue.some(function (i) {
    return getOptionValue(props, i) === candidate;
  });
}
function _filterOption(props, option, inputValue) {
  return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
  var hideSelectedOptions = props.hideSelectedOptions,
    isMulti = props.isMulti;
  if (hideSelectedOptions === undefined) return isMulti;
  return hideSelectedOptions;
};
var instanceId = 1;
var Select = /*#__PURE__*/function (_Component) {
  _inherits(Select, _Component);
  var _super = _createSuper(Select);
  // Misc. Instance Properties
  // ------------------------------

  // TODO

  // Refs
  // ------------------------------

  // Lifecycle
  // ------------------------------

  function Select(_props) {
    var _this;
    _classCallCheck(this, Select);
    _this = _super.call(this, _props);
    _this.state = {
      ariaSelection: null,
      focusedOption: null,
      focusedOptionId: null,
      focusableOptionsWithIds: [],
      focusedValue: null,
      inputIsHidden: false,
      isFocused: false,
      selectValue: [],
      clearFocusValueOnUpdate: false,
      prevWasFocused: false,
      inputIsHiddenAfterUpdate: undefined,
      prevProps: undefined,
      instancePrefix: ''
    };
    _this.blockOptionHover = false;
    _this.isComposing = false;
    _this.commonProps = void 0;
    _this.initialTouchX = 0;
    _this.initialTouchY = 0;
    _this.openAfterFocus = false;
    _this.scrollToFocusedOptionOnUpdate = false;
    _this.userIsDragging = void 0;
    _this.isAppleDevice = isAppleDevice();
    _this.controlRef = null;
    _this.getControlRef = function (ref) {
      _this.controlRef = ref;
    };
    _this.focusedOptionRef = null;
    _this.getFocusedOptionRef = function (ref) {
      _this.focusedOptionRef = ref;
    };
    _this.menuListRef = null;
    _this.getMenuListRef = function (ref) {
      _this.menuListRef = ref;
    };
    _this.inputRef = null;
    _this.getInputRef = function (ref) {
      _this.inputRef = ref;
    };
    _this.focus = _this.focusInput;
    _this.blur = _this.blurInput;
    _this.onChange = function (newValue, actionMeta) {
      var _this$props = _this.props,
        onChange = _this$props.onChange,
        name = _this$props.name;
      actionMeta.name = name;
      _this.ariaOnChange(newValue, actionMeta);
      onChange(newValue, actionMeta);
    };
    _this.setValue = function (newValue, action, option) {
      var _this$props2 = _this.props,
        closeMenuOnSelect = _this$props2.closeMenuOnSelect,
        isMulti = _this$props2.isMulti,
        inputValue = _this$props2.inputValue;
      _this.onInputChange('', {
        action: 'set-value',
        prevInputValue: inputValue
      });
      if (closeMenuOnSelect) {
        _this.setState({
          inputIsHiddenAfterUpdate: !isMulti
        });
        _this.onMenuClose();
      }
      // when the select value should change, we should reset focusedValue
      _this.setState({
        clearFocusValueOnUpdate: true
      });
      _this.onChange(newValue, {
        action: action,
        option: option
      });
    };
    _this.selectOption = function (newValue) {
      var _this$props3 = _this.props,
        blurInputOnSelect = _this$props3.blurInputOnSelect,
        isMulti = _this$props3.isMulti,
        name = _this$props3.name;
      var selectValue = _this.state.selectValue;
      var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
      var isDisabled = _this.isOptionDisabled(newValue, selectValue);
      if (deselected) {
        var candidate = _this.getOptionValue(newValue);
        _this.setValue(multiValueAsValue(selectValue.filter(function (i) {
          return _this.getOptionValue(i) !== candidate;
        })), 'deselect-option', newValue);
      } else if (!isDisabled) {
        // Select option if option is not disabled
        if (isMulti) {
          _this.setValue(multiValueAsValue([].concat(_toConsumableArray(selectValue), [newValue])), 'select-option', newValue);
        } else {
          _this.setValue(singleValueAsValue(newValue), 'select-option');
        }
      } else {
        _this.ariaOnChange(singleValueAsValue(newValue), {
          action: 'select-option',
          option: newValue,
          name: name
        });
        return;
      }
      if (blurInputOnSelect) {
        _this.blurInput();
      }
    };
    _this.removeValue = function (removedValue) {
      var isMulti = _this.props.isMulti;
      var selectValue = _this.state.selectValue;
      var candidate = _this.getOptionValue(removedValue);
      var newValueArray = selectValue.filter(function (i) {
        return _this.getOptionValue(i) !== candidate;
      });
      var newValue = valueTernary(isMulti, newValueArray, newValueArray[0] || null);
      _this.onChange(newValue, {
        action: 'remove-value',
        removedValue: removedValue
      });
      _this.focusInput();
    };
    _this.clearValue = function () {
      var selectValue = _this.state.selectValue;
      _this.onChange(valueTernary(_this.props.isMulti, [], null), {
        action: 'clear',
        removedValues: selectValue
      });
    };
    _this.popValue = function () {
      var isMulti = _this.props.isMulti;
      var selectValue = _this.state.selectValue;
      var lastSelectedValue = selectValue[selectValue.length - 1];
      var newValueArray = selectValue.slice(0, selectValue.length - 1);
      var newValue = valueTernary(isMulti, newValueArray, newValueArray[0] || null);
      if (lastSelectedValue) {
        _this.onChange(newValue, {
          action: 'pop-value',
          removedValue: lastSelectedValue
        });
      }
    };
    _this.getFocusedOptionId = function (focusedOption) {
      return getFocusedOptionId(_this.state.focusableOptionsWithIds, focusedOption);
    };
    _this.getFocusableOptionsWithIds = function () {
      return buildFocusableOptionsWithIds(buildCategorizedOptions(_this.props, _this.state.selectValue), _this.getElementId('option'));
    };
    _this.getValue = function () {
      return _this.state.selectValue;
    };
    _this.cx = function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return classNames.apply(void 0, [_this.props.classNamePrefix].concat(args));
    };
    _this.getOptionLabel = function (data) {
      return getOptionLabel(_this.props, data);
    };
    _this.getOptionValue = function (data) {
      return getOptionValue(_this.props, data);
    };
    _this.getStyles = function (key, props) {
      var unstyled = _this.props.unstyled;
      var base = defaultStyles[key](props, unstyled);
      base.boxSizing = 'border-box';
      var custom = _this.props.styles[key];
      return custom ? custom(base, props) : base;
    };
    _this.getClassNames = function (key, props) {
      var _this$props$className, _this$props$className2;
      return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
    };
    _this.getElementId = function (element) {
      return "".concat(_this.state.instancePrefix, "-").concat(element);
    };
    _this.getComponents = function () {
      return defaultComponents(_this.props);
    };
    _this.buildCategorizedOptions = function () {
      return buildCategorizedOptions(_this.props, _this.state.selectValue);
    };
    _this.getCategorizedOptions = function () {
      return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
    };
    _this.buildFocusableOptions = function () {
      return buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
    };
    _this.getFocusableOptions = function () {
      return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
    };
    _this.ariaOnChange = function (value, actionMeta) {
      _this.setState({
        ariaSelection: _objectSpread2({
          value: value
        }, actionMeta)
      });
    };
    _this.onMenuMouseDown = function (event) {
      if (event.button !== 0) {
        return;
      }
      event.stopPropagation();
      event.preventDefault();
      _this.focusInput();
    };
    _this.onMenuMouseMove = function (event) {
      _this.blockOptionHover = false;
    };
    _this.onControlMouseDown = function (event) {
      // Event captured by dropdown indicator
      if (event.defaultPrevented) {
        return;
      }
      var openMenuOnClick = _this.props.openMenuOnClick;
      if (!_this.state.isFocused) {
        if (openMenuOnClick) {
          _this.openAfterFocus = true;
        }
        _this.focusInput();
      } else if (!_this.props.menuIsOpen) {
        if (openMenuOnClick) {
          _this.openMenu('first');
        }
      } else {
        if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') {
          _this.onMenuClose();
        }
      }
      if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') {
        event.preventDefault();
      }
    };
    _this.onDropdownIndicatorMouseDown = function (event) {
      // ignore mouse events that weren't triggered by the primary button
      if (event && event.type === 'mousedown' && event.button !== 0) {
        return;
      }
      if (_this.props.isDisabled) return;
      var _this$props4 = _this.props,
        isMulti = _this$props4.isMulti,
        menuIsOpen = _this$props4.menuIsOpen;
      _this.focusInput();
      if (menuIsOpen) {
        _this.setState({
          inputIsHiddenAfterUpdate: !isMulti
        });
        _this.onMenuClose();
      } else {
        _this.openMenu('first');
      }
      event.preventDefault();
    };
    _this.onClearIndicatorMouseDown = function (event) {
      // ignore mouse events that weren't triggered by the primary button
      if (event && event.type === 'mousedown' && event.button !== 0) {
        return;
      }
      _this.clearValue();
      event.preventDefault();
      _this.openAfterFocus = false;
      if (event.type === 'touchend') {
        _this.focusInput();
      } else {
        setTimeout(function () {
          return _this.focusInput();
        });
      }
    };
    _this.onScroll = function (event) {
      if (typeof _this.props.closeMenuOnScroll === 'boolean') {
        if (event.target instanceof HTMLElement && isDocumentElement(event.target)) {
          _this.props.onMenuClose();
        }
      } else if (typeof _this.props.closeMenuOnScroll === 'function') {
        if (_this.props.closeMenuOnScroll(event)) {
          _this.props.onMenuClose();
        }
      }
    };
    _this.onCompositionStart = function () {
      _this.isComposing = true;
    };
    _this.onCompositionEnd = function () {
      _this.isComposing = false;
    };
    _this.onTouchStart = function (_ref2) {
      var touches = _ref2.touches;
      var touch = touches && touches.item(0);
      if (!touch) {
        return;
      }
      _this.initialTouchX = touch.clientX;
      _this.initialTouchY = touch.clientY;
      _this.userIsDragging = false;
    };
    _this.onTouchMove = function (_ref3) {
      var touches = _ref3.touches;
      var touch = touches && touches.item(0);
      if (!touch) {
        return;
      }
      var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
      var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
      var moveThreshold = 5;
      _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
    };
    _this.onTouchEnd = function (event) {
      if (_this.userIsDragging) return;

      // close the menu if the user taps outside
      // we're checking on event.target here instead of event.currentTarget, because we want to assert information
      // on events on child elements, not the document (which we've attached this handler to).
      if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) {
        _this.blurInput();
      }

      // reset move vars
      _this.initialTouchX = 0;
      _this.initialTouchY = 0;
    };
    _this.onControlTouchEnd = function (event) {
      if (_this.userIsDragging) return;
      _this.onControlMouseDown(event);
    };
    _this.onClearIndicatorTouchEnd = function (event) {
      if (_this.userIsDragging) return;
      _this.onClearIndicatorMouseDown(event);
    };
    _this.onDropdownIndicatorTouchEnd = function (event) {
      if (_this.userIsDragging) return;
      _this.onDropdownIndicatorMouseDown(event);
    };
    _this.handleInputChange = function (event) {
      var prevInputValue = _this.props.inputValue;
      var inputValue = event.currentTarget.value;
      _this.setState({
        inputIsHiddenAfterUpdate: false
      });
      _this.onInputChange(inputValue, {
        action: 'input-change',
        prevInputValue: prevInputValue
      });
      if (!_this.props.menuIsOpen) {
        _this.onMenuOpen();
      }
    };
    _this.onInputFocus = function (event) {
      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
      _this.setState({
        inputIsHiddenAfterUpdate: false,
        isFocused: true
      });
      if (_this.openAfterFocus || _this.props.openMenuOnFocus) {
        _this.openMenu('first');
      }
      _this.openAfterFocus = false;
    };
    _this.onInputBlur = function (event) {
      var prevInputValue = _this.props.inputValue;
      if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
        _this.inputRef.focus();
        return;
      }
      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
      _this.onInputChange('', {
        action: 'input-blur',
        prevInputValue: prevInputValue
      });
      _this.onMenuClose();
      _this.setState({
        focusedValue: null,
        isFocused: false
      });
    };
    _this.onOptionHover = function (focusedOption) {
      if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) {
        return;
      }
      var options = _this.getFocusableOptions();
      var focusedOptionIndex = options.indexOf(focusedOption);
      _this.setState({
        focusedOption: focusedOption,
        focusedOptionId: focusedOptionIndex > -1 ? _this.getFocusedOptionId(focusedOption) : null
      });
    };
    _this.shouldHideSelectedOptions = function () {
      return shouldHideSelectedOptions(_this.props);
    };
    _this.onValueInputFocus = function (e) {
      e.preventDefault();
      e.stopPropagation();
      _this.focus();
    };
    _this.onKeyDown = function (event) {
      var _this$props5 = _this.props,
        isMulti = _this$props5.isMulti,
        backspaceRemovesValue = _this$props5.backspaceRemovesValue,
        escapeClearsValue = _this$props5.escapeClearsValue,
        inputValue = _this$props5.inputValue,
        isClearable = _this$props5.isClearable,
        isDisabled = _this$props5.isDisabled,
        menuIsOpen = _this$props5.menuIsOpen,
        onKeyDown = _this$props5.onKeyDown,
        tabSelectsValue = _this$props5.tabSelectsValue,
        openMenuOnFocus = _this$props5.openMenuOnFocus;
      var _this$state = _this.state,
        focusedOption = _this$state.focusedOption,
        focusedValue = _this$state.focusedValue,
        selectValue = _this$state.selectValue;
      if (isDisabled) return;
      if (typeof onKeyDown === 'function') {
        onKeyDown(event);
        if (event.defaultPrevented) {
          return;
        }
      }

      // Block option hover events when the user has just pressed a key
      _this.blockOptionHover = true;
      switch (event.key) {
        case 'ArrowLeft':
          if (!isMulti || inputValue) return;
          _this.focusValue('previous');
          break;
        case 'ArrowRight':
          if (!isMulti || inputValue) return;
          _this.focusValue('next');
          break;
        case 'Delete':
        case 'Backspace':
          if (inputValue) return;
          if (focusedValue) {
            _this.removeValue(focusedValue);
          } else {
            if (!backspaceRemovesValue) return;
            if (isMulti) {
              _this.popValue();
            } else if (isClearable) {
              _this.clearValue();
            }
          }
          break;
        case 'Tab':
          if (_this.isComposing) return;
          if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption ||
          // don't capture the event if the menu opens on focus and the focused
          // option is already selected; it breaks the flow of navigation
          openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) {
            return;
          }
          _this.selectOption(focusedOption);
          break;
        case 'Enter':
          if (event.keyCode === 229) {
            // ignore the keydown event from an Input Method Editor(IME)
            // ref. https://www.w3.org/TR/uievents/#determine-keydown-keyup-keyCode
            break;
          }
          if (menuIsOpen) {
            if (!focusedOption) return;
            if (_this.isComposing) return;
            _this.selectOption(focusedOption);
            break;
          }
          return;
        case 'Escape':
          if (menuIsOpen) {
            _this.setState({
              inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange('', {
              action: 'menu-close',
              prevInputValue: inputValue
            });
            _this.onMenuClose();
          } else if (isClearable && escapeClearsValue) {
            _this.clearValue();
          }
          break;
        case ' ':
          // space
          if (inputValue) {
            return;
          }
          if (!menuIsOpen) {
            _this.openMenu('first');
            break;
          }
          if (!focusedOption) return;
          _this.selectOption(focusedOption);
          break;
        case 'ArrowUp':
          if (menuIsOpen) {
            _this.focusOption('up');
          } else {
            _this.openMenu('last');
          }
          break;
        case 'ArrowDown':
          if (menuIsOpen) {
            _this.focusOption('down');
          } else {
            _this.openMenu('first');
          }
          break;
        case 'PageUp':
          if (!menuIsOpen) return;
          _this.focusOption('pageup');
          break;
        case 'PageDown':
          if (!menuIsOpen) return;
          _this.focusOption('pagedown');
          break;
        case 'Home':
          if (!menuIsOpen) return;
          _this.focusOption('first');
          break;
        case 'End':
          if (!menuIsOpen) return;
          _this.focusOption('last');
          break;
        default:
          return;
      }
      event.preventDefault();
    };
    _this.state.instancePrefix = 'react-select-' + (_this.props.instanceId || ++instanceId);
    _this.state.selectValue = cleanValue(_props.value);
    // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
    if (_props.menuIsOpen && _this.state.selectValue.length) {
      var focusableOptionsWithIds = _this.getFocusableOptionsWithIds();
      var focusableOptions = _this.buildFocusableOptions();
      var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
      _this.state.focusableOptionsWithIds = focusableOptionsWithIds;
      _this.state.focusedOption = focusableOptions[optionIndex];
      _this.state.focusedOptionId = getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
    }
    return _this;
  }
  _createClass(Select, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startListeningComposition();
      this.startListeningToTouch();
      if (this.props.closeMenuOnScroll && document && document.addEventListener) {
        // Listen to all scroll events, and filter them out inside of 'onScroll'
        document.addEventListener('scroll', this.onScroll, true);
      }
      if (this.props.autoFocus) {
        this.focusInput();
      }

      // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
      if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) {
        scrollIntoView(this.menuListRef, this.focusedOptionRef);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props6 = this.props,
        isDisabled = _this$props6.isDisabled,
        menuIsOpen = _this$props6.menuIsOpen;
      var isFocused = this.state.isFocused;
      if (
      // ensure focus is restored correctly when the control becomes enabled
      isFocused && !isDisabled && prevProps.isDisabled ||
      // ensure focus is on the Input when the menu opens
      isFocused && menuIsOpen && !prevProps.menuIsOpen) {
        this.focusInput();
      }
      if (isFocused && isDisabled && !prevProps.isDisabled) {
        // ensure select state gets blurred in case Select is programmatically disabled while focused
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          isFocused: false
        }, this.onMenuClose);
      } else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) {
        // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          isFocused: true
        });
      }

      // scroll the focused option into view if necessary
      if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
        scrollIntoView(this.menuListRef, this.focusedOptionRef);
        this.scrollToFocusedOptionOnUpdate = false;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopListeningComposition();
      this.stopListeningToTouch();
      document.removeEventListener('scroll', this.onScroll, true);
    }

    // ==============================
    // Consumer Handlers
    // ==============================
  }, {
    key: "onMenuOpen",
    value: function onMenuOpen() {
      this.props.onMenuOpen();
    }
  }, {
    key: "onMenuClose",
    value: function onMenuClose() {
      this.onInputChange('', {
        action: 'menu-close',
        prevInputValue: this.props.inputValue
      });
      this.props.onMenuClose();
    }
  }, {
    key: "onInputChange",
    value: function onInputChange(newValue, actionMeta) {
      this.props.onInputChange(newValue, actionMeta);
    }

    // ==============================
    // Methods
    // ==============================
  }, {
    key: "focusInput",
    value: function focusInput() {
      if (!this.inputRef) return;
      this.inputRef.focus();
    }
  }, {
    key: "blurInput",
    value: function blurInput() {
      if (!this.inputRef) return;
      this.inputRef.blur();
    }

    // aliased for consumers
  }, {
    key: "openMenu",
    value: function openMenu(focusOption) {
      var _this2 = this;
      var _this$state2 = this.state,
        selectValue = _this$state2.selectValue,
        isFocused = _this$state2.isFocused;
      var focusableOptions = this.buildFocusableOptions();
      var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
      if (!this.props.isMulti) {
        var selectedIndex = focusableOptions.indexOf(selectValue[0]);
        if (selectedIndex > -1) {
          openAtIndex = selectedIndex;
        }
      }

      // only scroll if the menu isn't already open
      this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
      this.setState({
        inputIsHiddenAfterUpdate: false,
        focusedValue: null,
        focusedOption: focusableOptions[openAtIndex],
        focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
      }, function () {
        return _this2.onMenuOpen();
      });
    }
  }, {
    key: "focusValue",
    value: function focusValue(direction) {
      var _this$state3 = this.state,
        selectValue = _this$state3.selectValue,
        focusedValue = _this$state3.focusedValue;

      // Only multiselects support value focusing
      if (!this.props.isMulti) return;
      this.setState({
        focusedOption: null
      });
      var focusedIndex = selectValue.indexOf(focusedValue);
      if (!focusedValue) {
        focusedIndex = -1;
      }
      var lastIndex = selectValue.length - 1;
      var nextFocus = -1;
      if (!selectValue.length) return;
      switch (direction) {
        case 'previous':
          if (focusedIndex === 0) {
            // don't cycle from the start to the end
            nextFocus = 0;
          } else if (focusedIndex === -1) {
            // if nothing is focused, focus the last value first
            nextFocus = lastIndex;
          } else {
            nextFocus = focusedIndex - 1;
          }
          break;
        case 'next':
          if (focusedIndex > -1 && focusedIndex < lastIndex) {
            nextFocus = focusedIndex + 1;
          }
          break;
      }
      this.setState({
        inputIsHidden: nextFocus !== -1,
        focusedValue: selectValue[nextFocus]
      });
    }
  }, {
    key: "focusOption",
    value: function focusOption() {
      var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
      var pageSize = this.props.pageSize;
      var focusedOption = this.state.focusedOption;
      var options = this.getFocusableOptions();
      if (!options.length) return;
      var nextFocus = 0; // handles 'first'
      var focusedIndex = options.indexOf(focusedOption);
      if (!focusedOption) {
        focusedIndex = -1;
      }
      if (direction === 'up') {
        nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
      } else if (direction === 'down') {
        nextFocus = (focusedIndex + 1) % options.length;
      } else if (direction === 'pageup') {
        nextFocus = focusedIndex - pageSize;
        if (nextFocus < 0) nextFocus = 0;
      } else if (direction === 'pagedown') {
        nextFocus = focusedIndex + pageSize;
        if (nextFocus > options.length - 1) nextFocus = options.length - 1;
      } else if (direction === 'last') {
        nextFocus = options.length - 1;
      }
      this.scrollToFocusedOptionOnUpdate = true;
      this.setState({
        focusedOption: options[nextFocus],
        focusedValue: null,
        focusedOptionId: this.getFocusedOptionId(options[nextFocus])
      });
    }
  }, {
    key: "getTheme",
    value:
    // ==============================
    // Getters
    // ==============================

    function getTheme() {
      // Use the default theme if there are no customisations.
      if (!this.props.theme) {
        return defaultTheme;
      }
      // If the theme prop is a function, assume the function
      // knows how to merge the passed-in default theme with
      // its own modifications.
      if (typeof this.props.theme === 'function') {
        return this.props.theme(defaultTheme);
      }
      // Otherwise, if a plain theme object was passed in,
      // overlay it with the default theme.
      return _objectSpread2(_objectSpread2({}, defaultTheme), this.props.theme);
    }
  }, {
    key: "getCommonProps",
    value: function getCommonProps() {
      var clearValue = this.clearValue,
        cx = this.cx,
        getStyles = this.getStyles,
        getClassNames = this.getClassNames,
        getValue = this.getValue,
        selectOption = this.selectOption,
        setValue = this.setValue,
        props = this.props;
      var isMulti = props.isMulti,
        isRtl = props.isRtl,
        options = props.options;
      var hasValue = this.hasValue();
      return {
        clearValue: clearValue,
        cx: cx,
        getStyles: getStyles,
        getClassNames: getClassNames,
        getValue: getValue,
        hasValue: hasValue,
        isMulti: isMulti,
        isRtl: isRtl,
        options: options,
        selectOption: selectOption,
        selectProps: props,
        setValue: setValue,
        theme: this.getTheme()
      };
    }
  }, {
    key: "hasValue",
    value: function hasValue() {
      var selectValue = this.state.selectValue;
      return selectValue.length > 0;
    }
  }, {
    key: "hasOptions",
    value: function hasOptions() {
      return !!this.getFocusableOptions().length;
    }
  }, {
    key: "isClearable",
    value: function isClearable() {
      var _this$props7 = this.props,
        isClearable = _this$props7.isClearable,
        isMulti = _this$props7.isMulti;

      // single select, by default, IS NOT clearable
      // multi select, by default, IS clearable
      if (isClearable === undefined) return isMulti;
      return isClearable;
    }
  }, {
    key: "isOptionDisabled",
    value: function isOptionDisabled(option, selectValue) {
      return _isOptionDisabled(this.props, option, selectValue);
    }
  }, {
    key: "isOptionSelected",
    value: function isOptionSelected(option, selectValue) {
      return _isOptionSelected(this.props, option, selectValue);
    }
  }, {
    key: "filterOption",
    value: function filterOption(option, inputValue) {
      return _filterOption(this.props, option, inputValue);
    }
  }, {
    key: "formatOptionLabel",
    value: function formatOptionLabel(data, context) {
      if (typeof this.props.formatOptionLabel === 'function') {
        var _inputValue = this.props.inputValue;
        var _selectValue = this.state.selectValue;
        return this.props.formatOptionLabel(data, {
          context: context,
          inputValue: _inputValue,
          selectValue: _selectValue
        });
      } else {
        return this.getOptionLabel(data);
      }
    }
  }, {
    key: "formatGroupLabel",
    value: function formatGroupLabel(data) {
      return this.props.formatGroupLabel(data);
    }

    // ==============================
    // Mouse Handlers
    // ==============================
  }, {
    key: "startListeningComposition",
    value:
    // ==============================
    // Composition Handlers
    // ==============================

    function startListeningComposition() {
      if (document && document.addEventListener) {
        document.addEventListener('compositionstart', this.onCompositionStart, false);
        document.addEventListener('compositionend', this.onCompositionEnd, false);
      }
    }
  }, {
    key: "stopListeningComposition",
    value: function stopListeningComposition() {
      if (document && document.removeEventListener) {
        document.removeEventListener('compositionstart', this.onCompositionStart);
        document.removeEventListener('compositionend', this.onCompositionEnd);
      }
    }
  }, {
    key: "startListeningToTouch",
    value:
    // ==============================
    // Touch Handlers
    // ==============================

    function startListeningToTouch() {
      if (document && document.addEventListener) {
        document.addEventListener('touchstart', this.onTouchStart, false);
        document.addEventListener('touchmove', this.onTouchMove, false);
        document.addEventListener('touchend', this.onTouchEnd, false);
      }
    }
  }, {
    key: "stopListeningToTouch",
    value: function stopListeningToTouch() {
      if (document && document.removeEventListener) {
        document.removeEventListener('touchstart', this.onTouchStart);
        document.removeEventListener('touchmove', this.onTouchMove);
        document.removeEventListener('touchend', this.onTouchEnd);
      }
    }
  }, {
    key: "renderInput",
    value:
    // ==============================
    // Renderers
    // ==============================
    function renderInput() {
      var _this$props8 = this.props,
        isDisabled = _this$props8.isDisabled,
        isSearchable = _this$props8.isSearchable,
        inputId = _this$props8.inputId,
        inputValue = _this$props8.inputValue,
        tabIndex = _this$props8.tabIndex,
        form = _this$props8.form,
        menuIsOpen = _this$props8.menuIsOpen,
        required = _this$props8.required;
      var _this$getComponents = this.getComponents(),
        Input = _this$getComponents.Input;
      var _this$state4 = this.state,
        inputIsHidden = _this$state4.inputIsHidden,
        ariaSelection = _this$state4.ariaSelection;
      var commonProps = this.commonProps;
      var id = inputId || this.getElementId('input');

      // aria attributes makes the JSX "noisy", separated for clarity
      var ariaAttributes = _objectSpread2(_objectSpread2(_objectSpread2({
        'aria-autocomplete': 'list',
        'aria-expanded': menuIsOpen,
        'aria-haspopup': true,
        'aria-errormessage': this.props['aria-errormessage'],
        'aria-invalid': this.props['aria-invalid'],
        'aria-label': this.props['aria-label'],
        'aria-labelledby': this.props['aria-labelledby'],
        'aria-required': required,
        role: 'combobox',
        'aria-activedescendant': this.isAppleDevice ? undefined : this.state.focusedOptionId || ''
      }, menuIsOpen && {
        'aria-controls': this.getElementId('listbox')
      }), !isSearchable && {
        'aria-readonly': true
      }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus' && {
        'aria-describedby': this.getElementId('live-region')
      } : {
        'aria-describedby': this.getElementId('placeholder')
      });
      if (!isSearchable) {
        // use a dummy input to maintain focus/blur functionality
        return /*#__PURE__*/React.createElement(DummyInput, _extends({
          id: id,
          innerRef: this.getInputRef,
          onBlur: this.onInputBlur,
          onChange: noop,
          onFocus: this.onInputFocus,
          disabled: isDisabled,
          tabIndex: tabIndex,
          inputMode: "none",
          form: form,
          value: ""
        }, ariaAttributes));
      }
      return /*#__PURE__*/React.createElement(Input, _extends({}, commonProps, {
        autoCapitalize: "none",
        autoComplete: "off",
        autoCorrect: "off",
        id: id,
        innerRef: this.getInputRef,
        isDisabled: isDisabled,
        isHidden: inputIsHidden,
        onBlur: this.onInputBlur,
        onChange: this.handleInputChange,
        onFocus: this.onInputFocus,
        spellCheck: "false",
        tabIndex: tabIndex,
        form: form,
        type: "text",
        value: inputValue
      }, ariaAttributes));
    }
  }, {
    key: "renderPlaceholderOrValue",
    value: function renderPlaceholderOrValue() {
      var _this3 = this;
      var _this$getComponents2 = this.getComponents(),
        MultiValue = _this$getComponents2.MultiValue,
        MultiValueContainer = _this$getComponents2.MultiValueContainer,
        MultiValueLabel = _this$getComponents2.MultiValueLabel,
        MultiValueRemove = _this$getComponents2.MultiValueRemove,
        SingleValue = _this$getComponents2.SingleValue,
        Placeholder = _this$getComponents2.Placeholder;
      var commonProps = this.commonProps;
      var _this$props9 = this.props,
        controlShouldRenderValue = _this$props9.controlShouldRenderValue,
        isDisabled = _this$props9.isDisabled,
        isMulti = _this$props9.isMulti,
        inputValue = _this$props9.inputValue,
        placeholder = _this$props9.placeholder;
      var _this$state5 = this.state,
        selectValue = _this$state5.selectValue,
        focusedValue = _this$state5.focusedValue,
        isFocused = _this$state5.isFocused;
      if (!this.hasValue() || !controlShouldRenderValue) {
        return inputValue ? null : /*#__PURE__*/React.createElement(Placeholder, _extends({}, commonProps, {
          key: "placeholder",
          isDisabled: isDisabled,
          isFocused: isFocused,
          innerProps: {
            id: this.getElementId('placeholder')
          }
        }), placeholder);
      }
      if (isMulti) {
        return selectValue.map(function (opt, index) {
          var isOptionFocused = opt === focusedValue;
          var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
          return /*#__PURE__*/React.createElement(MultiValue, _extends({}, commonProps, {
            components: {
              Container: MultiValueContainer,
              Label: MultiValueLabel,
              Remove: MultiValueRemove
            },
            isFocused: isOptionFocused,
            isDisabled: isDisabled,
            key: key,
            index: index,
            removeProps: {
              onClick: function onClick() {
                return _this3.removeValue(opt);
              },
              onTouchEnd: function onTouchEnd() {
                return _this3.removeValue(opt);
              },
              onMouseDown: function onMouseDown(e) {
                e.preventDefault();
              }
            },
            data: opt
          }), _this3.formatOptionLabel(opt, 'value'));
        });
      }
      if (inputValue) {
        return null;
      }
      var singleValue = selectValue[0];
      return /*#__PURE__*/React.createElement(SingleValue, _extends({}, commonProps, {
        data: singleValue,
        isDisabled: isDisabled
      }), this.formatOptionLabel(singleValue, 'value'));
    }
  }, {
    key: "renderClearIndicator",
    value: function renderClearIndicator() {
      var _this$getComponents3 = this.getComponents(),
        ClearIndicator = _this$getComponents3.ClearIndicator;
      var commonProps = this.commonProps;
      var _this$props10 = this.props,
        isDisabled = _this$props10.isDisabled,
        isLoading = _this$props10.isLoading;
      var isFocused = this.state.isFocused;
      if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) {
        return null;
      }
      var innerProps = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        'aria-hidden': 'true'
      };
      return /*#__PURE__*/React.createElement(ClearIndicator, _extends({}, commonProps, {
        innerProps: innerProps,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderLoadingIndicator",
    value: function renderLoadingIndicator() {
      var _this$getComponents4 = this.getComponents(),
        LoadingIndicator = _this$getComponents4.LoadingIndicator;
      var commonProps = this.commonProps;
      var _this$props11 = this.props,
        isDisabled = _this$props11.isDisabled,
        isLoading = _this$props11.isLoading;
      var isFocused = this.state.isFocused;
      if (!LoadingIndicator || !isLoading) return null;
      var innerProps = {
        'aria-hidden': 'true'
      };
      return /*#__PURE__*/React.createElement(LoadingIndicator, _extends({}, commonProps, {
        innerProps: innerProps,
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderIndicatorSeparator",
    value: function renderIndicatorSeparator() {
      var _this$getComponents5 = this.getComponents(),
        DropdownIndicator = _this$getComponents5.DropdownIndicator,
        IndicatorSeparator = _this$getComponents5.IndicatorSeparator;

      // separator doesn't make sense without the dropdown indicator
      if (!DropdownIndicator || !IndicatorSeparator) return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      return /*#__PURE__*/React.createElement(IndicatorSeparator, _extends({}, commonProps, {
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderDropdownIndicator",
    value: function renderDropdownIndicator() {
      var _this$getComponents6 = this.getComponents(),
        DropdownIndicator = _this$getComponents6.DropdownIndicator;
      if (!DropdownIndicator) return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      var innerProps = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        'aria-hidden': 'true'
      };
      return /*#__PURE__*/React.createElement(DropdownIndicator, _extends({}, commonProps, {
        innerProps: innerProps,
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderMenu",
    value: function renderMenu() {
      var _this4 = this;
      var _this$getComponents7 = this.getComponents(),
        Group = _this$getComponents7.Group,
        GroupHeading = _this$getComponents7.GroupHeading,
        Menu = _this$getComponents7.Menu,
        MenuList = _this$getComponents7.MenuList,
        MenuPortal = _this$getComponents7.MenuPortal,
        LoadingMessage = _this$getComponents7.LoadingMessage,
        NoOptionsMessage = _this$getComponents7.NoOptionsMessage,
        Option = _this$getComponents7.Option;
      var commonProps = this.commonProps;
      var focusedOption = this.state.focusedOption;
      var _this$props12 = this.props,
        captureMenuScroll = _this$props12.captureMenuScroll,
        inputValue = _this$props12.inputValue,
        isLoading = _this$props12.isLoading,
        loadingMessage = _this$props12.loadingMessage,
        minMenuHeight = _this$props12.minMenuHeight,
        maxMenuHeight = _this$props12.maxMenuHeight,
        menuIsOpen = _this$props12.menuIsOpen,
        menuPlacement = _this$props12.menuPlacement,
        menuPosition = _this$props12.menuPosition,
        menuPortalTarget = _this$props12.menuPortalTarget,
        menuShouldBlockScroll = _this$props12.menuShouldBlockScroll,
        menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView,
        noOptionsMessage = _this$props12.noOptionsMessage,
        onMenuScrollToTop = _this$props12.onMenuScrollToTop,
        onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
      if (!menuIsOpen) return null;

      // TODO: Internal Option Type here
      var render = function render(props, id) {
        var type = props.type,
          data = props.data,
          isDisabled = props.isDisabled,
          isSelected = props.isSelected,
          label = props.label,
          value = props.value;
        var isFocused = focusedOption === data;
        var onHover = isDisabled ? undefined : function () {
          return _this4.onOptionHover(data);
        };
        var onSelect = isDisabled ? undefined : function () {
          return _this4.selectOption(data);
        };
        var optionId = "".concat(_this4.getElementId('option'), "-").concat(id);
        var innerProps = {
          id: optionId,
          onClick: onSelect,
          onMouseMove: onHover,
          onMouseOver: onHover,
          tabIndex: -1,
          role: 'option',
          'aria-selected': _this4.isAppleDevice ? undefined : isSelected // is not supported on Apple devices
        };

        return /*#__PURE__*/React.createElement(Option, _extends({}, commonProps, {
          innerProps: innerProps,
          data: data,
          isDisabled: isDisabled,
          isSelected: isSelected,
          key: optionId,
          label: label,
          type: type,
          value: value,
          isFocused: isFocused,
          innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
        }), _this4.formatOptionLabel(props.data, 'menu'));
      };
      var menuUI;
      if (this.hasOptions()) {
        menuUI = this.getCategorizedOptions().map(function (item) {
          if (item.type === 'group') {
            var _data = item.data,
              options = item.options,
              groupIndex = item.index;
            var groupId = "".concat(_this4.getElementId('group'), "-").concat(groupIndex);
            var headingId = "".concat(groupId, "-heading");
            return /*#__PURE__*/React.createElement(Group, _extends({}, commonProps, {
              key: groupId,
              data: _data,
              options: options,
              Heading: GroupHeading,
              headingProps: {
                id: headingId,
                data: item.data
              },
              label: _this4.formatGroupLabel(item.data)
            }), item.options.map(function (option) {
              return render(option, "".concat(groupIndex, "-").concat(option.index));
            }));
          } else if (item.type === 'option') {
            return render(item, "".concat(item.index));
          }
        });
      } else if (isLoading) {
        var message = loadingMessage({
          inputValue: inputValue
        });
        if (message === null) return null;
        menuUI = /*#__PURE__*/React.createElement(LoadingMessage, commonProps, message);
      } else {
        var _message = noOptionsMessage({
          inputValue: inputValue
        });
        if (_message === null) return null;
        menuUI = /*#__PURE__*/React.createElement(NoOptionsMessage, commonProps, _message);
      }
      var menuPlacementProps = {
        minMenuHeight: minMenuHeight,
        maxMenuHeight: maxMenuHeight,
        menuPlacement: menuPlacement,
        menuPosition: menuPosition,
        menuShouldScrollIntoView: menuShouldScrollIntoView
      };
      var menuElement = /*#__PURE__*/React.createElement(MenuPlacer, _extends({}, commonProps, menuPlacementProps), function (_ref4) {
        var ref = _ref4.ref,
          _ref4$placerProps = _ref4.placerProps,
          placement = _ref4$placerProps.placement,
          maxHeight = _ref4$placerProps.maxHeight;
        return /*#__PURE__*/React.createElement(Menu, _extends({}, commonProps, menuPlacementProps, {
          innerRef: ref,
          innerProps: {
            onMouseDown: _this4.onMenuMouseDown,
            onMouseMove: _this4.onMenuMouseMove
          },
          isLoading: isLoading,
          placement: placement
        }), /*#__PURE__*/React.createElement(ScrollManager, {
          captureEnabled: captureMenuScroll,
          onTopArrive: onMenuScrollToTop,
          onBottomArrive: onMenuScrollToBottom,
          lockEnabled: menuShouldBlockScroll
        }, function (scrollTargetRef) {
          return /*#__PURE__*/React.createElement(MenuList, _extends({}, commonProps, {
            innerRef: function innerRef(instance) {
              _this4.getMenuListRef(instance);
              scrollTargetRef(instance);
            },
            innerProps: {
              role: 'listbox',
              'aria-multiselectable': commonProps.isMulti,
              id: _this4.getElementId('listbox')
            },
            isLoading: isLoading,
            maxHeight: maxHeight,
            focusedOption: focusedOption
          }), menuUI);
        }));
      });

      // positioning behaviour is almost identical for portalled and fixed,
      // so we use the same component. the actual portalling logic is forked
      // within the component based on `menuPosition`
      return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/React.createElement(MenuPortal, _extends({}, commonProps, {
        appendTo: menuPortalTarget,
        controlElement: this.controlRef,
        menuPlacement: menuPlacement,
        menuPosition: menuPosition
      }), menuElement) : menuElement;
    }
  }, {
    key: "renderFormField",
    value: function renderFormField() {
      var _this5 = this;
      var _this$props13 = this.props,
        delimiter = _this$props13.delimiter,
        isDisabled = _this$props13.isDisabled,
        isMulti = _this$props13.isMulti,
        name = _this$props13.name,
        required = _this$props13.required;
      var selectValue = this.state.selectValue;
      if (required && !this.hasValue() && !isDisabled) {
        return /*#__PURE__*/React.createElement(RequiredInput$1, {
          name: name,
          onFocus: this.onValueInputFocus
        });
      }
      if (!name || isDisabled) return;
      if (isMulti) {
        if (delimiter) {
          var value = selectValue.map(function (opt) {
            return _this5.getOptionValue(opt);
          }).join(delimiter);
          return /*#__PURE__*/React.createElement("input", {
            name: name,
            type: "hidden",
            value: value
          });
        } else {
          var input = selectValue.length > 0 ? selectValue.map(function (opt, i) {
            return /*#__PURE__*/React.createElement("input", {
              key: "i-".concat(i),
              name: name,
              type: "hidden",
              value: _this5.getOptionValue(opt)
            });
          }) : /*#__PURE__*/React.createElement("input", {
            name: name,
            type: "hidden",
            value: ""
          });
          return /*#__PURE__*/React.createElement("div", null, input);
        }
      } else {
        var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
        return /*#__PURE__*/React.createElement("input", {
          name: name,
          type: "hidden",
          value: _value
        });
      }
    }
  }, {
    key: "renderLiveRegion",
    value: function renderLiveRegion() {
      var commonProps = this.commonProps;
      var _this$state6 = this.state,
        ariaSelection = _this$state6.ariaSelection,
        focusedOption = _this$state6.focusedOption,
        focusedValue = _this$state6.focusedValue,
        isFocused = _this$state6.isFocused,
        selectValue = _this$state6.selectValue;
      var focusableOptions = this.getFocusableOptions();
      return /*#__PURE__*/React.createElement(LiveRegion$1, _extends({}, commonProps, {
        id: this.getElementId('live-region'),
        ariaSelection: ariaSelection,
        focusedOption: focusedOption,
        focusedValue: focusedValue,
        isFocused: isFocused,
        selectValue: selectValue,
        focusableOptions: focusableOptions,
        isAppleDevice: this.isAppleDevice
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$getComponents8 = this.getComponents(),
        Control = _this$getComponents8.Control,
        IndicatorsContainer = _this$getComponents8.IndicatorsContainer,
        SelectContainer = _this$getComponents8.SelectContainer,
        ValueContainer = _this$getComponents8.ValueContainer;
      var _this$props14 = this.props,
        className = _this$props14.className,
        id = _this$props14.id,
        isDisabled = _this$props14.isDisabled,
        menuIsOpen = _this$props14.menuIsOpen;
      var isFocused = this.state.isFocused;
      var commonProps = this.commonProps = this.getCommonProps();
      return /*#__PURE__*/React.createElement(SelectContainer, _extends({}, commonProps, {
        className: className,
        innerProps: {
          id: id,
          onKeyDown: this.onKeyDown
        },
        isDisabled: isDisabled,
        isFocused: isFocused
      }), this.renderLiveRegion(), /*#__PURE__*/React.createElement(Control, _extends({}, commonProps, {
        innerRef: this.getControlRef,
        innerProps: {
          onMouseDown: this.onControlMouseDown,
          onTouchEnd: this.onControlTouchEnd
        },
        isDisabled: isDisabled,
        isFocused: isFocused,
        menuIsOpen: menuIsOpen
      }), /*#__PURE__*/React.createElement(ValueContainer, _extends({}, commonProps, {
        isDisabled: isDisabled
      }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/React.createElement(IndicatorsContainer, _extends({}, commonProps, {
        isDisabled: isDisabled
      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var prevProps = state.prevProps,
        clearFocusValueOnUpdate = state.clearFocusValueOnUpdate,
        inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate,
        ariaSelection = state.ariaSelection,
        isFocused = state.isFocused,
        prevWasFocused = state.prevWasFocused,
        instancePrefix = state.instancePrefix;
      var options = props.options,
        value = props.value,
        menuIsOpen = props.menuIsOpen,
        inputValue = props.inputValue,
        isMulti = props.isMulti;
      var selectValue = cleanValue(value);
      var newMenuOptionsState = {};
      if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
        var focusableOptions = menuIsOpen ? buildFocusableOptions(props, selectValue) : [];
        var focusableOptionsWithIds = menuIsOpen ? buildFocusableOptionsWithIds(buildCategorizedOptions(props, selectValue), "".concat(instancePrefix, "-option")) : [];
        var focusedValue = clearFocusValueOnUpdate ? getNextFocusedValue(state, selectValue) : null;
        var focusedOption = getNextFocusedOption(state, focusableOptions);
        var focusedOptionId = getFocusedOptionId(focusableOptionsWithIds, focusedOption);
        newMenuOptionsState = {
          selectValue: selectValue,
          focusedOption: focusedOption,
          focusedOptionId: focusedOptionId,
          focusableOptionsWithIds: focusableOptionsWithIds,
          focusedValue: focusedValue,
          clearFocusValueOnUpdate: false
        };
      }
      // some updates should toggle the state of the input visibility
      var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
        inputIsHidden: inputIsHiddenAfterUpdate,
        inputIsHiddenAfterUpdate: undefined
      } : {};
      var newAriaSelection = ariaSelection;
      var hasKeptFocus = isFocused && prevWasFocused;
      if (isFocused && !hasKeptFocus) {
        // If `value` or `defaultValue` props are not empty then announce them
        // when the Select is initially focused
        newAriaSelection = {
          value: valueTernary(isMulti, selectValue, selectValue[0] || null),
          options: selectValue,
          action: 'initial-input-focus'
        };
        hasKeptFocus = !prevWasFocused;
      }

      // If the 'initial-input-focus' action has been set already
      // then reset the ariaSelection to null
      if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') {
        newAriaSelection = null;
      }
      return _objectSpread2(_objectSpread2(_objectSpread2({}, newMenuOptionsState), newInputIsHiddenState), {}, {
        prevProps: props,
        ariaSelection: newAriaSelection,
        prevWasFocused: hasKeptFocus
      });
    }
  }]);
  return Select;
}(Component);
Select.defaultProps = defaultProps;

var _excluded$1 = ["defaultInputValue", "defaultMenuIsOpen", "defaultValue", "inputValue", "menuIsOpen", "onChange", "onInputChange", "onMenuClose", "onMenuOpen", "value"];
function useStateManager(_ref) {
  var _ref$defaultInputValu = _ref.defaultInputValue,
    defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu,
    _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen,
    defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe,
    _ref$defaultValue = _ref.defaultValue,
    defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue,
    propsInputValue = _ref.inputValue,
    propsMenuIsOpen = _ref.menuIsOpen,
    propsOnChange = _ref.onChange,
    propsOnInputChange = _ref.onInputChange,
    propsOnMenuClose = _ref.onMenuClose,
    propsOnMenuOpen = _ref.onMenuOpen,
    propsValue = _ref.value,
    restSelectProps = _objectWithoutProperties(_ref, _excluded$1);
  var _useState = useState(propsInputValue !== undefined ? propsInputValue : defaultInputValue),
    _useState2 = _slicedToArray(_useState, 2),
    stateInputValue = _useState2[0],
    setStateInputValue = _useState2[1];
  var _useState3 = useState(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen),
    _useState4 = _slicedToArray(_useState3, 2),
    stateMenuIsOpen = _useState4[0],
    setStateMenuIsOpen = _useState4[1];
  var _useState5 = useState(propsValue !== undefined ? propsValue : defaultValue),
    _useState6 = _slicedToArray(_useState5, 2),
    stateValue = _useState6[0],
    setStateValue = _useState6[1];
  var onChange = useCallback(function (value, actionMeta) {
    if (typeof propsOnChange === 'function') {
      propsOnChange(value, actionMeta);
    }
    setStateValue(value);
  }, [propsOnChange]);
  var onInputChange = useCallback(function (value, actionMeta) {
    var newValue;
    if (typeof propsOnInputChange === 'function') {
      newValue = propsOnInputChange(value, actionMeta);
    }
    setStateInputValue(newValue !== undefined ? newValue : value);
  }, [propsOnInputChange]);
  var onMenuOpen = useCallback(function () {
    if (typeof propsOnMenuOpen === 'function') {
      propsOnMenuOpen();
    }
    setStateMenuIsOpen(true);
  }, [propsOnMenuOpen]);
  var onMenuClose = useCallback(function () {
    if (typeof propsOnMenuClose === 'function') {
      propsOnMenuClose();
    }
    setStateMenuIsOpen(false);
  }, [propsOnMenuClose]);
  var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
  var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
  var value = propsValue !== undefined ? propsValue : stateValue;
  return _objectSpread2(_objectSpread2({}, restSelectProps), {}, {
    inputValue: inputValue,
    menuIsOpen: menuIsOpen,
    onChange: onChange,
    onInputChange: onInputChange,
    onMenuClose: onMenuClose,
    onMenuOpen: onMenuOpen,
    value: value
  });
}

var _excluded = ["defaultOptions", "cacheOptions", "loadOptions", "options", "isLoading", "onInputChange", "filterOption"];
function useAsync(_ref) {
  var _ref$defaultOptions = _ref.defaultOptions,
    propsDefaultOptions = _ref$defaultOptions === void 0 ? false : _ref$defaultOptions,
    _ref$cacheOptions = _ref.cacheOptions,
    cacheOptions = _ref$cacheOptions === void 0 ? false : _ref$cacheOptions,
    propsLoadOptions = _ref.loadOptions;
    _ref.options;
    var _ref$isLoading = _ref.isLoading,
    propsIsLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
    propsOnInputChange = _ref.onInputChange,
    _ref$filterOption = _ref.filterOption,
    filterOption = _ref$filterOption === void 0 ? null : _ref$filterOption,
    restSelectProps = _objectWithoutProperties(_ref, _excluded);
  var propsInputValue = restSelectProps.inputValue;
  var lastRequest = useRef(undefined);
  var mounted = useRef(false);
  var _useState = useState(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined),
    _useState2 = _slicedToArray(_useState, 2),
    defaultOptions = _useState2[0],
    setDefaultOptions = _useState2[1];
  var _useState3 = useState(typeof propsInputValue !== 'undefined' ? propsInputValue : ''),
    _useState4 = _slicedToArray(_useState3, 2),
    stateInputValue = _useState4[0],
    setStateInputValue = _useState4[1];
  var _useState5 = useState(propsDefaultOptions === true),
    _useState6 = _slicedToArray(_useState5, 2),
    isLoading = _useState6[0],
    setIsLoading = _useState6[1];
  var _useState7 = useState(undefined),
    _useState8 = _slicedToArray(_useState7, 2),
    loadedInputValue = _useState8[0],
    setLoadedInputValue = _useState8[1];
  var _useState9 = useState([]),
    _useState10 = _slicedToArray(_useState9, 2),
    loadedOptions = _useState10[0],
    setLoadedOptions = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    passEmptyOptions = _useState12[0],
    setPassEmptyOptions = _useState12[1];
  var _useState13 = useState({}),
    _useState14 = _slicedToArray(_useState13, 2),
    optionsCache = _useState14[0],
    setOptionsCache = _useState14[1];
  var _useState15 = useState(undefined),
    _useState16 = _slicedToArray(_useState15, 2),
    prevDefaultOptions = _useState16[0],
    setPrevDefaultOptions = _useState16[1];
  var _useState17 = useState(undefined),
    _useState18 = _slicedToArray(_useState17, 2),
    prevCacheOptions = _useState18[0],
    setPrevCacheOptions = _useState18[1];
  if (cacheOptions !== prevCacheOptions) {
    setOptionsCache({});
    setPrevCacheOptions(cacheOptions);
  }
  if (propsDefaultOptions !== prevDefaultOptions) {
    setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
    setPrevDefaultOptions(propsDefaultOptions);
  }
  useEffect(function () {
    mounted.current = true;
    return function () {
      mounted.current = false;
    };
  }, []);
  var loadOptions = useCallback(function (inputValue, callback) {
    if (!propsLoadOptions) return callback();
    var loader = propsLoadOptions(inputValue, callback);
    if (loader && typeof loader.then === 'function') {
      loader.then(callback, function () {
        return callback();
      });
    }
  }, [propsLoadOptions]);
  useEffect(function () {
    if (propsDefaultOptions === true) {
      loadOptions(stateInputValue, function (options) {
        if (!mounted.current) return;
        setDefaultOptions(options || []);
        setIsLoading(!!lastRequest.current);
      });
    }
    // NOTE: this effect is designed to only run when the component mounts,
    // so we don't want to include any hook dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var onInputChange = useCallback(function (newValue, actionMeta) {
    var inputValue = handleInputChange(newValue, actionMeta, propsOnInputChange);
    if (!inputValue) {
      lastRequest.current = undefined;
      setStateInputValue('');
      setLoadedInputValue('');
      setLoadedOptions([]);
      setIsLoading(false);
      setPassEmptyOptions(false);
      return;
    }
    if (cacheOptions && optionsCache[inputValue]) {
      setStateInputValue(inputValue);
      setLoadedInputValue(inputValue);
      setLoadedOptions(optionsCache[inputValue]);
      setIsLoading(false);
      setPassEmptyOptions(false);
    } else {
      var request = lastRequest.current = {};
      setStateInputValue(inputValue);
      setIsLoading(true);
      setPassEmptyOptions(!loadedInputValue);
      loadOptions(inputValue, function (options) {
        if (!mounted) return;
        if (request !== lastRequest.current) return;
        lastRequest.current = undefined;
        setIsLoading(false);
        setLoadedInputValue(inputValue);
        setLoadedOptions(options || []);
        setPassEmptyOptions(false);
        setOptionsCache(options ? _objectSpread2(_objectSpread2({}, optionsCache), {}, _defineProperty({}, inputValue, options)) : optionsCache);
      });
    }
  }, [cacheOptions, loadOptions, loadedInputValue, optionsCache, propsOnInputChange]);
  var options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
  return _objectSpread2(_objectSpread2({}, restSelectProps), {}, {
    options: options,
    isLoading: isLoading || propsIsLoading,
    onInputChange: onInputChange,
    filterOption: filterOption
  });
}

var AsyncSelect$1 = /*#__PURE__*/forwardRef(function (props, ref) {
  var stateManagedProps = useAsync(props);
  var selectProps = useStateManager(stateManagedProps);
  return /*#__PURE__*/React.createElement(Select, _extends({
    ref: ref
  }, selectProps));
});
var AsyncSelect$1$1 = AsyncSelect$1;

const EmotionCacheProvider = ({ children }) => {
    const cache = useMemo(() => createCache({
        key: 'async-select-prefix-key',
        nonce: window.__webpack_nonce__,
    }), []);
    return jsxRuntimeExports.jsx(CacheProvider, { value: cache, children: children });
};
function AsyncSelect(_a) {
    var { error, id, size } = _a, props = __rest(_a, ["error", "id", "size"]);
    const { size: formGroupContextSize } = useContext(FormGroupContext);
    const sizeProp = size || formGroupContextSize || 'large';
    return (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx(AsyncSelect$1$1, Object.assign({ components: { Option: SelectOption }, inputId: id, noOptionsMessage: ({ inputValue }) => (!inputValue ? inputValue : 'Geen opties'), placeholder: "Selecteer...", styles: customStyles(sizeProp, error) }, props)), error && jsxRuntimeExports.jsx(FormErrorMessage, { children: error })] }));
}

const sizeOptions = {
    large: '32px',
    medium: '24px',
};
function Switch(_a) {
    var { ariaLabel = 'checkbox', checked = false, disabled = false, error, id, inputRef, onChange, size = 'large', sx: sxProp, value } = _a, props = __rest(_a, ["ariaLabel", "checked", "disabled", "error", "id", "inputRef", "onChange", "size", "sx", "value"]);
    const inputId = useUniqueId(id);
    return (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsxs(StyledSwitchContainer, { "$size": size, sx: sxProp, children: [jsxRuntimeExports.jsx(StyledSwitchInput, Object.assign({ "aria-label": ariaLabel, checked: checked, disabled: disabled, id: inputId, onChange: onChange, ref: inputRef, role: "checkbox", tabIndex: 0, type: "checkbox", value: value }, props)), jsxRuntimeExports.jsx(StyledSwitchLabel, { "$checked": checked, "$disabled": disabled, "$size": size, htmlFor: inputId, children: jsxRuntimeExports.jsx(StyledSwitchCircle, { "$checked": checked, "$disabled": disabled }) })] }), error && jsxRuntimeExports.jsx(FormErrorMessage, { children: error })] }));
}
const StyledSwitchContainer = styled.div `
    position: relative;
    width: calc(${(props) => props.$size && sizeOptions[props.$size]} * 2);
    height: ${(props) => props.$size && sizeOptions[props.$size]};
    ${sx}
`;
const StyledSwitchLabel = styled.label `
    box-sizing: border-box;
    position: absolute;
    display: flex;
    align-items: center;
    background-color: ${(props) => props.theme.switch.backgroundColor};
    border-radius: ${(props) => props.theme.radii.full};
    width: calc(${(props) => props.$size && sizeOptions[props.$size]} * 2);
    height: ${(props) => props.$size && sizeOptions[props.$size]};
    cursor: ${(props) => (props.$disabled ? undefined : 'pointer')};
    transition: background-color 200ms ease 0s;
    margin: 0;

    ${(props) => props.$checked &&
    css$3 `
            background-color: ${props.theme.switch.backgroundColorChecked};

            &::after {
                opacity: 1;
            }
        `}

    ${(props) => props.$disabled &&
    css$3 `
            background-color: ${props.theme.switch.backgroundColorDisabled};
            border: 1px solid ${props.theme.switch.borderColorDisabled};
        `}

    ${(props) => props.$checked &&
    props.$disabled &&
    css$3 `
            background-color: ${props.theme.switch.backgroundColorCheckedDisabled};

            &::after {
                opacity: 0;
            }
        `}
`;
const StyledSwitchCircle = styled.div `
    position: relative;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    border-radius: ${(props) => props.theme.radii.full};
    width: calc(100% - 4px);
    height: calc(100% - 4px);
    margin: 2px;

    &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: calc((100% - 4px) / 2);
        height: 100%;
        border-radius: ${(props) => props.theme.radii.full};
        pointer-events: none;
        background-color: ${(props) => props.theme.switch.backgroundColorCircle};
        box-shadow: 0 2px 4px 0 rgb(0 0 0 / 50%);
        transition: transform 200ms ease-in-out;
    }

    ${(props) => props.$disabled &&
    css$3 `
            &::after {
                box-shadow: none;
                background-color: ${props.theme.switch.backgroundColorCircleDisabled};
            }
        `}

    ${(props) => props.$checked &&
    css$3 `
            &::after {
                transform: translateX(calc(100% + 4px));
            }
        `}
`;
const StyledSwitchInput = styled.input `
    clip: rect(0, 0, 0, 0);
    clip-path: inset(100%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
    border: none;
    margin: -1px;
    outline: currentcolor none 0;
    padding: 0;

    ${(props) => props.disabled &&
    css$3 `
            pointer-events: none;
        `};

    &:disabled ~ ${StyledSwitchLabel} {
        border: 1px solid ${(props) => props.theme.switch.borderColorDisabled};
    }

    &:focus-visible ~ ${StyledSwitchLabel} {
        outline: 2px solid var(--kds-color-border-focused);
        outline-offset: 2px;
    }
`;

function TextArea(_a) {
    var { autoResize = true, disabled, error, maxLength, onBlur, onChange, placeholder, rows = 2, size, sx: sxProp, value, variant } = _a, props = __rest(_a, ["autoResize", "disabled", "error", "maxLength", "onBlur", "onChange", "placeholder", "rows", "size", "sx", "value", "variant"]);
    const textAreaRef = useRef(null);
    const [characterCount, setCharacterCount] = useState(value.length);
    const { size: formGroupContextSize, variant: formGroupContextVariant } = useContext(FormGroupContext);
    const sizeProp = size || formGroupContextSize || 'large';
    const variantProp = variant || formGroupContextVariant || 'outline';
    const [textArea, setTextArea] = useState(null);
    useEffect(() => {
        const currentTextArea = textAreaRef.current;
        setTextArea(currentTextArea);
        setTextAreaHeight(currentTextArea, (currentTextArea === null || currentTextArea === void 0 ? void 0 : currentTextArea.scrollHeight) + 'px');
        textArea === null || textArea === void 0 ? void 0 : textArea.addEventListener('input', handleInput);
        return () => {
            textArea === null || textArea === void 0 ? void 0 : textArea.removeEventListener('input', handleInput);
        };
    }, [textAreaRef.current]);
    const handleInput = () => {
        if (textArea && autoResize) {
            setTextAreaHeight(textArea, 'auto');
            setTextAreaHeight(textArea, (textArea === null || textArea === void 0 ? void 0 : textArea.scrollHeight) + 'px');
        }
    };
    function setTextAreaHeight(textAreaArg, height) {
        if (textAreaArg) {
            textAreaArg.style.setProperty('height', height);
        }
    }
    const handleChange = (event) => {
        if (onChange) {
            onChange(event);
        }
        if (maxLength && textArea) {
            const currentLength = textArea.value.length;
            setCharacterCount(currentLength);
            if (currentLength >= maxLength) {
                return;
            }
        }
    };
    return (jsxRuntimeExports.jsxs(StyledTextAreaWrapper, { sx: sxProp, children: [jsxRuntimeExports.jsx(StyledTextArea, Object.assign({ "$autoResize": autoResize, "$error": Boolean(error), "$size": sizeProp, "$variant": variantProp, disabled: disabled, maxLength: maxLength, onBlur: onBlur, onChange: handleChange, placeholder: placeholder, ref: textAreaRef, rows: rows, value: value }, props)), jsxRuntimeExports.jsxs(Box, { display: "flex", flexDirection: error ? 'row' : 'row-reverse', justifyContent: "space-between", width: "100%", children: [error && jsxRuntimeExports.jsx(FormErrorMessage, { children: error }), maxLength && (jsxRuntimeExports.jsxs(Text, { as: "span", color: "minimal", size: "sm", sx: { flexShrink: 0 }, children: [characterCount, " / ", maxLength] }))] })] }));
}
const StyledTextAreaWrapper = styled.div `
    ${sx}
`;
const StyledTextArea = styled.textarea `
    color: var(--kds-color-foreground-default);
    font-weight: var(--kds-font-weight-input);
    width: 100%;
    box-shadow: none;
    border-radius: 0;
    border: 0;
    appearance: none;
    resize: ${(props) => (props.$autoResize ? 'none' : 'vertical')};
    overflow: ${(props) => (props.$autoResize ? 'hidden' : 'auto')};
    overflow-wrap: break-word;
    font-size: var(--kds-font-size-input-large);
    line-height: var(--kds-line-height-input-large);
    min-height: var(--kds-size-input-height-large);

    &::placeholder {
        font-weight: var(--kds-font-weight-placeholder);
        color: var(--kds-color-foreground-minimal);
    }

    ${(props) => props.$size === 'medium' &&
    css$3 `
            ${props.theme.mediaQueries.small} {
                font-size: var(--kds-font-size-input-medium);
                line-height: var(--kds-line-height-input-medium);
                min-height: var(--kds-size-input-height-medium);
            }
        `}

    ${(props) => props.$variant === 'flushed' &&
    css$3 `
            border-bottom: 1px solid var(--kds-color-border-medium);
            background-color: var(--kds-color-transparent);
            padding: 8px 0;
            border-radius: 0;

            &:hover {
                border-color: var(--kds-color-border-strong);
            }

            &:focus {
                outline: none;
                border-color: var(--kds-color-border-focused);
            }
        `}

    ${(props) => props.$variant === 'outline' &&
    css$3 `
            border: 1px solid var(--kds-color-border-medium);
            background-color: var(--kds-color-background-default);
            padding: 8px 12px;
            border-radius: var(--kds-border-radius-base);

            &:hover {
                border-color: var(--kds-color-border-strong);
            }

            &:focus {
                outline: none;
                background-color: var(--kds-color-background-default);
                border-color: var(--kds-color-border-focused);
                box-shadow: 0 0 0 4px var(--kds-color-shadow-focused);
            }
        `}


    ${(props) => props.$error &&
    css$3 `
            border-color: var(--kds-color-border-warning);

            &:hover {
                border-color: var(--kds-color-border-warning);
            }

            &:focus {
                border-color: var(--kds-color-border-warning);
                box-shadow: 0 0 0 4px var(--kds-color-shadow-warning);
            }

            &::placeholder {
                color: var(--kds-color-foreground-warning);
            }
        `}

    ${(props) => props.disabled &&
    css$3 `
            color: var(--kds-color-foreground-disabled);
            background-color: var(--kds-color-background-disabled);
            border-color: var(--kds-color-border-disabled);
            pointer-events: none;

            &::placeholder {
                color: var(--kds-color-foreground-disabled);
            }
        `}
`;

function FormGroup({ children, hasErrors, htmlFor, isLabelSensitiveData = true, isRequired, label, labelAvatar, layout, sx: sxProp, tooltipText, }) {
    var _a;
    const { labelWidth: formGroupContextLabelWidth, layout: formGroupContextLayout, size: formGroupContextSize, } = useContext(FormGroupContext);
    const expectedInputComponents = [
        AsyncSelect,
        Checkbox,
        DateInput,
        DatePicker,
        MonthPicker,
        NumberInput,
        PasswordInput,
        Select$1,
        Switch,
        TextArea,
        TextInput,
    ];
    const InputComponent = Children.toArray(children).find((child) => expectedInputComponents.some((inputComponent) => isValidElement(child) && child.type === inputComponent));
    const uniqueId = useUniqueId();
    const sizeProp = formGroupContextSize !== null && formGroupContextSize !== void 0 ? formGroupContextSize : 'large';
    const labelWidthProp = formGroupContextLabelWidth !== null && formGroupContextLabelWidth !== void 0 ? formGroupContextLabelWidth : 'one-third';
    const layoutProp = (_a = layout !== null && layout !== void 0 ? layout : formGroupContextLayout) !== null && _a !== void 0 ? _a : 'horizontal';
    const inputId = htmlFor !== null && htmlFor !== void 0 ? htmlFor : (InputComponent && label ? uniqueId : undefined);
    const inputChild = isValidElement(InputComponent) &&
        cloneElement(InputComponent, {
            id: inputId,
        });
    const noneInputChildren = Children.toArray(children).filter((child) => isValidElement(child) && !expectedInputComponents.some((inputComponent) => child.type === inputComponent));
    return (jsxRuntimeExports.jsxs(StyledFormGroup, { "$labelWidth": labelWidthProp, "$layout": layoutProp, "$size": sizeProp, className: hasErrors ? 'has-danger' : '', sx: sxProp, children: [label && (jsxRuntimeExports.jsx(StyledFormLabel, { avatar: labelAvatar, error: hasErrors, htmlFor: inputId, isRequired: isRequired, isSensitiveData: isLabelSensitiveData, size: sizeProp, tooltipText: tooltipText, children: label })), jsxRuntimeExports.jsxs(StyledInputContainer$1, { "$labelWidth": labelWidthProp, "$layout": layoutProp, children: [inputChild, noneInputChildren] })] }));
}
const StyledFormLabel = styled(FormLabel) ``;
const StyledFormGroup = styled.div `
    display: block;

    ${(props) => props.$layout === 'horizontal' &&
    props.$labelWidth === 'one-third' &&
    css$3 `
            ${props.theme.mediaQueries.medium} {
                display: grid;
                align-items: flex-start;
                grid-template-columns: repeat(3, minmax(0, 1fr));
                column-gap: 16px;
            }
        `}

    ${(props) => props.$layout === 'horizontal' &&
    props.$labelWidth === 'one-quarter' &&
    css$3 `
            ${props.theme.mediaQueries.medium} {
                display: grid;
                align-items: flex-start;
                grid-template-columns: repeat(4, minmax(0, 1fr));
                column-gap: 16px;
            }
        `}


    ${(props) => props.$size === 'medium' &&
    css$3 `
            &:not(:last-child) {
                margin-bottom: 12px;
            }
        `}

    ${(props) => props.$size === 'large' &&
    css$3 `
            &:not(:last-child) {
                margin-bottom: 16px;
            }
        `}


    ${StyledFormLabel} {
        font-weight: var(--kds-font-weight-medium);

        ${(props) => props.$size === 'medium' &&
    css$3 `
                margin-bottom: 4px;
            `}

        ${(props) => props.$size === 'large' &&
    css$3 `
                margin-bottom: 8px;
            `}

        ${(props) => props.theme.mediaQueries.medium} {
            font-weight: var(--kds-font-weight-normal);

            ${(props) => props.$layout === 'horizontal' &&
    css$3 `
                    grid-column: 1;
                    margin-bottom: 0;
                    padding-top: 4px;
                `}
        }
    }
    ${sx}
`;
const StyledInputContainer$1 = styled.div `
    display: block;
    position: relative;

    ${(props) => props.$layout === 'horizontal' &&
    props.$labelWidth === 'one-third' &&
    css$3 `
            ${props.theme.mediaQueries.medium} {
                grid-column: 2 / 4;
                margin: 0;
            }
        `}

    ${(props) => props.$layout === 'horizontal' &&
    props.$labelWidth === 'one-quarter' &&
    css$3 `
            ${props.theme.mediaQueries.medium} {
                grid-column: 2 / 5;
                margin: 0;
            }
        `}
`;

function FormParagraph(_a) {
    var _b, _c;
    var { badgeText, children, layout, size, tooltipText, whiteSpace = 'break-spaces' } = _a, props = __rest(_a, ["badgeText", "children", "layout", "size", "tooltipText", "whiteSpace"]);
    const { layout: formGroupContextLayout, size: formGroupContextSize } = useContext(FormGroupContext);
    const sizeProp = (_b = size !== null && size !== void 0 ? size : formGroupContextSize) !== null && _b !== void 0 ? _b : 'large';
    const layoutProp = (_c = layout !== null && layout !== void 0 ? layout : formGroupContextLayout) !== null && _c !== void 0 ? _c : 'horizontal';
    return (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx(StyledFormParagraph, Object.assign({ "$layout": layoutProp, "$size": sizeProp, "$whiteSpace": whiteSpace }, props, { children: children })), badgeText && (jsxRuntimeExports.jsx(Badge, { text: badgeText, tooltip: tooltipText ? { content: tooltipText } : undefined }))] }));
}
const StyledFormParagraph = styled.p `
    color: var(--kds-color-foreground-default);
    font-weight: var(--kds-font-weight-normal);
    margin: 0;
    white-space: ${(props) => props.$whiteSpace};
    padding: 0;

    ${(props) => props.$layout === 'horizontal' &&
    css$3 `
            ${props.theme.mediaQueries.medium} {
                padding-top: 4px;
            }
        `}

    ${(props) => props.$size === 'medium' &&
    css$3 `
            font-size: 14px;
            line-height: 20px;
        `}

    ${(props) => props.$size === 'large' &&
    css$3 `
            font-size: 16px;
            line-height: 24px;
        `}
`;

function FormSection(_a) {
    var { action, children, isBorderless, isSensitiveData = false, title, tooltipContent } = _a, props = __rest(_a, ["action", "children", "isBorderless", "isSensitiveData", "title", "tooltipContent"]);
    const { size: formGroupContextSize } = useContext(FormGroupContext);
    const sizeProp = formGroupContextSize || 'large';
    return (jsxRuntimeExports.jsxs(StyledFormSection, Object.assign({ "$isBorderless": isBorderless, "$size": sizeProp }, props, { children: [title && (jsxRuntimeExports.jsxs(StyledFormSectionHeader, { "$size": sizeProp, children: [jsxRuntimeExports.jsx(Heading, { as: "h3", "data-dd-privacy": isSensitiveData ? 'mask' : 'allow', size: sizeProp === 'large' ? 'medium' : 'small', sx: { margin: '0 !important' }, children: title }), tooltipContent && (jsxRuntimeExports.jsx(Tooltip, { content: tooltipContent, children: jsxRuntimeExports.jsx(Icon, { color: "primary", icon: "information" }) })), action && jsxRuntimeExports.jsx(StyledFormSectionHeaderAction, { children: action })] })), children] })));
}
const StyledFormSection = styled.section `
    margin: 0;
    padding: 0;
    padding-top: ${(props) => props.$size && props.theme.formSection[props.$size].paddingTop};
    margin-top: ${(props) => props.$size && props.theme.formSection[props.$size].marginTop};
    border-top: 1px solid var(--kds-color-border-minimal);

    &:first-of-type {
        padding: 0;
        margin: 0;
        border-top: none;
    }

    ${(props) => props.$isBorderless &&
    css$3 `
            padding: 0 !important;
            border-top: none !important;
        `}
    ${sx}
`;
const StyledFormSectionHeader = styled.div `
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: ${(props) => props.$size && props.theme.formSection[props.$size].header.marginBottom};
    min-height: 32px;
    gap: 8px;
`;
const StyledFormSectionHeaderAction = styled.div ``;

function FormSubsection({ children, title }) {
    const { size: formGroupContextSize } = useContext(FormGroupContext);
    const sizeProp = formGroupContextSize || 'large';
    return (jsxRuntimeExports.jsxs(StyledFormSubsection, { "$size": sizeProp, children: [title && (jsxRuntimeExports.jsx(Heading, { as: "h4", size: sizeProp === 'large' ? 'small' : 'xsmall', sx: { marginBottom: (theme) => theme.formSubsection[sizeProp].header.marginBottom }, children: title })), children] }));
}
const StyledFormSubsection = styled.section `
    margin: 0;
    padding: 0;
    margin-top: ${(props) => props.$size && props.theme.formSubsection[props.$size].marginTop};
`;

const RowContext = createContext({});

function getColWidth(span) {
    return `${Math.round((100 / 12) * span * 10e5) / 10e5}%`;
}
function Col(_a) {
    var { children, span } = _a, props = __rest(_a, ["children", "span"]);
    const { columnGap } = useContext(RowContext);
    return (jsxRuntimeExports.jsx(StyledCol, Object.assign({ "$columnGap": columnGap, span: span }, props, { children: children })));
}
const StyledCol = styled.div(css$2({
    flexGrow: 0,
    flexShrink: 0,
    position: 'relative',
}), variant({
    prop: 'span',
    variants: {
        1: {
            flexBasis: getColWidth(1),
            maxWidth: getColWidth(1),
        },
        2: {
            flexBasis: getColWidth(2),
            maxWidth: getColWidth(2),
        },
        3: {
            flexBasis: getColWidth(3),
            maxWidth: getColWidth(3),
        },
        4: {
            flexBasis: getColWidth(4),
            maxWidth: getColWidth(4),
        },
        5: {
            flexBasis: getColWidth(5),
            maxWidth: getColWidth(5),
        },
        6: {
            flexBasis: getColWidth(6),
            maxWidth: getColWidth(6),
        },
        7: {
            flexBasis: getColWidth(7),
            maxWidth: getColWidth(7),
        },
        8: {
            flexBasis: getColWidth(8),
            maxWidth: getColWidth(8),
        },
        9: {
            flexBasis: getColWidth(9),
            maxWidth: getColWidth(9),
        },
        10: {
            flexBasis: getColWidth(10),
            maxWidth: getColWidth(10),
        },
        11: {
            flexBasis: getColWidth(11),
            maxWidth: getColWidth(11),
        },
        12: {
            flexBasis: getColWidth(12),
            maxWidth: getColWidth(12),
        },
    },
}), (props) => !props.span &&
    css$2({
        width: 'auto',
    }), system({
    $columnGap: {
        properties: ['paddingLeft', 'paddingRight'],
        scale: 'space',
        transform: (value, scale) => {
            if (value !== null) {
                const gapValue = scale && scale[value / 2];
                return gapValue;
            }
            return value;
        },
    },
}));

/**### Row
 * Use only `Col` elements within `Row`.
 *
 * The column grid system is a value of 1-12 to represent its range spans.
 *
 * Three columns of equal width can be created by:
 * @example
 *```ts
 *      <Row>
 *          <Col span={4}/>
 *          <Col span={4}/>
 *          <Col span={4}/>
 *      </Row>
 * ```
 *
 * If the sum of col spans in a row are more than 12, then the overflowing col as a whole will start a new line arrangement.
 */
function Row(_a) {
    var { align, children, columnGap, rowGap, wrap = 'wrap' } = _a, props = __rest(_a, ["align", "children", "columnGap", "rowGap", "wrap"]);
    return (jsxRuntimeExports.jsx(RowContext.Provider, { value: { columnGap, rowGap }, children: jsxRuntimeExports.jsx(StyledRow, Object.assign({ "$columnGap": columnGap, "$rowGap": rowGap, align: align, wrap: wrap }, props, { children: children })) }));
}
const StyledRow = styled.div(css$2({
    display: 'flex',
    flexDirection: 'row',
    position: 'relative',
}), (props) => props.wrap &&
    css$2({
        flexWrap: props.wrap,
    }), (props) => props.align &&
    css$2({
        alignItems: props.align,
    }), (props) => props.$rowGap &&
    css$2({
        rowGap: props.$rowGap,
    }), system({
    $columnGap: {
        properties: ['marginLeft', 'marginRight'],
        scale: 'space',
        transform: (value, scale) => {
            if (value !== null) {
                const gapValue = scale && scale[value / 2];
                return '-' + gapValue;
            }
            return value;
        },
    },
}));

const HardwareTokenBack = () => (jsxRuntimeExports.jsxs("g", { fill: "none", fillRule: "evenodd", children: [jsxRuntimeExports.jsxs("g", { fillRule: "nonzero", children: [jsxRuntimeExports.jsx("path", { d: "M128.613 114.575c42.217 0 61.94 11.386 89.96-.644 28.98-12.442 35.788-33.244 35.788-52.479 0-21.246-4.728-44.77-39.192-57.334-26.903-9.808-50.41.983-88.06.983-44.022 0-56.184-9.547-86.106-.4C11.081 13.846 0 41.195 0 59.635c0 20.003 7.63 43.56 38.67 56.082 27.664 11.162 49.47-1.143 89.943-1.143v.001Z", fill: "#1C1B2B" }), jsxRuntimeExports.jsx("path", { d: "M58.238 25.132h147c12.564 1.31 20.155 4.753 22.774 10.33 3.156 6.721 6.942 13.191 6.68 24.216-.511 21.507-11.33 33.658-32.454 36.454h-144c-8.002-.437-14.374-2.767-19.115-6.99-7.766-6.92-14.242-16.209-14.021-28.664.195-11 4.214-19.582 10.672-25.912 5.959-5.84 13.447-8.986 22.464-9.434Z", fill: "#ECEDEC" }), jsxRuntimeExports.jsxs("g", { transform: "translate(61 38)", children: [jsxRuntimeExports.jsx("rect", { fill: "#000", height: "43", rx: "7", width: "105" }), jsxRuntimeExports.jsx("rect", { fill: "#F3F3F3", height: "43", rx: "7", width: "105" })] }), jsxRuntimeExports.jsx("path", { d: "M142 46h2v20h-2V46Zm6 0h1v20h-1V46Zm-3 0h2v20h-2V46Zm-26 0h1v20h-1V46Zm2 0h2v20h-2V46Zm-5 0h2v20h-2V46Z", fill: "#1C1B2B" }), jsxRuntimeExports.jsx("ellipse", { cx: "229.238", cy: "59.132", fill: "#1C1B2B", rx: "13", ry: "28" }), jsxRuntimeExports.jsx("ellipse", { cx: "237.238", cy: "57.632", fill: "#FFF", rx: "6", ry: "10.5" }), jsxRuntimeExports.jsx("path", { d: "M69 46h1v20h-1V46Zm2 0h1v20h-1V46Zm2 0h2v20h-2V46Zm3 0h1v20h-1V46Zm2 0h1v20h-1V46Zm8 0h1v20h-1V46Zm2 0h1v20h-1V46Zm2 0h1v20h-1V46Zm2 0h1v20h-1V46Zm-12 0h2v20h-2V46Zm3 0h2v20h-2V46Zm11 0h2v20h-2V46Zm3 0h1v20h-1V46Zm2 0h1v20h-1V46Zm2 0h1v20h-1V46Zm2 0h1v20h-1V46Zm2 0h2v20h-2V46Zm34 0h1v20h-1V46Zm2 0h1v20h-1V46Zm2 0h1v20h-1V46Zm2 0h2v20h-2V46Zm-21 0h1v20h-1V46Zm2 0h1v20h-1V46Zm2 0h2v20h-2V46Zm-17 0h1v20h-1V46Zm2 0h2v20h-2V46Zm-5 0h2v20h-2V46Zm23 0h2v20h-2V46Zm6 0h1v20h-1V46Zm-3 0h2v20h-2V46Zm16 0h1v20h-1V46Zm2 0h1v20h-1V46Zm2 0h1v20h-1V46Zm2 0h2v20h-2V46Z", fill: "#1C1B2B" }), jsxRuntimeExports.jsx("text", { fill: "#000", fontFamily: "ArialMT, Arial", fontSize: "10", children: jsxRuntimeExports.jsx("tspan", { x: "77.35", y: "77", children: "2608800100000" }) })] }), jsxRuntimeExports.jsx("path", { d: "M70 60h87v26H70z", stroke: "#FF37F0", strokeWidth: "2" }), jsxRuntimeExports.jsx("path", { d: "m176.887 65.779.095 5.999 17.502-.278 1-.016.032 2-1 .016-17.502.277.095 6L163 73z", fill: "#FF37F0", fillRule: "nonzero" })] }));

const HardwareTokenFront = () => (jsxRuntimeExports.jsxs("g", { transform: "translate(.76 .87)", children: [jsxRuntimeExports.jsx("path", { d: "M128.6 114.6c42.2 0 61.9 11.4 90-.6 29-12.4 35.8-33.2 35.8-52.5 0-21.2-4.7-44.8-39.2-57.3-26.9-9.8-50.4 1-88.1 1-44 0-56.2-9.5-86.1-.4S0 41.2 0 59.6c0 20 7.6 43.6 38.7 56.1 27.6 11.2 49.4-1.1 89.9-1.1z", fill: "#1C1B2B" }), jsxRuntimeExports.jsx("path", { d: "M58.2 25.1h147c12.6 1.3 20.2 4.8 22.8 10.3 3.2 6.7 6.9 13.2 6.7 24.2-.5 21.5-11.3 33.7-32.5 36.5h-144c-8-.4-14.4-2.8-19.1-7-7.8-6.9-14.2-16.2-14-28.7.2-11 4.2-19.6 10.7-25.9 5.9-5.8 13.4-8.9 22.4-9.4z", fill: "#DEDEE9" }), jsxRuntimeExports.jsxs("g", { transform: "translate(35.24 38.128)", children: [jsxRuntimeExports.jsx("circle", { cx: "22.5", cy: "22.5", fill: "#DD010A", r: "22.5" }), jsxRuntimeExports.jsx("circle", { cx: "22.5", cy: "22.5", fill: "#DEDEE9", r: "18.5" })] }), jsxRuntimeExports.jsx("path", { d: "M52.24 33.128h12v17h-12z", fill: "#DEDEE9" }), jsxRuntimeExports.jsx("path", { d: "M55.24 37.128h6v27h-6z", fill: "#DD010A" }), jsxRuntimeExports.jsx("g", { fill: "#DD010A", children: jsxRuntimeExports.jsx("path", { d: "M163.78 38.828v1.3h-4.9c.1-.5.2-.9.5-1.4.3-.4.8-1 1.5-1.7.6-.6 1-1 1.1-1.2.2-.3.3-.6.3-.8 0-.3-.1-.5-.2-.7-.1-.2-.4-.2-.6-.2-.3 0-.6 0-.7.2-.2.2-.3.5-.3.9l-1.4-.2c.1-.8.3-1.3.8-1.6s1-.5 1.6-.5c.7 0 1.2.2 1.7.6.4.4.6.9.6 1.4 0 .3-.1.6-.2.9-.1.3-.3.6-.6.9-.1.3-.4.6-.9 1-.4.4-.7.6-.8.7-.1.2-.2.3-.3.4h2.8zM166.98 32.928c.7 0 1.2.2 1.6.7.5.6.7 1.6.7 2.9 0 1.4-.2 2.3-.7 2.9-.4.6-.9.8-1.6.8s-1.3-.2-1.7-.8c-.4-.5-.6-1.5-.6-2.8s.2-2.3.7-2.9c.4-.5.9-.8 1.6-.8zm0 1.2c-.2 0-.3 0-.4.1-.2.1-.3.3-.3.6-.1.3-.2.9-.2 1.8s0 1.4.1 1.7c.1.3.2.5.3.6.2.1.3.2.5.2s.3-.1.4-.2c.2-.1.3-.3.4-.5.1-.4.1-.9.1-1.8s0-1.4-.1-1.7c-.1-.4-.2-.6-.4-.7-.1-.1-.2-.1-.4-.1zM172.58 32.928c.7 0 1.2.2 1.6.7.5.6.7 1.6.7 2.9 0 1.4-.2 2.3-.7 2.9-.4.5-.9.7-1.6.7-.7 0-1.3-.3-1.7-.8s-.6-1.5-.6-2.9c0-1.3.2-2.3.7-2.9.3-.3.9-.6 1.6-.6zm0 1.2c-.2 0-.3.1-.4.2-.1.1-.2.3-.3.6-.2.2-.2.8-.2 1.7s0 1.4.1 1.7c.1.3.2.5.3.6.2.1.3.2.5.2s.3-.1.4-.2c.1-.1.2-.3.3-.6.1-.4.1-.9.1-1.8s0-1.4-.1-1.7-.2-.5-.3-.6c-.1-.1-.3-.1-.4-.1z" }) }), jsxRuntimeExports.jsx("path", { d: "m156.98 35.728-1.6.3c-.1-.3-.2-.6-.4-.7s-.5-.3-.8-.3c-.4 0-.7.1-1 .4s-.3.8-.3 1.5.1 1.3.4 1.6.6.5 1 .5c.3 0 .6-.1.8-.3s.3-.5.4-.9l1.6.3c-.2.7-.5 1.3-1 1.7s-1.1.6-1.9.6c-.9 0-1.6-.3-2.2-.9s-.8-1.4-.8-2.4.3-1.8.8-2.4 1.3-.9 2.2-.9c.8 0 1.4.2 1.8.5s.8.7 1 1.4zM121.64 40.128c1.2 0 2.6-.1 3-.5s.6-1.9.6-3.1v-3c0-1.2-.2-2.8-.6-3.1-.4-.3-1.8-.5-3-.5h-3.8c-1.2 0-2.6.2-3 .5-.4.2-.6 1.9-.6 3.1v3c0 1.2.2 2.5.6 2.9.4.3 1.8.7 3 .7h3.8zm-4.4-2.6c-.3 0-.4-.1-.4-.4v-4.1c0-.1 0-.2.1-.3s.2-.1.3-.1h5.1c.3 0 .4.2.4.5v4.1c0 .3-.1.4-.4.4l-5.1-.1zm13.3 2.7c.4 0 1.1 0 1.4-.2.3-.3.2-.8.2-1.3v-6h1.1c.5 0 1.6 0 1.7-.1s.1-.8.1-1.3c0-.4-.1-1.1-.3-1.2-.2-.1-1.1-.2-1.6-.2h-5.2c-.5 0-1.7 0-1.9.2s-.1 1-.1 1.2 0 1.1.2 1.2 1.3.1 1.8.1h1l.1 6c0 .5-.1 1.1.2 1.4.3.3.9.2 1.3.2zm6.5 0c.8 0 1.2 0 1.4-.3.2-.3.1-.8.1-1.3v-1.8h2.4c1.3 0 4.1 0 4.5-.4.2-.3 1-1.9 1-2.9 0-1.3-.7-2.8-1.1-3.1-.4-.4-3.4-.4-4.4-.4h-4c-.5 0-1.1 0-1.2.1s-.2.8-.2 1.3 0 1 .1 1.1.7.2 1.2.2h6.2c.4 0 .7.4.6.9 0 .4-.1.5-.3.6-.6.2-1.9.2-2.2.2h-3.9c-.6 0-1.5 0-1.6.2s-.2.7-.2 1.3v2.8c0 .5 0 1 .2 1.3.3.1.4.1 1.4.2z" }), jsxRuntimeExports.jsxs("g", { children: [jsxRuntimeExports.jsx("path", { d: "M104.24 44.128h87c2.8 0 5 2.2 5 5v23c0 2.8-2.2 5-5 5h-87c-2.8 0-5-2.2-5-5v-23c0-2.8 2.2-5 5-5z", fill: "#191F17" }), jsxRuntimeExports.jsx("path", { d: "M108.24 49.128h80c1.7 0 3 1.3 3 3v17c0 1.7-1.3 3-3 3h-80c-1.7 0-3-1.3-3-3v-17c0-1.7 1.3-3 3-3z", fill: "#6C8278" }), jsxRuntimeExports.jsx("path", { d: "M191.24 51.128v18c0 1.7-1.3 3-3 3h-80l83-21z", fill: "#9B9F97" }), jsxRuntimeExports.jsxs("g", { children: [jsxRuntimeExports.jsx("path", { d: "m124.84 61.028.4-.3.5-5.3c-.1-.5-.4-.8-.9-1l-.6 1.5-.4 4 1 1.1zm-7.2 0 1.3-1.1.3-4.2-1.4-.6-.6 5.6.4.3zm6 1 .8-.8-.7-.7h-5l-.8.7.7.8h5zm-.1 6.1c.5-.1.9-.4 1-1l.5-5.3-.2-.4-1.3 1.2-.4 4 .4 1.5zm10.2-12.2.7-1.5h-5.7c-.5.1-.9.4-1.1 1l1.6.5h4.5zm1 5.1.5-.3.5-5.3c-.1-.5-.4-.8-.9-1l-.7 1.5-.4 4 1 1.1zm-7.2 0 1.3-1.1.4-3.6-1.5-.6-.5 5 .3.3zm6 1 .8-.8-.7-.8h-5l-.8.8.7.8h5zm0 6.1c.5-.1.9-.4 1-1l.5-5.3-.3-.4-1.3 1.1-.4 4 .5 1.6zm-.4 0-.4-1.5h-4.6l-1.6.5c.1.5.4.8.9 1h5.7zm10.6-12.2.7-1.5h-5.7c-.5.1-.9.4-1 1l1.5.6 4.5-.1zm1 5.1.4-.4.5-5.3c-.1-.5-.4-.8-.9-1l-.7 1.5-.4 4 1.1 1.2zm-1.3 1 .8-.8-.7-.8h-5l-.8.8.7.8h5zm0 6.1c.5-.1.9-.4 1-1l.5-5.3-.3-.4-1.3 1.1-.4 4 .5 1.6zm-.4 0-.4-1.5h-4.6l-1.6.5c.1.5.4.8.9 1h5.7zm16.3-12.2.7-1.5h-5.7c-.5.1-.9.4-1 1l1.5.6 4.5-.1zm1 5.1.4-.4.5-5.3c-.1-.5-.4-.8-.9-1l-.7 1.5-.4 4 1.1 1.2zm-1.2 1 .8-.8-.7-.7h-5l-.8.8.7.8h5v-.1zm-.1 6.1c.5-.1.9-.4 1-1l.5-5.3-.3-.4-1.3 1.1-.4 4 .5 1.6zm-.3 0-.5-1.5h-4.6l-1.5.5c.1.5.4.8.9 1h5.7zm10.5-12.2.7-1.5h-5.7c-.5.1-.9.4-1 1l1.5.6 4.5-.1zm1 5.1.4-.4.6-5.3c-.1-.5-.4-.8-.9-1l-.7 1.5-.4 4 1 1.2zm-1.2 1 .8-.8-.6-.7h-5l-.8.8.7.8h4.9v-.1zm0 6.1c.5-.1.9-.4 1-1l.5-5.3-.3-.4-1.3 1.1-.4 4 .5 1.6zm-.4 0-.4-1.5h-4.6l-1.6.5c.1.5.4.8.9 1h5.7zm11.1-12.2.7-1.5h-6.2c-.5.1-.9.4-1 1l1.5.6 5-.1zm-6.8 5.1 1.3-1.1.4-3.6-1.5-.6-.5 5 .3.3zm6 1 .8-.8-.7-.8h-5l-.8.8.7.8h5zm0 6.1c.5-.1.9-.4 1-1l.5-5.3-.3-.4-1.3 1.1-.4 4 .5 1.6zm-.4 0-.4-1.5h-4.6l-1.6.5c.1.5.4.8.9 1h5.7z" }), jsxRuntimeExports.jsx("path", { d: "m124.84 61.028.4-.3.5-5.3c-.1-.5-.4-.8-.9-1l-.6 1.5-.4 4 1 1.1zm-7.2 0 1.3-1.1.3-4.2-1.4-.6-.6 5.6.4.3zm6 1 .8-.8-.7-.7h-5l-.8.7.7.8h5zm-.1 6.1c.5-.1.9-.4 1-1l.5-5.3-.2-.4-1.3 1.2-.4 4 .4 1.5zm10.2-12.2.7-1.5h-5.7c-.5.1-.9.4-1.1 1l1.6.5h4.5zm1 5.1.5-.3.5-5.3c-.1-.5-.4-.8-.9-1l-.7 1.5-.4 4 1 1.1zm-7.2 0 1.3-1.1.4-3.6-1.5-.6-.5 5 .3.3zm6 1 .8-.8-.7-.8h-5l-.8.8.7.8h5zm0 6.1c.5-.1.9-.4 1-1l.5-5.3-.3-.4-1.3 1.1-.4 4 .5 1.6zm-.4 0-.4-1.5h-4.6l-1.6.5c.1.5.4.8.9 1h5.7zm10.6-12.2.7-1.5h-5.7c-.5.1-.9.4-1 1l1.5.6 4.5-.1zm1 5.1.4-.4.5-5.3c-.1-.5-.4-.8-.9-1l-.7 1.5-.4 4 1.1 1.2zm-1.3 1 .8-.8-.7-.8h-5l-.8.8.7.8h5zm0 6.1c.5-.1.9-.4 1-1l.5-5.3-.3-.4-1.3 1.1-.4 4 .5 1.6zm-.4 0-.4-1.5h-4.6l-1.6.5c.1.5.4.8.9 1h5.7zm16.3-12.2.7-1.5h-5.7c-.5.1-.9.4-1 1l1.5.6 4.5-.1zm1 5.1.4-.4.5-5.3c-.1-.5-.4-.8-.9-1l-.7 1.5-.4 4 1.1 1.2zm-1.2 1 .8-.8-.7-.7h-5l-.8.8.7.8h5v-.1zm-.1 6.1c.5-.1.9-.4 1-1l.5-5.3-.3-.4-1.3 1.1-.4 4 .5 1.6zm-.3 0-.5-1.5h-4.6l-1.5.5c.1.5.4.8.9 1h5.7zm10.5-12.2.7-1.5h-5.7c-.5.1-.9.4-1 1l1.5.6 4.5-.1zm1 5.1.4-.4.6-5.3c-.1-.5-.4-.8-.9-1l-.7 1.5-.4 4 1 1.2zm-1.2 1 .8-.8-.6-.7h-5l-.8.8.7.8h4.9v-.1zm0 6.1c.5-.1.9-.4 1-1l.5-5.3-.3-.4-1.3 1.1-.4 4 .5 1.6zm-.4 0-.4-1.5h-4.6l-1.6.5c.1.5.4.8.9 1h5.7zm11.1-12.2.7-1.5h-6.2c-.5.1-.9.4-1 1l1.5.6 5-.1zm-6.8 5.1 1.3-1.1.4-3.6-1.5-.6-.5 5 .3.3zm6 1 .8-.8-.7-.8h-5l-.8.8.7.8h5zm0 6.1c.5-.1.9-.4 1-1l.5-5.3-.3-.4-1.3 1.1-.4 4 .5 1.6zm-.4 0-.4-1.5h-4.6l-1.6.5c.1.5.4.8.9 1h5.7z" })] })] }), jsxRuntimeExports.jsx("g", { children: jsxRuntimeExports.jsx("path", { d: "M101.14 84.428c.5 0 1.7.2 1.7 1.9s-1.2 1.9-1.7 1.9-1.7-.2-1.7-1.9 1.3-1.9 1.7-1.9zm0 3.2c.4 0 1-.2 1-1.3s-.6-1.3-1-1.3-1 .2-1 1.3.6 1.3 1 1.3zM105.74 84.528h.7v3.6h-.8l-1.5-2.6v2.6h-.7v-3.6h.8l1.4 2.5.1-2.5zM109.74 85.128h-1.9v.8h1.8v.6h-1.8v.9h2v.7h-2.7v-3.6h2.6v.6zM112.84 88.128h-.8v-3h-1.1v-.6h2.9v.6h-1.1v3h.1zM115.14 88.128h-.8v-3.6h.8v3.6zM119.24 88.128h-.7v-3l-.7 3h-.7l-.7-3v3h-.7v-3.6h1.1l.7 2.8.6-2.8h1.1v3.6zM122.64 85.128h-1.9v.8h1.8v.6h-1.8v.9h2v.7h-2.7v-3.6h2.6v.6zM125.44 88.128h-.8v-3.6h1.6c.7 0 1.1.4 1.1 1.2 0 .3-.2 1.1-1.1 1.1h-.9l.1 1.3zm.7-1.9c.6 0 .6-.4.6-.6 0-.4-.2-.5-.7-.5h-.6v1.1h.7zM128.04 88.128h-.8l1.3-3.6h.9l1.2 3.6h-.8l-.2-.7h-1.4l-.2.7zm.4-1.4h.9l-.4-1.4-.5 1.4zM131.64 87.028c0 .2.1.6.8.6.4 0 .8-.1.8-.5 0-.3-.3-.4-.7-.4l-.4-.1c-.6-.1-1.1-.3-1.1-1.1 0-.4.2-1.1 1.4-1.1 1.1 0 1.4.7 1.4 1.2h-.7c0-.2-.1-.5-.7-.5-.3 0-.6.1-.6.4s.2.3.4.4l.7.2c.5.1.9.3.9 1 0 1.1-1.1 1.2-1.4 1.2-1.3 0-1.5-.8-1.5-1.2l.7-.1zM135.04 87.028c0 .2.1.6.8.6.4 0 .8-.1.8-.5 0-.3-.3-.4-.7-.4l-.4-.1c-.6-.1-1.1-.3-1.1-1.1 0-.4.2-1.1 1.4-1.1 1.1 0 1.4.7 1.4 1.2h-.7c0-.2-.1-.5-.7-.5-.3 0-.6.1-.6.4s.2.3.4.4l.6.2c.5.1.9.3.9 1 0 1.1-1.1 1.2-1.4 1.2-1.3 0-1.5-.8-1.5-1.2l.8-.1zM137.54 84.528h.8c.5 2 .5 2.2.6 2.6.1-.4.1-.7.5-2.6h.8c.4 2 .5 2.2.5 2.6.1-.3.1-.7.6-2.6h.8l-1 3.6h-.7c-.4-1.8-.4-2.1-.6-2.8-.1.7-.2 1-.6 2.8h-.7l-1-3.6zM143.94 84.428c.5 0 1.7.2 1.7 1.9s-1.3 1.9-1.7 1.9-1.7-.2-1.7-1.9 1.3-1.9 1.7-1.9zm0 3.2c.4 0 1-.2 1-1.3s-.6-1.3-1-1.3-1 .2-1 1.3.6 1.3 1 1.3zM146.34 84.528h1.8c1 0 1.1.7 1.1 1 0 .4-.2.7-.6.9.3.1.5.2.5.9 0 .5 0 .7.2.7v.1h-.8c-.1-.2-.1-.4-.1-.7 0-.5 0-.7-.6-.7h-.8v1.4h-.7v-3.6zm1.6 1.6c.4 0 .6-.1.6-.5 0-.2-.1-.5-.5-.5h-.9v1h.8zM149.94 84.528h1.6c1.2 0 1.5 1 1.5 1.7 0 .8-.3 1.9-1.5 1.9h-1.6v-3.6zm.7 3h.7c.6 0 .8-.6.8-1.2.1-1.1-.4-1.2-.8-1.2h-.7v2.4z" }) }), jsxRuntimeExports.jsx("ellipse", { cx: "229.2", cy: "59.1", fill: "#1C1B2B", rx: "13", ry: "28" }), jsxRuntimeExports.jsx("ellipse", { cx: "237.2", cy: "57.6", fill: "#FFF", rx: "6", ry: "10.5" })] }));

function HardwareToken(_a) {
    var { height = '100%', id, variant = 'front', width = '100%' } = _a, props = __rest(_a, ["height", "id", "variant", "width"]);
    return (jsxRuntimeExports.jsx("svg", Object.assign({ height: height, id: id, viewBox: "0 0 255 121", width: width, xmlns: "http://www.w3.org/2000/svg" }, props, { children: getTokenSide(variant) })));
}
function getTokenSide(variant) {
    switch (variant) {
        case 'front':
            return jsxRuntimeExports.jsx(HardwareTokenFront, {});
        case 'back':
            return jsxRuntimeExports.jsx(HardwareTokenBack, {});
        default:
            return null;
    }
}

function HeaderEnvLabel({ children, sx: sxProp }) {
    return jsxRuntimeExports.jsx(StyledHeaderEnvLabel, { sx: sxProp, children: children });
}
const StyledHeaderEnvLabel = styled.div `
    color: var(--kds-color-warning-700);
    font-weight: 700;
    font-size: 0.75rem;
    padding-right: 24px;

    ${sx}
`;

function HeaderItem(_a) {
    var { children, sx: sxProp } = _a, props = __rest(_a, ["children", "sx"]);
    return (jsxRuntimeExports.jsx(StyledHeaderItem, Object.assign({ sx: sxProp }, props, { children: children })));
}
const StyledHeaderItem = styled.div `
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    align-self: stretch;

    ${sx}
`;

function Header({ children, sx: sxProp }) {
    return jsxRuntimeExports.jsx(StyledHeader$2, { sx: sxProp, children: children });
}
const StyledHeader$2 = styled.header `
    display: flex;
    flex-wrap: nowrap;
    align-items: start;
    font-size: 14px;
    line-height: 1.5;
    background-color: white;
    box-shadow: 0 1px 0 0 var(--kds-color-border-minimal);
    padding: 0 16px;
    transition: all 0.2s ease;
    position: fixed;
    width: 100%;
    z-index: ${(props) => props.theme.zIndices.navbar};
    height: ${(props) => props.theme.appLayout.header.height};

    ${(props) => props.theme.mediaQueries.large} {
        padding-left: 24px;
        padding-right: 24px;
    }

    ${sx}
`;
Header.Item = HeaderItem;
Header.EnvLabel = HeaderEnvLabel;

const iconCircleSizes = {
    medium: '36px',
    small: '32px',
};
const accentColor = {
    primary: 'blue700',
    secondary: 'magenta700',
};
function getIconCircleSize(size) {
    if (typeof size === 'string') {
        if (size === 'small') {
            return 16;
        }
        if (size === 'medium') {
            return 18;
        }
        return undefined;
    }
    if (typeof size === 'number') {
        return size * 0.5;
    }
    return undefined;
}
function IconCircle(_a) {
    var { background = 'transparent', color, hasBorder = false, icon = 'question', size = 'medium' } = _a, props = __rest(_a, ["background", "color", "hasBorder", "icon", "size"]);
    const iconCircleSize = getIconCircleSize(size);
    return (jsxRuntimeExports.jsx(StyledIconCircle$2, Object.assign({ "$background": background, "$color": color, "$hasBorder": hasBorder, "$size": size }, props, { children: jsxRuntimeExports.jsx(Icon, { color: "inherit", icon: icon, size: iconCircleSize }) })));
}
const StyledIconCircle$2 = styled.div `
    box-sizing: border-box;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: ${(props) => props.theme.radii.full};
    box-shadow: none;
    padding: 0;
    position: relative;
    background-color: ${(props) => props.$background || props.theme.colors.transparent};
    height: ${(props) => (typeof props.$size === 'string' ? iconCircleSizes[props.$size] : `${props.$size}px`)};
    width: ${(props) => (typeof props.$size === 'string' ? iconCircleSizes[props.$size] : `${props.$size}px`)};
    color: ${(props) => (props.$color ? props.theme.colors[accentColor[props.$color]] : props.theme.colors.neutral800)};

    ${(props) => props.$hasBorder &&
    css$3 `
            border: 1px solid var(--kds-color-border-minimal);
        `};
    ${sx}
`;

function useControllableProp(prop, state) {
    const isControlled = prop !== undefined;
    const value = isControlled && prop !== undefined ? prop : state;
    return [isControlled, value];
}

const useMergeRefs = (...refs) => (element) => refs.forEach((ref) => {
    if (typeof ref === 'function') {
        ref(element);
    }
    else if (ref && typeof ref === 'object') {
        ref.current = element;
    }
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function usePrevious(value) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const ref = useRef();
    useEffect(() => {
        ref.current = value;
    });
    return ref.current;
}

function KsyosLogo(_a) {
    var { height = '33px', width = '99px' } = _a, props = __rest(_a, ["height", "width"]);
    const id = useUniqueId();
    return (jsxRuntimeExports.jsxs("svg", Object.assign({ "aria-label": "Ksyos logo", height: height, id: "Logo", viewBox: "0 0 209.8 63.8", width: width, xmlns: "http://www.w3.org/2000/svg" }, props, { children: [jsxRuntimeExports.jsx("path", { d: "M65.7 30.5l13.8 19.9H68.3L57.2 34v16.3H48V-.1h9.2v28l11-14.5H79L65.7 30.5zm95.9-17.7c11.6 0 19.3 8.1 19.3 19 0 10.8-7.9 19.1-19.3 19.1-11.5 0-19.2-8.1-19.2-19-.1-10.9 8.1-19.1 19.2-19.1zm0 29.8c6.1 0 10-4.5 10-10.7s-4.1-10.8-10.1-10.8c-6.1 0-10 4.5-10 10.8.1 6.2 4.2 10.7 10.1 10.7zm34.2-15.9c1.7.5 3.2.8 5 1.3 5.9 1.8 8.8 4.7 8.8 11.4 0 7.5-6.2 11.4-13.4 11.4-10.2 0-13.4-6-13.2-12.4h8.8c0 2.6.9 5 4.5 5 2.4 0 4.3-1.2 4.3-3.3s-1.1-3.1-3.7-3.8c-2-.6-3.6-.9-5.6-1.7-5.1-1.9-7.6-5.3-7.6-10.9 0-6.2 5.2-10.8 12.6-10.8 7.8 0 12.4 3.9 12.5 11.6h-8.5c-.1-2.8-1.4-4.5-4.2-4.5-2.2 0-3.7 1.2-3.7 3.1.2 1.9 1.2 2.9 3.4 3.6z", fill: "#322a24" }), jsxRuntimeExports.jsx("path", { d: "M91.4 26.7c1.7.5 3.2.8 5 1.3 5.9 1.8 8.8 4.7 8.8 11.4 0 7.5-6.2 11.4-13.4 11.4-10.2 0-13.4-6-13.2-12.4h8.8c0 2.6.9 5 4.5 5 2.4 0 4.3-1.2 4.3-3.3s-1.1-3.1-3.7-3.8c-2-.6-3.6-.9-5.6-1.7-5.1-1.9-7.7-5.3-7.7-10.9 0-6.2 5.2-10.8 12.6-10.8 7.8 0 12.4 3.9 12.5 11.6H96c-.1-2.8-1.4-4.5-4.2-4.5-2.2 0-3.7 1.2-3.7 3.1.1 1.9 1.1 2.9 3.3 3.6zm42.1-13.3l-8.8 25.4-9.4-25.4h-9.6l13.7 35.9c-2.4 5.8-8.6 5.5-8.6 5.5v8.9c.5.1 1.2.1 1.8.1 3.1 0 7-1.2 10.4-4.2 3.4-3 5.6-6.7 8-12.8 2-5.2 3.7-9.8 5.2-14l7.3-19.3-10-.1z", fill: "#322a24" }), jsxRuntimeExports.jsx("path", { d: "M-36.9-37h283.5v137.5H-36.9z", style: { fill: 'none' } }), jsxRuntimeExports.jsxs("linearGradient", { gradientTransform: "translate(174.275 -949.851)", gradientUnits: "userSpaceOnUse", id: `SVGID_1_${id}`, x1: "-132.214", x2: "-169.214", y1: "972.718", y2: "943.292", children: [jsxRuntimeExports.jsx("stop", { offset: ".33", stopColor: "#ff9a1e", stopOpacity: "0" }), jsxRuntimeExports.jsx("stop", { offset: ".71", stopColor: "#ff9a1e" })] }), jsxRuntimeExports.jsx("path", { d: "M38.7-.1H0l19.3 25.2z", fill: `url(#SVGID_1_${id})` }), jsxRuntimeExports.jsxs("linearGradient", { gradientTransform: "translate(174.275 -949.851)", gradientUnits: "userSpaceOnUse", id: `SVGID_2_${id}`, x1: "-171.049", x2: "-136.825", y1: "981.015", y2: "1015.861", children: [jsxRuntimeExports.jsx("stop", { offset: ".07", stopColor: "#ff37f0" }), jsxRuntimeExports.jsx("stop", { offset: ".755", stopColor: "#ff37f0", stopOpacity: "0" })] }), jsxRuntimeExports.jsx("path", { d: "M0 50.3h38.7L19.3 25.1z", fill: `url(#SVGID_2_${id})` }), jsxRuntimeExports.jsxs("linearGradient", { gradientTransform: "translate(191.76 -949.851)", gradientUnits: "userSpaceOnUse", id: `SVGID_3_${id}`, x1: "-167.106", x2: "-204.105", y1: "994.604", y2: "965.177", children: [jsxRuntimeExports.jsx("stop", { offset: ".352", stopColor: "#ff5ae2" }), jsxRuntimeExports.jsx("stop", { offset: ".655", stopColor: "#ff211c" })] }), jsxRuntimeExports.jsx("path", { d: "M0-.1v50.4l19.3-25.2z", fill: `url(#SVGID_3_${id})` })] })));
}

const ListContext = createContext({});

function ListItem(_a) {
    var { children, icon, iconColor = 'secondary', isSensitiveData = false } = _a, props = __rest(_a, ["children", "icon", "iconColor", "isSensitiveData"]);
    const { color, counterColor, counterFontWeight, size, styleType } = useContext(ListContext);
    return (jsxRuntimeExports.jsxs(StyledListItem, Object.assign({ "$color": color, "$counterColor": counterColor, "$counterFontWeight": counterFontWeight, "$icon": icon, "$iconColor": iconColor, "$size": size, "$styleType": styleType, "data-dd-privacy": isSensitiveData ? 'mask' : 'allow' }, props, { children: [icon && (jsxRuntimeExports.jsx(Icon, { color: iconColor, icon: icon, size: size === 'small' ? 16 : 18, sx: {
                    flexShrink: 0,
                    mr: size === 'small' ? 2 : 4,
                    mt: size === 'small' ? '2px' : '3px',
                } })), children] })));
}
const StyledListItem = styled.li `
    font-weight: var(--kds-font-weight-normal);

    ${({ $color }) => $color &&
    css$3 `
            color: ${textColor[$color]};
        `}

    ${({ $icon }) => $icon &&
    css$3 `
            display: flex;
        `}
    ${({ $size }) => $size === 'small' &&
    css$3 `
            font-size: var(--kds-font-size-sm);
            line-height: var(--kds-line-height-5);

            &:not(:last-child) {
                margin: 0 0 4px;
            }
        `}
        ${({ $size }) => $size === 'medium' &&
    css$3 `
            font-size: var(--kds-font-size-md);
            line-height: var(--kds-line-height-6);

            &:not(:last-child) {
                margin: 0 0 8px;
            }
        `}
        ${({ $counterColor, $counterFontWeight, $size, $styleType, theme }) => $styleType === 'counter' &&
    css$3 `
            counter-increment: counter;
            position: relative;

            &::before {
                content: counter(counter) '. ';
                position: absolute;
                left: ${$size === 'small' ? '-20px' : '-24px'};
                color: ${$counterColor && textColor[$counterColor]};
                font-weight: ${$counterFontWeight && theme.fontWeights[$counterFontWeight]};
            }
        `}
        ${({ $color, $styleType }) => $styleType === 'bullet' &&
    css$3 `
            &::marker {
                color: ${$color && textColor[$color]};
            }
        `}
        ${sx};
`;

const baseStyles = {
    margin: 0,
    padding: 0,
};
function getStyles(styleType, size, sx) {
    if (styleType === 'counter') {
        return Object.assign(Object.assign(Object.assign({}, baseStyles), { counterReset: 'counter', listStyle: 'none', paddingLeft: size === 'small' ? '20px' : '24px' }), sx);
    }
    if (styleType === 'bullet') {
        return Object.assign(Object.assign(Object.assign({}, baseStyles), { listStyle: 'disc outside', paddingLeft: size === 'small' ? '16px' : '20px' }), sx);
    }
    return Object.assign(Object.assign(Object.assign({}, baseStyles), { listStyle: 'none' }), sx);
}
function List({ children, color = 'inherit', counterColor = 'inherit', counterFontWeight = 'normal', size = 'medium', styleType = 'none', sx, }) {
    const elementTag = styleType === 'counter' ? 'ol' : 'ul';
    return (jsxRuntimeExports.jsx(ListContext.Provider, { value: { color, counterColor, counterFontWeight, size, styleType }, children: jsxRuntimeExports.jsx(Box, { as: elementTag, sx: getStyles(styleType, size, sx), children: children }) }));
}
List.Item = ListItem;

const getSize = (size) => {
    if (size === 'small') {
        return 64;
    }
    if (size === 'medium') {
        return 96;
    }
    if (size === 'large') {
        return 128;
    }
    return;
};
function Loader(_a) {
    var { size = 'small', sx: sxProp } = _a, props = __rest(_a, ["size", "sx"]);
    return (jsxRuntimeExports.jsx(StyledLoader, Object.assign({ "$size": size, sx: sxProp }, props, { children: jsxRuntimeExports.jsxs("svg", { viewBox: "0 0 117.293 117.292", children: [jsxRuntimeExports.jsxs("defs", { children: [jsxRuntimeExports.jsxs("linearGradient", { id: "left", x1: "48.7646216%", x2: "30.9646012%", y1: "72.5283907%", y2: "36.9283498%", children: [jsxRuntimeExports.jsx("stop", { offset: "20%", stopColor: "#E871CA" }), jsxRuntimeExports.jsx("stop", { offset: "100%", stopColor: "#EA3D2F" })] }), jsxRuntimeExports.jsxs("linearGradient", { id: "right", x1: "63.8377099%", x2: "43.0482138%", y1: "52.6736691%", y2: "11.0962384%", children: [jsxRuntimeExports.jsx("stop", { offset: "0%", stopColor: "#F4F4F2" }), jsxRuntimeExports.jsx("stop", { offset: "70%", stopColor: "#F4F4F2" })] }), jsxRuntimeExports.jsxs("linearGradient", { id: "bottom", x1: "61.6626738%", x2: "-0.207173489%", y1: "68.3308609%", y2: "37.396201%", children: [jsxRuntimeExports.jsx("stop", { offset: "0%", stopColor: "#E871CA" }), jsxRuntimeExports.jsx("stop", { offset: "51%", stopColor: "#F086F0" })] }), jsxRuntimeExports.jsxs("linearGradient", { id: "top", x1: "75.4512204%", x2: "36.5153931%", y1: "50.2255017%", y2: "30.757754%", children: [jsxRuntimeExports.jsx("stop", { offset: "0%", stopColor: "#F6E9D4" }), jsxRuntimeExports.jsx("stop", { offset: "97%", stopColor: "#F19E41" })] })] }), jsxRuntimeExports.jsx("g", { fillRule: "evenodd", stroke: "none", strokeWidth: "1", children: jsxRuntimeExports.jsxs("g", { fill: "none", fillRule: "nonzero", children: [jsxRuntimeExports.jsx("polygon", { fill: "url(#left)", points: "58.646 58.646 0 117.292 0 0" }), jsxRuntimeExports.jsx("polygon", { fill: "url(#right)", points: "58.646 58.646 117.293 0 117.293 117.292" }), jsxRuntimeExports.jsx("polygon", { fill: "url(#bottom)", points: "58.646 58.646 117.293 117.292 0 117.292" }), jsxRuntimeExports.jsx("polygon", { fill: "url(#top)", points: "58.646 58.646 117.293 0 0 0" })] }) })] }) })));
}
const StyledLoader = styled.div `
    width: ${(props) => props.$size && getSize(props.$size)}px;
    height: ${(props) => props.$size && getSize(props.$size)}px;
    z-index: 1;

    svg {
        width: 100%;
        height: 100%;
    }

    stop {
        animation-duration: 3s;
        animation-iteration-count: infinite;
        transition: all;
    }

    #left stop:first-child {
        animation-name: animation-left-1;
    }

    #left stop:last-child {
        animation-name: animation-left-2;
    }

    #right stop:first-child {
        animation-name: animation-right-1;
    }

    #right stop:last-child {
        animation-name: animation-right-2;
    }

    #bottom stop:first-child {
        animation-name: animation-bottom-1;
    }

    #bottom stop:last-child {
        animation-name: animation-bottom-2;
    }

    #top stop:first-child {
        animation-name: animation-top-1;
    }

    #top stop:last-child {
        animation-name: animation-top-2;
    }

    @keyframes animation-left-1 {
        0% {
            stop-color: #e871ca;
        }

        12% {
            stop-color: #f9dbfa;
        }

        24% {
            stop-color: #f084ef;
        }

        36% {
            stop-color: #ef7aee;
        }

        48% {
            stop-color: #e871ca;
        }

        100% {
            stop-color: #e871ca;
        }
    }

    @keyframes animation-left-2 {
        0% {
            stop-color: #ea3d2f;
        }

        12% {
            stop-color: #eb4fe9;
        }

        24% {
            stop-color: #eb4fe9;
        }

        36% {
            stop-color: #eb4fe9;
        }

        48% {
            stop-color: #ea3d2f;
        }

        100% {
            stop-color: #ea3d2f;
        }
    }

    @keyframes animation-right-1 {
        0% {
            stop-color: #f4f4f2;
        }

        12% {
            stop-color: #f6ebd6;
        }

        24% {
            stop-color: #f8eddc;
        }

        36% {
            stop-color: #edad5e;
        }

        48% {
            stop-color: #f4f4f2;
        }

        100% {
            stop-color: #f4f4f2;
        }
    }

    @keyframes animation-right-2 {
        0% {
            stop-color: #f4f4f2;
        }

        12% {
            stop-color: #f0963f;
        }

        24% {
            stop-color: #efaf5e;
        }

        36% {
            stop-color: #fff;
        }

        48% {
            stop-color: #f4f4f2;
        }

        100% {
            stop-color: #f4f4f2;
        }
    }

    @keyframes animation-bottom-1 {
        0% {
            stop-color: #e871ca;
        }

        12% {
            stop-color: #f4f4f2;
        }

        24% {
            stop-color: #fadcfa;
        }

        36% {
            stop-color: #edb89b;
        }

        48% {
            stop-color: #e871ca;
        }

        100% {
            stop-color: #e871ca;
        }
    }

    @keyframes animation-bottom-2 {
        0% {
            stop-color: #f086f0;
        }

        12% {
            stop-color: #f4f4f2;
        }

        24% {
            stop-color: #f084ef;
        }

        36% {
            stop-color: #ec5733;
        }

        48% {
            stop-color: #f086f0;
        }

        100% {
            stop-color: #f086f0;
        }
    }

    @keyframes animation-top-1 {
        0% {
            stop-color: #f6e9d4;
        }

        12% {
            stop-color: #f0963f;
        }

        24% {
            stop-color: #efaf5e;
        }

        36% {
            stop-color: #f4f4f2;
        }

        48% {
            stop-color: #f6e9d4;
        }

        100% {
            stop-color: #f6e9d4;
        }
    }

    @keyframes animation-top-2 {
        0% {
            stop-color: #f19e41;
        }

        12% {
            stop-color: #ea3d2f;
        }

        24% {
            stop-color: #f19e41;
        }

        36% {
            stop-color: #f4f4f2;
        }

        48% {
            stop-color: #f19e41;
        }

        100% {
            stop-color: #f19e41;
        }
    }

    ${sx}
`;

const ModalContext = createContext({});

function ModalBody(_a) {
    var { children, sx: sxProp } = _a, props = __rest(_a, ["children", "sx"]);
    const { size } = useContext(ModalContext);
    return (jsxRuntimeExports.jsx(StyledModalBody, Object.assign({ "$size": size, sx: sxProp }, props, { children: children })));
}
const StyledModalBody = styled.div(css$2({
    flex: 1,
    px: [4, 8],
}), (props) => props.$size === 'fullscreen' &&
    css$2({
        overflow: 'auto',
    }), sx);

function ModalCloseButton(_a) {
    var { children, icon = 'close', labelText = 'close', size = 'medium', variant = 'default' } = _a, props = __rest(_a, ["children", "icon", "labelText", "size", "variant"]);
    const { onClose } = useContext(ModalContext);
    return (jsxRuntimeExports.jsx(StyledModalCloseButton, Object.assign({ icon: icon, labelText: labelText, onClick: onClose, size: size, sx: sx, variant: variant }, props, { children: children })));
}
const StyledModalCloseButton = styled(IconButton)(css$2({
    position: 'absolute',
    right: [2, 4],
    top: [2, 4],
}), sx);

function ModalFooter(_a) {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (jsxRuntimeExports.jsx(StyledButtonRow, Object.assign({ isStackedBelowSmall: true, justify: "right", sx: sx }, props, { children: children })));
}
const StyledButtonRow = styled(ButtonRow)(css$2({
    p: [4, 8],
}), sx);

function ModalFootnote({ children, sx }) {
    return (jsxRuntimeExports.jsx(Box, { alignContent: "center", bg: "neutral200", borderBottomLeftRadius: "sm", borderBottomRightRadius: "sm", display: "flex", fontSize: "md", justifyContent: "center", lineHeight: 6, px: [6, 8], py: 4, sx: sx, children: children }));
}

function ModalHeader(_a) {
    var { children } = _a, props = __rest(_a, ["children"]);
    const { size } = useContext(ModalContext);
    return (jsxRuntimeExports.jsx(StyledHeader$1, Object.assign({ size: size }, props, { children: children })));
}
const StyledHeader$1 = styled.header(css$2({
    color: 'neutral700',
    fontWeight: 'bold',
    paddingBottom: 4,
    paddingTop: [4, 8],
    px: [4, 8],
}), (props) => (props.size === 'small' || props.size === 'medium') &&
    css$2({
        fontSize: ['lg', 'xl'],
        lineHeight: 7,
    }), (props) => (props.size === 'large' || props.size === 'xlarge' || props.size === 'fullscreen') &&
    css$2({
        fontSize: ['lg', 'xl', null, '2xl'],
        lineHeight: [7, null, null, 8],
    }), sx);

function Modal(_a) {
    var { children, closeOnEsc = true, closeOnOverlayClick = false, isOpen = false, onClose, onCloseComplete, size = 'small' } = _a, props = __rest(_a, ["children", "closeOnEsc", "closeOnOverlayClick", "isOpen", "onClose", "onCloseComplete", "size"]);
    const modalRef = useRef(null);
    const triggerRef = useRef(null);
    const { width } = useViewportWidth();
    setNonce(window.__webpack_nonce__);
    useOutsideClick({
        handler: (event) => {
            var _a;
            if (!((_a = triggerRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.target))) {
                if (closeOnOverlayClick) {
                    onClose();
                }
            }
        },
        ref: modalRef,
    });
    const overlayVariants = {
        enter: {
            opacity: 1,
            transition: {
                duration: 0.3,
                ease: [0, 0, 0.2, 1],
            },
        },
        exit: {
            opacity: 0,
            transition: {
                duration: 0.2,
                ease: [0.4, 0, 1, 1],
            },
        },
    };
    const modalWrapperVariantsDesktop = {
        enter: {
            opacity: 1,
            scale: 1,
            transition: {
                duration: 0.3,
                ease: [0, 0, 0.2, 1],
            },
        },
        exit: {
            opacity: 0,
            scale: 0.95,
            transition: {
                duration: 0.2,
                ease: [0.4, 0, 1, 1],
            },
        },
    };
    const modalWrapperVariantsMobile = {
        enter: {
            transition: { duration: 0.4, ease: [0.36, 0.66, 0.04, 1] },
            y: 0,
        },
        exit: {
            transition: { duration: 0.3, ease: [0.36, 0.66, 0.04, 1] },
            y: '100%',
        },
    };
    const onKeyDown = useCallback((event) => {
        if (event.key === 'Escape') {
            event.stopPropagation();
            if (closeOnEsc) {
                onClose === null || onClose === void 0 ? void 0 : onClose();
            }
        }
    }, [closeOnEsc, onClose]);
    const animate = isOpen ? 'enter' : 'exit';
    const modalWrapperVariant = width >= 576 ? modalWrapperVariantsDesktop : modalWrapperVariantsMobile;
    const reAnimate = width >= 576 ? 'desktop' : 'mobile';
    return (jsxRuntimeExports.jsx(ModalContext.Provider, { value: { isOpen, onClose, size }, children: jsxRuntimeExports.jsx(AnimatePresence, { onExitComplete: onCloseComplete, children: isOpen && (jsxRuntimeExports.jsxs(Portal, { children: [jsxRuntimeExports.jsx(StyledMotionOverlay, { animate: animate, exit: "exit", initial: "exit", ref: triggerRef, variants: overlayVariants }), jsxRuntimeExports.jsx(FocusLock, { children: jsxRuntimeExports.jsx(RemoveScroll, { allowPinchZoom: true, children: jsxRuntimeExports.jsx(StyledMotionWrapper, { animate: animate, "aria-modal": true, exit: "exit", initial: "exit", onKeyDown: onKeyDown, role: "dialog", tabIndex: -1, variants: modalWrapperVariant, children: jsxRuntimeExports.jsx(StyledModalWrapper, Object.assign({ "$size": size }, props, { children: jsxRuntimeExports.jsx(StyledModalContent, { "$size": size, ref: modalRef, children: children }) })) }, reAnimate) }) })] })) }) }));
}
const StyledMotionOverlay = styled(motion.div) `
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgb(0 0 0 / 50%);
    z-index: ${(props) => props.theme.zIndices.modal};
`;
const StyledMotionWrapper = styled(motion.div) `
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: ${(props) => props.theme.zIndices.modal};

    &:focus {
        outline: none;
    }

    ${(props) => props.theme.mediaQueries.small} {
        padding: 40px;
        overflow-y: auto;
    }
`;
const StyledModalWrapper = styled.section `
    display: flex;
    min-height: 100%;
    position: fixed;
    margin: 0 auto;
    justify-content: center;
    top: 32px;
    align-items: flex-start;
    width: 100%;

    &:focus {
        outline: none;
    }

    ${(props) => props.theme.mediaQueries.small} {
        position: relative;
        top: 0;
        align-items: center;

        ${(props) => props.$size === 'small' &&
    css$3 `
                max-width: 512px;
            `}

        ${(props) => props.$size === 'medium' &&
    css$3 `
                max-width: 672px;
            `}

        ${(props) => props.$size === 'large' &&
    css$3 `
                max-width: 896px;
            `}

        ${(props) => props.$size === 'xlarge' &&
    css$3 `
                max-width: 1248px;
            `}

        ${(props) => props.$size === 'fullscreen' &&
    css$3 `
                width: 100%;
                height: 100%;
            `}
    }

    ${sx};
`;
const StyledModalContent = styled.div `
    position: absolute;
    background-color: white;
    width: 100%;
    max-height: calc(100% - 32px);
    bottom: 32px;
    overflow: hidden auto;
    box-shadow: ${(props) => props.theme.shadows['2xl']};
    border-top-left-radius: ${(props) => props.theme.radii.base};
    border-top-right-radius: ${(props) => props.theme.radii.base};

    ${(props) => props.theme.mediaQueries.small} {
        position: relative;
        bottom: auto;
        padding-bottom: 0;
        height: auto;
        max-height: 100%;
        border-radius: ${(props) => props.theme.radii.sm};
        overflow: visible;
    }

    ${(props) => props.$size === 'fullscreen' &&
    css$3 `
            height: 100%;
            display: flex;
            flex-direction: column;
            overflow: auto;

            ${props.theme.mediaQueries.small} {
                height: 100%;
            }
        `}
`;
Modal.Header = ModalHeader;
Modal.Body = ModalBody;
Modal.Footer = ModalFooter;
Modal.CloseButton = ModalCloseButton;
Modal.Footnote = ModalFootnote;

const checkInput = (haystack, needles) => {
    return haystack.reduce((acc, curr) => {
        if (needles.indexOf(curr.value) !== -1) {
            acc.push(curr.value);
        }
        return acc;
    }, []);
};
function MultiSelectCard(_a) {
    var { color, counterSuffix = 'data items', error, isSensitiveData = false, name, onBlur, onSelectionChange, options, selectedOptions, sx: sxProp, title } = _a, props = __rest(_a, ["color", "counterSuffix", "error", "isSensitiveData", "name", "onBlur", "onSelectionChange", "options", "selectedOptions", "sx", "title"]);
    const [isOpen, setIsOpen] = useState(false);
    const [isAllChecked, setIsAllChecked] = useState(false);
    const [isIndeterminate, setIsIndeterminate] = useState(false);
    const [counterText, setCounterText] = useState('');
    const [selected, setSelected] = useState(checkInput(options, selectedOptions));
    const setFirstWordBold = (sentence) => {
        if (sentence === '') {
            return jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: sentence });
        }
        return (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx(Text, { as: "span", fontWeight: selected.length === 0 ? 'normal' : 'medium', size: ['sm', 'md'], children: sentence === null || sentence === void 0 ? void 0 : sentence.split(' ')[0] }), "\u00A0", sentence === null || sentence === void 0 ? void 0 : sentence.split(' ').slice(1).join(' ')] }));
    };
    const handleToggleAll = () => {
        if (selected.length === 0 || selected.length !== options.length) {
            setSelected([...options.map((o) => o.value)]);
        }
        if (selected.length === options.length) {
            setSelected([]);
        }
    };
    /**
     * Toggles the selection of an option.
     *
     * If the option is already selected, it removes the option from the selection.
     * If the option is not selected, it adds the option to the selection.
     *
     * @param {string} value - The value of the option to be toggled.
     */
    const handleToggleOption = (value) => {
        setSelected(selected.includes(value)
            ? selected.filter((item) => item !== value) // Remove the option from the selection (filter makes a new array too)
            : [...selected, value] // Add the option to the selection (it makes a new array as well!)
        );
    };
    useEffect(() => {
        const isEverythingChecked = selected.length === options.length;
        const isSelectionIndeterminate = selected.length !== 0 && selected.length < options.length && !isEverythingChecked;
        setIsAllChecked(isEverythingChecked);
        setIsIndeterminate(isSelectionIndeterminate);
        setCounterText(`${selected.length} / ${options.length} ${counterSuffix}`);
    }, [counterSuffix, options.length, selected]);
    useEffect(() => {
        if (onSelectionChange && selected.length !== selectedOptions.length) {
            onSelectionChange(selected);
        }
    }, [selected.length, selectedOptions.length, onSelectionChange, selected]);
    return (jsxRuntimeExports.jsxs(Box, Object.assign({ borderRadius: "base", boxShadow: "base", overflow: "hidden", sx: sxProp }, props, { children: [jsxRuntimeExports.jsxs(Box, { alignItems: "center", display: "flex", flexDirection: "row", height: "64px", justifyContent: "space-between", maxHeight: "64px", onClick: () => {
                    setIsOpen(!isOpen);
                }, pl: [4, 6], pr: 4, sx: { cursor: 'pointer' }, width: "100%", children: [jsxRuntimeExports.jsx(Box, { alignItems: "center", display: "flex", flexDirection: "row", children: jsxRuntimeExports.jsx(Checkbox, { checked: isAllChecked || isIndeterminate, id: useUniqueId(), indeterminate: isIndeterminate, name: name, onBlur: onBlur, onChange: handleToggleAll, sx: { mr: 3 } }) }), jsxRuntimeExports.jsxs(Box, { alignItems: ['flex-start', 'center'], display: "flex", flex: 1, flexDirection: ['column', 'row'], justifyContent: ['flex-start', 'space-between'], children: [jsxRuntimeExports.jsx(Text, { "data-dd-privacy": isSensitiveData ? 'mask' : 'allow', fontWeight: selected.length === 0 ? 'normal' : 'medium', size: ['sm', 'md'], sx: { whiteSpace: 'nowrap' }, children: title }), jsxRuntimeExports.jsx(Text, { mr: 2, size: ['sm', 'md'], sx: { whiteSpace: 'nowrap' }, children: setFirstWordBold(counterText) })] }), jsxRuntimeExports.jsx(Box, { alignItems: "center", display: "flex", flexDirection: "row", children: jsxRuntimeExports.jsx(IconButton, { icon: isOpen ? 'caret-up-big' : 'caret-down-big', labelText: "close", onClick: () => setIsOpen(!isOpen), size: "small", variant: "ghost" }) })] }), error && jsxRuntimeExports.jsx(FormErrorMessage, { children: error }), jsxRuntimeExports.jsx(Box, { pb: isOpen ? 2 : 0, px: [6, 14], children: jsxRuntimeExports.jsx(Collapse, { isOpen: isOpen, children: jsxRuntimeExports.jsx(Box, { display: "flex", flexDirection: "column", gap: 2, children: options.map((option, index) => {
                            return (jsxRuntimeExports.jsxs(Box, { alignItems: "center", display: "flex", flexDirection: "row", children: [jsxRuntimeExports.jsx(Checkbox, { checked: selected.includes(option.value), id: `${index}_${option.value}`, label: option.label, name: name, onBlur: onBlur, onChange: () => handleToggleOption(option.value) }), option.badgeText && (jsxRuntimeExports.jsx(Badge, { size: "small", sx: { ml: 4 }, text: option.badgeText }))] }, `${index}_${option.value}`));
                        }) }) }) })] })));
}

const NavBarContext = createContext({});

const NavBarLinkContext = createContext({ isMenuItem: false });

function NavBarLink(_a) {
    var { as, children, icon, onClick, to } = _a, props = __rest(_a, ["as", "children", "icon", "onClick", "to"]);
    const { isMenuItem } = useContext(NavBarLinkContext);
    const { mode } = useContext(NavBarContext);
    const Component = isMenuItem ? StyledNavBarMenuLink : StyledNavBarLink;
    return (jsxRuntimeExports.jsxs(Component, Object.assign({ "$mode": mode, as: as, onClick: onClick, to: to }, props, { children: [icon && (jsxRuntimeExports.jsx(StyledIcon$6, { "$mode": mode, color: "minimal", icon: icon, size: 16 })), jsxRuntimeExports.jsx(StyledSpan, { "data-content": children, children: children })] })));
}
const StyledIcon$6 = styled(Icon) `
    margin-right: ${(props) => (props.$mode === 'inline' ? '12px' : '8px')};
`;
const StyledNavBarLink = styled.a `
    display: flex;
    align-items: center;
    padding: 21px 12px;
    color: var(--kds-color-foreground-default);
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    text-decoration: none;
    text-align: center;
    white-space: nowrap;
    transition: border-bottom-color 0.1s ease-in;
    border-bottom: 2px solid transparent;
    margin-right: 16px;
    flex-shrink: 0;
    cursor: pointer;

    ${(props) => props.$mode === 'inline' &&
    css$3 `
            margin-right: 0;
            width: 100%;
            padding: 12px 24px;
            border-bottom: none;
        `}

    &:hover,
    &:focus {
        color: var(--kds-color-foreground-default);
        border-bottom-color: var(--kds-color-border-subtle);
        text-decoration: none;
    }

    ${(props) => props.$mode === 'inline' &&
    css$3 `
            &:hover,
            &:focus {
                border-bottom: none;
                background-color: ${props.theme.colors.neutral100};
            }
        `}

    &.active {
        color: ${(props) => props.theme.colors.magenta700};
        font-weight: 500;
        border-bottom-color: ${(props) => props.theme.colors.magenta700};

        & svg {
            color: ${(props) => props.theme.colors.magenta600};
        }
    }

    &:focus {
        outline: none;
    }

    &:focus-visible {
        outline: 2px solid var(--kds-color-border-focused);
        outline-offset: -2px;
    }
`;
const StyledSpan = styled.span `
    &::before {
        content: attr(data-content);
        display: block;
        font-weight: 500;
        height: 0;
        visibility: hidden;
    }
`;
const StyledNavBarMenuLink = styled.a `
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 10px 16px;
    cursor: pointer;
    box-sizing: border-box;
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
    color: var(--kds-color-foreground-default);
    white-space: nowrap;
    background-color: inherit;
    border: 0;
    text-decoration: none;
    width: 100%;

    ${(props) => props.$mode === 'inline' &&
    css$3 `
            padding: 12px 52px;
        `}

    &:hover,
    &:focus {
        color: var(--kds-color-foreground-default);
        text-decoration: none;
        background-color: ${(props) => props.theme.colors.neutral100};
    }

    &.active {
        color: ${(props) => props.theme.colors.magenta700};
        font-weight: 500;

        & svg {
            color: ${(props) => props.theme.colors.magenta600};
        }
    }

    &:focus {
        outline: none;
    }

    &:focus-visible {
        outline: 2px solid var(--kds-color-border-focused);
        outline-offset: -2px;
    }
`;

function NavBarMenu(_a) {
    var { children, icon, isOpen, isSensitiveData = false, onClose, onCloseAll, onOpen, title } = _a, props = __rest(_a, ["children", "icon", "isOpen", "isSensitiveData", "onClose", "onCloseAll", "onOpen", "title"]);
    const [openChildIndex, setOpenChildIndex] = useState();
    const { isMenuItem } = useContext(NavBarLinkContext);
    const { mode } = useContext(NavBarContext);
    if (!isOpen && openChildIndex) {
        setOpenChildIndex(undefined);
    }
    const [referenceElement, setReferenceElement] = useState(null);
    const [popperElement, setPopperElement] = useState(null);
    const { attributes, styles, update } = usePopper(referenceElement, popperElement, {
        placement: isMenuItem ? 'right-start' : 'bottom-start',
        strategy: isMenuItem ? 'absolute' : 'fixed',
    });
    const navBarMenuRef = useRef(null);
    const navBarMenuListRef = useRef(null);
    useOutsideClick({
        handler: (event) => {
            var _a;
            if (mode === 'horizontal' &&
                isOpen &&
                onClose &&
                !((_a = navBarMenuListRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.target))) {
                setOpenChildIndex(undefined);
                onClose();
            }
        },
        ref: navBarMenuRef,
    });
    useEffect(() => {
        if (update) {
            update();
        }
    }, [children, update]);
    const handleClick = () => {
        if (update) {
            update();
        }
        if (isOpen && onClose) {
            setOpenChildIndex(undefined);
            onClose();
        }
        if (!isOpen && onOpen) {
            onOpen();
        }
    };
    const handleCloseAll = () => {
        setOpenChildIndex(undefined);
        if (onCloseAll) {
            onCloseAll();
        }
    };
    const renderWithPopper = (newChildren, newMode) => {
        return newMode === 'horizontal' ? (jsxRuntimeExports.jsx(StyledPopperContainer, Object.assign({ ref: setPopperElement, style: styles.popper }, attributes.popper, { children: newChildren }))) : (jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: newChildren }));
    };
    const renderWithPortalAndPopper = (newChildren, newMode) => {
        return newMode === 'horizontal' ? (createPortal(jsxRuntimeExports.jsx(StyledPopperContainer, Object.assign({ ref: setPopperElement, style: styles.popper }, attributes.popper, { children: newChildren })), document.body)) : (jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: newChildren }));
    };
    if (isMenuItem) {
        return (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsxs(StyledNavBarMenuLink, { "$mode": mode, as: "button", "data-dd-privacy": isSensitiveData ? 'mask' : 'allow', onClick: handleClick, ref: setReferenceElement, style: mode === 'inline' ? { paddingRight: '16px' } : {}, children: [icon && (jsxRuntimeExports.jsx(StyledIconLeft, { "$mode": mode, icon: icon, size: 16 })), title, jsxRuntimeExports.jsx(StyledIconRight, { icon: mode === 'horizontal' ? 'caret-right' : isOpen ? 'caret-up' : 'caret-down', size: 18 })] }), renderWithPopper(jsxRuntimeExports.jsx(StyledNavBarMenuList, { "$isOpen": isOpen || false, "$mode": mode, children: children.map((child, index) => {
                        if (isValidElement(child)) {
                            const isChildMenuItem = true;
                            const handleClickChild = () => {
                                if (child.props.onClick) {
                                    child.props.onClick();
                                }
                                if (mode === 'horizontal') {
                                    handleCloseAll();
                                }
                            };
                            if (child.type === NavBarMenu) {
                                return (jsxRuntimeExports.jsx(React__default.Fragment, { children: jsxRuntimeExports.jsx(NavBarLinkContext.Provider, { value: { isMenuItem: isChildMenuItem }, children: cloneElement(child, Object.assign(Object.assign({}, child.props), { isOpen: openChildIndex === index, onClose: () => setOpenChildIndex(undefined), onCloseAll: handleCloseAll, onOpen: () => setOpenChildIndex(index) })) }) }, index));
                            }
                            return (jsxRuntimeExports.jsx(StyledNavBarMenuListItem, { children: jsxRuntimeExports.jsx(NavBarLinkContext.Provider, { value: { isMenuItem: isChildMenuItem }, children: cloneElement(child, Object.assign(Object.assign({}, child.props), { onClick: handleClickChild })) }) }, index));
                        }
                        return;
                    }) }), mode)] }));
    }
    return (jsxRuntimeExports.jsxs(StyledNavBarMenu, Object.assign({ "$mode": mode, ref: navBarMenuRef }, props, { children: [jsxRuntimeExports.jsxs(StyledNavBarMenuButton, { "$mode": mode, onClick: handleClick, ref: setReferenceElement, children: [icon && (jsxRuntimeExports.jsx(StyledIconLeft, { "$mode": mode, icon: icon, size: 16 })), title, jsxRuntimeExports.jsx(StyledIconRight, { icon: mode === 'inline' && isOpen ? 'caret-up' : 'caret-down', size: 18 })] }), renderWithPortalAndPopper(jsxRuntimeExports.jsx(StyledNavBarMenuList, { "$isOpen": isOpen || false, "$mode": mode, ref: navBarMenuListRef, children: children.map((child, index) => {
                    if (isValidElement(child)) {
                        const isChildMenuItem = true;
                        const handleClickChild = () => {
                            if (child.props.onClick) {
                                child.props.onClick();
                            }
                            if (mode === 'horizontal') {
                                handleCloseAll();
                            }
                        };
                        if (child.type === NavBarMenu) {
                            return (jsxRuntimeExports.jsx(StyledNavBarMenuListItem, { children: jsxRuntimeExports.jsx(NavBarLinkContext.Provider, { value: { isMenuItem: isChildMenuItem }, children: cloneElement(child, Object.assign(Object.assign({}, child.props), { isOpen: openChildIndex === index, onClose: () => setOpenChildIndex(undefined), onCloseAll: handleCloseAll, onOpen: () => setOpenChildIndex(index) })) }) }, index));
                        }
                        return (jsxRuntimeExports.jsx(StyledNavBarMenuListItem, { children: jsxRuntimeExports.jsx(NavBarLinkContext.Provider, { value: { isMenuItem: isChildMenuItem }, children: cloneElement(child, Object.assign(Object.assign({}, child.props), { onClick: handleClickChild })) }) }, index));
                    }
                    return;
                }) }), mode)] })));
}
const StyledNavBarMenuListItem = styled.li `
    display: block;
`;
const StyledNavBarMenuButton = styled.button `
    display: flex;
    align-items: center;
    color: ${(props) => props.theme.colors.neutral900};
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    background-color: transparent;
    border: none;
    border-radius: ${(props) => props.theme.radii.sm};

    ${(props) => props.$mode === 'horizontal' &&
    css$3 `
            height: 32px;
            padding: 16px 12px;
        `}

    ${(props) => props.$mode === 'inline' &&
    css$3 `
            height: 44px;
            width: 100%;
            padding: 0 16px 0 24px;
        `}

    &:hover {
        background-color: ${(props) => props.theme.colors.neutral100};
    }

    &:focus {
        outline: none;
    }

    &:focus-visible {
        outline: 2px solid var(--kds-color-border-focused);
        outline-offset: 2px;
    }
`;
const StyledIconLeft = styled(Icon) `
    margin-right: ${(props) => (props.$mode === 'inline' ? '12px' : '8px')};
    color: var(--kds-color-foreground-minimal);
`;
const StyledIconRight = styled(Icon) `
    margin-left: auto;
    color: ${(props) => props.theme.colors.neutral900};
`;
const StyledNavBarMenu = styled.div `
    position: relative;
    display: inline-block;
    align-self: center;
    margin-right: 16px;

    ${(props) => props.$mode === 'inline' &&
    css$3 `
            margin: 0;
            width: 100%;
        `}
`;
const StyledNavBarMenuList = styled.ul `
    display: ${(props) => (props.$isOpen ? 'block' : 'none')};
    background-color: ${(props) => props.theme.colors.white};
    border-radius: ${(props) => props.theme.radii.sm};
    list-style: none;
    white-space: nowrap;

    ${(props) => props.$mode === 'horizontal' &&
    css$3 `
            padding: 8px 0;
            box-shadow: ${props.theme.shadows.md};
            overflow: auto;
            max-height: calc(100vh - ${props.theme.appLayout.header.height});
        `}

    ${(props) => props.$mode === 'inline' &&
    css$3 `
            padding: 0;
            box-shadow: none;
            overflow: visible;
            max-height: none;
            padding-left: 16px;
        `}
`;
const StyledPopperContainer = styled.div `
    z-index: ${(props) => props.theme.zIndices.navbar};
`;

function getValidChildren(children) {
    return Children.toArray(children).filter((child) => isValidElement(child));
}
function NavBar(_a) {
    var { children, isSensitiveData = false, mode = 'horizontal' } = _a, props = __rest(_a, ["children", "isSensitiveData", "mode"]);
    const [openChildIndex, setOpenChildIndex] = useState();
    function reducer(state, action) {
        switch (action.type) {
            case 'move':
                const lastChild = state.children.reduceRight((child) => child);
                const newChildren = state.children.filter((child) => child !== lastChild);
                return Object.assign(Object.assign(Object.assign({}, state), { children: newChildren, dropdownItems: [...state.dropdownItems, lastChild] }), (action.payload.lastItem && {
                    lastItemWidth: [...state.lastItemWidth, action.payload.lastItem.clientWidth],
                }));
            case 'return':
                const copyDropdownItems = [...state.dropdownItems];
                const lastItemFromList = copyDropdownItems.splice(-1, 1);
                const lastItemWidth = [...state.lastItemWidth];
                lastItemWidth.splice(-1, 1);
                return {
                    children: [...state.children, ...lastItemFromList],
                    dropdownItems: copyDropdownItems,
                    lastItemWidth,
                };
            case 'update':
                const validChildren = getValidChildren(children);
                return {
                    children: validChildren,
                    dropdownItems: [],
                    lastItemWidth: [],
                };
            default:
                return state;
        }
    }
    const navBar = useRef(null);
    const navBarList = useRef(null);
    const items = useRef(new Map()).current;
    const validChildren = getValidChildren(children);
    const initialState = {
        children: validChildren,
        dropdownItems: [],
        lastItemWidth: [],
    };
    const [state, dispatch] = useReducer(reducer, initialState);
    function doesItFit() {
        if (navBar.current && navBarList.current) {
            const dropdownWidth = 116;
            const outerWidth = navBar.current.offsetWidth;
            const totalWidth = navBarList.current.scrollWidth;
            if (state.children.length > 1 && totalWidth > outerWidth) {
                moveItemToList();
            }
            else if (state.dropdownItems.length > 1 &&
                outerWidth > totalWidth + state.lastItemWidth[state.lastItemWidth.length - 1]) {
                moveItemToNav();
            }
            else if (state.dropdownItems.length === 1 &&
                outerWidth > totalWidth - dropdownWidth + state.lastItemWidth[state.lastItemWidth.length - 1]) {
                moveItemToNav();
            }
        }
    }
    const debouncedDoesItFit = debounce(doesItFit, 100);
    useEffect(() => {
        if (mode === 'horizontal') {
            doesItFit();
            window.addEventListener('resize', debouncedDoesItFit);
            return () => {
                window.removeEventListener('resize', debouncedDoesItFit);
            };
        }
        return;
    });
    const updateChildren = () => {
        dispatch({
            type: 'update',
        });
    };
    useEffect(() => {
        if (mode === 'horizontal') {
            updateChildren();
        }
    }, [children, mode]);
    const moveItemToList = () => {
        dispatch({
            payload: {
                lastItem: items.get(state.children.length - 1),
            },
            type: 'move',
        });
    };
    const moveItemToNav = () => {
        dispatch({
            type: 'return',
        });
    };
    const handleClick = () => {
        if (openChildIndex === 'more') {
            setOpenChildIndex(undefined);
        }
        else {
            setOpenChildIndex('more');
        }
    };
    return (jsxRuntimeExports.jsx(NavBarContext.Provider, { value: { mode }, children: jsxRuntimeExports.jsx(Wrapper$1, Object.assign({ "$mode": mode }, props, { children: jsxRuntimeExports.jsx(StyledNavBar, { ref: navBar, children: jsxRuntimeExports.jsxs(StyledNavBarList, { "$mode": mode, ref: navBarList, children: [Children.map(state.children, (child, index) => {
                            if (isValidElement(child)) {
                                if (child.type === NavBar.Menu) {
                                    return (jsxRuntimeExports.jsx(StyledNavBarListItem, { "data-dd-privacy": isSensitiveData ? 'mask' : 'allow', ref: (element) => {
                                            if (element) {
                                                items.set(index, element);
                                            }
                                        }, children: cloneElement(child, {
                                            isOpen: openChildIndex === index,
                                            onClose: () => setOpenChildIndex(undefined),
                                            onCloseAll: () => setOpenChildIndex(undefined),
                                            onOpen: () => setOpenChildIndex(index),
                                        }) }, index));
                                }
                                return (jsxRuntimeExports.jsx(StyledNavBarListItem, { ref: (element) => {
                                        if (element) {
                                            items.set(index, element);
                                        }
                                    }, children: child }, index));
                            }
                            return;
                        }), state.dropdownItems.length > 0 && (jsxRuntimeExports.jsx(NavBarMenu, { icon: "more", isOpen: openChildIndex === 'more', onClose: handleClick, onCloseAll: handleClick, onOpen: handleClick, title: "Meer", children: state.dropdownItems.slice(0).reverse() }))] }) }) })) }));
}
const Wrapper$1 = styled.div `
    flex: 1;
    display: flex;
    overflow: auto;

    ${(props) => props.$mode === 'inline' &&
    css$3 `
            overflow: visible;
        `}
`;
const StyledNavBar = styled.nav `
    display: flex;
    align-items: center;
    width: 100%;
    max-width: 100%;
`;
const StyledNavBarList = styled.ul `
    display: flex;
    padding-left: 0;
    margin-top: 0;
    margin-bottom: 0;
    list-style: none;
    scrollbar-width: none;
    overflow: auto hidden;
    width: auto;

    &::-webkit-scrollbar {
        display: none;
    }

    ${(props) => props.$mode === 'inline' &&
    css$3 `
            flex-direction: column;
            width: 100%;
            overflow: visible;
        `}

    ::-webkit-scrollbar {
        display: none;
    }
`;
const StyledNavBarListItem = styled.li `
    display: flex;
    flex-shrink: 0;
`;
NavBar.Link = NavBarLink;
NavBar.Menu = NavBarMenu;

const NavDropdownContext = createContext({});

function NavDropdownItem(_a) {
    var { as, children, icon, onClick, to, toggle = true } = _a, props = __rest(_a, ["as", "children", "icon", "onClick", "to", "toggle"]);
    const { isOpen, setIsOpen } = useContext(NavDropdownContext);
    function handleClick(event) {
        if (onClick) {
            onClick(event);
        }
        if (toggle) {
            setIsOpen(!isOpen);
        }
    }
    return (jsxRuntimeExports.jsxs(StyledNavDropdownItem, Object.assign({ as: as, onClick: handleClick, to: to }, props, { children: [icon && (jsxRuntimeExports.jsx(StyledIcon$5, { color: "minimal", icon: icon, size: 16 })), children] })));
}
const StyledIcon$5 = styled(Icon) `
    margin-right: 8px;
    min-width: 18px;
`;
const StyledNavDropdownItem = styled.a `
    font-weight: 400;
    font-size: 14px;
    color: var(--kds-color-foreground-default);
    line-height: 21px;
    display: flex;
    align-items: center;
    text-decoration: none;
    padding: 8px;
    cursor: pointer;

    &:hover {
        text-decoration: none;
        background-color: ${(props) => props.theme.colors.neutral50};
        border-radius: ${(props) => props.theme.radii.sm};
        color: var(--kds-color-foreground-default);
    }

    &.active {
        color: ${(props) => props.theme.colors.magenta700};
        font-weight: 500;

        &:hover {
            color: ${(props) => props.theme.colors.magenta700};
        }

        ${StyledIcon$5} {
            color: ${(props) => props.theme.colors.magenta600};
        }
    }
`;

const NavDropdownMenuVariants = {
    collapsed: {
        opacity: 0,
        transitionEnd: {
            display: 'none',
        },
        y: -10,
    },
    expanded: {
        display: 'flex',
        opacity: 1,
        y: 0,
    },
};
function NavDropdownMenu(_a) {
    var { children, isOpen, menuRef } = _a, props = __rest(_a, ["children", "isOpen", "menuRef"]);
    return (jsxRuntimeExports.jsx(motion.div, { animate: isOpen ? 'expanded' : 'collapsed', initial: isOpen ? 'expanded' : 'collapsed', transition: { duration: 0.15 }, variants: NavDropdownMenuVariants, children: jsxRuntimeExports.jsx(StyledNavDropdownMenu, Object.assign({ ref: menuRef }, props, { children: jsxRuntimeExports.jsx(Wrapper, { children: children }) })) }));
}
const StyledNavDropdownMenu = styled.div `
    position: absolute;
    right: 0;
    margin-top: 24px;
    z-index: ${(props) => props.theme.zIndices.navbar};
`;
const Wrapper = styled.div `
    padding: 16px;
    box-shadow: ${(props) => props.theme.shadows.md};
    display: flex;
    flex-direction: column;
    background-color: white;
    min-width: 300px;
    max-height: calc(100vh - 80px);
    overflow-y: auto;
    border-radius: ${(props) => props.theme.radii.sm};
`;

function NavDropdownSwitcher(_a) {
    var { children, isSelected = false, onClick } = _a, props = __rest(_a, ["children", "isSelected", "onClick"]);
    const theme = useTheme();
    return (jsxRuntimeExports.jsx(StyledNavDropdownSwitcherWrapper, { children: jsxRuntimeExports.jsxs(StyledNavDropdownSwitcher, Object.assign({ "$isSelected": isSelected, onClick: isSelected ? undefined : onClick }, props, { children: [children, isSelected && (jsxRuntimeExports.jsx("span", { style: {
                        alignItems: 'center',
                        backgroundColor: `${theme.colors.magenta700}`,
                        borderRadius: '50%',
                        display: 'inline-flex',
                        height: '24px',
                        justifyContent: 'center',
                        position: 'absolute',
                        right: '-11px',
                        top: '-8px',
                        width: '24px',
                    }, children: jsxRuntimeExports.jsx(Icon, { color: "inverse", icon: "check", size: 20 }) }))] })) }));
}
const StyledNavDropdownSwitcherWrapper = styled.div `
    margin: 8px 0;

    &:first-of-type {
        margin-top: 0;
    }
`;
const StyledNavDropdownSwitcher = styled.div `
    padding: 16px 8px;
    transition: all 0.2s ease-out;
    position: relative;
    border-radius: ${(props) => props.theme.radii.sm};

    ${(props) => props.$isSelected === true &&
    css$3 `
            box-shadow: inset 0 0 0 1px ${props.theme.colors.magenta700};
        `}

    ${(props) => props.$isSelected === false &&
    css$3 `
            cursor: pointer;
            box-shadow: inset 0 0 0 1px ${props.theme.colors.neutral300};

            &:hover {
                box-shadow: inset 0 0 0 1px ${props.theme.colors.neutral700};
            }
        `}
`;

function NavDropdownToggle(_a) {
    var { fullName = 'fullName', imageUrl, initials, isOpen, onClick, organization = 'organization' } = _a, props = __rest(_a, ["fullName", "imageUrl", "initials", "isOpen", "onClick", "organization"]);
    return (jsxRuntimeExports.jsxs(StyledNavDropdownToggle, Object.assign({ onClick: onClick }, props, { children: [jsxRuntimeExports.jsx(StyledAvatar, { altText: fullName, imageUrl: imageUrl, initials: initials, size: 32 }), jsxRuntimeExports.jsxs(StyledInnerText, { children: [jsxRuntimeExports.jsx(StyledTitle$3, { children: fullName }), jsxRuntimeExports.jsx(StyledSubtitle$2, { children: organization })] }), jsxRuntimeExports.jsx(IconBackground$1, { children: jsxRuntimeExports.jsx(StyledIcon$4, { "$isOpen": isOpen, icon: "caret-down", size: 18 }) })] })));
}
const StyledNavDropdownToggle = styled.div `
    display: inline-flex;
    align-items: center;
    vertical-align: middle;
    margin: 0;
    cursor: pointer;
`;
const StyledAvatar = styled(Avatar) `
    margin-right: 0;

    ${(props) => props.theme.mediaQueries.large} {
        margin-right: 12px;
    }
`;
const StyledInnerText = styled.div `
    display: none;

    ${(props) => props.theme.mediaQueries.large} {
        display: flex;
        flex-direction: column;
        overflow: hidden;
    }
`;
const StyledTitle$3 = styled.span `
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
    color: var(--kds-color-foreground-default);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 172px;
`;
const StyledSubtitle$2 = styled(StyledTitle$3) `
    color: var(--kds-color-foreground-minimal);
`;
const StyledIcon$4 = styled(Icon) `
    transform: ${(props) => props.$isOpen && `rotate(180deg)`};
    transition: transform 0.15s ease;
`;
const IconBackground$1 = styled.span `
    display: none;

    ${(props) => props.theme.mediaQueries.large} {
        border-radius: ${(props) => props.theme.radii.full};
        height: 32px;
        min-width: 32px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        margin-left: 0;
        margin-left: 16px;
        background-color: ${(props) => props.theme.colors.neutral200};
    }
`;

function NavDropdown(_a) {
    var { children, fullName, imageUrl, initials, organization } = _a, props = __rest(_a, ["children", "fullName", "imageUrl", "initials", "organization"]);
    const [isOpen, setIsOpen] = useState(false);
    const nodeRef = useRef(null);
    useEffect(() => {
        function handleClickAway(event) {
            if (nodeRef.current && !nodeRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        }
        if (isOpen) {
            document.addEventListener('click', handleClickAway);
        }
        return () => {
            document.removeEventListener('click', handleClickAway);
        };
    }, [isOpen]);
    const handleClick = (event) => {
        event.stopPropagation();
        setIsOpen(!isOpen);
    };
    return (jsxRuntimeExports.jsx(NavDropdownContext.Provider, { value: { isOpen, setIsOpen }, children: jsxRuntimeExports.jsxs(StyledNavDropdown, { children: [jsxRuntimeExports.jsx(NavDropdownToggle, Object.assign({ fullName: fullName, imageUrl: imageUrl, initials: initials, isOpen: isOpen, onClick: handleClick, organization: organization }, props)), jsxRuntimeExports.jsx(NavDropdownMenu, { isOpen: isOpen, menuRef: nodeRef, children: children })] }) }));
}
const StyledNavDropdown = styled.div `
    position: relative;
`;
const StyledNavDropdownListDivider = styled.div `
    margin-bottom: 8px;
    margin-top: 8px;
    border-bottom: 1px solid var(--kds-color-border-minimal);
`;
const StyledTitle$2 = styled.p `
    font-size: 14px;
    font-weight: 500;
    margin: 0;
    color: var(--kds-color-foreground-default);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 275px;
    padding: 0 8px;
`;
NavDropdown.Switcher = NavDropdownSwitcher;
NavDropdown.Divider = StyledNavDropdownListDivider;
NavDropdown.Item = NavDropdownItem;
NavDropdown.Title = StyledTitle$2;

function NavMenuItem(_a) {
    var { children, hasCaret, hasLeftBorder, hasTopBorder, isLink, isSelected = false, onClick } = _a, props = __rest(_a, ["children", "hasCaret", "hasLeftBorder", "hasTopBorder", "isLink", "isSelected", "onClick"]);
    return (jsxRuntimeExports.jsx(StyledNavMenuItem, Object.assign({ "$hasCaret": hasCaret, "$hasLeftBorder": hasLeftBorder, "$hasTopBorder": hasTopBorder, "$isLink": isLink, "$isSelected": isSelected, onClick: onClick }, props, { children: children })));
}
const StyledNavMenuItem = styled.li `
    list-style: none;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0;
    font-weight: ${(props) => props.theme.fontWeights.normal};
    font-size: ${(props) => props.theme.fontSizes.md};
    line-height: ${(props) => props.theme.lineHeights.normal};
    color: var(--kds-color-foreground-default);

    &:focus,
    &:active {
        outline: none;
    }

    &:hover {
        cursor: ${(props) => (props.$hasCaret || props.$isLink ? 'pointer' : 'default')};
        ${(props) => props.$isLink &&
    css$3 `
                background: ${props.theme.colors.neutral200};
            `}
    }

    ${(props) => props.$isSelected &&
    css$3 `
            color: ${props.theme.colors.magenta800} !important;
        `}

    ${(props) => props.$hasLeftBorder &&
    css$3 `
            border-left: 2px solid ${props.theme.colors.neutral200};
        `}

    ${(props) => props.$hasTopBorder &&
    css$3 `
            border-top: 1px solid ${props.theme.colors.neutral200};
        `}
`;

function NavMenuItemText({ children, type }) {
    return (jsxRuntimeExports.jsx(StyledNavMenuItemText, { "$type": type, as: "span", children: children }));
}
const StyledNavMenuItemText = styled(Text) `
    display: inline-block;
    color: inherit;

    ${(props) => props.$type === 'header' &&
    css$3 `
            font-size: 16px;
            line-height: 24px;
            font-weight: 500;
            padding: 20px 0;
        `}
    ${(props) => props.$type === 'subItem' &&
    css$3 `
            font-size: 14px;
            line-height: 20px;
            font-weight: 500;
            padding: 16px 0;
        `}
    ${(props) => props.$type === 'subItemSmall' &&
    css$3 `
            font-size: 14px;
            line-height: 20px;
            font-weight: 400;
            padding: 10px 0;
        `}
`;

const NavMenuVariants = {
    collapsed: {
        height: 0,
        opacity: 0,
        transitionEnd: {
            display: 'none',
        },
    },
    expanded: {
        display: 'block',
        height: 'auto',
        opacity: 1,
    },
};
function NavMenuLogic(_a) {
    var { depth = 0, isSelected, isSensitiveData, itemKey, items = [], label, link, onClickItem, selectedItemKey, variant } = _a, props = __rest(_a, ["depth", "isSelected", "isSensitiveData", "itemKey", "items", "label", "link", "onClickItem", "selectedItemKey", "variant"]);
    const hasChildren = items && items.length > 0;
    const willShowCaret = hasChildren && depth !== 0;
    const isSelectedItem = selectedItemKey === itemKey || isSelected || isChildSelected(items);
    const [isOpen, setIsOpen] = useState(depth === 0);
    useEffect(() => {
        if (isSelectedItem) {
            setIsOpen(true);
        }
    }, [selectedItemKey]);
    const depthStep = 24;
    const onClickHandler = (e) => {
        e.stopPropagation();
        setIsOpen(!isOpen);
    };
    const listItemVariant = (newDepth) => {
        if (newDepth === 0) {
            return 'header';
        }
        if (newDepth === 1) {
            return 'subItem';
        }
        return 'subItemSmall';
    };
    const MenuItem = (jsxRuntimeExports.jsxs(NavMenuItem, Object.assign({ hasCaret: hasChildren && depth !== 0, hasLeftBorder: variant === 'SideBar' && depth !== 0, hasTopBorder: variant === 'TopBar' && depth === 1, isLink: !!link, isSelected: isSelectedItem, onClick: () => {
            if (willShowCaret && !link) {
                setIsOpen(!isOpen);
            }
            if (willShowCaret && link && !isOpen) {
                setIsOpen(!isOpen);
            }
            if (onClickItem && link) {
                onClickItem(itemKey, link);
            }
        }, style: { paddingLeft: depth * depthStep } }, props, { children: [jsxRuntimeExports.jsx(NavMenuItemText, { "aria-label": label, "data-dd-privacy": isSensitiveData ? 'mask' : 'allow', type: listItemVariant(depth), children: label }), willShowCaret && (jsxRuntimeExports.jsx(StyledIconButton, { icon: isOpen ? 'caret-up' : 'caret-down', iconColor: isSelectedItem ? 'secondary' : 'default', labelText: isOpen ? 'open' : 'close', onClick: onClickHandler, variant: "ghost" }))] })));
    const MenuItemChildren = hasChildren ? (jsxRuntimeExports.jsx(StyledSideBarNestedList, { animate: isOpen ? 'expanded' : 'collapsed', initial: 'collapsed', transition: {
            duration: 0.15,
        }, variants: NavMenuVariants, children: items.map((item, index) => {
            return (createElement(NavMenuLogic, Object.assign({}, item, { depth: depth + 1, isSelected: isSelected, key: `${index}-${depth}`, onClickItem: onClickItem, selectedItemKey: selectedItemKey, variant: variant })));
        }) })) : null;
    return (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [MenuItem, MenuItemChildren] }));
    function isChildSelected(children) {
        for (const item of children) {
            if (item.itemKey === selectedItemKey) {
                return true;
            }
            else if (item.items) {
                const isAChildIsSelected = isChildSelected(item.items);
                if (isAChildIsSelected) {
                    return true;
                }
            }
        }
        return false;
    }
}
const StyledIconButton = styled(IconButton) `
    color: inherit;

    &:hover {
        color: inherit;
    }
`;
const StyledSideBarNestedList = styled(motion.ul) `
    margin: 0;
    padding: 0;
`;

function NavMenu({ isSensitiveData = false, items, onClickItem, selectedItemKey, variant = 'SideBar', }) {
    const [menuItems, setMenuItems] = useState(items);
    const prevMenuItems = usePrevious(items);
    useEffect(() => {
        if (!isEqual$1(prevMenuItems, items)) {
            setMenuItems(items);
        }
    }, [items]);
    function handleClickItem(itemKey, link) {
        if (link && onClickItem) {
            onClickItem(itemKey, link);
        }
    }
    return (jsxRuntimeExports.jsx(StyledNavMenu, { "$variant": variant, "aria-label": "sidebar", role: "navigation", children: menuItems &&
            menuItems.map((item, index) => (createElement(NavMenuLogic, Object.assign({}, item, { isSensitiveData: isSensitiveData, key: index, onClickItem: (itemKey, link) => handleClickItem(itemKey, link), selectedItemKey: selectedItemKey, variant: variant })))) }));
}
const StyledNavMenu = styled.ul `
    position: relative;
    margin: 0;

    ${(props) => props.$variant === 'SideBar' &&
    css$3 `
            padding: 0 12px;
        `}

    ${(props) => props.$variant === 'TopBar' &&
    css$3 `
            padding: 0;
        `}
`;

function PageHeader({ action, isSensitiveData = false, subtitle, title }) {
    return (jsxRuntimeExports.jsxs(Box, { alignItems: "start", "data-dd-privacy": isSensitiveData ? 'mask' : 'allow', display: "flex", flexDirection: ['column', null, null, 'row'], flexWrap: "wrap", gap: 4, justifyContent: "space-between", mb: [6, null, 8], children: [jsxRuntimeExports.jsxs(Box, { flex: "1 1 0", children: [jsxRuntimeExports.jsx(Heading, { size: "xlarge", children: title }), subtitle && (jsxRuntimeExports.jsx(Text, { mt: 1, size: "lg", children: subtitle }))] }), action && (jsxRuntimeExports.jsx(Box, { display: "flex", flexDirection: "row", gap: 3, children: action }))] }));
}

// This component is a work-in-progress. For now, it uses defaults that work with the split view in the page layout.
function Resizable({ children, isResizing, maxWidth = window.innerWidth / 2, minWidth = 420, onResizingChange, onWidthChange, }) {
    const resizeHandleEl = useRef(null);
    const onMouseMove = (mouseMoveEvent) => {
        const mouseX = mouseMoveEvent.clientX;
        const workspaceWidth = window.innerWidth;
        let proposedWidth = workspaceWidth - mouseX;
        if (resizeHandleEl.current) {
            proposedWidth += resizeHandleEl.current.offsetWidth / 2;
        }
        const newWidth = clamp(proposedWidth, minWidth, maxWidth);
        onWidthChange(newWidth);
    };
    const throttledMouseMove = throttle(onMouseMove, 50);
    const onMouseUp = () => {
        onResizingChange(false);
        window.removeEventListener('mousemove', throttledMouseMove);
        window.removeEventListener('mouseup', onMouseUp);
    };
    const onSideDockResizeStart = (e) => {
        if (e.button === 0) {
            onResizingChange(true);
            window.addEventListener('mousemove', throttledMouseMove);
            window.addEventListener('mouseup', onMouseUp);
            e.preventDefault();
        }
    };
    return (jsxRuntimeExports.jsxs(Box, { display: "flex", height: "100%", position: "relative", children: [jsxRuntimeExports.jsx(StyledResizeableContent, { children: children }), jsxRuntimeExports.jsx(ResizeHandle, { isResizing: isResizing, onMouseDown: onSideDockResizeStart, ref: resizeHandleEl })] }));
}
const StyledResizeableContent = styled.div `
    flex-grow: 1;
`;
const ResizeHandle = forwardRef(({ isResizing, onMouseDown }, ref) => {
    return (jsxRuntimeExports.jsx(StyledResizeHandle, { onMouseDown: onMouseDown, ref: ref, children: jsxRuntimeExports.jsx(StyledResizeIndicator, { "$isResizing": isResizing, className: "resize-indicator" }) }));
});
ResizeHandle.displayName = 'ResizeHandle';
const StyledResizeHandle = styled.div `
    position: absolute;
    margin: 0;
    left: 0;
    height: 100%;
    width: 16px;

    &:hover {
        cursor: col-resize;

        .resize-indicator {
            background-color: ${({ theme }) => theme.colors.magenta400};
            transition: 0.3s ease-in-out;
        }
    }
`;
const StyledResizeIndicator = styled.div `
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: 2px;

    ${(props) => props.$isResizing &&
    css$3 `
            background-color: ${({ theme }) => theme.colors.magenta400};
        `}
`;

var Breakpoints;
(function (Breakpoints) {
    Breakpoints[Breakpoints["large"] = 1024] = "large";
    Breakpoints[Breakpoints["medium"] = 768] = "medium";
    Breakpoints[Breakpoints["small"] = 576] = "small";
    Breakpoints[Breakpoints["xlarge"] = 1440] = "xlarge";
})(Breakpoints || (Breakpoints = {}));
function PageLayout({ bannerHeight, children, isSplitViewOpen = false, noGutterOnMobile, onSplitViewWidthChange, sideBar, splitView, splitViewWidth, topBar, width, }) {
    const viewportWidth = useViewportWidth();
    const hasSideBar = Boolean(sideBar);
    const hasTopBar = Boolean(topBar);
    const hasSplitView = Boolean(splitView);
    const isSideBarActive = hasSideBar && viewportWidth.width >= Breakpoints.large;
    const isTopBarActive = hasTopBar && viewportWidth.width < Breakpoints.large;
    const isSplitViewActive = hasSplitView && isSplitViewOpen && viewportWidth.width >= Breakpoints.xlarge;
    const [isResizing, setIsResizing] = useState(false);
    const getWidth = (pageLayoutWidth) => {
        if (pageLayoutWidth) {
            return pageLayoutWidth;
        }
        if (sideBar) {
            return 'medium';
        }
        return 'large';
    };
    return (jsxRuntimeExports.jsxs(StyledPageLayout, { "$hasSideBar": hasSideBar, "$hasSplitView": hasSplitView, "$isResizing": isResizing, "$isSplitViewOpen": isSplitViewOpen, "$splitViewWidth": splitViewWidth !== null && splitViewWidth !== void 0 ? splitViewWidth : 0, children: [isSideBarActive && jsxRuntimeExports.jsx(StyledSideBar$1, { children: sideBar }), jsxRuntimeExports.jsxs(StyledContent$4, { "$bannerHeight": bannerHeight, "$hasSideBar": hasSideBar, "$isSplitViewOpen": isSplitViewOpen, "$width": getWidth(width), children: [isTopBarActive && topBar, jsxRuntimeExports.jsx(StyledChildren, { "$noGutterOnMobile": noGutterOnMobile, children: children })] }), isSplitViewActive && (jsxRuntimeExports.jsx(StyledSplitView$1, { "$hasSideBar": hasSideBar, children: jsxRuntimeExports.jsx(Resizable, { isResizing: isResizing, onResizingChange: setIsResizing, onWidthChange: (newWidth) => onSplitViewWidthChange === null || onSplitViewWidthChange === void 0 ? void 0 : onSplitViewWidthChange(newWidth), children: splitView }) }))] }));
}
const StyledPageLayout = styled.div `
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    background-color: var(--kds-color-background-minimal);
    height: 100%;

    ${(props) => !props.$isResizing &&
    css$3 `
            transition: 300ms;
        `};

    ${(props) => props.$hasSideBar &&
    css$3 `
            ${props.theme.mediaQueries.large} {
                grid-template-columns: ${props.theme.pageLayout.sideBar.width} minmax(0, 1fr);
            }
        `}

    ${(props) => !props.$hasSideBar &&
    props.$hasSplitView &&
    css$3 `
            ${props.theme.mediaQueries.large} {
                grid-template-columns: minmax(0, 1fr) minmax(0, 0);
            }
        `}

    ${(props) => !props.$hasSideBar &&
    props.$hasSplitView &&
    props.$isSplitViewOpen &&
    css$3 `
            ${props.theme.mediaQueries.xlarge} {
                grid-template-columns: minmax(0, 1fr) minmax(0, ${props.$splitViewWidth}px);
            }
        `}

    ${(props) => props.$hasSideBar &&
    props.$hasSplitView &&
    css$3 `
            ${props.theme.mediaQueries.xlarge} {
                grid-template-columns: ${props.theme.pageLayout.sideBar.width} minmax(0, 1fr) minmax(0, 0);
            }
        `}

    ${(props) => props.$hasSideBar &&
    props.$hasSplitView &&
    props.$isSplitViewOpen &&
    css$3 `
            ${props.theme.mediaQueries.xlarge} {
                grid-template-columns: ${props.theme.pageLayout.sideBar.width} minmax(0, 1fr) minmax(
                        0,
                        ${props.$splitViewWidth}px
                    );
            }
        `}
`;
const StyledSideBar$1 = styled.aside `
    grid-column: 1 / 2;
`;
const StyledContent$4 = styled.section `
    max-width: ${(props) => props.$width && props.theme.pageLayout.width[props.$width]};
    margin: 0 auto;
    width: 100%;
    grid-column: 1 / 2;

    ${({ $bannerHeight, $isSplitViewOpen, theme }) => $isSplitViewOpen &&
    css$3 `
            overflow-y: auto;
            height: calc(
                100vh - ${theme.appLayout.header.height} ${$bannerHeight ? ` - ${$bannerHeight}px` : ''}
            ); /* Ternary operator instead of short-circuit evaluation to prevent trailing zero */
        `}

    ${(props) => props.$hasSideBar &&
    css$3 `
            ${props.theme.mediaQueries.large} {
                grid-column: 2 / 3;
            }
        `}
`;
const StyledChildren = styled.main `
    padding-right: 16px;
    padding-left: 16px;
    margin: 24px auto;
    transition: 0.15s padding ease-out;

    ${(props) => props.$noGutterOnMobile &&
    css$3 `
            padding: 0;
        `}

    ${(props) => props.theme.mediaQueries.small} {
        padding-right: 16px;
        padding-left: 16px;
    }

    ${(props) => props.theme.mediaQueries.large} {
        padding-right: 24px;
        padding-left: 24px;
        margin: 40px auto;
    }

    ${(props) => props.theme.mediaQueries.xlarge} {
        padding-right: 32px;
        padding-left: 32px;
    }
`;
const StyledSplitView$1 = styled.aside `
    ${(props) => !props.$hasSideBar &&
    css$3 `
            grid-column: 2 / 3;
        `}

    ${(props) => props.$hasSideBar &&
    css$3 `
            grid-column: 3 / 4;
        `}
`;

function Pagination({ backwardText = 'Vorige pagina', forwardText = 'Volgende pagina', isDisabled = false, isSensitiveData = false, itemRangeText = (min, max, total) => `Resultaat ${min} - ${max} van ${total}`, itemsPerPageText = 'Per pagina', onChange, page = 1, pageRangeText = (_current, total) => `van ${total}`, pageSize = 10, pageSizes = [10, 15, 20, 25, 50, 100], skipBackwardText = 'Eerste pagina', skipForwardText = 'Laatste pagina', totalItems, }) {
    const inputId = useUniqueId();
    const selectOptions = pageSizes.map((size) => ({ label: size, value: size }));
    const totalPages = Math.max(Math.ceil(totalItems / pageSize), 1);
    const isBackButtonDisabled = isDisabled || page === 1;
    const isForwardButtonDisabled = isDisabled || page === totalPages;
    function handleChange(newPage, newPageSize) {
        if (onChange) {
            onChange({ page: newPage, pageSize: newPageSize });
        }
    }
    function handleSizeChange(newValue) {
        const newPage = 1;
        const newPageSize = Number(newValue === null || newValue === void 0 ? void 0 : newValue.value);
        handleChange(newPage, newPageSize);
    }
    function handlePageInputChange(value) {
        let newPage;
        if (!value) {
            newPage = 1;
        }
        else if (value > totalPages) {
            newPage = totalPages;
        }
        else {
            newPage = value;
        }
        handleChange(newPage, pageSize);
    }
    function incrementPage() {
        const nextPage = page + 1;
        handleChange(nextPage, pageSize);
    }
    function decrementPage() {
        const nextPage = page - 1;
        handleChange(nextPage, pageSize);
    }
    function goToLastPage() {
        const lastPage = totalPages;
        handleChange(lastPage, pageSize);
    }
    function goToFirstPage() {
        const firstPage = 1;
        handleChange(firstPage, pageSize);
    }
    return (jsxRuntimeExports.jsxs(Box, { alignItems: ['flex-start', null, 'center'], display: "flex", flexDirection: ['column', null, 'row'], justifyContent: "space-between", mt: 6, sx: { columnGap: 3, rowGap: 4 }, width: "100%", children: [jsxRuntimeExports.jsxs(Box, { alignItems: "center", "data-dd-privacy": isSensitiveData ? 'mask' : 'allow', display: "flex", flexWrap: "wrap", sx: { rowGap: 4 }, children: [jsxRuntimeExports.jsx(Box, { minWidth: "224px", children: jsxRuntimeExports.jsx(Text, { size: "sm", sx: { whiteSpace: 'nowrap' }, children: itemRangeText(Math.min(pageSize * (page - 1) + 1, totalItems), Math.min(page * pageSize, totalItems), totalItems) }) }), jsxRuntimeExports.jsxs(Box, { alignItems: "center", display: "grid", gap: 2, gridTemplateColumns: "min-content 88px", children: [jsxRuntimeExports.jsx(FormLabel, { htmlFor: inputId, size: "medium", sx: { whiteSpace: 'nowrap' }, children: itemsPerPageText }), jsxRuntimeExports.jsx(Select$1, { id: inputId, isDisabled: isDisabled, isSearchable: false, menuPlacement: "top", onChange: handleSizeChange, options: selectOptions, size: "medium", value: { label: pageSize, value: pageSize } })] })] }), (!isBackButtonDisabled || !isForwardButtonDisabled) && (jsxRuntimeExports.jsxs(Box, { alignItems: "center", display: "flex", gap: 3, children: [!isBackButtonDisabled && (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx(IconButton, { disabled: isBackButtonDisabled, icon: "caret-skip-backward", labelText: skipBackwardText, onClick: goToFirstPage, size: "small", variant: "filled" }), jsxRuntimeExports.jsx(IconButton, { disabled: isBackButtonDisabled, icon: "caret-left", labelText: backwardText, onClick: decrementPage, size: "small", variant: "filled" })] })), jsxRuntimeExports.jsx(NumberInput, { "aria-label": "Paginanummer", isDisabled: isDisabled, onChange: handlePageInputChange, size: "medium", sx: { '.react-aria-Input': { textAlign: 'center' }, width: '48px' }, value: page, children: page }), jsxRuntimeExports.jsx(Text, { size: "sm", sx: { whiteSpace: 'nowrap' }, children: pageRangeText(page, totalPages) }), !isForwardButtonDisabled && (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx(IconButton, { disabled: isForwardButtonDisabled, icon: "caret-right", labelText: forwardText, onClick: incrementPage, size: "small", variant: "filled" }), jsxRuntimeExports.jsx(IconButton, { disabled: isForwardButtonDisabled, icon: "caret-skip-forward", labelText: skipForwardText, onClick: goToLastPage, size: "small", variant: "filled" })] }))] }))] }));
}

function Popover(_a) {
    var { children, content, sx: sxProp } = _a, props = __rest(_a, ["children", "content", "sx"]);
    return (jsxRuntimeExports.jsxs(PopoverPrimitive.Root, Object.assign({}, props, { children: [jsxRuntimeExports.jsx(StyledPopoverTrigger, { children: children }), jsxRuntimeExports.jsx(PopoverPrimitive.Portal, { children: jsxRuntimeExports.jsxs(StyledPopoverContent, { sideOffset: 4, sx: sxProp, children: [content, jsxRuntimeExports.jsx(StyledPopoverArrow, {})] }) })] })));
}
const StyledPopoverTrigger = styled(PopoverPrimitive.Trigger) `
    display: inline-flex;
    background-color: initial;
    border: 0;
    cursor: pointer;
    margin: 0;
    padding: 0;
    color: inherit;
    border-bottom: 1px dashed currentcolor;
    font-size: inherit;
    line-height: inherit;
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;

    &:focus {
        outline: none;
    }

    &:focus-visible {
        outline: 2px solid var(--kds-color-border-focused);
        outline-offset: 2px;
    }
`;
const StyledPopoverContent = styled(PopoverPrimitive.Content) `
    max-width: 320px;
    min-width: 200px;
    padding: 12px 16px;
    border-radius: ${(props) => props.theme.radii.base};
    box-shadow:
        hsl(206deg 22% 7% / 35%) 0 10px 38px -10px,
        hsl(206deg 22% 7% / 20%) 0 10px 20px -15px;
    font-weight: ${(props) => props.theme.fontWeights.normal};
    font-size: 14px;
    color: ${(props) => props.theme.colors.neutral900};
    line-height: 20px;
    background-color: white;
    text-align: left;
    z-index: 9999;

    ${sx};
`;
const StyledPopoverArrow = styled(PopoverPrimitive.Arrow) `
    fill: white;
`;

function ProcessActivityItem({ children, isRenderedInSplitView = false, mode }) {
    if (isRenderedInSplitView) {
        return (jsxRuntimeExports.jsx(Box, { sx: {
                container: 'process-activity-item / inline-size',
            }, children: children }));
    }
    else {
        return (jsxRuntimeExports.jsxs(Card, { sx: {
                container: 'process-activity-item / inline-size',
                margin: '0',
                zIndex: mode === 'edit' ? 1 : null,
            }, children: [jsxRuntimeExports.jsx(Card.Transition, { type: mode }), children] }));
    }
}

function ProcessAccordionItem(_a) {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (jsxRuntimeExports.jsx(AccordionPrimitive.Item, Object.assign({}, props, { children: jsxRuntimeExports.jsx(ProcessActivityItem, { mode: "read", children: children }) })));
}

const controlButtonStyles = {
    medium: {
        paddingLeft: 2.5,
        paddingRight: 2.5,
    },
    small: {
        paddingLeft: 1.5,
        paddingRight: 1.5,
    },
};
function SplitButton({ color = 'primary', isPersistent = false, isSensitiveData = false, items, size = 'medium', variant = 'solid', }) {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const handleClick = (event) => {
        event.stopPropagation();
        if (isOpen) {
            setIsOpen(false);
        }
        items[selectedIndex].onClick();
    };
    const handleMenuItemClick = (index, isDisabled) => {
        if (isDisabled) {
            return;
        }
        setIsOpen(!isOpen);
        if (isPersistent) {
            setSelectedIndex(index);
        }
        items[index].onClick();
    };
    return (jsxRuntimeExports.jsxs(RadixDropdownMenu.Root, { modal: false, onOpenChange: setIsOpen, open: isOpen, children: [jsxRuntimeExports.jsxs(ButtonGroup, { color: color, size: size, variant: variant, children: [jsxRuntimeExports.jsx(Button, { onClick: (event) => handleClick(event), children: items[selectedIndex].label }), jsxRuntimeExports.jsx(RadixDropdownMenu.Trigger, { asChild: true, children: jsxRuntimeExports.jsx(Button, { sx: {
                                pl: controlButtonStyles[size].paddingLeft,
                                pr: controlButtonStyles[size].paddingRight,
                            }, children: jsxRuntimeExports.jsx(Icon, { color: "inherit", icon: "caret-down" }) }) })] }), jsxRuntimeExports.jsx(RadixDropdownMenu.Portal, { children: jsxRuntimeExports.jsx(StyledRadixDropdownMenuContent, { align: "end", side: "bottom", sideOffset: 5, children: items.map((item, index) => (jsxRuntimeExports.jsx(DropdownMenuItem, { "data-dd-privacy": isSensitiveData ? 'mask' : 'allow', disabled: item.isDisabled, hidden: !isPersistent && index === selectedIndex, onClick: () => { var _a; return handleMenuItemClick(index, (_a = item.isDisabled) !== null && _a !== void 0 ? _a : false); }, children: item.label }, item.label))) }) })] }));
}

const containerQueries = {
    large: `@container process-activity-item (inline-size > 1024px)`,
    medium: `@container process-activity-item (inline-size > 700px)`,
    small: `@container process-activity-item (inline-size > 544px)`,
};
function ProcessActivityHeader({ autoSaveStatus, badgeItems, date: dateProp, isRenderedInSplitView, isSensitiveData = false, organizationName, practitionerName, primaryActionItems, secondaryActionItems, status, title, titleBadge, }) {
    const date = dateProp ? DateTime.from(dateProp) : undefined;
    const hasDetails = Boolean(practitionerName !== null && practitionerName !== void 0 ? practitionerName : organizationName);
    const hasSlot = Boolean(primaryActionItems !== null && primaryActionItems !== void 0 ? primaryActionItems : badgeItems);
    const statusIconStyles = {
        cancelled: {
            backgroundColor: 'purple100',
            color: 'purple800',
            icon: 'check',
            size: 18,
            tooltipText: 'Afgerond',
        },
        complete: {
            backgroundColor: 'purple100',
            color: 'purple800',
            icon: 'check',
            size: 18,
            tooltipText: 'Afgerond',
        },
        draft: {
            backgroundColor: 'lightBlue200',
            color: 'lightBlue800',
            icon: 'draft',
            size: 18,
            tooltipText: 'Concept',
        },
    };
    const truncateStyles = {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    };
    const handlePrimaryActionClick = (onClick) => (event) => {
        event.stopPropagation();
        onClick();
    };
    const handlePrimaryActionKeyDown = (onClick) => (event) => {
        if (event.key === ' ' || event.key === 'Enter' || event.key === 'Spacebar') {
            // Prevent the default action to stop scrolling when space is pressed
            event.preventDefault();
            onClick();
        }
    };
    const WithOrWithoutTooltip = ({ children }) => {
        if (status) {
            return jsxRuntimeExports.jsx(Tooltip, { content: statusIconStyles[status].tooltipText, children: children });
        }
        return children;
    };
    return (jsxRuntimeExports.jsxs(StyledProcessActivityHeader, { "$autoSaveStatus": autoSaveStatus, "$isRenderedInSplitView": isRenderedInSplitView, children: [jsxRuntimeExports.jsxs(StyledDate$1, { dateTime: date === null || date === void 0 ? void 0 : date.format('YYYY-MM-DD'), children: [jsxRuntimeExports.jsxs(Text, { as: "span", color: "minimal", fontWeight: "medium", size: "sm", children: [date === null || date === void 0 ? void 0 : date.format('D'), " ", date === null || date === void 0 ? void 0 : date.format('MMM')] }), jsxRuntimeExports.jsx(Text, { as: "span", color: "minimal", fontWeight: "normal", mt: 0.5, size: "sm", children: date === null || date === void 0 ? void 0 : date.format('YYYY') }), status && (jsxRuntimeExports.jsx(Box, { alignItems: "center", backgroundColor: statusIconStyles[status].backgroundColor, borderRadius: "full", boxShadow: "none", display: "inline-flex", height: "24px", justifyContent: "center", p: 0, position: "absolute", right: "-13px", width: "24px", children: jsxRuntimeExports.jsx(WithOrWithoutTooltip, { children: jsxRuntimeExports.jsx(Icon, { icon: statusIconStyles[status].icon, size: statusIconStyles[status].size, sx: {
                                    color: (theme) => theme.colors[statusIconStyles[status].color],
                                } }) }) }))] }), jsxRuntimeExports.jsxs(StyledContent$3, { "$hasDetails": hasDetails, "$hasSlot": hasSlot, children: [jsxRuntimeExports.jsxs(Box, { alignItems: "flex-start", display: "flex", flexDirection: "column", gridColumn: "title", justifyContent: "center", overflow: "hidden", children: [jsxRuntimeExports.jsxs(Box, { alignItems: "center", display: "flex", minHeight: "28px", width: "100%", children: [jsxRuntimeExports.jsx(StyledTitle$1, { as: "span", "data-dd-privacy": isSensitiveData ? 'mask' : 'allow', id: "process-activity-header-title", style: Object.assign(Object.assign({}, truncateStyles), { display: 'inline-block', userSelect: 'none', verticalAlign: 'top', whiteSpace: 'nowrap' }), children: title }), titleBadge && (jsxRuntimeExports.jsx(Badge, { color: "neutral", size: "small", sx: { ml: 2, mt: 0.5 }, text: titleBadge.text, tooltip: titleBadge.tooltipText ? { content: titleBadge.tooltipText } : undefined }))] }), hasDetails && (jsxRuntimeExports.jsx(StyledSubtitle$1, { children: jsxRuntimeExports.jsxs(Text, { as: "span", color: "minimal", size: "sm", sx: Object.assign(Object.assign({}, truncateStyles), { display: 'inline-block', userSelect: 'none' }), children: [practitionerName, organizationName && ` - ${organizationName}`] }) }))] }), hasDetails && (jsxRuntimeExports.jsxs(StyledNames, { children: [practitionerName && (jsxRuntimeExports.jsx(Text, { as: "span", color: "minimal", size: "sm", sx: Object.assign(Object.assign({}, truncateStyles), { display: 'inline-block', userSelect: 'none' }), children: practitionerName })), organizationName && (jsxRuntimeExports.jsx(Text, { as: "span", color: "minimal", mt: 0.5, size: "xs", sx: Object.assign(Object.assign({}, truncateStyles), { display: 'inline-block', userSelect: 'none' }), children: organizationName }))] })), badgeItems && (jsxRuntimeExports.jsx(StyledBadgeItems, { children: badgeItems.map((badge) => (jsxRuntimeExports.jsx(Badge, { color: badge.color, icon: badge.icon, text: badge.text }, badge.key))) })), primaryActionItems && (jsxRuntimeExports.jsx(StyledPrimaryActionItems, { children: primaryActionItems.length === 1
                            ? primaryActionItems.map((primaryActionItem) => {
                                var _a, _b;
                                return (jsxRuntimeExports.jsx(Button, { as: "div", color: (_a = primaryActionItem.color) !== null && _a !== void 0 ? _a : 'primary', onClick: handlePrimaryActionClick(primaryActionItem.onClick), onKeyDown: handlePrimaryActionKeyDown(primaryActionItem.onClick), role: "button", variant: (_b = primaryActionItem.variant) !== null && _b !== void 0 ? _b : 'solid', children: primaryActionItem.label }, primaryActionItem.key));
                            })
                            : primaryActionItems && jsxRuntimeExports.jsx(SplitButton, { items: primaryActionItems }) })), secondaryActionItems && (jsxRuntimeExports.jsx(StyledSecondaryActionItems, { children: jsxRuntimeExports.jsx(DropdownMenu, { trigger: jsxRuntimeExports.jsx(IconButton, { as: "div", icon: "more", labelText: "Meer acties", onClick: (event) => event.stopPropagation(), role: "button", size: "small", variant: "filled" }), children: secondaryActionItems.map((secondaryActionItem) => (jsxRuntimeExports.jsx(DropdownMenu.Item, { onClick: (event) => event.stopPropagation(), onSelect: () => {
                                    secondaryActionItem.onClick();
                                }, children: secondaryActionItem.label }, secondaryActionItem.key))) }) }))] }), autoSaveStatus && isRenderedInSplitView && (jsxRuntimeExports.jsx(Status, { isSensitiveData: isSensitiveData, state: autoSaveStatus.state, sx: { display: 'flex', justifyContent: 'flex-end', marginX: 2 }, text: autoSaveStatus.text }))] }));
}
const StyledProcessActivityHeader = styled.div `
    ${({ $autoSaveStatus, $isRenderedInSplitView }) => css$3 `
        display: grid;
        grid-template-columns: 122px minmax(0, 1fr) ${$isRenderedInSplitView && $autoSaveStatus && '200px'};
        align-items: center;
        margin: 0;
        padding: 0;
        min-height: 80px;
        width: 100%;
        background-color: transparent;
        border: none;
        border-radius: 4px;
        transition: 300ms;
    `}
    ${({ $isRenderedInSplitView, theme }) => $isRenderedInSplitView &&
    css$3 `
            background-color: ${theme.colors.white};
            border-bottom: 1px solid var(--kds-color-border-minimal);
            position: sticky;
            top: 1px;
            z-index: ${theme.zIndices.banner};
        `}
`;
const StyledDate$1 = styled.time `
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    padding-right: 24px;
    margin-right: 24px;
    text-align: right;
    position: relative;
    user-select: none;
    border-right: 1px solid var(--kds-color-border-minimal);
`;
const StyledContent$3 = styled.div `
    display: grid;
    padding: 16px 0;
    gap: 8px;
    justify-content: flex-start;
    transition: 300ms;

    ${containerQueries.medium} {
        gap: 16px;
        grid-template-columns:
            [title] minmax(0, 3fr) ${({ $hasSlot }) => ($hasSlot ? '[slot] minmax(0, 2fr)' : '')}
            [secondaryActionItems] 32px;
    }

    ${containerQueries.large} {
        grid-template-columns:
            [title] minmax(0, 3fr) ${({ $hasDetails }) => ($hasDetails ? '[details] minmax(0, 2fr)' : '')} ${({ $hasDetails, $hasSlot, }) => ($hasSlot || $hasDetails ? '[slot] minmax(0, 2fr)' : '')}
            [secondaryActionItems] 32px;
    }
`;
const StyledTitle$1 = styled.span `
    font-size: ${({ theme }) => theme.fontSizes.md};
    line-height: ${({ theme }) => theme.lineHeights[6]};
    font-weight: ${({ theme }) => theme.fontWeights.medium};
    color: var(--kds-color-foreground-subtle);
    letter-spacing: ${({ theme }) => theme.letterSpacings.tight};

    ${containerQueries.small} {
        font-size: ${({ theme }) => theme.fontSizes.lg};
        line-height: ${({ theme }) => theme.lineHeights[7]};
    }

    ${containerQueries.large} {
        font-size: ${({ theme }) => theme.fontSizes.xl};
        line-height: ${({ theme }) => theme.lineHeights[7]};
    }
`;
const StyledSecondaryActionItems = styled.div `
    display: flex;
    align-items: center;
    flex-shrink: 0;
    grid-column: secondaryActionItems;
    justify-content: flex-start;
    min-width: 32px;

    ${containerQueries.medium} {
        justify-content: flex-end;
    }
`;
const StyledPrimaryActionItems = styled.div `
    display: flex;
    align-items: center;
    flex-shrink: 0;
    grid-column: slot;
    justify-content: flex-start;

    ${containerQueries.medium} {
        justify-content: flex-end;
    }
`;
const StyledBadgeItems = styled.div `
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    grid-column: slot;

    ${containerQueries.medium} {
        align-items: center;
        justify-content: flex-end;
    }
`;
const StyledNames = styled.div `
    display: none;
    flex-direction: column;
    grid-column: details;
    height: 100%;
    justify-content: center;
    text-align: left;
    width: 100%;
    align-self: flex-start;

    ${containerQueries.large} {
        display: flex;
    }
`;
const StyledSubtitle$1 = styled.div `
    display: flex;
    width: 100%;

    ${containerQueries.large} {
        display: none;
    }
`;

function ProcessAccordionHeader(_a) {
    var { badgeItems, date, isSensitiveData = false, organizationName, practitionerName, primaryActionItems, secondaryActionItems, status, title, titleBadge } = _a, props = __rest(_a, ["badgeItems", "date", "isSensitiveData", "organizationName", "practitionerName", "primaryActionItems", "secondaryActionItems", "status", "title", "titleBadge"]);
    return (jsxRuntimeExports.jsx(StyledProcessAccordionHeader, { children: jsxRuntimeExports.jsxs(StyledProcessAccordionTrigger, Object.assign({}, props, { children: [jsxRuntimeExports.jsx(ProcessActivityHeader, { badgeItems: badgeItems, date: date, isSensitiveData: isSensitiveData, organizationName: organizationName, practitionerName: practitionerName, primaryActionItems: primaryActionItems, secondaryActionItems: secondaryActionItems, status: status, title: title, titleBadge: titleBadge }), jsxRuntimeExports.jsx(Box, { alignItems: "center", display: "flex", flexShrink: 0, height: "100%", justifyContent: "center", width: "64px", children: jsxRuntimeExports.jsx(StyledIcon$3, { color: "minimal", icon: "caret-down" }) })] })) }));
}
const StyledProcessAccordionHeader = styled(AccordionPrimitive.Header) `
    display: flex;
    margin: 0;
`;
const StyledIcon$3 = styled(Icon) `
    transition: transform 300ms cubic-bezier(0.87, 0, 0.13, 1);
`;
const StyledProcessAccordionTrigger = styled(AccordionPrimitive.Trigger) `
    margin: 0;
    padding: 0;
    width: 100%;
    display: flex;
    background-color: transparent;
    border: none;
    border-radius: 4px;

    &[data-state='open'] ${StyledIcon$3} {
        transform: rotate(180deg);
    }

    &[data-disabled] ${StyledIcon$3} {
        display: none;
    }

    &:focus {
        outline: none;
    }

    &:focus-visible {
        outline: 2px solid var(--kds-color-border-focused);
    }

    &:hover:not(:disabled) #process-activity-header-title {
        color: ${(props) => props.theme.colors.blue700};
        transition: color 0.2s ease-in-out;
    }
`;

function ProcessActivityContent({ children }) {
    return (jsxRuntimeExports.jsx(StyledBox, { pb: 12, pt: 6, px: 8, children: children }));
}
const StyledBox = styled(Box) `
    border-top: 1px solid var(--kds-color-border-minimal);
`;

function ProcessAccordionContent(_a) {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (jsxRuntimeExports.jsx(StyledProcessAccordionContent, Object.assign({}, props, { children: jsxRuntimeExports.jsx(ProcessActivityContent, { children: children }) })));
}
const slideDown = keyframes({
    from: { height: 0 },
    to: { height: 'var(--radix-accordion-content-height)' },
});
const slideUp = keyframes({
    from: { height: 'var(--radix-accordion-content-height)' },
    to: { height: 0 },
});
const StyledProcessAccordionContent = styled(AccordionPrimitive.Content) `
    overflow: hidden;

    &[data-state='open'] {
        animation: ${slideDown} 300ms cubic-bezier(0.87, 0, 0.13, 1);
    }

    &[data-state='closed'] {
        animation: ${slideUp} 300ms cubic-bezier(0.87, 0, 0.13, 1);
    }
`;

function ProcessAccordion(_a) {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (jsxRuntimeExports.jsx(StyledProcessAccordion, Object.assign({ type: "multiple" }, props, { children: children })));
}
const StyledProcessAccordion = styled(AccordionPrimitive.Root) `
    display: flex;
    gap: 12px;
    flex-direction: column;
    padding-bottom: 32px;
`;

function ProcessItemContainer(_a) {
    var { children } = _a, props = __rest(_a, ["children"]);
    return jsxRuntimeExports.jsx(StyledProcessItemContainer, Object.assign({}, props, { children: children }));
}
const StyledProcessItemContainer = styled.div `
    padding: 16px 16px 24px;
    border: 0;
    border-radius: 0;
    position: relative;

    &:not(:last-child) {
        border-bottom: 1px solid ${(props) => props.theme.colors.neutral100};
        margin-bottom: 0;
    }

    ${(props) => props.theme.mediaQueries.medium} {
        padding: 16px 24px 24px 64px;
    }

    ${(props) => props.theme.mediaQueries.xlarge} {
        padding: 24px 56px 32px 80px;
    }
    ${sx}
`;

function ProcessItemHeader(_a) {
    var { badgeIcon, badgeText, color, date: dateProp, icon, isOpen, isSensitiveData = false, onClick, organizationName, practitionerName, processId, title } = _a, props = __rest(_a, ["badgeIcon", "badgeText", "color", "date", "icon", "isOpen", "isSensitiveData", "onClick", "organizationName", "practitionerName", "processId", "title"]);
    const { width } = useViewportWidth();
    let date;
    if (dateProp) {
        date = DateTime.from(dateProp);
    }
    const handleClick = (event) => {
        event.stopPropagation();
        if (onClick) {
            onClick(event);
        }
    };
    return (jsxRuntimeExports.jsxs(StyledProcessItemHeader, Object.assign({ "$icon": icon, "data-dd-action-name": "expand-process-item", onClick: onClick && handleClick }, props, { children: [icon && (jsxRuntimeExports.jsx(StyledIconCircle$1, { color: color, hasBorder: true, icon: icon, size: "medium" })), jsxRuntimeExports.jsxs(Box, { display: "flex", flex: "1 1 0%", flexDirection: "column", flexWrap: "wrap", justifyContent: "space-between", overflow: "hidden", children: [jsxRuntimeExports.jsxs(StyledTitle, { children: [jsxRuntimeExports.jsx(Text, { as: "h2", color: "subtle", "data-dd-privacy": isSensitiveData ? 'mask' : 'allow', fontWeight: "medium", letterSpacing: "tight", size: ['lg', null, null, 'xl'], sx: {
                                    display: 'inline-block',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    verticalAlign: 'top',
                                    whiteSpace: 'nowrap',
                                }, children: title }), badgeText && (jsxRuntimeExports.jsx(Badge, { icon: badgeIcon, size: "small", sx: { ml: 2, mt: 0.5 }, text: badgeText }))] }), jsxRuntimeExports.jsxs(StyledSubtitle, { children: [processId && jsxRuntimeExports.jsxs(StyledSubtitleText, { size: "inherit", children: ["PID ", processId] }), practitionerName && width < 768 && (jsxRuntimeExports.jsxs(StyledSubtitleText, { size: "inherit", children: [practitionerName, organizationName && ` - ${organizationName}`] }))] })] }), jsxRuntimeExports.jsxs(StyledDetailsDateWrapper, { children: [jsxRuntimeExports.jsxs(StyledDetails, { children: [jsxRuntimeExports.jsx(StyledDetailsTitle, { children: practitionerName }), jsxRuntimeExports.jsx(StyledDetailsSubtitle, { children: organizationName && `${organizationName}` })] }), date && (jsxRuntimeExports.jsxs(StyledDate, { dateTime: date.format('YYYY-MM-DD'), children: [jsxRuntimeExports.jsxs(StyledDateTitle, { children: [date.format('D'), " ", date.format('MMM')] }), jsxRuntimeExports.jsx(StyledDateSubtitle, { children: date.format('YYYY') })] }))] }), onClick && (jsxRuntimeExports.jsx(StyledIcon$2, { color: "minimal", icon: isOpen ? 'caret-up' : 'caret-down' }))] })));
}
const StyledIcon$2 = styled(Icon) `
    margin-top: var(--kds-spacing-2);
`;
const StyledIconCircle$1 = styled(IconCircle) `
    position: relative;
    flex-shrink: 0;
    margin-right: 8px;
    margin-top: -4px;

    ${(props) => props.theme.mediaQueries.medium} {
        display: flex;
        position: absolute;
        left: 16px;
        top: 12px;
        margin: 0;
    }

    ${(props) => props.theme.mediaQueries.xlarge} {
        left: 28px;
        top: 20px;
    }
`;
const StyledProcessItemHeader = styled.div `
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin: 0 0 24px;
    cursor: ${(props) => (props.onClick ? 'pointer' : 'default')};
    flex-wrap: nowrap;

    ${(props) => props.$icon &&
    css$3 `
            margin-left: -8px;
        `}

    ${(props) => props.theme.mediaQueries.medium} {
        ${(props) => props.$icon &&
    css$3 `
                margin-left: 0;
            `}
    }
    ${sx}
`;
const StyledTitle = styled.div `
    display: flex;
    align-items: center;
    width: 100%;
    min-height: 28px;
`;
const StyledSubtitle = styled.div `
    margin: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    max-width: 100%;
    font-size: 12px;
    line-height: 16px;
    min-height: 16px;
    color: var(--kds-color-foreground-minimal);
`;
const StyledSubtitleText = styled(Text).attrs({ as: 'span' }) `
    color: var(--kds-color-foreground-minimal);

    &:not(:last-child) {
        &::after {
            margin-left: 4px;
            margin-right: 4px;
            content: '\\2022';
        }
    }
`;
const StyledDetailsDateWrapper = styled.div `
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 4px;
`;
const StyledDetails = styled.div `
    display: none;

    ${(props) => props.theme.mediaQueries.medium} {
        display: flex;
        align-self: flex-start;
        text-align: right;
        flex-direction: column;
        padding: 0 16px;
    }
`;
const StyledDetailsTitle = styled.span `
    display: block;
    font-size: 14px;
    line-height: 20px;
    color: var(--kds-color-foreground-minimal);
    width: 160px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-top: 1px;

    ${(props) => props.theme.mediaQueries.large} {
        margin-top: 2px;
    }

    ${(props) => props.theme.mediaQueries.xlarge} {
        width: 256px;
    }
`;
const StyledDetailsSubtitle = styled(StyledDetailsTitle) `
    font-size: 12px;
    line-height: 16px;
    margin-top: 3px;

    ${(props) => props.theme.mediaQueries.large} {
        margin-top: 2px;
    }
`;
const StyledDate = styled.time `
    min-width: 70px;
    max-width: 70px;
    padding: 0 0 0 16px;
    display: inline-block;

    ${(props) => props.theme.mediaQueries.medium} {
        border-left: 1px solid var(--kds-color-border-minimal);
    }
`;
const StyledDateTitle = styled.span `
    display: block;
    font-size: 14px;
    line-height: 20px;
    font-weight: 700;
    margin-top: 1px;
    color: var(--kds-color-foreground-subtle);

    ${(props) => props.theme.mediaQueries.large} {
        margin-top: 2px;
    }
`;
const StyledDateSubtitle = styled.span `
    display: block;
    font-size: 12px;
    line-height: 16px;
    font-weight: 400;
    color: var(--kds-color-foreground-subtle);
    margin-top: 3px;

    ${(props) => props.theme.mediaQueries.large} {
        margin-top: 2px;
    }
`;

/**
 * Custom hook that provides a ref object and a function to set focus on the referenced element.
 *
 * @returns {[React.RefObject<HTMLInputElement>, () => void]} A tuple containing:
 * - A ref object to be attached to an input element.
 * - A function to set focus on the input element referenced by the ref object.
 *
 * @example
 * const [inputRef, setInputFocus] = useFocus();
 *
 * return (
 *   <input ref={inputRef} />
 *   <button onClick={setInputFocus}>Focus Input</button>
 * );
 */
function useFocus() {
    const htmlElRef = useRef(null);
    function setFocus() {
        if (htmlElRef.current) {
            htmlElRef.current.focus();
        }
    }
    return [htmlElRef, setFocus];
}

function Radio(_a) {
    var { checked = false, disabled = false, error, id, inputRef, label = '', name, onChange, sx: sxProp, textInput, value } = _a, props = __rest(_a, ["checked", "disabled", "error", "id", "inputRef", "label", "name", "onChange", "sx", "textInput", "value"]);
    const inputId = useUniqueId(id);
    const [textInputRef, setTextInputFocus] = useFocus();
    useEffect(() => {
        if (checked && textInputRef.current) {
            setTextInputFocus();
        }
    }, [checked]);
    return (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsxs(StyledRadioContainer, { sx: sxProp, children: [jsxRuntimeExports.jsxs(StyledRadioInputWrapper, { children: [jsxRuntimeExports.jsx(StyledRadioInput, Object.assign({ "aria-checked": checked, checked: checked, disabled: disabled, id: inputId, name: name, onChange: onChange, ref: inputRef, type: "radio", value: value }, props)), jsxRuntimeExports.jsx(StyledRadioRipple, {}), jsxRuntimeExports.jsx(StyledRadioBackground, { checked: checked, disabled: disabled, children: jsxRuntimeExports.jsx(StyledRadioCheck, { checked: checked }) })] }), label && (jsxRuntimeExports.jsx(StyledRadioLabel, { "$disabled": disabled, htmlFor: inputId, children: label }))] }), textInput && (jsxRuntimeExports.jsx(TextInput, { "aria-label": textInput['aria-label'], disabled: !checked || disabled, onBlur: textInput.onBlur, onChange: (event) => {
                    textInput.onChange(event);
                }, ref: textInputRef, sx: { pb: 1, pl: 8, pt: 0.5 }, value: textInput.value })), error && jsxRuntimeExports.jsx(FormErrorMessage, { children: error })] }));
}
const StyledRadioContainer = styled.div `
    display: flex;
    align-items: center;
    position: relative;
    min-height: 24px;

    ${sx};
`;
const StyledRadioInputWrapper = styled.div `
    display: flex;
    height: 20px;
    width: 20px;
    flex-shrink: 0;
    margin-top: 2px;
    align-self: flex-start;
`;
const StyledRadioRipple = styled.span `
    border-radius: ${(props) => props.theme.radii.full};
    box-shadow: 0 0 0 0 var(--kds-color-shadow-subtle);
    height: 20px;
    transition: box-shadow 150ms ease-out;
    width: 20px;
    position: absolute;
    pointer-events: none;
`;
const StyledRadioBackground = styled.div `
    align-items: center;
    border-radius: ${(props) => props.theme.radii.full};
    border-style: solid;
    border-width: 1px;
    box-sizing: border-box;
    display: flex;
    height: 20px;
    justify-content: center;
    pointer-events: none;
    position: absolute;
    transition: all 200ms ease 0s;
    width: 20px;
    border-color: ${(props) => props.checked
    ? `var(--kds-color-border-selected)`
    : props.disabled
        ? `var(--kds-color-border-disabled)`
        : `var(--kds-color-border-medium)`};
    background-color: ${(props) => props.checked
    ? `var(--kds-color-border-selected)`
    : props.disabled
        ? `var(--kds-color-background-disabled)`
        : `var(--kds-color-background-default)`};
`;
const StyledRadioCheck = styled.div `
    background-color: var(--kds-color-background-default);
    border-radius: ${(props) => props.theme.radii.full};
    height: 8px;
    pointer-events: none;
    transition:
        transform 200ms ease,
        opacity 200ms ease;
    width: 8px;
    opacity: ${(props) => (props.checked ? '1' : '0')};
    transform: ${(props) => (props.checked ? 'scale(1)' : 'scale(0.5)')};
`;
const StyledRadioLabel = styled.label `
    font-size: var(--kds-font-size-sm);
    color: ${(props) => props.$disabled ? `var(--kds-color-foreground-disabled);` : `var(--kds-color-foreground-default)`};
    letter-spacing: 0;
    max-width: 100%;
    display: inline-block;
    line-height: 20px;
    font-weight: 400;
    padding-left: 12px;
    cursor: ${(props) => (props.$disabled ? undefined : 'pointer')};
    margin: 0;
`;
const StyledRadioInput = styled.input `
    border-radius: ${(props) => props.theme.radii.sm};
    width: 24px;
    height: 24px;
    margin: -2px 0 0 -2px;
    position: absolute;
    opacity: 0;
    cursor: ${(props) => (props.disabled ? undefined : 'pointer')};

    &:focus,
    &:active {
        outline: none;
    }

    &:focus,
    &:active,
    &:focus:hover,
    &:active:hover {
        ~ ${StyledRadioBackground} {
            border-color: ${(props) => props.disabled ? `var(--kds-color-border-disabled)` : `var(--kds-color-border-focused)`};
            border-width: 2px;
        }
    }

    &:focus:not(:focus-visible) ~ ${StyledRadioBackground} {
        border-color: var(--kds-color-border-medium);
        border-width: 1px;
    }

    &:focus:not(:focus-visible):hover ~ ${StyledRadioBackground} {
        border-color: var(--kds-color-border-strong);
    }

    &:checked:focus ~ ${StyledRadioBackground} {
        border-color: var(--kds-color-border-selected);
        outline: 2px solid var(--kds-color-border-focused);
        outline-offset: 2px;
    }

    &:checked:focus:not(:focus-visible) ~ ${StyledRadioBackground} {
        box-shadow: none;
        border-color: var(--kds-color-border-selected);
        outline: none;
    }

    &:hover ~ ${StyledRadioRipple} {
        box-shadow: ${(props) => (props.disabled ? undefined : `0 0 0 7px var(--kds-color-shadow-subtle)`)};
    }

    &:hover ~ ${StyledRadioBackground} {
        background-color: ${(props) => props.checked
    ? `var(--kds-color-background-selected)`
    : props.disabled
        ? `var(--kds-color-background-disabled)`
        : `var(--kds-color-background-default)`};
        border-color: ${(props) => props.checked
    ? `var(--kds-color-border-selected)`
    : props.disabled
        ? `var(--kds-color-border-disabled)`
        : `var(--kds-color-border-strong)`};
        border-width: 1px;
    }
`;

function RadioButton(_a) {
    var { checked = false, disabled = false, id, inputRef, isSensitiveData = false, label = '', name, onChange, value } = _a, props = __rest(_a, ["checked", "disabled", "id", "inputRef", "isSensitiveData", "label", "name", "onChange", "value"]);
    const inputId = useUniqueId(id);
    return (jsxRuntimeExports.jsxs(StyledRadioButtonContainer, { "$checked": checked, "$disabled": disabled, children: [jsxRuntimeExports.jsx(StyledRadioButtonInput, Object.assign({ "aria-checked": checked, checked: checked, disabled: disabled, id: inputId, name: name, onChange: onChange, ref: inputRef, type: "radio", value: value }, props)), jsxRuntimeExports.jsx(StyledRadioButtonLabel, { "$checked": checked, "$disabled": disabled, "data-dd-privacy": isSensitiveData ? 'mask' : 'allow', htmlFor: inputId, children: label })] }));
}
const StyledRadioButtonLabel = styled.label `
    cursor: ${(props) => (props.$disabled ? undefined : 'pointer')};
    font-weight: 400;
    font-size: var(--kds-font-size-sm);
    background-color: var(--kds-color-background-default);
    border-bottom: 1px solid var(--kds-color-border-medium);
    border-right: 1px solid var(--kds-color-border-medium);
    border-top: 1px solid var(--kds-color-border-medium);
    color: var(--kds-color-foreground-default);
    display: block;
    height: 34px;
    min-width: 45px;
    line-height: 31px;
    transition: all 0.2s ease-out;
    margin: 0;
    padding-left: 8px;
    padding-right: 8px;
    text-align: center;

    ${(props) => props.$checked &&
    css$3 `
            background-color: var(--kds-color-background-selected);
            border-bottom-color: var(--kds-color-border-selected);
            border-right-color: var(--kds-color-border-selected);
            border-top-color: var(--kds-color-border-selected);
            color: var(--kds-color-foreground-inverse);
        `}

    ${(props) => props.$disabled &&
    css$3 `
            border-bottom-color: var(--kds-color-border-disabled);
            border-right-color: var(--kds-color-border-disabled);
            border-top-color: var(--kds-color-border-disabled);
            color: var(--kds-color-foreground-disabled);
        `}

    ${(props) => props.$checked &&
    props.$disabled &&
    css$3 `
            background-color: var(--kds-color-background-disabled);
            color: var(--kds-color-foreground-disabled);
        `}
`;
const StyledRadioButtonContainer = styled.div `
    display: inline-block;
    position: relative;
    min-height: 34px;

    &:first-of-type > ${StyledRadioButtonLabel} {
        border-left: 1px solid var(--kds-color-border-medium);
        border-radius: 999px 0 0 999px;

        ${(props) => props.$checked &&
    css$3 `
                border-left-color: var(--kds-color-border-selected);
            `}

        ${(props) => props.$disabled &&
    css$3 `
                border-left-color: var(--kds-color-border-disabled);
            `}
    }

    &:last-of-type > ${StyledRadioButtonLabel} {
        border-right: 1px solid var(--kds-color-border-medium);
        border-radius: 0 999px 999px 0;

        ${(props) => props.$checked &&
    css$3 `
                border-right-color: var(--kds-color-border-selected);
            `}

        ${(props) => props.$disabled &&
    css$3 `
                border-right-color: var(--kds-color-border-disabled);
            `}
    }

    &:not(:first-child) > ${StyledRadioButtonLabel}::before {
        position: absolute;
        top: 0;
        left: -1px;
        display: block;
        box-sizing: content-box;
        width: 1px;
        height: 100%;
        background-color: var(--kds-color-border-medium);
        opacity: 0;
        transition: all 0.2s ease-out;
        content: '';
    }

    & > ${StyledRadioButtonLabel}::before {
        ${(props) => !props.$disabled &&
    props.$checked &&
    css$3 `
                opacity: 1;
                background-color: var(--kds-color-background-selected);
            `}
    }
`;
const StyledRadioButtonInput = styled.input `
    width: 0;
    opacity: 0;
    position: fixed;
    cursor: ${(props) => (props.disabled ? undefined : 'pointer')};

    &:hover ~ ${StyledRadioButtonLabel} {
        ${(props) => !props.checked &&
    !props.disabled &&
    css$3 `
                color: var(--kds-color-foreground-selected);
            `}
    }

    &:focus-visible ~ ${StyledRadioButtonLabel} {
        outline: 2px solid var(--kds-color-border-focused);
        outline-offset: 2px;
    }
`;

function RadioGroup(_a) {
    var { children, error, layout = 'column', name: nameProp, onBlur, onChange, onClearValue, value } = _a, props = __rest(_a, ["children", "error", "layout", "name", "onBlur", "onChange", "onClearValue", "value"]);
    const name = useUniqueId(nameProp);
    const handleChange = (event) => {
        if (onChange) {
            onChange(event);
        }
    };
    return (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx(StyledRadioGroup, Object.assign({ "$layout": layout }, props, { children: Children.map(children, (child, index) => {
                    var _a;
                    if (child.type === Radio || child.type === InputCheckmark || child.type === RadioButton) {
                        const isChecked = typeof value === 'string'
                            ? ((_a = child.props.value) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === (value === null || value === void 0 ? void 0 : value.toLowerCase())
                            : child.props.value === value;
                        const childName = name;
                        const isFirstChild = index === 0;
                        const getTabIndex = () => {
                            // If a RadioGroup has no radio selected the first enabled radio should be focusable
                            if (!value) {
                                return isFirstChild ? 0 : -1;
                            }
                            return isChecked ? 0 : -1;
                        };
                        return cloneElement(child, {
                            checked: isChecked,
                            name: childName,
                            onBlur,
                            onChange: (event) => handleChange(event),
                            onClick: () => {
                                if (isChecked) {
                                    if (onClearValue) {
                                        onClearValue();
                                    }
                                }
                            },
                            tabIndex: getTabIndex(),
                            type: 'radio',
                        });
                    }
                    return child;
                }) })), error && jsxRuntimeExports.jsx(FormErrorMessage, { children: error })] }));
}
const StyledRadioGroup = styled.div `
    /* stylelint-disable declaration-block-no-redundant-longhand-properties */
    display: flex;
    flex-direction: ${(props) => (props.$layout === 'row' ? 'row' : 'column')};
    flex-wrap: ${(props) => (props.$layout === 'row' ? 'wrap' : 'nowrap')};

    ${StyledRadioContainer} {
        margin: 4px 0;

        ${(props) => props.$layout === 'row' &&
    css$3 `
                &:not(:last-child) {
                    margin-right: 24px;
                }
            `}
    }

    ${StyledInputCheckmarkContainer} {
        ${(props) => props.$layout === 'row' &&
    css$3 `
                margin: 12px 16px 8px 0;
            `}

        ${(props) => props.$layout === 'column' &&
    css$3 `
                margin: 12px 0 4px;
            `}
    }
    ${sx}
`;

/**
 * A component that renders a radio group with an optional text input for the last radio button.
 */
function RadioGroupWithTextInput({ checkError, error, layout, onChange, onClearValue, options, value, }) {
    const [radioValue, setRadioValue] = useState();
    const [textInput, setTextInput] = useState('');
    const [radioGroupError, setRadioGroupError] = useState();
    useEffect(() => {
        if (value) {
            setRadioValue(value);
            if (!options.some((option) => option.label === value)) {
                setTextInput(value);
            }
        }
    }, [value]);
    useEffect(() => {
        if (options.some((option) => option.label.toLowerCase() === (textInput === null || textInput === void 0 ? void 0 : textInput.toLowerCase())) && textInput !== '') {
            setRadioGroupError('Optie bestaat al');
            checkError === null || checkError === void 0 ? void 0 : checkError(true);
            return;
        }
        setRadioGroupError(undefined);
        checkError === null || checkError === void 0 ? void 0 : checkError(false);
    }, [textInput, options]);
    function handleValueChange(event) {
        const valueArg = event.target.value;
        setRadioValue(valueArg);
        if (valueArg) {
            onChange === null || onChange === void 0 ? void 0 : onChange(valueArg);
        }
    }
    function handleClearValue() {
        if (onClearValue) {
            setRadioValue(undefined);
            onClearValue();
        }
    }
    function getTextInputProps(hasTextInput, label) {
        if (!hasTextInput) {
            return undefined;
        }
        return {
            'aria-label': label || '',
            onBlur: (event) => {
                if (event.target.value === '') {
                    onChange === null || onChange === void 0 ? void 0 : onChange(event.target.value);
                }
                if (radioGroupError) {
                    setTextInput('');
                    setRadioGroupError(undefined);
                }
            },
            onChange: (event) => {
                setRadioValue(event.target.value);
                setTextInput(event.target.value);
                onChange === null || onChange === void 0 ? void 0 : onChange(event.target.value);
            },
            value: textInput || '',
        };
    }
    return (jsxRuntimeExports.jsx(RadioGroup, { error: radioGroupError || error, layout: layout, onChange: handleValueChange, onClearValue: handleClearValue, value: radioValue, children: options.map((option) => {
            const isTextInput = 'isTextInput' in option;
            const { label } = option;
            const isChecked = isTextInput ? value === textInput : value === label;
            return (jsxRuntimeExports.jsx(Radio, { checked: isChecked, label: label, textInput: isTextInput ? getTextInputProps(isTextInput, label) : undefined, value: isTextInput ? textInput : label }, label));
        }) }));
}

function ScoreBar({ isSensitiveData = false, maxValue, minValue, range, rangeStops, sx: sxProp, value, valueRange, withGradient, }) {
    const percentage = ((value - minValue) * 100) / (maxValue - minValue);
    return (jsxRuntimeExports.jsxs(StyledScoreBar, { "data-dd-privacy": isSensitiveData ? 'mask' : 'allow', sx: sxProp, children: [jsxRuntimeExports.jsx(StyledMinValue, { children: minValue }), jsxRuntimeExports.jsxs(StyledBar, { "$range": range, "$rangeStops": rangeStops, "$withGradient": withGradient, children: [range.length === 1 && (jsxRuntimeExports.jsx(StyledSingleRangeScore, { "$range": range, style: { width: percentage + '%' } })), jsxRuntimeExports.jsx(Badge, { color: valueRange !== null && valueRange !== void 0 ? valueRange : range[0], shape: "circle", size: "medium", sx: {
                            left: percentage + '%',
                            position: 'absolute',
                            top: '50%',
                            transform: 'translate(-50%, -50%)',
                        }, text: value.toString() })] }), jsxRuntimeExports.jsx(StyledMaxValue, { children: maxValue })] }));
}
const StyledScoreBar = styled.div `
    display: flex;
    width: 100%;
    align-items: center;
    flex-flow: row nowrap;
    min-height: 24px;
    gap: 20px;

    ${sx}
`;
const StyledMinValue = styled.div `
    flex: 0 0 auto;
    align-self: center;
    color: ${(props) => props.theme.colors.neutral900};
    min-width: 24px;
    text-align: right;
    font-size: 12px;
`;
const StyledMaxValue = styled.div `
    flex: 0 0 auto;
    align-self: center;
    color: ${(props) => props.theme.colors.neutral900};
    min-width: 24px;
    text-align: left;
    font-size: 12px;
`;
const StyledSingleRangeScore = styled.div `
    position: absolute;
    top: 0;
    left: 0;
    height: 5px;
    border-top-left-radius: 2px;
    border-bottom-left-radius: 2px;
    max-width: 100%;

    ${(props) => props.$range &&
    css$3 `
            background-color: ${props.theme.scoreBar.backgroundColor[props.$range[0]]};
        `}
`;
const StyledBar = styled.div `
    position: relative;
    width: 100%;
    height: 5px;
    border-radius: ${(props) => props.theme.radii.sm};

    ${(props) => props.$range.length === 1 &&
    css$3 `
            background: ${props.theme.colors.neutral200};
        `}

    ${(props) => props.$range.length === 2 &&
    props.$rangeStops === undefined &&
    css$3 `
            background: linear-gradient(
                to right,
                ${props.theme.scoreBar.backgroundColor[props.$range[0]]} 0% 50%,
                ${props.theme.scoreBar.backgroundColor[props.$range[1]]} 50% 100%
            );
        `}

    ${(props) => props.$range.length === 2 &&
    props.$rangeStops &&
    props.$rangeStops.length === 1 &&
    css$3 `
            background: linear-gradient(
                to right,
                ${props.theme.scoreBar.backgroundColor[props.$range[0]]} 0% ${props.$rangeStops[0]}%,
                ${props.theme.scoreBar.backgroundColor[props.$range[1]]} ${props.$rangeStops[0]}% 100%
            );
        `}

    ${(props) => props.$range.length === 3 &&
    props.$rangeStops === undefined &&
    css$3 `
            background: linear-gradient(
                to right,
                ${props.theme.scoreBar.backgroundColor[props.$range[0]]} 0% 33%,
                ${props.theme.scoreBar.backgroundColor[props.$range[1]]} 33% 66%,
                ${props.theme.scoreBar.backgroundColor[props.$range[2]]} 66% 100%
            );
        `}

    ${(props) => props.$range.length === 3 &&
    props.$rangeStops &&
    props.$rangeStops.length === 2 &&
    css$3 `
            background: linear-gradient(
                to right,
                ${props.theme.scoreBar.backgroundColor[props.$range[0]]} 0% ${props.$rangeStops[0]}%,
                ${props.theme.scoreBar.backgroundColor[props.$range[1]]} ${props.$rangeStops[0]}%
                    ${props.$rangeStops[1]}%,
                ${props.theme.scoreBar.backgroundColor[props.$range[2]]} ${props.$rangeStops[1]}% 100%
            );
        `}

    ${(props) => props.$range.length === 4 &&
    props.$rangeStops === undefined &&
    css$3 `
            background: linear-gradient(
                to right,
                ${props.theme.scoreBar.backgroundColor[props.$range[0]]} 0% 25%,
                ${props.theme.scoreBar.backgroundColor[props.$range[1]]} 25% 50%,
                ${props.theme.scoreBar.backgroundColor[props.$range[2]]} 50% 75%,
                ${props.theme.scoreBar.backgroundColor[props.$range[3]]} 75% 100%
            );
        `}

    ${(props) => props.$range.length === 4 &&
    props.$rangeStops &&
    props.$rangeStops.length === 3 &&
    css$3 `
            background: linear-gradient(
                to right,
                ${props.theme.scoreBar.backgroundColor[props.$range[0]]} 0% ${props.$rangeStops[0]}%,
                ${props.theme.scoreBar.backgroundColor[props.$range[1]]} ${props.$rangeStops[0]}%
                    ${props.$rangeStops[1]}%,
                ${props.theme.scoreBar.backgroundColor[props.$range[2]]} ${props.$rangeStops[1]}%
                    ${props.$rangeStops[2]}%,
                ${props.theme.scoreBar.backgroundColor[props.$range[3]]} ${props.$rangeStops[2]}% 100%
            );
        `}

    ${(props) => props.$range.length === 5 &&
    props.$rangeStops === undefined &&
    css$3 `
            background: linear-gradient(
                to right,
                ${props.theme.scoreBar.backgroundColor[props.$range[0]]} 0% 20%,
                ${props.theme.scoreBar.backgroundColor[props.$range[1]]} 20% 40%,
                ${props.theme.scoreBar.backgroundColor[props.$range[2]]} 40% 60%,
                ${props.theme.scoreBar.backgroundColor[props.$range[3]]} 60% 80%,
                ${props.theme.scoreBar.backgroundColor[props.$range[4]]} 80% 100%
            );
        `}

    ${(props) => props.$range.length === 5 &&
    props.$rangeStops &&
    props.$rangeStops.length === 4 &&
    css$3 `
            background: linear-gradient(
                to right,
                ${props.theme.scoreBar.backgroundColor[props.$range[0]]} 0% ${props.$rangeStops[0]}%,
                ${props.theme.scoreBar.backgroundColor[props.$range[1]]} ${props.$rangeStops[0]}%
                    ${props.$rangeStops[1]}%,
                ${props.theme.scoreBar.backgroundColor[props.$range[2]]} ${props.$rangeStops[1]}%
                    ${props.$rangeStops[2]}%,
                ${props.theme.scoreBar.backgroundColor[props.$range[3]]} ${props.$rangeStops[2]}%
                    ${props.$rangeStops[3]}%,
                ${props.theme.scoreBar.backgroundColor[props.$range[4]]} ${props.$rangeStops[3]}% 100%
            );
        `}

    ${(props) => props.$withGradient &&
    props.$range.length === 2 &&
    props.$rangeStops === undefined &&
    css$3 `
            background: linear-gradient(
                to right,
                ${props.theme.scoreBar.backgroundColor[props.$range[0]]} 0%,
                ${props.theme.scoreBar.backgroundColor[props.$range[1]]} 50%
            );
        `}

    ${(props) => props.$withGradient &&
    props.$range.length === 2 &&
    props.$rangeStops &&
    props.$rangeStops.length === 1 &&
    css$3 `
            background: linear-gradient(
                to right,
                ${props.theme.scoreBar.backgroundColor[props.$range[0]]} 0%,
                ${props.theme.scoreBar.backgroundColor[props.$range[1]]} ${props.$rangeStops[0]}%
            );
        `}

      ${(props) => props.$withGradient &&
    props.$range.length === 3 &&
    props.$rangeStops === undefined &&
    css$3 `
            background: linear-gradient(
                to right,
                ${props.theme.scoreBar.backgroundColor[props.$range[0]]} 0%,
                ${props.theme.scoreBar.backgroundColor[props.$range[1]]} 33%,
                ${props.theme.scoreBar.backgroundColor[props.$range[2]]} 66%
            );
        `}

      ${(props) => props.$withGradient &&
    props.$range.length === 3 &&
    props.$rangeStops &&
    props.$rangeStops.length === 2 &&
    css$3 `
            background: linear-gradient(
                to right,
                ${props.theme.scoreBar.backgroundColor[props.$range[0]]} 0%,
                ${props.theme.scoreBar.backgroundColor[props.$range[1]]} ${props.$rangeStops[0]}%,
                ${props.theme.scoreBar.backgroundColor[props.$range[2]]} ${props.$rangeStops[1]}%
            );
        `}

    ${(props) => props.$withGradient &&
    props.$range.length === 4 &&
    props.$rangeStops === undefined &&
    css$3 `
            background: linear-gradient(
                to right,
                ${props.theme.scoreBar.backgroundColor[props.$range[0]]} 0%,
                ${props.theme.scoreBar.backgroundColor[props.$range[1]]} 25%,
                ${props.theme.scoreBar.backgroundColor[props.$range[2]]} 50%,
                ${props.theme.scoreBar.backgroundColor[props.$range[3]]} 75%
            );
        `}

    ${(props) => props.$withGradient &&
    props.$range.length === 4 &&
    props.$rangeStops &&
    props.$rangeStops.length === 3 &&
    css$3 `
            background: linear-gradient(
                to right,
                ${props.theme.scoreBar.backgroundColor[props.$range[0]]} 0%,
                ${props.theme.scoreBar.backgroundColor[props.$range[1]]} ${props.$rangeStops[0]}%,
                ${props.theme.scoreBar.backgroundColor[props.$range[2]]} ${props.$rangeStops[1]}%,
                ${props.theme.scoreBar.backgroundColor[props.$range[3]]} ${props.$rangeStops[2]}%
            );
        `}

    ${(props) => props.$withGradient &&
    props.$range.length === 5 &&
    props.$rangeStops === undefined &&
    css$3 `
            background: linear-gradient(
                to right,
                ${props.theme.scoreBar.backgroundColor[props.$range[0]]} 0%,
                ${props.theme.scoreBar.backgroundColor[props.$range[1]]} 20%,
                ${props.theme.scoreBar.backgroundColor[props.$range[2]]} 40%,
                ${props.theme.scoreBar.backgroundColor[props.$range[3]]} 60%,
                ${props.theme.scoreBar.backgroundColor[props.$range[4]]} 80%
            );
        `}

    ${(props) => props.$withGradient &&
    props.$range.length === 5 &&
    props.$rangeStops &&
    props.$rangeStops.length === 4 &&
    css$3 `
            background: linear-gradient(
                to right,
                ${props.theme.scoreBar.backgroundColor[props.$range[0]]} 0%,
                ${props.theme.scoreBar.backgroundColor[props.$range[1]]} ${props.$rangeStops[0]}%,
                ${props.theme.scoreBar.backgroundColor[props.$range[2]]} ${props.$rangeStops[1]}%,
                ${props.theme.scoreBar.backgroundColor[props.$range[3]]} ${props.$rangeStops[2]}%,
                ${props.theme.scoreBar.backgroundColor[props.$range[4]]} ${props.$rangeStops[3]}%
            );
        `}
`;

function SectionHeader({ action, isSensitiveData = false, noGutterOnMobile, subtitle, title, }) {
    return (jsxRuntimeExports.jsxs(Box, { alignItems: subtitle ? 'flex-start' : 'center', "data-dd-privacy": isSensitiveData ? 'mask' : 'allow', display: "flex", flexWrap: "wrap", gap: 3, justifyContent: "space-between", mb: [4, null, null, 6], minHeight: "40px", mt: [6, null, null, 8], px: noGutterOnMobile ? [4, 0] : null, children: [jsxRuntimeExports.jsxs(Box, { flex: "1 1 0", children: [jsxRuntimeExports.jsx(Heading, { size: "large", children: title }), subtitle && (jsxRuntimeExports.jsx(Text, { color: "minimal", fontWeight: "medium", mt: 1, size: ['sm', null, null, 'md'], children: subtitle }))] }), action && (jsxRuntimeExports.jsx(Box, { display: "flex", flexDirection: "row", gap: 3, children: action }))] }));
}

function SecurityShield(_a) {
    var { height = '80px', variant = 'unsecure', width = '80px' } = _a, props = __rest(_a, ["height", "variant", "width"]);
    switch (variant) {
        case 'unsecure': {
            return (jsxRuntimeExports.jsx("svg", Object.assign({ height: height, viewBox: "0 0 80 80", width: width }, props, { children: jsxRuntimeExports.jsxs("g", { fill: "none", fillRule: "evenodd", children: [jsxRuntimeExports.jsx("circle", { cx: "40", cy: "40", fill: "#FFF3E3", r: "40" }), jsxRuntimeExports.jsx("path", { d: "m59.83 23.772-18.602-7.629a1.92 1.92 0 0 0-1.456 0l-18.602 7.63c-.708.29-1.17.973-1.17 1.731v9.274c0 12.77 7.814 24.257 19.783 29.083.46.185.974.185 1.434 0C53.187 59.035 61 47.548 61 34.778v-9.274c0-.758-.462-1.44-1.17-1.732zm-2.626 11.006c0 10.856-6.454 20.85-16.704 25.31-9.976-4.341-16.704-14.16-16.704-25.31v-8.022l16.704-6.85 16.704 6.85v8.022z", fill: "#FF9A1E", fillRule: "nonzero" }), jsxRuntimeExports.jsx("path", { d: "m34.545 33.5 10.91 11m-10.91 0 10.91-11", stroke: "#FF9A1E", strokeLinecap: "round", strokeWidth: "3" })] }) })));
        }
        case 'secure': {
            return (jsxRuntimeExports.jsx("svg", Object.assign({ height: height, viewBox: "0 0 80 80", width: width }, props, { children: jsxRuntimeExports.jsxs("g", { fill: "none", fillRule: "evenodd", children: [jsxRuntimeExports.jsx("circle", { cx: "40", cy: "40", fill: "#E5FFCD", r: "40" }), jsxRuntimeExports.jsx("path", { d: "m59.83 23.772-18.602-7.629a1.92 1.92 0 0 0-1.456 0l-18.602 7.63c-.708.29-1.17.973-1.17 1.731v9.274c0 12.77 7.814 24.257 19.783 29.083.46.185.974.185 1.434 0C53.187 59.035 61 47.548 61 34.778v-9.274c0-.758-.462-1.44-1.17-1.732zm-2.626 11.006c0 10.856-6.454 20.85-16.704 25.31-9.976-4.341-16.704-14.16-16.704-25.31v-8.022l16.704-6.85 16.704 6.85v8.022z", fill: "#00D06A", fillRule: "nonzero" }), jsxRuntimeExports.jsx("path", { d: "M47.17 34.329a1.05 1.05 0 0 1 1.509-.019c.421.421.43 1.112.017 1.543l-9.218 9.654c-.659.659-1.672.647-2.29 0l-3.884-4.069a1.109 1.109 0 0 1 .017-1.542 1.05 1.05 0 0 1 1.509.018l3.503 3.669 8.837-9.254z", fill: "#00D06A" })] }) })));
        }
        default:
            return null;
    }
}

function SerialNumberInput(_a) {
    var { appearance = 'default', maxLength = 13, placeholder = 'Vul het serienummer in..', sx: sxProp } = _a, props = __rest(_a, ["appearance", "maxLength", "placeholder", "sx"]);
    const inputRef = useRef(null);
    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    }, []);
    return (jsxRuntimeExports.jsxs(StyledInputContainer, { sx: sxProp, children: [jsxRuntimeExports.jsx(StyledSerialNumberInput, Object.assign({ "$appearance": appearance, "aria-label": `Enter serial number`, inputMode: "numeric", maxLength: maxLength, pattern: "[0-9]*", placeholder: placeholder, ref: inputRef, type: "text" }, props)), appearance === 'success' && (jsxRuntimeExports.jsx(StyledIconContainer, { children: jsxRuntimeExports.jsx(StyledIcon$1, { color: "success", icon: "checked" }) }))] }));
}
const StyledInputContainer = styled.div `
    width: 100%;
    display: flex;
    position: relative;

    ${sx}
`;
const StyledSerialNumberInput = styled.input `
    border: 1px solid var(--kds-color-border-medium);
    border-radius: ${(props) => props.theme.radii.sm};
    height: 78px;
    width: 100%;
    font-size: 32px;
    font-weight: 400;
    caret-color: ${(props) => props.theme.colors.magenta700};
    box-shadow: none;
    appearance: none;
    letter-spacing: 2px;
    padding: 0 16px;
    margin: 0 40px;

    &::placeholder {
        font-size: 21px;
        color: var(--kds-color-foreground-minimal);
        font-weight: var(--kds-font-weight-placeholder);
        opacity: 1;
        letter-spacing: normal;
    }

    ${(props) => props.$appearance &&
    css$3 `
            color: ${props.theme.serialNumberInput.color[props.$appearance]};
        `}

    &:hover {
        border-color: var(--kds-color-border-strong);
    }

    &:focus {
        border-color: ${(props) => props.theme.colors.magenta700};
        outline: none;
    }
`;
const StyledIconContainer = styled.div `
    position: absolute;
    right: 0;
    top: 0;
    display: flex;
    align-items: center;
    height: 78px;
    width: 40px;
`;
const StyledIcon$1 = styled(Icon) `
    margin-left: 16px;
    flex-shrink: 0;
`;

function SideBar({ bannerHeight, content, header }) {
    return (jsxRuntimeExports.jsx(StyledSideBar, { "$bannerHeight": bannerHeight, children: jsxRuntimeExports.jsxs(StyledColumn$1, { children: [header && jsxRuntimeExports.jsx(StyledHeader, { children: header }), content && jsxRuntimeExports.jsx(StyledContent$2, { children: content })] }) }));
}
const StyledSideBar = styled.div `
    display: flex;
    width: ${({ theme }) => theme.pageLayout.sideBar.width};
    position: fixed;
    flex-direction: column;
    bottom: 0;

    ${({ $bannerHeight, theme }) => css$3 `
        top: calc(${$bannerHeight !== null && $bannerHeight !== void 0 ? $bannerHeight : 0}px + ${theme.appLayout.header.height});
    `}
`;
const StyledColumn$1 = styled.div `
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    overflow-y: auto;
    padding: 40px 16px;
    box-shadow: 0 0 0 1px var(--kds-color-border-minimal);
    background: var(--kds-color-background-subtle);
`;
const StyledHeader = styled.div `
    flex: 0 0 auto;
    margin-bottom: 40px;
`;
const StyledContent$2 = styled.div `
    flex: 1;
`;

function SmartphoneMfa({ height, id, width }) {
    return (jsxRuntimeExports.jsxs("svg", { height: height, id: id, viewBox: "0 0 117 116", width: width, xmlns: "http://www.w3.org/2000/svg", children: [jsxRuntimeExports.jsxs("defs", { children: [jsxRuntimeExports.jsxs("filter", { height: "170%", id: "a", width: "131.8%", x: "-15.9%", y: "-25%", children: [jsxRuntimeExports.jsx("feOffset", { dy: "2", in: "SourceAlpha", result: "shadowOffsetOuter1" }), jsxRuntimeExports.jsx("feGaussianBlur", { in: "shadowOffsetOuter1", result: "shadowBlurOuter1", stdDeviation: "2" }), jsxRuntimeExports.jsx("feColorMatrix", { in: "shadowBlurOuter1", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0488964161 0" })] }), jsxRuntimeExports.jsxs("filter", { height: "170%", id: "c", width: "131.8%", x: "-15.9%", y: "-25%", children: [jsxRuntimeExports.jsx("feOffset", { dy: "2", in: "SourceAlpha", result: "shadowOffsetOuter1" }), jsxRuntimeExports.jsx("feGaussianBlur", { in: "shadowOffsetOuter1", result: "shadowBlurOuter1", stdDeviation: "2" }), jsxRuntimeExports.jsx("feColorMatrix", { in: "shadowBlurOuter1", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.046055507 0" })] }), jsxRuntimeExports.jsxs("filter", { height: "170%", id: "e", width: "131.8%", x: "-15.9%", y: "-25%", children: [jsxRuntimeExports.jsx("feOffset", { dy: "2", in: "SourceAlpha", result: "shadowOffsetOuter1" }), jsxRuntimeExports.jsx("feGaussianBlur", { in: "shadowOffsetOuter1", result: "shadowBlurOuter1", stdDeviation: "2" }), jsxRuntimeExports.jsx("feColorMatrix", { in: "shadowBlurOuter1", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0488964161 0" })] }), jsxRuntimeExports.jsx("path", { d: "M37 25h44v20H37z", id: "b" }), jsxRuntimeExports.jsx("path", { d: "M37 48h44v20H37z", id: "d" }), jsxRuntimeExports.jsx("path", { d: "M37 71h44v20H37z", id: "f" })] }), jsxRuntimeExports.jsxs("g", { fill: "none", fillRule: "evenodd", children: [jsxRuntimeExports.jsxs("g", { fillRule: "nonzero", children: [jsxRuntimeExports.jsx("ellipse", { cx: "54.5", cy: "113.2", fill: "#ECECE6", fillOpacity: ".726", rx: "54.5", ry: "2.802" }), jsxRuntimeExports.jsx("path", { d: "M86.341 26.922h-.62V9.87c0-5.45-4.394-9.87-9.816-9.87H39.971c-5.421 0-9.816 4.42-9.816 9.87v93.55c0 5.45 4.395 9.87 9.816 9.87h35.934c5.422 0 9.817-4.42 9.817-9.87V39.06h.619V26.922z", fill: "#001858" }), jsxRuntimeExports.jsx("path", { d: "M83.633 9.938v93.412c0 4.071-3.282 7.371-7.331 7.371H40.196c-4.05 0-7.331-3.3-7.331-7.37V9.937c0-4.07 3.282-7.37 7.33-7.37h4.38a3.52 3.52 0 0 0 .336 3.275 3.48 3.48 0 0 0 2.89 1.549h20.586a3.48 3.48 0 0 0 2.89-1.55 3.52 3.52 0 0 0 .335-3.274h4.69c4.049 0 7.331 3.3 7.331 7.37z", fill: "#F6F5F4" })] }), jsxRuntimeExports.jsx("use", { fill: "#000", filter: "url(#a)", xlinkHref: "#b" }), jsxRuntimeExports.jsx("use", { fill: "#FFF", xlinkHref: "#b" }), jsxRuntimeExports.jsx("use", { fill: "#000", filter: "url(#c)", xlinkHref: "#d" }), jsxRuntimeExports.jsx("use", { fill: "#FFF", xlinkHref: "#d" }), jsxRuntimeExports.jsx("use", { fill: "#000", filter: "url(#e)", xlinkHref: "#f" }), jsxRuntimeExports.jsx("use", { fill: "#FFF", xlinkHref: "#f" }), jsxRuntimeExports.jsx("circle", { cx: "42", cy: "58", fill: "#FF37F0", r: "2" }), jsxRuntimeExports.jsx("circle", { cx: "48", cy: "58", fill: "#FF37F0", r: "2" }), jsxRuntimeExports.jsx("circle", { cx: "53", cy: "58", fill: "#FF37F0", r: "2" }), jsxRuntimeExports.jsx("circle", { cx: "63", cy: "58", fill: "#FF37F0", r: "2" }), jsxRuntimeExports.jsx("circle", { cx: "68", cy: "58", fill: "#FF37F0", r: "2" }), jsxRuntimeExports.jsx("circle", { cx: "74", cy: "58", fill: "#FF37F0", r: "2" }), jsxRuntimeExports.jsx("path", { d: "M91 41v2.032h3.215V47h2.424v-3.968h.922v2.275h2.28v-2.275H106V41z", fill: "#fff" }), jsxRuntimeExports.jsx("circle", { cx: "111.5", cy: "41.5", fill: "#fff", r: "5.5" })] })] }));
}

function SmartphoneMfaKey({ height, id, width }) {
    return (jsxRuntimeExports.jsxs("svg", { height: height, id: id, viewBox: "0 0 112 127", width: width, xmlns: "http://www.w3.org/2000/svg", children: [jsxRuntimeExports.jsxs("defs", { children: [jsxRuntimeExports.jsxs("filter", { filterUnits: "objectBoundingBox", height: "149.4%", id: "a", width: "122.5%", x: "-11.2%", y: "-15.7%", children: [jsxRuntimeExports.jsx("feOffset", { dy: "2", in: "SourceAlpha", result: "shadowOffsetOuter1" }), jsxRuntimeExports.jsx("feGaussianBlur", { in: "shadowOffsetOuter1", result: "shadowBlurOuter1", stdDeviation: "1.5" }), jsxRuntimeExports.jsx("feColorMatrix", { in: "shadowBlurOuter1", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0488964161 0" })] }), jsxRuntimeExports.jsxs("filter", { filterUnits: "objectBoundingBox", height: "149.4%", id: "c", width: "122.5%", x: "-11.2%", y: "-15.7%", children: [jsxRuntimeExports.jsx("feOffset", { dy: "2", in: "SourceAlpha", result: "shadowOffsetOuter1" }), jsxRuntimeExports.jsx("feGaussianBlur", { in: "shadowOffsetOuter1", result: "shadowBlurOuter1", stdDeviation: "1.5" }), jsxRuntimeExports.jsx("feColorMatrix", { in: "shadowBlurOuter1", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.046055507 0" })] }), jsxRuntimeExports.jsxs("filter", { filterUnits: "objectBoundingBox", height: "149.4%", id: "e", width: "122.5%", x: "-11.2%", y: "-15.7%", children: [jsxRuntimeExports.jsx("feOffset", { dy: "2", in: "SourceAlpha", result: "shadowOffsetOuter1" }), jsxRuntimeExports.jsx("feGaussianBlur", { in: "shadowOffsetOuter1", result: "shadowBlurOuter1", stdDeviation: "1.5" }), jsxRuntimeExports.jsx("feColorMatrix", { in: "shadowBlurOuter1", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0488964161 0" })] }), jsxRuntimeExports.jsx("path", { d: "M7.173 27.285h48.928v22.259H7.173z", id: "b" }), jsxRuntimeExports.jsx("path", { d: "M7.173 53.852h48.928v22.259H7.173z", id: "d" }), jsxRuntimeExports.jsx("path", { d: "M7.173 79.702h48.928v22.259H7.173z", id: "f" })] }), jsxRuntimeExports.jsxs("g", { fill: "none", fillRule: "evenodd", children: [jsxRuntimeExports.jsxs("g", { transform: "translate(.84)", children: [jsxRuntimeExports.jsxs("g", { fillRule: "nonzero", children: [jsxRuntimeExports.jsx("path", { d: "M63.052 29.996h-.695v-19C62.357 4.923 57.425 0 51.341 0H11.016C4.932 0 0 4.923 0 10.996V115.23c0 6.073 4.932 10.996 11.016 10.996h40.325c6.084 0 11.016-4.923 11.016-10.996V43.52h.695V29.996Z", fill: "#001858" }), jsxRuntimeExports.jsx("path", { d: "M60.013 11.073v104.08c0 4.535-3.684 8.212-8.227 8.212H11.267c-4.544 0-8.227-3.677-8.227-8.213V11.073c0-4.535 3.683-8.212 8.227-8.212h4.915a3.898 3.898 0 0 0 .377 3.649 3.912 3.912 0 0 0 3.243 1.726h23.101a3.912 3.912 0 0 0 3.243-1.726 3.898 3.898 0 0 0 .377-3.65h5.263c4.543 0 8.227 3.678 8.227 8.213Z", fill: "#F6F5F4" })] }), jsxRuntimeExports.jsx("use", { fill: "#000", filter: "url(#a)", xlinkHref: "#b" }), jsxRuntimeExports.jsx("use", { fill: "#FFF", xlinkHref: "#b" }), jsxRuntimeExports.jsx("use", { fill: "#000", filter: "url(#c)", xlinkHref: "#d" }), jsxRuntimeExports.jsx("use", { fill: "#FFF", xlinkHref: "#d" }), jsxRuntimeExports.jsx("use", { fill: "#000", filter: "url(#e)", xlinkHref: "#f" }), jsxRuntimeExports.jsx("use", { fill: "#FFF", xlinkHref: "#f" }), jsxRuntimeExports.jsx("ellipse", { cx: "12.929", cy: "64.623", fill: "#FF37F0", rx: "2.159", ry: "2.154" }), jsxRuntimeExports.jsx("ellipse", { cx: "19.405", cy: "64.623", fill: "#FF37F0", rx: "2.159", ry: "2.154" }), jsxRuntimeExports.jsx("ellipse", { cx: "25.161", cy: "64.623", fill: "#FF37F0", rx: "2.159", ry: "2.154" }), jsxRuntimeExports.jsx("ellipse", { cx: "36.674", cy: "64.623", fill: "#FF37F0", rx: "2.159", ry: "2.154" }), jsxRuntimeExports.jsx("ellipse", { cx: "42.43", cy: "64.623", fill: "#FF37F0", rx: "2.159", ry: "2.154" }), jsxRuntimeExports.jsx("ellipse", { cx: "48.906", cy: "64.623", fill: "#FF37F0", rx: "2.159", ry: "2.154" })] }), jsxRuntimeExports.jsxs("g", { fillRule: "nonzero", transform: "translate(50 36)", children: [jsxRuntimeExports.jsx("path", { d: "M5.62 30.6a.753.753 0 0 1-.481-.707v-7.915a1.01 1.01 0 0 0-1.007-1.011H2.517A2.524 2.524 0 0 1 0 18.44V2.526A2.524 2.524 0 0 1 2.517 0h56.966A2.524 2.524 0 0 1 62 2.526v15.915a2.524 2.524 0 0 1-2.517 2.526h-43.97c-.282 0-.551.12-.742.328l-8.32 9.11a.748.748 0 0 1-.831.194Z", fill: "#000" }), jsxRuntimeExports.jsx("path", { d: "M5.62 30.6a.753.753 0 0 1-.481-.707v-7.915a1.01 1.01 0 0 0-1.007-1.011H2.517A2.524 2.524 0 0 1 0 18.44V2.526A2.524 2.524 0 0 1 2.517 0h56.966A2.524 2.524 0 0 1 62 2.526v15.915a2.524 2.524 0 0 1-2.517 2.526h-43.97c-.282 0-.551.12-.742.328l-8.32 9.11a.748.748 0 0 1-.831.194Z", fill: "#003BD6" }), jsxRuntimeExports.jsx("path", { d: "M17.416 9.255v2.292h3.505v4.475h2.643v-4.475h1.005v2.566h2.486v-2.566h6.715V9.255z", fill: "#FFF" }), jsxRuntimeExports.jsx("circle", { cx: "39.127", cy: "10.101", fill: "#FFF", r: "5.921" }), jsxRuntimeExports.jsx("circle", { cx: "39.127", cy: "10.101", fill: "#003BD6", r: "3.666" })] })] })] }));
}

function Smartphone(_a) {
    var { height = '100%', id, variant = 'mfa', width = '100%' } = _a, props = __rest(_a, ["height", "id", "variant", "width"]);
    if (variant === 'mfa') {
        return (jsxRuntimeExports.jsx(SmartphoneMfa, Object.assign({ height: height, id: id, width: width }, props)));
    }
    if (variant === 'mfa-key') {
        return (jsxRuntimeExports.jsx(SmartphoneMfaKey, Object.assign({ height: height, id: id, width: width }, props)));
    }
    return null;
}

const spaceSize = {
    large: tokens.kdsSpacing6,
    medium: tokens.kdsSpacing4,
    small: tokens.kdsSpacing2,
    xlarge: tokens.kdsSpacing8,
    xsmall: tokens.kdsSpacing1,
    xxlarge: tokens.kdsSpacing10,
};
/**
 * @deprecated Use <Box display="flex" gap={...} .../>
 */
function Spacer(_a) {
    var { align = 'initial', children, direction = 'vertical', directionType = 'rtl', isFullWidth = false, lastChildHasNoSpacing = false, spacing = 'medium', wrap = 'nowrap' } = _a, props = __rest(_a, ["align", "children", "direction", "directionType", "isFullWidth", "lastChildHasNoSpacing", "spacing", "wrap"]);
    const marginDirection = directionType === 'rtl' ? 'marginRight' : 'marginLeft';
    return (jsxRuntimeExports.jsx(StyledSpacer, Object.assign({ "$align": align, "$direction": direction, "$directionType": directionType, "$isFullWidth": isFullWidth, "$lastChildHasNoSpacing": lastChildHasNoSpacing, "$wrap": wrap }, props, { children: Children.map(children, (child, index) => {
            if (isValidElement(child)) {
                return (jsxRuntimeExports.jsx("div", { style: {
                        [direction === 'vertical' ? 'marginBottom' : marginDirection]: typeof spacing === 'string' ? spaceSize[spacing] : `${spacing}px`,
                    }, children: child }, index));
            }
            return;
        }) })));
}
const StyledSpacer = styled.div `
    display: flex;
    flex-direction: column;

    ${(props) => props.$direction === 'horizontal' &&
    props.$directionType === 'ltr' &&
    css$3 `
            flex-direction: row-reverse;
        `}
    ${(props) => props.$direction === 'horizontal' &&
    props.$directionType === 'rtl' &&
    css$3 `
            flex-direction: row;
        `}

    ${(props) => props.$direction === 'horizontal' &&
    props.$align === 'start' &&
    css$3 `
            justify-content: flex-start;
        `}
    ${(props) => props.$direction === 'horizontal' &&
    props.$align === 'center' &&
    css$3 `
            justify-content: center;
        `}
    ${(props) => props.$direction === 'horizontal' &&
    props.$align === 'end' &&
    css$3 `
            justify-content: flex-end;
        `}

    ${(props) => props.$direction === 'vertical' &&
    props.$align === 'start' &&
    css$3 `
            align-items: flex-start;
        `}
    ${(props) => props.$direction === 'vertical' &&
    props.$align === 'center' &&
    css$3 `
            align-items: center;
        `}
    ${(props) => props.$direction === 'vertical' &&
    props.$align === 'end' &&
    css$3 `
            align-items: flex-end;
        `}

    ${(props) => props.$direction === 'vertical' &&
    props.$align === 'initial' &&
    css$3 `
            align-items: initial;
        `}
    ${(props) => props.$direction === 'horizontal' &&
    props.$align === 'initial' &&
    css$3 `
            justify-content: initial;
        `}

    ${(props) => props.$wrap === 'wrap' &&
    css$3 `
            flex-wrap: wrap;

            & > div {
                margin-bottom: 8px;
                margin-top: 8px;
            }
        `}
    ${(props) => props.$wrap === 'nowrap' &&
    css$3 `
            flex-wrap: nowrap;
        `}

    ${(props) => props.$isFullWidth &&
    css$3 `
            & > div {
                display: block;
                width: 100%;
            }
        `}

    ${(props) => props.$direction === 'vertical' &&
    props.$lastChildHasNoSpacing &&
    css$3 `
            & > div {
                &:last-child {
                    margin-bottom: 0 !important;
                }
            }
        `}

    ${(props) => props.$direction === 'horizontal' &&
    props.$lastChildHasNoSpacing &&
    css$3 `
            & > div {
                &:last-child {
                    margin-right: 0 !important;
                }
            }
        `}
`;

function SplitView({ bannerHeight, children }) {
    return (jsxRuntimeExports.jsx(StyledSplitView, { "$bannerHeight": bannerHeight, children: jsxRuntimeExports.jsx(StyledColumn, { children: children }) }));
}
const StyledSplitView = styled.div `
    display: flex;
    flex-direction: column;
    overflow: auto;

    ${({ $bannerHeight, theme }) => css$3 `
        height: calc(100dvh - ${$bannerHeight !== null && $bannerHeight !== void 0 ? $bannerHeight : 0}px - ${theme.appLayout.header.height});
    `}
`;
const StyledColumn = styled.div `
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    overflow-y: auto;
    background: white;
    border-left: 1px solid var(--kds-color-border-minimal);
`;

function SplitViewTrigger({ icon = 'split-view', isSplitViewOpen, labelTextClose = 'Sluit splitscherm weergave', labelTextOpen = 'Splitscherm weergave', onClick, }) {
    return (jsxRuntimeExports.jsx(Tooltip, { content: isSplitViewOpen ? labelTextClose : labelTextOpen, children: jsxRuntimeExports.jsx(IconButton, { icon: icon, iconColor: isSplitViewOpen ? 'primary' : 'minimal', labelText: isSplitViewOpen ? labelTextClose : labelTextOpen, onClick: onClick, sx: {
                '@media (hover: hover)': {
                    '&:hover:not(:disabled)': {
                        backgroundColor: 'white',
                    },
                },
                backgroundColor: 'white',
                boxShadow: (theme) => theme.shadows.base,
            }, variant: "ghost" }) }));
}

function Step(_a) {
    var { isSensitiveData = false, label, onClick, status } = _a, props = __rest(_a, ["isSensitiveData", "label", "onClick", "status"]);
    const isOnClickEnabled = status === 'completed';
    return (jsxRuntimeExports.jsxs(StyledStep, Object.assign({ "$hasClickHandler": isOnClickEnabled, "$status": status, onClick: isOnClickEnabled ? onClick : undefined }, props, { children: [jsxRuntimeExports.jsx(IconBackground, { "$status": status, children: status === 'completed' && (jsxRuntimeExports.jsx(Icon, { color: "inverse", icon: "check" })) }), jsxRuntimeExports.jsx(StyledLabel, { "$status": status, "data-dd-privacy": isSensitiveData ? 'mask' : 'allow', children: label })] })));
}
const StyledStep = styled.div `
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
    z-index: 0;
    cursor: ${(props) => (props.$hasClickHandler && props.$status === 'completed' ? 'pointer' : 'default')};

    &::before {
        position: absolute;
        top: 10px;
        left: 0;
        display: block;
        width: 50%;
        height: 1px;
        z-index: -1;
        content: '';

        ${(props) => props.$status &&
    props.$status === 'completed' &&
    css$3 `
                background-color: var(--kds-color-background-selected);
            `}
        ${(props) => props.$status &&
    props.$status === 'active' &&
    css$3 `
                background-color: var(--kds-color-background-selected);
            `}
        ${(props) => props.$status &&
    props.$status === 'disabled' &&
    css$3 `
                background-color: var(--kds-color-border-disabled);
            `}
    }

    &::after {
        position: absolute;
        top: 10px;
        right: 0;
        display: block;
        width: 50%;
        height: 1px;
        z-index: -1;
        content: '';

        ${(props) => props.$status &&
    props.$status === 'completed' &&
    css$3 `
                background-color: var(--kds-color-background-selected);
            `}
        ${(props) => props.$status &&
    props.$status === 'active' &&
    css$3 `
                background-color: var(--kds-color-border-disabled);
            `}
        ${(props) => props.$status &&
    props.$status === 'disabled' &&
    css$3 `
                background-color: var(--kds-color-border-disabled);
            `}
    }
    ${sx}
`;
const StyledLabel = styled.div `
    font-size: 12px;
    font-weight: 400;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    margin-top: 12px;

    ${(props) => props.$status &&
    props.$status === 'completed' &&
    css$3 `
            color: var(--kds-color-foreground-minimal);
        `}
    ${(props) => props.$status &&
    props.$status === 'active' &&
    css$3 `
            color: var(--kds-color-foreground-selected);
        `}
    ${(props) => props.$status &&
    props.$status === 'disabled' &&
    css$3 `
            color: var(--kds-color-foreground-disabled);
        `}

    ${(props) => props.$status &&
    props.$status !== 'active' &&
    css$3 `
            display: none;

            ${props.theme.mediaQueries.small} {
                display: block;
            }
        `}
`;
const IconBackground = styled.div `
    border-radius: ${(props) => props.theme.radii.full};
    height: 20px;
    width: 20px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-left: 0;

    ${(props) => props.$status &&
    props.$status === 'completed' &&
    css$3 `
            background-color: var(--kds-color-background-selected);
        `}
    ${(props) => props.$status &&
    props.$status === 'active' &&
    css$3 `
            background-color: white;
            border: 1px solid var(--kds-color-background-selected);

            &::after {
                content: '';
                width: 10px;
                height: 10px;
                background-color: var(--kds-color-background-selected);
                border-radius: ${props.theme.radii.full};
            }
        `}
    ${(props) => props.$status &&
    props.$status === 'disabled' &&
    css$3 `
            background-color: var(--kds-color-border-disabled);
        `}
`;

function Steps(_a) {
    var { activeStep = 0, children } = _a, props = __rest(_a, ["activeStep", "children"]);
    return (jsxRuntimeExports.jsx(StyledStepsContainer, Object.assign({}, props, { children: Children.map(children, (child, index) => {
            if (child.type === Step) {
                let status;
                if (activeStep === index) {
                    status = 'active';
                }
                else if (activeStep > index) {
                    status = 'completed';
                }
                else if (activeStep < index) {
                    status = 'disabled';
                }
                return cloneElement(child, {
                    status,
                });
            }
            return child;
        }) })));
}
const StyledStepsContainer = styled.div `
    display: flex;
    width: 100%;

    ${sx}
`;
Steps.Step = Step;

const checkmarkSizes = {
    large: 160,
    medium: 120,
    small: 72,
    xlarge: 200,
};
const confettiParts = [
    {
        color: tokens.kdsColorYellow300,
        d: 'M39.8,35.6 c-2-3.7-9.8-15.8-21.5-16.9c-13-1.1-12.3,7.9-10.7,10.7c3.4,6.1,15.3,4.9,14.2-7.6c-0.8-9.4-7.4-9.9-7.1-10.5',
        delay: 1.4,
        duration: 3,
    },
    {
        color: tokens.kdsColorOrange300,
        d: 'M54.2,42.3 c0.7-4.2,4.1-18.2,14.8-23c11.9-5.3,14.2,3.5,13.6,6.6c-1.2,6.9-12.8,9.6-15.9-2.5c-2.3-9.1,3.8-11.8,3.3-12.3',
        delay: 1.3,
        duration: 2.5,
    },
    {
        color: tokens.kdsColorPurple300,
        d: 'M43.8,56.1 c-3.3,2.7-15,11.1-26.3,7.6c-12.5-3.8-8.4-11.9-6-13.9c5.5-4.4,16,1.1,10.4,12.3c-4.2,8.4-10.6,6.4-10.5,7.1',
        delay: 1.6,
        duration: 2.8,
    },
    {
        color: tokens.kdsColorBlue300,
        d: 'M55.6,53.2 c4.2,0.3,18.5,2.4,24.2,12.7c6.4,11.4-2.1,14.4-5.3,14.2c-7-0.6-10.7-11.9,1.1-16.1c8.8-3.2,12.1,2.7,12.5,2.1',
        delay: 1.5,
        duration: 2,
    },
    {
        color: tokens.kdsColorPurple300,
        d: 'M46,46.7 c2.9-3.8,6.9-32.4-8.2-40.3',
        delay: 1.6,
        duration: 3,
    },
    {
        color: tokens.kdsColorBlue300,
        d: 'M55.8,47.4 c4.2,2.3,33,2.3,38.8-13.7',
        delay: 1.2,
        duration: 4,
    },
    {
        color: tokens.kdsColorYellow300,
        d: 'M45,46.4 C41.7,42.9,14.4,33.7,3.8,47',
        delay: 1.3,
        duration: 4,
    },
    {
        color: tokens.kdsColorOrange300,
        d: 'M51,57.8 C49.9,62.5,57,90.4,73.9,92',
        delay: 1.3,
        duration: 4,
    },
    {
        color: tokens.kdsColorBlue300,
        d: 'M49.3,54.3 c1.2,4.6-5.9,32.6-22.9,34.2',
        delay: 1.5,
        duration: 4,
    },
];
function SuccessAnimation(_a) {
    var { backgroundcolor = tokens.kdsColorWhite, size = 'medium' } = _a, props = __rest(_a, ["backgroundcolor", "size"]);
    return (jsxRuntimeExports.jsxs(Checkmark, Object.assign({ size: size, viewBox: "0 0 100 100", xmlns: "http://www.w3.org.2000.svg" }, props, { children: [jsxRuntimeExports.jsx(CheckmarkFill, { cx: "50", cy: "50", r: "30" }), jsxRuntimeExports.jsx(CheckmarkBackgound, { backgroundcolor: backgroundcolor, cx: "50", cy: "50", r: "30" }), jsxRuntimeExports.jsx(CheckmarkOutline, { cx: "50", cy: "50", r: "30" }), jsxRuntimeExports.jsx(CheckmarkCheck, { points: "31.5,50 44.3,62.8 67.1,40.1" }), confettiParts.map((part, i) => (jsxRuntimeExports.jsx(ConfettiStroke, { color: part.color, d: part.d, delay: part.delay, duration: part.duration }, i)))] })));
}
const fill = keyframes `
    100% {
      transform: scale(0);
    }
  `;
const scale = keyframes `
    0%,
    100% {
      transform: none;
    }
    50% {
      transform: scale3d(1.2, 1.2, 1);
    }
  `;
const stroke = keyframes `
    100% {
      stroke-dashoffset: 0;
    }
  `;
const confetti = keyframes `
    100% {
      stroke-dashoffset: 20;
    }
  `;
const Checkmark = styled.svg `
    width: ${(props) => props.size && checkmarkSizes[props.size]}px;
    height: ${(props) => props.size && checkmarkSizes[props.size]}px;
    display: block;

    ${sx}
`;
const CheckmarkBackgound = styled.circle `
    transform-origin: 50% 50%;
    transform: scale(1.05);
    fill: ${(props) => props.backgroundcolor};
    animation: ${fill} 0.3s ease-in-out 0.6s forwards;
`;
const CheckmarkFill = styled.circle `
    transform-origin: 50% 50%;
    fill: ${tokens.kdsColorGreen500};
    animation: ${scale} 0.3s ease-in-out 1.2s both;
`;
const CheckmarkOutline = styled.circle `
    transform-origin: 50% 50%;
    stroke-dasharray: 200;
    stroke-dashoffset: 200;
    stroke-width: 5;
    stroke-miterlimit: 10;
    stroke: ${tokens.kdsColorGreen500};
    fill: none;
    animation: ${stroke} 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
`;
const CheckmarkCheck = styled.polyline `
    fill: none;
    transform-origin: 50% 50%;
    stroke-dasharray: 60;
    stroke-dashoffset: 60;
    stroke-linecap: round;
    stroke-width: 8;
    stroke: ${tokens.kdsColorWhite};
    stroke-miterlimit: 10;
    animation: ${stroke} 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.9s forwards;
`;
const ConfettiStroke = styled.path `
    fill: none;
    stroke: ${(props) => props.color};
    stroke-width: 6;
    stroke-linecap: round;
    stroke-miterlimit: 10;
    stroke-dasharray: 8 100;
    stroke-dashoffset: 120;
    animation: ${confetti} ${(props) => props.duration}s cubic-bezier(0.15, 0.87, 0.19, 0.99) ${(props) => props.delay}s
        forwards;
`;

function TabBarButton(_a) {
    var { children, isSelected } = _a, props = __rest(_a, ["children", "isSelected"]);
    return (jsxRuntimeExports.jsx(StyledTab, Object.assign({ "$isSelected": isSelected, type: "button" }, props, { children: children })));
}
const StyledTab = styled.button `
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    position: relative;
    font-weight: 400;
    font-size: 16px;
    padding: 16px 0;
    background-color: transparent;
    border: none;
    cursor: pointer;
    border-bottom: 2px solid transparent;
    color: ${(props) => props.theme.colors.neutral700};
    transition: border-color 125ms ease-in-out;

    &:not(:last-child) {
        margin-right: 24px;
    }

    &:hover {
        ${(props) => !props.$isSelected &&
    css$3 `
                border-color: ${props.theme.colors.neutral300};
            `}
    }

    &:focus {
        outline: none;
    }

    &:focus-visible {
        outline: 2px solid var(--kds-color-border-focused);
        outline-offset: -2px;
    }

    ${(props) => props.$isSelected &&
    css$3 `
            border-color: ${props.theme.colors.magenta700};
            cursor: default;
            color: ${props.theme.colors.magenta700};
        `};
    ${sx}
`;

function TabBar(_a) {
    var { children, isSensitiveData = false, sx: sxProp } = _a, props = __rest(_a, ["children", "isSensitiveData", "sx"]);
    const tabBar = useRef(null);
    const [hasLeftOverflow, setHasLeftOverflow] = useState(false);
    const [hasRightOverflow, setHasRightOverflow] = useState(false);
    const OVERFLOW_BUTTON_OFFSET = 30;
    const handleWindowResize = handleScroll;
    const debouncedHandleWindowResize = debounce(handleWindowResize, 200);
    useEffect(() => {
        handleWindowResize();
        window.addEventListener('resize', debouncedHandleWindowResize);
        return () => window.removeEventListener('resize', debouncedHandleWindowResize);
    });
    function handleScroll() {
        if (!tabBar.current) {
            return;
        }
        setHasLeftOverflow(tabBar.current.scrollWidth > tabBar.current.clientWidth && tabBar.current.scrollLeft !== 0);
        setHasRightOverflow(tabBar.current.scrollWidth > tabBar.current.clientWidth &&
            tabBar.current.clientWidth + tabBar.current.scrollLeft !== tabBar.current.scrollWidth);
    }
    function handleOverflowNavClick({ direction }) {
        if (!tabBar.current) {
            return;
        }
        if (direction === 1 && !tabBar.current.scrollLeft) {
            tabBar.current.scrollLeft += OVERFLOW_BUTTON_OFFSET;
        }
        tabBar.current.scrollLeft += direction * tabBar.current.clientWidth * 0.75;
    }
    return (jsxRuntimeExports.jsxs(TabBarContainer, { "data-dd-privacy": isSensitiveData ? 'mask' : 'allow', sx: sxProp, children: [hasLeftOverflow && (jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: jsxRuntimeExports.jsx(IconButton, { "aria-hidden": "true", icon: "caret-left", labelText: "scroll left", onClick: () => handleOverflowNavClick({ direction: -1 }), size: "small", style: { marginRight: '0px' }, tabIndex: -1, variant: "filled" }) })), jsxRuntimeExports.jsx(StyledTabBar, Object.assign({ onScroll: handleScroll, ref: tabBar }, props, { children: children })), hasRightOverflow && (jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: jsxRuntimeExports.jsx(IconButton, { "aria-hidden": "true", icon: "caret-right", labelText: "scroll right", onClick: () => handleOverflowNavClick({ direction: 1 }), size: "small", style: { marginLeft: '0px' }, tabIndex: -1, variant: "filled" }) }))] }));
}
const TabBarContainer = styled.div `
    display: flex;
    align-items: center;
    min-height: 2.5rem;
    height: auto;
    width: 100%;
    min-width: 0;

    ${sx}
`;
const StyledTabBar = styled.div `
    display: flex;
    flex-direction: row;
    width: 100%;
    max-width: 100%;
    scrollbar-width: none;
    align-items: center;
    border-bottom: 1px solid var(--kds-color-border-subtle);
    margin: 0;
    padding: 0;
    overflow: auto hidden;
    scroll-behavior: smooth;

    &::-webkit-scrollbar {
        display: none;
    }
`;
TabBar.Button = TabBarButton;

const TableContext = createContext({});

function Table(_a) {
    var { children, spacing = 'none' } = _a, props = __rest(_a, ["children", "spacing"]);
    return (jsxRuntimeExports.jsx(TableContext.Provider, { value: { spacing }, children: jsxRuntimeExports.jsx(StyledTable, Object.assign({ "$spacing": spacing }, props, { children: children })) }));
}
const StyledTable = styled.table `
    width: 100%;
    ${(props) => props.$spacing === 'none' &&
    css$3 `
            border-collapse: collapse;
            border-spacing: 0;
        `};
    ${(props) => props.$spacing === 'medium' &&
    css$3 `
            border-spacing: 0 ${props.theme.space[2]};
            border-collapse: separate;
        `};
    ${sx}
`;

function TableBody(_a) {
    var { children } = _a, props = __rest(_a, ["children"]);
    return jsxRuntimeExports.jsx(StyledTableBody, Object.assign({}, props, { children: children }));
}
const StyledTableBody = styled.tbody `
    ${sx}
`;

function TableCell(_a) {
    var { align = 'left', children, color = 'subtle', ellipsis = false, fontWeight = 'normal', isSelected = false } = _a, props = __rest(_a, ["align", "children", "color", "ellipsis", "fontWeight", "isSelected"]);
    const { spacing } = useContext(TableContext);
    return (jsxRuntimeExports.jsx(StyledTableCell, Object.assign({ "$align": align, "$color": color, "$ellipsis": ellipsis, "$fontWeight": fontWeight, "$isSelected": isSelected, "$spacing": spacing }, props, { children: children })));
}
const StyledTableCell = styled.td `
    --is-selected-offset: ${(props) => (props.$spacing === 'medium' ? '-1px' : '0')};
    --is-selected-border-radius: ${(props) => (props.$spacing === 'medium' ? 'var(--kds-border-radius-base)' : '0')};

    border-block-start: 1px solid var(--kds-color-border-minimal);
    padding-inline: var(--kds-spacing-3);
    padding-block: var(--kds-spacing-4);
    font-size: var(--kds-font-size-sm);
    line-height: var(--kds-line-height-5);
    background-color: var(--kds-color-background-default);
    vertical-align: middle;
    text-align: ${(props) => props.$align};
    color: ${(props) => textColor[props.$color]};
    font-weight: ${(props) => `var(--kds-font-weight-${props.$fontWeight})`};
    position: relative;

    &:first-of-type {
        padding-inline-start: var(--kds-spacing-6);

        ${(props) => props.theme.mediaQueries.large} {
            padding-inline-start: var(--kds-spacing-8);
        }
    }

    &:last-of-type {
        padding-inline-end: var(--kds-spacing-6);

        ${(props) => props.theme.mediaQueries.large} {
            padding-inline-end: var(--kds-spacing-8);
        }
    }

    ${(props) => props.$ellipsis &&
    css$3 `
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            word-break: keep-all;
            max-width: 200px;
        `};

    ${(props) => props.$isSelected &&
    css$3 `
            &::before {
                background: var(--kds-color-border-selected);
                border-top-left-radius: var(--is-selected-border-radius);
                border-bottom-left-radius: var(--is-selected-border-radius);
                width: var(--kds-spacing-1);
                position: absolute;
                left: var(--is-selected-offset);
                content: '';
                top: var(--is-selected-offset);
                bottom: var(--is-selected-offset);
            }
        `}

    ${(props) => props.$spacing === 'medium' &&
    css$3 `
            padding-inline: var(--kds-spacing-3);
            padding-block: var(--kds-spacing-5);
            border-block-start: 1px solid var(--kds-color-border-minimal);
            border-block-end: 1px solid var(--kds-color-border-minimal);

            &:first-of-type {
                border-radius: var(--kds-border-radius-base) 0 0 var(--kds-border-radius-base);
                border-inline-start: 1px solid var(--kds-color-border-minimal);
            }

            &:last-of-type {
                border-radius: 0 var(--kds-border-radius-base) var(--kds-border-radius-base) 0;
                border-inline-end: 1px solid var(--kds-color-border-minimal);
            }
        `};
    ${sx}
`;

function TableCellExpanded(_a) {
    var { align = 'left', children, color = 'subtle', ellipsis = false, fontWeight = 'normal', isSelected = false } = _a, props = __rest(_a, ["align", "children", "color", "ellipsis", "fontWeight", "isSelected"]);
    const { spacing } = useContext(TableContext);
    return (jsxRuntimeExports.jsx(StyledTableCell, Object.assign({ "$align": align, "$color": color, "$ellipsis": ellipsis, "$fontWeight": fontWeight, "$isSelected": isSelected, "$spacing": spacing, sx: { border: 'none' } }, props, { children: children })));
}

function TableCellExpandRow(_a) {
    var { isExpandable, isExpanded = false, onExpand } = _a, props = __rest(_a, ["isExpandable", "isExpanded", "onExpand"]);
    if (!onExpand) {
        return jsxRuntimeExports.jsx(TableCell, {});
    }
    return (jsxRuntimeExports.jsx(StyledTableCellExpandRow, Object.assign({}, props, { children: isExpandable ? (jsxRuntimeExports.jsx(IconButton, { icon: isExpanded ? 'caret-up' : 'caret-down', labelText: isExpanded ? 'close' : 'open', onClick: onExpand, size: "small", variant: "ghost" })) : null })));
}
const StyledTableCellExpandRow = styled(TableCell) `
    padding: 0 var(--kds-spacing-3);
    width: 56px;
    min-width: 56px;
`;

function TableCellSelectRow(_a) {
    var { isSelected, onSelect } = _a, props = __rest(_a, ["isSelected", "onSelect"]);
    return (jsxRuntimeExports.jsx(StyledTableCellSelectRow, Object.assign({ isSelected: isSelected }, props, { children: jsxRuntimeExports.jsx(Checkbox, { "aria-label": "Select row", checked: isSelected, onChange: onSelect }) })));
}
const StyledTableCellSelectRow = styled(TableCell) `
    width: 56px;
    min-width: 56px;
    ${sx}
`;

function TableContainer(_a) {
    var { children } = _a, props = __rest(_a, ["children"]);
    return jsxRuntimeExports.jsx(StyledTableContainer, Object.assign({}, props, { children: children }));
}
const StyledTableContainer = styled.div `
    width: 100%;
    overflow-x: auto;

    ${sx}
`;

function TableHead(_a) {
    var { children } = _a, props = __rest(_a, ["children"]);
    return jsxRuntimeExports.jsx(StyledTableHead, Object.assign({}, props, { children: children }));
}
const StyledTableHead = styled.thead `
    ${sx}
`;

function TableHeader(_a) {
    var { align = 'left', children, isSensitiveData = false, isSortable = false, isSortHeader, onClick, scope = 'col', sortDirection } = _a, props = __rest(_a, ["align", "children", "isSensitiveData", "isSortable", "isSortHeader", "onClick", "scope", "sortDirection"]);
    const { spacing } = useContext(TableContext);
    if (!isSortable) {
        return (jsxRuntimeExports.jsx(StyledTableHeader, Object.assign({ "$align": align, "$spacing": spacing, scope: scope }, props, { children: jsxRuntimeExports.jsx(TableHeaderLabel, { "data-dd-privacy": isSensitiveData ? 'mask' : 'allow', children: children }) })));
    }
    return (jsxRuntimeExports.jsx(StyledTableHeader, Object.assign({ "$align": align, "$spacing": spacing, scope: scope }, props, { children: jsxRuntimeExports.jsxs(TableHeaderButton, { "$isSortHeader": !!isSortHeader, "$spacing": spacing, "data-dd-privacy": isSensitiveData ? 'mask' : 'allow', onClick: onClick, type: "button", children: [children, jsxRuntimeExports.jsx(StyledIcon, { "$isSortHeader": !!isSortHeader, "$sortDirection": sortDirection !== null && sortDirection !== void 0 ? sortDirection : 'ASC', color: isSortHeader ? 'primary' : 'minimal', icon: "arrow-up", size: 14 })] }) })));
}
const StyledIcon = styled(Icon) `
    margin-left: 4px;
    transition:
        transform 250ms cubic-bezier(0.5, 0, 0.1, 1),
        opacity 200ms cubic-bezier(0.4, 0, 0.2, 1);
    transform: ${(props) => (props.$sortDirection === 'ASC' ? 'rotate(0deg)' : 'rotate(180deg)')};
    opacity: ${(props) => (props.$isSortHeader ? 1 : 0)};
`;
const TableHeaderButton = styled.button `
    border: 0;
    cursor: pointer;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    font-weight: var(--kds-font-weight-medium);
    font-size: var(--kds-font-size-md);
    line-height: var(--kds-line-height-6);
    min-height: 100%;
    background-color: var(--kds-color-background-subtle);
    color: var(--kds-color-foreground-subtle);
    transition:
        background-color 70ms cubic-bezier(0, 0, 0.38, 0.9),
        outline 70ms cubic-bezier(0, 0, 0.38, 0.9);
    padding-inline: var(--kds-spacing-3);
    padding-block: var(--kds-spacing-4);

    &:hover {
        background-color: ${(props) => props.theme.colors.neutral200};

        ${StyledIcon} {
            opacity: 1;
        }
    }

    &:focus {
        outline: none;
    }

    &:focus-visible {
        outline: 2px solid var(--kds-color-border-focused);
        outline-offset: -2px;
    }
`;
const TableHeaderLabel = styled.div `
    padding-inline: var(--kds-spacing-3);
    padding-block: var(--kds-spacing-4);
`;
const StyledTableHeader = styled.th `
    white-space: nowrap;
    text-align: ${(props) => props.$align};
    color: var(--kds-color-foreground-subtle);
    font-weight: var(--kds-font-weight-medium);
    font-size: var(--kds-font-size-md);
    line-height: var(--kds-line-height-6);
    background-color: var(--kds-color-background-subtle);
    padding: 0;

    &:first-of-type {
        ${TableHeaderLabel} {
            padding-inline-start: var(--kds-spacing-6);

            ${(props) => props.theme.mediaQueries.large} {
                padding-inline-start: var(--kds-spacing-8);
            }
        }
        ${TableHeaderButton} {
            padding-inline-start: var(--kds-spacing-6);

            ${(props) => props.theme.mediaQueries.large} {
                padding-inline-start: var(--kds-spacing-8);
            }
        }
    }

    &:last-of-type {
        ${TableHeaderLabel} {
            padding-inline-end: var(--kds-spacing-6);

            ${(props) => props.theme.mediaQueries.large} {
                padding-inline-end: var(--kds-spacing-8);
            }
        }
        ${TableHeaderButton} {
            padding-inline-end: var(--kds-spacing-6);

            ${(props) => props.theme.mediaQueries.large} {
                padding-inline-end: var(--kds-spacing-8);
            }
        }
    }

    ${(props) => props.$spacing === 'medium' &&
    css$3 `
            &:first-of-type {
                border-radius: var(--kds-border-radius-base) 0 0 var(--kds-border-radius-base);
                ${TableHeaderButton} {
                    border-radius: var(--kds-border-radius-base) 0 0 var(--kds-border-radius-base);
                }
            }

            &:last-of-type {
                border-radius: 0 var(--kds-border-radius-base) var(--kds-border-radius-base) 0;
                ${TableHeaderButton} {
                    border-radius: 0 var(--kds-border-radius-base) var(--kds-border-radius-base) 0;
                }
            }
        `}

    ${(props) => props.$align &&
    css$3 `
            ${TableHeaderButton} {
                justify-content: ${props.$align};
            }
        `}


    ${sx}
`;

function TableHeaderSelectAll(_a) {
    var { ariaLabel = 'Select all rows in the table', checked, indeterminate, onSelect, scope = 'col' } = _a, props = __rest(_a, ["ariaLabel", "checked", "indeterminate", "onSelect", "scope"]);
    const { spacing } = useContext(TableContext);
    return (jsxRuntimeExports.jsx(StyledTableHeaderSelectAll, Object.assign({ "$spacing": spacing, "aria-label": ariaLabel, scope: scope }, props, { children: jsxRuntimeExports.jsx(Checkbox, { "aria-label": "Select all", checked: checked, indeterminate: indeterminate, onChange: onSelect }) })));
}
const StyledTableHeaderSelectAll = styled(TableHeader) `
    width: 56px;
    min-width: 56px;
    ${sx}
`;

function TableRow(_a) {
    var { children, onClick, sx: sxProp } = _a, props = __rest(_a, ["children", "onClick", "sx"]);
    const { spacing } = useContext(TableContext);
    return (jsxRuntimeExports.jsx(StyledTableRow, Object.assign({ "$spacing": spacing, onClick: onClick, sx: sxProp }, props, { children: children })));
}
const StyledTableRow = styled.tr `
    ${(props) => props.onClick &&
    css$3 `
            cursor: pointer;
        `};

    ${(props) => props.$spacing === 'none' &&
    css$3 `
            &:first-of-type ${StyledTableCell} {
                border-block-start: 0;
            }

            &:hover ${StyledTableCell} {
                background-color: var(--kds-color-background-minimal);
            }
        `}

    ${(props) => props.$spacing === 'medium' &&
    css$3 `
            &:hover ${StyledTableCell} {
                background-color: var(--kds-color-background-default);
                border-color: ${props.onClick && 'var(--kds-color-border-medium)'};
            }
        `}

    ${sx}
`;

function TableRowExpanded(_a) {
    var { children, isExpanded } = _a, props = __rest(_a, ["children", "isExpanded"]);
    return (jsxRuntimeExports.jsx(StyledTableRowExpanded, Object.assign({ "$isExpanded": isExpanded }, props, { children: children })));
}
const StyledTableRowExpanded = styled(TableRow) `
    display: ${(props) => (props.$isExpanded ? 'table-row' : 'none')};

    ${sx}
`;

function TableHeaderRowGroup(_a) {
    var { children, isSensitiveData = false, scope = 'colgroup' } = _a, props = __rest(_a, ["children", "isSensitiveData", "scope"]);
    const { spacing } = useContext(TableContext);
    return (jsxRuntimeExports.jsx(StyledTableHeaderRowGroup, Object.assign({ "$spacing": spacing, scope: scope }, props, { children: jsxRuntimeExports.jsx(TableHeaderRowGroupLabel, { "data-dd-privacy": isSensitiveData ? 'mask' : 'allow', children: children }) })));
}
const StyledTableHeaderRowGroup = styled.th `
    white-space: nowrap;
    text-align: left;
    color: var(--kds-color-foreground-subtle);
    font-weight: var(--kds-font-weight-medium);
    font-size: var(--kds-font-size-sm);
    line-height: var(--kds-line-height-5);
    background-color: var(--kds-color-transparent);
    padding: 0;
    border-block-start: 1px solid var(--kds-color-border-minimal);

    ${sx}
`;
const TableHeaderRowGroupLabel = styled.div `
    padding-inline: var(--kds-spacing-3);
    padding-block: var(--kds-spacing-4);

    &:first-of-type {
        padding-inline-start: var(--kds-spacing-6);

        ${(props) => props.theme.mediaQueries.large} {
            padding-inline-start: var(--kds-spacing-8);
        }
    }

    &:last-of-type {
        padding-inline-end: var(--kds-spacing-6);

        ${(props) => props.theme.mediaQueries.large} {
            padding-inline-end: var(--kds-spacing-8);
        }
    }
`;

function TimelineItem(_a) {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (jsxRuntimeExports.jsxs(StyledTimelineItem, Object.assign({}, props, { children: [jsxRuntimeExports.jsx(StyledTimelineItemMarker, {}), jsxRuntimeExports.jsx(StyledTimelineItemContent, { children: children })] })));
}
const StyledTimelineItem = styled.li `
    display: flex;
    padding-bottom: ${(props) => props.theme.space[4]};
    position: relative;
    font-size: ${(props) => props.theme.fontSizes.sm};
    line-height: ${(props) => props.theme.lineHeights[5]};
    font-weight: ${(props) => props.theme.fontWeights.normal};
    color: ${(props) => props.theme.colors.neutral900};

    &::before {
        content: '';
        position: absolute;
        left: 12px;
        bottom: 4px;
        top: 28px;
        border-left: 1px dashed ${(props) => props.theme.colors.neutral500};
    }

    &:last-child {
        padding-bottom: 0;

        &::before {
            display: none;
        }
    }

    ${sx}
`;
const StyledTimelineItemMarker = styled.span `
    display: block;
    border: 2px solid ${(props) => props.theme.colors.magenta700};
    border-radius: ${(props) => props.theme.radii.full};
    flex: 0 0 ${(props) => props.theme.space[6]};
    height: ${(props) => props.theme.space[6]};
    margin-right: ${(props) => props.theme.space[4]};
    position: relative;
    background-color: white;

    &::after {
        content: '';
        position: absolute;
        inset: 0;
        width: 10px;
        height: 10px;
        margin: auto;
        background-color: ${(props) => props.theme.colors.magenta700};
        border-radius: ${(props) => props.theme.radii.full};
    }
`;
const StyledTimelineItemContent = styled.div ``;

function TimelineItemHeading(_a) {
    var { children, color = 'subtle', fontWeight = 'bold', size = 'sm' } = _a, props = __rest(_a, ["children", "color", "fontWeight", "size"]);
    return (jsxRuntimeExports.jsx(Text, Object.assign({ color: color, fontWeight: fontWeight, mb: 1, size: size }, props, { children: children })));
}

function Timeline(_a) {
    var { children, isSensitiveData = false } = _a, props = __rest(_a, ["children", "isSensitiveData"]);
    return (jsxRuntimeExports.jsx(StyledTimeline, Object.assign({ "data-dd-privacy": isSensitiveData ? 'mask' : 'allow' }, props, { children: children })));
}
const StyledTimeline = styled.ul `
    margin: 0;
    padding: 0;
    max-width: 60ch;

    ${sx}
`;
Timeline.Item = TimelineItem;
Timeline.ItemHeading = TimelineItemHeading;

function EmptyState() {
    return (jsxRuntimeExports.jsxs(Box, { display: "flex", flexDirection: "column", justifyContent: "center", paddingBottom: 7, paddingX: 4, children: [jsxRuntimeExports.jsx(StyledImage, { alt: "logo", src: "/assets/icon-svg/icon-empty-folder.svg" }), jsxRuntimeExports.jsx(Text, { size: "sm", textAlign: "center", children: "Je hebt op dit moment geen openstaande taken of acties" })] }));
}
function TodoList({ children, isRenderedInSplitView = false }) {
    return jsxRuntimeExports.jsx(StyledTodoList, { "$isRenderedInSplitView": isRenderedInSplitView, children: children || jsxRuntimeExports.jsx(EmptyState, {}) });
}
const StyledTodoList = styled.div `
    ${({ $isRenderedInSplitView, theme }) => css$3 `
        min-width: 368px;
        padding: ${$isRenderedInSplitView ? 0 : theme.space[2]};
        margin-bottom: ${theme.space[2]};
        box-shadow: ${$isRenderedInSplitView ? theme.shadows.none : theme.shadows.base};
        background-color: ${theme.colors.white};
        border-radius: ${theme.radii.base};
        overflow-y: auto;
        scrollbar-width: thin;
    `}
`;
const StyledImage = styled.img `
    ${({ theme }) => css$3 `
        align-self: center;
        width: ${theme.space[20]};
        height: ${theme.space[20]};
        margin-bottom: ${theme.space[6]};
        margin-top: ${theme.space[4]};
    `}
`;

function TodoListItemButton({ color, icon, variant }) {
    const theme = useTheme();
    return (jsxRuntimeExports.jsx(StyledButton, { "$color": color, "$variant": variant, children: jsxRuntimeExports.jsx(Icon, { color: variant === 'outline' ? theme.todoList.iconColor[color] : 'inverse', icon: icon }) }));
}
const StyledButton = styled.button `
    ${({ $color, $variant, theme }) => css$3 `
        width: ${theme.space[10]};
        height: ${theme.space[10]};
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: ${$variant === 'solid' ? theme.todoList.color[$color] : theme.colors.white};
        border: solid 1px ${theme.todoList.color[$color]};
        border-radius: ${theme.radii.md};
        pointer-events: none;

        &:focus {
            outline: none;
        }

        &:focus-visible {
            outline: 2px solid var(--kds-color-border-focused);
            outline-offset: 2px;
        }
    `}
`;

function TodoListItem(_a) {
    var { badge, buttonVariant, color, disabledMessage, icon, isDisabled, onClick, subtitle, title } = _a, props = __rest(_a, ["badge", "buttonVariant", "color", "disabledMessage", "icon", "isDisabled", "onClick", "subtitle", "title"]);
    const computedColor = isDisabled ? 'neutral' : color;
    return (jsxRuntimeExports.jsx(StyledTodoListItem, Object.assign({ "$barColor": onClick ? computedColor : undefined, onClick: isDisabled ? undefined : onClick }, props, { children: jsxRuntimeExports.jsxs(StyledTodoListContent, { children: [jsxRuntimeExports.jsxs(StyledTodoListContentWrapper, { children: [jsxRuntimeExports.jsxs(Box, { children: [jsxRuntimeExports.jsx(Text, { fontWeight: "medium", size: "md", children: title }), subtitle && jsxRuntimeExports.jsx(Text, { size: "sm", children: subtitle })] }), badge && (jsxRuntimeExports.jsx("div", { children: jsxRuntimeExports.jsx(Badge, { text: badge }) }))] }), onClick && (jsxRuntimeExports.jsxs(StyledRightContentWrapper, { children: [isDisabled && disabledMessage && (jsxRuntimeExports.jsx(Tooltip, { content: disabledMessage, children: jsxRuntimeExports.jsx(Icon, { color: "disabled", icon: "information" }) })), !isDisabled && (jsxRuntimeExports.jsx(TodoListItemButton, { color: color, icon: icon, variant: buttonVariant }))] }))] }) })));
}
const StyledTodoListItem = styled.div `
    background-color: var(--kds-color-background-default);
    border: 1px solid var(--kds-color-border-subtle);
    border-radius: var(--kds-border-radius-base);
    margin-bottom: ${({ theme }) => theme.space[2]};
    container: todo-list-item / inline-size;
    position: relative;

    ${({ $barColor, theme }) => $barColor &&
    css$3 `
            &::before {
                background: ${theme.todoList.color[$barColor]};
                border-top-left-radius: var(--kds-border-radius-base);
                border-bottom-left-radius: var(--kds-border-radius-base);
                width: 4px;
                position: absolute;
                left: -1px;
                content: '';
                top: -1px;
                bottom: -1px;
            }
        `}

    ${({ onClick }) => !!onClick &&
    css$3 `
            &:hover {
                background-color: ${({ theme }) => theme.colors.neutral50};
                cursor: pointer;
            }
        `}
`;
const StyledTodoListContent = styled.div `
    align-items: center;
    display: flex;
    justify-content: space-between;
    padding-block: var(--kds-spacing-3);
    padding-inline: var(--kds-spacing-4);
`;
const StyledTodoListContentWrapper = styled.div `
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
    row-gap: ${({ theme }) => theme.space[2]};

    @container todo-list-item (width < ${({ theme }) => theme.space[96]}) {
        flex-direction: column;
        align-items: flex-start;
    }
`;
const StyledRightContentWrapper = styled.div `
    display: flex;
    width: 40px;
    flex-shrink: 0;
    justify-content: center;
    margin-left: ${({ theme }) => theme.space[3]};

    @container todo-list-item (width >= ${({ theme }) => theme.space[96]}) {
        margin-left: ${({ theme }) => theme.space[4]};
    }
`;

function TodoListSection({ children, icon, isExpanded, title }) {
    return (jsxRuntimeExports.jsx(StyledAccordion, { collapsible: true, defaultValue: isExpanded ? title : undefined, type: "single", children: jsxRuntimeExports.jsxs(StyledAccordionItem, { value: title, children: [jsxRuntimeExports.jsx(StyledAccordionTrigger, { icon: icon, children: title }), jsxRuntimeExports.jsx(AccordionContent, { children: children })] }) }));
}
const StyledAccordion = styled(Accordion) `
    &:not(:last-child) {
        margin-bottom: ${({ theme }) => theme.space[2]};
    }
`;
const StyledAccordionItem = styled(AccordionItem) `
    border-radius: ${({ theme }) => theme.radii.md};
    padding: ${({ theme }) => theme.space[0]} ${({ theme }) => theme.space[2]};

    &:has(h3:hover) {
        background-color: ${({ theme }) => theme.colors.neutral50};
    }
`;
const StyledAccordionTrigger = styled(AccordionTrigger) `
    font-size: ${({ theme }) => theme.fontSizes.md};
    line-height: ${({ theme }) => theme.lineHeights[6]};
    padding: 16px 4px;

    &:hover {
        background-color: inherit;
        cursor: pointer;
    }

    &:focus-visible {
        outline-offset: -2px;
    }

    svg {
        color: ${({ theme }) => theme.colors.neutral900};
    }
`;

function TodoListWrapper({ children, title }) {
    return (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [title && (jsxRuntimeExports.jsx(Heading, { marginY: 8, size: "medium", children: title })), children.map((child) => (jsxRuntimeExports.jsx(StyledContent$1, { children: child }, v4())))] }));
}
const StyledContent$1 = styled.div `
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.space[5]};
`;

const variants = {
    closed: {
        opacity: 0,
        top: '-10px',
        transition: {
            duration: 0.3,
        },
        transitionEnd: {
            display: 'none',
        },
    },
    open: {
        display: 'block',
        opacity: 1,
        top: 'auto',
        transition: {
            duration: 0.3,
        },
    },
};
const background = {
    closed: {
        opacity: 0,
        transition: {
            duration: 0.3,
        },
        transitionEnd: {
            display: 'none',
        },
    },
    open: {
        display: 'block',
        opacity: 1,
        transition: {
            duration: 0.3,
        },
    },
};
function TopBar(_a) {
    var { content, header, isOpen = false, isSensitiveData = false, onClose, onToggle, toggleId } = _a, props = __rest(_a, ["content", "header", "isOpen", "isSensitiveData", "onClose", "onToggle", "toggleId"]);
    return (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsxs(StyledTopBar, Object.assign({ "data-dd-privacy": isSensitiveData ? 'mask' : 'allow', onClick: onToggle }, props, { children: [header, content && (jsxRuntimeExports.jsx(IconButton, { icon: isOpen ? 'caret-up' : 'caret-down', iconColor: "secondary", id: toggleId, labelText: "Open or Close menu", onClick: onToggle, style: { marginLeft: 12 }, variant: "ghost" }))] })), content && (jsxRuntimeExports.jsx(StyledMotionBackdrop, { animate: isOpen ? 'open' : 'closed', initial: 'closed', onClick: onClose, variants: background })), content && (jsxRuntimeExports.jsx(StyledContent, { animate: isOpen ? 'open' : 'closed', "data-dd-privacy": isSensitiveData ? 'mask' : 'allow', initial: 'closed', variants: variants, children: content }))] }));
}
const StyledTopBar = styled.div `
    min-height: 64px;
    background: #f4f2f0;
    z-index: 3;
    position: relative;
    cursor: ${(props) => (props.onClick ? 'pointer' : 'default')};
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    max-height: 64px;
`;
const StyledMotionBackdrop = styled(motion.div) `
    position: fixed;
    display: none;
    width: 100%;
    height: 100%;
    inset: 0;
    background: rgb(0 0 0 / 50%);
    z-index: 1;
`;
const StyledContent = styled(motion.div) `
    position: absolute;
    display: none;
    width: 100%;
    background-color: var(--kds-color-background-minimal);
    z-index: 3;
    padding: 0 16px;
`;

function TopBarTitle(_a) {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (jsxRuntimeExports.jsx(StyledTopBarTitle, Object.assign({}, props, { children: jsxRuntimeExports.jsx(Text, { color: "subtle", fontWeight: "medium", children: children }) })));
}
const StyledTopBarTitle = styled.div `
    display: flex;
    align-items: center;
`;

function UserSelect(_a) {
    var { defaultValue, id, onChange, onDismiss, placeholder = 'Selecteer je eigen account', users } = _a, props = __rest(_a, ["defaultValue", "id", "onChange", "onDismiss", "placeholder", "users"]);
    const [isOpen, setIsOpen] = useState(false);
    const [selectedUser, setSelectedUser] = useState(defaultValue);
    const [selectedItemIndex, setSelectedItemIndex] = useState(-1);
    const menuRef = useRef(null);
    const buttonRef = useRef(null);
    useEffect(() => {
        if (isOpen && menuRef.current) {
            menuRef.current.focus();
        }
    }, [isOpen, menuRef]);
    const userSelectRef = useRef(null);
    const menuId = `menu-controlled-${useUniqueId()}`;
    const inputId = useUniqueId(id);
    const controlButtonId = `${menuId}-button`;
    useOutsideClick({
        handler: () => {
            setIsOpen(false);
        },
        ref: userSelectRef,
    });
    function handleButtonClick(event) {
        event.preventDefault();
        setIsOpen(!isOpen);
    }
    function handleSelectionChange(user) {
        setSelectedUser(user);
        setIsOpen(!isOpen);
        if (onChange) {
            onChange(user.username);
        }
        if (buttonRef && buttonRef.current) {
            buttonRef.current.focus();
        }
    }
    const remainingUsers = users.filter((user) => {
        return user.id !== (selectedUser === null || selectedUser === void 0 ? void 0 : selectedUser.id);
    });
    const handleButtonKeyDown = (event) => {
        if (event.key === `ArrowDown`) {
            setIsOpen(true);
        }
    };
    const handleClose = () => {
        if (!isOpen) {
            return;
        }
        setIsOpen(false);
        if (buttonRef && buttonRef.current) {
            buttonRef.current.focus();
        }
    };
    const handleKeyDown = (event) => {
        if (event.ctrlKey || event.altKey || event.metaKey) {
            return;
        }
        const childrenArray = remainingUsers;
        let nextSelectedIndex = 0;
        let isShortcut = false;
        const getItemCount = () => {
            if (onDismiss) {
                return childrenArray.length + 1;
            }
            return childrenArray.length;
        };
        const itemCount = getItemCount();
        const firstItem = 0;
        const lastItem = itemCount - 1;
        switch (event.key) {
            case 'ArrowUp':
            case 'ArrowDown':
            case 'Down': // IE/Edge specific value
            case 'Up': // IE/Edge specific value
                const direction = event.key === 'ArrowUp' ? -1 : 1;
                isShortcut = true;
                const nextIndex = selectedItemIndex + direction;
                nextSelectedIndex = nextIndex < 0 ? lastItem : nextIndex >= itemCount ? firstItem : nextIndex;
                break;
            case 'Home':
            case 'End':
                const skipTo = event.key === 'Home' ? firstItem : lastItem;
                isShortcut = true;
                nextSelectedIndex = skipTo;
                break;
            case 'Tab':
                handleClose();
                break;
            case 'Escape':
            case 'Esc': // IE/Edge specific value
                isShortcut = true;
                handleClose();
                break;
            case 'Spacebar':
            case ' ':
            case 'Enter':
                nextSelectedIndex = selectedItemIndex;
                if (onDismiss && selectedItemIndex === remainingUsers.length) {
                    onDismiss();
                }
                if (selectedItemIndex !== remainingUsers.length) {
                    handleSelectionChange(childrenArray[selectedItemIndex]);
                }
                isShortcut = true;
                break;
        }
        if (isShortcut) {
            event.stopPropagation();
            event.preventDefault();
            setSelectedItemIndex(nextSelectedIndex);
        }
    };
    return (jsxRuntimeExports.jsxs(StyledUserSelectContainer, Object.assign({ ref: userSelectRef }, props, { children: [jsxRuntimeExports.jsxs(StyledUserSelectButton, { "aria-controls": menuId, "aria-expanded": isOpen, "aria-haspopup": true, id: controlButtonId, onClick: (event) => handleButtonClick(event), onKeyDown: handleButtonKeyDown, onKeyUp: (e) => {
                    e.preventDefault();
                }, ref: buttonRef, children: [selectedUser ? (jsxRuntimeExports.jsxs(StyledUserBlock, { children: [jsxRuntimeExports.jsx(Avatar, { initials: selectedUser.initials, size: 54 }), jsxRuntimeExports.jsx(StyledUserName, { children: selectedUser.name })] })) : (jsxRuntimeExports.jsx(StyledUserName, { style: { marginLeft: 0 }, children: placeholder })), jsxRuntimeExports.jsx(Icon, { color: "minimal", icon: "caret-down-big" })] }), jsxRuntimeExports.jsxs(StyledOptions, { "$isOpen": isOpen, "aria-activedescendant": `${inputId}-${selectedItemIndex}`, "aria-labelledby": controlButtonId, onKeyDown: handleKeyDown, onKeyUp: (e) => {
                    e.preventDefault();
                }, ref: menuRef, role: "menu", tabIndex: 0, children: [remainingUsers.map((user, index) => {
                        const itemId = `${inputId}-${index}`;
                        return (jsxRuntimeExports.jsx(StyledOption, { "$isFocused": selectedItemIndex === index, id: itemId, onClick: () => handleSelectionChange(user), onMouseOver: () => setSelectedItemIndex(index), children: jsxRuntimeExports.jsxs(StyledUserBlock, { children: [jsxRuntimeExports.jsx(Avatar, { initials: user.initials, size: 54 }), jsxRuntimeExports.jsx(StyledUserName, { children: user.name })] }) }, user.id));
                    }), onDismiss && (jsxRuntimeExports.jsx(StyledOption, { "$isFocused": selectedItemIndex === remainingUsers.length, onClick: onDismiss, onMouseOver: () => setSelectedItemIndex(remainingUsers.length), children: jsxRuntimeExports.jsxs(StyledUserBlock, { children: [jsxRuntimeExports.jsx(StyledIconCircle, { background: tokens.kdsColorNeutral200, icon: "add", size: "small" }), jsxRuntimeExports.jsx(StyledUserName, { style: { color: tokens.kdsColorNeutral400 }, children: "Ander account" })] }) }))] })] })));
}
const StyledUserSelectContainer = styled.div `
    position: relative;
    width: 100%;

    ${sx}
`;
const StyledUserSelectButton = styled.button `
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    color: ${tokens.kdsColorNeutral900};
    background-color: white;
    margin: 0;
    cursor: pointer;
    outline: none;
    height: 86px;
    border: 1px solid var(--kds-color-border-medium);
    padding: 0 16px;
    transition: border 0.2s;
    border-radius: ${tokens.kdsBorderRadiusSmall};

    ${(props) => props.theme.mediaQueries.small} {
        padding-left: 24px;
        padding-right: 24px;
    }

    &:hover {
        border-color: var(--kds-color-border-strong);
    }

    &:focus {
        outline: none;
    }

    &:focus-visible {
        outline: 2px solid var(--kds-color-border-focused);
        outline-offset: 2px;
    }
`;
const StyledUserBlock = styled.span `
    display: flex;
    align-items: center;
`;
const StyledUserName = styled.p `
    margin: 0;
    margin-left: 12px;
    font-size: 16px;
    line-height: 24px;
    font-weight: 500;

    ${(props) => props.theme.mediaQueries.small} {
        margin-left: 16px;
    }
`;
const StyledOptions = styled.ul `
    display: ${(props) => (props.$isOpen ? 'block' : 'none')};
    position: absolute;
    background-color: white;
    padding: 0;
    z-index: 1;
    top: 100%;
    left: 0;
    right: 0;
    max-height: 258px;
    overflow: hidden auto;
    box-shadow: ${(props) => props.theme.shadows.md};
    margin-top: 8px;

    &:focus {
        outline: none;
    }
`;
const StyledOption = styled.li `
    width: 100%;
    height: 86px;
    display: flex;
    align-items: center;
    padding-left: 16px;
    cursor: pointer;
    border-bottom: 1px solid ${tokens.kdsColorNeutral200};
    border-left: 1px solid ${tokens.kdsColorNeutral200};
    border-right: 1px solid ${tokens.kdsColorNeutral200};

    &:first-of-type {
        border-top: 1px solid ${tokens.kdsColorNeutral200};
        border-top-left-radius: ${tokens.kdsBorderRadiusSmall};
        border-top-right-radius: ${tokens.kdsBorderRadiusSmall};
    }

    &:last-of-type {
        border-bottom-left-radius: ${tokens.kdsBorderRadiusSmall};
        border-bottom-right-radius: ${tokens.kdsBorderRadiusSmall};
    }

    ${(props) => props.$isFocused &&
    css$3 `
            background-color: ${props.theme.colors.neutral100};
            color: ${props.theme.colors.neutral900};
        `}

    ${(props) => props.theme.mediaQueries.small} {
        padding-left: 24px;
    }
`;
const StyledIconCircle = styled(IconCircle) `
    margin: 0 11px;
`;

export { Accordion, AccordionContent, AccordionContentIndent, AccordionDescriptionDetails, AccordionDescriptionList, AccordionDescriptionTerm, AccordionItem, AccordionLink, AccordionListItem, AccordionTrigger, AccordionUnorderedList, ActionBar, Alert, AppLayout, AsyncSelect, AuthCode, Avatar, AvatarBlock, AvatarButton, AvatarGroup, AvatarIcon, Badge, Box, Button, ButtonGroup, ButtonRow, Card, CarePathIcon, Checkbox, CheckboxGroup, CheckboxGroupWithTextInput, Col, Collapse, Collection, CollectionItem, CollectionLink, DateInput, DatePicker, Divider, Drawer, DropdownFilter, DropdownMenu, EmotionCacheProvider, EmptyState$1 as EmptyState, EpisodeHeader, FileTypeIcon, Form, FormButtonRow, FormErrorMessage, FormGroup, FormGroupContext, FormLabel, FormParagraph, FormSection, FormSubsection, HardwareToken, Header, Heading, Icon, IconButton, IconCircle, InputCheckmark, KsyosLogo, Link, List, Loader, Modal, MonthPicker, MultiSelectCard, NavBar, NavDropdown, NavMenu, NumberInput, PageHeader, PageLayout, Pagination, PasswordInput, Popover, ProcessAccordion, ProcessAccordionContent, ProcessAccordionHeader, ProcessAccordionItem, ProcessActivityContent, ProcessActivityHeader, ProcessActivityItem, ProcessItemContainer, ProcessItemHeader, Radio, RadioButton, RadioGroup, RadioGroupWithTextInput, Ribbon, Row, ScoreBar, SectionHeader, SecurityShield, Select$1 as Select, SerialNumberInput, SideBar, Smartphone, Spacer, Spinner, SplitButton, SplitView, SplitViewTrigger, Steps, SuccessAnimation, Switch, TabBar, Table, TableBody, TableCell, TableCellExpandRow, TableCellExpanded, TableCellSelectRow, TableContainer, TableHead, TableHeader, TableHeaderRowGroup, TableHeaderSelectAll, TableRow, TableRowExpanded, Text, TextArea, TextInput, ThemeProvider, Timeline, TodoList, TodoListItem, TodoListSection, TodoListWrapper, Tooltip, TopBar, TopBarTitle, UserSelect, defaultTheme$1 as defaultTheme, sx, useControllableProp, useMergeRefs, useOutsideClick, usePrevious, useUniqueId, useViewportWidth };
//# sourceMappingURL=index.es.js.map
